
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire72c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire72c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9ATkq", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $6fc264ec92100d3a$export$882461b6382ed46c; }, function (v) { return $6fc264ec92100d3a$export$882461b6382ed46c = v; });
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";

var $6afFj = parcelRequire("6afFj");
var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $6afFj.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $6afFj.hydrateRoot;

});
parcelRegister("6afFj", function(module, exports) {
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("foRq4"));

});
parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});





parcelRegister("ih19M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("0qhf8"));

});
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});


parcelRegister("gSab4", function(module, exports) {

$parcel$export(module.exports, "useProviderContext", function () { return $895e6ac20d917f11$export$f3632c8327428963; });

var $8kHrV = parcelRequire("8kHrV");
"use client";
var [$895e6ac20d917f11$export$b1da5abff9d0406, $895e6ac20d917f11$export$f3632c8327428963] = (0, $8kHrV.createContext)({
    name: "ProviderContext",
    strict: false
});

});
parcelRegister("8kHrV", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return $04a093c131471473$export$fd42f52fd3ae1109; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
function $04a093c131471473$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = $bh6RR.createContext(void 0);
    Context.displayName = name;
    function useContext2() {
        var _a;
        const context = $bh6RR.useContext(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext2);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext2,
        Context
    ];
}

});


parcelRegister("3HS2q", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $2b2f4e1b1aad8b18$export$80f3e147d781571c; });
$parcel$export(module.exports, "useFocusRing", function () { return $2b2f4e1b1aad8b18$export$4e328f61c538687f; });
$parcel$export(module.exports, "useFocusable", function () { return $2b2f4e1b1aad8b18$export$4c014de7c8940b4c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $dCyIs = parcelRequire("dCyIs");
var $8l8s9 = parcelRequire("8l8s9");
var $1nsPC = parcelRequire("1nsPC");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");

var $7yqEi = parcelRequire("7yqEi");
var $itUXW = parcelRequire("itUXW");
var $2mSSg = parcelRequire("2mSSg");
var $fUXN5 = parcelRequire("fUXN5");

var $aPsoC = parcelRequire("aPsoC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2b2f4e1b1aad8b18$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $7yqEi.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2b2f4e1b1aad8b18$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $2b2f4e1b1aad8b18$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $2b2f4e1b1aad8b18$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $2b2f4e1b1aad8b18$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $2b2f4e1b1aad8b18$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $2b2f4e1b1aad8b18$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
const $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
let $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = null;
function $2b2f4e1b1aad8b18$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $bh6RR.useRef)(null);
    let endRef = (0, $bh6RR.useRef)(null);
    let scopeRef = (0, $bh6RR.useRef)([]);
    let { parentNode: parentNode } = (0, $bh6RR.useContext)($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $bh6RR.useMemo)(()=>new $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.root;
        if ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope && !$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isAncestorScope($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let node = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        const activeElement = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope || $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $bh6RR.useMemo)(()=>$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $bh6RR.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $2b2f4e1b1aad8b18$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $bh6RR.useRef)();
    let raf = (0, $bh6RR.useRef)();
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope || $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isAncestorScope($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope.current) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusFirstInScope($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope.current) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusFirstInScope($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.traverse($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $2b2f4e1b1aad8b18$export$1258395f99bf9cbf(element) {
    return $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInChildScope(element, $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope);
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        $2b2f4e1b1aad8b18$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $bh6RR.useRef)(typeof document !== "undefined" ? (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope || $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isAncestorScope($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $ld26B.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $2b2f4e1b1aad8b18$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $2b2f4e1b1aad8b18$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$last(walker);
                if (next) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$last(walker);
            if (next) $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$export$d06fae2ee68b101e = new $2b2f4e1b1aad8b18$var$$9bf71ea28793e738$var$Tree();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2b2f4e1b1aad8b18$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $bh6RR.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $7yqEi.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, $bh6RR.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $bh6RR.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $bh6RR.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $7yqEi.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $itUXW.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $2mSSg.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}
function $2b2f4e1b1aad8b18$export$1a38b4ad7f578e1d(props) {
    let { children: children, focusClass: focusClass, focusRingClass: focusRingClass } = props;
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = $2b2f4e1b1aad8b18$export$4e328f61c538687f(props);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(child, (0, $dCyIs.mergeProps)(child.props, {
        ...focusProps,
        className: (0, $aPsoC.default)({
            [focusClass || ""]: isFocused,
            [focusRingClass || ""]: isFocusVisible
        })
    }));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2b2f4e1b1aad8b18$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $2b2f4e1b1aad8b18$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $bh6RR.useContext)($2b2f4e1b1aad8b18$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $2Cn0z.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $2b2f4e1b1aad8b18$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $99EP5.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($2b2f4e1b1aad8b18$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $2b2f4e1b1aad8b18$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($2b2f4e1b1aad8b18$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $2b2f4e1b1aad8b18$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $itUXW.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $fUXN5.useKeyboard)(props);
    let interactions = (0, $dCyIs.mergeProps)(focusProps, keyboardProps);
    let domProps = $2b2f4e1b1aad8b18$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $bh6RR.useRef)(props.autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) $2b2f4e1b1aad8b18$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $dCyIs.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2b2f4e1b1aad8b18$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $bh6RR.useState)(false);
    (0, $1nsPC.useLayoutEffect)(()=>{
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = $2b2f4e1b1aad8b18$export$2d6ec8fc375ceafa(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

});
parcelRegister("61nPD", function(module, exports) {

$parcel$export(module.exports, "focusWithoutScrolling", function () { return $46255297eeaed40e$export$de79e2c695e052f3; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $46255297eeaed40e$export$de79e2c695e052f3(element) {
    if ($46255297eeaed40e$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $46255297eeaed40e$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $46255297eeaed40e$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $46255297eeaed40e$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $46255297eeaed40e$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($46255297eeaed40e$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $46255297eeaed40e$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $46255297eeaed40e$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $46255297eeaed40e$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $46255297eeaed40e$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $46255297eeaed40e$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

});

parcelRegister("ld26B", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", function () { return $f70c71fef3aa66c3$export$b204af158042fbac; });
$parcel$export(module.exports, "getOwnerWindow", function () { return $f70c71fef3aa66c3$export$f21a1ffae260145a; });
const $f70c71fef3aa66c3$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $f70c71fef3aa66c3$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $f70c71fef3aa66c3$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

});

parcelRegister("dCyIs", function(module, exports) {

$parcel$export(module.exports, "mergeProps", function () { return $9ea9c0de3738d1c1$export$9d1611c77c2fe928; });

var $i65Wu = parcelRequire("i65Wu");

var $43JEG = parcelRequire("43JEG");

var $aPsoC = parcelRequire("aPsoC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9ea9c0de3738d1c1$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $i65Wu.chain)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $aPsoC.default)(a, b);
            else if (key === "id" && a && b) result.id = (0, $43JEG.mergeIds)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}

});
parcelRegister("i65Wu", function(module, exports) {

$parcel$export(module.exports, "chain", function () { return $d2cd6590851f3942$export$e08e3b67e392101e; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $d2cd6590851f3942$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}

});

parcelRegister("43JEG", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $2f4adb649ece3e53$export$f680877a34711e37; });
$parcel$export(module.exports, "mergeIds", function () { return $2f4adb649ece3e53$export$cd8c9cb68f842629; });
$parcel$export(module.exports, "useSlotId", function () { return $2f4adb649ece3e53$export$b4cc09c592e8fdb8; });

var $1nsPC = parcelRequire("1nsPC");

var $irLbY = parcelRequire("irLbY");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $2f4adb649ece3e53$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $2f4adb649ece3e53$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $2f4adb649ece3e53$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $bh6RR.useState)(defaultId);
    let nextId = (0, $bh6RR.useRef)(null);
    let res = (0, $2GhkT.useSSRSafeId)(value);
    let updateValue = (0, $bh6RR.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if ($2f4adb649ece3e53$var$$bdb11010cef70236$var$canUseDOM) $2f4adb649ece3e53$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let r = res;
        return ()=>{
            $2f4adb649ece3e53$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, $bh6RR.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $2f4adb649ece3e53$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $2f4adb649ece3e53$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $2f4adb649ece3e53$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $2f4adb649ece3e53$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $2f4adb649ece3e53$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $irLbY.useValueEffect)(id);
    let updateId = (0, $bh6RR.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $1nsPC.useLayoutEffect)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}

});
parcelRegister("1nsPC", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $100e4dc4db0ce664$export$e5c5a5f917a5871c; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $100e4dc4db0ce664$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect : ()=>{};

});

parcelRegister("irLbY", function(module, exports) {

$parcel$export(module.exports, "useValueEffect", function () { return $d6df5af61974d7e0$export$14d238f342723f25; });

var $77fRS = parcelRequire("77fRS");

var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d6df5af61974d7e0$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $bh6RR.useState)(defaultValue);
    let effect = (0, $bh6RR.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $77fRS.useEffectEvent)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = (0, $77fRS.useEffectEvent)((fn)=>{
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}

});
parcelRegister("77fRS", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", function () { return $52e57ee6f7a56a7b$export$7f54fc3180508a52; });

var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $52e57ee6f7a56a7b$export$7f54fc3180508a52(fn) {
    const ref = (0, $bh6RR.useRef)(null);
    (0, $1nsPC.useLayoutEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $bh6RR.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

});


parcelRegister("2GhkT", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", function () { return $1f3cf38f5cb725a6$export$535bd6ca7f90a273; });
$parcel$export(module.exports, "useSSRSafeId", function () { return $1f3cf38f5cb725a6$export$619500959fc48b26; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$defaultContext);
const $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(false);
// This is only used in React < 18.
function $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $bh6RR.useContext)($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$useCounter(cur === $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $bh6RR.useState)(true);
    let value = (0, $bh6RR.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $bh6RR.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $1f3cf38f5cb725a6$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useId"] === "function") {
        if (!$1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $bh6RR.useContext)($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $bh6RR.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $bh6RR.useContext)($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$defaultContext && !$1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useId();
    let [didSSR] = (0, $bh6RR.useState)($1f3cf38f5cb725a6$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $1f3cf38f5cb725a6$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useId"] === "function" ? $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$useModernSSRSafeId : $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $1f3cf38f5cb725a6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useSyncExternalStore"]($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$subscribe, $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$getSnapshot, $1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $bh6RR.useContext)($1f3cf38f5cb725a6$var$$b5e257d569688ac6$var$IsSSRContext);
}

});


parcelRegister("aPsoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1a2e608fb826ea$export$2e2bcd8739ae039; });
function $fa1a2e608fb826ea$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fa1a2e608fb826ea$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fa1a2e608fb826ea$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fa1a2e608fb826ea$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fa1a2e608fb826ea$export$2e2bcd8739ae039 = $fa1a2e608fb826ea$export$4f5d2d50c9deca37;

});


parcelRegister("8l8s9", function(module, exports) {

$parcel$export(module.exports, "runAfterTransition", function () { return $6126d7821065b79e$export$24490316f764c430; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $6126d7821065b79e$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $6126d7821065b79e$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $6126d7821065b79e$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $6126d7821065b79e$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $6126d7821065b79e$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}

});

parcelRegister("99EP5", function(module, exports) {

$parcel$export(module.exports, "useObjectRef", function () { return $6aa49eec6fb93f14$export$4338b53315abf666; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6aa49eec6fb93f14$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $bh6RR.useRef)(null);
    return (0, $bh6RR.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        }), [
        forwardedRef
    ]);
}

});

parcelRegister("2Cn0z", function(module, exports) {

$parcel$export(module.exports, "useSyncRef", function () { return $1e80fa5613cf7770$export$4debdb1a3f0fa79e; });

var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1e80fa5613cf7770$export$4debdb1a3f0fa79e(context, ref) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}

});

parcelRegister("7yqEi", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $580061518ea5cb91$export$b9b3dfddab17db27; });
$parcel$export(module.exports, "getInteractionModality", function () { return $580061518ea5cb91$export$630ff653c5ada6a9; });
$parcel$export(module.exports, "useFocusVisibleListener", function () { return $580061518ea5cb91$export$ec71b4b83ac08ec3; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality = null;
let $580061518ea5cb91$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $580061518ea5cb91$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $580061518ea5cb91$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $580061518ea5cb91$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $580061518ea5cb91$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $580061518ea5cb91$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($580061518ea5cb91$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$580061518ea5cb91$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $580061518ea5cb91$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $580061518ea5cb91$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $580061518ea5cb91$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $580061518ea5cb91$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$580061518ea5cb91$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $580061518ea5cb91$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $580061518ea5cb91$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $580061518ea5cb91$export$d90243b58daecda7.delete(windowObject);
};
function $580061518ea5cb91$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $580061518ea5cb91$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $580061518ea5cb91$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$580061518ea5cb91$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $580061518ea5cb91$export$2f1888112f558a7d();
function $580061518ea5cb91$export$b9b3dfddab17db27() {
    return $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $580061518ea5cb91$export$630ff653c5ada6a9() {
    return $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality;
}
function $580061518ea5cb91$export$8397ddfc504fdb9a(modality) {
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality = modality;
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $580061518ea5cb91$export$98e20ec92f614cfe() {
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($580061518ea5cb91$var$$507fabe10e71c6fb$var$currentModality);
        };
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $580061518ea5cb91$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $580061518ea5cb91$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $580061518ea5cb91$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$580061518ea5cb91$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$580061518ea5cb91$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $580061518ea5cb91$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $580061518ea5cb91$export$b9b3dfddab17db27());
    $580061518ea5cb91$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $580061518ea5cb91$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $580061518ea5cb91$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$580061518ea5cb91$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($580061518ea5cb91$export$b9b3dfddab17db27());
        };
        $580061518ea5cb91$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $580061518ea5cb91$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});
parcelRegister("kI2if", function(module, exports) {

$parcel$export(module.exports, "isMac", function () { return $f139b21ed8b2ecdc$export$9ac100e40613ea10; });
$parcel$export(module.exports, "isIPad", function () { return $f139b21ed8b2ecdc$export$7bef049ce92e4224; });
$parcel$export(module.exports, "isIOS", function () { return $f139b21ed8b2ecdc$export$fedb369cb70207f1; });
$parcel$export(module.exports, "isAppleDevice", function () { return $f139b21ed8b2ecdc$export$e1865c3bedcd822b; });
$parcel$export(module.exports, "isWebKit", function () { return $f139b21ed8b2ecdc$export$78551043582a6a98; });
$parcel$export(module.exports, "isAndroid", function () { return $f139b21ed8b2ecdc$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isFirefox", function () { return $f139b21ed8b2ecdc$export$b7d78993b74f766d; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $f139b21ed8b2ecdc$export$9ac100e40613ea10() {
    return $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $f139b21ed8b2ecdc$export$186c6964ca17d99() {
    return $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $f139b21ed8b2ecdc$export$7bef049ce92e4224() {
    return $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $f139b21ed8b2ecdc$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $f139b21ed8b2ecdc$export$fedb369cb70207f1() {
    return $f139b21ed8b2ecdc$export$186c6964ca17d99() || $f139b21ed8b2ecdc$export$7bef049ce92e4224();
}
function $f139b21ed8b2ecdc$export$e1865c3bedcd822b() {
    return $f139b21ed8b2ecdc$export$9ac100e40613ea10() || $f139b21ed8b2ecdc$export$fedb369cb70207f1();
}
function $f139b21ed8b2ecdc$export$78551043582a6a98() {
    return $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$f139b21ed8b2ecdc$export$6446a186d09e379e();
}
function $f139b21ed8b2ecdc$export$6446a186d09e379e() {
    return $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $f139b21ed8b2ecdc$export$a11b0059900ceec8() {
    return $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $f139b21ed8b2ecdc$export$b7d78993b74f766d() {
    return $f139b21ed8b2ecdc$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
}

});

parcelRegister("7uYIl", function(module, exports) {

$parcel$export(module.exports, "isVirtualClick", function () { return $575a6e5802a10bad$export$60278871457622de; });
$parcel$export(module.exports, "isVirtualPointerEvent", function () { return $575a6e5802a10bad$export$29bf1b5f2c56cf63; });

var $kI2if = parcelRequire("kI2if");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $575a6e5802a10bad$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $kI2if.isAndroid)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $575a6e5802a10bad$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $kI2if.isAndroid)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

});


parcelRegister("itUXW", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $d7471fa84b8ebe8b$export$f8168d8dd8fd66e6; });

var $alaZF = parcelRequire("alaZF");

var $bh6RR = parcelRequire("bh6RR");

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $d7471fa84b8ebe8b$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $alaZF.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $ld26B.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("alaZF", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $787464a4db44869a$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $787464a4db44869a$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $787464a4db44869a$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $787464a4db44869a$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("2mSSg", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $1b9833bb9192ecf3$export$420e68273165f4ec; });

var $alaZF = parcelRequire("alaZF");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $1b9833bb9192ecf3$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $bh6RR.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $bh6RR.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $alaZF.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});

parcelRegister("fUXN5", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $b96a7729638bdc09$export$8f71654801c2f7cd; });

var $qQ5Km = parcelRequire("qQ5Km");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b96a7729638bdc09$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $qQ5Km.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $qQ5Km.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("qQ5Km", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $050ad625aee66d8b$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $050ad625aee66d8b$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});



parcelRegister("6ujkL", function(module, exports) {

$parcel$export(module.exports, "tv", function () { return $0cdc8b657fe5dde4$export$984d890fc49ac622; });

var $iCcWq = parcelRequire("iCcWq");

var $9SfKt = parcelRequire("9SfKt");
var $0cdc8b657fe5dde4$export$984d890fc49ac622 = (options, config)=>{
    var _a, _b, _c;
    return (0, $9SfKt.tv)(options, {
        ...config,
        twMerge: (_a = config == null ? void 0 : config.twMerge) != null ? _a : true,
        twMergeConfig: {
            ...config == null ? void 0 : config.twMergeConfig,
            theme: {
                ...(_b = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _b.theme,
                ...(0, $iCcWq.twMergeConfig).theme
            },
            classGroups: {
                ...(_c = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _c.classGroups,
                ...(0, $iCcWq.twMergeConfig).classGroups
            }
        }
    });
};

});
parcelRegister("iCcWq", function(module, exports) {

$parcel$export(module.exports, "twMergeConfig", function () { return $c7d298c5dd4a9358$export$c5ce76624eaef353; });
// src/utils/tw-merge-config.ts
var $c7d298c5dd4a9358$export$7c071ef0138dc46e = [
    "small",
    "medium",
    "large"
];
var $c7d298c5dd4a9358$export$c5ce76624eaef353 = {
    theme: {
        opacity: [
            "disabled"
        ],
        spacing: [
            "divider"
        ],
        borderWidth: $c7d298c5dd4a9358$export$7c071ef0138dc46e,
        borderRadius: $c7d298c5dd4a9358$export$7c071ef0138dc46e
    },
    classGroups: {
        shadow: [
            {
                shadow: $c7d298c5dd4a9358$export$7c071ef0138dc46e
            }
        ],
        "font-size": [
            {
                text: [
                    "tiny",
                    ...$c7d298c5dd4a9358$export$7c071ef0138dc46e
                ]
            }
        ],
        "bg-image": [
            "bg-stripe-gradient"
        ]
    }
};

});

parcelRegister("9SfKt", function(module, exports) {

$parcel$export(module.exports, "tv", function () { return $73055f8a9e3c55f7$export$984d890fc49ac622; });

var $ajKXu = parcelRequire("ajKXu");

var $2GxNG = parcelRequire("2GxNG");
var $6hu5m = parcelRequire("6hu5m");
var $73055f8a9e3c55f7$export$f84bd70098573c5c = {
    twMerge: !0,
    twMergeConfig: {},
    responsiveVariants: !1
}, $73055f8a9e3c55f7$export$b2b720306681cd4b = (s)=>s || void 0, $73055f8a9e3c55f7$export$bdb9d1405dbffd0f = (...s)=>$73055f8a9e3c55f7$export$b2b720306681cd4b((0, $ajKXu.e)(s).filter(Boolean).join(" ")), $73055f8a9e3c55f7$var$q = null, $73055f8a9e3c55f7$var$M = {}, $73055f8a9e3c55f7$var$F = !1, $73055f8a9e3c55f7$export$1343a74baacb0543 = (...s)=>(b$1)=>b$1.twMerge ? ((!$73055f8a9e3c55f7$var$q || $73055f8a9e3c55f7$var$F) && ($73055f8a9e3c55f7$var$F = !1, $73055f8a9e3c55f7$var$q = (0, $ajKXu.b)($73055f8a9e3c55f7$var$M) ? (0, $6hu5m.twMerge) : (0, $2GxNG.extendTailwindMerge)($73055f8a9e3c55f7$var$M)), $73055f8a9e3c55f7$export$b2b720306681cd4b($73055f8a9e3c55f7$var$q($73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s)))) : $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s), $73055f8a9e3c55f7$var$Z = (s, b)=>{
    for(let e in b)s.hasOwnProperty(e) ? s[e] = $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s[e], b[e]) : s[e] = b[e];
    return s;
}, $73055f8a9e3c55f7$export$984d890fc49ac622 = (s, b$1)=>{
    let { extend: e = null, slots: j = {}, variants: U = {}, compoundVariants: C = [], compoundSlots: V = [], defaultVariants: W = {} } = s, m = {
        ...$73055f8a9e3c55f7$export$f84bd70098573c5c,
        ...b$1
    }, S = e != null && e.base ? $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !(0, $ajKXu.b)(e.variants) ? (0, $ajKXu.g)(U, e.variants) : U, A = e != null && e.defaultVariants && !(0, $ajKXu.b)(e.defaultVariants) ? {
        ...e.defaultVariants,
        ...W
    } : W;
    !(0, $ajKXu.b)(m.twMergeConfig) && !(0, $ajKXu.c)(m.twMergeConfig, $73055f8a9e3c55f7$var$M) && ($73055f8a9e3c55f7$var$F = !0, $73055f8a9e3c55f7$var$M = m.twMergeConfig);
    let O = (0, $ajKXu.b)(e == null ? void 0 : e.slots), $ = (0, $ajKXu.b)(j) ? {} : {
        base: $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s == null ? void 0 : s.base, O && (e == null ? void 0 : e.base)),
        ...j
    }, h$1 = O ? $ : $73055f8a9e3c55f7$var$Z({
        ...e == null ? void 0 : e.slots
    }, (0, $ajKXu.b)($) ? {
        base: s == null ? void 0 : s.base
    } : $), v = (l)=>{
        if ((0, $ajKXu.b)(g$1) && (0, $ajKXu.b)(j) && O) return $73055f8a9e3c55f7$export$1343a74baacb0543(S, l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
        if (C && !Array.isArray(C)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof C}`);
        if (V && !Array.isArray(V)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof V}`);
        let K = (t, n, a = [], i)=>{
            let r = a;
            if (typeof n == "string") r = r.concat((0, $ajKXu.h)(n).split(" ").map((c)=>`${t}:${c}`));
            else if (Array.isArray(n)) r = r.concat(n.reduce((c, f)=>c.concat(`${t}:${f}`), []));
            else if (typeof n == "object" && typeof i == "string") {
                for(let c in n)if (n.hasOwnProperty(c) && c === i) {
                    let f = n[c];
                    if (f && typeof f == "string") {
                        let o = (0, $ajKXu.h)(f);
                        r[i] ? r[i] = r[i].concat(o.split(" ").map((u)=>`${t}:${u}`)) : r[i] = o.split(" ").map((u)=>`${t}:${u}`);
                    } else Array.isArray(f) && f.length > 0 && (r[i] = f.reduce((o, u)=>o.concat(`${t}:${u}`), []));
                }
            }
            return r;
        }, z = (t, n = g$1, a$1 = null, i = null)=>{
            var J;
            let r = n[t];
            if (!r || (0, $ajKXu.b)(r)) return null;
            let c = (J = i == null ? void 0 : i[t]) != null ? J : l == null ? void 0 : l[t];
            if (c === null) return null;
            let f = (0, $ajKXu.a)(c), o = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === !0, u = A == null ? void 0 : A[t], d = [];
            if (typeof f == "object" && o) for (let [k, L] of Object.entries(f)){
                let ae = r[L];
                if (k === "initial") {
                    u = L;
                    continue;
                }
                Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(k) || (d = K(k, ae, d, a$1));
            }
            let T = r[f] || r[(0, $ajKXu.a)(u)];
            return typeof d == "object" && typeof a$1 == "string" && d[a$1] ? $73055f8a9e3c55f7$var$Z(d, T) : d.length > 0 ? (d.push(T), d) : T;
        }, P = ()=>g$1 ? Object.keys(g$1).map((t)=>z(t, g$1)) : null, p = (t, n)=>{
            if (!g$1 || typeof g$1 != "object") return null;
            let a = new Array;
            for(let i in g$1){
                let r = z(i, g$1, t, n), c = t === "base" && typeof r == "string" ? r : r && r[t];
                c && (a[a.length] = c);
            }
            return a;
        }, D = {};
        for(let t in l)l[t] !== void 0 && (D[t] = l[t]);
        let G = (t, n)=>{
            var i;
            let a = typeof (l == null ? void 0 : l[t]) == "object" ? {
                [t]: (i = l[t]) == null ? void 0 : i.initial
            } : {};
            return {
                ...A,
                ...D,
                ...a,
                ...n
            };
        }, H = (t = [], n)=>{
            let a = [];
            for (let { class: i, className: r, ...c } of t){
                let f = !0;
                for (let [o, u] of Object.entries(c)){
                    let d = G(o, n);
                    if (Array.isArray(u)) {
                        if (!u.includes(d[o])) {
                            f = !1;
                            break;
                        }
                    } else if (d[o] !== u) {
                        f = !1;
                        break;
                    }
                }
                f && (i && a.push(i), r && a.push(r));
            }
            return a;
        }, I = (t)=>{
            let n = H(C, t), a = H(e == null ? void 0 : e.compoundVariants, t);
            return (0, $ajKXu.f)(a, n);
        }, ee = (t)=>{
            let n = I(t);
            if (!Array.isArray(n)) return n;
            let a = {};
            for (let i of n)if (typeof i == "string" && (a.base = $73055f8a9e3c55f7$export$1343a74baacb0543(a.base, i)(m)), typeof i == "object") for (let [r, c] of Object.entries(i))a[r] = $73055f8a9e3c55f7$export$1343a74baacb0543(a[r], c)(m);
            return a;
        }, te = (t)=>{
            if (V.length < 1) return null;
            let n = {};
            for (let { slots: a = [], class: i, className: r, ...c } of V){
                if (!(0, $ajKXu.b)(c)) {
                    let f = !0;
                    for (let o of Object.keys(c)){
                        let u = G(o, t)[o];
                        if (u === void 0 || (Array.isArray(c[o]) ? !c[o].includes(u) : c[o] !== u)) {
                            f = !1;
                            break;
                        }
                    }
                    if (!f) continue;
                }
                for (let f of a)n[f] = n[f] || [], n[f].push([
                    i,
                    r
                ]);
            }
            return n;
        };
        if (!(0, $ajKXu.b)(j) || !O) {
            let t = {};
            if (typeof h$1 == "object" && !(0, $ajKXu.b)(h$1)) for (let n of Object.keys(h$1))t[n] = (a)=>{
                var i, r;
                return $73055f8a9e3c55f7$export$1343a74baacb0543(h$1[n], p(n, a), ((i = ee(a)) != null ? i : [])[n], ((r = te(a)) != null ? r : [])[n], a == null ? void 0 : a.class, a == null ? void 0 : a.className)(m);
            };
            return t;
        }
        return $73055f8a9e3c55f7$export$1343a74baacb0543(S, P(), I(), l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
    }, x = ()=>{
        if (!(!g$1 || typeof g$1 != "object")) return Object.keys(g$1);
    };
    return v.variantKeys = x(), v.extend = e, v.base = S, v.slots = h$1, v.variants = g$1, v.defaultVariants = A, v.compoundSlots = V, v.compoundVariants = C, v;
}, $73055f8a9e3c55f7$export$cc73e0e70ed8b709 = (s)=>(b, e)=>$73055f8a9e3c55f7$export$984d890fc49ac622(b, e ? (0, $ajKXu.g)(s, e) : s);

});
parcelRegister("ajKXu", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $78301ab34e9078ef$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $78301ab34e9078ef$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "c", function () { return $78301ab34e9078ef$export$db3b6bfb95261072; });
$parcel$export(module.exports, "e", function () { return $78301ab34e9078ef$export$f1e1789686576879; });
$parcel$export(module.exports, "f", function () { return $78301ab34e9078ef$export$2d1720544b23b823; });
$parcel$export(module.exports, "g", function () { return $78301ab34e9078ef$export$39b482c5e57630a8; });
$parcel$export(module.exports, "h", function () { return $78301ab34e9078ef$export$dda1d9f60106f0e9; });
var $78301ab34e9078ef$export$407448d2b89b1813 = (e)=>typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, $78301ab34e9078ef$export$8b22cf2602fb60ce = (e)=>!e || typeof e != "object" || Object.keys(e).length === 0, $78301ab34e9078ef$export$db3b6bfb95261072 = (e, o)=>JSON.stringify(e) === JSON.stringify(o), $78301ab34e9078ef$export$4368d992c4eafac0 = (e)=>typeof e == "boolean";
function $78301ab34e9078ef$var$i(e, o) {
    e.forEach(function(r) {
        Array.isArray(r) ? $78301ab34e9078ef$var$i(r, o) : o.push(r);
    });
}
function $78301ab34e9078ef$export$f1e1789686576879(e) {
    let o = [];
    return $78301ab34e9078ef$var$i(e, o), o;
}
var $78301ab34e9078ef$export$2d1720544b23b823 = (...e)=>$78301ab34e9078ef$export$f1e1789686576879(e).filter(Boolean), $78301ab34e9078ef$export$39b482c5e57630a8 = (e, o)=>{
    let r = {}, c = Object.keys(e), f = Object.keys(o);
    for (let t of c)if (f.includes(t)) {
        let s = e[t], n = o[t];
        typeof s == "object" && typeof n == "object" ? r[t] = $78301ab34e9078ef$export$39b482c5e57630a8(s, n) : Array.isArray(s) || Array.isArray(n) ? r[t] = $78301ab34e9078ef$export$2d1720544b23b823(n, s) : r[t] = n + " " + s;
    } else r[t] = e[t];
    for (let t of f)c.includes(t) || (r[t] = o[t]);
    return r;
}, $78301ab34e9078ef$export$dda1d9f60106f0e9 = (e)=>!e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();

});

parcelRegister("2GxNG", function(module, exports) {

$parcel$export(module.exports, "extendTailwindMerge", function () { return $1e2179a9817d22a0$export$c8d8406b6cd2243e; });

var $21Oy3 = parcelRequire("21Oy3");

var $eJy5L = parcelRequire("eJy5L");

var $gYKrG = parcelRequire("gYKrG");
function $1e2179a9817d22a0$export$c8d8406b6cd2243e(configExtension) {
    for(var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)createConfig[_key - 1] = arguments[_key];
    return typeof configExtension === "function" ? (0, $21Oy3.createTailwindMerge).apply(void 0, [
        (0, $eJy5L.getDefaultConfig),
        configExtension
    ].concat(createConfig)) : (0, $21Oy3.createTailwindMerge).apply(void 0, [
        function() {
            return (0, $gYKrG.mergeConfigs)((0, $eJy5L.getDefaultConfig)(), configExtension);
        }
    ].concat(createConfig));
}

});
parcelRegister("21Oy3", function(module, exports) {

$parcel$export(module.exports, "createTailwindMerge", function () { return $02b505b6857dfcd4$export$ea2d4fba4d1bd27f; });

var $cewI8 = parcelRequire("cewI8");

var $3Tuy3 = parcelRequire("3Tuy3");

var $8mmIt = parcelRequire("8mmIt");
function $02b505b6857dfcd4$export$ea2d4fba4d1bd27f() {
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $cewI8.createConfigUtils)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $3Tuy3.mergeClassList)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall((0, $8mmIt.twJoin).apply(null, arguments));
    };
}

});
parcelRegister("cewI8", function(module, exports) {

$parcel$export(module.exports, "createConfigUtils", function () { return $4e8b98b622c8eddd$export$56ab4ba5b0b25eb0; });

var $9PPhV = parcelRequire("9PPhV");

var $f247Z = parcelRequire("f247Z");

var $8OqIz = parcelRequire("8OqIz");
function $4e8b98b622c8eddd$export$56ab4ba5b0b25eb0(config) {
    return {
        cache: (0, $f247Z.createLruCache)(config.cacheSize),
        splitModifiers: (0, $8OqIz.createSplitModifiers)(config),
        ...(0, $9PPhV.createClassUtils)(config)
    };
}

});
parcelRegister("9PPhV", function(module, exports) {

$parcel$export(module.exports, "createClassUtils", function () { return $28daedd7a8cf13b2$export$e3a687438e51f555; });
var $28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR = "-";
function $28daedd7a8cf13b2$export$e3a687438e51f555(config) {
    var classMap = $28daedd7a8cf13b2$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    function getClassGroupId(className) {
        var classParts = className.split($28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $28daedd7a8cf13b2$var$getGroupRecursive(classParts, classMap) || $28daedd7a8cf13b2$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $28daedd7a8cf13b2$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $28daedd7a8cf13b2$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })?.classGroupId;
}
var $28daedd7a8cf13b2$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $28daedd7a8cf13b2$var$getGroupIdForArbitraryProperty(className) {
    if ($28daedd7a8cf13b2$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $28daedd7a8cf13b2$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $28daedd7a8cf13b2$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $28daedd7a8cf13b2$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $28daedd7a8cf13b2$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $28daedd7a8cf13b2$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $28daedd7a8cf13b2$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($28daedd7a8cf13b2$var$isThemeGetter(classDefinition)) {
                $28daedd7a8cf13b2$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], classGroup = _ref3[1];
            $28daedd7a8cf13b2$var$processClassesRecursively(classGroup, $28daedd7a8cf13b2$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $28daedd7a8cf13b2$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($28daedd7a8cf13b2$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $28daedd7a8cf13b2$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $28daedd7a8cf13b2$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}

});

parcelRegister("f247Z", function(module, exports) {

$parcel$export(module.exports, "createLruCache", function () { return $4707b55ae288e7f8$export$cf6a7cbaa5f64437; });
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $4707b55ae288e7f8$export$cf6a7cbaa5f64437(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}

});

parcelRegister("8OqIz", function(module, exports) {

$parcel$export(module.exports, "IMPORTANT_MODIFIER", function () { return $9270754a4f9f3614$export$61823b46426d06fa; });
$parcel$export(module.exports, "createSplitModifiers", function () { return $9270754a4f9f3614$export$b5f40ac45a8dd583; });
$parcel$export(module.exports, "sortModifiers", function () { return $9270754a4f9f3614$export$4f247a60f8a83b3a; });
var $9270754a4f9f3614$export$61823b46426d06fa = "!";
function $9270754a4f9f3614$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($9270754a4f9f3614$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $9270754a4f9f3614$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}

});


parcelRegister("3Tuy3", function(module, exports) {

$parcel$export(module.exports, "mergeClassList", function () { return $b349a8363cf7ab57$export$b41084d9255a3248; });

var $8OqIz = parcelRequire("8OqIz");
var $b349a8363cf7ab57$var$SPLIT_CLASSES_REGEX = /\s+/;
function $b349a8363cf7ab57$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($b349a8363cf7ab57$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $8OqIz.sortModifiers)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $8OqIz.IMPORTANT_MODIFIER) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}

});

parcelRegister("8mmIt", function(module, exports) {

$parcel$export(module.exports, "twJoin", function () { return $049d6204c3fd8b94$export$a8bbfb445e1f163f; });
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $049d6204c3fd8b94$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $049d6204c3fd8b94$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $049d6204c3fd8b94$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $049d6204c3fd8b94$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}

});


parcelRegister("eJy5L", function(module, exports) {

$parcel$export(module.exports, "getDefaultConfig", function () { return $891902bcdecedc9f$export$ed30944e0fe6ae5c; });

var $l4viY = parcelRequire("l4viY");

var $1Zihv = parcelRequire("1Zihv");
function $891902bcdecedc9f$export$ed30944e0fe6ae5c() {
    var colors = (0, $l4viY.fromTheme)("colors");
    var spacing = (0, $l4viY.fromTheme)("spacing");
    var blur = (0, $l4viY.fromTheme)("blur");
    var brightness = (0, $l4viY.fromTheme)("brightness");
    var borderColor = (0, $l4viY.fromTheme)("borderColor");
    var borderRadius = (0, $l4viY.fromTheme)("borderRadius");
    var borderSpacing = (0, $l4viY.fromTheme)("borderSpacing");
    var borderWidth = (0, $l4viY.fromTheme)("borderWidth");
    var contrast = (0, $l4viY.fromTheme)("contrast");
    var grayscale = (0, $l4viY.fromTheme)("grayscale");
    var hueRotate = (0, $l4viY.fromTheme)("hueRotate");
    var invert = (0, $l4viY.fromTheme)("invert");
    var gap = (0, $l4viY.fromTheme)("gap");
    var gradientColorStops = (0, $l4viY.fromTheme)("gradientColorStops");
    var gradientColorStopPositions = (0, $l4viY.fromTheme)("gradientColorStopPositions");
    var inset = (0, $l4viY.fromTheme)("inset");
    var margin = (0, $l4viY.fromTheme)("margin");
    var opacity = (0, $l4viY.fromTheme)("opacity");
    var padding = (0, $l4viY.fromTheme)("padding");
    var saturate = (0, $l4viY.fromTheme)("saturate");
    var scale = (0, $l4viY.fromTheme)("scale");
    var sepia = (0, $l4viY.fromTheme)("sepia");
    var skew = (0, $l4viY.fromTheme)("skew");
    var space = (0, $l4viY.fromTheme)("space");
    var translate = (0, $l4viY.fromTheme)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $1Zihv.isArbitraryValue),
            spacing
        ];
    };
    var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
        return [
            (0, $1Zihv.isArbitraryValue),
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $1Zihv.isLength)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $1Zihv.isNumber),
            (0, $1Zihv.isArbitraryValue)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $1Zihv.isArbitraryValue)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $1Zihv.isNumber),
            (0, $1Zihv.isArbitraryNumber)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $1Zihv.isNumber),
            (0, $1Zihv.isArbitraryValue)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $1Zihv.isAny)
            ],
            spacing: [
                (0, $1Zihv.isLength)
            ],
            blur: [
                "none",
                "",
                (0, $1Zihv.isTshirtSize),
                (0, $1Zihv.isArbitraryValue)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $1Zihv.isTshirtSize),
                (0, $1Zihv.isArbitraryValue)
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $1Zihv.isPercent),
                (0, $1Zihv.isArbitraryLength)
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $1Zihv.isTshirtSize)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $1Zihv.isArbitraryValue)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $1Zihv.isInteger)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $1Zihv.isInteger)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $1Zihv.isAny)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                (0, $1Zihv.isInteger)
                            ]
                        },
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $1Zihv.isAny)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $1Zihv.isInteger)
                            ]
                        },
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        (0, $1Zihv.isArbitraryValue),
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $1Zihv.isArbitraryValue),
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $1Zihv.isTshirtSize)
                            ]
                        },
                        (0, $1Zihv.isTshirtSize),
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        (0, $1Zihv.isArbitraryValue),
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $1Zihv.isArbitraryValue),
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        (0, $1Zihv.isArbitraryValue),
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $1Zihv.isTshirtSize),
                        (0, $1Zihv.isArbitraryLength)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $1Zihv.isArbitraryNumber)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $1Zihv.isAny)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $1Zihv.isNumber),
                        (0, $1Zihv.isArbitraryNumber)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $1Zihv.isArbitraryValue),
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $1Zihv.isArbitraryValue),
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $1Zihv.isArbitraryPosition)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $1Zihv.isArbitrarySize)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $1Zihv.isArbitraryUrl)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $1Zihv.isArbitraryValue),
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $1Zihv.isLength)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $1Zihv.isTshirtSize),
                        (0, $1Zihv.isArbitraryShadow)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $1Zihv.isAny)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $1Zihv.isTshirtSize),
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $1Zihv.isInteger),
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $1Zihv.isArbitraryValue)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $1Zihv.isLength),
                        (0, $1Zihv.isArbitraryNumber)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}

});
parcelRegister("l4viY", function(module, exports) {

$parcel$export(module.exports, "fromTheme", function () { return $7ee5b424ab0fa1bb$export$e176af7b8eefe933; });
function $7ee5b424ab0fa1bb$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}

});

parcelRegister("1Zihv", function(module, exports) {

$parcel$export(module.exports, "isLength", function () { return $72990d7fd9846713$export$38db3d147cb3433; });
$parcel$export(module.exports, "isNumber", function () { return $72990d7fd9846713$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isArbitraryLength", function () { return $72990d7fd9846713$export$f5e3af6d4c0fbe38; });
$parcel$export(module.exports, "isArbitrarySize", function () { return $72990d7fd9846713$export$92dbd3a305a7cb8b; });
$parcel$export(module.exports, "isArbitraryPosition", function () { return $72990d7fd9846713$export$57d00f225f425549; });
$parcel$export(module.exports, "isArbitraryUrl", function () { return $72990d7fd9846713$export$478a5386e985802b; });
$parcel$export(module.exports, "isArbitraryNumber", function () { return $72990d7fd9846713$export$ea45ce4f1b2d6088; });
$parcel$export(module.exports, "isPercent", function () { return $72990d7fd9846713$export$e50269385c77c348; });
$parcel$export(module.exports, "isInteger", function () { return $72990d7fd9846713$export$a287f47fed4544b8; });
$parcel$export(module.exports, "isArbitraryValue", function () { return $72990d7fd9846713$export$5534a8576501817d; });
$parcel$export(module.exports, "isAny", function () { return $72990d7fd9846713$export$ebb65efc98a3b5f7; });
$parcel$export(module.exports, "isTshirtSize", function () { return $72990d7fd9846713$export$a40791c6b7db5bcc; });
$parcel$export(module.exports, "isArbitraryShadow", function () { return $72990d7fd9846713$export$d01106465b385604; });
var $72990d7fd9846713$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $72990d7fd9846713$var$fractionRegex = /^\d+\/\d+$/;
var $72990d7fd9846713$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $72990d7fd9846713$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $72990d7fd9846713$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $72990d7fd9846713$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $72990d7fd9846713$export$38db3d147cb3433(value) {
    return $72990d7fd9846713$export$7e4aa119212bc614(value) || $72990d7fd9846713$var$stringLengths.has(value) || $72990d7fd9846713$var$fractionRegex.test(value) || $72990d7fd9846713$export$f5e3af6d4c0fbe38(value);
}
function $72990d7fd9846713$export$f5e3af6d4c0fbe38(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "length", $72990d7fd9846713$var$isLengthOnly);
}
function $72990d7fd9846713$export$92dbd3a305a7cb8b(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "size", $72990d7fd9846713$var$isNever);
}
function $72990d7fd9846713$export$57d00f225f425549(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "position", $72990d7fd9846713$var$isNever);
}
function $72990d7fd9846713$export$478a5386e985802b(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "url", $72990d7fd9846713$var$isUrl);
}
function $72990d7fd9846713$export$ea45ce4f1b2d6088(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "number", $72990d7fd9846713$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $72990d7fd9846713$export$cd3ce15f42623f06 = $72990d7fd9846713$export$ea45ce4f1b2d6088;
function $72990d7fd9846713$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $72990d7fd9846713$export$e50269385c77c348(value) {
    return value.endsWith("%") && $72990d7fd9846713$export$7e4aa119212bc614(value.slice(0, -1));
}
function $72990d7fd9846713$export$a287f47fed4544b8(value) {
    return $72990d7fd9846713$var$isIntegerOnly(value) || $72990d7fd9846713$var$getIsArbitraryValue(value, "number", $72990d7fd9846713$var$isIntegerOnly);
}
function $72990d7fd9846713$export$5534a8576501817d(value) {
    return $72990d7fd9846713$var$arbitraryValueRegex.test(value);
}
function $72990d7fd9846713$export$ebb65efc98a3b5f7() {
    return true;
}
function $72990d7fd9846713$export$a40791c6b7db5bcc(value) {
    return $72990d7fd9846713$var$tshirtUnitRegex.test(value);
}
function $72990d7fd9846713$export$d01106465b385604(value) {
    return $72990d7fd9846713$var$getIsArbitraryValue(value, "", $72990d7fd9846713$var$isShadow);
}
function $72990d7fd9846713$var$getIsArbitraryValue(value, label, testValue) {
    var result = $72990d7fd9846713$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $72990d7fd9846713$var$isLengthOnly(value) {
    return $72990d7fd9846713$var$lengthUnitRegex.test(value);
}
function $72990d7fd9846713$var$isNever() {
    return false;
}
function $72990d7fd9846713$var$isUrl(value) {
    return value.startsWith("url(");
}
function $72990d7fd9846713$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $72990d7fd9846713$var$isShadow(value) {
    return $72990d7fd9846713$var$shadowRegex.test(value);
}

});


parcelRegister("gYKrG", function(module, exports) {

$parcel$export(module.exports, "mergeConfigs", function () { return $f0b6d32a12f0b155$export$5d86b86a654a7039; });
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $f0b6d32a12f0b155$export$5d86b86a654a7039(baseConfig, configExtension) {
    for(var key in configExtension)$f0b6d32a12f0b155$var$mergePropertyRecursively(baseConfig, key, configExtension[key]);
    return baseConfig;
}
var $f0b6d32a12f0b155$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f0b6d32a12f0b155$var$overrideTypes = /*#__PURE__*/ new Set([
    "string",
    "number",
    "boolean"
]);
function $f0b6d32a12f0b155$var$mergePropertyRecursively(baseObject, mergeKey, mergeValue) {
    if (!$f0b6d32a12f0b155$var$hasOwnProperty.call(baseObject, mergeKey) || $f0b6d32a12f0b155$var$overrideTypes.has(typeof mergeValue) || mergeValue === null) {
        baseObject[mergeKey] = mergeValue;
        return;
    }
    if (Array.isArray(mergeValue) && Array.isArray(baseObject[mergeKey])) {
        baseObject[mergeKey] = baseObject[mergeKey].concat(mergeValue);
        return;
    }
    if (typeof mergeValue === "object" && typeof baseObject[mergeKey] === "object") {
        if (baseObject[mergeKey] === null) {
            baseObject[mergeKey] = mergeValue;
            return;
        }
        for(var nextKey in mergeValue)$f0b6d32a12f0b155$var$mergePropertyRecursively(baseObject[mergeKey], nextKey, mergeValue[nextKey]);
    }
}

});


parcelRegister("6hu5m", function(module, exports) {

$parcel$export(module.exports, "twMerge", function () { return $3b83a0ac4514ea3d$export$b4660bb6000dfbc9; });

var $21Oy3 = parcelRequire("21Oy3");

var $eJy5L = parcelRequire("eJy5L");
var $3b83a0ac4514ea3d$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $21Oy3.createTailwindMerge)((0, $eJy5L.getDefaultConfig));

});



parcelRegister("g2NHD", function(module, exports) {

$parcel$export(module.exports, "dataFocusVisibleClasses", function () { return $0abf0de53783f959$export$13376dc9c57a19ba; });
$parcel$export(module.exports, "groupDataFocusVisibleClasses", function () { return $0abf0de53783f959$export$23b17e6367ab693; });
$parcel$export(module.exports, "collapseAdjacentVariantBorders", function () { return $0abf0de53783f959$export$be7ffb88629cefac; });
// src/utils/classes.ts
var $0abf0de53783f959$export$6a08aa478781aaec = (prefix)=>({
        color: `hsl(var(--${prefix}-foreground))`,
        backgroundColor: `hsl(var(--${prefix}-background))`
    });
var $0abf0de53783f959$export$ca6a30fd41be6708 = [
    "focus-visible:z-10",
    "focus-visible:outline-2",
    "focus-visible:outline-focus",
    "focus-visible:outline-offset-2"
];
var $0abf0de53783f959$export$13376dc9c57a19ba = [
    "outline-none",
    "data-[focus-visible=true]:z-10",
    "data-[focus-visible=true]:outline-2",
    "data-[focus-visible=true]:outline-focus",
    "data-[focus-visible=true]:outline-offset-2"
];
var $0abf0de53783f959$export$23b17e6367ab693 = [
    "outline-none",
    "group-data-[focus-visible=true]:z-10",
    "group-data-[focus-visible=true]:ring-2",
    "group-data-[focus-visible=true]:ring-focus",
    "group-data-[focus-visible=true]:ring-offset-2",
    "group-data-[focus-visible=true]:ring-offset-background"
];
var $0abf0de53783f959$export$e0ed6e3275f8955 = [
    "outline-none",
    "ring-2",
    "ring-focus",
    "ring-offset-2",
    "ring-offset-background"
];
var $0abf0de53783f959$export$99bb92cbe55f4b50 = [
    "absolute",
    "top-1/2",
    "left-1/2",
    "-translate-x-1/2",
    "-translate-y-1/2"
];
var $0abf0de53783f959$export$88a9566cd73b4303 = [
    "absolute",
    "inset-0"
];
var $0abf0de53783f959$export$be7ffb88629cefac = {
    default: [
        "[&+.border-medium.border-default]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    primary: [
        "[&+.border-medium.border-primary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    secondary: [
        "[&+.border-medium.border-secondary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    success: [
        "[&+.border-medium.border-success]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    warning: [
        "[&+.border-medium.border-warning]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    danger: [
        "[&+.border-medium.border-danger]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ]
};

});

parcelRegister("6N9Z9", function(module, exports) {

$parcel$export(module.exports, "capitalize", function () { return $adbbc1c51b9d2a1a$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "callAllHandlers", function () { return $adbbc1c51b9d2a1a$export$5bdd3f730ec2c47e; });
$parcel$export(module.exports, "getUniqueID", function () { return $adbbc1c51b9d2a1a$export$b8ba5815f1bdad68; });
$parcel$export(module.exports, "removeEvents", function () { return $adbbc1c51b9d2a1a$export$da5f6eb3bb522cd; });
$parcel$export(module.exports, "objectToDeps", function () { return $adbbc1c51b9d2a1a$export$36eebbb473f6d2fe; });
// src/functions.ts
var $adbbc1c51b9d2a1a$export$9a00dee1beb8f576 = (text)=>{
    return text.charAt(0).toUpperCase() + text.slice(1);
};
function $adbbc1c51b9d2a1a$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $adbbc1c51b9d2a1a$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
function $adbbc1c51b9d2a1a$export$bb64030b028b5009(key, defaultValue, ...objs) {
    let result = defaultValue;
    for (const obj of objs)if (obj && key in obj && !!obj[key]) result = obj[key];
    return result;
}
function $adbbc1c51b9d2a1a$export$b8ba5815f1bdad68(prefix) {
    return `${prefix}-${Math.floor(Math.random() * 1e6)}`;
}
function $adbbc1c51b9d2a1a$export$da5f6eb3bb522cd(input) {
    for(const key in input)if (key.startsWith("on")) delete input[key];
    return input;
}
function $adbbc1c51b9d2a1a$export$36eebbb473f6d2fe(obj) {
    if (!obj || typeof obj !== "object") return "";
    try {
        return JSON.stringify(obj);
    } catch (e) {
        return "";
    }
}

});

parcelRegister("3xP29", function(module, exports) {

$parcel$export(module.exports, "clsx", function () { return $bf614d2ded98d41c$export$4f5d2d50c9deca37; });
// src/clsx.ts
function $bf614d2ded98d41c$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $bf614d2ded98d41c$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $bf614d2ded98d41c$export$4f5d2d50c9deca37(...args) {
    var i = 0, tmp, x, str = "";
    while(i < args.length){
        if (tmp = args[i++]) {
            if (x = $bf614d2ded98d41c$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("6G4gc", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $9982f01e1890c6aa$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "isFunction", function () { return $9982f01e1890c6aa$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "dataAttr", function () { return $9982f01e1890c6aa$export$5cc3b7b83e34ade7; });
// src/assertion.ts
var $9982f01e1890c6aa$export$a866f231438cc228 = false;
var $9982f01e1890c6aa$export$61cb32cff9a99948 = false;
function $9982f01e1890c6aa$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $9982f01e1890c6aa$export$4c0262a4f954db45(value) {
    return $9982f01e1890c6aa$export$43bee75e5e14138e(value) && value.length === 0;
}
function $9982f01e1890c6aa$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$9982f01e1890c6aa$export$43bee75e5e14138e(value);
}
function $9982f01e1890c6aa$export$83b788b1a3698c03(value) {
    return $9982f01e1890c6aa$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $9982f01e1890c6aa$export$dd1bc94b04021eeb(value) {
    if ($9982f01e1890c6aa$export$43bee75e5e14138e(value)) return $9982f01e1890c6aa$export$4c0262a4f954db45(value);
    if ($9982f01e1890c6aa$export$a6cdc56e425d0d0a(value)) return $9982f01e1890c6aa$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
function $9982f01e1890c6aa$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
var $9982f01e1890c6aa$export$5cc3b7b83e34ade7 = (condition)=>condition ? "true" : void 0;
var $9982f01e1890c6aa$export$e90fb89750dba83f = (value)=>value != null && parseInt(value.toString(), 10) > 0;

});

parcelRegister("bIkcs", function(module, exports) {

$parcel$export(module.exports, "filterDOMProps", function () { return $d722afb877604608$export$457c3d6518dd4c6f; });

var $jSIxl = parcelRequire("jSIxl");
// src/filter-dom-props.ts
var $d722afb877604608$var$propRe = /^(data-.*)$/;
var $d722afb877604608$var$ariaRe = /^(aria-.*)$/;
var $d722afb877604608$var$funcRe = /^(on[A-Z].*)$/;
function $d722afb877604608$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable = true, enabled: enabled = true, propNames: propNames, omitPropNames: omitPropNames, omitEventNames: omitEventNames, omitDataProps: omitDataProps, omitEventProps: omitEventProps } = opts;
    let filteredProps = {};
    if (!enabled) return props;
    for(const prop in props){
        if (omitPropNames == null ? void 0 : omitPropNames.has(prop)) continue;
        if ((omitEventNames == null ? void 0 : omitEventNames.has(prop)) && $d722afb877604608$var$funcRe.test(prop)) continue;
        if ($d722afb877604608$var$funcRe.test(prop) && !(0, $jSIxl.DOMEventNames).has(prop)) continue;
        if (omitDataProps && $d722afb877604608$var$propRe.test(prop)) continue;
        if (omitEventProps && $d722afb877604608$var$funcRe.test(prop)) continue;
        if (Object.prototype.hasOwnProperty.call(props, prop) && ((0, $jSIxl.DOMPropNames).has(prop) || labelable && $d722afb877604608$var$ariaRe.test(prop) || (propNames == null ? void 0 : propNames.has(prop)) || $d722afb877604608$var$propRe.test(prop)) || $d722afb877604608$var$funcRe.test(prop)) filteredProps[prop] = props[prop];
    }
    return filteredProps;
}

});
parcelRegister("jSIxl", function(module, exports) {

$parcel$export(module.exports, "DOMPropNames", function () { return $2c1aeed2d13a2726$export$5f28e08e1b07d392; });
$parcel$export(module.exports, "DOMEventNames", function () { return $2c1aeed2d13a2726$export$8519a64fe4099896; });
// src/dom-props.ts
var $2c1aeed2d13a2726$export$5f28e08e1b07d392 = /* @__PURE__ */ new Set([
    "id",
    "type",
    "style",
    "title",
    "role",
    "tabIndex",
    "htmlFor",
    "width",
    "height",
    "abbr",
    "accept",
    "acceptCharset",
    "accessKey",
    "action",
    "allowFullScreen",
    "allowTransparency",
    "alt",
    "async",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "challenge",
    "charset",
    "checked",
    "cite",
    "class",
    "className",
    "cols",
    "colSpan",
    "command",
    "content",
    "contentEditable",
    "contextMenu",
    "controls",
    "coords",
    "crossOrigin",
    "data",
    "dateTime",
    "default",
    "defer",
    "dir",
    "disabled",
    "download",
    "draggable",
    "dropzone",
    "encType",
    "enterKeyHint",
    "for",
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "headers",
    "hidden",
    "high",
    "href",
    "hrefLang",
    "httpEquiv",
    "icon",
    "inputMode",
    "isMap",
    "itemId",
    "itemProp",
    "itemRef",
    "itemScope",
    "itemType",
    "kind",
    "label",
    "lang",
    "list",
    "loop",
    "manifest",
    "max",
    "maxLength",
    "media",
    "mediaGroup",
    "method",
    "min",
    "minLength",
    "multiple",
    "muted",
    "name",
    "noValidate",
    "open",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "poster",
    "preload",
    "radioGroup",
    "referrerPolicy",
    "readOnly",
    "rel",
    "required",
    "rows",
    "rowSpan",
    "sandbox",
    "scope",
    "scoped",
    "scrolling",
    "seamless",
    "selected",
    "shape",
    "size",
    "sizes",
    "slot",
    "sortable",
    "span",
    "spellCheck",
    "src",
    "srcDoc",
    "srcSet",
    "start",
    "step",
    "target",
    "translate",
    "typeMustMatch",
    "useMap",
    "value",
    "wmode",
    "wrap"
]);
var $2c1aeed2d13a2726$export$8519a64fe4099896 = /* @__PURE__ */ new Set([
    "onCopy",
    "onCut",
    "onPaste",
    "onLoad",
    "onError",
    "onWheel",
    "onScroll",
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate",
    "onKeyDown",
    "onKeyPress",
    "onKeyUp",
    "onFocus",
    "onBlur",
    "onChange",
    "onInput",
    "onSubmit",
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp",
    "onPointerDown",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerUp",
    "onSelect",
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration",
    "onTransitionEnd"
]);

});


parcelRegister("gedB5", function(module, exports) {

$parcel$export(module.exports, "createDOMRef", function () { return $453f4d1152b89d68$export$a5795cc979dfae80; });
$parcel$export(module.exports, "useDOMRef", function () { return $453f4d1152b89d68$export$c2c55ef9111cafd8; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
function $453f4d1152b89d68$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $453f4d1152b89d68$export$4e09c449d6c407f7 = $453f4d1152b89d68$export$71594e8a50f746f4();
function $453f4d1152b89d68$export$6ffcd379b2770ab0(navigator) {
    const { userAgent: ua, vendor: vendor } = navigator;
    const android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $453f4d1152b89d68$export$54dee9623b75428b(navigator) {
    const { userAgent: ua, platform: platform } = navigator;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $453f4d1152b89d68$export$568a7d21694b4b32(navigator) {
    const { userAgent: ua } = navigator;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $453f4d1152b89d68$export$3070bd282ec37ea8(os) {
    if (!$453f4d1152b89d68$export$4e09c449d6c407f7) return false;
    return $453f4d1152b89d68$export$54dee9623b75428b(window.navigator) === os;
}
function $453f4d1152b89d68$export$2d31490a0c05f094(browser) {
    if (!$453f4d1152b89d68$export$4e09c449d6c407f7) return false;
    return $453f4d1152b89d68$export$6ffcd379b2770ab0(window.navigator) === browser;
}
function $453f4d1152b89d68$export$8d04c8cf4d9e22d8() {
    if (!$453f4d1152b89d68$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $453f4d1152b89d68$export$a5795cc979dfae80(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function $453f4d1152b89d68$export$79d69eee6ae4b329(domRef, focusableRef = domRef) {
    return {
        ...$453f4d1152b89d68$export$a5795cc979dfae80(domRef),
        focus () {
            if (focusableRef.current) focusableRef.current.focus();
        }
    };
}
function $453f4d1152b89d68$export$c2c55ef9111cafd8(ref) {
    const domRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useImperativeHandle)(ref, ()=>domRef.current);
    return domRef;
}
function $453f4d1152b89d68$export$96a734597687c040(ref, focusableRef) {
    const domRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useImperativeHandle)(ref, ()=>$453f4d1152b89d68$export$79d69eee6ae4b329(domRef, focusableRef));
    return domRef;
}
function $453f4d1152b89d68$export$4debdb1a3f0fa79e(context, ref) {
    (0, $bh6RR.useLayoutEffect)(()=>{
        if (context && context.ref && ref && ref.current) {
            context.ref.current = ref.current;
            return ()=>{
                var _a;
                if ((_a = context.ref) == null ? void 0 : _a.current) context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}
function $453f4d1152b89d68$export$33e83fe63cd475d5(rect1, rect2) {
    return rect1 && rect2 && rect1.x < rect2.x + rect2.width && rect1.x + rect1.width > rect2.x && rect1.y < rect2.y + rect2.height && rect1.y + rect1.height > rect2.y;
}

});

parcelRegister("leZvJ", function(module, exports) {

$parcel$export(module.exports, "filterDOMProps", function () { return $f76a9e862ce0c238$export$457c3d6518dd4c6f; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
const $f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "hrefLang",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
const $f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $f76a9e862ce0c238$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $f76a9e862ce0c238$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}

});

parcelRegister("2iPDq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ad550d5c291b3dc$export$5a67b255b80ee4f2; });

var $30qZj = parcelRequire("30qZj");

var $beDys = parcelRequire("beDys");
function $1ad550d5c291b3dc$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $beDys._class_extract_field_descriptor)(receiver, privateMap, "get");
    return (0, $30qZj._class_apply_descriptor_get)(receiver, descriptor);
}

});
parcelRegister("30qZj", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_get", function () { return $23064e67de588bbb$export$184ff5d81c0e5775; });
function $23064e67de588bbb$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("beDys", function(module, exports) {

$parcel$export(module.exports, "_class_extract_field_descriptor", function () { return $82dfaf3e78086f9a$export$20c20a422940e173; });
function $82dfaf3e78086f9a$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("f9kyn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b077a3c21f489735$export$e235798705076415; });

var $8uPsV = parcelRequire("8uPsV");
function $b077a3c21f489735$export$e235798705076415(obj, privateMap, value) {
    (0, $8uPsV._check_private_redeclaration)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("8uPsV", function(module, exports) {

$parcel$export(module.exports, "_check_private_redeclaration", function () { return $62f90c0da26e8f0e$export$6b10452b5ac97eba; });
function $62f90c0da26e8f0e$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("lgPAm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7c31b625f5de596$export$268446c9779b3a21; });

var $lp604 = parcelRequire("lp604");

var $beDys = parcelRequire("beDys");
function $f7c31b625f5de596$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $beDys._class_extract_field_descriptor)(receiver, privateMap, "set");
    (0, $lp604._class_apply_descriptor_set)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("lp604", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_set", function () { return $f950964663165d03$export$b7b24cdba6bcb11c; });
function $f950964663165d03$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("aCMC4", function(module, exports) {

$parcel$export(module.exports, "shouldClientNavigate", function () { return $7bc32981eba88c35$export$efa8c9099e530235; });
$parcel$export(module.exports, "openLink", function () { return $7bc32981eba88c35$export$95185d699e05d4d7; });
$parcel$export(module.exports, "useRouter", function () { return $7bc32981eba88c35$export$9a302a45f65d0572; });
$parcel$export(module.exports, "useLinkProps", function () { return $7bc32981eba88c35$export$7e924b3091a3bd18; });

var $61nPD = parcelRequire("61nPD");

var $kI2if = parcelRequire("kI2if");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $bh6RR.createContext)({
    isNative: true,
    open: $7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: (href)=>href
});
function $7bc32981eba88c35$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $bh6RR.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($7bc32981eba88c35$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $7bc32981eba88c35$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $7bc32981eba88c35$export$9a302a45f65d0572() {
    return (0, $bh6RR.useContext)($7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $7bc32981eba88c35$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $7bc32981eba88c35$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $kI2if.isFirefox)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ((0, $kI2if.isMac)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $kI2if.isWebKit)() && (0, $kI2if.isMac)() && !(0, $kI2if.isIPad)() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $7bc32981eba88c35$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $61nPD.focusWithoutScrolling)(target);
    target.dispatchEvent(event);
    $7bc32981eba88c35$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$7bc32981eba88c35$export$95185d699e05d4d7.isOpening = false;
function $7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        let link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $7bc32981eba88c35$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$7bc32981eba88c35$export$95185d699e05d4d7(link, modifiers));
}
function $7bc32981eba88c35$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
function $7bc32981eba88c35$export$7e924b3091a3bd18(props) {
    let router = $7bc32981eba88c35$export$9a302a45f65d0572();
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? router.useHref(props === null || props === void 0 ? void 0 : props.href) : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}

});

parcelRegister("1mw9Z", function(module, exports) {

$parcel$export(module.exports, "useGlobalListeners", function () { return $0fe0caddd719d5d8$export$4eaf04e54aa8eed6; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0fe0caddd719d5d8$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $bh6RR.useRef)(new Map());
    let addGlobalListener = (0, $bh6RR.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $bh6RR.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $bh6RR.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}

});

parcelRegister("fvnOt", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $b49c390dce3202f1$export$45712eceda6fad21; });
$parcel$export(module.exports, "setInteractionModality", function () { return $b49c390dce3202f1$export$8397ddfc504fdb9a; });
$parcel$export(module.exports, "useInteractionModality", function () { return $b49c390dce3202f1$export$98e20ec92f614cfe; });
$parcel$export(module.exports, "useFocusWithin", function () { return $b49c390dce3202f1$export$420e68273165f4ec; });
$parcel$export(module.exports, "useHover", function () { return $b49c390dce3202f1$export$ae780daf29e6d456; });

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $8l8s9 = parcelRequire("8l8s9");
var $9IUYG = parcelRequire("9IUYG");
var $77fRS = parcelRequire("77fRS");
var $gsEnF = parcelRequire("gsEnF");
var $1mw9Z = parcelRequire("1mw9Z");
var $1nsPC = parcelRequire("1nsPC");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");

var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $b49c390dce3202f1$var$$14c0b72509d70225$var$state = "default";
let $b49c390dce3202f1$var$$14c0b72509d70225$var$savedUserSelect = "";
let $b49c390dce3202f1$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $b49c390dce3202f1$var$$14c0b72509d70225$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($b49c390dce3202f1$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $b49c390dce3202f1$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $b49c390dce3202f1$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $b49c390dce3202f1$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $b49c390dce3202f1$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($b49c390dce3202f1$var$$14c0b72509d70225$var$state !== "disabled") return;
        $b49c390dce3202f1$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($b49c390dce3202f1$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $b49c390dce3202f1$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $b49c390dce3202f1$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $b49c390dce3202f1$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $b49c390dce3202f1$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $b49c390dce3202f1$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $b49c390dce3202f1$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b49c390dce3202f1$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$b49c390dce3202f1$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)($b49c390dce3202f1$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $b49c390dce3202f1$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $b49c390dce3202f1$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $b49c390dce3202f1$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $b49c390dce3202f1$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $b49c390dce3202f1$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $b49c390dce3202f1$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $b49c390dce3202f1$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $b49c390dce3202f1$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $b49c390dce3202f1$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $b49c390dce3202f1$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $b49c390dce3202f1$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $b49c390dce3202f1$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $b49c390dce3202f1$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) $b49c390dce3202f1$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$b49c390dce3202f1$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$b49c390dce3202f1$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) $b49c390dce3202f1$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $b49c390dce3202f1$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $b49c390dce3202f1$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) $b49c390dce3202f1$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $b49c390dce3202f1$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $b49c390dce3202f1$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) $b49c390dce3202f1$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) $b49c390dce3202f1$var$$14c0b72509d70225$export$b0d6fa1ab32e3295((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$b49c390dce3202f1$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $b49c390dce3202f1$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $b49c390dce3202f1$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$b49c390dce3202f1$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($b49c390dce3202f1$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $b49c390dce3202f1$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $b49c390dce3202f1$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $b49c390dce3202f1$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
const $b49c390dce3202f1$export$27c701ed9e449e99 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ children: children, ...props }, ref)=>{
    ref = (0, $99EP5.useObjectRef)(ref);
    let { pressProps: pressProps } = $b49c390dce3202f1$export$45712eceda6fad21({
        ...props,
        ref: ref
    });
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(child, {
        ref: ref,
        ...(0, $dCyIs.mergeProps)(child.props, pressProps)
    });
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b49c390dce3202f1$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $bh6RR.useRef)(false);
    let prevContext = (0, $bh6RR.useContext)($b49c390dce3202f1$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    ref = (0, $99EP5.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $dCyIs.mergeProps)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $2Cn0z.useSyncRef)(prevContext, ref);
    (0, $bh6RR.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b49c390dce3202f1$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
});
function $b49c390dce3202f1$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $bh6RR.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b49c390dce3202f1$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b49c390dce3202f1$var$$8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $b49c390dce3202f1$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $b49c390dce3202f1$var$$8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}
function $b49c390dce3202f1$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = $b49c390dce3202f1$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (e.target === e.currentTarget && document.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality = null;
let $b49c390dce3202f1$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b49c390dce3202f1$var$$507fabe10e71c6fb$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b49c390dce3202f1$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b49c390dce3202f1$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b49c390dce3202f1$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $b49c390dce3202f1$var$$507fabe10e71c6fb$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b49c390dce3202f1$var$$507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b49c390dce3202f1$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$b49c390dce3202f1$var$$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b49c390dce3202f1$var$$507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $b49c390dce3202f1$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b49c390dce3202f1$var$$507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $b49c390dce3202f1$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $b49c390dce3202f1$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b49c390dce3202f1$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$b49c390dce3202f1$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $b49c390dce3202f1$export$2f1888112f558a7d();
function $b49c390dce3202f1$export$b9b3dfddab17db27() {
    return $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $b49c390dce3202f1$export$630ff653c5ada6a9() {
    return $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality;
}
function $b49c390dce3202f1$export$8397ddfc504fdb9a(modality) {
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b49c390dce3202f1$export$98e20ec92f614cfe() {
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($b49c390dce3202f1$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b49c390dce3202f1$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $b49c390dce3202f1$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b49c390dce3202f1$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b49c390dce3202f1$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$b49c390dce3202f1$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b49c390dce3202f1$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $b49c390dce3202f1$export$b9b3dfddab17db27());
    $b49c390dce3202f1$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b49c390dce3202f1$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b49c390dce3202f1$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b49c390dce3202f1$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b49c390dce3202f1$export$b9b3dfddab17db27());
        };
        $b49c390dce3202f1$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b49c390dce3202f1$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $b49c390dce3202f1$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $bh6RR.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $bh6RR.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = $b49c390dce3202f1$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    let onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $b49c390dce3202f1$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $b49c390dce3202f1$var$$6179b936705e76d3$var$hoverCount = 0;
function $b49c390dce3202f1$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $b49c390dce3202f1$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $b49c390dce3202f1$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $b49c390dce3202f1$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $b49c390dce3202f1$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $b49c390dce3202f1$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $b49c390dce3202f1$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $b49c390dce3202f1$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $b49c390dce3202f1$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $b49c390dce3202f1$var$$6179b936705e76d3$var$hoverCount--;
        if ($b49c390dce3202f1$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $b49c390dce3202f1$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $b49c390dce3202f1$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $b49c390dce3202f1$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $bh6RR.useState)(false);
    let state = (0, $bh6RR.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $bh6RR.useEffect)($b49c390dce3202f1$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $bh6RR.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($b49c390dce3202f1$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$b49c390dce3202f1$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $bh6RR.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $b49c390dce3202f1$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $bh6RR.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $77fRS.useEffectEvent)((e)=>{
        if (onInteractOutside && $b49c390dce3202f1$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $77fRS.useEffectEvent)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $bh6RR.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $ld26B.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && $b49c390dce3202f1$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $b49c390dce3202f1$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $b49c390dce3202f1$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $b49c390dce3202f1$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b49c390dce3202f1$var$$93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}
function $b49c390dce3202f1$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: $b49c390dce3202f1$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $b49c390dce3202f1$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b49c390dce3202f1$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart, onMove: onMove, onMoveEnd: onMoveEnd } = props;
    let state = (0, $bh6RR.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $1mw9Z.useGlobalListeners)();
    let move = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, deltaX, deltaY)=>{
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                type: "movestart",
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove === null || onMove === void 0 || onMove({
            type: "move",
            pointerType: pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let end = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        $b49c390dce3202f1$var$$14c0b72509d70225$export$b0d6fa1ab32e3295();
        if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
            type: "moveend",
            pointerType: pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let moveProps = (0, $bh6RR.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            $b49c390dce3202f1$var$$14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        if (typeof PointerEvent === "undefined") {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "mouse", e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let { pageX: pageX, pageY: pageY } = e.changedTouches[touch];
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "touch", pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX: pageX, pageY: pageY, identifier: identifier } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let pointerType = e.pointerType || "mouse";
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        addGlobalListener,
        removeGlobalListener,
        move,
        end
    ]);
    return {
        moveProps: moveProps
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b49c390dce3202f1$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll, isDisabled: isDisabled } = props;
    let onScrollHandler = (0, $bh6RR.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, $gsEnF.useEvent)(ref, "wheel", isDisabled ? undefined : onScrollHandler);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b49c390dce3202f1$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $b49c390dce3202f1$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $b49c390dce3202f1$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $bh6RR.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $1mw9Z.useGlobalListeners)();
    let { pressProps: pressProps } = $b49c390dce3202f1$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $9IUYG.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $dCyIs.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("9IUYG", function(module, exports) {

$parcel$export(module.exports, "useDescription", function () { return $71446bb8d356beed$export$f8aeda7b10753fa1; });

var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $71446bb8d356beed$var$$ef06256079686ba0$var$descriptionId = 0;
const $71446bb8d356beed$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $71446bb8d356beed$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $bh6RR.useState)();
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (!description) return;
        let desc = $71446bb8d356beed$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$71446bb8d356beed$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $71446bb8d356beed$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $71446bb8d356beed$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}

});

parcelRegister("gsEnF", function(module, exports) {

$parcel$export(module.exports, "useEvent", function () { return $bfbe959ea3b2fa9c$export$90fc3a17d93f704c; });

var $77fRS = parcelRequire("77fRS");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bfbe959ea3b2fa9c$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = (0, $77fRS.useEffectEvent)(handler);
    let isDisabled = handler == null;
    (0, $bh6RR.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}

});


parcelRegister("hN2BG", function(module, exports) {

$parcel$export(module.exports, "forwardRef", function () { return $81539f9aba95dd16$export$257a8862b851cb5b; });
$parcel$export(module.exports, "mapPropsVariants", function () { return $81539f9aba95dd16$export$9f203ede2b8cf905; });
// src/utils.ts

var $bh6RR = parcelRequire("bh6RR");
function $81539f9aba95dd16$export$257a8862b851cb5b(component) {
    return (0, $bh6RR.forwardRef)(component);
}
var $81539f9aba95dd16$export$21e0669b7bd01bb4 = (obj)=>{
    return {
        ...obj,
        [Symbol.iterator]: function() {
            const keys = Object.keys(this);
            let index = 0;
            return {
                next: ()=>{
                    if (index >= keys.length) return {
                        done: true
                    };
                    const key = keys[index];
                    const value = this[key];
                    index++;
                    return {
                        value: {
                            key: key,
                            value: value
                        },
                        done: false
                    };
                }
            };
        }
    };
};
var $81539f9aba95dd16$export$9f203ede2b8cf905 = (props, variantKeys, removeVariantProps = true)=>{
    if (!variantKeys) return [
        props,
        {}
    ];
    const picked = variantKeys.reduce((acc, key)=>{
        if (key in props) return {
            ...acc,
            [key]: props[key]
        };
        else return acc;
    }, {});
    if (removeVariantProps) {
        const omitted = Object.keys(props).filter((key)=>!variantKeys.includes(key)).reduce((acc, key)=>({
                ...acc,
                [key]: props[key]
            }), {});
        return [
            omitted,
            picked
        ];
    } else return [
        props,
        picked
    ];
};
var $81539f9aba95dd16$export$ab8830944406cf18 = (originalProps, variantKeys, commonKeys)=>{
    const props = Object.keys(originalProps).filter((key)=>!variantKeys.includes(key) || (commonKeys == null ? void 0 : commonKeys.includes(key))).reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    const variants = variantKeys.reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    return [
        props,
        variants
    ];
};
var $81539f9aba95dd16$export$749da038d9da17ac = (component)=>{
    var _a, _b, _c;
    return !!((_c = (_b = (_a = component.type) == null ? void 0 : _a.render) == null ? void 0 : _b.displayName) == null ? void 0 : _c.includes("NextUI"));
};

});

parcelRegister("lTq24", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $86643c55894bf611$export$3ae376d12526dd6f; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $kIcmp = parcelRequire("kIcmp");

var $jcgaf = parcelRequire("jcgaf");

var $b9uLO = parcelRequire("b9uLO");

var $2JU6p = parcelRequire("2JU6p");

var $3Q5ZO = parcelRequire("3Q5ZO");

var $cdAeN = parcelRequire("cdAeN");

var $9Xqx7 = parcelRequire("9Xqx7");
const $86643c55894bf611$var$getChildKey = (child)=>child.key || "";
function $86643c55894bf611$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $86643c55894bf611$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $86643c55894bf611$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $bh6RR.Children).forEach(children, (child)=>{
        if ((0, $bh6RR.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $86643c55894bf611$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $9Xqx7.invariant)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $bh6RR.useContext)((0, $2JU6p.LayoutGroupContext)).forceRender || (0, $kIcmp.useForceUpdate)()[0];
    const isMounted = (0, $jcgaf.useIsMounted)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $86643c55894bf611$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $bh6RR.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $bh6RR.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $bh6RR.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $bh6RR.useRef)(true);
    (0, $3Q5ZO.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        $86643c55894bf611$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $cdAeN.useUnmountEffect)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: childrenToRender.map((child)=>(0, $ih19M.jsx)((0, $b9uLO.PresenceChild), {
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $86643c55894bf611$var$getChildKey(child)))
    });
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($86643c55894bf611$var$getChildKey);
    const targetKeys = filteredChildren.map($86643c55894bf611$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $86643c55894bf611$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = (0, $ih19M.jsx)((0, $b9uLO.PresenceChild), {
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $86643c55894bf611$var$getChildKey(child));
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : (0, $ih19M.jsx)((0, $b9uLO.PresenceChild), {
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode,
            children: child
        }, $86643c55894bf611$var$getChildKey(child));
    });
    return (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $bh6RR.cloneElement)(child))
    });
};

});
parcelRegister("kIcmp", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", function () { return $9fa8237cfa1feaa5$export$91db9bc4f8ac944a; });

var $bh6RR = parcelRequire("bh6RR");

var $jcgaf = parcelRequire("jcgaf");

var $f6xYV = parcelRequire("f6xYV");
function $9fa8237cfa1feaa5$export$91db9bc4f8ac944a() {
    const isMounted = (0, $jcgaf.useIsMounted)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $bh6RR.useState)(0);
    const forceRender = (0, $bh6RR.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $bh6RR.useCallback)(()=>(0, $f6xYV.frame).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}

});
parcelRegister("jcgaf", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", function () { return $44fe9b5a67d08fd8$export$80c2a3957bcb42ea; });

var $bh6RR = parcelRequire("bh6RR");

var $3Q5ZO = parcelRequire("3Q5ZO");
function $44fe9b5a67d08fd8$export$80c2a3957bcb42ea() {
    const isMounted = (0, $bh6RR.useRef)(false);
    (0, $3Q5ZO.useIsomorphicLayoutEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

});
parcelRegister("3Q5ZO", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $56377e0c81527360$export$700979bc83e7db82; });

var $bh6RR = parcelRequire("bh6RR");

var $bGgku = parcelRequire("bGgku");
const $56377e0c81527360$export$700979bc83e7db82 = (0, $bGgku.isBrowser) ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);

});
parcelRegister("bGgku", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $0ec11121663cc82b$export$4e09c449d6c407f7; });
const $0ec11121663cc82b$export$4e09c449d6c407f7 = typeof document !== "undefined";

});



parcelRegister("f6xYV", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $6491bdd13544fdda$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $6491bdd13544fdda$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $6491bdd13544fdda$export$fff89137e9e818ce; });

var $hcHQh = parcelRequire("hcHQh");

var $6gjGb = parcelRequire("6gjGb");
const { schedule: $6491bdd13544fdda$export$2cef06c20297c17d, cancel: $6491bdd13544fdda$export$ec99c0ef4978dccb, state: $6491bdd13544fdda$export$fff89137e9e818ce, steps: $6491bdd13544fdda$export$be3f796aed065412 } = (0, $6gjGb.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $hcHQh.noop), true);

});
parcelRegister("hcHQh", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $890b2290aa50a5ad$export$8793edee2d425525; });
const $890b2290aa50a5ad$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("6gjGb", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $3c9d516863748892$export$510b0596a933801a; });

var $yKftU = parcelRequire("yKftU");

var $8vwHt = parcelRequire("8vwHt");
const $3c9d516863748892$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3c9d516863748892$var$maxElapsed = 40;
function $3c9d516863748892$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $8vwHt.createRenderStep)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>{
        steps[stepId].process(state);
    };
    const processBatch = ()=>{
        const timestamp = (0, $yKftU.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3c9d516863748892$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $3c9d516863748892$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$3c9d516863748892$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("yKftU", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $6c4fc775126b27b6$export$dd826089e3c5e502; });
const $6c4fc775126b27b6$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};

});

parcelRegister("8vwHt", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $1b7b86ec18a0a90a$export$b995e5e85f5c8289; });
class $1b7b86ec18a0a90a$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $1b7b86ec18a0a90a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $1b7b86ec18a0a90a$var$Queue();
    let nextFrame = new $1b7b86ec18a0a90a$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
                callback(frameData);
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});




parcelRegister("b9uLO", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $1fc7283dda0b311f$export$979daf65881a382a; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ap3St = parcelRequire("ap3St");

var $4I9GC = parcelRequire("4I9GC");

var $kNubk = parcelRequire("kNubk");
const $1fc7283dda0b311f$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $4I9GC.useConstant)($1fc7283dda0b311f$var$newChildrenMap);
    const id = (0, $bh6RR.useId)();
    const context = (0, $bh6RR.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $bh6RR.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $bh6RR.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $ih19M.jsx)((0, $kNubk.PopChild), {
        isPresent: isPresent,
        children: children
    });
    return (0, $ih19M.jsx)((0, $ap3St.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $1fc7283dda0b311f$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("ap3St", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $12e60920c2394b39$export$f224e4635b6f8ce2; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * @public
 */ const $12e60920c2394b39$export$f224e4635b6f8ce2 = (0, $bh6RR.createContext)(null);

});

parcelRegister("4I9GC", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $9237e2773f81c3d0$export$fe4300aa8eebea86; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $9237e2773f81c3d0$export$fe4300aa8eebea86(init) {
    const ref = (0, $bh6RR.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("kNubk", function(module, exports) {

$parcel$export(module.exports, "PopChild", function () { return $ac1170d8eaf727fe$export$1d6cdde0c6816c6d; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $8vT8C = parcelRequire("8vT8C");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $ac1170d8eaf727fe$var$PopChildMeasure extends $bh6RR.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $ac1170d8eaf727fe$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $bh6RR.useId)();
    const ref = (0, $bh6RR.useRef)(null);
    const size = (0, $bh6RR.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $bh6RR.useContext)((0, $8vT8C.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $bh6RR.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $ih19M.jsx)($ac1170d8eaf727fe$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $bh6RR.cloneElement(children, {
            ref: ref
        })
    });
}

});
parcelRegister("8vT8C", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $f69ceb430ae9345a$export$22a697fb29aac98d; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * @public
 */ const $f69ceb430ae9345a$export$22a697fb29aac98d = (0, $bh6RR.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});



parcelRegister("2JU6p", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $364741b44296b530$export$a3579ca508007a95; });

var $bh6RR = parcelRequire("bh6RR");
const $364741b44296b530$export$a3579ca508007a95 = (0, $bh6RR.createContext)({});

});

parcelRegister("cdAeN", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", function () { return $9fd3b3c1a7f0ce3a$export$f3a192d0cbd30b96; });

var $bh6RR = parcelRequire("bh6RR");
function $9fd3b3c1a7f0ce3a$export$f3a192d0cbd30b96(callback) {
    return (0, $bh6RR.useEffect)(()=>()=>callback(), []);
}

});

parcelRegister("9Xqx7", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $9ef77cb0818a2387$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $9ef77cb0818a2387$export$f5708dca728d7177; });

var $hcHQh = parcelRequire("hcHQh");
let $9ef77cb0818a2387$export$491112666e282270 = (0, $hcHQh.noop);
let $9ef77cb0818a2387$export$f5708dca728d7177 = (0, $hcHQh.noop);
var $9ef77cb0818a2387$var$check, $9ef77cb0818a2387$var$message, $9ef77cb0818a2387$var$check1, $9ef77cb0818a2387$var$message1;

});


parcelRegister("6Vrqz", function(module, exports) {

$parcel$export(module.exports, "domAnimation", function () { return $456169fbd38f8046$export$2cb19dbf990677e3; });

var $ftEfR = parcelRequire("ftEfR");

var $aFn5x = parcelRequire("aFn5x");

var $k2HLV = parcelRequire("k2HLV");
/**
 * @public
 */ const $456169fbd38f8046$export$2cb19dbf990677e3 = {
    renderer: (0, $k2HLV.createDomVisualElement),
    ...(0, $ftEfR.animations),
    ...(0, $aFn5x.gestureAnimations)
};

});
parcelRegister("ftEfR", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $61912b83da9ce72c$export$7f9953c70dacfd7f; });

var $43bGa = parcelRequire("43bGa");

var $b6orE = parcelRequire("b6orE");
const $61912b83da9ce72c$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $43bGa.AnimationFeature)
    },
    exit: {
        Feature: (0, $b6orE.ExitAnimationFeature)
    }
};

});
parcelRegister("43bGa", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $f32e32aeb432bca6$export$b45b3fe5caabdca; });

var $kQQPC = parcelRequire("kQQPC");

var $bGRGp = parcelRequire("bGRGp");

var $cxR2c = parcelRequire("cxR2c");
class $f32e32aeb432bca6$export$b45b3fe5caabdca extends (0, $cxR2c.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $bGRGp.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $kQQPC.isAnimationControls)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}

});
parcelRegister("kQQPC", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $6c424f3bd35daf15$export$aa71198ceeaf53ce; });
function $6c424f3bd35daf15$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("bGRGp", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $e4063d3013cf053c$export$bb53502b7a672aa8; });

var $kQQPC = parcelRequire("kQQPC");

var $f8Cke = parcelRequire("f8Cke");

var $3EOi4 = parcelRequire("3EOi4");

var $8YLfI = parcelRequire("8YLfI");

var $fA79e = parcelRequire("fA79e");

var $9pS7S = parcelRequire("9pS7S");

var $kMKP0 = parcelRequire("kMKP0");
const $e4063d3013cf053c$var$reversePriorityOrder = [
    ...(0, $9pS7S.variantPriorityOrder)
].reverse();
const $e4063d3013cf053c$var$numAnimationTypes = (0, $9pS7S.variantPriorityOrder).length;
function $e4063d3013cf053c$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $kMKP0.animateVisualElement)(visualElement, animation, options)));
}
function $e4063d3013cf053c$export$bb53502b7a672aa8(visualElement) {
    let animate = $e4063d3013cf053c$var$animateList(visualElement);
    const state = $e4063d3013cf053c$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $fA79e.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $e4063d3013cf053c$var$numAnimationTypes; i++){
            const type = $e4063d3013cf053c$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $8YLfI.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $kQQPC.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $e4063d3013cf053c$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $f8Cke.isKeyframesTarget)(next) && (0, $f8Cke.isKeyframesTarget)(prev)) valueHasChanged = !(0, $3EOi4.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $e4063d3013cf053c$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $3EOi4.shallowCompare)(next, prev);
    return false;
}
function $e4063d3013cf053c$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $e4063d3013cf053c$var$createState() {
    return {
        animate: $e4063d3013cf053c$var$createTypeState(true),
        whileInView: $e4063d3013cf053c$var$createTypeState(),
        whileHover: $e4063d3013cf053c$var$createTypeState(),
        whileTap: $e4063d3013cf053c$var$createTypeState(),
        whileDrag: $e4063d3013cf053c$var$createTypeState(),
        whileFocus: $e4063d3013cf053c$var$createTypeState(),
        exit: $e4063d3013cf053c$var$createTypeState()
    };
}

});
parcelRegister("f8Cke", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $96ae1bfc697c0155$export$9153ad4c4999f4a0; });
const $96ae1bfc697c0155$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});

parcelRegister("3EOi4", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $b3131a4296a9915c$export$90e866afbd6b9f1a; });
function $b3131a4296a9915c$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("8YLfI", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $e4ec7857057a08b6$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $e4ec7857057a08b6$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("fA79e", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $dfe6a10b7b91d234$export$7b1b1c981f4f0558; });

var $gHRI2 = parcelRequire("gHRI2");
function $dfe6a10b7b91d234$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $gHRI2.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("gHRI2", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $960c679efe64d12b$export$d68f140c4d9b48bc; });
function $960c679efe64d12b$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $960c679efe64d12b$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});


parcelRegister("9pS7S", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $eb6a0a2a824114cd$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $eb6a0a2a824114cd$export$1405a65085f40b9; });
const $eb6a0a2a824114cd$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $eb6a0a2a824114cd$export$1405a65085f40b9 = [
    "initial",
    ...$eb6a0a2a824114cd$export$16e45afcc206d3a8
];

});

parcelRegister("kMKP0", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $ca7433f5e9b78911$export$ff62cf473653f109; });

var $fA79e = parcelRequire("fA79e");

var $02GM7 = parcelRequire("02GM7");

var $bpI65 = parcelRequire("bpI65");

var $f6xYV = parcelRequire("f6xYV");
function $ca7433f5e9b78911$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $bpI65.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $bpI65.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $fA79e.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $02GM7.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        (0, $f6xYV.frame).postRender(()=>{
            visualElement.notify("AnimationComplete", definition);
        });
    });
}

});
parcelRegister("02GM7", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $cbfc21822c188a13$export$68cacfeee78d98d2; });

var $4LMqa = parcelRequire("4LMqa");

var $ioyNN = parcelRequire("ioyNN");

var $bMmjh = parcelRequire("bMmjh");

var $fZs52 = parcelRequire("fZs52");

var $1BiAr = parcelRequire("1BiAr");

var $bzdeT = parcelRequire("bzdeT");

var $f6xYV = parcelRequire("f6xYV");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cbfc21822c188a13$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cbfc21822c188a13$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $cbfc21822c188a13$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $1BiAr.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const appearId = (0, $bzdeT.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $f6xYV.frame));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $ioyNN.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $4LMqa.transformProps).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) {
            if ((0, $bMmjh.isWillChangeMotionValue)(willChange)) {
                willChange.add(key);
                animation.then(()=>willChange.remove(key));
            }
            animations.push(animation);
        }
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $f6xYV.frame).update(()=>{
            transitionEnd && (0, $fZs52.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("4LMqa", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $05d385f303970557$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $05d385f303970557$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ const $05d385f303970557$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $05d385f303970557$export$7b42a0094fb00b6e = new Set($05d385f303970557$export$280dc01950909d86);

});

parcelRegister("ioyNN", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $3431270835958863$export$90b3dfc33ff3548; });

var $faqPt = parcelRequire("faqPt");

var $1Jn1k = parcelRequire("1Jn1k");

var $1BiAr = parcelRequire("1BiAr");

var $yKftU = parcelRequire("yKftU");

var $81ZQd = parcelRequire("81ZQd");

var $dlXx4 = parcelRequire("dlXx4");

var $f6xYV = parcelRequire("f6xYV");

var $gIk59 = parcelRequire("gIk59");

var $gqZNo = parcelRequire("gqZNo");

var $8IAzf = parcelRequire("8IAzf");
const $3431270835958863$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $1BiAr.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $faqPt.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $1BiAr.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $1Jn1k.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $faqPt.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $faqPt.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $81ZQd.instantAnimationState).current || (0, $yKftU.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $dlXx4.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $f6xYV.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $8IAzf.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $gIk59.AcceleratedAnimation).supports(options)) return new (0, $gIk59.AcceleratedAnimation)(options);
        else return new (0, $gqZNo.MainThreadAnimation)(options);
    };

});
parcelRegister("faqPt", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $631bdbca8ed9a472$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $631bdbca8ed9a472$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $631bdbca8ed9a472$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $631bdbca8ed9a472$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("1Jn1k", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $943a3f0a32f59f42$export$262124b154b9f1c0; });

var $4LMqa = parcelRequire("4LMqa");
const $943a3f0a32f59f42$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $943a3f0a32f59f42$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $943a3f0a32f59f42$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $943a3f0a32f59f42$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $943a3f0a32f59f42$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $943a3f0a32f59f42$var$keyframesTransition;
    else if ((0, $4LMqa.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $943a3f0a32f59f42$var$criticallyDampedSpring(keyframes[1]) : $943a3f0a32f59f42$var$underDampedSpring;
    return $943a3f0a32f59f42$var$ease;
};

});

parcelRegister("1BiAr", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $cba3eab4a749f231$export$ca8e47dc8ed5a9d7; });
$parcel$export(module.exports, "getValueTransition", function () { return $cba3eab4a749f231$export$7c1391340308742e; });
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $cba3eab4a749f231$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $cba3eab4a749f231$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}

});

parcelRegister("81ZQd", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", function () { return $636ef95c23a1ebef$export$888a3d84909f9e3d; });
const $636ef95c23a1ebef$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("dlXx4", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $cb21c6c57eea1e02$export$14de59408fad90b; });
const $cb21c6c57eea1e02$var$isNotNull = (value)=>value !== null;
function $cb21c6c57eea1e02$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($cb21c6c57eea1e02$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("gIk59", function(module, exports) {

$parcel$export(module.exports, "AcceleratedAnimation", function () { return $264f965dbb30cd85$export$2a45abb4e6513325; });

var $035gC = parcelRequire("035gC");

var $7U3iI = parcelRequire("7U3iI");

var $lG8CU = parcelRequire("lG8CU");

var $hcHQh = parcelRequire("hcHQh");

var $faqPt = parcelRequire("faqPt");

var $3QPLs = parcelRequire("3QPLs");

var $gqZNo = parcelRequire("gqZNo");

var $6wHmf = parcelRequire("6wHmf");

var $61c9Y = parcelRequire("61c9Y");

var $dlXx4 = parcelRequire("dlXx4");
const $264f965dbb30cd85$var$supportsWaapi = (0, $lG8CU.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $264f965dbb30cd85$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $264f965dbb30cd85$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $264f965dbb30cd85$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $264f965dbb30cd85$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || options.name === "backgroundColor" || !(0, $61c9Y.isWaapiSupportedEasing)(options.ease);
}
function $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $gqZNo.MainThreadAnimation)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $264f965dbb30cd85$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $264f965dbb30cd85$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $264f965dbb30cd85$var$sampleDelta,
        ease: "linear"
    };
}
class $264f965dbb30cd85$export$2a45abb4e6513325 extends (0, $3QPLs.BaseAnimation) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        this.resolver = new (0, $7U3iI.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($264f965dbb30cd85$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, ...options } = this.options;
            const pregeneratedAnimation = $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $6wHmf.animateStyle)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $035gC.time).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $dlXx4.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $faqPt.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $faqPt.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $faqPt.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $hcHQh.noop;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $hcHQh.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, ...options } = this.options;
            const sampleAnimation = new (0, $gqZNo.MainThreadAnimation)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $faqPt.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $264f965dbb30cd85$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $264f965dbb30cd85$var$sampleDelta);
        }
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $264f965dbb30cd85$var$supportsWaapi() && name && $264f965dbb30cd85$var$acceleratedValues.has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}

});
parcelRegister("035gC", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $05b982fb85a2786e$export$2da9be4cfdb689b1; });

var $yKftU = parcelRequire("yKftU");

var $f6xYV = parcelRequire("f6xYV");
let $05b982fb85a2786e$var$now;
function $05b982fb85a2786e$var$clearTime() {
    $05b982fb85a2786e$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $05b982fb85a2786e$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($05b982fb85a2786e$var$now === undefined) $05b982fb85a2786e$export$2da9be4cfdb689b1.set((0, $f6xYV.frameData).isProcessing || (0, $yKftU.MotionGlobalConfig).useManualTiming ? (0, $f6xYV.frameData).timestamp : performance.now());
        return $05b982fb85a2786e$var$now;
    },
    set: (newTime)=>{
        $05b982fb85a2786e$var$now = newTime;
        queueMicrotask($05b982fb85a2786e$var$clearTime);
    }
};

});

parcelRegister("7U3iI", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $c8b2f05e40a653fe$export$4983792d11b61017; });

var $2AIQH = parcelRequire("2AIQH");

var $93hnr = parcelRequire("93hnr");

var $lB8dT = parcelRequire("lB8dT");

var $l77mz = parcelRequire("l77mz");

var $1OAXv = parcelRequire("1OAXv");

var $8Nfz4 = parcelRequire("8Nfz4");

var $6z1IG = parcelRequire("6z1IG");
class $c8b2f05e40a653fe$export$4983792d11b61017 extends (0, $8Nfz4.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $lB8dT.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $93hnr.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $l77mz.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $1OAXv.findDimensionValueType)(origin);
        const targetType = (0, $1OAXv.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $l77mz.isNumOrPxType)(originType) && (0, $l77mz.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $2AIQH.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $6z1IG.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $l77mz.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $l77mz.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("2AIQH", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $cfbb3fdee2e93a54$export$e56af863d5645d5f; });

var $ihFxk = parcelRequire("ihFxk");
function $cfbb3fdee2e93a54$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $ihFxk.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("ihFxk", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $e46637106d3b5fd8$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $e46637106d3b5fd8$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("93hnr", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $ff42741a21ccb940$export$289398774300c991; });

var $9Xqx7 = parcelRequire("9Xqx7");

var $gUFdC = parcelRequire("gUFdC");

var $lB8dT = parcelRequire("lB8dT");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ff42741a21ccb940$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $ff42741a21ccb940$export$b9f0c1f373aee2b0(current) {
    const match = $ff42741a21ccb940$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $ff42741a21ccb940$var$maxDepth = 4;
function $ff42741a21ccb940$export$289398774300c991(current, element, depth = 1) {
    (0, $9Xqx7.invariant)(depth <= $ff42741a21ccb940$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ff42741a21ccb940$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $gUFdC.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $lB8dT.isCSSVariableToken)(fallback) ? $ff42741a21ccb940$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("gUFdC", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $307e1e0a636b2ddb$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $307e1e0a636b2ddb$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});

parcelRegister("lB8dT", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $9223341d00255d67$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $9223341d00255d67$export$31f9caa2600b5723; });
const $9223341d00255d67$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $9223341d00255d67$export$9de1236619d9e756 = $9223341d00255d67$var$checkStringStartsWith("--");
const $9223341d00255d67$var$startsAsVariableToken = $9223341d00255d67$var$checkStringStartsWith("var(--");
const $9223341d00255d67$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $9223341d00255d67$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $9223341d00255d67$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $9223341d00255d67$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});


parcelRegister("l77mz", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $2b1f30070063653f$export$c66c0d5db2a205d; });
$parcel$export(module.exports, "isNumOrPxType", function () { return $2b1f30070063653f$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $2b1f30070063653f$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $2b1f30070063653f$export$781d46a8aa670d52; });

var $4LMqa = parcelRequire("4LMqa");

var $5y23w = parcelRequire("5y23w");

var $1aEW4 = parcelRequire("1aEW4");
const $2b1f30070063653f$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $2b1f30070063653f$export$8e5250d1aa9bf370 = (v)=>v === (0, $5y23w.number) || v === (0, $1aEW4.px);
const $2b1f30070063653f$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $2b1f30070063653f$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $2b1f30070063653f$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $2b1f30070063653f$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $2b1f30070063653f$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $2b1f30070063653f$var$nonTranslationalTransformKeys = (0, $4LMqa.transformPropOrder).filter((key)=>!$2b1f30070063653f$var$transformKeys.has(key));
function $2b1f30070063653f$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $2b1f30070063653f$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $2b1f30070063653f$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $2b1f30070063653f$var$getTranslateFromMatrix(4, 13),
    y: $2b1f30070063653f$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$2b1f30070063653f$export$781d46a8aa670d52.translateX = $2b1f30070063653f$export$781d46a8aa670d52.x;
$2b1f30070063653f$export$781d46a8aa670d52.translateY = $2b1f30070063653f$export$781d46a8aa670d52.y;

});
parcelRegister("5y23w", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $84044ef4463ca44e$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $84044ef4463ca44e$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $84044ef4463ca44e$export$dcdf75081b88279d; });

var $9akfM = parcelRequire("9akfM");
const $84044ef4463ca44e$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $84044ef4463ca44e$export$58f0f39f63f3cf42 = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    transform: (v)=>(0, $9akfM.clamp)(0, 1, v)
};
const $84044ef4463ca44e$export$dcdf75081b88279d = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    default: 1
};

});
parcelRegister("9akfM", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4; });
const $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("1aEW4", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $ee89500f7aaa2f56$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $ee89500f7aaa2f56$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $ee89500f7aaa2f56$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $ee89500f7aaa2f56$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $ee89500f7aaa2f56$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $ee89500f7aaa2f56$export$44e2e1705876d7ed; });

var $M3cKA = parcelRequire("M3cKA");
const $ee89500f7aaa2f56$var$createUnitType = (unit)=>({
        test: (v)=>(0, $M3cKA.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ee89500f7aaa2f56$export$41fc368e1a942b97 = $ee89500f7aaa2f56$var$createUnitType("deg");
const $ee89500f7aaa2f56$export$626336c2cd4b14de = $ee89500f7aaa2f56$var$createUnitType("%");
const $ee89500f7aaa2f56$export$91c0eda1d06bf008 = $ee89500f7aaa2f56$var$createUnitType("px");
const $ee89500f7aaa2f56$export$f91e8c45a95a32f2 = $ee89500f7aaa2f56$var$createUnitType("vh");
const $ee89500f7aaa2f56$export$aed3d7b7d206c196 = $ee89500f7aaa2f56$var$createUnitType("vw");
const $ee89500f7aaa2f56$export$44e2e1705876d7ed = {
    ...$ee89500f7aaa2f56$export$626336c2cd4b14de,
    parse: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.transform(v * 100)
};

});
parcelRegister("M3cKA", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $633590f9df316f77$export$83d2e9e3e4ee39ed; });
$parcel$export(module.exports, "floatRegex", function () { return $633590f9df316f77$export$2444ca58c08448e4; });
$parcel$export(module.exports, "colorRegex", function () { return $633590f9df316f77$export$740b69c5fad25dba; });
$parcel$export(module.exports, "singleColorRegex", function () { return $633590f9df316f77$export$ed808ff6ecd39e8d; });
$parcel$export(module.exports, "isString", function () { return $633590f9df316f77$export$844ec244b1367d54; });
/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $633590f9df316f77$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $633590f9df316f77$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $633590f9df316f77$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $633590f9df316f77$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $633590f9df316f77$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});



parcelRegister("1OAXv", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $d03d4f627f09ffbd$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $d03d4f627f09ffbd$export$eefdd52e3ccae428; });

var $5y23w = parcelRequire("5y23w");

var $1aEW4 = parcelRequire("1aEW4");

var $ddx0Q = parcelRequire("ddx0Q");

var $cWkWc = parcelRequire("cWkWc");
/**
 * A list of value types commonly used for dimensions
 */ const $d03d4f627f09ffbd$export$d176691c1998a1f5 = [
    (0, $5y23w.number),
    (0, $1aEW4.px),
    (0, $1aEW4.percent),
    (0, $1aEW4.degrees),
    (0, $1aEW4.vw),
    (0, $1aEW4.vh),
    (0, $cWkWc.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $d03d4f627f09ffbd$export$eefdd52e3ccae428 = (v)=>$d03d4f627f09ffbd$export$d176691c1998a1f5.find((0, $ddx0Q.testValueType)(v));

});
parcelRegister("ddx0Q", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $bce78752b9f7f913$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ const $bce78752b9f7f913$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("cWkWc", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $6e9d07411e0549ee$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ const $6e9d07411e0549ee$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});


parcelRegister("8Nfz4", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $8a643b2da1c7bc40$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $8a643b2da1c7bc40$export$74d34ca3182f1750; });

var $l77mz = parcelRequire("l77mz");

var $f6xYV = parcelRequire("f6xYV");
const $8a643b2da1c7bc40$var$toResolve = new Set();
let $8a643b2da1c7bc40$var$isScheduled = false;
let $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
function $8a643b2da1c7bc40$var$measureAllKeyframes() {
    if ($8a643b2da1c7bc40$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($8a643b2da1c7bc40$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $l77mz.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
    $8a643b2da1c7bc40$var$isScheduled = false;
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>resolver.complete());
    $8a643b2da1c7bc40$var$toResolve.clear();
}
function $8a643b2da1c7bc40$var$readAllKeyframes() {
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $8a643b2da1c7bc40$var$anyNeedsMeasurement = true;
    });
}
function $8a643b2da1c7bc40$export$78b96d2a12593b05() {
    $8a643b2da1c7bc40$var$readAllKeyframes();
    $8a643b2da1c7bc40$var$measureAllKeyframes();
}
class $8a643b2da1c7bc40$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $8a643b2da1c7bc40$var$toResolve.add(this);
            if (!$8a643b2da1c7bc40$var$isScheduled) {
                $8a643b2da1c7bc40$var$isScheduled = true;
                (0, $f6xYV.frame).read($8a643b2da1c7bc40$var$readAllKeyframes);
                (0, $f6xYV.frame).resolveKeyframes($8a643b2da1c7bc40$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $8a643b2da1c7bc40$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $8a643b2da1c7bc40$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}

});

parcelRegister("6z1IG", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $7a2127a321ebfc42$export$8cc4958f8e540f37; });

var $aSe5F = parcelRequire("aSe5F");

var $leusC = parcelRequire("leusC");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $7a2127a321ebfc42$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $7a2127a321ebfc42$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$7a2127a321ebfc42$var$invalidTemplates.has(keyframe) && (0, $aSe5F.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $leusC.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("aSe5F", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $a554c66132092e1c$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $a554c66132092e1c$export$83a0e34f1302825b; });

var $4SRtp = parcelRequire("4SRtp");

var $M3cKA = parcelRequire("M3cKA");
function $a554c66132092e1c$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $M3cKA.isString)(v) && (((_a = v.match((0, $M3cKA.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $M3cKA.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $a554c66132092e1c$var$NUMBER_TOKEN = "number";
const $a554c66132092e1c$var$COLOR_TOKEN = "color";
const $a554c66132092e1c$var$VAR_TOKEN = "var";
const $a554c66132092e1c$var$VAR_FUNCTION_TOKEN = "var(";
const $a554c66132092e1c$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $a554c66132092e1c$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $a554c66132092e1c$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($a554c66132092e1c$var$complexRegex, (parsedValue)=>{
        if ((0, $4SRtp.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($a554c66132092e1c$var$COLOR_TOKEN);
            values.push((0, $4SRtp.color).parse(parsedValue));
        } else if (parsedValue.startsWith($a554c66132092e1c$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($a554c66132092e1c$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($a554c66132092e1c$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $a554c66132092e1c$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($a554c66132092e1c$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $a554c66132092e1c$var$parseComplexValue(v) {
    return $a554c66132092e1c$export$b61fc7c44bf646d5(v).values;
}
function $a554c66132092e1c$var$createTransformer(source) {
    const { split: split, types: types } = $a554c66132092e1c$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $a554c66132092e1c$var$NUMBER_TOKEN) output += (0, $M3cKA.sanitize)(v[i]);
                else if (type === $a554c66132092e1c$var$COLOR_TOKEN) output += (0, $4SRtp.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $a554c66132092e1c$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $a554c66132092e1c$var$getAnimatableNone(v) {
    const parsed = $a554c66132092e1c$var$parseComplexValue(v);
    const transformer = $a554c66132092e1c$var$createTransformer(v);
    return transformer(parsed.map($a554c66132092e1c$var$convertNumbersToZero));
}
const $a554c66132092e1c$export$83a0e34f1302825b = {
    test: $a554c66132092e1c$var$test,
    parse: $a554c66132092e1c$var$parseComplexValue,
    createTransformer: $a554c66132092e1c$var$createTransformer,
    getAnimatableNone: $a554c66132092e1c$var$getAnimatableNone
};

});
parcelRegister("4SRtp", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $7a26ed3125820d32$export$35e9368ef982300f; });

var $M3cKA = parcelRequire("M3cKA");

var $do2NO = parcelRequire("do2NO");

var $7TVwi = parcelRequire("7TVwi");

var $am2YS = parcelRequire("am2YS");
const $7a26ed3125820d32$export$35e9368ef982300f = {
    test: (v)=>(0, $am2YS.rgba).test(v) || (0, $do2NO.hex).test(v) || (0, $7TVwi.hsla).test(v),
    parse: (v)=>{
        if ((0, $am2YS.rgba).test(v)) return (0, $am2YS.rgba).parse(v);
        else if ((0, $7TVwi.hsla).test(v)) return (0, $7TVwi.hsla).parse(v);
        else return (0, $do2NO.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $M3cKA.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $am2YS.rgba).transform(v) : (0, $7TVwi.hsla).transform(v);
    }
};

});
parcelRegister("do2NO", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $30a5a0b739818b6d$export$834dfc94dde4b3d8; });

var $am2YS = parcelRequire("am2YS");

var $cAyvb = parcelRequire("cAyvb");
function $30a5a0b739818b6d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $30a5a0b739818b6d$export$834dfc94dde4b3d8 = {
    test: (0, $cAyvb.isColorString)("#"),
    parse: $30a5a0b739818b6d$var$parseHex,
    transform: (0, $am2YS.rgba).transform
};

});
parcelRegister("am2YS", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b; });

var $9akfM = parcelRequire("9akfM");

var $5y23w = parcelRequire("5y23w");

var $M3cKA = parcelRequire("M3cKA");

var $cAyvb = parcelRequire("cAyvb");
const $73de4a1e9f0dd80c$var$clampRgbUnit = (v)=>(0, $9akfM.clamp)(0, 255, v);
const $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e = {
    ...(0, $5y23w.number),
    transform: (v)=>Math.round($73de4a1e9f0dd80c$var$clampRgbUnit(v))
};
const $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b = {
    test: (0, $cAyvb.isColorString)("rgb", "red"),
    parse: (0, $cAyvb.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(red) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(green) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $M3cKA.sanitize)((0, $5y23w.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("cAyvb", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $5722faa01ec1ec2e$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $5722faa01ec1ec2e$export$73d6f35be992df24; });

var $M3cKA = parcelRequire("M3cKA");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $5722faa01ec1ec2e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $M3cKA.isString)(v) && (0, $M3cKA.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $5722faa01ec1ec2e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $M3cKA.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $M3cKA.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("7TVwi", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $0843b7e1fb4696f0$export$810b04175080204c; });

var $5y23w = parcelRequire("5y23w");

var $1aEW4 = parcelRequire("1aEW4");

var $M3cKA = parcelRequire("M3cKA");

var $cAyvb = parcelRequire("cAyvb");
const $0843b7e1fb4696f0$export$810b04175080204c = {
    test: (0, $cAyvb.isColorString)("hsl", "hue"),
    parse: (0, $cAyvb.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $1aEW4.percent).transform((0, $M3cKA.sanitize)(saturation)) + ", " + (0, $1aEW4.percent).transform((0, $M3cKA.sanitize)(lightness)) + ", " + (0, $M3cKA.sanitize)((0, $5y23w.alpha).transform(alpha$1)) + ")";
    }
};

});



parcelRegister("leusC", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $1838583c06c42261$export$cea0cedcb94873b5; });

var $aSe5F = parcelRequire("aSe5F");

var $8YMh9 = parcelRequire("8YMh9");

var $3b0Ll = parcelRequire("3b0Ll");
function $1838583c06c42261$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $3b0Ll.getDefaultValueType)(key);
    if (defaultValueType !== (0, $8YMh9.filter)) defaultValueType = (0, $aSe5F.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("8YMh9", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $9326f348bb1b920e$export$3dea766d36a8935f; });

var $aSe5F = parcelRequire("aSe5F");

var $M3cKA = parcelRequire("M3cKA");
/**
 * Properties that should default to 1 or 100%
 */ const $9326f348bb1b920e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $9326f348bb1b920e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $M3cKA.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $9326f348bb1b920e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $9326f348bb1b920e$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $9326f348bb1b920e$export$3dea766d36a8935f = {
    ...(0, $aSe5F.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($9326f348bb1b920e$var$functionRegex);
        return functions ? functions.map($9326f348bb1b920e$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("3b0Ll", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $5244b39289cc5c6d$export$67d1babe0338d23b; });

var $4SRtp = parcelRequire("4SRtp");

var $8YMh9 = parcelRequire("8YMh9");

var $htuxd = parcelRequire("htuxd");
/**
 * A map of default value types for common values
 */ const $5244b39289cc5c6d$export$98cd7c72c5a731fb = {
    ...(0, $htuxd.numberValueTypes),
    color: // Color props
    $4SRtp.color,
    backgroundColor: (0, $4SRtp.color),
    outlineColor: (0, $4SRtp.color),
    fill: (0, $4SRtp.color),
    stroke: (0, $4SRtp.color),
    // Border props
    borderColor: (0, $4SRtp.color),
    borderTopColor: (0, $4SRtp.color),
    borderRightColor: (0, $4SRtp.color),
    borderBottomColor: (0, $4SRtp.color),
    borderLeftColor: (0, $4SRtp.color),
    filter: $8YMh9.filter,
    WebkitFilter: (0, $8YMh9.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $5244b39289cc5c6d$export$67d1babe0338d23b = (key)=>$5244b39289cc5c6d$export$98cd7c72c5a731fb[key];

});
parcelRegister("htuxd", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $e26e0ac69c88d1e3$export$eec14432cd1cb67b; });

var $5y23w = parcelRequire("5y23w");

var $1aEW4 = parcelRequire("1aEW4");

var $9Y1Er = parcelRequire("9Y1Er");
const $e26e0ac69c88d1e3$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $1aEW4.px),
    borderTopWidth: (0, $1aEW4.px),
    borderRightWidth: (0, $1aEW4.px),
    borderBottomWidth: (0, $1aEW4.px),
    borderLeftWidth: (0, $1aEW4.px),
    borderRadius: (0, $1aEW4.px),
    radius: (0, $1aEW4.px),
    borderTopLeftRadius: (0, $1aEW4.px),
    borderTopRightRadius: (0, $1aEW4.px),
    borderBottomRightRadius: (0, $1aEW4.px),
    borderBottomLeftRadius: (0, $1aEW4.px),
    // Positioning props
    width: (0, $1aEW4.px),
    maxWidth: (0, $1aEW4.px),
    height: (0, $1aEW4.px),
    maxHeight: (0, $1aEW4.px),
    size: (0, $1aEW4.px),
    top: (0, $1aEW4.px),
    right: (0, $1aEW4.px),
    bottom: (0, $1aEW4.px),
    left: (0, $1aEW4.px),
    // Spacing props
    padding: (0, $1aEW4.px),
    paddingTop: (0, $1aEW4.px),
    paddingRight: (0, $1aEW4.px),
    paddingBottom: (0, $1aEW4.px),
    paddingLeft: (0, $1aEW4.px),
    margin: (0, $1aEW4.px),
    marginTop: (0, $1aEW4.px),
    marginRight: (0, $1aEW4.px),
    marginBottom: (0, $1aEW4.px),
    marginLeft: (0, $1aEW4.px),
    // Transform props
    rotate: (0, $1aEW4.degrees),
    rotateX: (0, $1aEW4.degrees),
    rotateY: (0, $1aEW4.degrees),
    rotateZ: (0, $1aEW4.degrees),
    scale: $5y23w.scale,
    scaleX: (0, $5y23w.scale),
    scaleY: (0, $5y23w.scale),
    scaleZ: (0, $5y23w.scale),
    skew: (0, $1aEW4.degrees),
    skewX: (0, $1aEW4.degrees),
    skewY: (0, $1aEW4.degrees),
    distance: (0, $1aEW4.px),
    translateX: (0, $1aEW4.px),
    translateY: (0, $1aEW4.px),
    translateZ: (0, $1aEW4.px),
    x: (0, $1aEW4.px),
    y: (0, $1aEW4.px),
    z: (0, $1aEW4.px),
    perspective: (0, $1aEW4.px),
    transformPerspective: (0, $1aEW4.px),
    opacity: (0, $5y23w.alpha),
    originX: (0, $1aEW4.progressPercentage),
    originY: (0, $1aEW4.progressPercentage),
    originZ: (0, $1aEW4.px),
    // Misc
    zIndex: (0, $9Y1Er.int),
    backgroundPositionX: (0, $1aEW4.px),
    backgroundPositionY: (0, $1aEW4.px),
    // SVG
    fillOpacity: (0, $5y23w.alpha),
    strokeOpacity: (0, $5y23w.alpha),
    numOctaves: (0, $9Y1Er.int)
};

});
parcelRegister("9Y1Er", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $1500fa361742b746$export$7d260a2a5f8bc19e; });

var $5y23w = parcelRequire("5y23w");
const $1500fa361742b746$export$7d260a2a5f8bc19e = {
    ...(0, $5y23w.number),
    transform: Math.round
};

});






parcelRegister("lG8CU", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $b4f9da87da1ca830$export$7c73462e0d25e514; });
function $b4f9da87da1ca830$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("3QPLs", function(module, exports) {

$parcel$export(module.exports, "BaseAnimation", function () { return $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1; });

var $8Nfz4 = parcelRequire("8Nfz4");

var $81ZQd = parcelRequire("81ZQd");

var $7rWDV = parcelRequire("7rWDV");

var $dlXx4 = parcelRequire("dlXx4");
class $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $8Nfz4.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $7rWDV.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $81ZQd.instantAnimationState).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $dlXx4.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}

});
parcelRegister("7rWDV", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $dd719f2577620065$export$1b109e6c9968df4f; });

var $9Xqx7 = parcelRequire("9Xqx7");

var $bhTHg = parcelRequire("bhTHg");
function $dd719f2577620065$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $dd719f2577620065$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $bhTHg.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $bhTHg.isAnimatable)(targetKeyframe, name);
    (0, $9Xqx7.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $dd719f2577620065$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}

});
parcelRegister("bhTHg", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $9af063a91152801b$export$65676b58b122bc38; });

var $aSe5F = parcelRequire("aSe5F");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $9af063a91152801b$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $aSe5F.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});



parcelRegister("gqZNo", function(module, exports) {

$parcel$export(module.exports, "MainThreadAnimation", function () { return $38d8d0fc14215eff$export$fd98d9cca67a58bc; });

var $8Nfz4 = parcelRequire("8Nfz4");

var $iRUPD = parcelRequire("iRUPD");

var $34fjL = parcelRequire("34fjL");

var $5PmPp = parcelRequire("5PmPp");

var $3QPLs = parcelRequire("3QPLs");

var $gvGU7 = parcelRequire("gvGU7");

var $guE26 = parcelRequire("guE26");

var $1GD7g = parcelRequire("1GD7g");

var $faqPt = parcelRequire("faqPt");

var $9akfM = parcelRequire("9akfM");


var $6wMO1 = parcelRequire("6wMO1");

var $dlXx4 = parcelRequire("dlXx4");
const $38d8d0fc14215eff$var$generators = {
    decay: (0, $34fjL.inertia),
    inertia: $34fjL.inertia,
    tween: (0, $5PmPp.keyframes),
    keyframes: (0, $5PmPp.keyframes),
    spring: $iRUPD.spring
};
const $38d8d0fc14215eff$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $38d8d0fc14215eff$export$fd98d9cca67a58bc extends (0, $3QPLs.BaseAnimation) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $8Nfz4.KeyframeResolver), ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $38d8d0fc14215eff$var$generators[type] || (0, $5PmPp.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $5PmPp.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $gvGU7.pipe)($38d8d0fc14215eff$var$percentToProgress, (0, $guE26.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $1GD7g.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $9akfM.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $dlXx4.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $faqPt.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $faqPt.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $faqPt.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $faqPt.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $6wMO1.frameloopDriver), onPlay: onPlay } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $38d8d0fc14215eff$export$ee9b76de7353d815(options) {
    return new $38d8d0fc14215eff$export$fd98d9cca67a58bc(options);
}

});
parcelRegister("iRUPD", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $883a7f57df047776$export$b36281d89752ae66; });

var $faqPt = parcelRequire("faqPt");

var $eW3mg = parcelRequire("eW3mg");

var $j5bgf = parcelRequire("j5bgf");
const $883a7f57df047776$var$durationKeys = [
    "duration",
    "bounce"
];
const $883a7f57df047776$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $883a7f57df047776$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $883a7f57df047776$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$physicsKeys) && $883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$durationKeys)) {
        const derived = (0, $j5bgf.findSpring)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $883a7f57df047776$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $883a7f57df047776$var$getSpringOptions({
        ...options,
        velocity: -(0, $faqPt.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $faqPt.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $j5bgf.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $eW3mg.calcGeneratorVelocity)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}

});
parcelRegister("eW3mg", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", function () { return $53c11e9376dd0d8e$export$854187271d233eb5; });

var $j6Lkz = parcelRequire("j6Lkz");
const $53c11e9376dd0d8e$var$velocitySampleDuration = 5; // ms
function $53c11e9376dd0d8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $53c11e9376dd0d8e$var$velocitySampleDuration, 0);
    return (0, $j6Lkz.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});
parcelRegister("j6Lkz", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $8d9716de34c4d522$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $8d9716de34c4d522$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("j5bgf", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $e053e23acb72da0f$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $e053e23acb72da0f$export$5f679887c3a78b15; });

var $9Xqx7 = parcelRequire("9Xqx7");

var $9akfM = parcelRequire("9akfM");

var $faqPt = parcelRequire("faqPt");
const $e053e23acb72da0f$var$safeMin = 0.001;
const $e053e23acb72da0f$export$a3cdb76e84ee608e = 0.01;
const $e053e23acb72da0f$export$1824b851fad8862b = 10.0;
const $e053e23acb72da0f$export$ff08f2d53484465 = 0.05;
const $e053e23acb72da0f$export$201ca48e54038115 = 1;
function $e053e23acb72da0f$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $9Xqx7.warning)(duration <= (0, $faqPt.secondsToMilliseconds)($e053e23acb72da0f$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $9akfM.clamp)($e053e23acb72da0f$export$ff08f2d53484465, $e053e23acb72da0f$export$201ca48e54038115, dampingRatio);
    duration = (0, $9akfM.clamp)($e053e23acb72da0f$export$a3cdb76e84ee608e, $e053e23acb72da0f$export$1824b851fad8862b, (0, $faqPt.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $e053e23acb72da0f$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $e053e23acb72da0f$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $e053e23acb72da0f$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$e053e23acb72da0f$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $faqPt.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $e053e23acb72da0f$var$rootIterations = 12;
function $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $e053e23acb72da0f$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});


parcelRegister("34fjL", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $45d5055f4c56892a$export$ee3ff3a17106998; });

var $iRUPD = parcelRequire("iRUPD");

var $eW3mg = parcelRequire("eW3mg");
function $45d5055f4c56892a$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $iRUPD.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $eW3mg.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});

parcelRegister("5PmPp", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $a441228218aac9d3$export$d25ddfdf17c3ad3e; });

var $cZiAH = parcelRequire("cZiAH");

var $2VC8b = parcelRequire("2VC8b");

var $1DpCs = parcelRequire("1DpCs");

var $ihHTo = parcelRequire("ihHTo");

var $7s1rD = parcelRequire("7s1rD");

var $5bhjS = parcelRequire("5bhjS");
function $a441228218aac9d3$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $cZiAH.easeInOut)).splice(0, values.length - 1);
}
function $a441228218aac9d3$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $2VC8b.isEasingArray)(ease) ? ease.map((0, $1DpCs.easingDefinitionToFunction)) : (0, $1DpCs.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $5bhjS.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $7s1rD.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ihHTo.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $a441228218aac9d3$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("cZiAH", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $d8968a9bf4ef9569$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $d8968a9bf4ef9569$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $d8968a9bf4ef9569$export$c07234257a03d5e9; });

var $eetDG = parcelRequire("eetDG");
const $d8968a9bf4ef9569$export$929e5a82286172a6 = (0, $eetDG.cubicBezier)(0.42, 0, 1, 1);
const $d8968a9bf4ef9569$export$57636bb43b1ccbb0 = (0, $eetDG.cubicBezier)(0, 0, 0.58, 1);
const $d8968a9bf4ef9569$export$c07234257a03d5e9 = (0, $eetDG.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("eetDG", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $704adaa4b6058bb3$export$2c575fa1d20488bd; });

var $hcHQh = parcelRequire("hcHQh");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $704adaa4b6058bb3$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $704adaa4b6058bb3$var$subdivisionPrecision = 0.0000001;
const $704adaa4b6058bb3$var$subdivisionMaxIterations = 12;
function $704adaa4b6058bb3$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $704adaa4b6058bb3$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $704adaa4b6058bb3$var$subdivisionPrecision && ++i < $704adaa4b6058bb3$var$subdivisionMaxIterations);
    return currentT;
}
function $704adaa4b6058bb3$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $hcHQh.noop;
    const getTForX = (aX)=>$704adaa4b6058bb3$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $704adaa4b6058bb3$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("2VC8b", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $77de1aec9c0d8bc3$export$216948827bbdc797; });
const $77de1aec9c0d8bc3$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("1DpCs", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $d606f3c6c8f4d23c$export$ef97fe084f156ca4; });

var $9Xqx7 = parcelRequire("9Xqx7");

var $eetDG = parcelRequire("eetDG");

var $hcHQh = parcelRequire("hcHQh");

var $cZiAH = parcelRequire("cZiAH");

var $e8q1q = parcelRequire("e8q1q");

var $c9wA9 = parcelRequire("c9wA9");

var $626Z4 = parcelRequire("626Z4");
const $d606f3c6c8f4d23c$var$easingLookup = {
    linear: (0, $hcHQh.noop),
    easeIn: $cZiAH.easeIn,
    easeInOut: $cZiAH.easeInOut,
    easeOut: $cZiAH.easeOut,
    circIn: $e8q1q.circIn,
    circInOut: $e8q1q.circInOut,
    circOut: $e8q1q.circOut,
    backIn: $c9wA9.backIn,
    backInOut: $c9wA9.backInOut,
    backOut: $c9wA9.backOut,
    anticipate: $626Z4.anticipate
};
const $d606f3c6c8f4d23c$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $9Xqx7.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $eetDG.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $9Xqx7.invariant)($d606f3c6c8f4d23c$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $d606f3c6c8f4d23c$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("e8q1q", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $f0e499eff44e3cea$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $f0e499eff44e3cea$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $f0e499eff44e3cea$export$30d3455eee55bed5; });

var $jEOCQ = parcelRequire("jEOCQ");

var $cXloI = parcelRequire("cXloI");
const $f0e499eff44e3cea$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $f0e499eff44e3cea$export$c8d67a19199d1a50 = (0, $cXloI.reverseEasing)($f0e499eff44e3cea$export$e444123e42d03385);
const $f0e499eff44e3cea$export$30d3455eee55bed5 = (0, $jEOCQ.mirrorEasing)($f0e499eff44e3cea$export$e444123e42d03385);

});
parcelRegister("jEOCQ", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $89b4bec8fd3fdad1$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $89b4bec8fd3fdad1$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("cXloI", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $0437738b097fa26f$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $0437738b097fa26f$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});


parcelRegister("c9wA9", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $d3c4eaabf34a945a$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $d3c4eaabf34a945a$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $d3c4eaabf34a945a$export$ddc5fd596f6c71b2; });

var $eetDG = parcelRequire("eetDG");

var $jEOCQ = parcelRequire("jEOCQ");

var $cXloI = parcelRequire("cXloI");
const $d3c4eaabf34a945a$export$77edfce482316a60 = (0, $eetDG.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $d3c4eaabf34a945a$export$b01116c84cdfe1a2 = (0, $cXloI.reverseEasing)($d3c4eaabf34a945a$export$77edfce482316a60);
const $d3c4eaabf34a945a$export$ddc5fd596f6c71b2 = (0, $jEOCQ.mirrorEasing)($d3c4eaabf34a945a$export$b01116c84cdfe1a2);

});

parcelRegister("626Z4", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $1a7a42634de0d0af$export$6b0af63b873d419e; });

var $c9wA9 = parcelRequire("c9wA9");
const $1a7a42634de0d0af$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $c9wA9.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});


parcelRegister("ihHTo", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $db1b2cb99cb3914e$export$89e29e4ab65e70a9; });

var $9Xqx7 = parcelRequire("9Xqx7");

var $9akfM = parcelRequire("9akfM");

var $gvGU7 = parcelRequire("gvGU7");

var $8YF9J = parcelRequire("8YF9J");

var $hcHQh = parcelRequire("hcHQh");

var $guE26 = parcelRequire("guE26");
function $db1b2cb99cb3914e$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $guE26.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $hcHQh.noop) : ease;
            mixer = (0, $gvGU7.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $db1b2cb99cb3914e$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $9Xqx7.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $db1b2cb99cb3914e$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $8YF9J.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $9akfM.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("gvGU7", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $6cc9e4dbba39be5c$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $6cc9e4dbba39be5c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $6cc9e4dbba39be5c$export$a4627e546088548d = (...transformers)=>transformers.reduce($6cc9e4dbba39be5c$var$combineFunctions);

});

parcelRegister("8YF9J", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $e6e94e48128648b0$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $e6e94e48128648b0$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("guE26", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $ffbcc7e5194b07fa$export$2c9e8a9632a706b2; });

var $1vcft = parcelRequire("1vcft");

var $74P7x = parcelRequire("74P7x");
function $ffbcc7e5194b07fa$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $74P7x.mixNumber)(from, to, p);
    const mixer = (0, $1vcft.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("1vcft", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $bbad6d399b1675c4$export$36ec24672cd098e0; });

var $74P7x = parcelRequire("74P7x");

var $bi71X = parcelRequire("bi71X");

var $gvGU7 = parcelRequire("gvGU7");

var $9Xqx7 = parcelRequire("9Xqx7");

var $4SRtp = parcelRequire("4SRtp");

var $aSe5F = parcelRequire("aSe5F");

var $lB8dT = parcelRequire("lB8dT");

var $ci1ip = parcelRequire("ci1ip");

var $iOJ62 = parcelRequire("iOJ62");
function $bbad6d399b1675c4$var$mixNumber(a, b) {
    return (p)=>(0, $74P7x.mixNumber)(a, b, p);
}
function $bbad6d399b1675c4$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $bbad6d399b1675c4$var$mixNumber;
    else if (typeof a === "string") return (0, $lB8dT.isCSSVariableToken)(a) ? (0, $iOJ62.mixImmediate) : (0, $4SRtp.color).test(a) ? (0, $bi71X.mixColor) : $bbad6d399b1675c4$export$65516310a87d8205;
    else if (Array.isArray(a)) return $bbad6d399b1675c4$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $4SRtp.color).test(a) ? (0, $bi71X.mixColor) : $bbad6d399b1675c4$export$ebc23b6840c51ba1;
    return 0, $iOJ62.mixImmediate;
}
function $bbad6d399b1675c4$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$bbad6d399b1675c4$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $bbad6d399b1675c4$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $bbad6d399b1675c4$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $bbad6d399b1675c4$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $bbad6d399b1675c4$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $aSe5F.complex).createTransformer(target);
    const originStats = (0, $aSe5F.analyseComplexValue)(origin);
    const targetStats = (0, $aSe5F.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $ci1ip.invisibleValues).has(origin) && !targetStats.values.length || (0, $ci1ip.invisibleValues).has(target) && !originStats.values.length) return (0, $ci1ip.mixVisibility)(origin, target);
        return (0, $gvGU7.pipe)($bbad6d399b1675c4$export$3bbefa2f402845c4($bbad6d399b1675c4$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $9Xqx7.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $iOJ62.mixImmediate)(origin, target);
    }
};

});
parcelRegister("74P7x", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $87248eb8ba080f28$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $87248eb8ba080f28$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("bi71X", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $3587923dc2cfe4e2$export$51e568cf5c039bac; });

var $74P7x = parcelRequire("74P7x");

var $9Xqx7 = parcelRequire("9Xqx7");

var $1oU8R = parcelRequire("1oU8R");

var $do2NO = parcelRequire("do2NO");

var $am2YS = parcelRequire("am2YS");

var $7TVwi = parcelRequire("7TVwi");

var $iOJ62 = parcelRequire("iOJ62");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $3587923dc2cfe4e2$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $3587923dc2cfe4e2$var$colorTypes = [
    (0, $do2NO.hex),
    (0, $am2YS.rgba),
    (0, $7TVwi.hsla)
];
const $3587923dc2cfe4e2$var$getColorType = (v)=>$3587923dc2cfe4e2$var$colorTypes.find((type)=>type.test(v));
function $3587923dc2cfe4e2$var$asRGBA(color) {
    const type = $3587923dc2cfe4e2$var$getColorType(color);
    (0, $9Xqx7.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $7TVwi.hsla)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $1oU8R.hslaToRgba)(model);
    return model;
}
const $3587923dc2cfe4e2$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $3587923dc2cfe4e2$var$asRGBA(from);
    const toRGBA = $3587923dc2cfe4e2$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $iOJ62.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $74P7x.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $am2YS.rgba).transform(blended);
    };
};

});
parcelRegister("1oU8R", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $5429745468e3b812$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $5429745468e3b812$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5429745468e3b812$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $5429745468e3b812$var$hueToRgb(p, q, hue + 1 / 3);
        green = $5429745468e3b812$var$hueToRgb(p, q, hue);
        blue = $5429745468e3b812$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("iOJ62", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $a4bfef1e47c99c15$export$a6f92d4bae65c0f1; });
function $a4bfef1e47c99c15$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("ci1ip", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $d051ba1e71c72dc9$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $d051ba1e71c72dc9$export$fed62ccc3fb1a568; });
const $d051ba1e71c72dc9$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $d051ba1e71c72dc9$export$fed62ccc3fb1a568(origin, target) {
    if ($d051ba1e71c72dc9$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});




parcelRegister("7s1rD", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d; });

var $iDNzl = parcelRequire("iDNzl");
function $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $iDNzl.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("iDNzl", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $3d0a1060fe6b890b$export$dafee61230cf05c6; });

var $74P7x = parcelRequire("74P7x");

var $8YF9J = parcelRequire("8YF9J");
function $3d0a1060fe6b890b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $8YF9J.progress)(0, remaining, i);
        offset.push((0, $74P7x.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("5bhjS", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $56a5cdb9e012c5ee$export$2a91b4e3a4539316; });
function $56a5cdb9e012c5ee$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("1GD7g", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorDuration", function () { return $9e09771207b3385c$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9e09771207b3385c$export$f4ff70a5b4808fd8 = 20000;
function $9e09771207b3385c$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $9e09771207b3385c$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $9e09771207b3385c$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("6wMO1", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $eb7f9ad0d187e388$export$c1033964b5ad7fef; });

var $035gC = parcelRequire("035gC");

var $f6xYV = parcelRequire("f6xYV");
const $eb7f9ad0d187e388$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $f6xYV.frame).update(passTimestamp, true),
        stop: ()=>(0, $f6xYV.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $f6xYV.frameData).isProcessing ? (0, $f6xYV.frameData).timestamp : (0, $035gC.time).now()
    };
};

});


parcelRegister("6wHmf", function(module, exports) {

$parcel$export(module.exports, "animateStyle", function () { return $2b04773fa5493e28$export$c76cd972d26986f9; });

var $61c9Y = parcelRequire("61c9Y");
function $2b04773fa5493e28$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $61c9Y.mapEasingToNativeEasing)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});
parcelRegister("61c9Y", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", function () { return $9b4b0944f487b7c3$export$fcdd8f3f2160beda; });
$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $9b4b0944f487b7c3$export$916ea73bcd3a6030; });

var $32y6J = parcelRequire("32y6J");
function $9b4b0944f487b7c3$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $9b4b0944f487b7c3$export$2cf569f5e2221176 || (0, $32y6J.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($9b4b0944f487b7c3$export$fcdd8f3f2160beda));
}
const $9b4b0944f487b7c3$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $9b4b0944f487b7c3$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $9b4b0944f487b7c3$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $9b4b0944f487b7c3$var$mapEasingToNativeEasingWithDefault(easing) {
    return $9b4b0944f487b7c3$export$916ea73bcd3a6030(easing) || $9b4b0944f487b7c3$export$2cf569f5e2221176.easeOut;
}
function $9b4b0944f487b7c3$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $32y6J.isBezierDefinition)(easing)) return $9b4b0944f487b7c3$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($9b4b0944f487b7c3$var$mapEasingToNativeEasingWithDefault);
    else return $9b4b0944f487b7c3$export$2cf569f5e2221176[easing];
}

});
parcelRegister("32y6J", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $3a622b680f893ceb$export$ff43f99925d7366b; });
const $3a622b680f893ceb$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});




parcelRegister("8IAzf", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", function () { return $dc9a88cb44e235dd$export$c1e41718f71efe41; });

var $bo6Ep = parcelRequire("bo6Ep");

var $5gocv = parcelRequire("5gocv");
class $dc9a88cb44e235dd$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $5gocv.supportsScrollTimeline)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $bo6Ep.observeTimeline)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

});
parcelRegister("bo6Ep", function(module, exports) {

$parcel$export(module.exports, "observeTimeline", function () { return $19a70e2eba46f551$export$b4f1bbab0c442a76; });

var $f6xYV = parcelRequire("f6xYV");
function $19a70e2eba46f551$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $f6xYV.frame).update(onFrame, true);
    return ()=>(0, $f6xYV.cancelFrame)(onFrame);
}

});

parcelRegister("5gocv", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $e728714da8c8a772$export$20d68f04f30763a5; });

var $lG8CU = parcelRequire("lG8CU");
const $e728714da8c8a772$export$20d68f04f30763a5 = (0, $lG8CU.memo)(()=>window.ScrollTimeline !== undefined);

});



parcelRegister("bMmjh", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $7b21dab475728d1e$export$98397f3adbf6259f; });

var $6fKk5 = parcelRequire("6fKk5");
function $7b21dab475728d1e$export$98397f3adbf6259f(value) {
    return Boolean((0, $6fKk5.isMotionValue)(value) && value.add);
}

});
parcelRegister("6fKk5", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $d449570363f09a53$export$605d60a2578142d3; });
const $d449570363f09a53$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});


parcelRegister("fZs52", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $4ddbbe2518feafa3$export$1f61c53461aff4a5; });

var $5t0FJ = parcelRequire("5t0FJ");

var $Fxl2f = parcelRequire("Fxl2f");

var $fA79e = parcelRequire("fA79e");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $Fxl2f.motionValue)(value));
}
function $4ddbbe2518feafa3$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $fA79e.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $5t0FJ.resolveFinalValueInKeyframes)(target[key]);
        $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("5t0FJ", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $b9d94c0c185391a2$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $b9d94c0c185391a2$export$5485128c47bd48bb; });

var $f8Cke = parcelRequire("f8Cke");
const $b9d94c0c185391a2$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $b9d94c0c185391a2$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $f8Cke.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});

parcelRegister("Fxl2f", function(module, exports) {

$parcel$export(module.exports, "MotionValue", function () { return $925342fde4532b85$export$8cea36d14ee64562; });
$parcel$export(module.exports, "motionValue", function () { return $925342fde4532b85$export$ce8bdc721e76545f; });

var $eDqtm = parcelRequire("eDqtm");

var $j6Lkz = parcelRequire("j6Lkz");


var $035gC = parcelRequire("035gC");

var $f6xYV = parcelRequire("f6xYV");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $925342fde4532b85$var$MAX_VELOCITY_DELTA = 30;
const $925342fde4532b85$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $925342fde4532b85$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $925342fde4532b85$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.2.10";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $035gC.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $035gC.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $925342fde4532b85$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $eDqtm.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $f6xYV.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($925342fde4532b85$export$67fcd818a264039d.current) $925342fde4532b85$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $035gC.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $925342fde4532b85$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $925342fde4532b85$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $j6Lkz.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $925342fde4532b85$export$ce8bdc721e76545f(init, options) {
    return new $925342fde4532b85$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("eDqtm", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c; });

var $jgfKC = parcelRequire("jgfKC");
class $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $jgfKC.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $jgfKC.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});
parcelRegister("jgfKC", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $13ad1cfa8b4681b0$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c; });
function $13ad1cfa8b4681b0$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $13ad1cfa8b4681b0$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});




parcelRegister("bzdeT", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $e2f74713dde14d85$export$5f8d21e84d1d84fc; });

var $cTas6 = parcelRequire("cTas6");
function $e2f74713dde14d85$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.getProps()[0, $cTas6.optimizedAppearDataAttribute];
}

});
parcelRegister("cTas6", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $6b140fcbcf20767d$export$8592e1c077c890a6; });

var $1UgmA = parcelRequire("1UgmA");
const $6b140fcbcf20767d$export$ed7b8fa9dbf0105d = "framerAppearId";
const $6b140fcbcf20767d$export$8592e1c077c890a6 = "data-" + (0, $1UgmA.camelToDash)($6b140fcbcf20767d$export$ed7b8fa9dbf0105d);

});
parcelRegister("1UgmA", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $002b84d235cc9e7f$export$9fd24a634729c672; });
/**
 * Convert camelCase to dash-case properties.
 */ const $002b84d235cc9e7f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});




parcelRegister("bpI65", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $8c445c76717d72c0$export$4709dc300705b2af; });

var $fA79e = parcelRequire("fA79e");

var $02GM7 = parcelRequire("02GM7");
function $8c445c76717d72c0$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $fA79e.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $02GM7.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($8c445c76717d72c0$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($8c445c76717d72c0$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $8c445c76717d72c0$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});



parcelRegister("cxR2c", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $8c269db61902fb68$export$6e91cf7616333d5; });
class $8c269db61902fb68$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("b6orE", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $a4f717d2e1520e94$export$4989d1eb6104cc6c; });

var $cxR2c = parcelRequire("cxR2c");
let $a4f717d2e1520e94$var$id = 0;
class $a4f717d2e1520e94$export$4989d1eb6104cc6c extends (0, $cxR2c.Feature) {
    constructor(){
        super(...arguments);
        this.id = $a4f717d2e1520e94$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("aFn5x", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $aadd72d7ca06bd3a$export$e5b72898e5a201f1; });

var $61GlQ = parcelRequire("61GlQ");

var $8dWOV = parcelRequire("8dWOV");

var $cE0fg = parcelRequire("cE0fg");

var $5gtIE = parcelRequire("5gtIE");
const $aadd72d7ca06bd3a$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $5gtIE.InViewFeature)
    },
    tap: {
        Feature: (0, $cE0fg.PressGesture)
    },
    focus: {
        Feature: (0, $8dWOV.FocusGesture)
    },
    hover: {
        Feature: (0, $61GlQ.HoverGesture)
    }
};

});
parcelRegister("61GlQ", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $d74f51ccafbc2725$export$93a81ea037eac456; });

var $4JRxN = parcelRequire("4JRxN");

var $gvGU7 = parcelRequire("gvGU7");

var $cxEY6 = parcelRequire("cxEY6");

var $cxR2c = parcelRequire("cxR2c");

var $f6xYV = parcelRequire("f6xYV");
function $d74f51ccafbc2725$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $cxEY6.isDragActive)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $f6xYV.frame).postRender(()=>callback(event, info));
    };
    return (0, $4JRxN.addPointerEvent)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $d74f51ccafbc2725$export$93a81ea037eac456 extends (0, $cxR2c.Feature) {
    mount() {
        this.unmount = (0, $gvGU7.pipe)($d74f51ccafbc2725$var$addHoverEvent(this.node, true), $d74f51ccafbc2725$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}

});
parcelRegister("4JRxN", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $149813d40ccb6fe7$export$fcff2e64e6676b81; });

var $7OSJB = parcelRequire("7OSJB");

var $a2uDX = parcelRequire("a2uDX");
function $149813d40ccb6fe7$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $7OSJB.addDomEvent)(target, eventName, (0, $a2uDX.addPointerInfo)(handler), options);
}

});
parcelRegister("7OSJB", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $5727f053dc302d4d$export$b1d829ddf82884aa; });
function $5727f053dc302d4d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("a2uDX", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $c20245f8d567b28b$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "addPointerInfo", function () { return $c20245f8d567b28b$export$c404e80f92c98d29; });

var $ifmOr = parcelRequire("ifmOr");
function $c20245f8d567b28b$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $c20245f8d567b28b$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $ifmOr.isPrimaryPointer)(event) && handler(event, $c20245f8d567b28b$export$12f84bb882d06e1a(event));
};

});
parcelRegister("ifmOr", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $d4a10dbc24cee995$export$a4cf9c8a4b063a6e; });
const $d4a10dbc24cee995$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("cxEY6", function(module, exports) {

$parcel$export(module.exports, "isDragActive", function () { return $ab472a7ccdd5989f$export$1b3dd616664938e4; });
function $ab472a7ccdd5989f$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $ab472a7ccdd5989f$var$globalHorizontalLock = $ab472a7ccdd5989f$export$518c5fc2dcb7974b("dragHorizontal");
const $ab472a7ccdd5989f$var$globalVerticalLock = $ab472a7ccdd5989f$export$518c5fc2dcb7974b("dragVertical");
function $ab472a7ccdd5989f$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $ab472a7ccdd5989f$var$globalVerticalLock();
    else if (drag === "x") lock = $ab472a7ccdd5989f$var$globalHorizontalLock();
    else {
        const openHorizontal = $ab472a7ccdd5989f$var$globalHorizontalLock();
        const openVertical = $ab472a7ccdd5989f$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $ab472a7ccdd5989f$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $ab472a7ccdd5989f$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});


parcelRegister("8dWOV", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $194e5f2fba7dd91c$export$d4826db40d47595b; });

var $7OSJB = parcelRequire("7OSJB");

var $cxR2c = parcelRequire("cxR2c");

var $gvGU7 = parcelRequire("gvGU7");
class $194e5f2fba7dd91c$export$d4826db40d47595b extends (0, $cxR2c.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $gvGU7.pipe)((0, $7OSJB.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $7OSJB.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("cE0fg", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $7978956cdecaf1df$export$f026abdbba7f0c9e; });

var $a2uDX = parcelRequire("a2uDX");

var $7OSJB = parcelRequire("7OSJB");

var $4JRxN = parcelRequire("4JRxN");

var $cxR2c = parcelRequire("cxR2c");

var $gvGU7 = parcelRequire("gvGU7");

var $cxEY6 = parcelRequire("cxEY6");

var $8A29e = parcelRequire("8A29e");

var $hcHQh = parcelRequire("hcHQh");

var $f6xYV = parcelRequire("f6xYV");
function $7978956cdecaf1df$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $a2uDX.extractEventInfo)(syntheticPointerEvent));
}
class $7978956cdecaf1df$export$f026abdbba7f0c9e extends (0, $cxR2c.Feature) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $hcHQh.noop);
        this.removeEndListeners = (0, $hcHQh.noop);
        this.removeAccessibleListeners = (0, $hcHQh.noop);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $8A29e.isNodeOrChild)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $f6xYV.frame).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $4JRxN.addPointerEvent)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $4JRxN.addPointerEvent)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $gvGU7.pipe)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $7978956cdecaf1df$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $f6xYV.frame).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $7OSJB.addDomEvent)(this.node.current, "keyup", handleKeyup);
                $7978956cdecaf1df$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $7OSJB.addDomEvent)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $7978956cdecaf1df$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $7OSJB.addDomEvent)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $gvGU7.pipe)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $f6xYV.frame).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $cxEY6.isDragActive)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $f6xYV.frame).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $4JRxN.addPointerEvent)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $7OSJB.addDomEvent)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $gvGU7.pipe)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

});
parcelRegister("8A29e", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $53e08f6fdf34dfce$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $53e08f6fdf34dfce$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $53e08f6fdf34dfce$export$e841ada32ff745b(parent, child.parentElement);
};

});


parcelRegister("5gtIE", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $62d26f27ee79826d$export$150851c8cc2f0c72; });

var $cxR2c = parcelRequire("cxR2c");

var $7PO8Z = parcelRequire("7PO8Z");
const $62d26f27ee79826d$var$thresholdNames = {
    some: 0,
    all: 1
};
class $62d26f27ee79826d$export$150851c8cc2f0c72 extends (0, $cxR2c.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $62d26f27ee79826d$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $7PO8Z.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($62d26f27ee79826d$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $62d26f27ee79826d$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("7PO8Z", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $a7da81711d7ddff5$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $a7da81711d7ddff5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $a7da81711d7ddff5$var$observers = new WeakMap();
const $a7da81711d7ddff5$var$fireObserverCallback = (entry)=>{
    const callback = $a7da81711d7ddff5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $a7da81711d7ddff5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($a7da81711d7ddff5$var$fireObserverCallback);
};
function $a7da81711d7ddff5$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$a7da81711d7ddff5$var$observers.has(lookupRoot)) $a7da81711d7ddff5$var$observers.set(lookupRoot, {});
    const rootObservers = $a7da81711d7ddff5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($a7da81711d7ddff5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $a7da81711d7ddff5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $a7da81711d7ddff5$var$initIntersectionObserver(options);
    $a7da81711d7ddff5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $a7da81711d7ddff5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("k2HLV", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $584c8429f63c1575$export$56ba0183203348f5; });

var $bh6RR = parcelRequire("bh6RR");

var $dQHxp = parcelRequire("dQHxp");

var $43mvt = parcelRequire("43mvt");

var $ap7Tt = parcelRequire("ap7Tt");
const $584c8429f63c1575$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ap7Tt.isSVGComponent)(Component) ? new (0, $43mvt.SVGVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $dQHxp.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $bh6RR.Fragment),
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("dQHxp", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $c22d56f4f698c1a8$export$23fea75b03ac16b3; });

var $6MT1W = parcelRequire("6MT1W");

var $lB8dT = parcelRequire("lB8dT");

var $4LMqa = parcelRequire("4LMqa");

var $kHkJ2 = parcelRequire("kHkJ2");

var $5TBab = parcelRequire("5TBab");

var $3b0Ll = parcelRequire("3b0Ll");

var $lHn3N = parcelRequire("lHn3N");

var $abe5q = parcelRequire("abe5q");

var $6fKk5 = parcelRequire("6fKk5");
function $c22d56f4f698c1a8$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $c22d56f4f698c1a8$export$23fea75b03ac16b3 extends (0, $abe5q.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $4LMqa.transformProps).has(key)) {
            const defaultType = (0, $3b0Ll.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $c22d56f4f698c1a8$export$3735103072e4a80(instance);
            const value = ((0, $lB8dT.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $lHn3N.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $6MT1W.buildHTMLStyles)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $kHkJ2.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $6fKk5.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $5TBab.renderHTML)(instance, renderState, styleProp, projection);
    }
}

});
parcelRegister("6MT1W", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $5a314cc097974a58$export$bb517f8b40f8e99d; });

var $foDF2 = parcelRequire("foDF2");

var $lB8dT = parcelRequire("lB8dT");

var $4LMqa = parcelRequire("4LMqa");

var $9I1aU = parcelRequire("9I1aU");

var $htuxd = parcelRequire("htuxd");
function $5a314cc097974a58$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $lB8dT.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $htuxd.numberValueTypes)[key];
        const valueAsType = (0, $9I1aU.getValueAsType)(value, valueType);
        if ((0, $4LMqa.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $foDF2.buildTransform)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("foDF2", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $6330a89fb7e6648e$export$bdc96e0d5c8f914; });

var $4LMqa = parcelRequire("4LMqa");
const $6330a89fb7e6648e$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $6330a89fb7e6648e$var$numTransforms = (0, $4LMqa.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $6330a89fb7e6648e$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $6330a89fb7e6648e$var$numTransforms; i++){
        const key = (0, $4LMqa.transformPropOrder)[i];
        if (transform[key] !== undefined) {
            const transformName = $6330a89fb7e6648e$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}

});

parcelRegister("9I1aU", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $40c56554da907737$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $40c56554da907737$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});


parcelRegister("kHkJ2", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $c0a33d9fc770b07f$export$16da615486abaa45; });

var $1kYFu = parcelRequire("1kYFu");

var $6fKk5 = parcelRequire("6fKk5");
function $c0a33d9fc770b07f$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $6fKk5.isMotionValue)(style[key]) || prevProps.style && (0, $6fKk5.isMotionValue)(prevProps.style[key]) || (0, $1kYFu.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("1kYFu", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf; });

var $kRWnr = parcelRequire("kRWnr");

var $4LMqa = parcelRequire("4LMqa");
function $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $4LMqa.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $kRWnr.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("kRWnr", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $93233d74f0d10a65$export$91ddd985b97788d1; });
const $93233d74f0d10a65$export$91ddd985b97788d1 = {};
function $93233d74f0d10a65$export$de9e7791c71225fd(correctors) {
    Object.assign($93233d74f0d10a65$export$91ddd985b97788d1, correctors);
}

});



parcelRegister("5TBab", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $46b26a876b49a8ee$export$1a32bf6229c258c0; });
function $46b26a876b49a8ee$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("lHn3N", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $0b2600dd2e3d7275$export$d8718b6a7e5c624e; });

var $kQElj = parcelRequire("kQElj");

var $jiU4J = parcelRequire("jiU4J");
function $0b2600dd2e3d7275$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $kQElj.convertBoundingBoxToBox)((0, $kQElj.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $0b2600dd2e3d7275$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $0b2600dd2e3d7275$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $jiU4J.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $jiU4J.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("kQElj", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $040c3e7ac51c9eb3$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $040c3e7ac51c9eb3$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $040c3e7ac51c9eb3$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $040c3e7ac51c9eb3$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $040c3e7ac51c9eb3$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("jiU4J", function(module, exports) {

$parcel$export(module.exports, "translateAxis", function () { return $4c951bbfa32a6f81$export$a807a5ce5ebb3895; });

var $74P7x = parcelRequire("74P7x");

var $7Z6Is = parcelRequire("7Z6Is");
/**
 * Scales a point based on a factor and an originPoint
 */ function $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $4c951bbfa32a6f81$export$d80074982803af5c(box, { x: x, y: y }) {
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $4c951bbfa32a6f81$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $4c951bbfa32a6f81$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $4c951bbfa32a6f81$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $7Z6Is.hasTransform)(node.latestValues)) $4c951bbfa32a6f81$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $4c951bbfa32a6f81$var$snapToDefault(treeScale.x);
    treeScale.y = $4c951bbfa32a6f81$var$snapToDefault(treeScale.y);
}
function $4c951bbfa32a6f81$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $4c951bbfa32a6f81$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $4c951bbfa32a6f81$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $74P7x.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $4c951bbfa32a6f81$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $4c951bbfa32a6f81$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $4c951bbfa32a6f81$export$58b16271041fbfb(box, transform) {
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.x, transform, $4c951bbfa32a6f81$var$xKeys);
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.y, transform, $4c951bbfa32a6f81$var$yKeys);
}

});
parcelRegister("7Z6Is", function(module, exports) {

$parcel$export(module.exports, "hasTransform", function () { return $fed21f2a9fad1fb9$export$a545127cf1fbb600; });
function $fed21f2a9fad1fb9$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fed21f2a9fad1fb9$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fed21f2a9fad1fb9$var$isIdentityScale(scale) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleX) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleY);
}
function $fed21f2a9fad1fb9$export$a545127cf1fbb600(values) {
    return $fed21f2a9fad1fb9$export$bdf30dca883ea463(values) || $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) {
    return $fed21f2a9fad1fb9$var$is2DTranslate(values.x) || $fed21f2a9fad1fb9$var$is2DTranslate(values.y);
}
function $fed21f2a9fad1fb9$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("abe5q", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $f82c67e8782ea4e3$export$e49735c2a366bdc7; });

var $jE9G3 = parcelRequire("jE9G3");

var $7U3iI = parcelRequire("7U3iI");
class $f82c67e8782ea4e3$export$e49735c2a366bdc7 extends (0, $jE9G3.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $7U3iI.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}

});
parcelRegister("jE9G3", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $59dc28bcfaa62e03$export$fa8b653c0f3714e5; });


var $6PX5Z = parcelRequire("6PX5Z");

var $9r4iv = parcelRequire("9r4iv");

var $7jIql = parcelRequire("7jIql");

var $5cT5a = parcelRequire("5cT5a");

var $eDqtm = parcelRequire("eDqtm");

var $Fxl2f = parcelRequire("Fxl2f");

var $bMmjh = parcelRequire("bMmjh");

var $6fKk5 = parcelRequire("6fKk5");

var $4LMqa = parcelRequire("4LMqa");

var $j2zSu = parcelRequire("j2zSu");

var $8YLfI = parcelRequire("8YLfI");

var $5d2DI = parcelRequire("5d2DI");

var $gHRI2 = parcelRequire("gHRI2");


var $4Z4wM = parcelRequire("4Z4wM");

var $9pS7S = parcelRequire("9pS7S");

var $lByvf = parcelRequire("lByvf");

var $8Nfz4 = parcelRequire("8Nfz4");

var $gUFdC = parcelRequire("gUFdC");

var $ihFxk = parcelRequire("ihFxk");

var $5MAxK = parcelRequire("5MAxK");

var $aSe5F = parcelRequire("aSe5F");

var $leusC = parcelRequire("leusC");

var $f6xYV = parcelRequire("f6xYV");
const $59dc28bcfaa62e03$var$featureNames = Object.keys((0, $4Z4wM.featureDefinitions));
const $59dc28bcfaa62e03$var$numFeatures = $59dc28bcfaa62e03$var$featureNames.length;
const $59dc28bcfaa62e03$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $59dc28bcfaa62e03$var$numVariantProps = (0, $9pS7S.variantProps).length;
function $59dc28bcfaa62e03$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $59dc28bcfaa62e03$var$getClosestProjectingNode(visualElement.parent);
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $59dc28bcfaa62e03$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $8Nfz4.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $f6xYV.frame).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $j2zSu.isControllingVariants)(props);
        this.isVariantNode = (0, $j2zSu.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $6fKk5.isMotionValue)(value)) {
                value.set(latestValues[key], false);
                if ((0, $bMmjh.isWillChangeMotionValue)(willChange)) willChange.add(key);
            }
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $lByvf.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5cT5a.hasReducedMotionListener).current) (0, $7jIql.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5cT5a.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        var _a;
        (0, $lByvf.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $f6xYV.cancelFrame)(this.notifyUpdate);
        (0, $f6xYV.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)(_a = this.features[key]) === null || _a === void 0 || _a.unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $4LMqa.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $f6xYV.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $59dc28bcfaa62e03$var$numFeatures; i++){
            const name = $59dc28bcfaa62e03$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $4Z4wM.featureDefinitions)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection = new ProjectionNodeConstructor(this.latestValues, renderedProps["data-framer-portal-id"] ? undefined : $59dc28bcfaa62e03$var$getClosestProjectingNode(this.parent));
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $9r4iv.isRefObject)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $6PX5Z.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $59dc28bcfaa62e03$var$propEventHandlers.length; i++){
            const key = $59dc28bcfaa62e03$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $5d2DI.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $59dc28bcfaa62e03$var$numVariantProps; i++){
            const name = (0, $9pS7S.variantProps)[i];
            const prop = this.props[name];
            if ((0, $8YLfI.isVariantLabel)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $Fxl2f.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $gUFdC.isNumericalString)(value) || (0, $ihFxk.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $5MAxK.findValueType)(value) && (0, $aSe5F.complex).test(target)) value = (0, $leusC.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $6fKk5.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $6fKk5.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $gHRI2.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $6fKk5.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $eDqtm.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("6PX5Z", function(module, exports) {

$parcel$export(module.exports, "createBox", function () { return $93b39ae61dedc877$export$6459fc9e86be362e; });
const $93b39ae61dedc877$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $93b39ae61dedc877$export$3d227df54007d73a = ()=>({
        x: $93b39ae61dedc877$export$ff25708b37f72782(),
        y: $93b39ae61dedc877$export$ff25708b37f72782()
    });
const $93b39ae61dedc877$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $93b39ae61dedc877$export$6459fc9e86be362e = ()=>({
        x: $93b39ae61dedc877$export$6db76765312617ac(),
        y: $93b39ae61dedc877$export$6db76765312617ac()
    });

});

parcelRegister("9r4iv", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $0dc8dc297bc3aa83$export$dedd81df7bc1307; });
function $0dc8dc297bc3aa83$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});

parcelRegister("7jIql", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $8c52f85ab085b323$export$ca9f41fb23dded3d; });

var $bGgku = parcelRequire("bGgku");

var $5cT5a = parcelRequire("5cT5a");
function $8c52f85ab085b323$export$ca9f41fb23dded3d() {
    (0, $5cT5a.hasReducedMotionListener).current = true;
    if (!(0, $bGgku.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5cT5a.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5cT5a.prefersReducedMotion).current = false;
}

});
parcelRegister("5cT5a", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $16faa30fcf534207$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $16faa30fcf534207$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
const $16faa30fcf534207$export$ff7706047246b98b = {
    current: null
};
const $16faa30fcf534207$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("j2zSu", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $a01dc07902ba23d1$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $a01dc07902ba23d1$export$ce46fa4165cdec40; });

var $kQQPC = parcelRequire("kQQPC");

var $8YLfI = parcelRequire("8YLfI");

var $9pS7S = parcelRequire("9pS7S");
function $a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) {
    return (0, $kQQPC.isAnimationControls)(props.animate) || (0, $9pS7S.variantProps).some((name)=>(0, $8YLfI.isVariantLabel)(props[name]));
}
function $a01dc07902ba23d1$export$ce46fa4165cdec40(props) {
    return Boolean($a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) || props.variants);
}

});

parcelRegister("5d2DI", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $c1ce9b34358097f3$export$9a552858d5197f6e; });

var $bMmjh = parcelRequire("bMmjh");


var $Fxl2f = parcelRequire("Fxl2f");

var $6fKk5 = parcelRequire("6fKk5");
function $c1ce9b34358097f3$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $6fKk5.isMotionValue)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $bMmjh.isWillChangeMotionValue)(willChange)) willChange.add(key);
        } else if ((0, $6fKk5.isMotionValue)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $Fxl2f.motionValue)(nextValue, {
                owner: element
            }));
            if ((0, $bMmjh.isWillChangeMotionValue)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $Fxl2f.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("4Z4wM", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $145d8d26c6dc52b8$export$65570e08d843624d; });
const $145d8d26c6dc52b8$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $145d8d26c6dc52b8$export$65570e08d843624d = {};
for(const key in $145d8d26c6dc52b8$var$featureProps)$145d8d26c6dc52b8$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$145d8d26c6dc52b8$var$featureProps[key].some((name)=>!!props[name])
};

});

parcelRegister("lByvf", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $7680e86648d809f1$export$bc2a978a17abfdde; });
const $7680e86648d809f1$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("5MAxK", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $3f77fa41782f639b$export$950e7e59ea1ffed7; });

var $4SRtp = parcelRequire("4SRtp");

var $aSe5F = parcelRequire("aSe5F");

var $1OAXv = parcelRequire("1OAXv");

var $ddx0Q = parcelRequire("ddx0Q");
/**
 * A list of all ValueTypes
 */ const $3f77fa41782f639b$var$valueTypes = [
    ...(0, $1OAXv.dimensionValueTypes),
    (0, $4SRtp.color),
    (0, $aSe5F.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $3f77fa41782f639b$export$950e7e59ea1ffed7 = (v)=>$3f77fa41782f639b$var$valueTypes.find((0, $ddx0Q.testValueType)(v));

});




parcelRegister("43mvt", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $86a41d187babab09$export$86bcdffbaf733d84; });

var $ctAkp = parcelRequire("ctAkp");

var $abe5q = parcelRequire("abe5q");

var $dKNLi = parcelRequire("dKNLi");

var $1UgmA = parcelRequire("1UgmA");

var $9pSjB = parcelRequire("9pSjB");

var $4LMqa = parcelRequire("4LMqa");

var $7VA0i = parcelRequire("7VA0i");

var $3b0Ll = parcelRequire("3b0Ll");

var $6PX5Z = parcelRequire("6PX5Z");

var $5Cb6L = parcelRequire("5Cb6L");
class $86a41d187babab09$export$86bcdffbaf733d84 extends (0, $abe5q.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $4LMqa.transformProps).has(key)) {
            const defaultType = (0, $3b0Ll.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $9pSjB.camelCaseAttributes).has(key) ? (0, $1UgmA.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $6PX5Z.createBox)();
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $ctAkp.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, options, props) {
        (0, $dKNLi.buildSVGAttrs)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $7VA0i.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $5Cb6L.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});
parcelRegister("ctAkp", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $4c234d289d8baf9a$export$16da615486abaa45; });

var $6fKk5 = parcelRequire("6fKk5");

var $kHkJ2 = parcelRequire("kHkJ2");

var $4LMqa = parcelRequire("4LMqa");
function $4c234d289d8baf9a$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $kHkJ2.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $6fKk5.isMotionValue)(props[key]) || (0, $6fKk5.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $4LMqa.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});

parcelRegister("dKNLi", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $6f8e2d5207755192$export$5475d24f125d7053; });

var $6MT1W = parcelRequire("6MT1W");

var $4IiUa = parcelRequire("4IiUa");

var $lgy5D = parcelRequire("lgy5D");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $6f8e2d5207755192$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $6MT1W.buildHTMLStyles)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $4IiUa.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $lgy5D.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("4IiUa", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $72f78baea8d3959f$export$d4fbcfc8e5472155; });

var $1aEW4 = parcelRequire("1aEW4");
function $72f78baea8d3959f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $1aEW4.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $72f78baea8d3959f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $72f78baea8d3959f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $72f78baea8d3959f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});

parcelRegister("lgy5D", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $3fd910e6a82125ad$export$311b43f666da1d82; });

var $1aEW4 = parcelRequire("1aEW4");
const $3fd910e6a82125ad$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $3fd910e6a82125ad$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $3fd910e6a82125ad$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $3fd910e6a82125ad$var$dashKeys : $3fd910e6a82125ad$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $1aEW4.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $1aEW4.px).transform(length);
    const pathSpacing = (0, $1aEW4.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("9pSjB", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $896574d8c8ac028d$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $896574d8c8ac028d$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("7VA0i", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $50c74351dd8901bc$export$c5f8399d19a7394b; });

var $1UgmA = parcelRequire("1UgmA");

var $5TBab = parcelRequire("5TBab");

var $9pSjB = parcelRequire("9pSjB");
function $50c74351dd8901bc$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $5TBab.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $9pSjB.camelCaseAttributes).has(key) ? (0, $1UgmA.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("5Cb6L", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $5c8095c47c03f29b$export$6328ce7565ea1049; });
const $5c8095c47c03f29b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});


parcelRegister("ap7Tt", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $f9a5862a9160f78d$export$88f3fc2fd3766989; });

var $82jVG = parcelRequire("82jVG");
function $f9a5862a9160f78d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $82jVG.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("82jVG", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $c47a60ce42aa9a7c$export$40209c4c512158e6; });
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c47a60ce42aa9a7c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});




parcelRegister("k87FL", function(module, exports) {

$parcel$export(module.exports, "LazyMotion", function () { return $7d0a87d2ed532dac$export$23c340a7eb1b419; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $3gQgL = parcelRequire("3gQgL");

var $aJ1hM = parcelRequire("aJ1hM");
/**
 * Used in conjunction with the `m` component to reduce bundle size.
 *
 * `m` is a version of the `motion` component that only loads functionality
 * critical for the initial render.
 *
 * `LazyMotion` can then be used to either synchronously or asynchronously
 * load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, m, domAnimation } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={domAnimation}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion, m } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimation')}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 * ```
 *
 * @public
 */ function $7d0a87d2ed532dac$export$23c340a7eb1b419({ children: children, features: features, strict: strict = false }) {
    const [, setIsLoaded] = (0, $bh6RR.useState)(!$7d0a87d2ed532dac$var$isLazyBundle(features));
    const loadedRenderer = (0, $bh6RR.useRef)(undefined);
    /**
     * If this is a synchronous load, load features immediately
     */ if (!$7d0a87d2ed532dac$var$isLazyBundle(features)) {
        const { renderer: renderer, ...loadedFeatures } = features;
        loadedRenderer.current = renderer;
        (0, $aJ1hM.loadFeatures)(loadedFeatures);
    }
    (0, $bh6RR.useEffect)(()=>{
        if ($7d0a87d2ed532dac$var$isLazyBundle(features)) features().then(({ renderer: renderer, ...loadedFeatures })=>{
            (0, $aJ1hM.loadFeatures)(loadedFeatures);
            loadedRenderer.current = renderer;
            setIsLoaded(true);
        });
    }, []);
    return (0, $ih19M.jsx)((0, $3gQgL.LazyContext).Provider, {
        value: {
            renderer: loadedRenderer.current,
            strict: strict
        },
        children: children
    });
}
function $7d0a87d2ed532dac$var$isLazyBundle(features) {
    return typeof features === "function";
}

});
parcelRegister("3gQgL", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $6a5cdc65c5393968$export$40f10139ecf1f171; });

var $bh6RR = parcelRequire("bh6RR");
const $6a5cdc65c5393968$export$40f10139ecf1f171 = (0, $bh6RR.createContext)({
    strict: false
});

});

parcelRegister("aJ1hM", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $8223c64d87d3460d$export$449561ec5703cdc8; });

var $4Z4wM = parcelRequire("4Z4wM");
function $8223c64d87d3460d$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $4Z4wM.featureDefinitions)[key] = {
        ...(0, $4Z4wM.featureDefinitions)[key],
        ...features[key]
    };
}

});


parcelRegister("dqffP", function(module, exports) {

$parcel$export(module.exports, "m", function () { return $7e7543db361e9601$export$953cecd6e717a553; });

var $2O6Km = parcelRequire("2O6Km");

var $dztZ8 = parcelRequire("dztZ8");
/**
 * @public
 */ const $7e7543db361e9601$export$953cecd6e717a553 = (0, $2O6Km.createMotionProxy)((0, $dztZ8.createDomMotionConfig));

});
parcelRegister("2O6Km", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $5b22e6221ec72104$export$a28d6df673050e18; });

var $4R6OO = parcelRequire("4R6OO");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $5b22e6221ec72104$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $4R6OO.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});
parcelRegister("4R6OO", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $0c5a031ea8dd3973$export$46b7e4b9dc6110c3; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $8vT8C = parcelRequire("8vT8C");

var $5YQBm = parcelRequire("5YQBm");

var $2NwUh = parcelRequire("2NwUh");

var $b8dH3 = parcelRequire("b8dH3");

var $lpBTW = parcelRequire("lpBTW");

var $aJ1hM = parcelRequire("aJ1hM");

var $bGgku = parcelRequire("bGgku");

var $2JU6p = parcelRequire("2JU6p");

var $3gQgL = parcelRequire("3gQgL");

var $ddIWO = parcelRequire("ddIWO");

var $kNaLx = parcelRequire("kNaLx");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $0c5a031ea8dd3973$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $aJ1hM.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $bh6RR.useContext)((0, $8vT8C.MotionConfigContext)),
            ...props,
            layoutId: $0c5a031ea8dd3973$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $lpBTW.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $bGgku.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $2NwUh.useVisualElement)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $bh6RR.useContext)((0, $ddIWO.SwitchLayoutGroupContext));
            const isStrict = (0, $bh6RR.useContext)((0, $3gQgL.LazyContext)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $ih19M.jsxs)((0, $5YQBm.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $ih19M.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $b8dH3.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $bh6RR.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $kNaLx.motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function $0c5a031ea8dd3973$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $bh6RR.useContext)((0, $2JU6p.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

});
parcelRegister("5YQBm", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $38e1c7c15d587098$export$2285bbca2c666415; });

var $bh6RR = parcelRequire("bh6RR");
const $38e1c7c15d587098$export$2285bbca2c666415 = (0, $bh6RR.createContext)({});

});

parcelRegister("2NwUh", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $05aa2ab8e054331c$export$dc0335d73ab0b115; });

var $bh6RR = parcelRequire("bh6RR");

var $ap3St = parcelRequire("ap3St");

var $5YQBm = parcelRequire("5YQBm");

var $3Q5ZO = parcelRequire("3Q5ZO");

var $3gQgL = parcelRequire("3gQgL");

var $8vT8C = parcelRequire("8vT8C");

var $cTas6 = parcelRequire("cTas6");

var $6IbrO = parcelRequire("6IbrO");
function $05aa2ab8e054331c$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $bh6RR.useContext)((0, $5YQBm.MotionContext));
    const lazyContext = (0, $bh6RR.useContext)((0, $3gQgL.LazyContext));
    const presenceContext = (0, $bh6RR.useContext)((0, $ap3St.PresenceContext));
    const reducedMotionConfig = (0, $bh6RR.useContext)((0, $8vT8C.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $bh6RR.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $bh6RR.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $bh6RR.useRef)(Boolean(props[0, $cTas6.optimizedAppearDataAttribute] && !window.HandoffComplete));
    (0, $3Q5ZO.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        (0, $6IbrO.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}

});
parcelRegister("6IbrO", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $3858c82cd1ca695a$export$bb76eed83315504c; });

var $6gjGb = parcelRequire("6gjGb");
const { schedule: $3858c82cd1ca695a$export$bb76eed83315504c, cancel: $3858c82cd1ca695a$export$3252729004b8456e } = (0, $6gjGb.createRenderBatcher)(queueMicrotask, false);

});


parcelRegister("b8dH3", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $29bcaad27b8bb245$export$c684914703d321fd; });

var $bh6RR = parcelRequire("bh6RR");

var $9r4iv = parcelRequire("9r4iv");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $29bcaad27b8bb245$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $bh6RR.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $9r4iv.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});

parcelRegister("lpBTW", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $a6e92297d8c984af$export$c5638d843b37a176; });

var $bh6RR = parcelRequire("bh6RR");

var $5YQBm = parcelRequire("5YQBm");

var $8Y8RN = parcelRequire("8Y8RN");
function $a6e92297d8c984af$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $8Y8RN.getCurrentTreeVariants)(props, (0, $bh6RR.useContext)((0, $5YQBm.MotionContext)));
    return (0, $bh6RR.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a6e92297d8c984af$var$variantLabelsAsDependency(initial),
        $a6e92297d8c984af$var$variantLabelsAsDependency(animate)
    ]);
}
function $a6e92297d8c984af$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("8Y8RN", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $be811e3f75d8f6fc$export$12fc32fc096a04a3; });

var $8YLfI = parcelRequire("8YLfI");

var $j2zSu = parcelRequire("j2zSu");
function $be811e3f75d8f6fc$export$12fc32fc096a04a3(props, context) {
    if ((0, $j2zSu.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $8YLfI.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $8YLfI.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});


parcelRegister("ddIWO", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $b8a0e6b50203ba18$export$da5f7b802957459a; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * Internal, exported only for usage in Framer
 */ const $b8a0e6b50203ba18$export$da5f7b802957459a = (0, $bh6RR.createContext)({});

});

parcelRegister("kNaLx", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $92847778545e8ed0$export$28e2e4cce424ae23; });
const $92847778545e8ed0$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});



parcelRegister("dztZ8", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", function () { return $a6b6deed5b4ac5c0$export$732916c0e88175fb; });

var $ap7Tt = parcelRequire("ap7Tt");

var $9ZZxj = parcelRequire("9ZZxj");

var $b8EiY = parcelRequire("b8EiY");

var $2Re13 = parcelRequire("2Re13");
function $a6b6deed5b4ac5c0$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $ap7Tt.isSVGComponent)(Component) ? (0, $b8EiY.svgMotionConfig) : (0, $2Re13.htmlMotionConfig);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $9ZZxj.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}

});
parcelRegister("9ZZxj", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $890426a95a69aae0$export$5d29104eefd89cc8; });

var $bh6RR = parcelRequire("bh6RR");

var $hRMt3 = parcelRequire("hRMt3");

var $kIEd9 = parcelRequire("kIEd9");

var $ap7Tt = parcelRequire("ap7Tt");

var $4OxSQ = parcelRequire("4OxSQ");

var $6fKk5 = parcelRequire("6fKk5");
function $890426a95a69aae0$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ap7Tt.isSVGComponent)(Component) ? (0, $4OxSQ.useSVGProps) : (0, $hRMt3.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $kIEd9.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $bh6RR.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $bh6RR.useMemo)(()=>(0, $6fKk5.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $bh6RR.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("hRMt3", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $1988bd02b7e1d29b$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $1988bd02b7e1d29b$export$57be0a314572d87d; });

var $bh6RR = parcelRequire("bh6RR");

var $1kYFu = parcelRequire("1kYFu");

var $6fKk5 = parcelRequire("6fKk5");

var $6MT1W = parcelRequire("6MT1W");

var $8meNy = parcelRequire("8meNy");
function $1988bd02b7e1d29b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $6fKk5.isMotionValue)(source[key]) && !(0, $1kYFu.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $1988bd02b7e1d29b$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $bh6RR.useMemo)(()=>{
        const state = (0, $8meNy.createHtmlRenderState)();
        (0, $6MT1W.buildHTMLStyles)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $1988bd02b7e1d29b$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $1988bd02b7e1d29b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $1988bd02b7e1d29b$var$useInitialMotionValues(props, visualState, isStatic));
    return style;
}
function $1988bd02b7e1d29b$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $1988bd02b7e1d29b$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("8meNy", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $44dd7fb05ec6c3e6$export$8940b483cf52eeda; });
const $44dd7fb05ec6c3e6$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("kIEd9", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $2d7757648940a601$export$d697c39a2985a4c; });

var $inItn = parcelRequire("inItn");
let $2d7757648940a601$var$shouldForward = (key)=>!(0, $inItn.isValidMotionProp)(key);
function $2d7757648940a601$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $2d7757648940a601$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $inItn.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $2d7757648940a601$export$59d6962c470509a5($2d7757648940a601$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $2d7757648940a601$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($2d7757648940a601$var$shouldForward(key) || forwardMotionProps === true && (0, $inItn.isValidMotionProp)(key) || !isDom && !(0, $inItn.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("inItn", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $a022688aad5e3d50$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a022688aad5e3d50$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a022688aad5e3d50$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a022688aad5e3d50$var$validMotionProps.has(key);
}

});


parcelRegister("4OxSQ", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $f708387b704893ba$export$84309c4f53cb1bd5; });

var $bh6RR = parcelRequire("bh6RR");

var $hRMt3 = parcelRequire("hRMt3");

var $dKNLi = parcelRequire("dKNLi");

var $l3ZiF = parcelRequire("l3ZiF");

var $5Cb6L = parcelRequire("5Cb6L");
function $f708387b704893ba$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $bh6RR.useMemo)(()=>{
        const state = (0, $l3ZiF.createSvgRenderState)();
        (0, $dKNLi.buildSVGAttrs)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $5Cb6L.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $hRMt3.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});
parcelRegister("l3ZiF", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $a6f7f4461a184c55$export$41be8b43e1c4d4f9; });

var $8meNy = parcelRequire("8meNy");
const $a6f7f4461a184c55$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $8meNy.createHtmlRenderState)(),
        attrs: {}
    });

});



parcelRegister("b8EiY", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $ecbb32c06e7c035d$export$44dabd3fae512e85; });

var $7VA0i = parcelRequire("7VA0i");

var $ctAkp = parcelRequire("ctAkp");

var $bgBWr = parcelRequire("bgBWr");

var $l3ZiF = parcelRequire("l3ZiF");

var $dKNLi = parcelRequire("dKNLi");

var $5Cb6L = parcelRequire("5Cb6L");

var $f6xYV = parcelRequire("f6xYV");
const $ecbb32c06e7c035d$export$44dabd3fae512e85 = {
    useVisualState: (0, $bgBWr.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $ctAkp.scrapeMotionValuesFromProps),
        createRenderState: (0, $l3ZiF.createSvgRenderState),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $f6xYV.frame).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $f6xYV.frame).render(()=>{
                (0, $dKNLi.buildSVGAttrs)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $5Cb6L.isSVGTag)(instance.tagName), props.transformTemplate);
                (0, $7VA0i.renderSVG)(instance, renderState);
            });
        }
    })
};

});
parcelRegister("bgBWr", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $e82a2bc47b563e2e$export$e91e107bc6d03a8e; });

var $bh6RR = parcelRequire("bh6RR");

var $kQQPC = parcelRequire("kQQPC");

var $ap3St = parcelRequire("ap3St");

var $gHRI2 = parcelRequire("gHRI2");

var $4I9GC = parcelRequire("4I9GC");

var $2UTaB = parcelRequire("2UTaB");

var $5YQBm = parcelRequire("5YQBm");

var $j2zSu = parcelRequire("j2zSu");
function $e82a2bc47b563e2e$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $e82a2bc47b563e2e$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $bh6RR.useContext)((0, $5YQBm.MotionContext));
        const presenceContext = (0, $bh6RR.useContext)((0, $ap3St.PresenceContext));
        const make = ()=>$e82a2bc47b563e2e$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $4I9GC.useConstant)(make);
    };
function $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $2UTaB.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $j2zSu.isControllingVariants)(props);
    const isVariantNode$1 = (0, $j2zSu.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $kQQPC.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $gHRI2.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("2UTaB", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $9e7923b7600c25b9$export$fcc2206ecb6d74b; });

var $5t0FJ = parcelRequire("5t0FJ");

var $6fKk5 = parcelRequire("6fKk5");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $9e7923b7600c25b9$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $6fKk5.isMotionValue)(value) ? value.get() : value;
    return (0, $5t0FJ.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});



parcelRegister("2Re13", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $cb524d462e20deb3$export$e13ea21d87ea57c8; });

var $bgBWr = parcelRequire("bgBWr");

var $kHkJ2 = parcelRequire("kHkJ2");

var $8meNy = parcelRequire("8meNy");
const $cb524d462e20deb3$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $bgBWr.makeUseVisualState)({
        scrapeMotionValuesFromProps: $kHkJ2.scrapeMotionValuesFromProps,
        createRenderState: (0, $8meNy.createHtmlRenderState)
    })
};

});



parcelRegister("6ujp5", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_VARIANTS", function () { return $2b5ca79c7e2ced8d$export$55b7325ba41bb523; });
"use client";
// src/transition-utils.ts
var $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f = {
    ease: [
        0.36,
        0.66,
        0.4,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ],
    spring: [
        0.155,
        1.105,
        0.295,
        1.12
    ],
    springOut: [
        0.57,
        -0.15,
        0.62,
        0.07
    ],
    softSpring: [
        0.16,
        1.11,
        0.3,
        1.02
    ]
};
var $2b5ca79c7e2ced8d$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.easeIn
    }
};
var $2b5ca79c7e2ced8d$export$55b7325ba41bb523 = {
    scaleSpring: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0,
                duration: 0.2
            }
        },
        exit: {
            transform: "scale(0.85)",
            opacity: 0,
            transition: {
                type: "easeOut",
                duration: 0.15
            }
        }
    },
    scaleSpringOpacity: {
        initial: {
            opacity: 0,
            transform: "scale(0.8)"
        },
        enter: {
            opacity: 1,
            transform: "scale(1)",
            transition: {
                type: "spring",
                bounce: 0,
                duration: 0.3
            }
        },
        exit: {
            opacity: 0,
            transform: "scale(0.96)",
            transition: {
                type: "easeOut",
                bounce: 0,
                duration: 0.15
            }
        }
    },
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    scaleFadeIn: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                duration: 0.25,
                ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.easeIn
            }
        },
        exit: {
            transform: "scale(0.95)",
            opacity: 0,
            transition: {
                duration: 0.2,
                ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.easeOut
            }
        }
    },
    scaleInOut: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                duration: 0.4,
                ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.ease
            }
        },
        exit: {
            transform: "scale(1.03)",
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.ease
            }
        }
    },
    fade: {
        enter: {
            opacity: 1,
            transition: {
                duration: 0.4,
                ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.ease
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: $2b5ca79c7e2ced8d$export$9ee1d08bb6db426f.ease
            }
        }
    },
    collapse: {
        enter: {
            opacity: 1,
            height: "auto",
            transition: {
                height: {
                    type: "spring",
                    bounce: 0,
                    duration: 0.3
                },
                opacity: {
                    easings: "ease",
                    duration: 0.4
                }
            }
        },
        exit: {
            opacity: 0,
            height: 0,
            transition: {
                easings: "ease",
                duration: 0.3
            }
        }
    }
};

});

parcelRegister("52VKi", function(module, exports) {

$parcel$export(module.exports, "SelectionManager", function () { return $3ac9eebf3e3b4cb6$export$6c8a5aaad13c9852; });

var $1Us6g = parcelRequire("1Us6g");

var $98tKj = parcelRequire("98tKj");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $3ac9eebf3e3b4cb6$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $98tKj.compareNodeOrder)(this.collection, item, first) < 0) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $98tKj.compareNodeOrder)(this.collection, item, last) > 0) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new (0, $1Us6g.Selection)([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new (0, $1Us6g.Selection)(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $98tKj.compareNodeOrder)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new (0, $1Us6g.Selection)(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new (0, $1Us6g.Selection)([
            key
        ], key, key) : new (0, $1Us6g.Selection)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new (0, $1Us6g.Selection)();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys((0, $98tKj.getFirstItem)((0, $98tKj.getChildNodes)(item, this.collection)).key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $1Us6g.Selection)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        var _item_props;
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled));
    }
    isLink(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
    getItemProps(key) {
        var _this_collection_getItem;
        return (_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.props;
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
    }
}

});
parcelRegister("1Us6g", function(module, exports) {

$parcel$export(module.exports, "Selection", function () { return $1640d17b89f251fb$export$52baac22726c72bf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $1640d17b89f251fb$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $1640d17b89f251fb$export$52baac22726c72bf) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}

});

parcelRegister("98tKj", function(module, exports) {

$parcel$export(module.exports, "getChildNodes", function () { return $6a6bef596714be76$export$1005530eda016c13; });
$parcel$export(module.exports, "getFirstItem", function () { return $6a6bef596714be76$export$fbdeaa6a76694f71; });
$parcel$export(module.exports, "compareNodeOrder", function () { return $6a6bef596714be76$export$8c434b3a7a4dad6; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a6bef596714be76$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $6a6bef596714be76$export$fbdeaa6a76694f71(iterable) {
    return $6a6bef596714be76$export$5f3398f8733f90e2(iterable, 0);
}
function $6a6bef596714be76$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $6a6bef596714be76$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $6a6bef596714be76$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$6a6bef596714be76$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$6a6bef596714be76$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $6a6bef596714be76$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}

});


parcelRegister("mPpgr", function(module, exports) {

$parcel$export(module.exports, "useMultipleSelectionState", function () { return $0449ee724e560a35$export$253fe78d46329472; });

var $1Us6g = parcelRequire("1Us6g");

var $6YdNt = parcelRequire("6YdNt");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0449ee724e560a35$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $0449ee724e560a35$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = "none", disallowEmptySelection: disallowEmptySelection, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = "toggle", disabledBehavior: disabledBehavior = "all" } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $bh6RR.useRef)(false);
    let [, setFocused] = (0, $bh6RR.useState)(false);
    let focusedKeyRef = (0, $bh6RR.useRef)(null);
    let childFocusStrategyRef = (0, $bh6RR.useRef)(null);
    let [, setFocusedKey] = (0, $bh6RR.useState)(null);
    let selectedKeysProp = (0, $bh6RR.useMemo)(()=>$0449ee724e560a35$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $bh6RR.useMemo)(()=>$0449ee724e560a35$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new (0, $1Us6g.Selection)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $6YdNt.useControlledState)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $bh6RR.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $bh6RR.useRef)(selectionBehaviorProp);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$0449ee724e560a35$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $0449ee724e560a35$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new (0, $1Us6g.Selection)(selection);
}

});
parcelRegister("6YdNt", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $51330c70eabe5eaa$export$40bfa8c7b0832715; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $51330c70eabe5eaa$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $bh6RR.useState)(value || defaultValue);
    let isControlledRef = (0, $bh6RR.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $bh6RR.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $bh6RR.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}

});


parcelRegister("1OXFU", function(module, exports) {

$parcel$export(module.exports, "useCollection", function () { return $1538c02b00aa0807$export$6cd28814d92fa9c9; });

var $iyOYP = parcelRequire("iyOYP");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1538c02b00aa0807$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $bh6RR.useMemo)(()=>new (0, $iyOYP.CollectionBuilder)(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $bh6RR.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}

});
parcelRegister("iyOYP", function(module, exports) {

$parcel$export(module.exports, "CollectionBuilder", function () { return $d832f28d14539be1$export$bf788dd355e3a401; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $d832f28d14539be1$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $d832f28d14539be1$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $d832f28d14539be1$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$d832f28d14539be1$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$d832f28d14539be1$var$$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$d832f28d14539be1$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $d832f28d14539be1$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $d832f28d14539be1$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $d832f28d14539be1$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $d832f28d14539be1$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}

});


parcelRegister("eiwoe", function(module, exports) {

$parcel$export(module.exports, "isScrollable", function () { return $a68bdf147c755f07$export$2bb74740c4e19def; });
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a68bdf147c755f07$export$2bb74740c4e19def(node, checkForOverflow) {
    let style = window.getComputedStyle(node);
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}

});

parcelRegister("h4wtR", function(module, exports) {

$parcel$export(module.exports, "scrollIntoView", function () { return $c6dc015e40bdd47b$export$53a0910f038337bd; });
$parcel$export(module.exports, "scrollIntoViewport", function () { return $c6dc015e40bdd47b$export$c826860796309d1b; });

var $ennM8 = parcelRequire("ennM8");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c6dc015e40bdd47b$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $c6dc015e40bdd47b$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $c6dc015e40bdd47b$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    let { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth } = getComputedStyle(scrollView);
    let borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $c6dc015e40bdd47b$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $c6dc015e40bdd47b$export$c826860796309d1b(targetElement, opts) {
    if (document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            let scrollParents = (0, $ennM8.getScrollParents)(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            for (let scrollParent of scrollParents)$c6dc015e40bdd47b$export$53a0910f038337bd(scrollParent, targetElement);
        }
    }
}

});
parcelRegister("ennM8", function(module, exports) {

$parcel$export(module.exports, "getScrollParents", function () { return $a775a7f6760d39e3$export$94ed1c92c7beeb22; });

var $eiwoe = parcelRequire("eiwoe");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a775a7f6760d39e3$export$94ed1c92c7beeb22(node, checkForOverflow) {
    const scrollParents = [];
    while(node && node !== document.documentElement){
        if ((0, $eiwoe.isScrollable)(node, checkForOverflow)) scrollParents.push(node);
        node = node.parentElement;
    }
    return scrollParents;
}

});


parcelRegister("i6bwP", function(module, exports) {

$parcel$export(module.exports, "useCollator", function () { return $d2d1bad760a17fb9$export$a16aca283550c30d; });

var $dG3Oc = parcelRequire("dG3Oc");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $d2d1bad760a17fb9$var$$325a3faab7a68acd$var$cache = new Map();
function $d2d1bad760a17fb9$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $dG3Oc.useLocale)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($d2d1bad760a17fb9$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $d2d1bad760a17fb9$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $d2d1bad760a17fb9$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}

});
parcelRegister("dG3Oc", function(module, exports) {

$parcel$export(module.exports, "useLocale", function () { return $9f5226ed9e961fa8$export$43bb16f9c6d9e3f7; });

var $cmCWV = parcelRequire("cmCWV");

var $h68NN = parcelRequire("h68NN");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9f5226ed9e961fa8$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $9f5226ed9e961fa8$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = (0, $h68NN.useDefaultLocale)();
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $cmCWV.isRTL)(locale) ? "rtl" : "ltr"
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($9f5226ed9e961fa8$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $9f5226ed9e961fa8$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $h68NN.useDefaultLocale)();
    let context = (0, $bh6RR.useContext)($9f5226ed9e961fa8$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}

});
parcelRegister("cmCWV", function(module, exports) {

$parcel$export(module.exports, "isRTL", function () { return $9005c0ab93c365fb$export$702d680b21cbd764; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $9005c0ab93c365fb$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $9005c0ab93c365fb$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $9005c0ab93c365fb$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $9005c0ab93c365fb$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $9005c0ab93c365fb$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

});

parcelRegister("h68NN", function(module, exports) {

$parcel$export(module.exports, "useDefaultLocale", function () { return $c729d31e22fa2a90$export$188ec29ebc2bdc3a; });

var $cmCWV = parcelRequire("cmCWV");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $c729d31e22fa2a90$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: (0, $cmCWV.isRTL)(locale) ? "rtl" : "ltr"
    };
}
let $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$currentLocale = $c729d31e22fa2a90$export$f09106e7c6677ec5();
let $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$currentLocale = $c729d31e22fa2a90$export$f09106e7c6677ec5();
    for (let listener of $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$listeners)listener($c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $c729d31e22fa2a90$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $2GhkT.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $bh6RR.useState)($c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $bh6RR.useEffect)(()=>{
        if ($c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $c729d31e22fa2a90$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}

});



parcelRegister("1Bn3l", function(module, exports) {

$parcel$export(module.exports, "divider_default", function () { return $51b57fa21e487f49$export$2233c5fdcde64809; });

var $dbhGx = parcelRequire("dbhGx");

var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");
var $51b57fa21e487f49$var$Divider = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, getDividerProps: getDividerProps } = (0, $dbhGx.useDivider)({
        ...props
    });
    return /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
        ref: ref,
        ...getDividerProps()
    });
});
$51b57fa21e487f49$var$Divider.displayName = "NextUI.Divider";
var $51b57fa21e487f49$export$2233c5fdcde64809 = $51b57fa21e487f49$var$Divider;

});
parcelRegister("dbhGx", function(module, exports) {

$parcel$export(module.exports, "useDivider", function () { return $8cb07d4965b56b4c$export$9352472c0af59bd6; });

var $2o1Aj = parcelRequire("2o1Aj");

var $6UvjS = parcelRequire("6UvjS");

var $bh6RR = parcelRequire("bh6RR");
function $8cb07d4965b56b4c$export$9352472c0af59bd6(props) {
    const { as: as, className: className, orientation: orientation, ...otherProps } = props;
    let Component = as || "hr";
    if (Component === "hr" && orientation === "vertical") Component = "div";
    const { separatorProps: separatorProps } = (0, $2o1Aj.useSeparator)({
        elementType: typeof Component === "string" ? Component : "hr",
        orientation: orientation
    });
    const styles = (0, $bh6RR.useMemo)(()=>(0, $6UvjS.divider)({
            orientation: orientation,
            className: className
        }), [
        orientation,
        className
    ]);
    const getDividerProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            className: styles,
            role: "separator",
            "data-orientation": orientation,
            ...separatorProps,
            ...otherProps,
            ...props2
        }), [
        styles,
        orientation,
        separatorProps,
        otherProps
    ]);
    return {
        Component: Component,
        getDividerProps: getDividerProps
    };
}

});
parcelRegister("2o1Aj", function(module, exports) {

$parcel$export(module.exports, "useSeparator", function () { return $510f110920af3905$export$52210f68a14655d0; });
// src/use-separator.ts

var $bIkcs = parcelRequire("bIkcs");
function $510f110920af3905$export$52210f68a14655d0(props) {
    let domProps = (0, $bIkcs.filterDOMProps)(props, {
        enabled: typeof props.elementType === "string"
    });
    let ariaOrientation;
    if (props.orientation === "vertical") ariaOrientation = "vertical";
    if (props.elementType !== "hr") return {
        separatorProps: {
            ...domProps,
            role: "separator",
            "aria-orientation": ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}

});

parcelRegister("6UvjS", function(module, exports) {

$parcel$export(module.exports, "divider", function () { return $9fb769e2713097b6$export$e8c9778bf415dd08; });

var $6ujkL = parcelRequire("6ujkL");
// src/components/divider.ts
var $9fb769e2713097b6$export$e8c9778bf415dd08 = (0, $6ujkL.tv)({
    base: "shrink-0 bg-divider border-none",
    variants: {
        orientation: {
            horizontal: "w-full h-divider",
            vertical: "h-full w-divider"
        }
    },
    defaultVariants: {
        orientation: "horizontal"
    }
});

});



parcelRegister("cTO50", function(module, exports) {

$parcel$export(module.exports, "Item", function () { return $964177e83e61d348$export$6d08773d2e66f8f2; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $964177e83e61d348$var$$c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$964177e83e61d348$var$$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems, title: title, children: children } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered: rendered,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: $964177e83e61d348$var$$c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: "item",
                value: child
            };
            else if (title) {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $964177e83e61d348$var$$c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $964177e83e61d348$export$6d08773d2e66f8f2 = $964177e83e61d348$var$$c1d7fb2ec91bae71$var$Item;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $964177e83e61d348$var$$9fc4852771d079eb$var$Section(props) {
    return null;
}
$964177e83e61d348$var$$9fc4852771d079eb$var$Section.getCollectionNode = function* getCollectionNode(props) {
    let { children: children, title: title, items: items } = props;
    yield {
        type: "section",
        props: props,
        hasChildNodes: true,
        rendered: title,
        "aria-label": props["aria-label"],
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let $964177e83e61d348$export$6e2c8f0811a474ce = $964177e83e61d348$var$$9fc4852771d079eb$var$Section;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $964177e83e61d348$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $964177e83e61d348$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $964177e83e61d348$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$964177e83e61d348$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$964177e83e61d348$var$$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$964177e83e61d348$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $964177e83e61d348$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $964177e83e61d348$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $964177e83e61d348$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $964177e83e61d348$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
function $964177e83e61d348$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $bh6RR.useMemo)(()=>new $964177e83e61d348$export$bf788dd355e3a401(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $bh6RR.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $964177e83e61d348$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $964177e83e61d348$export$fbdeaa6a76694f71(iterable) {
    return $964177e83e61d348$export$5f3398f8733f90e2(iterable, 0);
}
function $964177e83e61d348$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $964177e83e61d348$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $964177e83e61d348$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$964177e83e61d348$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$964177e83e61d348$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $964177e83e61d348$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}
const $964177e83e61d348$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $964177e83e61d348$export$77d5aafae4e095b2(collection) {
    let count = $964177e83e61d348$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === "section") countItems($964177e83e61d348$export$1005530eda016c13(item, collection));
        else count++;
    };
    countItems(collection);
    $964177e83e61d348$var$$453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}

});

parcelRegister("jLJKz", function(module, exports) {

$parcel$export(module.exports, "Calculator", function () { return $5127eb6a5db9e71c$export$770682f56f7e9e8f; });
// NOTE: IF YOU CHANGE THE CONTENT HERE YOU NEED TO CHANGE THE CONTENT ON THE WRAPPED CALCULATOR HERE AND ON WEBSITE TOO

var $ih19M = parcelRequire("ih19M");

var $1v1Xn = parcelRequire("1v1Xn");
var $1Bn3l = parcelRequire("1Bn3l");
var $2QfYo = parcelRequire("2QfYo");
var $fPXqB = parcelRequire("fPXqB");
var $6Owvw = parcelRequire("6Owvw");
var $5HibV = parcelRequire("5HibV");
var $aBgOx = parcelRequire("aBgOx");
var $2jaxN = parcelRequire("2jaxN");
var $ccrSm = parcelRequire("ccrSm");
var $33otw = parcelRequire("33otw");

var $2gNm1 = parcelRequire("2gNm1");
var $iXlRp = parcelRequire("iXlRp");
var $59s2y = parcelRequire("59s2y");
var $31liG = parcelRequire("31liG");
var $3xiYP = parcelRequire("3xiYP");
var $4Kpzs = parcelRequire("4Kpzs");

var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");

var $9yX7V = parcelRequire("9yX7V");

var $Xc4ZS = parcelRequire("Xc4ZS");

var $bEzwx = parcelRequire("bEzwx");

var $166Oq = parcelRequire("166Oq");



const $5127eb6a5db9e71c$var$membershipsRake = 0;
const $5127eb6a5db9e71c$var$currencyTypes = [
    {
        name: "DKK",
        label: "DKK",
        value: "da-DK",
        currency: "DKK",
        symbol: "kr"
    },
    {
        name: "USD",
        label: "USD",
        value: "en-US",
        currency: "USD",
        symbol: "$"
    },
    {
        name: "EUR",
        label: "EUR",
        value: "en-GB",
        currency: "EUR",
        symbol: "\u20AC"
    }
];
if (typeof window !== "undefined" && !(0, $166Oq.default).__loaded) (0, $166Oq.default).init("phc_aDiLXpzc4PfexVbJojOhrEDrsoQ6OFzqA6okexm9qSR", {
    api_host: "https://sleeve.fm/s/m",
    person_profiles: "always",
    autocapture: false
});
const $5127eb6a5db9e71c$export$770682f56f7e9e8f = ()=>{
    const [socialFollowers, setSocialFollowers] = (0, $bh6RR.useState)(100000);
    const [socialPercent, setSocialPercent] = (0, $bh6RR.useState)(10);
    const [emailSubscribers, setEmailSubscribers] = (0, $bh6RR.useState)(20000);
    const [hasEditedTiers, setHasEditedTiers] = (0, $bh6RR.useState)(false);
    const [tiers, setTiers] = (0, $bh6RR.useState)([]);
    const [currencyName, setCurrencyName] = (0, $bh6RR.useState)("USD");
    const [frequency, setFrequency] = (0, $bh6RR.useState)("yearly");
    const [isLoadingFromUrl, setIsLoadingFromUrl] = (0, $bh6RR.useState)(true);
    const [hasLoadedTiersFromUrl, setHasLoadedTiersFromUrl] = (0, $bh6RR.useState)(false);
    const frequencyMultiplier = frequency === "monthly" ? 1 : 12;
    const currencies = {
        USD: {
            symbol: "$",
            locale: "en-US",
            fee: 0.3
        },
        DKK: {
            symbol: "kr",
            locale: "da-DK",
            fee: 1.8
        },
        EUR: {
            symbol: "\u20AC",
            locale: "en-GB",
            fee: 0.3
        }
    };
    const currentCurrency = currencies[currencyName];
    const freeTierTotal = (0, $bh6RR.useMemo)(()=>emailSubscribers + socialPercent / 100 * socialFollowers, [
        emailSubscribers,
        socialFollowers,
        socialPercent
    ]);
    // Fire once when the user first models their numbers (edits a tier or input)
    const hasTrackedModeled = (0, $bh6RR.useRef)(false);
    const trackModeled = (0, $bh6RR.useCallback)(()=>{
        if (!hasTrackedModeled.current) {
            hasTrackedModeled.current = true;
            (0, $166Oq.default).capture("calculator_modeled");
        }
    }, []);
    // Decode state from URL on component mount
    (0, $bh6RR.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const encodedData = Array.from(urlParams.keys())[0];
        if (encodedData) try {
            const decodedData = JSON.parse(atob(decodeURIComponent(encodedData)));
            console.log("Decoded data:", decodedData);
            // Set all state at once to avoid race conditions
            if (decodedData.socialFollowers !== undefined) setSocialFollowers(decodedData.socialFollowers);
            if (decodedData.socialPercent !== undefined) setSocialPercent(decodedData.socialPercent);
            if (decodedData.emailSubscribers !== undefined) setEmailSubscribers(decodedData.emailSubscribers);
            if (decodedData.currencyName) setCurrencyName(decodedData.currencyName);
            if (decodedData.frequency) setFrequency(decodedData.frequency);
            if (decodedData.tiers && Array.isArray(decodedData.tiers)) {
                setTiers(decodedData.tiers);
                setHasLoadedTiersFromUrl(true);
            }
            setIsLoadingFromUrl(false);
        } catch (error) {
            console.error("Failed to decode URL data:", error);
            setIsLoadingFromUrl(false);
        }
        else setIsLoadingFromUrl(false);
    }, []);
    // Initialize default tiers only if not loading from URL and tiers are empty
    (0, $bh6RR.useEffect)(()=>{
        if (!isLoadingFromUrl && tiers.length === 0) {
            console.log("Initializing default tiers");
            setTiers([
                {
                    id: "free",
                    pledgers: Math.round(freeTierTotal),
                    amount: 0,
                    label: "Free"
                },
                {
                    id: "base",
                    pledgers: Math.round(freeTierTotal * 0.1),
                    amount: 5,
                    label: "Base"
                },
                {
                    id: "premium",
                    pledgers: Math.round(freeTierTotal * 0.01),
                    amount: 10,
                    label: "Premium"
                },
                {
                    id: "VIP",
                    pledgers: Math.round(freeTierTotal * 0.0025),
                    amount: 50,
                    label: "VIP"
                }
            ]);
        }
    }, [
        freeTierTotal,
        isLoadingFromUrl,
        tiers.length
    ]);
    // Update tiers when audience changes - robust logic
    (0, $bh6RR.useEffect)(()=>{
        if (isLoadingFromUrl || tiers.length === 0) return;
        console.log("Audience change effect triggered", {
            freeTierTotal: freeTierTotal,
            hasEditedTiers: hasEditedTiers,
            hasLoadedTiersFromUrl: hasLoadedTiersFromUrl,
            tiersLength: tiers.length
        });
        if (!hasEditedTiers && !hasLoadedTiersFromUrl) {
            // Fresh state or after reset - update all tiers based on audience
            console.log("Updating all tiers based on audience change (fresh/reset state)");
            setTiers([
                {
                    id: "free",
                    pledgers: Math.round(freeTierTotal),
                    amount: 0,
                    label: "Free"
                },
                {
                    id: "base",
                    pledgers: Math.round(freeTierTotal * 0.1),
                    amount: 5,
                    label: "Base"
                },
                {
                    id: "premium",
                    pledgers: Math.round(freeTierTotal * 0.01),
                    amount: 10,
                    label: "Premium"
                },
                {
                    id: "VIP",
                    pledgers: Math.round(freeTierTotal * 0.0025),
                    amount: 50,
                    label: "VIP"
                }
            ]);
        } else {
            // We have custom tiers (from URL or manual edits) - only update free tier
            console.log("Updating only free tier (preserving custom values)");
            setTiers((currentTiers)=>currentTiers.map((tier)=>tier.id === "free" ? {
                        ...tier,
                        pledgers: Math.round(freeTierTotal)
                    } : tier));
        }
    }, [
        freeTierTotal,
        isLoadingFromUrl,
        hasEditedTiers,
        hasLoadedTiersFromUrl
    ]);
    // Encode state into URL whenever state changes (but not during initial load)
    (0, $bh6RR.useEffect)(()=>{
        if (isLoadingFromUrl || tiers.length === 0) return;
        const data = btoa(JSON.stringify({
            socialFollowers: socialFollowers,
            socialPercent: socialPercent,
            emailSubscribers: emailSubscribers,
            tiers: tiers,
            currencyName: currencyName,
            frequency: frequency
        }));
        const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + encodeURIComponent(data);
        window.history.replaceState({
            path: newurl
        }, "", newurl);
        console.log("Encoded state to URL");
    }, [
        socialFollowers,
        socialPercent,
        emailSubscribers,
        tiers,
        currencyName,
        frequency,
        isLoadingFromUrl
    ]);
    const updateTierPledgers = (0, $bh6RR.useCallback)((id, pledgers)=>{
        trackModeled();
        setHasEditedTiers(true);
        setTiers((tiers)=>tiers.map((t)=>t.id === id ? {
                    ...t,
                    pledgers: pledgers
                } : t));
    }, [
        trackModeled
    ]);
    const updateTierAmount = (0, $bh6RR.useCallback)((id, amount)=>{
        trackModeled();
        setHasEditedTiers(true);
        setTiers((tiers)=>tiers.map((t)=>t.id === id ? {
                    ...t,
                    amount: amount
                } : t));
    }, [
        trackModeled
    ]);
    const deleteTier = (id)=>{
        setHasEditedTiers(true);
        setTiers((tiers)=>tiers.filter((t)=>t.id !== id));
    };
    const addTier = ()=>{
        setHasEditedTiers(true);
        setTiers((tiers)=>[
                ...tiers,
                {
                    id: (0, $bEzwx.default)(),
                    pledgers: 10,
                    amount: 7
                }
            ]);
    };
    const calculateStripeFee = (amount)=>amount <= 0 ? 0 : amount * 0.03 + currencies[currencyName].fee;
    const tierIncome = (tier)=>tier.amount > 0 ? (tier.amount - tier.amount * $5127eb6a5db9e71c$var$membershipsRake - calculateStripeFee(tier.amount)) * tier.pledgers : 0;
    const pledgeIncome = tiers.reduce((acc, t)=>acc + tierIncome(t), 0) * frequencyMultiplier;
    const currencyFormatter = new Intl.NumberFormat(currentCurrency.locale, {
        style: "currency",
        currency: currencyName,
        maximumFractionDigits: 0
    });
    const sankeyOptions = (0, $bh6RR.useMemo)(()=>({
            legend: "none",
            animation: {
                duration: 1000,
                easing: "out",
                startup: true
            },
            sankey: {
                node: {
                    label: {
                        fontSize: 14,
                        bold: true
                    }
                }
            },
            tooltip: {
                isHtml: true,
                textStyle: {
                    fontSize: 14,
                    fontName: "Inter, system-ui, sans-serif"
                }
            }
        }), []);
    const sankeyData = (0, $bh6RR.useMemo)(()=>{
        const totals = {
            you: 0,
            processing: 0
        };
        tiers.forEach((tier)=>{
            const amount = Number(tier.amount);
            const pledgers = Number(tier.pledgers);
            if (isNaN(amount) || isNaN(pledgers) || amount <= 0 || pledgers <= 0) return;
            totals.you += tierIncome(tier) * frequencyMultiplier;
            totals.processing += calculateStripeFee(amount) * pledgers * frequencyMultiplier;
        });
        return [
            [
                "From",
                "To",
                "Amount",
                {
                    role: "tooltip",
                    type: "string",
                    p: {
                        html: true
                    }
                }
            ],
            [
                "Members",
                "You",
                Math.round(totals.you),
                `<div style="padding: 8px; font-family: Inter, system-ui, sans-serif;"><strong>${currencyFormatter.format(Math.round(totals.you))}</strong></div>`
            ],
            [
                "Members",
                "Processing Fees",
                Math.round(totals.processing),
                `<div style="padding: 8px; font-family: Inter, system-ui, sans-serif;"><strong>${currencyFormatter.format(Math.round(totals.processing))}</strong></div>`
            ]
        ];
    }, [
        tiers,
        frequencyMultiplier,
        currencyFormatter
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "calculator space-y-6",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "mt-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "prose prose-sm text-balance italic",
                        children: "Try modeling your tiers below and start imagining what a direct connection with your audience could mean for your music and your future."
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex justify-end gap-2 w-full sm:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $33otw.tooltip_default), {
                                        content: "Click to copy a link to this model",
                                        placement: "left",
                                        radius: "none",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1v1Xn.button_default), {
                                            isIconOnly: true,
                                            variant: "flat",
                                            radius: "none",
                                            size: "sm",
                                            className: "min-h-[44px] min-w-[44px]",
                                            onClick: ()=>{
                                                (0, $166Oq.default).capture("CalculatorShare");
                                                navigator.clipboard.writeText(window.location.href);
                                                (0, (/*@__PURE__*/$parcel$interopDefault($Xc4ZS))).success("Copied to clipboard");
                                            },
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2gNm1.Clipboard), {
                                                size: 18
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $Xc4ZS.Toaster), {
                                        toastOptions: {
                                            duration: 3000
                                        },
                                        containerClassName: "font-inter"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aBgOx.select_default), {
                                size: "sm",
                                radius: "none",
                                variant: "bordered",
                                classNames: {
                                    base: "w-24 base",
                                    trigger: "shadow-none min-h-[44px]",
                                    mainWrapper: "mainwrapper",
                                    innerWrapper: "innerwrapper",
                                    label: "label"
                                },
                                id: "currency",
                                selectedKeys: [
                                    currencyName
                                ],
                                onSelectionChange: (e)=>setCurrencyName(Array.from(e)[0]),
                                children: $5127eb6a5db9e71c$var$currencyTypes.map((d)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $2jaxN.listbox_item_base_default), {
                                        id: "currency",
                                        children: d.name
                                    }, d.currency))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1Bn3l.divider_default), {}),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "sticky top-4 z-10 bg-white border border-gray-200 rounded-lg p-3 sm:p-4 shadow-sm grid gap-4",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                className: "prose-md sm:prose-lg font-semibold",
                                children: "Estimated Income"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex flex-row items-center justify-between gap-2 sm:gap-0",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: "text-xl sm:text-2xl font-bold",
                                        children: currencyFormatter.format(pledgeIncome)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ccrSm.switch_default), {
                                        classNames: {
                                            label: "min-w-16"
                                        },
                                        isSelected: frequency === "yearly",
                                        onValueChange: (val)=>setFrequency(val ? "yearly" : "monthly"),
                                        children: frequency === "monthly" ? "Monthly" : "Yearly"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1Bn3l.divider_default), {}),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $fPXqB.popover_default), {
                                placement: "bottom",
                                showArrow: true,
                                triggerScaleOnOpen: false,
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5HibV.popover_trigger_default), {
                                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("h3", {
                                            className: "prose-md font-semibold flex items-center hover:cursor-pointer gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    children: "Your Audience"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $31liG.Question), {
                                                    size: 18,
                                                    weight: "fill"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6Owvw.popover_content_default), {
                                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: "px-1 py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                    className: "text-sm font-bold",
                                                    children: "Add your email list size and your total social followers."
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                    className: "text-sm text-gray-500",
                                                    children: "We'll estimate how many might join you on Sleeve. We start with your email list plus 10% of social followers as your free tier, but your fans might surprise you! From there, we estimate 10% might become paying members and 1% premium supporters."
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                    className: "text-sm text-gray-500",
                                                    children: "We'll use this to model your potential subscriber base below."
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $2QfYo.input_default), {
                                        variant: "faded",
                                        type: "number",
                                        placeholder: "0.00",
                                        labelPlacement: "outside",
                                        radius: "none",
                                        endContent: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                            className: "pointer-events-none flex items-center",
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3xiYP.User), {
                                                size: 14
                                            })
                                        }),
                                        classNames: {
                                            mainWrapper: "mainwrapper",
                                            inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                            innerWrapper: "innerwrapper",
                                            input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                        },
                                        min: 0,
                                        value: String(emailSubscribers),
                                        onChange: (e)=>{
                                            trackModeled();
                                            setEmailSubscribers(Number(e.target.value));
                                        },
                                        label: "Email List Size"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "grid grid-cols-[1fr_120px] sm:contents gap-3 sm:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2QfYo.input_default), {
                                                variant: "faded",
                                                type: "number",
                                                placeholder: "0.00",
                                                labelPlacement: "outside",
                                                radius: "none",
                                                endContent: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: "pointer-events-none flex items-center",
                                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3xiYP.User), {
                                                        size: 14
                                                    })
                                                }),
                                                classNames: {
                                                    mainWrapper: "mainwrapper",
                                                    inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                                    innerWrapper: "innerwrapper",
                                                    input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                                },
                                                min: 0,
                                                value: String(socialFollowers),
                                                label: "Total Social Followers",
                                                onChange: (e)=>{
                                                    trackModeled();
                                                    setSocialFollowers(Number(e.target.value));
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2QfYo.input_default), {
                                                variant: "faded",
                                                type: "number",
                                                placeholder: "0",
                                                labelPlacement: "outside",
                                                radius: "none",
                                                label: "% on Sleeve",
                                                endContent: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: "pointer-events-none flex items-center",
                                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iXlRp.Percent), {
                                                        size: 14
                                                    })
                                                }),
                                                classNames: {
                                                    mainWrapper: "mainwrapper",
                                                    inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                                    innerWrapper: "innerwrapper",
                                                    input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base text-center sm:text-left"
                                                },
                                                min: 0,
                                                max: 100,
                                                value: String(socialPercent),
                                                onChange: (e)=>{
                                                    trackModeled();
                                                    setSocialPercent(Number(e.target.value));
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "px-1 sm:px-2",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9yX7V.default), {
                    chartType: "Sankey",
                    width: "100%",
                    height: "250px",
                    data: sankeyData,
                    options: sankeyOptions
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1Bn3l.divider_default), {}),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "px-1 sm:px-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                        className: "text-base font-semibold leading-7 text-gray-900",
                        children: "Membership Tiers"
                    }),
                    tiers.map((t, index)=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "my-2",
                            children: [
                                index === 0 && /*#__PURE__*/ (0, $ih19M.jsxs)("h3", {
                                    className: "text-sm font-semibold text-gray-900",
                                    children: [
                                        "Free Tier/Followers (",
                                        emailSubscribers.toLocaleString(),
                                        " from email list + ",
                                        socialPercent,
                                        "% of",
                                        " ",
                                        socialFollowers.toLocaleString(),
                                        " social)"
                                    ]
                                }),
                                index === 1 && /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                    className: "mt-6 text-sm font-semibold text-gray-900",
                                    children: "Paid Tiers"
                                }),
                                index === 1 && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "mt-2 hidden sm:flex items-center gap-4 text-sm font-medium text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "w-1/2",
                                            children: "Members"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "w-1/2",
                                            children: "Tier Price"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "min-w-8"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "mb-4 flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1Bn3l.divider_default), {
                                            className: "my-2"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: "flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 order-2 sm:order-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                            className: "block text-xs font-medium text-gray-700 mb-1 sm:hidden",
                                                            children: "Members"
                                                        }),
                                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $2QfYo.input_default), {
                                                            variant: "faded",
                                                            type: "number",
                                                            placeholder: "0.00",
                                                            labelPlacement: "outside",
                                                            radius: "none",
                                                            endContent: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                                className: "pointer-events-none flex items-center",
                                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3xiYP.User), {
                                                                    size: 14
                                                                })
                                                            }),
                                                            classNames: {
                                                                mainWrapper: "mainwrapper",
                                                                inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                                                innerWrapper: "innerwrapper",
                                                                input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                                            },
                                                            min: 0,
                                                            value: String(t.pledgers),
                                                            onChange: (e)=>updateTierPledgers(t.id, e.currentTarget.valueAsNumber)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                            className: "block text-xs font-medium text-gray-700 mb-1 sm:hidden",
                                                            children: "Tier Price"
                                                        }),
                                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $2QfYo.input_default), {
                                                            variant: "faded",
                                                            type: "number",
                                                            placeholder: "0.00",
                                                            labelPlacement: "outside",
                                                            radius: "none",
                                                            startContent: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                                className: "pointer-events-none flex items-center",
                                                                children: currentCurrency.symbol
                                                            }),
                                                            classNames: {
                                                                mainWrapper: "mainwrapper",
                                                                inputWrapper: "shadow-none !pe-0 inputwrapper min-h-[44px]",
                                                                innerWrapper: "innerwrapper",
                                                                input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                                            },
                                                            min: 0,
                                                            value: String(t.amount),
                                                            onChange: (e)=>updateTierAmount(t.id, e.currentTarget.valueAsNumber),
                                                            isDisabled: t.id === "free"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))({
                                                        "justify-center sm:justify-start": true,
                                                        "sm:invisible hidden": t.id === "free"
                                                    }),
                                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1v1Xn.button_default), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))({
                                                            "flex items-center justify-center sm:!px-0 [&>svg]:!max-w-[32px] [&>svg]:! min-w-[32px]": true,
                                                            invisible: t.id === "free"
                                                        }),
                                                        size: "sm",
                                                        variant: "flat",
                                                        onClick: ()=>deleteTier(t.id),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                                className: "sm:hidden",
                                                                children: "Delete tier"
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $4Kpzs.X), {
                                                                size: 16
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                                            className: "sm:pl-2 text-base sm:text-sm text-gray-500 mb-1  mt-2 order-1 sm:order-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                    className: "font-semibold",
                                                    children: [
                                                        t.label,
                                                        " Tier:"
                                                    ]
                                                }),
                                                " ",
                                                t.id !== "free" && tiers[0]?.pledgers > 0 ? (()=>{
                                                    const percentage = t.pledgers / tiers[0].pledgers * 100;
                                                    if (percentage < 1 && percentage > 0) return `${percentage.toFixed(1)}%`;
                                                    return `${Math.round(percentage)}%`;
                                                })() : "",
                                                " ",
                                                t.id !== "free" && " of followers \u2022",
                                                " ",
                                                currencyFormatter.format(tierIncome(t) * frequencyMultiplier),
                                                " ",
                                                frequency
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, t.id)),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1Bn3l.divider_default), {}),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                onClick: ()=>addTier(),
                                type: "button",
                                className: "inline-flex w-full items-center justify-center gap-x-1.5 bg-gray-50 px-2 py-1 text-xs font-semibold text-gray-600 shadow-sm hover:bg-gray-100 min-h-[44px]",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $59s2y.PlusCircle), {
                                        size: 16
                                    }),
                                    "Add a Tier"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                onClick: ()=>{
                                    setHasEditedTiers(false);
                                    setHasLoadedTiersFromUrl(false);
                                    // Clear tiers to trigger re-initialization
                                    setTiers([]);
                                },
                                type: "button",
                                className: "inline-flex w-full items-center justify-center gap-x-1.5 px-2 py-1 text-xs font-semibold text-gray-600 min-h-[44px]",
                                children: "Reset Tiers to Defaults"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1v1Xn", function(module, exports) {

$parcel$export(module.exports, "button_default", function () { return $80c5bff69d8c3842$export$11c362adf4e83e40; });

var $84Z70 = parcelRequire("84Z70");

var $3NUgt = parcelRequire("3NUgt");

var $4RwgV = parcelRequire("4RwgV");

var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");
"use client";
var $80c5bff69d8c3842$var$Button = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, domRef: domRef, children: children, styles: styles, spinnerSize: spinnerSize, spinner: spinner = /* @__PURE__ */ (0, $ih19M.jsx)((0, $3NUgt.spinner_default), {
        color: "current",
        size: spinnerSize
    }), spinnerPlacement: spinnerPlacement, startContent: startContent, endContent: endContent, isLoading: isLoading, disableRipple: disableRipple, getButtonProps: getButtonProps, getRippleProps: getRippleProps, isIconOnly: isIconOnly } = (0, $84Z70.useButton)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
        ref: domRef,
        className: styles,
        ...getButtonProps(),
        children: [
            startContent,
            isLoading && spinnerPlacement === "start" && spinner,
            isLoading && isIconOnly ? null : children,
            isLoading && spinnerPlacement === "end" && spinner,
            endContent,
            !disableRipple && /* @__PURE__ */ (0, $ih19M.jsx)((0, $4RwgV.ripple_default), {
                ...getRippleProps()
            })
        ]
    });
});
$80c5bff69d8c3842$var$Button.displayName = "NextUI.Button";
var $80c5bff69d8c3842$export$11c362adf4e83e40 = $80c5bff69d8c3842$var$Button;

});
parcelRegister("84Z70", function(module, exports) {

$parcel$export(module.exports, "useButton", function () { return $f36a9d296bea0c2f$export$ea18c227d4417cc3; });

var $fIu59 = parcelRequire("fIu59");

var $gSab4 = parcelRequire("gSab4");

var $6G4gc = parcelRequire("6G4gc");

var $bh6RR = parcelRequire("bh6RR");

var $3HS2q = parcelRequire("3HS2q");

var $i65Wu = parcelRequire("i65Wu");
var $dCyIs = parcelRequire("dCyIs");

var $bIkcs = parcelRequire("bIkcs");
var $gedB5 = parcelRequire("gedB5");

var $6GWzv = parcelRequire("6GWzv");

var $1lwgY = parcelRequire("1lwgY");

var $fvnOt = parcelRequire("fvnOt");

var $1t45L = parcelRequire("1t45L");
"use client";
function $f36a9d296bea0c2f$export$ea18c227d4417cc3(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const groupContext = (0, $fIu59.useButtonGroupContext)();
    const globalContext = (0, $gSab4.useProviderContext)();
    const isInGroup = !!groupContext;
    const { ref: ref, as: as, children: children, startContent: startContentProp, endContent: endContentProp, autoFocus: autoFocus, className: className, spinner: spinner, isLoading: isLoading = false, disableRipple: disableRippleProp = false, fullWidth: fullWidth = (_a = groupContext == null ? void 0 : groupContext.fullWidth) != null ? _a : false, radius: radius = groupContext == null ? void 0 : groupContext.radius, size: size = (_b = groupContext == null ? void 0 : groupContext.size) != null ? _b : "md", color: color = (_c = groupContext == null ? void 0 : groupContext.color) != null ? _c : "default", variant: variant = (_d = groupContext == null ? void 0 : groupContext.variant) != null ? _d : "solid", disableAnimation: disableAnimation = (_f = (_e = groupContext == null ? void 0 : groupContext.disableAnimation) != null ? _e : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _f : false, isDisabled: isDisabledProp = (_g = groupContext == null ? void 0 : groupContext.isDisabled) != null ? _g : false, isIconOnly: isIconOnly = (_h = groupContext == null ? void 0 : groupContext.isIconOnly) != null ? _h : false, spinnerPlacement: spinnerPlacement = "start", onPress: onPress, onClick: onClick, ...otherProps } = props;
    const Component = as || "button";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const disableRipple = (_i = disableRippleProp || (globalContext == null ? void 0 : globalContext.disableRipple)) != null ? _i : disableAnimation;
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $3HS2q.useFocusRing)({
        autoFocus: autoFocus
    });
    const isDisabled = isDisabledProp || isLoading;
    const styles = (0, $bh6RR.useMemo)(()=>(0, $6GWzv.button)({
            size: size,
            color: color,
            variant: variant,
            radius: radius,
            fullWidth: fullWidth,
            isDisabled: isDisabled,
            isInGroup: isInGroup,
            disableAnimation: disableAnimation,
            isIconOnly: isIconOnly,
            className: className
        }), [
        size,
        color,
        variant,
        radius,
        fullWidth,
        isDisabled,
        isInGroup,
        isIconOnly,
        disableAnimation,
        className
    ]);
    const { onClick: onRippleClickHandler, onClear: onClearRipple, ripples: ripples } = (0, $1t45L.useRipple)();
    const handleClick = (0, $bh6RR.useCallback)((e)=>{
        if (disableRipple || isDisabled || disableAnimation) return;
        domRef.current && onRippleClickHandler(e);
    }, [
        disableRipple,
        isDisabled,
        disableAnimation,
        domRef,
        onRippleClickHandler
    ]);
    const { buttonProps: ariaButtonProps, isPressed: isPressed } = (0, $1lwgY.useAriaButton)({
        elementType: as,
        isDisabled: isDisabled,
        onPress: onPress,
        onClick: (0, $i65Wu.chain)(onClick, handleClick),
        ...otherProps
    }, domRef);
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $fvnOt.useHover)({
        isDisabled: isDisabled
    });
    const getButtonProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-pressed": (0, $6G4gc.dataAttr)(isPressed),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            "data-hover": (0, $6G4gc.dataAttr)(isHovered),
            "data-loading": (0, $6G4gc.dataAttr)(isLoading),
            ...(0, $dCyIs.mergeProps)(ariaButtonProps, focusProps, hoverProps, (0, $bIkcs.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $bIkcs.filterDOMProps)(props2))
        }), [
        isLoading,
        isDisabled,
        isFocused,
        isPressed,
        shouldFilterDOMProps,
        isFocusVisible,
        isHovered,
        ariaButtonProps,
        focusProps,
        hoverProps,
        otherProps
    ]);
    const getIconClone = (icon)=>(0, $bh6RR.isValidElement)(icon) ? (0, $bh6RR.cloneElement)(icon, {
            "aria-hidden": true,
            focusable: false,
            tabIndex: -1
        }) : null;
    const startContent = getIconClone(startContentProp);
    const endContent = getIconClone(endContentProp);
    const spinnerSize = (0, $bh6RR.useMemo)(()=>{
        const buttonSpinnerSizeMap = {
            sm: "sm",
            md: "sm",
            lg: "md"
        };
        return buttonSpinnerSizeMap[size];
    }, [
        size
    ]);
    const getRippleProps = (0, $bh6RR.useCallback)(()=>({
            ripples: ripples,
            onClear: onClearRipple
        }), [
        ripples,
        onClearRipple
    ]);
    return {
        Component: Component,
        children: children,
        domRef: domRef,
        spinner: spinner,
        styles: styles,
        startContent: startContent,
        endContent: endContent,
        isLoading: isLoading,
        spinnerPlacement: spinnerPlacement,
        spinnerSize: spinnerSize,
        disableRipple: disableRipple,
        getButtonProps: getButtonProps,
        getRippleProps: getRippleProps,
        isIconOnly: isIconOnly
    };
}

});
parcelRegister("fIu59", function(module, exports) {

$parcel$export(module.exports, "useButtonGroupContext", function () { return $3de6386078b6ba9f$export$85d63e852e3be3b3; });

var $8kHrV = parcelRequire("8kHrV");
"use client";
var [$3de6386078b6ba9f$export$85041a2bb9328e33, $3de6386078b6ba9f$export$85d63e852e3be3b3] = (0, $8kHrV.createContext)({
    name: "ButtonGroupContext",
    strict: false
});

});

parcelRegister("6GWzv", function(module, exports) {

$parcel$export(module.exports, "button", function () { return $f43d071ab618b89f$export$2ba01fb71ed41cb6; });

var $b2I1q = parcelRequire("b2I1q");

var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/button.ts
var $f43d071ab618b89f$export$2ba01fb71ed41cb6 = (0, $6ujkL.tv)({
    base: [
        "z-0",
        "group",
        "relative",
        "inline-flex",
        "items-center",
        "justify-center",
        "box-border",
        "appearance-none",
        "outline-none",
        "select-none",
        "whitespace-nowrap",
        "min-w-max",
        "font-normal",
        "subpixel-antialiased",
        "overflow-hidden",
        "tap-highlight-transparent",
        "data-[pressed=true]:scale-[0.97]",
        ...(0, $g2NHD.dataFocusVisibleClasses)
    ],
    variants: {
        variant: {
            solid: "",
            bordered: "border-medium bg-transparent",
            light: "bg-transparent",
            flat: "",
            faded: "border-medium",
            shadow: "",
            ghost: "border-medium bg-transparent"
        },
        size: {
            sm: "px-3 min-w-16 h-8 text-tiny gap-2 rounded-small",
            md: "px-4 min-w-20 h-10 text-small gap-2 rounded-medium",
            lg: "px-6 min-w-24 h-12 text-medium gap-3 rounded-large"
        },
        color: {
            default: "",
            primary: "",
            secondary: "",
            success: "",
            warning: "",
            danger: ""
        },
        radius: {
            none: "rounded-none",
            sm: "rounded-small",
            md: "rounded-medium",
            lg: "rounded-large",
            full: "rounded-full"
        },
        fullWidth: {
            true: "w-full"
        },
        isDisabled: {
            true: "opacity-disabled pointer-events-none"
        },
        isInGroup: {
            true: "[&:not(:first-child):not(:last-child)]:rounded-none"
        },
        isIconOnly: {
            true: "px-0 !gap-0",
            false: "[&>svg]:max-w-[theme(spacing.8)]"
        },
        disableAnimation: {
            true: "!transition-none",
            false: "transition-transform-colors-opacity motion-reduce:transition-none"
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid",
        color: "default",
        fullWidth: false,
        isDisabled: false,
        isInGroup: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: (0, $b2I1q.colorVariants).solid.default
        },
        {
            variant: "solid",
            color: "primary",
            class: (0, $b2I1q.colorVariants).solid.primary
        },
        {
            variant: "solid",
            color: "secondary",
            class: (0, $b2I1q.colorVariants).solid.secondary
        },
        {
            variant: "solid",
            color: "success",
            class: (0, $b2I1q.colorVariants).solid.success
        },
        {
            variant: "solid",
            color: "warning",
            class: (0, $b2I1q.colorVariants).solid.warning
        },
        {
            variant: "solid",
            color: "danger",
            class: (0, $b2I1q.colorVariants).solid.danger
        },
        {
            variant: "shadow",
            color: "default",
            class: (0, $b2I1q.colorVariants).shadow.default
        },
        {
            variant: "shadow",
            color: "primary",
            class: (0, $b2I1q.colorVariants).shadow.primary
        },
        {
            variant: "shadow",
            color: "secondary",
            class: (0, $b2I1q.colorVariants).shadow.secondary
        },
        {
            variant: "shadow",
            color: "success",
            class: (0, $b2I1q.colorVariants).shadow.success
        },
        {
            variant: "shadow",
            color: "warning",
            class: (0, $b2I1q.colorVariants).shadow.warning
        },
        {
            variant: "shadow",
            color: "danger",
            class: (0, $b2I1q.colorVariants).shadow.danger
        },
        {
            variant: "bordered",
            color: "default",
            class: (0, $b2I1q.colorVariants).bordered.default
        },
        {
            variant: "bordered",
            color: "primary",
            class: (0, $b2I1q.colorVariants).bordered.primary
        },
        {
            variant: "bordered",
            color: "secondary",
            class: (0, $b2I1q.colorVariants).bordered.secondary
        },
        {
            variant: "bordered",
            color: "success",
            class: (0, $b2I1q.colorVariants).bordered.success
        },
        {
            variant: "bordered",
            color: "warning",
            class: (0, $b2I1q.colorVariants).bordered.warning
        },
        {
            variant: "bordered",
            color: "danger",
            class: (0, $b2I1q.colorVariants).bordered.danger
        },
        {
            variant: "flat",
            color: "default",
            class: (0, $b2I1q.colorVariants).flat.default
        },
        {
            variant: "flat",
            color: "primary",
            class: (0, $b2I1q.colorVariants).flat.primary
        },
        {
            variant: "flat",
            color: "secondary",
            class: (0, $b2I1q.colorVariants).flat.secondary
        },
        {
            variant: "flat",
            color: "success",
            class: (0, $b2I1q.colorVariants).flat.success
        },
        {
            variant: "flat",
            color: "warning",
            class: (0, $b2I1q.colorVariants).flat.warning
        },
        {
            variant: "flat",
            color: "danger",
            class: (0, $b2I1q.colorVariants).flat.danger
        },
        {
            variant: "faded",
            color: "default",
            class: (0, $b2I1q.colorVariants).faded.default
        },
        {
            variant: "faded",
            color: "primary",
            class: (0, $b2I1q.colorVariants).faded.primary
        },
        {
            variant: "faded",
            color: "secondary",
            class: (0, $b2I1q.colorVariants).faded.secondary
        },
        {
            variant: "faded",
            color: "success",
            class: (0, $b2I1q.colorVariants).faded.success
        },
        {
            variant: "faded",
            color: "warning",
            class: (0, $b2I1q.colorVariants).faded.warning
        },
        {
            variant: "faded",
            color: "danger",
            class: (0, $b2I1q.colorVariants).faded.danger
        },
        {
            variant: "light",
            color: "default",
            class: [
                (0, $b2I1q.colorVariants).light.default,
                "data-[hover=true]:bg-default/40"
            ]
        },
        {
            variant: "light",
            color: "primary",
            class: [
                (0, $b2I1q.colorVariants).light.primary,
                "data-[hover=true]:bg-primary/20"
            ]
        },
        {
            variant: "light",
            color: "secondary",
            class: [
                (0, $b2I1q.colorVariants).light.secondary,
                "data-[hover=true]:bg-secondary/20"
            ]
        },
        {
            variant: "light",
            color: "success",
            class: [
                (0, $b2I1q.colorVariants).light.success,
                "data-[hover=true]:bg-success/20"
            ]
        },
        {
            variant: "light",
            color: "warning",
            class: [
                (0, $b2I1q.colorVariants).light.warning,
                "data-[hover=true]:bg-warning/20"
            ]
        },
        {
            variant: "light",
            color: "danger",
            class: [
                (0, $b2I1q.colorVariants).light.danger,
                "data-[hover=true]:bg-danger/20"
            ]
        },
        {
            variant: "ghost",
            color: "default",
            class: (0, $b2I1q.colorVariants).ghost.default
        },
        {
            variant: "ghost",
            color: "primary",
            class: (0, $b2I1q.colorVariants).ghost.primary
        },
        {
            variant: "ghost",
            color: "secondary",
            class: (0, $b2I1q.colorVariants).ghost.secondary
        },
        {
            variant: "ghost",
            color: "success",
            class: (0, $b2I1q.colorVariants).ghost.success
        },
        {
            variant: "ghost",
            color: "warning",
            class: (0, $b2I1q.colorVariants).ghost.warning
        },
        {
            variant: "ghost",
            color: "danger",
            class: (0, $b2I1q.colorVariants).ghost.danger
        },
        {
            isInGroup: true,
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            size: "sm",
            class: "rounded-none first:rounded-s-small last:rounded-e-small"
        },
        {
            isInGroup: true,
            size: "md",
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            size: "lg",
            class: "rounded-none first:rounded-s-large last:rounded-e-large"
        },
        {
            isInGroup: true,
            isRounded: true,
            class: "rounded-none first:rounded-s-full last:rounded-e-full"
        },
        {
            isInGroup: true,
            radius: "none",
            class: "rounded-none first:rounded-s-none last:rounded-e-none"
        },
        {
            isInGroup: true,
            radius: "sm",
            class: "rounded-none first:rounded-s-small last:rounded-e-small"
        },
        {
            isInGroup: true,
            radius: "md",
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            radius: "lg",
            class: "rounded-none first:rounded-s-large last:rounded-e-large"
        },
        {
            isInGroup: true,
            radius: "full",
            class: "rounded-none first:rounded-s-full last:rounded-e-full"
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "default",
            className: (0, $g2NHD.collapseAdjacentVariantBorders).default
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "primary",
            className: (0, $g2NHD.collapseAdjacentVariantBorders).primary
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "secondary",
            className: (0, $g2NHD.collapseAdjacentVariantBorders).secondary
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "success",
            className: (0, $g2NHD.collapseAdjacentVariantBorders).success
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "warning",
            className: (0, $g2NHD.collapseAdjacentVariantBorders).warning
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "danger",
            className: (0, $g2NHD.collapseAdjacentVariantBorders).danger
        },
        {
            isIconOnly: true,
            size: "sm",
            class: "min-w-8 w-8 h-8"
        },
        {
            isIconOnly: true,
            size: "md",
            class: "min-w-10 w-10 h-10"
        },
        {
            isIconOnly: true,
            size: "lg",
            class: "min-w-12 w-12 h-12"
        },
        {
            variant: [
                "solid",
                "faded",
                "flat",
                "bordered",
                "shadow"
            ],
            class: "data-[hover=true]:opacity-hover"
        }
    ]
});
var $f43d071ab618b89f$export$9c686a975407e95c = (0, $6ujkL.tv)({
    base: "inline-flex items-center justify-center h-auto",
    variants: {
        fullWidth: {
            true: "w-full"
        }
    },
    defaultVariants: {
        fullWidth: false
    }
});

});
parcelRegister("b2I1q", function(module, exports) {

$parcel$export(module.exports, "colorVariants", function () { return $a844efd32fd2d708$export$ac48af53e325e736; });
// src/utils/variants.ts
var $a844efd32fd2d708$var$solid = {
    default: "bg-default text-default-foreground",
    primary: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    success: "bg-success text-success-foreground",
    warning: "bg-warning text-warning-foreground",
    danger: "bg-danger text-danger-foreground",
    foreground: "bg-foreground text-background"
};
var $a844efd32fd2d708$var$shadow = {
    default: "shadow-lg shadow-default/50 bg-default text-default-foreground",
    primary: "shadow-lg shadow-primary/40 bg-primary text-primary-foreground",
    secondary: "shadow-lg shadow-secondary/40 bg-secondary text-secondary-foreground",
    success: "shadow-lg shadow-success/40 bg-success text-success-foreground",
    warning: "shadow-lg shadow-warning/40 bg-warning text-warning-foreground",
    danger: "shadow-lg shadow-danger/40 bg-danger text-danger-foreground",
    foreground: "shadow-lg shadow-foreground/40 bg-foreground text-background"
};
var $a844efd32fd2d708$var$bordered = {
    default: "bg-transparent border-default text-foreground",
    primary: "bg-transparent border-primary text-primary",
    secondary: "bg-transparent border-secondary text-secondary",
    success: "bg-transparent border-success text-success",
    warning: "bg-transparent border-warning text-warning",
    danger: "bg-transparent border-danger text-danger",
    foreground: "bg-transparent border-foreground text-foreground"
};
var $a844efd32fd2d708$var$flat = {
    default: "bg-default/40 text-default-foreground",
    primary: "bg-primary/20 text-primary",
    secondary: "bg-secondary/20 text-secondary",
    success: "bg-success/20 text-success-600 dark:text-success",
    warning: "bg-warning/20 text-warning-600 dark:text-warning",
    danger: "bg-danger/20 text-danger dark:text-danger-500",
    foreground: "bg-foreground/10 text-foreground"
};
var $a844efd32fd2d708$var$faded = {
    default: "border-default bg-default-100 text-default-foreground",
    primary: "border-default bg-default-100 text-primary",
    secondary: "border-default bg-default-100 text-secondary",
    success: "border-default bg-default-100 text-success",
    warning: "border-default bg-default-100 text-warning",
    danger: "border-default bg-default-100 text-danger",
    foreground: "border-default bg-default-100 text-foreground"
};
var $a844efd32fd2d708$var$light = {
    default: "bg-transparent text-default-foreground",
    primary: "bg-transparent text-primary",
    secondary: "bg-transparent text-secondary",
    success: "bg-transparent text-success",
    warning: "bg-transparent text-warning",
    danger: "bg-transparent text-danger",
    foreground: "bg-transparent text-foreground"
};
var $a844efd32fd2d708$var$ghost = {
    default: "border-default text-default-foreground hover:!bg-default",
    primary: "border-primary text-primary hover:!text-primary-foreground hover:!bg-primary",
    secondary: "border-secondary text-secondary hover:text-secondary-foreground hover:!bg-secondary",
    success: "border-success text-success hover:!text-success-foreground hover:!bg-success",
    warning: "border-warning text-warning hover:!text-warning-foreground hover:!bg-warning",
    danger: "border-danger text-danger hover:!text-danger-foreground hover:!bg-danger",
    foreground: "border-foreground text-foreground hover:!bg-foreground"
};
var $a844efd32fd2d708$export$ac48af53e325e736 = {
    solid: $a844efd32fd2d708$var$solid,
    shadow: $a844efd32fd2d708$var$shadow,
    bordered: $a844efd32fd2d708$var$bordered,
    flat: $a844efd32fd2d708$var$flat,
    faded: $a844efd32fd2d708$var$faded,
    light: $a844efd32fd2d708$var$light,
    ghost: $a844efd32fd2d708$var$ghost
};

});


parcelRegister("1lwgY", function(module, exports) {

$parcel$export(module.exports, "useAriaButton", function () { return $ac0d7c3f55997f2e$export$1aff6edc04132adb; });
// src/index.ts

var $leZvJ = parcelRequire("leZvJ");
var $dCyIs = parcelRequire("dCyIs");

var $3HS2q = parcelRequire("3HS2q");

var $fvnOt = parcelRequire("fvnOt");
function $ac0d7c3f55997f2e$export$1aff6edc04132adb(props, ref) {
    let { elementType: elementType = "button", isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: deprecatedOnClick, href: href, target: target, rel: rel, type: type = "button", allowTextSelectionOnPress: allowTextSelectionOnPress } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? void 0 : 0,
        href: elementType === "a" && isDisabled ? void 0 : href,
        target: elementType === "a" ? target : void 0,
        type: elementType === "input" ? type : void 0,
        disabled: elementType === "input" ? isDisabled : void 0,
        "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
        rel: elementType === "a" ? rel : void 0
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $fvnOt.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        allowTextSelectionOnPress: allowTextSelectionOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $3HS2q.useFocusable)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $dCyIs.mergeProps)(focusableProps, pressProps, (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $dCyIs.mergeProps)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                deprecatedOnClick == null || deprecatedOnClick(e);
            }
        })
    };
}

});

parcelRegister("1t45L", function(module, exports) {

$parcel$export(module.exports, "useRipple", function () { return $df6d5d0b819781e3$export$66d23405c38d2c80; });

var $6N9Z9 = parcelRequire("6N9Z9");

var $bh6RR = parcelRequire("bh6RR");
"use client";
function $df6d5d0b819781e3$export$66d23405c38d2c80(props = {}) {
    const [ripples, setRipples] = (0, $bh6RR.useState)([]);
    const onClick = (0, $bh6RR.useCallback)((event)=>{
        const trigger = event.currentTarget;
        const size = Math.max(trigger.clientWidth, trigger.clientHeight);
        const rect = trigger.getBoundingClientRect();
        setRipples((prevRipples)=>[
                ...prevRipples,
                {
                    key: (0, $6N9Z9.getUniqueID)(prevRipples.length.toString()),
                    size: size,
                    x: event.clientX - rect.left - size / 2,
                    y: event.clientY - rect.top - size / 2
                }
            ]);
    }, []);
    const onClear = (0, $bh6RR.useCallback)((key)=>{
        setRipples((prevState)=>prevState.filter((ripple)=>ripple.key !== key));
    }, []);
    return {
        ripples: ripples,
        onClick: onClick,
        onClear: onClear,
        ...props
    };
}

});


parcelRegister("3NUgt", function(module, exports) {

$parcel$export(module.exports, "spinner_default", function () { return $0e200743ec49781d$export$b67103861f057d1a; });

var $fOuRZ = parcelRequire("fOuRZ");

var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");
var $0e200743ec49781d$var$Spinner = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { slots: slots, classNames: classNames, label: label, getSpinnerProps: getSpinnerProps } = (0, $fOuRZ.useSpinner)({
        ...props
    });
    return /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
        ref: ref,
        ...getSpinnerProps(),
        children: [
            /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
                className: slots.wrapper({
                    class: classNames == null ? void 0 : classNames.wrapper
                }),
                children: [
                    /* @__PURE__ */ (0, $ih19M.jsx)("i", {
                        className: slots.circle1({
                            class: classNames == null ? void 0 : classNames.circle1
                        })
                    }),
                    /* @__PURE__ */ (0, $ih19M.jsx)("i", {
                        className: slots.circle2({
                            class: classNames == null ? void 0 : classNames.circle2
                        })
                    })
                ]
            }),
            label && /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                className: slots.label({
                    class: classNames == null ? void 0 : classNames.label
                }),
                children: label
            })
        ]
    });
});
$0e200743ec49781d$var$Spinner.displayName = "NextUI.Spinner";
var $0e200743ec49781d$export$b67103861f057d1a = $0e200743ec49781d$var$Spinner;

});
parcelRegister("fOuRZ", function(module, exports) {

$parcel$export(module.exports, "useSpinner", function () { return $b72a1795a9d561fb$export$21495182eeff761c; });
// src/use-spinner.ts

var $hN2BG = parcelRequire("hN2BG");

var $9NFMg = parcelRequire("9NFMg");

var $3xP29 = parcelRequire("3xP29");
var $6N9Z9 = parcelRequire("6N9Z9");

var $bh6RR = parcelRequire("bh6RR");
function $b72a1795a9d561fb$export$21495182eeff761c(originalProps) {
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $9NFMg.spinner).variantKeys);
    const { children: children, className: className, classNames: classNames, label: labelProp, ...otherProps } = props;
    const slots = (0, $bh6RR.useMemo)(()=>(0, $9NFMg.spinner)({
            ...variantProps
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps)
    ]);
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    const label = labelProp || children;
    const ariaLabel = (0, $bh6RR.useMemo)(()=>{
        if (label && typeof label === "string") return label;
        return !otherProps["aria-label"] ? "Loading" : "";
    }, [
        children,
        label,
        otherProps["aria-label"]
    ]);
    const getSpinnerProps = (0, $bh6RR.useCallback)(()=>({
            "aria-label": ariaLabel,
            className: slots.base({
                class: baseStyles
            }),
            ...otherProps
        }), [
        ariaLabel,
        slots,
        baseStyles,
        otherProps
    ]);
    return {
        label: label,
        slots: slots,
        classNames: classNames,
        getSpinnerProps: getSpinnerProps
    };
}

});
parcelRegister("9NFMg", function(module, exports) {

$parcel$export(module.exports, "spinner", function () { return $86c89730c8879220$export$641374ffb95bc399; });

var $6ujkL = parcelRequire("6ujkL");
// src/components/spinner.ts
var $86c89730c8879220$export$641374ffb95bc399 = (0, $6ujkL.tv)({
    slots: {
        base: "relative inline-flex flex-col gap-2 items-center justify-center",
        wrapper: "relative flex",
        circle1: [
            "absolute",
            "w-full",
            "h-full",
            "rounded-full",
            "animate-spinner-ease-spin",
            "border-2",
            "border-solid",
            "border-t-transparent",
            "border-l-transparent",
            "border-r-transparent"
        ],
        circle2: [
            "absolute",
            "w-full",
            "h-full",
            "rounded-full",
            "opacity-75",
            "animate-spinner-linear-spin",
            "border-2",
            "border-dotted",
            "border-t-transparent",
            "border-l-transparent",
            "border-r-transparent"
        ],
        label: "text-foreground dark:text-foreground-dark font-regular"
    },
    variants: {
        size: {
            sm: {
                wrapper: "w-5 h-5",
                circle1: "border-2",
                circle2: "border-2",
                label: "text-small"
            },
            md: {
                wrapper: "w-8 h-8",
                circle1: "border-3",
                circle2: "border-3",
                label: "text-medium"
            },
            lg: {
                wrapper: "w-10 h-10",
                circle1: "border-3",
                circle2: "border-3",
                label: "text-large"
            }
        },
        color: {
            current: {
                circle1: "border-b-current",
                circle2: "border-b-current"
            },
            white: {
                circle1: "border-b-white",
                circle2: "border-b-white"
            },
            default: {
                circle1: "border-b-default",
                circle2: "border-b-default"
            },
            primary: {
                circle1: "border-b-primary",
                circle2: "border-b-primary"
            },
            secondary: {
                circle1: "border-b-secondary",
                circle2: "border-b-secondary"
            },
            success: {
                circle1: "border-b-success",
                circle2: "border-b-success"
            },
            warning: {
                circle1: "border-b-warning",
                circle2: "border-b-warning"
            },
            danger: {
                circle1: "border-b-danger",
                circle2: "border-b-danger"
            }
        },
        labelColor: {
            foreground: {
                label: "text-foreground"
            },
            primary: {
                label: "text-primary"
            },
            secondary: {
                label: "text-secondary"
            },
            success: {
                label: "text-success"
            },
            warning: {
                label: "text-warning"
            },
            danger: {
                label: "text-danger"
            }
        }
    },
    defaultVariants: {
        size: "md",
        color: "primary",
        labelColor: "foreground"
    }
});

});



parcelRegister("4RwgV", function(module, exports) {

$parcel$export(module.exports, "ripple_default", function () { return $8053231188d4fb3d$export$db886ec4bd2671e8; });

var $lTq24 = parcelRequire("lTq24");
var $6Vrqz = parcelRequire("6Vrqz");
var $k87FL = parcelRequire("k87FL");
var $dqffP = parcelRequire("dqffP");

var $5MejQ = parcelRequire("5MejQ");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8053231188d4fb3d$var$Ripple = (props)=>{
    const { ripples: ripples = [], motionProps: motionProps, color: color = "currentColor", style: style, onClear: onClear } = props;
    return /* @__PURE__ */ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: ripples.map((ripple)=>{
            const duration = (0, $5MejQ.clamp)(0.01 * ripple.size, 0.2, ripple.size > 100 ? 0.75 : 0.5);
            return /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
                features: (0, $6Vrqz.domAnimation),
                children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $lTq24.AnimatePresence), {
                    mode: "popLayout",
                    children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).span, {
                        animate: {
                            transform: "scale(2)",
                            opacity: 0
                        },
                        className: "nextui-ripple",
                        exit: {
                            opacity: 0
                        },
                        initial: {
                            transform: "scale(0)",
                            opacity: 0.35
                        },
                        style: {
                            position: "absolute",
                            backgroundColor: color,
                            borderRadius: "100%",
                            transformOrigin: "center",
                            pointerEvents: "none",
                            overflow: "hidden",
                            inset: 0,
                            zIndex: 0,
                            top: ripple.y,
                            left: ripple.x,
                            width: `${ripple.size}px`,
                            height: `${ripple.size}px`,
                            ...style
                        },
                        transition: {
                            duration: duration
                        },
                        onAnimationComplete: ()=>{
                            onClear(ripple.key);
                        },
                        ...motionProps
                    })
                })
            }, ripple.key);
        })
    });
};
$8053231188d4fb3d$var$Ripple.displayName = "NextUI.Ripple";
var $8053231188d4fb3d$export$db886ec4bd2671e8 = $8053231188d4fb3d$var$Ripple;

});
parcelRegister("5MejQ", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $0a44fb944d0e0982$export$7d15b64cf5a3a4c4; });
// src/numbers.ts
function $0a44fb944d0e0982$export$d02631cccf789723(start, end) {
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, index)=>index + start);
}
function $0a44fb944d0e0982$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $0a44fb944d0e0982$export$b7cb35a8bec19265(value, max = 100) {
    return Math.min(Math.max(value, 0), max);
}

});



parcelRegister("2QfYo", function(module, exports) {

$parcel$export(module.exports, "input_default", function () { return $8dd1e245fea69ecc$export$921a3451e53aa4ce; });

var $lB1Ws = parcelRequire("lB1Ws");

var $7F1d7 = parcelRequire("7F1d7");

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8dd1e245fea69ecc$var$Input = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, label: label, description: description, isClearable: isClearable, startContent: startContent, endContent: endContent, labelPlacement: labelPlacement, hasHelper: hasHelper, isOutsideLeft: isOutsideLeft, shouldLabelBeOutside: shouldLabelBeOutside, errorMessage: errorMessage, isInvalid: isInvalid, getBaseProps: getBaseProps, getLabelProps: getLabelProps, getInputProps: getInputProps, getInnerWrapperProps: getInnerWrapperProps, getInputWrapperProps: getInputWrapperProps, getMainWrapperProps: getMainWrapperProps, getHelperWrapperProps: getHelperWrapperProps, getDescriptionProps: getDescriptionProps, getErrorMessageProps: getErrorMessageProps, getClearButtonProps: getClearButtonProps } = (0, $lB1Ws.useInput)({
        ...props,
        ref: ref
    });
    const labelContent = label ? /* @__PURE__ */ (0, $ih19M.jsx)("label", {
        ...getLabelProps(),
        children: label
    }) : null;
    const end = (0, $bh6RR.useMemo)(()=>{
        if (isClearable) return /* @__PURE__ */ (0, $ih19M.jsx)("span", {
            ...getClearButtonProps(),
            children: endContent || /* @__PURE__ */ (0, $ih19M.jsx)((0, $7F1d7.CloseFilledIcon), {})
        });
        return endContent;
    }, [
        isClearable,
        getClearButtonProps
    ]);
    const helperWrapper = (0, $bh6RR.useMemo)(()=>{
        if (!hasHelper) return null;
        return /* @__PURE__ */ (0, $ih19M.jsx)("div", {
            ...getHelperWrapperProps(),
            children: isInvalid && errorMessage ? /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                ...getErrorMessageProps(),
                children: errorMessage
            }) : description ? /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                ...getDescriptionProps(),
                children: description
            }) : null
        });
    }, [
        hasHelper,
        isInvalid,
        errorMessage,
        description,
        getHelperWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    const innerWrapper = (0, $bh6RR.useMemo)(()=>{
        return /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
            ...getInnerWrapperProps(),
            children: [
                startContent,
                /* @__PURE__ */ (0, $ih19M.jsx)("input", {
                    ...getInputProps()
                }),
                end
            ]
        });
    }, [
        startContent,
        end,
        getInputProps,
        getInnerWrapperProps
    ]);
    const mainWrapper = (0, $bh6RR.useMemo)(()=>{
        if (shouldLabelBeOutside) return /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
            ...getMainWrapperProps(),
            children: [
                /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
                    ...getInputWrapperProps(),
                    children: [
                        !isOutsideLeft ? labelContent : null,
                        innerWrapper
                    ]
                }),
                helperWrapper
            ]
        });
        return /* @__PURE__ */ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
                    ...getInputWrapperProps(),
                    children: [
                        labelContent,
                        innerWrapper
                    ]
                }),
                helperWrapper
            ]
        });
    }, [
        labelPlacement,
        helperWrapper,
        shouldLabelBeOutside,
        labelContent,
        innerWrapper,
        errorMessage,
        description,
        getMainWrapperProps,
        getInputWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    return /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            isOutsideLeft ? labelContent : null,
            mainWrapper
        ]
    });
});
$8dd1e245fea69ecc$var$Input.displayName = "NextUI.Input";
var $8dd1e245fea69ecc$export$921a3451e53aa4ce = $8dd1e245fea69ecc$var$Input;

});
parcelRegister("lB1Ws", function(module, exports) {

$parcel$export(module.exports, "useInput", function () { return $56475479d50b84ac$export$1e36b9f257eee5fa; });

var $hN2BG = parcelRequire("hN2BG");
var $gSab4 = parcelRequire("gSab4");

var $cOcFk = parcelRequire("cOcFk");

var $3HS2q = parcelRequire("3HS2q");

var $gRmsp = parcelRequire("gRmsp");

var $bIkcs = parcelRequire("bIkcs");
var $gedB5 = parcelRequire("gedB5");

var $fvnOt = parcelRequire("fvnOt");

var $3xP29 = parcelRequire("3xP29");
var $6G4gc = parcelRequire("6G4gc");
var $6N9Z9 = parcelRequire("6N9Z9");
var $fAuxS = parcelRequire("fAuxS");

var $5gL1f = parcelRequire("5gL1f");

var $bh6RR = parcelRequire("bh6RR");

var $i65Wu = parcelRequire("i65Wu");
var $dCyIs = parcelRequire("dCyIs");

var $75Msr = parcelRequire("75Msr");
"use client";
function $56475479d50b84ac$export$1e36b9f257eee5fa(originalProps) {
    var _a, _b, _c, _d;
    const globalContext = (0, $gSab4.useProviderContext)();
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $gRmsp.input).variantKeys);
    const { ref: ref, as: as, type: type, label: label, baseRef: baseRef, wrapperRef: wrapperRef, description: description, className: className, classNames: classNames, autoFocus: autoFocus, startContent: startContent, endContent: endContent, onClear: onClear, onChange: onChange, validationState: validationState, validationBehavior: validationBehavior = (_a = globalContext == null ? void 0 : globalContext.validationBehavior) != null ? _a : "aria", innerWrapperRef: innerWrapperRefProp, onValueChange: onValueChange = ()=>{}, ...otherProps } = props;
    const handleValueChange = (0, $bh6RR.useCallback)((value)=>{
        onValueChange(value != null ? value : "");
    }, [
        onValueChange
    ]);
    const [isFocusWithin, setFocusWithin] = (0, $bh6RR.useState)(false);
    const Component = as || "div";
    const disableAnimation = (_c = (_b = originalProps.disableAnimation) != null ? _b : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _c : false;
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const baseDomRef = (0, $gedB5.useDOMRef)(baseRef);
    const inputWrapperRef = (0, $gedB5.useDOMRef)(wrapperRef);
    const innerWrapperRef = (0, $gedB5.useDOMRef)(innerWrapperRefProp);
    const [inputValue, setInputValue] = (0, $5gL1f.useControlledState)(props.value, (_d = props.defaultValue) != null ? _d : "", handleValueChange);
    const isFilledByDefault = [
        "date",
        "time",
        "month",
        "week",
        "range"
    ].includes(type);
    const isFilled = !(0, $6G4gc.isEmpty)(inputValue) || isFilledByDefault;
    const isFilledWithin = isFilled || isFocusWithin;
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className, isFilled ? "is-filled" : "");
    const isMultiline = originalProps.isMultiline;
    const handleClear = (0, $bh6RR.useCallback)(()=>{
        var _a2;
        setInputValue("");
        onClear == null || onClear();
        (_a2 = domRef.current) == null || _a2.focus();
    }, [
        setInputValue,
        onClear
    ]);
    (0, $cOcFk.useSafeLayoutEffect)(()=>{
        if (!domRef.current) return;
        setInputValue(domRef.current.value);
    }, [
        domRef.current
    ]);
    const { labelProps: labelProps, inputProps: inputProps, isInvalid: isAriaInvalid, validationErrors: validationErrors, validationDetails: validationDetails, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $75Msr.useTextField)({
        ...originalProps,
        validationBehavior: validationBehavior,
        autoCapitalize: originalProps.autoCapitalize,
        value: inputValue,
        "aria-label": (0, $fAuxS.safeAriaLabel)(originalProps["aria-label"], originalProps.label, originalProps.placeholder),
        inputElementType: isMultiline ? "textarea" : "input",
        onChange: setInputValue
    }, domRef);
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $3HS2q.useFocusRing)({
        autoFocus: autoFocus,
        isTextInput: true
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $fvnOt.useHover)({
        isDisabled: !!(originalProps == null ? void 0 : originalProps.isDisabled)
    });
    const { focusProps: clearFocusProps, isFocusVisible: isClearButtonFocusVisible } = (0, $3HS2q.useFocusRing)();
    const { focusWithinProps: focusWithinProps } = (0, $fvnOt.useFocusWithin)({
        onFocusWithinChange: setFocusWithin
    });
    const { pressProps: clearPressProps } = (0, $fvnOt.usePress)({
        isDisabled: !!(originalProps == null ? void 0 : originalProps.isDisabled),
        onPress: handleClear
    });
    const isInvalid = validationState === "invalid" || originalProps.isInvalid || isAriaInvalid;
    const labelPlacement = (0, $bh6RR.useMemo)(()=>{
        var _a2;
        if ((!originalProps.labelPlacement || originalProps.labelPlacement === "inside") && !label) return "outside";
        return (_a2 = originalProps.labelPlacement) != null ? _a2 : "inside";
    }, [
        originalProps.labelPlacement,
        label
    ]);
    const errorMessage = typeof props.errorMessage === "function" ? props.errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : props.errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" "));
    const isClearable = !!onClear || originalProps.isClearable;
    const hasElements = !!label || !!description || !!errorMessage;
    const hasPlaceholder = !!props.placeholder;
    const hasLabel = !!label;
    const hasHelper = !!description || !!errorMessage;
    const shouldLabelBeOutside = labelPlacement === "outside" || labelPlacement === "outside-left";
    const shouldLabelBeInside = labelPlacement === "inside";
    const isPlaceholderShown = domRef.current ? (!domRef.current.value || domRef.current.value === "" || !inputValue || inputValue === "") && hasPlaceholder : false;
    const isOutsideLeft = labelPlacement === "outside-left";
    const hasStartContent = !!startContent;
    const isLabelOutside = shouldLabelBeOutside ? labelPlacement === "outside-left" || hasPlaceholder || labelPlacement === "outside" && hasStartContent : false;
    const isLabelOutsideAsPlaceholder = labelPlacement === "outside" && !hasPlaceholder && !hasStartContent;
    const slots = (0, $bh6RR.useMemo)(()=>(0, $gRmsp.input)({
            ...variantProps,
            isInvalid: isInvalid,
            labelPlacement: labelPlacement,
            isClearable: isClearable,
            disableAnimation: disableAnimation
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps),
        isInvalid,
        labelPlacement,
        isClearable,
        hasStartContent,
        disableAnimation
    ]);
    const getBaseProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ref: baseDomRef,
            className: slots.base({
                class: baseStyles
            }),
            "data-slot": "base",
            "data-filled": (0, $6G4gc.dataAttr)(isFilled || hasPlaceholder || hasStartContent || isPlaceholderShown),
            "data-filled-within": (0, $6G4gc.dataAttr)(isFilledWithin || hasPlaceholder || hasStartContent || isPlaceholderShown),
            "data-focus-within": (0, $6G4gc.dataAttr)(isFocusWithin),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            "data-readonly": (0, $6G4gc.dataAttr)(originalProps.isReadOnly),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-hover": (0, $6G4gc.dataAttr)(isHovered),
            "data-required": (0, $6G4gc.dataAttr)(originalProps.isRequired),
            "data-invalid": (0, $6G4gc.dataAttr)(isInvalid),
            "data-disabled": (0, $6G4gc.dataAttr)(originalProps.isDisabled),
            "data-has-elements": (0, $6G4gc.dataAttr)(hasElements),
            "data-has-helper": (0, $6G4gc.dataAttr)(hasHelper),
            "data-has-label": (0, $6G4gc.dataAttr)(hasLabel),
            "data-has-value": (0, $6G4gc.dataAttr)(!isPlaceholderShown),
            ...focusWithinProps,
            ...props2
        };
    }, [
        slots,
        baseStyles,
        isFilled,
        isFocused,
        isHovered,
        isInvalid,
        hasHelper,
        hasLabel,
        hasElements,
        isPlaceholderShown,
        hasStartContent,
        isFocusWithin,
        isFocusVisible,
        isFilledWithin,
        hasPlaceholder,
        focusWithinProps,
        originalProps.isReadOnly,
        originalProps.isRequired,
        originalProps.isDisabled
    ]);
    const getLabelProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "data-slot": "label",
            className: slots.label({
                class: classNames == null ? void 0 : classNames.label
            }),
            ...labelProps,
            ...props2
        };
    }, [
        slots,
        labelProps,
        classNames == null ? void 0 : classNames.label
    ]);
    const getInputProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "input",
            "data-filled": (0, $6G4gc.dataAttr)(isFilled),
            "data-filled-within": (0, $6G4gc.dataAttr)(isFilledWithin),
            "data-has-start-content": (0, $6G4gc.dataAttr)(hasStartContent),
            "data-has-end-content": (0, $6G4gc.dataAttr)(!!endContent),
            className: slots.input({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.input, isFilled ? "is-filled" : "")
            }),
            ...(0, $dCyIs.mergeProps)(focusProps, inputProps, (0, $bIkcs.filterDOMProps)(otherProps, {
                enabled: true,
                labelable: true,
                omitEventNames: new Set(Object.keys(inputProps))
            }), props2),
            "aria-readonly": (0, $6G4gc.dataAttr)(originalProps.isReadOnly),
            onChange: (0, $i65Wu.chain)(inputProps.onChange, onChange)
        };
    }, [
        slots,
        inputValue,
        focusProps,
        inputProps,
        otherProps,
        isFilled,
        isFilledWithin,
        hasStartContent,
        endContent,
        classNames == null ? void 0 : classNames.input,
        originalProps.isReadOnly,
        originalProps.isRequired,
        onChange
    ]);
    const getInputWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ref: inputWrapperRef,
            "data-slot": "input-wrapper",
            "data-hover": (0, $6G4gc.dataAttr)(isHovered),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            className: slots.inputWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.inputWrapper, isFilled ? "is-filled" : "")
            }),
            ...(0, $dCyIs.mergeProps)(props2, hoverProps),
            onClick: (e)=>{
                if (domRef.current && e.currentTarget === e.target) domRef.current.focus();
            },
            style: {
                cursor: "text",
                ...props2.style
            }
        };
    }, [
        slots,
        isHovered,
        isFocusVisible,
        isFocused,
        inputValue,
        classNames == null ? void 0 : classNames.inputWrapper
    ]);
    const getInnerWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ref: innerWrapperRef,
            "data-slot": "inner-wrapper",
            onClick: (e)=>{
                if (domRef.current && e.currentTarget === e.target) domRef.current.focus();
            },
            className: slots.innerWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.innerWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.innerWrapper
    ]);
    const getMainWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "main-wrapper",
            className: slots.mainWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.mainWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.mainWrapper
    ]);
    const getHelperWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "helper-wrapper",
            className: slots.helperWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.helperWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.helperWrapper
    ]);
    const getDescriptionProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...descriptionProps,
            "data-slot": "description",
            className: slots.description({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.description, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.description
    ]);
    const getErrorMessageProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...errorMessageProps,
            "data-slot": "error-message",
            className: slots.errorMessage({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.errorMessage, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        errorMessageProps,
        classNames == null ? void 0 : classNames.errorMessage
    ]);
    const getClearButtonProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            role: "button",
            tabIndex: 0,
            "data-slot": "clear-button",
            "data-focus-visible": (0, $6G4gc.dataAttr)(isClearButtonFocusVisible),
            className: slots.clearButton({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.clearButton, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $dCyIs.mergeProps)(clearPressProps, clearFocusProps)
        };
    }, [
        slots,
        isClearButtonFocusVisible,
        clearPressProps,
        clearFocusProps,
        classNames == null ? void 0 : classNames.clearButton
    ]);
    return {
        Component: Component,
        classNames: classNames,
        domRef: domRef,
        label: label,
        description: description,
        startContent: startContent,
        endContent: endContent,
        labelPlacement: labelPlacement,
        isClearable: isClearable,
        hasHelper: hasHelper,
        hasStartContent: hasStartContent,
        isLabelOutside: isLabelOutside,
        isOutsideLeft: isOutsideLeft,
        isLabelOutsideAsPlaceholder: isLabelOutsideAsPlaceholder,
        shouldLabelBeOutside: shouldLabelBeOutside,
        shouldLabelBeInside: shouldLabelBeInside,
        hasPlaceholder: hasPlaceholder,
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        getBaseProps: getBaseProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getMainWrapperProps: getMainWrapperProps,
        getInputWrapperProps: getInputWrapperProps,
        getInnerWrapperProps: getInnerWrapperProps,
        getHelperWrapperProps: getHelperWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getErrorMessageProps: getErrorMessageProps,
        getClearButtonProps: getClearButtonProps
    };
}

});
parcelRegister("cOcFk", function(module, exports) {

$parcel$export(module.exports, "useSafeLayoutEffect", function () { return $10789006048a381e$export$deebe11a338de063; });
// src/index.ts

var $bh6RR = parcelRequire("bh6RR");
var $10789006048a381e$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);

});

parcelRegister("gRmsp", function(module, exports) {

$parcel$export(module.exports, "input", function () { return $84776f134ba91e77$export$b7e3ae3d7c15e42e; });

var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/input.ts
var $84776f134ba91e77$export$b7e3ae3d7c15e42e = (0, $6ujkL.tv)({
    slots: {
        base: "group flex flex-col",
        label: [
            "absolute",
            "z-10",
            "pointer-events-none",
            "origin-top-left",
            "rtl:origin-top-right",
            "subpixel-antialiased",
            "block",
            "text-small",
            "text-foreground-500"
        ],
        mainWrapper: "h-full",
        inputWrapper: "relative w-full inline-flex tap-highlight-transparent flex-row items-center shadow-sm px-3 gap-3",
        innerWrapper: "inline-flex w-full items-center h-full box-border",
        input: [
            "w-full font-normal bg-transparent !outline-none placeholder:text-foreground-500 focus-visible:outline-none",
            "data-[has-start-content=true]:ps-1.5",
            "data-[has-end-content=true]:pe-1.5"
        ],
        clearButton: [
            "p-2",
            "-m-2",
            "z-10",
            "hidden",
            "absolute",
            "right-3",
            "rtl:right-auto",
            "rtl:left-3",
            "appearance-none",
            "outline-none",
            "select-none",
            "opacity-0",
            "hover:!opacity-100",
            "cursor-pointer",
            "active:!opacity-70",
            "rounded-full",
            ...(0, $g2NHD.dataFocusVisibleClasses)
        ],
        helperWrapper: "hidden group-data-[has-helper=true]:flex p-1 relative flex-col gap-1.5",
        description: "text-tiny text-foreground-400",
        errorMessage: "text-tiny text-danger"
    },
    variants: {
        variant: {
            flat: {
                inputWrapper: [
                    "bg-default-100",
                    "data-[hover=true]:bg-default-200",
                    "group-data-[focus=true]:bg-default-100"
                ]
            },
            faded: {
                inputWrapper: [
                    "bg-default-100",
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400"
                ],
                value: "group-data-[has-value=true]:text-default-foreground"
            },
            bordered: {
                inputWrapper: [
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400",
                    "group-data-[focus=true]:border-default-foreground"
                ]
            },
            underlined: {
                inputWrapper: [
                    "!px-1",
                    "!pb-0",
                    "!gap-0",
                    "relative",
                    "box-border",
                    "border-b-medium",
                    "shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]",
                    "border-default-200",
                    "!rounded-none",
                    "hover:border-default-300",
                    "after:content-['']",
                    "after:w-0",
                    "after:origin-center",
                    "after:bg-default-foreground",
                    "after:absolute",
                    "after:left-1/2",
                    "after:-translate-x-1/2",
                    "after:-bottom-[2px]",
                    "after:h-[2px]",
                    "group-data-[focus=true]:after:w-full"
                ],
                innerWrapper: "pb-1",
                label: "group-data-[filled-within=true]:text-foreground"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        size: {
            sm: {
                label: "text-tiny",
                inputWrapper: "h-8 min-h-8 px-2 rounded-small",
                input: "text-small",
                clearButton: "text-medium"
            },
            md: {
                inputWrapper: "h-10 min-h-10 rounded-medium",
                input: "text-small",
                clearButton: "text-large"
            },
            lg: {
                inputWrapper: "h-12 min-h-12 rounded-large",
                input: "text-medium",
                clearButton: "text-large"
            }
        },
        radius: {
            none: {
                inputWrapper: "rounded-none"
            },
            sm: {
                inputWrapper: "rounded-small"
            },
            md: {
                inputWrapper: "rounded-medium"
            },
            lg: {
                inputWrapper: "rounded-large"
            },
            full: {
                inputWrapper: "rounded-full"
            }
        },
        labelPlacement: {
            outside: {
                mainWrapper: "flex flex-col"
            },
            "outside-left": {
                base: "flex-row items-center flex-nowrap data-[has-helper=true]:items-start",
                inputWrapper: "flex-1",
                mainWrapper: "flex flex-col",
                label: "relative text-foreground pr-2 rtl:pr-0 rtl:pl-2"
            },
            inside: {
                label: "text-tiny cursor-text",
                inputWrapper: "flex-col items-start justify-center gap-0",
                innerWrapper: "group-data-[has-label=true]:items-end"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isClearable: {
            true: {
                input: "peer pr-6 rtl:pr-0 rtl:pl-6",
                clearButton: "peer-data-[filled=true]:opacity-70 peer-data-[filled=true]:block"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none",
                inputWrapper: "pointer-events-none",
                label: "pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                label: "!text-danger",
                input: "!placeholder:text-danger !text-danger"
            }
        },
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5 rtl:after:ml-[unset] rtl:after:mr-0.5"
            }
        },
        isMultiline: {
            true: {
                label: "relative",
                inputWrapper: "!h-auto",
                innerWrapper: "items-start group-data-[has-label=true]:items-start",
                input: "resize-none data-[hide-scroll=true]:scrollbar-hide"
            }
        },
        disableAnimation: {
            true: {
                input: "transition-none",
                inputWrapper: "transition-none",
                label: "transition-none"
            },
            false: {
                inputWrapper: "transition-background motion-reduce:transition-none !duration-150",
                label: [
                    "will-change-auto",
                    "!duration-200",
                    "!ease-out",
                    "motion-reduce:transition-none",
                    "transition-[transform,color,left,opacity]"
                ],
                clearButton: [
                    "transition-opacity",
                    "motion-reduce:transition-none"
                ]
            }
        }
    },
    defaultVariants: {
        variant: "flat",
        color: "default",
        size: "md",
        fullWidth: true,
        labelPlacement: "inside",
        isDisabled: false,
        isMultiline: false
    },
    compoundVariants: [
        {
            variant: "flat",
            color: "default",
            class: {
                input: "group-data-[has-value=true]:text-default-foreground"
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                inputWrapper: [
                    "bg-primary-50",
                    "data-[hover=true]:bg-primary-100",
                    "text-primary",
                    "group-data-[focus=true]:bg-primary-50",
                    "placeholder:text-primary"
                ],
                input: "placeholder:text-primary",
                label: "text-primary"
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                inputWrapper: [
                    "bg-secondary-50",
                    "text-secondary",
                    "data-[hover=true]:bg-secondary-100",
                    "group-data-[focus=true]:bg-secondary-50",
                    "placeholder:text-secondary"
                ],
                input: "placeholder:text-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                inputWrapper: [
                    "bg-success-50",
                    "text-success-600",
                    "dark:text-success",
                    "placeholder:text-success-600",
                    "dark:placeholder:text-success",
                    "data-[hover=true]:bg-success-100",
                    "group-data-[focus=true]:bg-success-50"
                ],
                input: "placeholder:text-success-600 dark:placeholder:text-success",
                label: "text-success-600 dark:text-success"
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                inputWrapper: [
                    "bg-warning-50",
                    "text-warning-600",
                    "dark:text-warning",
                    "placeholder:text-warning-600",
                    "dark:placeholder:text-warning",
                    "data-[hover=true]:bg-warning-100",
                    "group-data-[focus=true]:bg-warning-50"
                ],
                input: "placeholder:text-warning-600 dark:placeholder:text-warning",
                label: "text-warning-600 dark:text-warning"
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                inputWrapper: [
                    "bg-danger-50",
                    "text-danger",
                    "dark:text-danger-500",
                    "placeholder:text-danger",
                    "dark:placeholder:text-danger-500",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ],
                input: "placeholder:text-danger dark:placeholder:text-danger-500",
                label: "text-danger dark:text-danger-500"
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                label: "text-primary",
                inputWrapper: "data-[hover=true]:border-primary focus-within:border-primary"
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                label: "text-secondary",
                inputWrapper: "data-[hover=true]:border-secondary focus-within:border-secondary"
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                label: "text-success",
                inputWrapper: "data-[hover=true]:border-success focus-within:border-success"
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                label: "text-warning",
                inputWrapper: "data-[hover=true]:border-warning focus-within:border-warning"
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                label: "text-danger",
                inputWrapper: "data-[hover=true]:border-danger focus-within:border-danger"
            }
        },
        {
            variant: "underlined",
            color: "default",
            class: {
                input: "group-data-[has-value=true]:text-foreground"
            }
        },
        {
            variant: "underlined",
            color: "primary",
            class: {
                inputWrapper: "after:bg-primary",
                label: "text-primary"
            }
        },
        {
            variant: "underlined",
            color: "secondary",
            class: {
                inputWrapper: "after:bg-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "underlined",
            color: "success",
            class: {
                inputWrapper: "after:bg-success",
                label: "text-success"
            }
        },
        {
            variant: "underlined",
            color: "warning",
            class: {
                inputWrapper: "after:bg-warning",
                label: "text-warning"
            }
        },
        {
            variant: "underlined",
            color: "danger",
            class: {
                inputWrapper: "after:bg-danger",
                label: "text-danger"
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                inputWrapper: "group-data-[focus=true]:border-primary",
                label: "text-primary"
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                inputWrapper: "group-data-[focus=true]:border-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                inputWrapper: "group-data-[focus=true]:border-success",
                label: "text-success"
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                inputWrapper: "group-data-[focus=true]:border-warning",
                label: "text-warning"
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                inputWrapper: "group-data-[focus=true]:border-danger",
                label: "text-danger"
            }
        },
        {
            labelPlacement: "inside",
            color: "default",
            class: {
                label: "group-data-[filled-within=true]:text-default-600"
            }
        },
        {
            labelPlacement: "outside",
            color: "default",
            class: {
                label: "group-data-[filled-within=true]:text-foreground"
            }
        },
        {
            radius: "full",
            size: [
                "sm"
            ],
            class: {
                inputWrapper: "px-3"
            }
        },
        {
            radius: "full",
            size: "md",
            class: {
                inputWrapper: "px-4"
            }
        },
        {
            radius: "full",
            size: "lg",
            class: {
                inputWrapper: "px-5"
            }
        },
        {
            disableAnimation: false,
            variant: [
                "faded",
                "bordered"
            ],
            class: {
                inputWrapper: "transition-colors motion-reduce:transition-none"
            }
        },
        {
            disableAnimation: false,
            variant: "underlined",
            class: {
                inputWrapper: "after:transition-width motion-reduce:after:transition-none"
            }
        },
        {
            variant: [
                "flat",
                "faded"
            ],
            class: {
                inputWrapper: [
                    ...(0, $g2NHD.groupDataFocusVisibleClasses)
                ]
            }
        },
        {
            isInvalid: true,
            variant: "flat",
            class: {
                inputWrapper: [
                    "!bg-danger-50",
                    "data-[hover=true]:!bg-danger-100",
                    "group-data-[focus=true]:!bg-danger-50"
                ]
            }
        },
        {
            isInvalid: true,
            variant: "bordered",
            class: {
                inputWrapper: "!border-danger group-data-[focus=true]:!border-danger"
            }
        },
        {
            isInvalid: true,
            variant: "underlined",
            class: {
                inputWrapper: "after:!bg-danger"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            class: {
                inputWrapper: "h-12 py-1.5 px-3"
            }
        },
        {
            labelPlacement: "inside",
            size: "md",
            class: {
                inputWrapper: "h-14 py-2"
            }
        },
        {
            labelPlacement: "inside",
            size: "lg",
            class: {
                label: "text-small",
                inputWrapper: "h-16 py-2.5 gap-0"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            variant: [
                "bordered",
                "faded"
            ],
            class: {
                inputWrapper: "py-1"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "group-data-[filled-within=true]:pointer-events-auto"
                ]
            }
        },
        {
            labelPlacement: [
                "outside",
                "outside-left"
            ],
            class: {
                input: "h-full"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            class: {
                base: "group relative justify-end",
                label: [
                    "pb-0",
                    "z-20",
                    "top-1/2",
                    "-translate-y-1/2",
                    "group-data-[filled-within=true]:left-0"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            class: {
                label: [
                    "group-data-[filled-within=true]:scale-85"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            variant: "flat",
            class: {
                innerWrapper: "pb-0.5"
            }
        },
        {
            variant: "underlined",
            size: "sm",
            class: {
                innerWrapper: "pb-1"
            }
        },
        {
            variant: "underlined",
            size: [
                "md",
                "lg"
            ],
            class: {
                innerWrapper: "pb-1.5"
            }
        },
        {
            labelPlacement: "inside",
            size: [
                "sm",
                "md"
            ],
            class: {
                label: "text-small"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_3.5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            size: "lg",
            isMultiline: false,
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_4px)]"
                ]
            }
        },
        {
            labelPlacement: "outside",
            size: "sm",
            isMultiline: false,
            class: {
                label: [
                    "left-2",
                    "text-tiny",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.tiny)/2_+_16px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_8px)]"
            }
        },
        {
            labelPlacement: "outside",
            size: "md",
            isMultiline: false,
            class: {
                label: [
                    "left-3",
                    "rtl:left-auto",
                    "rtl:right-3",
                    "text-small",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_20px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_10px)]"
            }
        },
        {
            labelPlacement: "outside",
            size: "lg",
            isMultiline: false,
            class: {
                label: [
                    "left-3",
                    "rtl:left-auto",
                    "rtl:right-3",
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_24px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_12px)]"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "sm",
            class: {
                label: "group-data-[has-helper=true]:pt-2"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "md",
            class: {
                label: "group-data-[has-helper=true]:pt-3"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "lg",
            class: {
                label: "group-data-[has-helper=true]:pt-4"
            }
        },
        {
            labelPlacement: [
                "outside",
                "outside-left"
            ],
            isMultiline: true,
            class: {
                inputWrapper: "py-2"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: true,
            class: {
                label: "pb-1.5"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: true,
            class: {
                label: "pb-0.5",
                input: "pt-0"
            }
        },
        {
            isMultiline: true,
            disableAnimation: false,
            class: {
                input: "transition-height !duration-100 motion-reduce:transition-none"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "pe-2",
                    "max-w-full",
                    "text-ellipsis",
                    "overflow-hidden"
                ]
            }
        },
        {
            isMultiline: true,
            radius: "full",
            class: {
                inputWrapper: "data-[has-multiple-rows=true]:rounded-large"
            }
        }
    ]
});

});

parcelRegister("fAuxS", function(module, exports) {

$parcel$export(module.exports, "safeAriaLabel", function () { return $d768f9f7745c6467$export$a3d82bd9a7fbdcbb; });
// src/text.ts
var $d768f9f7745c6467$export$bb381007244da5ab = (text)=>{
    if ((text == null ? void 0 : text.length) <= 4) return text;
    return text == null ? void 0 : text.slice(0, 3);
};
var $d768f9f7745c6467$export$a3d82bd9a7fbdcbb = (...texts)=>{
    let ariaLabel = " ";
    for (const text of texts)if (typeof text === "string" && text.length > 0) {
        ariaLabel = text;
        break;
    }
    return ariaLabel;
};

});

parcelRegister("5gL1f", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $3d62eb612dfa28ff$export$40bfa8c7b0832715; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3d62eb612dfa28ff$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $bh6RR.useState)(value || defaultValue);
    let isControlledRef = (0, $bh6RR.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $bh6RR.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $bh6RR.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $3d62eb612dfa28ff$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $3d62eb612dfa28ff$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $3d62eb612dfa28ff$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});

parcelRegister("75Msr", function(module, exports) {

$parcel$export(module.exports, "useTextField", function () { return $529e96b5e4532228$export$712718f7aec83d5; });

var $bh6RR = parcelRequire("bh6RR");

var $leZvJ = parcelRequire("leZvJ");
var $ld26B = parcelRequire("ld26B");
var $dCyIs = parcelRequire("dCyIs");
var $77fRS = parcelRequire("77fRS");
var $4yIWF = parcelRequire("4yIWF");

var $6YdNt = parcelRequire("6YdNt");

var $16VJg = parcelRequire("16VJg");

var $4wqg7 = parcelRequire("4wqg7");

var $7SXQb = parcelRequire("7SXQb");

var $bMRiS = parcelRequire("bMRiS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $529e96b5e4532228$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = "input", isDisabled: isDisabled = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, type: type = "text", validationBehavior: validationBehavior = "aria" } = props;
    let [value, setValue] = (0, $6YdNt.useControlledState)(props.value, props.defaultValue || "", props.onChange);
    let { focusableProps: focusableProps } = (0, $4wqg7.useFocusable)(props, ref);
    let validationState = (0, $bMRiS.useFormValidationState)({
        ...props,
        value: value
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $16VJg.useField)({
        ...props,
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    (0, $4yIWF.useFormReset)(ref, value, setValue);
    (0, $7SXQb.useFormValidation)(props, validationState, ref);
    (0, $bh6RR.useEffect)(()=>{
        // This works around a React/Chrome bug that prevents textarea elements from validating when controlled.
        // We prevent React from updating defaultValue (i.e. children) of textarea when `value` changes,
        // which causes Chrome to skip validation. Only updating `value` is ok in our case since our
        // textareas are always controlled. React is planning on removing this synchronization in a
        // future major version.
        // https://github.com/facebook/react/issues/19474
        // https://github.com/facebook/react/issues/11896
        if (ref.current instanceof (0, $ld26B.getOwnerWindow)(ref.current).HTMLTextAreaElement) {
            let input = ref.current;
            Object.defineProperty(input, "defaultValue", {
                get: ()=>input.value,
                set: ()=>{},
                configurable: true
            });
        }
    }, [
        ref
    ]);
    return {
        labelProps: labelProps,
        inputProps: (0, $dCyIs.mergeProps)(domProps, inputElementType === "input" && inputOnlyProps, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === "native",
            "aria-required": isRequired && validationBehavior === "aria" || undefined,
            "aria-invalid": isInvalid || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-activedescendant": props["aria-activedescendant"],
            "aria-autocomplete": props["aria-autocomplete"],
            "aria-haspopup": props["aria-haspopup"],
            value: value,
            onChange: (e)=>setValue(e.target.value),
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $529e96b5e4532228$var$$d841c8010a73d545$var$supportsNativeBeforeInputEvent() {
    return typeof window !== "undefined" && window.InputEvent && // @ts-ignore
    typeof InputEvent.prototype.getTargetRanges === "function";
}
function $529e96b5e4532228$export$4f384c9210e583c3(props, state, inputRef) {
    // All browsers implement the 'beforeinput' event natively except Firefox
    // (currently behind a flag as of Firefox 84). React's polyfill does not
    // run in all cases that the native event fires, e.g. when deleting text.
    // Use the native event if available so that we can prevent invalid deletions.
    // We do not attempt to polyfill this in Firefox since it would be very complicated,
    // the benefit of doing so is fairly minor, and it's going to be natively supported soon.
    let onBeforeInputFallback = (0, $77fRS.useEffectEvent)((e)=>{
        let input = inputRef.current;
        // Compute the next value of the input if the event is allowed to proceed.
        // See https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes for a full list of input types.
        let nextValue;
        switch(e.inputType){
            case "historyUndo":
            case "historyRedo":
                // Explicitly allow undo/redo. e.data is null in this case, but there's no need to validate,
                // because presumably the input would have already been validated previously.
                return;
            case "deleteContent":
            case "deleteByCut":
            case "deleteByDrag":
                nextValue = input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteContentForward":
                // This is potentially incorrect, since the browser may actually delete more than a single UTF-16
                // character. In reality, a full Unicode grapheme cluster consisting of multiple UTF-16 characters
                // or code points may be deleted. However, in our currently supported locales, there are no such cases.
                // If we support additional locales in the future, this may need to change.
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd + 1) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteContentBackward":
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart - 1) + input.value.slice(input.selectionStart) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteSoftLineBackward":
            case "deleteHardLineBackward":
                nextValue = input.value.slice(input.selectionStart);
                break;
            default:
                if (e.data != null) nextValue = input.value.slice(0, input.selectionStart) + e.data + input.value.slice(input.selectionEnd);
                break;
        }
        // If we did not compute a value, or the new value is invalid, prevent the event
        // so that the browser does not update the input text, move the selection, or add to
        // the undo/redo stack.
        if (nextValue == null || !state.validate(nextValue)) e.preventDefault();
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!$529e96b5e4532228$var$$d841c8010a73d545$var$supportsNativeBeforeInputEvent()) return;
        let input = inputRef.current;
        input.addEventListener("beforeinput", onBeforeInputFallback, false);
        return ()=>{
            input.removeEventListener("beforeinput", onBeforeInputFallback, false);
        };
    }, [
        inputRef,
        onBeforeInputFallback
    ]);
    let onBeforeInput = !$529e96b5e4532228$var$$d841c8010a73d545$var$supportsNativeBeforeInputEvent() ? (e)=>{
        let nextValue = e.target.value.slice(0, e.target.selectionStart) + e.data + e.target.value.slice(e.target.selectionEnd);
        if (!state.validate(nextValue)) e.preventDefault();
    } : null;
    let { labelProps: labelProps, inputProps: textFieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = $529e96b5e4532228$export$712718f7aec83d5(props, inputRef);
    let compositionStartState = (0, $bh6RR.useRef)(null);
    return {
        inputProps: (0, $dCyIs.mergeProps)(textFieldProps, {
            onBeforeInput: onBeforeInput,
            onCompositionStart () {
                // Chrome does not implement Input Events Level 2, which specifies the insertFromComposition
                // and deleteByComposition inputType values for the beforeinput event. These are meant to occur
                // at the end of a composition (e.g. Pinyin IME, Android auto correct, etc.), and crucially, are
                // cancelable. The insertCompositionText and deleteCompositionText input types are not cancelable,
                // nor would we want to cancel them because the input from the user is incomplete at that point.
                // In Safari, insertFromComposition/deleteFromComposition will fire, however, allowing us to cancel
                // the final composition result if it is invalid. As a fallback for Chrome and Firefox, which either
                // don't support Input Events Level 2, or beforeinput at all, we store the state of the input when
                // the compositionstart event fires, and undo the changes in compositionend (below) if it is invalid.
                // Unfortunately, this messes up the undo/redo stack, but until insertFromComposition/deleteByComposition
                // are implemented, there is no other way to prevent composed input.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1022204
                let { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = inputRef.current;
                compositionStartState.current = {
                    value: value,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            },
            onCompositionEnd () {
                if (!state.validate(inputRef.current.value)) {
                    // Restore the input value in the DOM immediately so we can synchronously update the selection position.
                    // But also update the value in React state as well so it is correct for future updates.
                    let { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = compositionStartState.current;
                    inputRef.current.value = value;
                    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    state.setInputValue(value);
                }
            }
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        ...validation
    };
}

});
parcelRegister("4yIWF", function(module, exports) {

$parcel$export(module.exports, "useFormReset", function () { return $351d339b36963032$export$5add1d006293d136; });

var $77fRS = parcelRequire("77fRS");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $351d339b36963032$export$5add1d006293d136(ref, initialValue, onReset) {
    let resetValue = (0, $bh6RR.useRef)(initialValue);
    let handleReset = (0, $77fRS.useEffectEvent)(()=>{
        if (onReset) onReset(resetValue.current);
    });
    (0, $bh6RR.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener("reset", handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}

});

parcelRegister("16VJg", function(module, exports) {

$parcel$export(module.exports, "useField", function () { return $0cf321cbfeadaf90$export$294aa081a6c6f55d; });

var $cvRSw = parcelRequire("cvRSw");

var $dCyIs = parcelRequire("dCyIs");
var $43JEG = parcelRequire("43JEG");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0cf321cbfeadaf90$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $cvRSw.useLabel)(props);
    let descriptionId = (0, $43JEG.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $43JEG.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $dCyIs.mergeProps)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

});
parcelRegister("cvRSw", function(module, exports) {

$parcel$export(module.exports, "useLabel", function () { return $91c22c66bd35a351$export$8467354a121f1b9f; });

var $43JEG = parcelRequire("43JEG");
var $bZ9ps = parcelRequire("bZ9ps");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $91c22c66bd35a351$export$8467354a121f1b9f(props) {
    let { id: id, label: label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType: labelElementType = "label" } = props;
    id = (0, $43JEG.useId)(id);
    let labelId = (0, $43JEG.useId)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, $bZ9ps.useLabels)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}

});
parcelRegister("bZ9ps", function(module, exports) {

$parcel$export(module.exports, "useLabels", function () { return $8b9cb0c7fc6bec21$export$d6875122194c7b44; });

var $43JEG = parcelRequire("43JEG");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8b9cb0c7fc6bec21$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, "aria-label": label, "aria-labelledby": labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $43JEG.useId)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}

});



parcelRegister("4wqg7", function(module, exports) {

$parcel$export(module.exports, "useFocusable", function () { return $34ae85144e9378fa$export$4c014de7c8940b4c; });

var $dCxGQ = parcelRequire("dCxGQ");

var $dCyIs = parcelRequire("dCyIs");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");

var $1fxmD = parcelRequire("1fxmD");
var $lRxSB = parcelRequire("lRxSB");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $34ae85144e9378fa$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $34ae85144e9378fa$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $bh6RR.useContext)($34ae85144e9378fa$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $2Cn0z.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $34ae85144e9378fa$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $99EP5.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($34ae85144e9378fa$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $34ae85144e9378fa$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($34ae85144e9378fa$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $34ae85144e9378fa$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $1fxmD.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $lRxSB.useKeyboard)(props);
    let interactions = (0, $dCyIs.mergeProps)(focusProps, keyboardProps);
    let domProps = $34ae85144e9378fa$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $bh6RR.useRef)(props.autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $dCxGQ.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $dCyIs.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

});
parcelRegister("dCxGQ", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $9ea8f51eb7bf5615$export$80f3e147d781571c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $lRz5x = parcelRequire("lRz5x");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9ea8f51eb7bf5615$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $lRz5x.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}

});
parcelRegister("lRz5x", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $fea9c4004e995b32$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality = null;
let $fea9c4004e995b32$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $fea9c4004e995b32$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $fea9c4004e995b32$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $fea9c4004e995b32$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($fea9c4004e995b32$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $fea9c4004e995b32$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $fea9c4004e995b32$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $fea9c4004e995b32$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$fea9c4004e995b32$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $fea9c4004e995b32$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $fea9c4004e995b32$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $fea9c4004e995b32$export$d90243b58daecda7.delete(windowObject);
};
function $fea9c4004e995b32$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $fea9c4004e995b32$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $fea9c4004e995b32$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$fea9c4004e995b32$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $fea9c4004e995b32$export$2f1888112f558a7d();
function $fea9c4004e995b32$export$b9b3dfddab17db27() {
    return $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $fea9c4004e995b32$export$630ff653c5ada6a9() {
    return $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality;
}
function $fea9c4004e995b32$export$8397ddfc504fdb9a(modality) {
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality = modality;
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $fea9c4004e995b32$export$98e20ec92f614cfe() {
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($fea9c4004e995b32$var$$507fabe10e71c6fb$var$currentModality);
        };
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $fea9c4004e995b32$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $fea9c4004e995b32$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $fea9c4004e995b32$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$fea9c4004e995b32$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$fea9c4004e995b32$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $fea9c4004e995b32$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $fea9c4004e995b32$export$b9b3dfddab17db27());
    $fea9c4004e995b32$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $fea9c4004e995b32$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $fea9c4004e995b32$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$fea9c4004e995b32$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($fea9c4004e995b32$export$b9b3dfddab17db27());
        };
        $fea9c4004e995b32$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $fea9c4004e995b32$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("1fxmD", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $0e911291e09446e4$export$f8168d8dd8fd66e6; });

var $7Nwsk = parcelRequire("7Nwsk");

var $bh6RR = parcelRequire("bh6RR");

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $0e911291e09446e4$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $7Nwsk.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $ld26B.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("7Nwsk", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $5ad6490e5936ff26$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $5ad6490e5936ff26$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $5ad6490e5936ff26$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $5ad6490e5936ff26$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("lRxSB", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $fea8d405840bb56b$export$8f71654801c2f7cd; });

var $facyH = parcelRequire("facyH");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fea8d405840bb56b$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $facyH.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $facyH.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("facyH", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $b0a1880d6fffaad1$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b0a1880d6fffaad1$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});



parcelRegister("7SXQb", function(module, exports) {

$parcel$export(module.exports, "useFormValidation", function () { return $5bdbfeac5a9a671b$export$b8473d3665f3a75a; });

var $bh6RR = parcelRequire("bh6RR");

var $1Oxsm = parcelRequire("1Oxsm");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5bdbfeac5a9a671b$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation($5bdbfeac5a9a671b$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    let onReset = (0, $77fRS.useEffectEvent)(()=>{
        state.resetValidation();
    });
    let onInvalid = (0, $77fRS.useEffectEvent)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $5bdbfeac5a9a671b$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $1Oxsm.setInteractionModality)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $77fRS.useEffectEvent)(()=>{
        state.commitValidation();
    });
    (0, $bh6RR.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 || form.addEventListener("reset", onReset);
        return ()=>{
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 || form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $5bdbfeac5a9a671b$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $5bdbfeac5a9a671b$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $5bdbfeac5a9a671b$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $5bdbfeac5a9a671b$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

});
parcelRegister("1Oxsm", function(module, exports) {

$parcel$export(module.exports, "setInteractionModality", function () { return $152469b7b7f51ae8$export$8397ddfc504fdb9a; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality = null;
let $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $152469b7b7f51ae8$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($152469b7b7f51ae8$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $152469b7b7f51ae8$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $152469b7b7f51ae8$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$152469b7b7f51ae8$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $152469b7b7f51ae8$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $152469b7b7f51ae8$export$d90243b58daecda7.delete(windowObject);
};
function $152469b7b7f51ae8$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$152469b7b7f51ae8$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $152469b7b7f51ae8$export$2f1888112f558a7d();
function $152469b7b7f51ae8$export$b9b3dfddab17db27() {
    return $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $152469b7b7f51ae8$export$630ff653c5ada6a9() {
    return $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality;
}
function $152469b7b7f51ae8$export$8397ddfc504fdb9a(modality) {
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality = modality;
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $152469b7b7f51ae8$export$98e20ec92f614cfe() {
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($152469b7b7f51ae8$var$$507fabe10e71c6fb$var$currentModality);
        };
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$152469b7b7f51ae8$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$152469b7b7f51ae8$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $152469b7b7f51ae8$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $152469b7b7f51ae8$export$b9b3dfddab17db27());
    $152469b7b7f51ae8$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $152469b7b7f51ae8$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$152469b7b7f51ae8$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($152469b7b7f51ae8$export$b9b3dfddab17db27());
        };
        $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $152469b7b7f51ae8$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("bMRiS", function(module, exports) {

$parcel$export(module.exports, "useFormValidationState", function () { return $894d8658d35a7e3e$export$fc1a364ae1f3ff10; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $894d8658d35a7e3e$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
    ...$894d8658d35a7e3e$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $894d8658d35a7e3e$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $894d8658d35a7e3e$export$aca958c65c314e6c,
    validationErrors: []
};
const $894d8658d35a7e3e$export$571b5131b7e65c11 = (0, $bh6RR.createContext)({});
const $894d8658d35a7e3e$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $894d8658d35a7e3e$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$894d8658d35a7e3e$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$894d8658d35a7e3e$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = "aria" } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $bh6RR.useMemo)(()=>$894d8658d35a7e3e$var$$e5be200c675c3b3a$var$getValidationResult($894d8658d35a7e3e$var$$e5be200c675c3b3a$var$runValidate(validate, value)), [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    let serverErrors = (0, $bh6RR.useContext)($894d8658d35a7e3e$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $bh6RR.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$894d8658d35a7e3e$var$$e5be200c675c3b3a$var$asArray(serverErrors[name])) : $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $bh6RR.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $bh6RR.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $bh6RR.useMemo)(()=>$894d8658d35a7e3e$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $bh6RR.useRef)($894d8658d35a7e3e$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $bh6RR.useState)($894d8658d35a7e3e$export$dad6ae84456c676a);
    let lastError = (0, $bh6RR.useRef)($894d8658d35a7e3e$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$894d8658d35a7e3e$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $894d8658d35a7e3e$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$894d8658d35a7e3e$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $894d8658d35a7e3e$export$dad6ae84456c676a;
            if (!$894d8658d35a7e3e$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        let e = validate(value);
        if (e && typeof e !== "boolean") return $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $894d8658d35a7e3e$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $894d8658d35a7e3e$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$894d8658d35a7e3e$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}

});



parcelRegister("7F1d7", function(module, exports) {

$parcel$export(module.exports, "CloseFilledIcon", function () { return $efa2d308ba4e96d0$export$2b32a5a2c6e4dc78; });
// src/close-filled.tsx

var $ih19M = parcelRequire("ih19M");
var $efa2d308ba4e96d0$export$2b32a5a2c6e4dc78 = (props)=>/* @__PURE__ */ (0, $ih19M.jsx)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $ih19M.jsx)("path", {
            d: "M12 2a10 10 0 1010 10A10.016 10.016 0 0012 2zm3.36 12.3a.754.754 0 010 1.06.748.748 0 01-1.06 0l-2.3-2.3-2.3 2.3a.748.748 0 01-1.06 0 .754.754 0 010-1.06l2.3-2.3-2.3-2.3A.75.75 0 019.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 011.06 1.06l-2.3 2.3z",
            fill: "currentColor"
        })
    });

});


parcelRegister("fPXqB", function(module, exports) {

$parcel$export(module.exports, "popover_default", function () { return $bda20178209b1c60$export$b56270f92ff8018; });

var $0l7yB = parcelRequire("0l7yB");

var $8JM8v = parcelRequire("8JM8v");

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");

var $iOLGl = parcelRequire("iOLGl");

var $lTq24 = parcelRequire("lTq24");

var $ih19M = parcelRequire("ih19M");
"use client";
var $bda20178209b1c60$var$Popover = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { children: children, ...otherProps } = props;
    const context = (0, $8JM8v.usePopover)({
        ...otherProps,
        ref: ref
    });
    const [trigger, content] = (0, $bh6RR.Children).toArray(children);
    const overlay = /* @__PURE__ */ (0, $ih19M.jsx)((0, $iOLGl.Overlay), {
        disableFocusManagement: true,
        portalContainer: context.portalContainer,
        children: content
    });
    return /* @__PURE__ */ (0, $ih19M.jsxs)((0, $0l7yB.PopoverProvider), {
        value: context,
        children: [
            trigger,
            context.disableAnimation && context.isOpen ? overlay : /* @__PURE__ */ (0, $ih19M.jsx)((0, $lTq24.AnimatePresence), {
                children: context.isOpen ? overlay : null
            })
        ]
    });
});
$bda20178209b1c60$var$Popover.displayName = "NextUI.Popover";
var $bda20178209b1c60$export$b56270f92ff8018 = $bda20178209b1c60$var$Popover;

});
parcelRegister("0l7yB", function(module, exports) {

$parcel$export(module.exports, "PopoverProvider", function () { return $85bcad597c9cff7a$export$bf694c7c431c162a; });
$parcel$export(module.exports, "usePopoverContext", function () { return $85bcad597c9cff7a$export$1468d0761b26e6c8; });

var $8kHrV = parcelRequire("8kHrV");
"use client";
var [$85bcad597c9cff7a$export$bf694c7c431c162a, $85bcad597c9cff7a$export$1468d0761b26e6c8] = (0, $8kHrV.createContext)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});

});

parcelRegister("8JM8v", function(module, exports) {

$parcel$export(module.exports, "usePopover", function () { return $46d69fc8fedab709$export$542a6fd13ac93354; });

var $fHxHP = parcelRequire("fHxHP");

var $bh6RR = parcelRequire("bh6RR");

var $gedB5 = parcelRequire("gedB5");

var $4lcRq = parcelRequire("4lcRq");

var $3HS2q = parcelRequire("3HS2q");

var $iOLGl = parcelRequire("iOLGl");

var $hN2BG = parcelRequire("hN2BG");
var $gSab4 = parcelRequire("gSab4");

var $aGkwu = parcelRequire("aGkwu");

var $9y80h = parcelRequire("9y80h");

var $dCyIs = parcelRequire("dCyIs");
var $8PomS = parcelRequire("8PomS");

var $3xP29 = parcelRequire("3xP29");
var $6G4gc = parcelRequire("6G4gc");
var $6N9Z9 = parcelRequire("6N9Z9");

var $5DJTk = parcelRequire("5DJTk");
"use client";
function $46d69fc8fedab709$export$542a6fd13ac93354(originalProps) {
    var _a, _b, _c;
    const globalContext = (0, $gSab4.useProviderContext)();
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $9y80h.popover).variantKeys);
    const { as: as, ref: ref, children: children, state: stateProp, triggerRef: triggerRefProp, scrollRef: scrollRef, defaultOpen: defaultOpen, onOpenChange: onOpenChange, isOpen: isOpenProp, isNonModal: isNonModal = true, shouldFlip: shouldFlip = true, containerPadding: containerPadding = 12, shouldBlockScroll: shouldBlockScroll = false, isDismissable: isDismissable = true, shouldCloseOnBlur: shouldCloseOnBlur, portalContainer: portalContainer, updatePositionDeps: updatePositionDeps, dialogProps: dialogPropsProp, placement: placementProp = "top", triggerType: triggerType = "dialog", showArrow: showArrow = false, offset: offset = 7, crossOffset: crossOffset = 0, boundaryElement: boundaryElement, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, motionProps: motionProps, className: className, classNames: classNames, onClose: onClose, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const domTriggerRef = (0, $bh6RR.useRef)(null);
    const wasTriggerPressedRef = (0, $bh6RR.useRef)(false);
    const dialogRef = (0, $bh6RR.useRef)(null);
    const triggerRef = triggerRefProp || domTriggerRef;
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const innerState = (0, $4lcRq.useOverlayTriggerState)({
        isOpen: isOpenProp,
        defaultOpen: defaultOpen,
        onOpenChange: (isOpen)=>{
            onOpenChange == null || onOpenChange(isOpen);
            if (!isOpen) onClose == null || onClose();
        }
    });
    const state = stateProp || innerState;
    const { popoverProps: popoverProps, underlayProps: underlayProps, placement: ariaPlacement } = (0, $fHxHP.useReactAriaPopover)({
        triggerRef: triggerRef,
        isNonModal: isNonModal,
        popoverRef: domRef,
        placement: placementProp,
        offset: offset,
        scrollRef: scrollRef,
        isDismissable: isDismissable,
        shouldCloseOnBlur: shouldCloseOnBlur,
        boundaryElement: boundaryElement,
        crossOffset: crossOffset,
        shouldFlip: shouldFlip,
        containerPadding: containerPadding,
        updatePositionDeps: updatePositionDeps,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, state);
    const { triggerProps: triggerProps } = (0, $iOLGl.useOverlayTrigger)({
        type: triggerType
    }, state, triggerRef);
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $3HS2q.useFocusRing)();
    const { dialogProps: dialogProps, titleProps: titleProps } = (0, $5DJTk.useDialog)({}, dialogRef);
    const slots = (0, $bh6RR.useMemo)(()=>(0, $9y80h.popover)({
            ...variantProps
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps)
    ]);
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    const getPopoverProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $dCyIs.mergeProps)(popoverProps, otherProps, props2),
            style: (0, $dCyIs.mergeProps)(popoverProps.style, otherProps.style, props2.style)
        });
    const getDialogProps = (props2 = {})=>({
            ref: dialogRef,
            "data-slot": "base",
            "data-open": (0, $6G4gc.dataAttr)(state.isOpen),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-arrow": (0, $6G4gc.dataAttr)(showArrow),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            "data-placement": (0, $aGkwu.getArrowPlacement)(ariaPlacement, placementProp),
            ...(0, $dCyIs.mergeProps)(focusProps, dialogProps, dialogPropsProp, props2),
            className: slots.base({
                class: (0, $3xP29.clsx)(baseStyles)
            }),
            style: {
                outline: "none"
            }
        });
    const getContentProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            "data-slot": "content",
            "data-open": (0, $6G4gc.dataAttr)(state.isOpen),
            "data-arrow": (0, $6G4gc.dataAttr)(showArrow),
            "data-placement": (0, $aGkwu.getArrowPlacement)(ariaPlacement, placementProp),
            className: slots.content({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.content, props2.className)
            })
        }), [
        slots,
        state.isOpen,
        showArrow,
        ariaPlacement,
        placementProp,
        classNames
    ]);
    const placement = (0, $bh6RR.useMemo)(()=>(0, $aGkwu.getShouldUseAxisPlacement)(ariaPlacement, placementProp) ? ariaPlacement || placementProp : placementProp, [
        ariaPlacement,
        placementProp
    ]);
    const onPress = (0, $bh6RR.useCallback)((e)=>{
        var _a2;
        let pressTimer;
        if (e.pointerType === "touch" && ((originalProps == null ? void 0 : originalProps.backdrop) === "blur" || (originalProps == null ? void 0 : originalProps.backdrop) === "opaque")) pressTimer = setTimeout(()=>{
            wasTriggerPressedRef.current = true;
        }, 100);
        else wasTriggerPressedRef.current = true;
        (_a2 = triggerProps.onPress) == null || _a2.call(triggerProps, e);
        return ()=>{
            clearTimeout(pressTimer);
        };
    }, [
        triggerProps == null ? void 0 : triggerProps.onPress
    ]);
    const getTriggerProps = (0, $bh6RR.useCallback)((props2 = {}, _ref = null)=>{
        const { isDisabled: isDisabled, ...otherProps2 } = props2;
        return {
            "data-slot": "trigger",
            "aria-haspopup": "dialog",
            ...(0, $dCyIs.mergeProps)(triggerProps, otherProps2),
            onPress: onPress,
            isDisabled: isDisabled,
            className: slots.trigger({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.trigger, props2.className),
                isTriggerDisabled: isDisabled
            }),
            ref: (0, $8PomS.mergeRefs)(_ref, triggerRef)
        };
    }, [
        state,
        triggerProps,
        onPress,
        triggerRef
    ]);
    const getBackdropProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            "data-slot": "backdrop",
            className: slots.backdrop({
                class: classNames == null ? void 0 : classNames.backdrop
            }),
            onClick: (e)=>{
                if (!wasTriggerPressedRef.current) {
                    e.preventDefault();
                    return;
                }
                state.close();
                wasTriggerPressedRef.current = false;
            },
            ...underlayProps,
            ...props2
        }), [
        slots,
        state.isOpen,
        classNames,
        underlayProps
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (state.isOpen && (domRef == null ? void 0 : domRef.current)) return (0, $iOLGl.ariaHideOutside)([
            domRef == null ? void 0 : domRef.current
        ]);
    }, [
        state.isOpen,
        domRef
    ]);
    return {
        state: state,
        Component: Component,
        children: children,
        classNames: classNames,
        showArrow: showArrow,
        triggerRef: triggerRef,
        placement: placement,
        isNonModal: isNonModal,
        titleProps: titleProps,
        popoverRef: domRef,
        portalContainer: portalContainer,
        isOpen: state.isOpen,
        onClose: state.close,
        disableAnimation: disableAnimation,
        shouldBlockScroll: shouldBlockScroll,
        backdrop: (_c = originalProps.backdrop) != null ? _c : "transparent",
        motionProps: motionProps,
        getBackdropProps: getBackdropProps,
        getPopoverProps: getPopoverProps,
        getTriggerProps: getTriggerProps,
        getDialogProps: getDialogProps,
        getContentProps: getContentProps
    };
}

});
parcelRegister("fHxHP", function(module, exports) {

$parcel$export(module.exports, "useReactAriaPopover", function () { return $155f595220f4d34c$export$edc31d940c0b0631; });

var $bh6RR = parcelRequire("bh6RR");

var $iOLGl = parcelRequire("iOLGl");

var $43CqS = parcelRequire("43CqS");
var $iGORm = parcelRequire("iGORm");
var $aGkwu = parcelRequire("aGkwu");

var $dCyIs = parcelRequire("dCyIs");

var $cOcFk = parcelRequire("cOcFk");
"use client";
function $155f595220f4d34c$export$edc31d940c0b0631(props, state) {
    const { triggerRef: triggerRef, popoverRef: popoverRef, showArrow: showArrow, offset: offset = 7, crossOffset: crossOffset = 0, scrollRef: scrollRef, shouldFlip: shouldFlip, boundaryElement: boundaryElement, isDismissable: isDismissable = true, shouldCloseOnBlur: shouldCloseOnBlur = true, placement: placementProp = "top", containerPadding: containerPadding, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, isNonModal: isNonModalProp, isKeyboardDismissDisabled: isKeyboardDismissDisabled, updatePositionDeps: updatePositionDeps = [], ...otherProps } = props;
    const isNonModal = isNonModalProp != null ? isNonModalProp : true;
    const { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $iOLGl.useOverlay)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: shouldCloseOnBlur,
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside ? shouldCloseOnInteractOutside : (element)=>(0, $iGORm.ariaShouldCloseOnInteractOutside)(element, triggerRef, state)
    }, popoverRef);
    const { overlayProps: positionProps, arrowProps: arrowProps, placement: placement, updatePosition: updatePosition } = (0, $iOLGl.useOverlayPosition)({
        ...otherProps,
        shouldFlip: shouldFlip,
        crossOffset: crossOffset,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        scrollRef: scrollRef,
        boundaryElement: boundaryElement,
        containerPadding: containerPadding,
        placement: (0, $aGkwu.toReactAriaPlacement)(placementProp),
        offset: showArrow ? offset + 3 : offset,
        onClose: ()=>{}
    });
    (0, $cOcFk.useSafeLayoutEffect)(()=>{
        if (!updatePositionDeps.length) return;
        updatePosition();
    }, updatePositionDeps);
    (0, $bh6RR.useEffect)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return (0, $43CqS.ariaHideOutside)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, $dCyIs.mergeProps)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}

});
parcelRegister("iOLGl", function(module, exports) {

$parcel$export(module.exports, "useOverlayPosition", function () { return $db31e22122d8b8cc$export$d39e1813b3bdd0e1; });
$parcel$export(module.exports, "useOverlay", function () { return $db31e22122d8b8cc$export$ea8f71083e90600f; });
$parcel$export(module.exports, "useOverlayTrigger", function () { return $db31e22122d8b8cc$export$f9d5c8beee7d008d; });
$parcel$export(module.exports, "OverlayContainer", function () { return $db31e22122d8b8cc$export$b47c3594eab58386; });
$parcel$export(module.exports, "DismissButton", function () { return $db31e22122d8b8cc$export$2317d149ed6f78c4; });
$parcel$export(module.exports, "ariaHideOutside", function () { return $db31e22122d8b8cc$export$1c3ebcada18427bf; });
$parcel$export(module.exports, "Overlay", function () { return $db31e22122d8b8cc$export$c6fdb837b070b4ff; });

var $ltyGu = parcelRequire("ltyGu");

var $a70hM = parcelRequire("a70hM");

var $1Aoqm = parcelRequire("1Aoqm");

var $lJJZV = parcelRequire("lJJZV");

var $cgSB4 = parcelRequire("cgSB4");

var $Hjwxh = parcelRequire("Hjwxh");

var $eS2gy = parcelRequire("eS2gy");

var $fdZ1G = parcelRequire("fdZ1G");

var $fug7d = parcelRequire("fug7d");

var $032Tj = parcelRequire("032Tj");

var $1TWoG = parcelRequire("1TWoG");

var $9B3Xx = parcelRequire("9B3Xx");

var $g8Xt7 = parcelRequire("g8Xt7");

var $1Jgrr = parcelRequire("1Jgrr");

var $kjpTk = parcelRequire("kjpTk");

var $dNjkw = parcelRequire("dNjkw");

var $cvI7y = parcelRequire("cvI7y");

var $S5NNm = parcelRequire("S5NNm");

var $5Y2Ik = parcelRequire("5Y2Ik");

var $e0XcG = parcelRequire("e0XcG");

var $dB7dZ = parcelRequire("dB7dZ");

var $fAgvy = parcelRequire("fAgvy");

var $8SQ8M = parcelRequire("8SQ8M");

var $kfQW5 = parcelRequire("kfQW5");

var $1umob = parcelRequire("1umob");

var $3Rp9o = parcelRequire("3Rp9o");

var $i5efW = parcelRequire("i5efW");

var $jECpC = parcelRequire("jECpC");

var $fj4Eb = parcelRequire("fj4Eb");

var $5XItF = parcelRequire("5XItF");

var $gZmGG = parcelRequire("gZmGG");

var $cRLo6 = parcelRequire("cRLo6");

var $yBm23 = parcelRequire("yBm23");

var $6F2tz = parcelRequire("6F2tz");

var $bh6RR = parcelRequire("bh6RR");

var $i65Wu = parcelRequire("i65Wu");
var $7WB9r = parcelRequire("7WB9r");
var $l8CUu = parcelRequire("l8CUu");
var $kI2if = parcelRequire("kI2if");
var $dCyIs = parcelRequire("dCyIs");
var $43JEG = parcelRequire("43JEG");
var $bZ9ps = parcelRequire("bZ9ps");
var $1nsPC = parcelRequire("1nsPC");
var $2oc8v = parcelRequire("2oc8v");

var $dG3Oc = parcelRequire("dG3Oc");
var $atGLR = parcelRequire("atGLR");

var $gQknz = parcelRequire("gQknz");

var $k9VSu = parcelRequire("k9VSu");
var $gjydL = parcelRequire("gjydL");
var $hTeHH = parcelRequire("hTeHH");

var $6afFj = parcelRequire("6afFj");

var $2GhkT = parcelRequire("2GhkT");

var $6ykbp = parcelRequire("6ykbp");
function $db31e22122d8b8cc$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const $db31e22122d8b8cc$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const $db31e22122d8b8cc$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: "left",
    left: "top"
};
const $db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: "height",
    left: "width"
};
const $db31e22122d8b8cc$var$$edcf132a9284368a$var$TOTAL_SIZE = {
    width: "totalWidth",
    height: "totalHeight"
};
const $db31e22122d8b8cc$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    let isPinchZoomedIn = ($db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport === null || $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport.scale) > 1;
    if (containerNode.tagName === "BODY") {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport === null || $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport === null || $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if ($db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport) {
            top = $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport.offsetTop;
            left = $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport.offsetLeft;
        }
    } else {
        ({ width: width, height: height, top: top, left: left } = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $kI2if.isWebKit)() && (containerNode.tagName === "BODY" || containerNode.tagName === "HTML") && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        top = $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport.pageTop;
        left = $db31e22122d8b8cc$var$$edcf132a9284368a$var$visualViewport.pageLeft;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    let containerScroll = containerDimensions.scroll[axis];
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[$db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = boundaryDimensions.scroll[$db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS[axis]] + padding;
    let boundaryEndEdge = boundarySize + boundaryDimensions.scroll[$db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS[axis]] - padding;
    let startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[$db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS[axis]];
    let endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[$db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($db31e22122d8b8cc$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $db31e22122d8b8cc$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = $db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS[placement] || "right";
    let crossAxis = $db31e22122d8b8cc$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = "center";
    let size = $db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $db31e22122d8b8cc$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $db31e22122d8b8cc$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $db31e22122d8b8cc$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $7WB9r.clamp)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[$db31e22122d8b8cc$var$$edcf132a9284368a$var$TOTAL_SIZE[size]];
        position[$db31e22122d8b8cc$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
    const containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[$db31e22122d8b8cc$var$$edcf132a9284368a$var$TOTAL_SIZE.height];
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
    // used in computePosition.
    let overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - position.bottom - overlayHeight);
    let maxHeight = heightGrowthDirection !== "top" ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - overlayTop // this is the top of the overlay
     - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
    return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$db31e22122d8b8cc$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$db31e22122d8b8cc$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    let placementInfo = $db31e22122d8b8cc$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $db31e22122d8b8cc$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    let normalizedOffset = offset;
    let space = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $db31e22122d8b8cc$var$$edcf132a9284368a$var$parsePlacement(`${$db31e22122d8b8cc$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $db31e22122d8b8cc$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        let flippedSpace = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = "bottom";
    if (placementInfo.axis === "top") {
        if (placementInfo.placement === "top") heightGrowthDirection = "top";
        else if (placementInfo.placement === "bottom") heightGrowthDirection = "bottom";
    } else if (placementInfo.crossAxis === "top") {
        if (placementInfo.crossPlacement === "top") heightGrowthDirection = "bottom";
        else if (placementInfo.crossPlacement === "bottom") heightGrowthDirection = "top";
    }
    let delta = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $db31e22122d8b8cc$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    let preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - overlaySize[crossAxis];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    const arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] - overlaySize[crossAxis] + arrowSize / 2;
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - overlaySize[crossAxis] - arrowSize / 2;
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $7WB9r.clamp)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $7WB9r.clamp)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = opts;
    let container = overlayNode instanceof HTMLElement ? $db31e22122d8b8cc$var$$edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isViewportContainer ? $db31e22122d8b8cc$var$$edcf132a9284368a$var$getOffset(targetNode) : $db31e22122d8b8cc$var$$edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getOffset(overlayNode);
    let margins = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerDimensions = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getContainerDimensions(container);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? $db31e22122d8b8cc$var$$edcf132a9284368a$var$getOffset(container) : $db31e22122d8b8cc$var$$edcf132a9284368a$var$getPosition(container, boundaryElement);
    if (container.tagName === "HTML" && boundaryElement.tagName === "BODY") {
        containerDimensions.scroll.top = 0;
        containerDimensions.scroll.left = 0;
    }
    return $db31e22122d8b8cc$var$$edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getOffset(node) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === "fixed") {
        let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getOffset(node);
        let parentOffset = $db31e22122d8b8cc$var$$edcf132a9284368a$var$getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === "static" && !$db31e22122d8b8cc$var$$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$db31e22122d8b8cc$var$$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $db31e22122d8b8cc$var$$edcf132a9284368a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== "none" || /transform|perspective/.test(style.willChange) || style.filter !== "none" || style.contain === "paint" || // @ts-ignore
    "backdropFilter" in style && style.backdropFilter !== "none" || // @ts-ignore
    "WebkitBackdropFilter" in style && style.WebkitBackdropFilter !== "none";
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $db31e22122d8b8cc$var$$dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $db31e22122d8b8cc$var$$dd149f63282afbbf$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $bh6RR.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $db31e22122d8b8cc$var$$dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}
// @ts-ignore
let $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $db31e22122d8b8cc$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $dG3Oc.useLocale)();
    let { arrowSize: arrowSize = 0, targetRef: targetRef, overlayRef: overlayRef, scrollRef: scrollRef = overlayRef, placement: placement = "bottom", containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== "undefined" ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, $bh6RR.useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, $bh6RR.useRef)($db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === null || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport.scale);
    (0, $bh6RR.useEffect)(()=>{
        if (isOpen) lastScale.current = $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === null || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, $bh6RR.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        if (($db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === null || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport.scale) !== lastScale.current) return;
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        if (!maxHeight && overlayRef.current) overlayRef.current.style.maxHeight = "none";
        let position = $db31e22122d8b8cc$var$$edcf132a9284368a$export$b3ceb0cbf1056d98({
            placement: $db31e22122d8b8cc$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        Object.keys(position.position).forEach((key)=>overlayRef.current.style[key] = position.position[key] + "px");
        overlayRef.current.style.maxHeight = position.maxHeight != null ? position.maxHeight + "px" : undefined;
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $1nsPC.useLayoutEffect)(updatePosition, deps);
    // Update position on window resize
    $db31e22122d8b8cc$var$$2a41e45df1593e64$var$useResize(updatePosition);
    (0, $2oc8v.useResizeObserver)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $bh6RR.useRef)(false);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === null || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === void 0 || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport.addEventListener("resize", onResize);
        $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === null || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === void 0 || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport.addEventListener("scroll", onScroll);
        return ()=>{
            $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === null || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === void 0 || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("resize", onResize);
            $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === null || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport === void 0 || $db31e22122d8b8cc$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("scroll", onScroll);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $bh6RR.useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    $db31e22122d8b8cc$var$$dd149f63282afbbf$export$18fc8428861184da({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            "aria-hidden": "true",
            role: "presentation",
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $db31e22122d8b8cc$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function $db31e22122d8b8cc$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $db31e22122d8b8cc$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    (0, $bh6RR.useEffect)(()=>{
        if (isOpen) $db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if ($db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays[$db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays[$db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays[$db31e22122d8b8cc$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $hTeHH.useInteractOutside)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $gjydL.useFocusWithin)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $gQknz.isElementInChildOfActiveScope)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $db31e22122d8b8cc$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $bh6RR.useEffect)(()=>{
        if (ref && ref.current) $db31e22122d8b8cc$var$$dd149f63282afbbf$export$f6211563215e3b37.set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, $43JEG.useId)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
const $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollCount = 0;
let $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$restore;
function $db31e22122d8b8cc$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (isDisabled) return;
        $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollCount++;
        if ($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollCount === 1) {
            if ((0, $kI2if.isIOS)()) $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$restore = $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$restore = $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollCount--;
            if ($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollCount === 0) $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    return (0, $i65Wu.chain)($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let restoreScrollableStyles;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, $l8CUu.getScrollParent)(e.target, true);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead.
        if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === "auto") restoreScrollableStyles = $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$setStyle(scrollable, "overscrollBehavior", "contain");
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            setupStyles();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
        if (restoreScrollableStyles) restoreScrollableStyles();
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            setupStyles();
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$visualViewport) {
                    if ($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // measure the correct position to scroll to.
                    $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$visualViewport.addEventListener("resize", ()=>$db31e22122d8b8cc$var$$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let restoreStyles = null;
    let setupStyles = ()=>{
        if (restoreStyles) return;
        let onWindowScroll = ()=>{
            // Last resort. If the window scrolled, scroll it back to the top.
            // It should always be at the top because the body will have a negative margin (see below).
            window.scrollTo(0, 0);
        };
        // Record the original scroll position so we can restore it.
        // Then apply a negative margin to the body to offset it by the scroll position. This will
        // enable us to scroll the window to the top, which is required for the rest of this to work.
        let scrollX = window.pageXOffset;
        let scrollY = window.pageYOffset;
        restoreStyles = (0, $i65Wu.chain)($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll), $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`), ()=>{
            window.scrollTo(scrollX, scrollY);
        });
        // Scroll to the top. The negative margin on the body will make this appear the same.
        window.scrollTo(0, 0);
    };
    let removeEvents = (0, $i65Wu.chain)($db31e22122d8b8cc$var$$49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreScrollableStyles === null || restoreScrollableStyles === void 0 || restoreScrollableStyles();
        restoreStyles === null || restoreStyles === void 0 || restoreStyles();
        removeEvents();
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $l8CUu.getScrollParent)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $db31e22122d8b8cc$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$db31e22122d8b8cc$var$$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $db31e22122d8b8cc$var$$f57aed4a881a3485$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $db31e22122d8b8cc$export$178405afcd8c5eb(props) {
    let { children: children } = props;
    let parent = (0, $bh6RR.useContext)($db31e22122d8b8cc$var$$f57aed4a881a3485$var$Context);
    let [modalCount, setModalCount] = (0, $bh6RR.useState)(0);
    let context = (0, $bh6RR.useMemo)(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($db31e22122d8b8cc$var$$f57aed4a881a3485$var$Context.Provider, {
        value: context
    }, children);
}
function $db31e22122d8b8cc$export$d9aaed4c3ece1bc0() {
    let context = (0, $bh6RR.useContext)($db31e22122d8b8cc$var$$f57aed4a881a3485$var$Context);
    return {
        modalProviderProps: {
            "aria-hidden": context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $db31e22122d8b8cc$var$$f57aed4a881a3485$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps } = $db31e22122d8b8cc$export$d9aaed4c3ece1bc0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function $db31e22122d8b8cc$export$bf688221f59024e5(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($db31e22122d8b8cc$export$178405afcd8c5eb, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($db31e22122d8b8cc$var$$f57aed4a881a3485$var$OverlayContainerDOM, props));
}
function $db31e22122d8b8cc$export$b47c3594eab58386(props) {
    let isSSR = (0, $2GhkT.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, ...rest } = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    let contents = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($db31e22122d8b8cc$export$bf688221f59024e5, rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).createPortal(contents, portalContainer);
}
function $db31e22122d8b8cc$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, $bh6RR.useContext)($db31e22122d8b8cc$var$$f57aed4a881a3485$var$Context);
    if (!context) throw new Error("Modal is not contained within a provider");
    (0, $bh6RR.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            "data-ismodal": !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $db31e22122d8b8cc$var$$a2f21f5f14f60553$exports = {};
$db31e22122d8b8cc$var$$a2f21f5f14f60553$exports = {
    "ar-AE": (0, $ltyGu.default),
    "bg-BG": (0, $a70hM.default),
    "cs-CZ": (0, $1Aoqm.default),
    "da-DK": (0, $lJJZV.default),
    "de-DE": (0, $cgSB4.default),
    "el-GR": (0, $Hjwxh.default),
    "en-US": (0, $eS2gy.default),
    "es-ES": (0, $fdZ1G.default),
    "et-EE": (0, $fug7d.default),
    "fi-FI": (0, $032Tj.default),
    "fr-FR": (0, $1TWoG.default),
    "he-IL": (0, $9B3Xx.default),
    "hr-HR": (0, $g8Xt7.default),
    "hu-HU": (0, $1Jgrr.default),
    "it-IT": (0, $kjpTk.default),
    "ja-JP": (0, $dNjkw.default),
    "ko-KR": (0, $cvI7y.default),
    "lt-LT": (0, $S5NNm.default),
    "lv-LV": (0, $5Y2Ik.default),
    "nb-NO": (0, $e0XcG.default),
    "nl-NL": (0, $dB7dZ.default),
    "pl-PL": (0, $fAgvy.default),
    "pt-BR": (0, $8SQ8M.default),
    "pt-PT": (0, $kfQW5.default),
    "ro-RO": (0, $1umob.default),
    "ru-RU": (0, $3Rp9o.default),
    "sk-SK": (0, $i5efW.default),
    "sl-SI": (0, $jECpC.default),
    "sr-SP": (0, $fj4Eb.default),
    "sv-SE": (0, $5XItF.default),
    "tr-TR": (0, $gZmGG.default),
    "uk-UA": (0, $cRLo6.default),
    "zh-CN": (0, $yBm23.default),
    "zh-TW": (0, $6F2tz.default)
};
function $db31e22122d8b8cc$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $atGLR.useLocalizedStringFormatter)(/*@__PURE__*/ $db31e22122d8b8cc$var$$parcel$interopDefault($db31e22122d8b8cc$var$$a2f21f5f14f60553$exports), "@react-aria/overlays");
    let labels = (0, $bZ9ps.useLabels)(otherProps, stringFormatter.format("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6ykbp.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $db31e22122d8b8cc$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
let $db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack = [];
function $db31e22122d8b8cc$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $db31e22122d8b8cc$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $db31e22122d8b8cc$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.length) $db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack[$db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $db31e22122d8b8cc$var$$5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $db31e22122d8b8cc$var$$5e3802645cc19319$var$refCountMap.delete(node);
            } else $db31e22122d8b8cc$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack[$db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.length - 1]) {
            $db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.pop();
            if ($db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.length) $db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack[$db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.splice($db31e22122d8b8cc$var$$5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $db31e22122d8b8cc$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef, popoverRef: popoverRef, isNonModal: isNonModal, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, ...otherProps } = props;
    let { overlayProps: overlayProps, underlayProps: underlayProps } = $db31e22122d8b8cc$export$ea8f71083e90600f({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, popoverRef);
    let { overlayProps: positionProps, arrowProps: arrowProps, placement: placement } = $db31e22122d8b8cc$export$d39e1813b3bdd0e1({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal ? state.close : null
    });
    $db31e22122d8b8cc$export$ee0f7cc6afcd1c18({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return $db31e22122d8b8cc$export$1c3ebcada18427bf([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, $dCyIs.mergeProps)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $db31e22122d8b8cc$var$$337b884510726a0d$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $db31e22122d8b8cc$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $2GhkT.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $bh6RR.useState)(false);
    let contextValue = (0, $bh6RR.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $gQknz.FocusScope), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($db31e22122d8b8cc$var$$337b884510726a0d$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $k9VSu.ClearPressResponder), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).createPortal(contents, portalContainer);
}
function $db31e22122d8b8cc$export$14c98a7594375490() {
    let ctx = (0, $bh6RR.useContext)($db31e22122d8b8cc$var$$337b884510726a0d$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $1nsPC.useLayoutEffect)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}
function $db31e22122d8b8cc$export$dbc0f175b25fb0fb(props, state, ref) {
    let { overlayProps: overlayProps, underlayProps: underlayProps } = $db31e22122d8b8cc$export$ea8f71083e90600f({
        ...props,
        isOpen: state.isOpen,
        onClose: state.close
    }, ref);
    $db31e22122d8b8cc$export$ee0f7cc6afcd1c18({
        isDisabled: !state.isOpen
    });
    $db31e22122d8b8cc$export$14c98a7594375490();
    (0, $bh6RR.useEffect)(()=>{
        if (state.isOpen) return $db31e22122d8b8cc$export$1c3ebcada18427bf([
            ref.current
        ]);
    }, [
        state.isOpen,
        ref
    ]);
    return {
        modalProps: (0, $dCyIs.mergeProps)(overlayProps),
        underlayProps: underlayProps
    };
}

});
parcelRegister("ltyGu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2735f7ba3a862e$export$2e2bcd8739ae039; });
var $fa2735f7ba3a862e$export$2e2bcd8739ae039 = {};
$fa2735f7ba3a862e$export$2e2bcd8739ae039 = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};

});

parcelRegister("a70hM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75cac796c4fc4d11$export$2e2bcd8739ae039; });
var $75cac796c4fc4d11$export$2e2bcd8739ae039 = {};
$75cac796c4fc4d11$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};

});

parcelRegister("1Aoqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $127c19631c24f84e$export$2e2bcd8739ae039; });
var $127c19631c24f84e$export$2e2bcd8739ae039 = {};
$127c19631c24f84e$export$2e2bcd8739ae039 = {
    "dismiss": `Odstranit`
};

});

parcelRegister("lJJZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd317b20e7442eb3$export$2e2bcd8739ae039; });
var $fd317b20e7442eb3$export$2e2bcd8739ae039 = {};
$fd317b20e7442eb3$export$2e2bcd8739ae039 = {
    "dismiss": `Luk`
};

});

parcelRegister("cgSB4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ef1547d081b51ea$export$2e2bcd8739ae039; });
var $8ef1547d081b51ea$export$2e2bcd8739ae039 = {};
$8ef1547d081b51ea$export$2e2bcd8739ae039 = {
    "dismiss": `Schlie\xdfen`
};

});

parcelRegister("Hjwxh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08232947e6af02fb$export$2e2bcd8739ae039; });
var $08232947e6af02fb$export$2e2bcd8739ae039 = {};
$08232947e6af02fb$export$2e2bcd8739ae039 = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};

});

parcelRegister("eS2gy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad37ddd4f37b170d$export$2e2bcd8739ae039; });
var $ad37ddd4f37b170d$export$2e2bcd8739ae039 = {};
$ad37ddd4f37b170d$export$2e2bcd8739ae039 = {
    "dismiss": `Dismiss`
};

});

parcelRegister("fdZ1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1576870653d2c6a$export$2e2bcd8739ae039; });
var $b1576870653d2c6a$export$2e2bcd8739ae039 = {};
$b1576870653d2c6a$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("fug7d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b466288e6b17569b$export$2e2bcd8739ae039; });
var $b466288e6b17569b$export$2e2bcd8739ae039 = {};
$b466288e6b17569b$export$2e2bcd8739ae039 = {
    "dismiss": `L\xf5peta`
};

});

parcelRegister("032Tj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $009286122b167002$export$2e2bcd8739ae039; });
var $009286122b167002$export$2e2bcd8739ae039 = {};
$009286122b167002$export$2e2bcd8739ae039 = {
    "dismiss": `Hylk\xe4\xe4`
};

});

parcelRegister("1TWoG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $162839f49ccc3266$export$2e2bcd8739ae039; });
var $162839f49ccc3266$export$2e2bcd8739ae039 = {};
$162839f49ccc3266$export$2e2bcd8739ae039 = {
    "dismiss": `Rejeter`
};

});

parcelRegister("9B3Xx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fcaa401a9742393$export$2e2bcd8739ae039; });
var $6fcaa401a9742393$export$2e2bcd8739ae039 = {};
$6fcaa401a9742393$export$2e2bcd8739ae039 = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};

});

parcelRegister("g8Xt7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc0b85ef97b9d1ff$export$2e2bcd8739ae039; });
var $bc0b85ef97b9d1ff$export$2e2bcd8739ae039 = {};
$bc0b85ef97b9d1ff$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("1Jgrr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1426bf5a13b22fc2$export$2e2bcd8739ae039; });
var $1426bf5a13b22fc2$export$2e2bcd8739ae039 = {};
$1426bf5a13b22fc2$export$2e2bcd8739ae039 = {
    "dismiss": `Elutas\xedt\xe1s`
};

});

parcelRegister("kjpTk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec99aa7905d09a3f$export$2e2bcd8739ae039; });
var $ec99aa7905d09a3f$export$2e2bcd8739ae039 = {};
$ec99aa7905d09a3f$export$2e2bcd8739ae039 = {
    "dismiss": `Ignora`
};

});

parcelRegister("dNjkw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0aed88439d71d98$export$2e2bcd8739ae039; });
var $a0aed88439d71d98$export$2e2bcd8739ae039 = {};
$a0aed88439d71d98$export$2e2bcd8739ae039 = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};

});

parcelRegister("cvI7y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ba9abe467c7246$export$2e2bcd8739ae039; });
var $91ba9abe467c7246$export$2e2bcd8739ae039 = {};
$91ba9abe467c7246$export$2e2bcd8739ae039 = {
    "dismiss": `\u{BB34}\u{C2DC}`
};

});

parcelRegister("S5NNm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a298b7224685e4e$export$2e2bcd8739ae039; });
var $0a298b7224685e4e$export$2e2bcd8739ae039 = {};
$0a298b7224685e4e$export$2e2bcd8739ae039 = {
    "dismiss": `Atmesti`
};

});

parcelRegister("5Y2Ik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4584a94eb988a0ba$export$2e2bcd8739ae039; });
var $4584a94eb988a0ba$export$2e2bcd8739ae039 = {};
$4584a94eb988a0ba$export$2e2bcd8739ae039 = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};

});

parcelRegister("e0XcG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33efd65ae1c5a2a$export$2e2bcd8739ae039; });
var $a33efd65ae1c5a2a$export$2e2bcd8739ae039 = {};
$a33efd65ae1c5a2a$export$2e2bcd8739ae039 = {
    "dismiss": `Lukk`
};

});

parcelRegister("dB7dZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e6455b833503f3f$export$2e2bcd8739ae039; });
var $9e6455b833503f3f$export$2e2bcd8739ae039 = {};
$9e6455b833503f3f$export$2e2bcd8739ae039 = {
    "dismiss": `Negeren`
};

});

parcelRegister("fAgvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b58705ed45e539ec$export$2e2bcd8739ae039; });
var $b58705ed45e539ec$export$2e2bcd8739ae039 = {};
$b58705ed45e539ec$export$2e2bcd8739ae039 = {
    "dismiss": `Zignoruj`
};

});

parcelRegister("8SQ8M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $677bcfe46cc2e29b$export$2e2bcd8739ae039; });
var $677bcfe46cc2e29b$export$2e2bcd8739ae039 = {};
$677bcfe46cc2e29b$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("kfQW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebee4558f5b097b4$export$2e2bcd8739ae039; });
var $ebee4558f5b097b4$export$2e2bcd8739ae039 = {};
$ebee4558f5b097b4$export$2e2bcd8739ae039 = {
    "dismiss": `Dispensar`
};

});

parcelRegister("1umob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1159f5cdcaf3941e$export$2e2bcd8739ae039; });
var $1159f5cdcaf3941e$export$2e2bcd8739ae039 = {};
$1159f5cdcaf3941e$export$2e2bcd8739ae039 = {
    "dismiss": `Revocare`
};

});

parcelRegister("3Rp9o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cf9d4b7996a212d$export$2e2bcd8739ae039; });
var $2cf9d4b7996a212d$export$2e2bcd8739ae039 = {};
$2cf9d4b7996a212d$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};

});

parcelRegister("i5efW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2a3c09b4528f490$export$2e2bcd8739ae039; });
var $d2a3c09b4528f490$export$2e2bcd8739ae039 = {};
$d2a3c09b4528f490$export$2e2bcd8739ae039 = {
    "dismiss": `Zru\u{161}i\u{165}`
};

});

parcelRegister("jECpC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4ef8c9e65ff11bd$export$2e2bcd8739ae039; });
var $e4ef8c9e65ff11bd$export$2e2bcd8739ae039 = {};
$e4ef8c9e65ff11bd$export$2e2bcd8739ae039 = {
    "dismiss": `Opusti`
};

});

parcelRegister("fj4Eb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b24c3c3524fde931$export$2e2bcd8739ae039; });
var $b24c3c3524fde931$export$2e2bcd8739ae039 = {};
$b24c3c3524fde931$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("5XItF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4574f6bc2674cd2a$export$2e2bcd8739ae039; });
var $4574f6bc2674cd2a$export$2e2bcd8739ae039 = {};
$4574f6bc2674cd2a$export$2e2bcd8739ae039 = {
    "dismiss": `Avvisa`
};

});

parcelRegister("gZmGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5e3f11ebeef1dfd$export$2e2bcd8739ae039; });
var $c5e3f11ebeef1dfd$export$2e2bcd8739ae039 = {};
$c5e3f11ebeef1dfd$export$2e2bcd8739ae039 = {
    "dismiss": `Kapat`
};

});

parcelRegister("cRLo6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95df317c851e33d8$export$2e2bcd8739ae039; });
var $95df317c851e33d8$export$2e2bcd8739ae039 = {};
$95df317c851e33d8$export$2e2bcd8739ae039 = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};

});

parcelRegister("yBm23", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $068026e354a111ba$export$2e2bcd8739ae039; });
var $068026e354a111ba$export$2e2bcd8739ae039 = {};
$068026e354a111ba$export$2e2bcd8739ae039 = {
    "dismiss": `\u{53D6}\u{6D88}`
};

});

parcelRegister("6F2tz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d987e1922db2949$export$2e2bcd8739ae039; });
var $4d987e1922db2949$export$2e2bcd8739ae039 = {};
$4d987e1922db2949$export$2e2bcd8739ae039 = {
    "dismiss": `\u{95DC}\u{9589}`
};

});

parcelRegister("7WB9r", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $5c8ac4a99f76b540$export$7d15b64cf5a3a4c4; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $5c8ac4a99f76b540$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $5c8ac4a99f76b540$export$e1a7b8e69ef6c52f(value, step) {
    let roundedValue = value;
    let stepString = step.toString();
    let pointIndex = stepString.indexOf(".");
    let precision = pointIndex >= 0 ? stepString.length - pointIndex : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $5c8ac4a99f76b540$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = $5c8ac4a99f76b540$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($5c8ac4a99f76b540$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($5c8ac4a99f76b540$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $5c8ac4a99f76b540$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $5c8ac4a99f76b540$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});

parcelRegister("l8CUu", function(module, exports) {

$parcel$export(module.exports, "getScrollParent", function () { return $f638871313a615ba$export$cfa2225e87938781; });

var $eiwoe = parcelRequire("eiwoe");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f638871313a615ba$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $eiwoe.isScrollable)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $eiwoe.isScrollable)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}

});

parcelRegister("2oc8v", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", function () { return $1bd73ca529c3fe1d$export$683480f191c0e3ea; });

var $bh6RR = parcelRequire("bh6RR");
function $1bd73ca529c3fe1d$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $1bd73ca529c3fe1d$export$683480f191c0e3ea(options) {
    const { ref: ref, onResize: onResize } = options;
    (0, $bh6RR.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$1bd73ca529c3fe1d$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}

});

parcelRegister("atGLR", function(module, exports) {

$parcel$export(module.exports, "useLocalizedStringFormatter", function () { return $7a0dca42a88f9a36$export$f12b703ca79dfbb1; });

var $dG3Oc = parcelRequire("dG3Oc");

var $aO9ah = parcelRequire("aO9ah");
var $8Il4O = parcelRequire("8Il4O");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7a0dca42a88f9a36$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $7a0dca42a88f9a36$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $7a0dca42a88f9a36$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $aO9ah.LocalizedStringDictionary)(strings);
        $7a0dca42a88f9a36$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $7a0dca42a88f9a36$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $aO9ah.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || $7a0dca42a88f9a36$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $7a0dca42a88f9a36$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $dG3Oc.useLocale)();
    let dictionary = $7a0dca42a88f9a36$export$87b761675e8eaa10(strings, packageName);
    return (0, $bh6RR.useMemo)(()=>new (0, $8Il4O.LocalizedStringFormatter)(locale, dictionary), [
        locale,
        dictionary
    ]);
}

});
parcelRegister("aO9ah", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringDictionary", function () { return $7de5aed68385a760$export$c17fa47878dc55b6; });
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7de5aed68385a760$var$$5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
const $7de5aed68385a760$var$$5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
let $7de5aed68385a760$var$$5b160d28a433310d$var$cachedGlobalStrings = undefined;
class $7de5aed68385a760$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $7de5aed68385a760$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === "undefined") return null;
        let locale = window[$7de5aed68385a760$var$$5b160d28a433310d$var$localeSymbol];
        if ($7de5aed68385a760$var$$5b160d28a433310d$var$cachedGlobalStrings === undefined) {
            let globalStrings = window[$7de5aed68385a760$var$$5b160d28a433310d$var$stringsSymbol];
            if (!globalStrings) return null;
            $7de5aed68385a760$var$$5b160d28a433310d$var$cachedGlobalStrings = {};
            for(let pkg in globalStrings)$7de5aed68385a760$var$$5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $7de5aed68385a760$export$c17fa47878dc55b6({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = $7de5aed68385a760$var$$5b160d28a433310d$var$cachedGlobalStrings === null || $7de5aed68385a760$var$$5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $7de5aed68385a760$var$$5b160d28a433310d$var$cachedGlobalStrings[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(([, v])=>v));
        this.defaultLocale = defaultLocale;
    }
}
function $7de5aed68385a760$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $7de5aed68385a760$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $7de5aed68385a760$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}

});

parcelRegister("8Il4O", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringFormatter", function () { return $6582c82614f54693$export$2f817fcdc4b89ae0; });
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6582c82614f54693$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
const $6582c82614f54693$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
class $6582c82614f54693$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = $6582c82614f54693$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $6582c82614f54693$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = $6582c82614f54693$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $6582c82614f54693$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}

});


parcelRegister("gQknz", function(module, exports) {

$parcel$export(module.exports, "FocusScope", function () { return $c4314f8e4bd4d73f$export$20e40289641fbbb6; });
$parcel$export(module.exports, "isElementInChildOfActiveScope", function () { return $c4314f8e4bd4d73f$export$1258395f99bf9cbf; });

var $1z5YQ = parcelRequire("1z5YQ");

var $lcawj = parcelRequire("lcawj");

var $ld26B = parcelRequire("ld26B");
var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
let $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = null;
function $c4314f8e4bd4d73f$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $bh6RR.useRef)(null);
    let endRef = (0, $bh6RR.useRef)(null);
    let scopeRef = (0, $bh6RR.useRef)([]);
    let { parentNode: parentNode } = (0, $bh6RR.useContext)($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $bh6RR.useMemo)(()=>new $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $c4314f8e4bd4d73f$export$d06fae2ee68b101e.root;
        if ($c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope && !$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isAncestorScope($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $c4314f8e4bd4d73f$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let node = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        const activeElement = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $c4314f8e4bd4d73f$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope || $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(parentScope))) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $c4314f8e4bd4d73f$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $bh6RR.useMemo)(()=>$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $bh6RR.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $c4314f8e4bd4d73f$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $c4314f8e4bd4d73f$export$4c063cf1350e6fed(element) {
    return element.matches($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $bh6RR.useRef)();
    let raf = (0, $bh6RR.useRef)();
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope || $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isAncestorScope($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope.current) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusFirstInScope($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope.current) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusFirstInScope($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $c4314f8e4bd4d73f$export$d06fae2ee68b101e.traverse($c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $c4314f8e4bd4d73f$export$1258395f99bf9cbf(element) {
    return $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInChildScope(element, $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope);
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $1z5YQ.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $bh6RR.useRef)(typeof document !== "undefined" ? (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope || $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isAncestorScope($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $c4314f8e4bd4d73f$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $c4314f8e4bd4d73f$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $ld26B.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $lcawj.isElementVisible)(node) && (!scope || $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $c4314f8e4bd4d73f$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$last(walker);
                if (next) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $c4314f8e4bd4d73f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$last(walker);
            if (next) $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $c4314f8e4bd4d73f$export$d06fae2ee68b101e = new $c4314f8e4bd4d73f$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("1z5YQ", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $123db2e5625549e8$export$80f3e147d781571c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $dVohB = parcelRequire("dVohB");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $123db2e5625549e8$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $dVohB.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}

});
parcelRegister("dVohB", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $a2336f4d9356ba5d$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality = null;
let $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $a2336f4d9356ba5d$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $a2336f4d9356ba5d$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $a2336f4d9356ba5d$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$a2336f4d9356ba5d$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $a2336f4d9356ba5d$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $a2336f4d9356ba5d$export$d90243b58daecda7.delete(windowObject);
};
function $a2336f4d9356ba5d$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $a2336f4d9356ba5d$export$2f1888112f558a7d();
function $a2336f4d9356ba5d$export$b9b3dfddab17db27() {
    return $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $a2336f4d9356ba5d$export$630ff653c5ada6a9() {
    return $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality;
}
function $a2336f4d9356ba5d$export$8397ddfc504fdb9a(modality) {
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality = modality;
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $a2336f4d9356ba5d$export$98e20ec92f614cfe() {
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$currentModality);
        };
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $a2336f4d9356ba5d$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $a2336f4d9356ba5d$export$b9b3dfddab17db27());
    $a2336f4d9356ba5d$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $a2336f4d9356ba5d$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($a2336f4d9356ba5d$export$b9b3dfddab17db27());
        };
        $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $a2336f4d9356ba5d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("lcawj", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $f6e2e1097d66bdf4$export$e989c0fffaa6b27a; });

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f6e2e1097d66bdf4$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $f6e2e1097d66bdf4$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $f6e2e1097d66bdf4$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $f6e2e1097d66bdf4$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $f6e2e1097d66bdf4$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $f6e2e1097d66bdf4$export$e989c0fffaa6b27a(element.parentElement, element));
}

});


parcelRegister("k9VSu", function(module, exports) {

$parcel$export(module.exports, "ClearPressResponder", function () { return $ead18b3cc9802fa2$export$cf75428e0b9ed1ea; });

var $450BF = parcelRequire("450BF");

var $dCyIs = parcelRequire("dCyIs");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ead18b3cc9802fa2$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $bh6RR.useRef)(false);
    let prevContext = (0, $bh6RR.useContext)((0, $450BF.PressResponderContext));
    ref = (0, $99EP5.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $dCyIs.mergeProps)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $2Cn0z.useSyncRef)(prevContext, ref);
    (0, $bh6RR.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $450BF.PressResponderContext).Provider, {
        value: context
    }, children);
});
function $ead18b3cc9802fa2$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $bh6RR.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $450BF.PressResponderContext).Provider, {
        value: context
    }, children);
}

});
parcelRegister("450BF", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $2f88197f83c29373$export$5165eccb35aaadb5; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2f88197f83c29373$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$2f88197f83c29373$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});


parcelRegister("gjydL", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $be08f7496f8ee4d1$export$420e68273165f4ec; });

var $7SRGW = parcelRequire("7SRGW");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $be08f7496f8ee4d1$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $bh6RR.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $bh6RR.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $7SRGW.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});
parcelRegister("7SRGW", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $5bd73994b6e5c8fb$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $5bd73994b6e5c8fb$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $5bd73994b6e5c8fb$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $5bd73994b6e5c8fb$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("hTeHH", function(module, exports) {

$parcel$export(module.exports, "useInteractOutside", function () { return $d062fa98759fbfe2$export$872b660ac5a1ff98; });

var $ld26B = parcelRequire("ld26B");
var $77fRS = parcelRequire("77fRS");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $d062fa98759fbfe2$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $bh6RR.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $77fRS.useEffectEvent)((e)=>{
        if (onInteractOutside && $d062fa98759fbfe2$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $77fRS.useEffectEvent)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $bh6RR.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $ld26B.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && $d062fa98759fbfe2$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $d062fa98759fbfe2$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $d062fa98759fbfe2$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $d062fa98759fbfe2$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}

});

parcelRegister("6ykbp", function(module, exports) {

$parcel$export(module.exports, "VisuallyHidden", function () { return $4c5592f9440f5548$export$439d29a4e110a164; });

var $dCyIs = parcelRequire("dCyIs");

var $bh6RR = parcelRequire("bh6RR");

var $gjydL = parcelRequire("gjydL");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4c5592f9440f5548$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function $4c5592f9440f5548$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $bh6RR.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $gjydL.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $bh6RR.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$4c5592f9440f5548$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $4c5592f9440f5548$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $4c5592f9440f5548$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = "div", isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $4c5592f9440f5548$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Element, (0, $dCyIs.mergeProps)(otherProps, visuallyHiddenProps), children);
}

});


parcelRegister("43CqS", function(module, exports) {

$parcel$export(module.exports, "ariaHideOutside", function () { return $ac7f6b0384aa9ae4$export$1c3ebcada18427bf; });
"use client";
// src/overlays/ariaHideOutside.ts
var $ac7f6b0384aa9ae4$var$refCountMap = /* @__PURE__ */ new WeakMap();
var $ac7f6b0384aa9ae4$var$observerStack = [];
function $ac7f6b0384aa9ae4$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = /* @__PURE__ */ new Set();
    let walk = (root2)=>{
        for (let element of root2.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            const parentElement = node.parentElement;
            if (visibleNodes.has(node) || hiddenNodes.has(parentElement) && parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root2, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        let acceptRoot = acceptNode(root2);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root2);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _a;
        let refCount = (_a = $ac7f6b0384aa9ae4$var$refCountMap.get(node)) != null ? _a : 0;
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $ac7f6b0384aa9ae4$var$refCountMap.set(node, refCount + 1);
    };
    if ($ac7f6b0384aa9ae4$var$observerStack.length) $ac7f6b0384aa9ae4$var$observerStack[$ac7f6b0384aa9ae4$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $ac7f6b0384aa9ae4$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $ac7f6b0384aa9ae4$var$refCountMap.get(node);
            if (count == null) continue;
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $ac7f6b0384aa9ae4$var$refCountMap.delete(node);
            } else $ac7f6b0384aa9ae4$var$refCountMap.set(node, count - 1);
        }
        if (observerWrapper === $ac7f6b0384aa9ae4$var$observerStack[$ac7f6b0384aa9ae4$var$observerStack.length - 1]) {
            $ac7f6b0384aa9ae4$var$observerStack.pop();
            if ($ac7f6b0384aa9ae4$var$observerStack.length) $ac7f6b0384aa9ae4$var$observerStack[$ac7f6b0384aa9ae4$var$observerStack.length - 1].observe();
        } else $ac7f6b0384aa9ae4$var$observerStack.splice($ac7f6b0384aa9ae4$var$observerStack.indexOf(observerWrapper), 1);
    };
}

});

parcelRegister("iGORm", function(module, exports) {

$parcel$export(module.exports, "ariaShouldCloseOnInteractOutside", function () { return $cc6e600d41a2cad9$export$ef74e55a94b62f23; });
"use client";
// src/overlays/ariaShouldCloseOnInteractOutside.ts
var $cc6e600d41a2cad9$export$ef74e55a94b62f23 = (element, ref, state, shouldFocus)=>{
    var _a, _b;
    let trigger = ref == null ? void 0 : ref.current;
    const clickOnUnderlay = ((_b = (_a = element == null ? void 0 : element.children) == null ? void 0 : _a[0]) == null ? void 0 : _b.getAttribute("role")) === "dialog";
    if (!trigger || !trigger.contains(element)) {
        if (shouldFocus) shouldFocus.current = false;
        if (!clickOnUnderlay) state.close();
    } else if (shouldFocus) shouldFocus.current = true;
    return clickOnUnderlay;
};

});

parcelRegister("aGkwu", function(module, exports) {

$parcel$export(module.exports, "getTransformOrigins", function () { return $2b766c0450279cb6$export$d0ca24f1cd6d5c41; });
$parcel$export(module.exports, "toReactAriaPlacement", function () { return $2b766c0450279cb6$export$94c1bd7c13567e02; });
$parcel$export(module.exports, "getShouldUseAxisPlacement", function () { return $2b766c0450279cb6$export$6f1fde9fd5d7ce61; });
$parcel$export(module.exports, "getArrowPlacement", function () { return $2b766c0450279cb6$export$98fe55eaa3d1484b; });
"use client";
// src/overlays/utils.ts
var $2b766c0450279cb6$export$d0ca24f1cd6d5c41 = (placement)=>{
    const origins = {
        top: {
            originY: 1
        },
        bottom: {
            originY: 0
        },
        left: {
            originX: 1
        },
        right: {
            originX: 0
        },
        "top-start": {
            originX: 0,
            originY: 1
        },
        "top-end": {
            originX: 1,
            originY: 1
        },
        "bottom-start": {
            originX: 0,
            originY: 0
        },
        "bottom-end": {
            originX: 1,
            originY: 0
        },
        "right-start": {
            originX: 0,
            originY: 0
        },
        "right-end": {
            originX: 0,
            originY: 1
        },
        "left-start": {
            originX: 1,
            originY: 0
        },
        "left-end": {
            originX: 1,
            originY: 1
        }
    };
    return (origins == null ? void 0 : origins[placement]) || {};
};
var $2b766c0450279cb6$export$94c1bd7c13567e02 = (placement)=>{
    const mapPositions = {
        top: "top",
        bottom: "bottom",
        left: "left",
        right: "right",
        "top-start": "top start",
        "top-end": "top end",
        "bottom-start": "bottom start",
        "bottom-end": "bottom end",
        "left-start": "left top",
        "left-end": "left bottom",
        "right-start": "right top",
        "right-end": "right bottom"
    };
    return mapPositions[placement];
};
var $2b766c0450279cb6$export$3d8d9aff18e3ce6 = (placement)=>{
    const mapPositions = {
        top: "top",
        bottom: "bottom",
        left: "left",
        right: "right",
        center: "top"
    };
    return mapPositions[placement];
};
var $2b766c0450279cb6$export$6f1fde9fd5d7ce61 = (axisPlacement, overlayPlacement)=>{
    if (overlayPlacement.includes("-")) {
        const [position] = overlayPlacement.split("-");
        if (position.includes(axisPlacement)) return false;
    }
    return true;
};
var $2b766c0450279cb6$export$98fe55eaa3d1484b = (dynamicPlacement, placement)=>{
    if (placement.includes("-")) {
        const [, position] = placement.split("-");
        return `${dynamicPlacement}-${position}`;
    }
    return dynamicPlacement;
};

});


parcelRegister("4lcRq", function(module, exports) {

$parcel$export(module.exports, "useOverlayTriggerState", function () { return $329319763d86bd09$export$61c6a8c84e605fb6; });

var $bh6RR = parcelRequire("bh6RR");

var $5qQ8f = parcelRequire("5qQ8f");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $329319763d86bd09$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $5qQ8f.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $bh6RR.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $bh6RR.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $bh6RR.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}

});
parcelRegister("5qQ8f", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $3f47d1cf4f5fd12b$export$40bfa8c7b0832715; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3f47d1cf4f5fd12b$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $bh6RR.useState)(value || defaultValue);
    let isControlledRef = (0, $bh6RR.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $bh6RR.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $bh6RR.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $3f47d1cf4f5fd12b$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $3f47d1cf4f5fd12b$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $3f47d1cf4f5fd12b$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});


parcelRegister("9y80h", function(module, exports) {

$parcel$export(module.exports, "popover", function () { return $c1aae37dae436d03$export$899efff2d0433d49; });

var $b2I1q = parcelRequire("b2I1q");

var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/popover.ts
var $c1aae37dae436d03$export$899efff2d0433d49 = (0, $6ujkL.tv)({
    slots: {
        base: [
            "z-0",
            "relative",
            "bg-transparent",
            "before:content-['']",
            "before:hidden",
            "before:z-[-1]",
            "before:absolute",
            "before:rotate-45",
            "before:w-2.5",
            "before:h-2.5",
            "before:rounded-sm",
            "data-[arrow=true]:before:block",
            "data-[placement=top]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top]:before:left-1/2",
            "data-[placement=top]:before:-translate-x-1/2",
            "data-[placement=top-start]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top-start]:before:left-3",
            "data-[placement=top-end]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top-end]:before:right-3",
            "data-[placement=bottom]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom]:before:left-1/2",
            "data-[placement=bottom]:before:-translate-x-1/2",
            "data-[placement=bottom-start]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom-start]:before:left-3",
            "data-[placement=bottom-end]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom-end]:before:right-3",
            "data-[placement=left]:before:-right-[calc(theme(spacing.5)/4_-_2px)]",
            "data-[placement=left]:before:top-1/2",
            "data-[placement=left]:before:-translate-y-1/2",
            "data-[placement=left-start]:before:-right-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=left-start]:before:top-1/4",
            "data-[placement=left-end]:before:-right-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=left-end]:before:bottom-1/4",
            "data-[placement=right]:before:-left-[calc(theme(spacing.5)/4_-_2px)]",
            "data-[placement=right]:before:top-1/2",
            "data-[placement=right]:before:-translate-y-1/2",
            "data-[placement=right-start]:before:-left-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=right-start]:before:top-1/4",
            "data-[placement=right-end]:before:-left-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=right-end]:before:bottom-1/4",
            ...(0, $g2NHD.dataFocusVisibleClasses)
        ],
        content: [
            "z-10",
            "px-2.5",
            "py-1",
            "w-full",
            "inline-flex",
            "flex-col",
            "items-center",
            "justify-center",
            "box-border",
            "subpixel-antialiased",
            "outline-none",
            "box-border"
        ],
        trigger: [
            "z-10"
        ],
        backdrop: [
            "hidden"
        ],
        arrow: []
    },
    variants: {
        size: {
            sm: {
                content: "text-tiny"
            },
            md: {
                content: "text-small"
            },
            lg: {
                content: "text-medium"
            }
        },
        color: {
            default: {
                base: "before:bg-content1 before:shadow-small",
                content: "bg-content1"
            },
            foreground: {
                base: "before:bg-foreground",
                content: (0, $b2I1q.colorVariants).solid.foreground
            },
            primary: {
                base: "before:bg-primary",
                content: (0, $b2I1q.colorVariants).solid.primary
            },
            secondary: {
                base: "before:bg-secondary",
                content: (0, $b2I1q.colorVariants).solid.secondary
            },
            success: {
                base: "before:bg-success",
                content: (0, $b2I1q.colorVariants).solid.success
            },
            warning: {
                base: "before:bg-warning",
                content: (0, $b2I1q.colorVariants).solid.warning
            },
            danger: {
                base: "before:bg-danger",
                content: (0, $b2I1q.colorVariants).solid.danger
            }
        },
        radius: {
            none: {
                content: "rounded-none"
            },
            sm: {
                content: "rounded-small"
            },
            md: {
                content: "rounded-medium"
            },
            lg: {
                content: "rounded-large"
            },
            full: {
                content: "rounded-full"
            }
        },
        shadow: {
            sm: {
                content: "shadow-small"
            },
            md: {
                content: "shadow-medium"
            },
            lg: {
                content: "shadow-large"
            }
        },
        backdrop: {
            transparent: {},
            opaque: {
                backdrop: "bg-overlay/50 backdrop-opacity-disabled"
            },
            blur: {
                backdrop: "backdrop-blur-sm backdrop-saturate-150 bg-overlay/30"
            }
        },
        triggerScaleOnOpen: {
            true: {
                trigger: [
                    "aria-expanded:scale-[0.97]",
                    "aria-expanded:opacity-70",
                    "subpixel-antialiased"
                ]
            },
            false: {}
        },
        disableAnimation: {
            true: {
                base: "animate-none"
            }
        },
        isTriggerDisabled: {
            true: {
                trigger: "opacity-disabled pointer-events-none"
            },
            false: {}
        }
    },
    defaultVariants: {
        color: "default",
        radius: "lg",
        size: "md",
        shadow: "md",
        backdrop: "transparent",
        triggerScaleOnOpen: true
    },
    compoundVariants: [
        {
            backdrop: [
                "opaque",
                "blur"
            ],
            class: {
                backdrop: "block w-full h-full fixed inset-0 -z-30"
            }
        }
    ]
});

});

parcelRegister("8PomS", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", function () { return $66d5fd1d85274b77$export$c9058316764c140e; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $66d5fd1d85274b77$export$c9058316764c140e(...refs) {
    if (refs.length === 1) return refs[0];
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}

});

parcelRegister("5DJTk", function(module, exports) {

$parcel$export(module.exports, "useDialog", function () { return $41b4315aaa469fef$export$d55e7ee900f34e93; });

var $leZvJ = parcelRequire("leZvJ");
var $43JEG = parcelRequire("43JEG");

var $c6Ga3 = parcelRequire("c6Ga3");

var $bh6RR = parcelRequire("bh6RR");

var $6FIt0 = parcelRequire("6FIt0");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $41b4315aaa469fef$export$d55e7ee900f34e93(props, ref) {
    let { role: role = "dialog" } = props;
    let titleId = (0, $43JEG.useSlotId)();
    titleId = props["aria-label"] ? undefined : titleId;
    let isRefocusing = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $c6Ga3.focusSafely)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $c6Ga3.focusSafely)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $6FIt0.useOverlayFocusContain)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $leZvJ.filterDOMProps)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            "aria-labelledby": props["aria-labelledby"] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}

});
parcelRegister("c6Ga3", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $8d06bfeae51d0b12$export$80f3e147d781571c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $ip38u = parcelRequire("ip38u");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8d06bfeae51d0b12$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $ip38u.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}

});
parcelRegister("ip38u", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $d65cfe88df27b5b9$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality = null;
let $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $d65cfe88df27b5b9$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $d65cfe88df27b5b9$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $d65cfe88df27b5b9$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$d65cfe88df27b5b9$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $d65cfe88df27b5b9$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $d65cfe88df27b5b9$export$d90243b58daecda7.delete(windowObject);
};
function $d65cfe88df27b5b9$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $d65cfe88df27b5b9$export$2f1888112f558a7d();
function $d65cfe88df27b5b9$export$b9b3dfddab17db27() {
    return $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $d65cfe88df27b5b9$export$630ff653c5ada6a9() {
    return $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality;
}
function $d65cfe88df27b5b9$export$8397ddfc504fdb9a(modality) {
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality = modality;
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $d65cfe88df27b5b9$export$98e20ec92f614cfe() {
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$currentModality);
        };
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $d65cfe88df27b5b9$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $d65cfe88df27b5b9$export$b9b3dfddab17db27());
    $d65cfe88df27b5b9$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $d65cfe88df27b5b9$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($d65cfe88df27b5b9$export$b9b3dfddab17db27());
        };
        $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $d65cfe88df27b5b9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("6FIt0", function(module, exports) {

$parcel$export(module.exports, "useOverlayFocusContain", function () { return $4db9109321132036$export$14c98a7594375490; });

var $5l7oF = parcelRequire("5l7oF");

var $7nXnz = parcelRequire("7nXnz");

var $K7wXf = parcelRequire("K7wXf");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $2GhkT = parcelRequire("2GhkT");

var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4db9109321132036$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $4db9109321132036$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $2GhkT.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $bh6RR.useState)(false);
    let contextValue = (0, $bh6RR.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    let { getContainer: getContainer } = (0, $5l7oF.useUNSTABLE_PortalContext)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $K7wXf.FocusScope), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4db9109321132036$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7nXnz.ClearPressResponder), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).createPortal(contents, portalContainer);
}
function $4db9109321132036$export$14c98a7594375490() {
    let ctx = (0, $bh6RR.useContext)($4db9109321132036$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $1nsPC.useLayoutEffect)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}

});
parcelRegister("5l7oF", function(module, exports) {

$parcel$export(module.exports, "useUNSTABLE_PortalContext", function () { return $3e34a6c3d2451b35$export$574e9b0fb070c3b0; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3e34a6c3d2451b35$export$60d741e20e0aa309 = (0, $bh6RR.createContext)({});
function $3e34a6c3d2451b35$export$db995ea7163b4b67(props) {
    let { getContainer: getContainer } = props;
    let { getContainer: ctxGetContainer } = $3e34a6c3d2451b35$export$574e9b0fb070c3b0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($3e34a6c3d2451b35$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? null : getContainer !== null && getContainer !== void 0 ? getContainer : ctxGetContainer
        }
    }, props.children);
}
function $3e34a6c3d2451b35$export$574e9b0fb070c3b0() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($3e34a6c3d2451b35$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}

});

parcelRegister("7nXnz", function(module, exports) {

$parcel$export(module.exports, "ClearPressResponder", function () { return $5608bddea3e577b7$export$cf75428e0b9ed1ea; });

var $3WO0C = parcelRequire("3WO0C");

var $dCyIs = parcelRequire("dCyIs");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5608bddea3e577b7$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $bh6RR.useRef)(false);
    let prevContext = (0, $bh6RR.useContext)((0, $3WO0C.PressResponderContext));
    ref = (0, $99EP5.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $dCyIs.mergeProps)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $2Cn0z.useSyncRef)(prevContext, ref);
    (0, $bh6RR.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3WO0C.PressResponderContext).Provider, {
        value: context
    }, children);
});
function $5608bddea3e577b7$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $bh6RR.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3WO0C.PressResponderContext).Provider, {
        value: context
    }, children);
}

});
parcelRegister("3WO0C", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $2dfd949a900d922e$export$5165eccb35aaadb5; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2dfd949a900d922e$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$2dfd949a900d922e$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});


parcelRegister("K7wXf", function(module, exports) {

$parcel$export(module.exports, "FocusScope", function () { return $08aa2365d6d468d4$export$20e40289641fbbb6; });

var $c6Ga3 = parcelRequire("c6Ga3");

var $5yb5K = parcelRequire("5yb5K");

var $ld26B = parcelRequire("ld26B");
var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $08aa2365d6d468d4$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
let $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = null;
function $08aa2365d6d468d4$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $bh6RR.useRef)(null);
    let endRef = (0, $bh6RR.useRef)(null);
    let scopeRef = (0, $bh6RR.useRef)([]);
    let { parentNode: parentNode } = (0, $bh6RR.useContext)($08aa2365d6d468d4$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $bh6RR.useMemo)(()=>new $08aa2365d6d468d4$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $08aa2365d6d468d4$export$d06fae2ee68b101e.root;
        if ($08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope && !$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isAncestorScope($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $08aa2365d6d468d4$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let node = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        const activeElement = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $08aa2365d6d468d4$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope || $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(parentScope))) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $08aa2365d6d468d4$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $bh6RR.useMemo)(()=>$08aa2365d6d468d4$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $bh6RR.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($08aa2365d6d468d4$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $08aa2365d6d468d4$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($08aa2365d6d468d4$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $08aa2365d6d468d4$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $08aa2365d6d468d4$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $08aa2365d6d468d4$export$4c063cf1350e6fed(element) {
    return element.matches($08aa2365d6d468d4$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $bh6RR.useRef)();
    let raf = (0, $bh6RR.useRef)();
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope || $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isAncestorScope($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope.current) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusFirstInScope($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope.current) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusFirstInScope($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $08aa2365d6d468d4$export$d06fae2ee68b101e.traverse($08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $08aa2365d6d468d4$export$1258395f99bf9cbf(element) {
    return $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInChildScope(element, $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope);
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $c6Ga3.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $bh6RR.useRef)(typeof document !== "undefined" ? (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope || $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isAncestorScope($08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $08aa2365d6d468d4$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $08aa2365d6d468d4$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $08aa2365d6d468d4$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $08aa2365d6d468d4$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $08aa2365d6d468d4$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $ld26B.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $5yb5K.isElementVisible)(node) && (!scope || $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $08aa2365d6d468d4$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$last(walker);
                if (next) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $08aa2365d6d468d4$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $08aa2365d6d468d4$var$$9bf71ea28793e738$var$last(walker);
            if (next) $08aa2365d6d468d4$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $08aa2365d6d468d4$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $08aa2365d6d468d4$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $08aa2365d6d468d4$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $08aa2365d6d468d4$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $08aa2365d6d468d4$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $08aa2365d6d468d4$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $08aa2365d6d468d4$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $08aa2365d6d468d4$export$d06fae2ee68b101e = new $08aa2365d6d468d4$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("5yb5K", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $40a8bb524f774783$export$e989c0fffaa6b27a; });

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $40a8bb524f774783$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $40a8bb524f774783$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $40a8bb524f774783$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $40a8bb524f774783$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $40a8bb524f774783$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $40a8bb524f774783$export$e989c0fffaa6b27a(element.parentElement, element));
}

});






parcelRegister("6Owvw", function(module, exports) {

$parcel$export(module.exports, "popover_content_default", function () { return $839bcda99abfdce9$export$2a0d18fe44adc4b6; });

var $0l7yB = parcelRequire("0l7yB");

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");

var $iOLGl = parcelRequire("iOLGl");

var $6ujp5 = parcelRequire("6ujp5");

var $6Vrqz = parcelRequire("6Vrqz");
var $k87FL = parcelRequire("k87FL");
var $dqffP = parcelRequire("dqffP");

var $3Ez43 = parcelRequire("3Ez43");

var $aGkwu = parcelRequire("aGkwu");

var $ih19M = parcelRequire("ih19M");
"use client";
var $839bcda99abfdce9$var$PopoverContent = (0, $hN2BG.forwardRef)((props, _)=>{
    const { as: as, children: children, className: className, ...otherProps } = props;
    const { Component: OverlayComponent, isOpen: isOpen, placement: placement, backdrop: backdrop, motionProps: motionProps, titleProps: titleProps, disableAnimation: disableAnimation, shouldBlockScroll: shouldBlockScroll, getPopoverProps: getPopoverProps, getDialogProps: getDialogProps, getBackdropProps: getBackdropProps, getContentProps: getContentProps, isNonModal: isNonModal, onClose: onClose } = (0, $0l7yB.usePopoverContext)();
    const dialogProps = getDialogProps(otherProps);
    delete dialogProps.role;
    const Component = as || OverlayComponent || "div";
    const content = /* @__PURE__ */ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            !isNonModal && /* @__PURE__ */ (0, $ih19M.jsx)((0, $iOLGl.DismissButton), {
                onDismiss: onClose
            }),
            /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
                ...dialogProps,
                children: /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                    ...getContentProps({
                        className: className
                    }),
                    children: typeof children === "function" ? children(titleProps) : children
                })
            }),
            /* @__PURE__ */ (0, $ih19M.jsx)((0, $iOLGl.DismissButton), {
                onDismiss: onClose
            })
        ]
    });
    const backdropContent = (0, $bh6RR.useMemo)(()=>{
        if (backdrop === "transparent") return null;
        if (disableAnimation) return /* @__PURE__ */ (0, $ih19M.jsx)("div", {
            ...getBackdropProps()
        });
        return /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
            features: (0, $6Vrqz.domAnimation),
            children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $6ujp5.TRANSITION_VARIANTS).fade,
                ...getBackdropProps()
            })
        });
    }, [
        backdrop,
        disableAnimation,
        getBackdropProps
    ]);
    const RemoveScrollWrapper = (0, $bh6RR.useCallback)(({ children: children2 })=>{
        return /* @__PURE__ */ (0, $ih19M.jsx)((0, $3Ez43.default), {
            enabled: shouldBlockScroll && isOpen,
            removeScrollBar: false,
            children: children2
        });
    }, [
        shouldBlockScroll,
        isOpen
    ]);
    const contents = disableAnimation ? /* @__PURE__ */ (0, $ih19M.jsx)(RemoveScrollWrapper, {
        children: content
    }) : /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
        features: (0, $6Vrqz.domAnimation),
        children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).div, {
            animate: "enter",
            exit: "exit",
            initial: "initial",
            style: {
                ...(0, $aGkwu.getTransformOrigins)(placement === "center" ? "top" : placement)
            },
            variants: (0, $6ujp5.TRANSITION_VARIANTS).scaleSpringOpacity,
            ...motionProps,
            children: /* @__PURE__ */ (0, $ih19M.jsx)(RemoveScrollWrapper, {
                children: content
            })
        })
    });
    return /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
        ...getPopoverProps(),
        children: [
            backdropContent,
            contents
        ]
    });
});
$839bcda99abfdce9$var$PopoverContent.displayName = "NextUI.PopoverContent";
var $839bcda99abfdce9$export$2a0d18fe44adc4b6 = $839bcda99abfdce9$var$PopoverContent;

});
parcelRegister("3Ez43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a904e957609af53$export$2e2bcd8739ae039; });

var $l73V3 = parcelRequire("l73V3");

var $bh6RR = parcelRequire("bh6RR");

var $2pHrl = parcelRequire("2pHrl");

var $4nnXm = parcelRequire("4nnXm");
var $2a904e957609af53$var$ReactRemoveScroll = $bh6RR.forwardRef(function(props, ref) {
    return $bh6RR.createElement((0, $2pHrl.RemoveScroll), (0, $l73V3.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $4nnXm.default)
    }));
});
$2a904e957609af53$var$ReactRemoveScroll.classNames = (0, $2pHrl.RemoveScroll).classNames;
var $2a904e957609af53$export$2e2bcd8739ae039 = $2a904e957609af53$var$ReactRemoveScroll;

});
parcelRegister("l73V3", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $f5ed4ab2a4d1861b$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $f5ed4ab2a4d1861b$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $f5ed4ab2a4d1861b$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};

});

parcelRegister("2pHrl", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", function () { return $1c1f9cd94bee4822$export$22940b497e769dee; });

var $l73V3 = parcelRequire("l73V3");

var $bh6RR = parcelRequire("bh6RR");

var $iRt7j = parcelRequire("iRt7j");

var $7IBwo = parcelRequire("7IBwo");

var $2AJGY = parcelRequire("2AJGY");
var $1c1f9cd94bee4822$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $1c1f9cd94bee4822$export$22940b497e769dee = $bh6RR.forwardRef(function(props, parentRef) {
    var ref = $bh6RR.useRef(null);
    var _a = $bh6RR.useState({
        onScrollCapture: $1c1f9cd94bee4822$var$nothing,
        onWheelCapture: $1c1f9cd94bee4822$var$nothing,
        onTouchMoveCapture: $1c1f9cd94bee4822$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $l73V3.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $7IBwo.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, rest), callbacks);
    return $bh6RR.createElement($bh6RR.Fragment, null, enabled && $bh6RR.createElement(SideCar, {
        sideCar: (0, $2AJGY.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $bh6RR.cloneElement($bh6RR.Children.only(children), (0, $l73V3.__assign)((0, $l73V3.__assign)({}, containerProps), {
        ref: containerRef
    })) : $bh6RR.createElement(Container, (0, $l73V3.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$1c1f9cd94bee4822$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$1c1f9cd94bee4822$export$22940b497e769dee.classNames = {
    fullWidth: (0, $iRt7j.fullWidthClassName),
    zeroRight: (0, $iRt7j.zeroRightClassName)
};

});
parcelRegister("iRt7j", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", function () { return $dbb3c33b31cdcfb1$export$1da7500147d4bc3; });
$parcel$export(module.exports, "fullWidthClassName", function () { return $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e; });
$parcel$export(module.exports, "noScrollbarsClassName", function () { return $dbb3c33b31cdcfb1$export$bb813dfbbc432abc; });
$parcel$export(module.exports, "removedBarSizeVariable", function () { return $dbb3c33b31cdcfb1$export$63d0edf80fea83b1; });
var $dbb3c33b31cdcfb1$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $dbb3c33b31cdcfb1$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $dbb3c33b31cdcfb1$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $dbb3c33b31cdcfb1$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";

});

parcelRegister("7IBwo", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $59e9bf7262dc1a6d$export$74665b213cb5c4cf; });

var $bh6RR = parcelRequire("bh6RR");

var $biDT0 = parcelRequire("biDT0");

var $gdACW = parcelRequire("gdACW");
var $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $59e9bf7262dc1a6d$var$currentValues = new WeakMap();
function $59e9bf7262dc1a6d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $gdACW.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $biDT0.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $59e9bf7262dc1a6d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $59e9bf7262dc1a6d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $biDT0.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $biDT0.assignRef)(ref, current_1);
            });
        }
        $59e9bf7262dc1a6d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("biDT0", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $83a050b8f7e61fc1$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $83a050b8f7e61fc1$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("gdACW", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $bcea459d6fe13dac$export$25bec8c6f54ee79a; });

var $bh6RR = parcelRequire("bh6RR");
function $bcea459d6fe13dac$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $bh6RR.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("2AJGY", function(module, exports) {

$parcel$export(module.exports, "effectCar", function () { return $1e32631777ba14da$export$e27363444bedfeac; });

var $xpISY = parcelRequire("xpISY");
var $1e32631777ba14da$export$e27363444bedfeac = (0, $xpISY.createSidecarMedium)();

});
parcelRegister("xpISY", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", function () { return $0647093a1b1c5afc$export$e13ec7dd7a14088d; });

var $l73V3 = parcelRequire("l73V3");
function $0647093a1b1c5afc$var$ItoI(a) {
    return a;
}
function $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $0647093a1b1c5afc$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $0647093a1b1c5afc$var$ItoI;
    return $0647093a1b1c5afc$var$innerCreateMedium(defaults, middleware);
}
function $0647093a1b1c5afc$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $0647093a1b1c5afc$var$innerCreateMedium(null);
    medium.options = (0, $l73V3.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("4nnXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32fbe4a10a756a07$export$2e2bcd8739ae039; });

var $iOca9 = parcelRequire("iOca9");

var $0nIfl = parcelRequire("0nIfl");

var $2AJGY = parcelRequire("2AJGY");
var $32fbe4a10a756a07$export$2e2bcd8739ae039 = (0, $iOca9.exportSidecar)((0, $2AJGY.effectCar), (0, $0nIfl.RemoveScrollSideCar));

});
parcelRegister("iOca9", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", function () { return $db1654befbc8d676$export$6cacc8fb0a9b94ce; });

var $l73V3 = parcelRequire("l73V3");

var $bh6RR = parcelRequire("bh6RR");
var $db1654befbc8d676$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $l73V3.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $bh6RR.createElement(Target, (0, $l73V3.__assign)({}, rest));
};
$db1654befbc8d676$var$SideCar.isSideCarExport = true;
function $db1654befbc8d676$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $db1654befbc8d676$var$SideCar;
}

});

parcelRegister("0nIfl", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", function () { return $0012650a668228df$export$a09dbff87b5da2d; });

var $l73V3 = parcelRequire("l73V3");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("kJMsS");
var $dSV7u = parcelRequire("dSV7u");
parcelRequire("3lbqq");
var $chrXJ = parcelRequire("chrXJ");

var $gOqzg = parcelRequire("gOqzg");

var $fmu2N = parcelRequire("fmu2N");
var $0012650a668228df$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0012650a668228df$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0012650a668228df$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $0012650a668228df$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0012650a668228df$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0012650a668228df$var$idCounter = 0;
var $0012650a668228df$var$lockStack = [];
function $0012650a668228df$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $bh6RR.useRef([]);
    var touchStartRef = $bh6RR.useRef([
        0,
        0
    ]);
    var activeAxis = $bh6RR.useRef();
    var id = $bh6RR.useState($0012650a668228df$var$idCounter++)[0];
    var Style = $bh6RR.useState((0, $chrXJ.styleSingleton))[0];
    var lastProps = $bh6RR.useRef(props);
    $bh6RR.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $bh6RR.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $l73V3.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($0012650a668228df$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $bh6RR.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $0012650a668228df$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $fmu2N.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $fmu2N.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $fmu2N.handleScroll)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $bh6RR.useCallback(function(_event) {
        var event = _event;
        if (!$0012650a668228df$var$lockStack.length || $0012650a668228df$var$lockStack[$0012650a668228df$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $0012650a668228df$export$39efaa2ca254a28d(event) : $0012650a668228df$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $0012650a668228df$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0012650a668228df$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $bh6RR.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $0012650a668228df$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $bh6RR.useCallback(function(event) {
        touchStartRef.current = $0012650a668228df$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $bh6RR.useCallback(function(event) {
        shouldCancel(event.type, $0012650a668228df$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $bh6RR.useEffect(function() {
        $0012650a668228df$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $gOqzg.nonPassive));
        document.addEventListener("touchmove", shouldPrevent, (0, $gOqzg.nonPassive));
        document.addEventListener("touchstart", scrollTouchStart, (0, $gOqzg.nonPassive));
        return function() {
            $0012650a668228df$var$lockStack = $0012650a668228df$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $gOqzg.nonPassive));
            document.removeEventListener("touchmove", shouldPrevent, (0, $gOqzg.nonPassive));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $gOqzg.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $bh6RR.createElement($bh6RR.Fragment, null, inert ? $bh6RR.createElement(Style, {
        styles: $0012650a668228df$var$generateStyle(id)
    }) : null, removeScrollBar ? $bh6RR.createElement((0, $dSV7u.RemoveScrollBar), {
        gapMode: props.gapMode
    }) : null);
}
function $0012650a668228df$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

});
parcelRegister("kJMsS", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", function () { return (parcelRequire("dSV7u")).RemoveScrollBar; });

var $dSV7u = parcelRequire("dSV7u");

var $iRt7j = parcelRequire("iRt7j");

var $gGdXj = parcelRequire("gGdXj");

});
parcelRegister("dSV7u", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", function () { return $a1bca04d3c994e31$export$9aa43b459c5ae9b9; });

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("3lbqq");
var $chrXJ = parcelRequire("chrXJ");

var $iRt7j = parcelRequire("iRt7j");

var $gGdXj = parcelRequire("gGdXj");
var $a1bca04d3c994e31$var$Style = (0, $chrXJ.styleSingleton)();
var $a1bca04d3c994e31$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $a1bca04d3c994e31$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $iRt7j.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $iRt7j.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $iRt7j.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $iRt7j.zeroRightClassName), " .").concat((0, $iRt7j.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $iRt7j.fullWidthClassName), " .").concat((0, $iRt7j.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($a1bca04d3c994e31$export$65254d5f26cb9564, "] {\n    ").concat((0, $iRt7j.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $a1bca04d3c994e31$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($a1bca04d3c994e31$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $a1bca04d3c994e31$export$a1939b1f9f9b02dc = function() {
    $bh6RR.useEffect(function() {
        document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, ($a1bca04d3c994e31$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $a1bca04d3c994e31$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($a1bca04d3c994e31$export$65254d5f26cb9564);
            else document.body.setAttribute($a1bca04d3c994e31$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $a1bca04d3c994e31$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $a1bca04d3c994e31$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $bh6RR.useMemo(function() {
        return (0, $gGdXj.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $bh6RR.createElement($a1bca04d3c994e31$var$Style, {
        styles: $a1bca04d3c994e31$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};

});
parcelRegister("3lbqq", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", function () { return (parcelRequire("chrXJ")).styleSingleton; });

var $chrXJ = parcelRequire("chrXJ");

var $kgt1U = parcelRequire("kgt1U");

var $4R1Uh = parcelRequire("4R1Uh");

});
parcelRegister("chrXJ", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", function () { return $8f0cc34b8d78d287$export$c1248ee86ba532c8; });

var $4R1Uh = parcelRequire("4R1Uh");
var $8f0cc34b8d78d287$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $4R1Uh.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("4R1Uh", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", function () { return $388d9750a20580a4$export$7d7b35c2d250e94c; });

var $bh6RR = parcelRequire("bh6RR");

var $kgt1U = parcelRequire("kgt1U");
var $388d9750a20580a4$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $kgt1U.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $bh6RR.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("kgt1U", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", function () { return $ec0bd1fbc8093bb3$export$7c74eec858d5d226; });

var $gCRew = parcelRequire("gCRew");
function $ec0bd1fbc8093bb3$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $gCRew.getNonce)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $ec0bd1fbc8093bb3$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $ec0bd1fbc8093bb3$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $ec0bd1fbc8093bb3$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $ec0bd1fbc8093bb3$var$makeStyleTag()) {
                    $ec0bd1fbc8093bb3$var$injectStyles(stylesheet, style);
                    $ec0bd1fbc8093bb3$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("gCRew", function(module, exports) {

$parcel$export(module.exports, "getNonce", function () { return $c1a97cf4bee7a747$export$2b85b721e524d74b; });
var $c1a97cf4bee7a747$var$currentNonce;
var $c1a97cf4bee7a747$export$c5f670b24c0ae95a = function(nonce) {
    $c1a97cf4bee7a747$var$currentNonce = nonce;
};
var $c1a97cf4bee7a747$export$2b85b721e524d74b = function() {
    if ($c1a97cf4bee7a747$var$currentNonce) return $c1a97cf4bee7a747$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("gGdXj", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", function () { return $c24b64e0e48f5c2b$export$75f2ca8f029c77f4; });
var $c24b64e0e48f5c2b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $c24b64e0e48f5c2b$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $c24b64e0e48f5c2b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $c24b64e0e48f5c2b$var$parse(left),
        $c24b64e0e48f5c2b$var$parse(top),
        $c24b64e0e48f5c2b$var$parse(right)
    ];
};
var $c24b64e0e48f5c2b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $c24b64e0e48f5c2b$export$efed13b5d0ca3386;
    var offsets = $c24b64e0e48f5c2b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("gOqzg", function(module, exports) {

$parcel$export(module.exports, "nonPassive", function () { return $c3d5eca92c5827bc$export$10a6e88623fa9454; });
var $c3d5eca92c5827bc$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $c3d5eca92c5827bc$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $c3d5eca92c5827bc$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
    // @ts-ignore
    window.removeEventListener("test", $c3d5eca92c5827bc$var$options, $c3d5eca92c5827bc$var$options);
} catch (err) {
    $c3d5eca92c5827bc$var$passiveSupported = false;
}
var $c3d5eca92c5827bc$export$10a6e88623fa9454 = $c3d5eca92c5827bc$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("fmu2N", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", function () { return $b2f037382e9b8811$export$9ec64480cae49817; });
$parcel$export(module.exports, "handleScroll", function () { return $b2f037382e9b8811$export$dde0441bd4a6ded8; });
var $b2f037382e9b8811$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $b2f037382e9b8811$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$b2f037382e9b8811$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $b2f037382e9b8811$var$elementCouldBeVScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowY");
};
var $b2f037382e9b8811$var$elementCouldBeHScrolled = function(node) {
    return $b2f037382e9b8811$var$elementCanBeScrolled(node, "overflowX");
};
var $b2f037382e9b8811$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $b2f037382e9b8811$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $b2f037382e9b8811$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $b2f037382e9b8811$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $b2f037382e9b8811$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $b2f037382e9b8811$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$elementCouldBeVScrolled(node) : $b2f037382e9b8811$var$elementCouldBeHScrolled(node);
};
var $b2f037382e9b8811$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $b2f037382e9b8811$var$getVScrollVariables(node) : $b2f037382e9b8811$var$getHScrollVariables(node);
};
var $b2f037382e9b8811$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $b2f037382e9b8811$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $b2f037382e9b8811$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $b2f037382e9b8811$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($b2f037382e9b8811$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});





parcelRegister("5HibV", function(module, exports) {

$parcel$export(module.exports, "popover_trigger_default", function () { return $67b8c2a931ce7ed8$export$251d96216457b64b; });

var $0l7yB = parcelRequire("0l7yB");

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");

var $1Oz2L = parcelRequire("1Oz2L");

var $1lwgY = parcelRequire("1lwgY");

var $1v1Xn = parcelRequire("1v1Xn");

var $dCyIs = parcelRequire("dCyIs");

var $ih19M = parcelRequire("ih19M");
"use client";
var $67b8c2a931ce7ed8$var$PopoverTrigger = (0, $hN2BG.forwardRef)((props, _)=>{
    const { triggerRef: triggerRef, getTriggerProps: getTriggerProps } = (0, $0l7yB.usePopoverContext)();
    const { children: children, ...otherProps } = props;
    const child = (0, $bh6RR.useMemo)(()=>{
        if (typeof children === "string") return /* @__PURE__ */ (0, $ih19M.jsx)("p", {
            children: children
        });
        return (0, $bh6RR.Children).only(children);
    }, [
        children
    ]);
    const { onPress: onPress, isDisabled: isDisabled, ...restProps } = (0, $bh6RR.useMemo)(()=>{
        return getTriggerProps((0, $dCyIs.mergeProps)(otherProps, child.props), child.ref);
    }, [
        getTriggerProps,
        child.props,
        otherProps,
        child.ref
    ]);
    const [, triggerChildren] = (0, $1Oz2L.pickChildren)(children, (0, $1v1Xn.button_default));
    const { buttonProps: buttonProps } = (0, $1lwgY.useAriaButton)({
        onPress: onPress,
        isDisabled: isDisabled
    }, triggerRef);
    const hasNextUIButton = (0, $bh6RR.useMemo)(()=>{
        return (triggerChildren == null ? void 0 : triggerChildren[0]) !== void 0;
    }, [
        triggerChildren
    ]);
    return (0, $bh6RR.cloneElement)(child, (0, $dCyIs.mergeProps)(restProps, hasNextUIButton ? {
        onPress: onPress,
        isDisabled: isDisabled
    } : buttonProps));
});
$67b8c2a931ce7ed8$var$PopoverTrigger.displayName = "NextUI.PopoverTrigger";
var $67b8c2a931ce7ed8$export$251d96216457b64b = $67b8c2a931ce7ed8$var$PopoverTrigger;

});
parcelRegister("1Oz2L", function(module, exports) {

$parcel$export(module.exports, "pickChildren", function () { return $feb2b61743be60c2$export$7d7d2f98282298f7; });

var $5MWec = parcelRequire("5MWec");

var $fmoXt = parcelRequire("fmoXt");
// src/children.ts
var $feb2b61743be60c2$var$import_react = (0, $fmoXt.__toESM)((0, $5MWec.require_react)());
function $feb2b61743be60c2$export$b2c43d7d050b2e63(children) {
    return $feb2b61743be60c2$var$import_react.Children.toArray(children).filter((child)=>(0, $feb2b61743be60c2$var$import_react.isValidElement)(child));
}
var $feb2b61743be60c2$export$7d7d2f98282298f7 = (children, targetChild)=>{
    var _a;
    let target = [];
    const withoutTargetChildren = (_a = $feb2b61743be60c2$var$import_react.Children.map(children, (item)=>{
        if (!(0, $feb2b61743be60c2$var$import_react.isValidElement)(item)) return item;
        if (item.type === targetChild) {
            target.push(item);
            return null;
        }
        return item;
    })) == null ? void 0 : _a.filter(Boolean);
    const targetChildren = target.length >= 0 ? target : void 0;
    return [
        withoutTargetChildren,
        targetChildren
    ];
};

});
parcelRegister("5MWec", function(module, exports) {

$parcel$export(module.exports, "require_react", function () { return $bd281d0293cbb34e$export$18dc0e75b6bbb2d3; });

var $fmoXt = parcelRequire("fmoXt");
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.production.min.js
var $bd281d0293cbb34e$var$require_react_production_min = (0, $fmoXt.__commonJS)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.production.min.js" (exports) {
        "use strict";
        var l = Symbol.for("react.element");
        var n = Symbol.for("react.portal");
        var p = Symbol.for("react.fragment");
        var q = Symbol.for("react.strict_mode");
        var r = Symbol.for("react.profiler");
        var t = Symbol.for("react.provider");
        var u = Symbol.for("react.context");
        var v = Symbol.for("react.forward_ref");
        var w = Symbol.for("react.suspense");
        var x = Symbol.for("react.memo");
        var y = Symbol.for("react.lazy");
        var z = Symbol.iterator;
        function A(a) {
            if (null === a || "object" !== typeof a) return null;
            a = z && a[z] || a["@@iterator"];
            return "function" === typeof a ? a : null;
        }
        var B = {
            isMounted: function() {
                return false;
            },
            enqueueForceUpdate: function() {},
            enqueueReplaceState: function() {},
            enqueueSetState: function() {}
        };
        var C = Object.assign;
        var D = {};
        function E(a, b, e) {
            this.props = a;
            this.context = b;
            this.refs = D;
            this.updater = e || B;
        }
        E.prototype.isReactComponent = {};
        E.prototype.setState = function(a, b) {
            if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
            this.updater.enqueueSetState(this, a, b, "setState");
        };
        E.prototype.forceUpdate = function(a) {
            this.updater.enqueueForceUpdate(this, a, "forceUpdate");
        };
        function F() {}
        F.prototype = E.prototype;
        function G(a, b, e) {
            this.props = a;
            this.context = b;
            this.refs = D;
            this.updater = e || B;
        }
        var H = G.prototype = new F();
        H.constructor = G;
        C(H, E.prototype);
        H.isPureReactComponent = true;
        var I = Array.isArray;
        var J = Object.prototype.hasOwnProperty;
        var K = {
            current: null
        };
        var L = {
            key: true,
            ref: true,
            __self: true,
            __source: true
        };
        function M(a, b, e) {
            var d, c = {}, k = null, h = null;
            if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
            var g = arguments.length - 2;
            if (1 === g) c.children = e;
            else if (1 < g) {
                for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
                c.children = f;
            }
            if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
            return {
                $$typeof: l,
                type: a,
                key: k,
                ref: h,
                props: c,
                _owner: K.current
            };
        }
        function N(a, b) {
            return {
                $$typeof: l,
                type: a.type,
                key: b,
                ref: a.ref,
                props: a.props,
                _owner: a._owner
            };
        }
        function O(a) {
            return "object" === typeof a && null !== a && a.$$typeof === l;
        }
        function escape(a) {
            var b = {
                "=": "=0",
                ":": "=2"
            };
            return "$" + a.replace(/[=:]/g, function(a2) {
                return b[a2];
            });
        }
        var P = /\/+/g;
        function Q(a, b) {
            return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
        }
        function R(a, b, e, d, c) {
            var k = typeof a;
            if ("undefined" === k || "boolean" === k) a = null;
            var h = false;
            if (null === a) h = true;
            else switch(k){
                case "string":
                case "number":
                    h = true;
                    break;
                case "object":
                    switch(a.$$typeof){
                        case l:
                        case n:
                            h = true;
                    }
            }
            if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a2) {
                return a2;
            })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
            h = 0;
            d = "" === d ? "." : d + ":";
            if (I(a)) for(var g = 0; g < a.length; g++){
                k = a[g];
                var f = d + Q(k, g);
                h += R(k, b, e, f, c);
            }
            else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
            else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
            return h;
        }
        function S(a, b, e) {
            if (null == a) return a;
            var d = [], c = 0;
            R(a, d, "", "", function(a2) {
                return b.call(e, a2, c++);
            });
            return d;
        }
        function T(a) {
            if (-1 === a._status) {
                var b = a._result;
                b = b();
                b.then(function(b2) {
                    if (0 === a._status || -1 === a._status) a._status = 1, a._result = b2;
                }, function(b2) {
                    if (0 === a._status || -1 === a._status) a._status = 2, a._result = b2;
                });
                -1 === a._status && (a._status = 0, a._result = b);
            }
            if (1 === a._status) return a._result.default;
            throw a._result;
        }
        var U = {
            current: null
        };
        var V = {
            transition: null
        };
        var W = {
            ReactCurrentDispatcher: U,
            ReactCurrentBatchConfig: V,
            ReactCurrentOwner: K
        };
        exports.Children = {
            map: S,
            forEach: function(a, b, e) {
                S(a, function() {
                    b.apply(this, arguments);
                }, e);
            },
            count: function(a) {
                var b = 0;
                S(a, function() {
                    b++;
                });
                return b;
            },
            toArray: function(a) {
                return S(a, function(a2) {
                    return a2;
                }) || [];
            },
            only: function(a) {
                if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
                return a;
            }
        };
        exports.Component = E;
        exports.Fragment = p;
        exports.Profiler = r;
        exports.PureComponent = G;
        exports.StrictMode = q;
        exports.Suspense = w;
        exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
        exports.cloneElement = function(a, b, e) {
            if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
            var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
            if (null != b) {
                void 0 !== b.ref && (k = b.ref, h = K.current);
                void 0 !== b.key && (c = "" + b.key);
                if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
                for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
            }
            var f = arguments.length - 2;
            if (1 === f) d.children = e;
            else if (1 < f) {
                g = Array(f);
                for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
                d.children = g;
            }
            return {
                $$typeof: l,
                type: a.type,
                key: c,
                ref: k,
                props: d,
                _owner: h
            };
        };
        exports.createContext = function(a) {
            a = {
                $$typeof: u,
                _currentValue: a,
                _currentValue2: a,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null
            };
            a.Provider = {
                $$typeof: t,
                _context: a
            };
            return a.Consumer = a;
        };
        exports.createElement = M;
        exports.createFactory = function(a) {
            var b = M.bind(null, a);
            b.type = a;
            return b;
        };
        exports.createRef = function() {
            return {
                current: null
            };
        };
        exports.forwardRef = function(a) {
            return {
                $$typeof: v,
                render: a
            };
        };
        exports.isValidElement = O;
        exports.lazy = function(a) {
            return {
                $$typeof: y,
                _payload: {
                    _status: -1,
                    _result: a
                },
                _init: T
            };
        };
        exports.memo = function(a, b) {
            return {
                $$typeof: x,
                type: a,
                compare: void 0 === b ? null : b
            };
        };
        exports.startTransition = function(a) {
            var b = V.transition;
            V.transition = {};
            try {
                a();
            } finally{
                V.transition = b;
            }
        };
        exports.unstable_act = function() {
            throw Error("act(...) is not supported in production builds of React.");
        };
        exports.useCallback = function(a, b) {
            return U.current.useCallback(a, b);
        };
        exports.useContext = function(a) {
            return U.current.useContext(a);
        };
        exports.useDebugValue = function() {};
        exports.useDeferredValue = function(a) {
            return U.current.useDeferredValue(a);
        };
        exports.useEffect = function(a, b) {
            return U.current.useEffect(a, b);
        };
        exports.useId = function() {
            return U.current.useId();
        };
        exports.useImperativeHandle = function(a, b, e) {
            return U.current.useImperativeHandle(a, b, e);
        };
        exports.useInsertionEffect = function(a, b) {
            return U.current.useInsertionEffect(a, b);
        };
        exports.useLayoutEffect = function(a, b) {
            return U.current.useLayoutEffect(a, b);
        };
        exports.useMemo = function(a, b) {
            return U.current.useMemo(a, b);
        };
        exports.useReducer = function(a, b, e) {
            return U.current.useReducer(a, b, e);
        };
        exports.useRef = function(a) {
            return U.current.useRef(a);
        };
        exports.useState = function(a) {
            return U.current.useState(a);
        };
        exports.useSyncExternalStore = function(a, b, e) {
            return U.current.useSyncExternalStore(a, b, e);
        };
        exports.useTransition = function() {
            return U.current.useTransition();
        };
        exports.version = "18.2.0";
    }
});
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.development.js
var $bd281d0293cbb34e$var$require_react_development = (0, $fmoXt.__commonJS)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.development.js" (exports, module) {
        "use strict";
    }
});
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var $bd281d0293cbb34e$export$18dc0e75b6bbb2d3 = (0, $fmoXt.__commonJS)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js" (exports, module) {
        "use strict";
        module.exports = $bd281d0293cbb34e$var$require_react_production_min();
    }
});
 /**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */  /**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
});
parcelRegister("fmoXt", function(module, exports) {

$parcel$export(module.exports, "__commonJS", function () { return $32c6da90c5676d24$export$c98acbe61b4a254a; });
$parcel$export(module.exports, "__toESM", function () { return $32c6da90c5676d24$export$82dec27a9dce9602; });
var $32c6da90c5676d24$var$__create = Object.create;
var $32c6da90c5676d24$var$__defProp = Object.defineProperty;
var $32c6da90c5676d24$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $32c6da90c5676d24$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $32c6da90c5676d24$var$__getProtoOf = Object.getPrototypeOf;
var $32c6da90c5676d24$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $32c6da90c5676d24$export$c98acbe61b4a254a = (cb, mod)=>function __require() {
        return mod || (0, cb[$32c6da90c5676d24$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $32c6da90c5676d24$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $32c6da90c5676d24$var$__getOwnPropNames(from))if (!$32c6da90c5676d24$var$__hasOwnProp.call(to, key) && key !== except) $32c6da90c5676d24$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $32c6da90c5676d24$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $32c6da90c5676d24$export$82dec27a9dce9602 = (mod, isNodeMode, target)=>(target = mod != null ? $32c6da90c5676d24$var$__create($32c6da90c5676d24$var$__getProtoOf(mod)) : {}, $32c6da90c5676d24$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $32c6da90c5676d24$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));

});




parcelRegister("aBgOx", function(module, exports) {

$parcel$export(module.exports, "select_default", function () { return $36fe0e6b9294f492$export$5f058b6414bc662f; });

var $9ProK = parcelRequire("9ProK");

var $dEee3 = parcelRequire("dEee3");

var $dyaxi = parcelRequire("dyaxi");

var $hmdH9 = parcelRequire("hmdH9");

var $lwpxJ = parcelRequire("lwpxJ");

var $3NUgt = parcelRequire("3NUgt");

var $hN2BG = parcelRequire("hN2BG");

var $kedtD = parcelRequire("kedtD");

var $bh6RR = parcelRequire("bh6RR");

var $ebpD3 = parcelRequire("ebpD3");

var $lTq24 = parcelRequire("lTq24");

var $ih19M = parcelRequire("ih19M");
"use client";
function $36fe0e6b9294f492$var$Select(props, ref) {
    const { Component: Component, state: state, label: label, hasHelper: hasHelper, isLoading: isLoading, triggerRef: triggerRef, selectorIcon: selectorIcon = /* @__PURE__ */ (0, $ih19M.jsx)((0, $lwpxJ.ChevronDownIcon), {}), description: description, errorMessage: errorMessage, isInvalid: isInvalid, startContent: startContent, endContent: endContent, placeholder: placeholder, renderValue: renderValue, isOutsideLeft: isOutsideLeft, disableAnimation: disableAnimation, getBaseProps: getBaseProps, getLabelProps: getLabelProps, getTriggerProps: getTriggerProps, getValueProps: getValueProps, getListboxProps: getListboxProps, getPopoverProps: getPopoverProps, getSpinnerProps: getSpinnerProps, getMainWrapperProps: getMainWrapperProps, getInnerWrapperProps: getInnerWrapperProps, getHiddenSelectProps: getHiddenSelectProps, getHelperWrapperProps: getHelperWrapperProps, getListboxWrapperProps: getListboxWrapperProps, getDescriptionProps: getDescriptionProps, getErrorMessageProps: getErrorMessageProps, getSelectorIconProps: getSelectorIconProps } = (0, $dEee3.useSelect)({
        ...props,
        ref: ref
    });
    const labelContent = label ? /* @__PURE__ */ (0, $ih19M.jsx)("label", {
        ...getLabelProps(),
        children: label
    }) : null;
    const clonedIcon = (0, $bh6RR.cloneElement)(selectorIcon, getSelectorIconProps());
    const helperWrapper = (0, $bh6RR.useMemo)(()=>{
        if (!hasHelper) return null;
        return /* @__PURE__ */ (0, $ih19M.jsx)("div", {
            ...getHelperWrapperProps(),
            children: isInvalid && errorMessage ? /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                ...getErrorMessageProps(),
                children: errorMessage
            }) : description ? /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                ...getDescriptionProps(),
                children: description
            }) : null
        });
    }, [
        hasHelper,
        isInvalid,
        errorMessage,
        description,
        getHelperWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    const renderSelectedItem = (0, $bh6RR.useMemo)(()=>{
        var _a;
        if (!((_a = state.selectedItems) == null ? void 0 : _a.length)) return placeholder;
        if (renderValue && typeof renderValue === "function") {
            const mappedItems = [
                ...state.selectedItems
            ].map((item)=>({
                    key: item.key,
                    data: item.value,
                    type: item.type,
                    props: item.props,
                    textValue: item.textValue,
                    rendered: item.rendered,
                    "aria-label": item["aria-label"]
                }));
            return renderValue(mappedItems);
        }
        return state.selectedItems.map((item)=>item.textValue).join(", ");
    }, [
        state.selectedItems,
        renderValue,
        placeholder
    ]);
    const renderIndicator = (0, $bh6RR.useMemo)(()=>{
        if (isLoading) return /* @__PURE__ */ (0, $ih19M.jsx)((0, $3NUgt.spinner_default), {
            ...getSpinnerProps()
        });
        return clonedIcon;
    }, [
        isLoading,
        clonedIcon,
        getSpinnerProps
    ]);
    const popoverContent = (0, $bh6RR.useMemo)(()=>state.isOpen ? /* @__PURE__ */ (0, $ih19M.jsx)((0, $hmdH9.free_solo_popover_default), {
            ...getPopoverProps(),
            children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $kedtD.scroll_shadow_default), {
                ...getListboxWrapperProps(),
                children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dyaxi.listbox_default), {
                    ...getListboxProps()
                })
            })
        }) : null, [
        state.isOpen,
        getPopoverProps,
        state,
        triggerRef,
        getListboxWrapperProps,
        getListboxProps
    ]);
    return /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $ih19M.jsx)((0, $9ProK.HiddenSelect), {
                ...getHiddenSelectProps()
            }),
            isOutsideLeft ? labelContent : null,
            /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
                ...getMainWrapperProps(),
                children: [
                    /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
                        ...getTriggerProps(),
                        children: [
                            !isOutsideLeft ? labelContent : null,
                            /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
                                ...getInnerWrapperProps(),
                                children: [
                                    startContent,
                                    /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                                        ...getValueProps(),
                                        children: renderSelectedItem
                                    }),
                                    endContent && state.selectedItems && /* @__PURE__ */ (0, $ih19M.jsx)((0, $ebpD3.VisuallyHidden), {
                                        elementType: "span",
                                        children: ","
                                    }),
                                    endContent
                                ]
                            }),
                            renderIndicator
                        ]
                    }),
                    helperWrapper
                ]
            }),
            disableAnimation ? popoverContent : /* @__PURE__ */ (0, $ih19M.jsx)((0, $lTq24.AnimatePresence), {
                children: popoverContent
            })
        ]
    });
}
var $36fe0e6b9294f492$export$5f058b6414bc662f = (0, $hN2BG.forwardRef)($36fe0e6b9294f492$var$Select);
$36fe0e6b9294f492$var$Select.displayName = "NextUI.Select";

});
parcelRegister("9ProK", function(module, exports) {

$parcel$export(module.exports, "HiddenSelect", function () { return $dcbe8cd460590738$export$cbd84cdb2e668835; });

var $dEee3 = parcelRequire("dEee3");

var $4yIWF = parcelRequire("4yIWF");

var $fvnOt = parcelRequire("fvnOt");

var $ebpD3 = parcelRequire("ebpD3");

var $b2mWI = parcelRequire("b2mWI");

var $ih19M = parcelRequire("ih19M");
"use client";
function $dcbe8cd460590738$export$f809e80f58e251d1(props, state, triggerRef) {
    var _a;
    let data = (0, $dEee3.selectData).get(state) || {};
    let { autoComplete: autoComplete, name: name = data.name, isDisabled: isDisabled = data.isDisabled, selectionMode: selectionMode, onChange: onChange } = props;
    let { validationBehavior: validationBehavior, isRequired: isRequired } = data;
    let modality = (0, $fvnOt.useInteractionModality)();
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $ebpD3.useVisuallyHidden)();
    (0, $4yIWF.useFormReset)(props.selectRef, state.selectedKeys, state.setSelectedKeys);
    (0, $b2mWI.useFormValidation)({
        validationBehavior: validationBehavior,
        focus: ()=>{
            var _a2;
            return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
        }
    }, state, props.selectRef);
    return {
        containerProps: {
            ...visuallyHiddenProps,
            "aria-hidden": true,
            ["data-a11y-ignore"]: "aria-hidden-focus"
        },
        inputProps: {
            type: "text",
            tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
            autoComplete: autoComplete,
            value: (_a = [
                ...state.selectedKeys
            ].join(",")) != null ? _a : "",
            required: isRequired,
            style: {
                fontSize: 16
            },
            onFocus: ()=>{
                var _a2;
                return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
            },
            disabled: isDisabled,
            onChange: ()=>{}
        },
        selectProps: {
            name: name,
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            size: state.collection.size,
            value: selectionMode === "multiple" ? [
                ...state.selectedKeys
            ].map((k)=>String(k)) : [
                ...state.selectedKeys
            ][0],
            multiple: selectionMode === "multiple",
            onChange: (e)=>{
                state.setSelectedKeys(e.target.value);
                onChange == null || onChange(e);
            }
        }
    };
}
function $dcbe8cd460590738$export$cbd84cdb2e668835(props) {
    var _a;
    let { state: state, triggerRef: triggerRef, selectRef: selectRef, label: label, name: name, isDisabled: isDisabled } = props;
    let { containerProps: containerProps, inputProps: inputProps, selectProps: selectProps } = $dcbe8cd460590738$export$f809e80f58e251d1({
        ...props,
        selectRef: selectRef
    }, state, triggerRef);
    if (state.collection.size <= 300) return /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
        ...containerProps,
        "data-testid": "hidden-select-container",
        children: [
            /* @__PURE__ */ (0, $ih19M.jsx)("input", {
                ...inputProps
            }),
            /* @__PURE__ */ (0, $ih19M.jsxs)("label", {
                children: [
                    label,
                    /* @__PURE__ */ (0, $ih19M.jsxs)("select", {
                        ...selectProps,
                        ref: selectRef,
                        children: [
                            /* @__PURE__ */ (0, $ih19M.jsx)("option", {}),
                            [
                                ...state.collection.getKeys()
                            ].map((key)=>{
                                let item = state.collection.getItem(key);
                                if ((item == null ? void 0 : item.type) === "item") return /* @__PURE__ */ (0, $ih19M.jsx)("option", {
                                    value: item.key,
                                    children: item.textValue
                                }, item.key);
                            })
                        ]
                    })
                ]
            })
        ]
    });
    else if (name) return /* @__PURE__ */ (0, $ih19M.jsx)("input", {
        autoComplete: selectProps.autoComplete,
        disabled: isDisabled,
        name: name,
        type: "hidden",
        value: (_a = [
            ...state.selectedKeys
        ].join(",")) != null ? _a : ""
    });
    return null;
}

});
parcelRegister("dEee3", function(module, exports) {

$parcel$export(module.exports, "selectData", function () { return $5d7bf360b0d0637f$export$703601b7e90536f8; });
$parcel$export(module.exports, "useSelect", function () { return $5d7bf360b0d0637f$export$e64b2f635402ca43; });

var $hN2BG = parcelRequire("hN2BG");
var $gSab4 = parcelRequire("gSab4");

var $890a1 = parcelRequire("890a1");

var $bIkcs = parcelRequire("bIkcs");
var $gedB5 = parcelRequire("gedB5");

var $bh6RR = parcelRequire("bh6RR");

var $1lwgY = parcelRequire("1lwgY");

var $3HS2q = parcelRequire("3HS2q");

var $3xP29 = parcelRequire("3xP29");
var $6G4gc = parcelRequire("6G4gc");
var $6N9Z9 = parcelRequire("6N9Z9");

var $dCyIs = parcelRequire("dCyIs");

var $fvnOt = parcelRequire("fvnOt");

var $aSMQ6 = parcelRequire("aSMQ6");
var $aRKER = parcelRequire("aRKER");

var $cOcFk = parcelRequire("cOcFk");

var $iGORm = parcelRequire("iGORm");
"use client";
var $5d7bf360b0d0637f$export$703601b7e90536f8 = /* @__PURE__ */ new WeakMap();
function $5d7bf360b0d0637f$export$e64b2f635402ca43(originalProps) {
    var _a, _b, _c, _d, _e;
    const globalContext = (0, $gSab4.useProviderContext)();
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $890a1.select).variantKeys);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const { ref: ref, as: as, label: label, name: name, isLoading: isLoading, selectorIcon: selectorIcon, isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange, startContent: startContent, endContent: endContent, description: description, renderValue: renderValue, onSelectionChange: onSelectionChange, placeholder: placeholder, children: children, disallowEmptySelection: disallowEmptySelection = false, selectionMode: selectionMode = "single", spinnerRef: spinnerRef, scrollRef: scrollRefProp, popoverProps: popoverProps = {}, scrollShadowProps: scrollShadowProps = {}, listboxProps: listboxProps = {}, spinnerProps: spinnerProps = {}, validationState: validationState, onChange: onChange, onClose: onClose, className: className, classNames: classNames, ...otherProps } = props;
    const scrollShadowRef = (0, $gedB5.useDOMRef)(scrollRefProp);
    const slotsProps = {
        popoverProps: (0, $dCyIs.mergeProps)({
            placement: "bottom",
            triggerScaleOnOpen: false,
            offset: 5,
            disableAnimation: disableAnimation
        }, popoverProps),
        scrollShadowProps: (0, $dCyIs.mergeProps)({
            ref: scrollShadowRef,
            isEnabled: (_c = originalProps.showScrollIndicators) != null ? _c : true,
            hideScrollBar: true,
            offset: 15
        }, scrollShadowProps),
        listboxProps: (0, $dCyIs.mergeProps)({
            disableAnimation: disableAnimation
        }, listboxProps)
    };
    const Component = as || "button";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const triggerRef = (0, $bh6RR.useRef)(null);
    const listBoxRef = (0, $bh6RR.useRef)(null);
    const popoverRef = (0, $bh6RR.useRef)(null);
    let state = (0, $aRKER.useMultiSelectState)({
        ...props,
        isOpen: isOpen,
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        children: children,
        isRequired: originalProps.isRequired,
        isDisabled: originalProps.isDisabled,
        defaultOpen: defaultOpen,
        onOpenChange: (open)=>{
            onOpenChange == null || onOpenChange(open);
            if (!open) onClose == null || onClose();
        },
        onSelectionChange: (keys)=>{
            onSelectionChange == null || onSelectionChange(keys);
            if (onChange && typeof onChange === "function" && domRef.current) {
                const event = {
                    target: {
                        ...domRef.current,
                        value: Array.from(keys).join(","),
                        name: domRef.current.name
                    }
                };
                onChange(event);
            }
        }
    });
    state = {
        ...state,
        ...originalProps.isDisabled && {
            disabledKeys: /* @__PURE__ */ new Set([
                ...state.collection.getKeys()
            ])
        }
    };
    (0, $cOcFk.useSafeLayoutEffect)(()=>{
        var _a2;
        if (!((_a2 = domRef.current) == null ? void 0 : _a2.value)) return;
        state.setSelectedKeys(/* @__PURE__ */ new Set([
            ...state.selectedKeys,
            domRef.current.value
        ]));
    }, [
        domRef.current
    ]);
    const { labelProps: labelProps, triggerProps: triggerProps, valueProps: valueProps, menuProps: menuProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isInvalid: isAriaInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $aSMQ6.useMultiSelect)({
        ...props,
        disallowEmptySelection: disallowEmptySelection,
        isDisabled: originalProps.isDisabled
    }, state, triggerRef);
    const isInvalid = originalProps.isInvalid || validationState === "invalid" || isAriaInvalid;
    const { isPressed: isPressed, buttonProps: buttonProps } = (0, $1lwgY.useAriaButton)(triggerProps, triggerRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3HS2q.useFocusRing)();
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $fvnOt.useHover)({
        isDisabled: originalProps.isDisabled
    });
    const labelPlacement = (0, $bh6RR.useMemo)(()=>{
        var _a2;
        if ((!originalProps.labelPlacement || originalProps.labelPlacement === "inside") && !label) return "outside";
        return (_a2 = originalProps.labelPlacement) != null ? _a2 : "inside";
    }, [
        originalProps.labelPlacement,
        label
    ]);
    const hasPlaceholder = !!placeholder;
    const shouldLabelBeOutside = labelPlacement === "outside-left" || labelPlacement === "outside" && (hasPlaceholder || !!originalProps.isMultiline);
    const shouldLabelBeInside = labelPlacement === "inside";
    const isOutsideLeft = labelPlacement === "outside-left";
    const isFilled = state.isOpen || hasPlaceholder || !!((_d = state.selectedItems) == null ? void 0 : _d.length) || !!startContent || !!endContent || !!originalProps.isMultiline;
    const hasValue = !!((_e = state.selectedItems) == null ? void 0 : _e.length);
    const hasLabel = !!label;
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    const slots = (0, $bh6RR.useMemo)(()=>(0, $890a1.select)({
            ...variantProps,
            isInvalid: isInvalid,
            labelPlacement: labelPlacement,
            disableAnimation: disableAnimation,
            className: className
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps),
        isInvalid,
        labelPlacement,
        disableAnimation,
        className
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (state.isOpen && popoverRef.current && listBoxRef.current) {
            let selectedItem = listBoxRef.current.querySelector("[aria-selected=true] [data-label=true]");
            let scrollShadow = scrollShadowRef.current;
            if (selectedItem && scrollShadow && selectedItem.parentElement) {
                let scrollShadowRect = scrollShadow == null ? void 0 : scrollShadow.getBoundingClientRect();
                let scrollShadowHeight = scrollShadowRect.height;
                scrollShadow.scrollTop = selectedItem.parentElement.offsetTop - scrollShadowHeight / 2 + selectedItem.parentElement.clientHeight / 2;
            }
        }
    }, [
        state.isOpen,
        disableAnimation
    ]);
    const errorMessage = typeof props.errorMessage === "function" ? props.errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : props.errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" "));
    const hasHelper = !!description || !!errorMessage;
    (0, $bh6RR.useEffect)(()=>{
        if (state.isOpen && popoverRef.current && triggerRef.current) {
            let selectRect = triggerRef.current.getBoundingClientRect();
            let popover = popoverRef.current;
            popover.style.width = selectRect.width + "px";
        }
    }, [
        state.isOpen
    ]);
    const getBaseProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            "data-slot": "base",
            "data-filled": (0, $6G4gc.dataAttr)(isFilled),
            "data-has-value": (0, $6G4gc.dataAttr)(hasValue),
            "data-has-label": (0, $6G4gc.dataAttr)(hasLabel),
            "data-has-helper": (0, $6G4gc.dataAttr)(hasHelper),
            className: slots.base({
                class: (0, $3xP29.clsx)(baseStyles, props2.className)
            }),
            ...props2
        }), [
        slots,
        hasHelper,
        hasValue,
        hasLabel,
        isFilled,
        baseStyles
    ]);
    const getTriggerProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ref: triggerRef,
            "data-slot": "trigger",
            "data-open": (0, $6G4gc.dataAttr)(state.isOpen),
            "data-disabled": (0, $6G4gc.dataAttr)(originalProps == null ? void 0 : originalProps.isDisabled),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-pressed": (0, $6G4gc.dataAttr)(isPressed),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            "data-hover": (0, $6G4gc.dataAttr)(isHovered),
            className: slots.trigger({
                class: classNames == null ? void 0 : classNames.trigger
            }),
            ...(0, $dCyIs.mergeProps)(buttonProps, focusProps, hoverProps, (0, $bIkcs.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $bIkcs.filterDOMProps)(props2))
        };
    }, [
        slots,
        triggerRef,
        state.isOpen,
        classNames == null ? void 0 : classNames.trigger,
        originalProps == null ? void 0 : originalProps.isDisabled,
        isFocused,
        isPressed,
        isFocusVisible,
        isHovered,
        buttonProps,
        focusProps,
        hoverProps,
        otherProps,
        shouldFilterDOMProps
    ]);
    const getHiddenSelectProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            state: state,
            triggerRef: triggerRef,
            selectRef: domRef,
            selectionMode: selectionMode,
            label: originalProps == null ? void 0 : originalProps.label,
            name: originalProps == null ? void 0 : originalProps.name,
            isRequired: originalProps == null ? void 0 : originalProps.isRequired,
            autoComplete: originalProps == null ? void 0 : originalProps.autoComplete,
            isDisabled: originalProps == null ? void 0 : originalProps.isDisabled,
            onChange: onChange,
            ...props2
        }), [
        state,
        selectionMode,
        originalProps == null ? void 0 : originalProps.label,
        originalProps == null ? void 0 : originalProps.autoComplete,
        originalProps == null ? void 0 : originalProps.name,
        originalProps == null ? void 0 : originalProps.isDisabled,
        triggerRef
    ]);
    const getLabelProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            "data-slot": "label",
            className: slots.label({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.label, props2.className)
            }),
            ...labelProps,
            ...props2
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        labelProps
    ]);
    const getValueProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            "data-slot": "value",
            className: slots.value({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.value, props2.className)
            }),
            ...valueProps,
            ...props2
        }), [
        slots,
        classNames == null ? void 0 : classNames.value,
        valueProps
    ]);
    const getListboxWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            "data-slot": "listboxWrapper",
            className: slots.listboxWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.listboxWrapper, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $dCyIs.mergeProps)(slotsProps.scrollShadowProps, props2)
        }), [
        slots.listboxWrapper,
        classNames == null ? void 0 : classNames.listboxWrapper,
        slotsProps.scrollShadowProps
    ]);
    const getListboxProps = (props2 = {})=>{
        return {
            state: state,
            ref: listBoxRef,
            "data-slot": "listbox",
            className: slots.listbox({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.listbox, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $dCyIs.mergeProps)(slotsProps.listboxProps, props2, menuProps)
        };
    };
    const getPopoverProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        var _a2, _b2;
        const popoverProps2 = (0, $dCyIs.mergeProps)(slotsProps.popoverProps, props2);
        return {
            state: state,
            triggerRef: triggerRef,
            ref: popoverRef,
            "data-slot": "popover",
            scrollRef: listBoxRef,
            triggerType: "listbox",
            classNames: {
                content: slots.popoverContent({
                    class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.popoverContent, props2.className)
                })
            },
            ...popoverProps2,
            offset: state.selectedItems && state.selectedItems.length > 0 ? state.selectedItems.length * 1e-8 + (((_a2 = slotsProps.popoverProps) == null ? void 0 : _a2.offset) || 0) : (_b2 = slotsProps.popoverProps) == null ? void 0 : _b2.offset,
            shouldCloseOnInteractOutside: (popoverProps2 == null ? void 0 : popoverProps2.shouldCloseOnInteractOutside) ? popoverProps2.shouldCloseOnInteractOutside : (element)=>(0, $iGORm.ariaShouldCloseOnInteractOutside)(element, triggerRef, state)
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.popoverContent,
        slotsProps.popoverProps,
        triggerRef,
        state,
        state.selectedItems
    ]);
    const getSelectorIconProps = (0, $bh6RR.useCallback)(()=>({
            "data-slot": "selectorIcon",
            "aria-hidden": (0, $6G4gc.dataAttr)(true),
            "data-open": (0, $6G4gc.dataAttr)(state.isOpen),
            className: slots.selectorIcon({
                class: classNames == null ? void 0 : classNames.selectorIcon
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.selectorIcon,
        state == null ? void 0 : state.isOpen
    ]);
    const getInnerWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "innerWrapper",
            className: slots.innerWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.innerWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.innerWrapper
    ]);
    const getHelperWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "helperWrapper",
            className: slots.helperWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.helperWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.helperWrapper
    ]);
    const getDescriptionProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...descriptionProps,
            "data-slot": "description",
            className: slots.description({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.description, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.description
    ]);
    const getMainWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "mainWrapper",
            className: slots.mainWrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.mainWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.mainWrapper
    ]);
    const getErrorMessageProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...errorMessageProps,
            "data-slot": "errorMessage",
            className: slots.errorMessage({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.errorMessage, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        errorMessageProps,
        classNames == null ? void 0 : classNames.errorMessage
    ]);
    const getSpinnerProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $6G4gc.dataAttr)(true),
            "data-slot": "spinner",
            color: "current",
            size: "sm",
            ...spinnerProps,
            ...props2,
            ref: spinnerRef,
            className: slots.spinner({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.spinner, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        spinnerRef,
        spinnerProps,
        classNames == null ? void 0 : classNames.spinner
    ]);
    $5d7bf360b0d0637f$export$703601b7e90536f8.set(state, {
        isDisabled: originalProps == null ? void 0 : originalProps.isDisabled,
        isRequired: originalProps == null ? void 0 : originalProps.isRequired,
        name: originalProps == null ? void 0 : originalProps.name,
        validationBehavior: "native"
    });
    return {
        Component: Component,
        domRef: domRef,
        state: state,
        label: label,
        name: name,
        triggerRef: triggerRef,
        isLoading: isLoading,
        placeholder: placeholder,
        startContent: startContent,
        endContent: endContent,
        description: description,
        selectorIcon: selectorIcon,
        hasHelper: hasHelper,
        labelPlacement: labelPlacement,
        hasPlaceholder: hasPlaceholder,
        renderValue: renderValue,
        selectionMode: selectionMode,
        disableAnimation: disableAnimation,
        isOutsideLeft: isOutsideLeft,
        shouldLabelBeOutside: shouldLabelBeOutside,
        shouldLabelBeInside: shouldLabelBeInside,
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        getBaseProps: getBaseProps,
        getTriggerProps: getTriggerProps,
        getLabelProps: getLabelProps,
        getValueProps: getValueProps,
        getListboxProps: getListboxProps,
        getPopoverProps: getPopoverProps,
        getSpinnerProps: getSpinnerProps,
        getMainWrapperProps: getMainWrapperProps,
        getListboxWrapperProps: getListboxWrapperProps,
        getHiddenSelectProps: getHiddenSelectProps,
        getInnerWrapperProps: getInnerWrapperProps,
        getHelperWrapperProps: getHelperWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getErrorMessageProps: getErrorMessageProps,
        getSelectorIconProps: getSelectorIconProps
    };
}

});
parcelRegister("890a1", function(module, exports) {

$parcel$export(module.exports, "select", function () { return $e54e407bc9daf65d$export$2e6c959c16ff56b8; });

var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/select.ts
var $e54e407bc9daf65d$export$2e6c959c16ff56b8 = (0, $6ujkL.tv)({
    slots: {
        base: [
            "group inline-flex flex-col relative w-full"
        ],
        label: [
            "block",
            "absolute",
            "z-10",
            "origin-top-left",
            "rtl:origin-top-right",
            "subpixel-antialiased",
            "text-small",
            "text-foreground-500",
            "pointer-events-none"
        ],
        mainWrapper: "w-full flex flex-col",
        trigger: "relative px-3 gap-3 w-full inline-flex flex-row items-center shadow-sm outline-none tap-highlight-transparent",
        innerWrapper: "inline-flex h-full w-[calc(100%_-_theme(spacing.6))] min-h-4 items-center gap-1.5 box-border",
        selectorIcon: "absolute right-3 rtl:left-3 rtl:right-[unset] w-4 h-4",
        spinner: "absolute right-3 rtl:left-3 rtl:right-[unset]",
        value: [
            "text-foreground-500",
            "font-normal",
            "w-full",
            "text-left",
            "rtl:text-right"
        ],
        listboxWrapper: "scroll-py-6 max-h-64 w-full",
        listbox: "",
        popoverContent: "w-full p-1 overflow-hidden",
        helperWrapper: "p-1 flex relative flex-col gap-1.5",
        description: "text-tiny text-foreground-400",
        errorMessage: "text-tiny text-danger"
    },
    variants: {
        variant: {
            flat: {
                trigger: [
                    "bg-default-100",
                    "data-[hover=true]:bg-default-200",
                    "group-data-[focus=true]:bg-default-100"
                ]
            },
            faded: {
                trigger: [
                    "bg-default-100",
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400"
                ],
                value: "group-data-[has-value=true]:text-default-foreground"
            },
            bordered: {
                trigger: [
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400",
                    "data-[open=true]:border-default-foreground",
                    "data-[focus=true]:border-default-foreground",
                    "data-[focus=true]:border-default-foreground"
                ]
            },
            underlined: {
                trigger: [
                    "!px-1",
                    "!pb-0",
                    "!gap-0",
                    "relative",
                    "box-border",
                    "border-b-medium",
                    "shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]",
                    "border-default-200",
                    "!rounded-none",
                    "hover:border-default-300",
                    "after:content-['']",
                    "after:w-0",
                    "after:origin-center",
                    "after:bg-default-foreground",
                    "after:absolute",
                    "after:left-1/2",
                    "after:-translate-x-1/2",
                    "after:-bottom-[2px]",
                    "after:h-[2px]",
                    "data-[open=true]:after:w-full",
                    "data-[focus=true]:after:w-full"
                ],
                label: "group-data-[filled=true]:text-foreground"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        size: {
            sm: {
                label: "text-tiny",
                trigger: "h-8 min-h-8 px-2 rounded-small",
                value: "text-small"
            },
            md: {
                trigger: "h-10 min-h-10 rounded-medium",
                value: "text-small"
            },
            lg: {
                trigger: "h-12 min-h-12 rounded-large",
                value: "text-medium"
            }
        },
        radius: {
            none: {
                trigger: "rounded-none"
            },
            sm: {
                trigger: "rounded-small"
            },
            md: {
                trigger: "rounded-medium"
            },
            lg: {
                trigger: "rounded-large"
            },
            full: {
                trigger: "rounded-full"
            }
        },
        labelPlacement: {
            outside: {
                base: "flex flex-col"
            },
            "outside-left": {
                base: "flex-row items-center flex-nowrap items-start",
                label: "relative pr-2 rtl:pl-2 rtl:pr-[unset] text-foreground"
            },
            inside: {
                label: "text-tiny cursor-pointer",
                trigger: "flex-col items-start justify-center gap-0"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none",
                trigger: "pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                label: "!text-danger",
                value: "!text-danger",
                selectorIcon: "text-danger"
            }
        },
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5"
            }
        },
        isMultiline: {
            true: {
                label: "relative",
                trigger: "!h-auto"
            },
            false: {
                value: "truncate"
            }
        },
        disableAnimation: {
            true: {
                trigger: "after:transition-none",
                base: "transition-none",
                label: "transition-none",
                selectorIcon: "transition-none"
            },
            false: {
                base: "transition-background motion-reduce:transition-none !duration-150",
                label: [
                    "will-change-auto",
                    "origin-top-left",
                    "rtl:origin-top-right",
                    "!duration-200",
                    "!ease-out",
                    "transition-[transform,color,left,opacity]",
                    "motion-reduce:transition-none"
                ],
                selectorIcon: "transition-transform duration-150 ease motion-reduce:transition-none"
            }
        },
        disableSelectorIconRotation: {
            true: {},
            false: {
                selectorIcon: "data-[open=true]:rotate-180"
            }
        }
    },
    defaultVariants: {
        variant: "flat",
        color: "default",
        size: "md",
        labelPlacement: "inside",
        fullWidth: true,
        isDisabled: false,
        isMultiline: false,
        disableSelectorIconRotation: false
    },
    compoundVariants: [
        {
            variant: "flat",
            color: "default",
            class: {
                value: "group-data-[has-value=true]:text-default-foreground"
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                trigger: [
                    "bg-primary-50",
                    "text-primary",
                    "data-[hover=true]:bg-primary-100",
                    "group-data-[focus=true]:bg-primary-50"
                ],
                value: "text-primary",
                label: "text-primary"
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                trigger: [
                    "bg-secondary-50",
                    "text-secondary",
                    "data-[hover=true]:bg-secondary-100",
                    "group-data-[focus=true]:bg-secondary-50"
                ],
                value: "text-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                trigger: [
                    "bg-success-50",
                    "text-success-600",
                    "dark:text-success",
                    "data-[hover=true]:bg-success-100",
                    "group-data-[focus=true]:bg-success-50"
                ],
                value: "text-success-600 dark:text-success",
                label: "text-success-600 dark:text-success"
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                trigger: [
                    "bg-warning-50",
                    "text-warning-600",
                    "dark:text-warning",
                    "data-[hover=true]:bg-warning-100",
                    "group-data-[focus=true]:bg-warning-50"
                ],
                value: "text-warning-600 dark:text-warning",
                label: "text-warning-600 dark:text-warning"
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                trigger: [
                    "bg-danger-50",
                    "text-danger",
                    "dark:text-danger-500",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ],
                value: "text-danger dark:text-danger-500",
                label: "text-danger dark:text-danger-500"
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                trigger: "data-[hover=true]:border-primary",
                label: "text-primary"
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                trigger: "data-[hover=true]:border-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                trigger: "data-[hover=true]:border-success",
                label: "text-success"
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                trigger: "data-[hover=true]:border-warning",
                label: "text-warning"
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                trigger: "data-[hover=true]:border-danger",
                label: "text-danger"
            }
        },
        {
            variant: "underlined",
            color: "default",
            class: {
                value: "group-data-[has-value=true]:text-foreground"
            }
        },
        {
            variant: "underlined",
            color: "primary",
            class: {
                trigger: "after:bg-primary",
                label: "text-primary"
            }
        },
        {
            variant: "underlined",
            color: "secondary",
            class: {
                trigger: "after:bg-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "underlined",
            color: "success",
            class: {
                trigger: "after:bg-success",
                label: "text-success"
            }
        },
        {
            variant: "underlined",
            color: "warning",
            class: {
                trigger: "after:bg-warning",
                label: "text-warning"
            }
        },
        {
            variant: "underlined",
            color: "danger",
            class: {
                trigger: "after:bg-danger",
                label: "text-danger"
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                trigger: [
                    "data-[open=true]:border-primary",
                    "data-[focus=true]:border-primary"
                ],
                label: "text-primary"
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                trigger: [
                    "data-[open=true]:border-secondary",
                    "data-[focus=true]:border-secondary"
                ],
                label: "text-secondary"
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                trigger: [
                    "data-[open=true]:border-success",
                    "data-[focus=true]:border-success"
                ],
                label: "text-success"
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                trigger: [
                    "data-[open=true]:border-warning",
                    "data-[focus=true]:border-warning"
                ],
                label: "text-warning"
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                trigger: [
                    "data-[open=true]:border-danger",
                    "data-[focus=true]:border-danger"
                ],
                label: "text-danger"
            }
        },
        {
            labelPlacement: "inside",
            color: "default",
            class: {
                label: "group-data-[filled=true]:text-default-600"
            }
        },
        {
            labelPlacement: "outside",
            color: "default",
            class: {
                label: "group-data-[filled=true]:text-foreground"
            }
        },
        {
            radius: "full",
            size: [
                "sm"
            ],
            class: {
                trigger: "px-3"
            }
        },
        {
            radius: "full",
            size: "md",
            class: {
                trigger: "px-4"
            }
        },
        {
            radius: "full",
            size: "lg",
            class: {
                trigger: "px-5"
            }
        },
        {
            disableAnimation: false,
            variant: [
                "faded",
                "bordered"
            ],
            class: {
                trigger: "transition-colors motion-reduce:transition-none"
            }
        },
        {
            disableAnimation: false,
            variant: "underlined",
            class: {
                trigger: "after:transition-width motion-reduce:after:transition-none"
            }
        },
        {
            variant: [
                "flat",
                "faded"
            ],
            class: {
                trigger: [
                    ...(0, $g2NHD.dataFocusVisibleClasses)
                ]
            }
        },
        {
            isInvalid: true,
            variant: "flat",
            class: {
                trigger: [
                    "bg-danger-50",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ]
            }
        },
        {
            isInvalid: true,
            variant: "bordered",
            class: {
                trigger: "!border-danger group-data-[focus=true]:border-danger"
            }
        },
        {
            isInvalid: true,
            variant: "underlined",
            class: {
                trigger: "after:bg-danger"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            class: {
                trigger: "h-12 min-h-12 py-1.5 px-3"
            }
        },
        {
            labelPlacement: "inside",
            size: "md",
            class: {
                trigger: "h-14 min-h-14 py-2"
            }
        },
        {
            labelPlacement: "inside",
            size: "lg",
            class: {
                label: "text-small",
                trigger: "h-16 min-h-16 py-2.5 gap-0"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "group-data-[filled=true]:pointer-events-auto"
                ]
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            class: {
                base: "group relative justify-end",
                label: [
                    "pb-0",
                    "z-20",
                    "top-1/2",
                    "-translate-y-1/2",
                    "group-data-[filled=true]:left-0",
                    "rtl:group-data-[filled=true]:right-0",
                    "rtl:group-data-[filled=true]:left-[unset]"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            class: {
                label: "group-data-[filled=true]:scale-85"
            }
        },
        {
            labelPlacement: "inside",
            size: [
                "sm",
                "md"
            ],
            class: {
                label: "text-small"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-4"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-4"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-5"
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_3.5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_4px)]"
                ]
            }
        },
        {
            labelPlacement: "outside",
            size: "sm",
            isMultiline: false,
            class: {
                label: [
                    "left-2",
                    "rtl:right-2",
                    "rtl:left-[unset]",
                    "text-tiny",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.tiny)/2_+_16px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_8px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "left-3",
                    "rtl:right-3",
                    "rtl:left-[unset]",
                    "text-small",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_20px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_10px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "left-3",
                    "rtl:right-3",
                    "rtl:left-[unset]",
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_24px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_12px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: true,
            class: {
                label: "pb-1.5"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "pe-2",
                    "max-w-full",
                    "text-ellipsis",
                    "overflow-hidden"
                ]
            }
        }
    ]
});

});

parcelRegister("aSMQ6", function(module, exports) {

$parcel$export(module.exports, "useMultiSelect", function () { return $4ae3c8a6beb0240c$export$efbfa63d6e989c0e; });
// src/use-multiselect.ts

var $6KOwj = parcelRequire("6KOwj");

var $fvnOt = parcelRequire("fvnOt");

var $kayKA = parcelRequire("kayKA");

var $3qDwh = parcelRequire("3qDwh");

var $2FbWw = parcelRequire("2FbWw");

var $i65Wu = parcelRequire("i65Wu");
var $leZvJ = parcelRequire("leZvJ");
var $dCyIs = parcelRequire("dCyIs");
var $43JEG = parcelRequire("43JEG");

var $bh6RR = parcelRequire("bh6RR");
function $4ae3c8a6beb0240c$export$efbfa63d6e989c0e(props, state, ref) {
    const { disallowEmptySelection: disallowEmptySelection, isDisabled: isDisabled } = props;
    const collator = (0, $6KOwj.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    const delegate = (0, $bh6RR.useMemo)(()=>new (0, $2FbWw.ListKeyboardDelegate)(state.collection, state.disabledKeys, null, collator), [
        state.collection,
        state.disabledKeys,
        collator
    ]);
    const { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $3qDwh.useMenuTrigger)({
        isDisabled: isDisabled,
        type: "listbox"
    }, state, ref);
    const triggerOnKeyDown = (e)=>{
        if (state.selectionMode === "single") switch(e.key){
            case "ArrowLeft":
                {
                    e.preventDefault();
                    const key = state.selectedKeys.size > 0 ? delegate.getKeyAbove(state.selectedKeys.values().next().value) : delegate.getFirstKey();
                    if (key) state.setSelectedKeys([
                        key
                    ]);
                    break;
                }
            case "ArrowRight":
                {
                    e.preventDefault();
                    const key = state.selectedKeys.size > 0 ? delegate.getKeyBelow(state.selectedKeys.values().next().value) : delegate.getFirstKey();
                    if (key) state.setSelectedKeys([
                        key
                    ]);
                    break;
                }
        }
    };
    const { typeSelectProps: typeSelectProps } = (0, $2FbWw.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKeys([
                key
            ]);
        }
    });
    const { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    const { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $kayKA.useField)({
        ...props,
        labelElementType: "span",
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    const domProps = (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    });
    const triggerProps = (0, $dCyIs.mergeProps)(typeSelectProps, menuTriggerProps, fieldProps);
    const valueId = (0, $43JEG.useId)();
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                var _a;
                if (!props.isDisabled) {
                    (_a = ref.current) == null || _a.focus();
                    (0, $fvnOt.setInteractionModality)("keyboard");
                }
            }
        },
        triggerProps: (0, $dCyIs.mergeProps)(domProps, {
            ...triggerProps,
            onKeyDown: (0, $i65Wu.chain)(triggerProps.onKeyDown, triggerOnKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            "aria-labelledby": [
                valueId,
                domProps["aria-label"] !== void 0 ? domProps["aria-labelledby"] !== void 0 ? domProps["aria-labelledby"] : triggerProps.id : triggerProps["aria-labelledby"]
            ].join(" "),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            disallowEmptySelection: disallowEmptySelection,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                state.setFocused(false);
            },
            onFocus: menuProps == null ? void 0 : menuProps.onFocus,
            "aria-labelledby": [
                fieldProps["aria-labelledby"],
                triggerProps["aria-label"] && !fieldProps["aria-labelledby"] ? triggerProps.id : null
            ].filter(Boolean).join(" ")
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});
parcelRegister("6KOwj", function(module, exports) {

$parcel$export(module.exports, "useCollator", function () { return $4eae3a3a0cafbcf4$export$a16aca283550c30d; });

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");

var $aO9ah = parcelRequire("aO9ah");
var $8Il4O = parcelRequire("8Il4O");

var $6pvHs = parcelRequire("6pvHs");

var $1cCUt = parcelRequire("1cCUt");

var $dcFdO = parcelRequire("dcFdO");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $4eae3a3a0cafbcf4$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $4eae3a3a0cafbcf4$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $4eae3a3a0cafbcf4$var$$148a7a147e38ea7f$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $4eae3a3a0cafbcf4$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $4eae3a3a0cafbcf4$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: $4eae3a3a0cafbcf4$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    };
}
let $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$currentLocale = $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$currentLocale = $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$listeners)listener($4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $2GhkT.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $bh6RR.useState)($4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $bh6RR.useEffect)(()=>{
        if ($4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}
const $4eae3a3a0cafbcf4$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $4eae3a3a0cafbcf4$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let value = locale ? {
        locale: locale,
        direction: $4eae3a3a0cafbcf4$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4eae3a3a0cafbcf4$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $4eae3a3a0cafbcf4$export$43bb16f9c6d9e3f7() {
    let defaultLocale = $4eae3a3a0cafbcf4$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let context = (0, $bh6RR.useContext)($4eae3a3a0cafbcf4$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}
var $4eae3a3a0cafbcf4$var$$2aa2084a6c2b6b4f$exports = {};
"use strict";
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4eae3a3a0cafbcf4$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $4eae3a3a0cafbcf4$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $4eae3a3a0cafbcf4$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $aO9ah.LocalizedStringDictionary)(strings);
        $4eae3a3a0cafbcf4$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $4eae3a3a0cafbcf4$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $aO9ah.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || $4eae3a3a0cafbcf4$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $4eae3a3a0cafbcf4$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = $4eae3a3a0cafbcf4$export$43bb16f9c6d9e3f7();
    let dictionary = $4eae3a3a0cafbcf4$export$87b761675e8eaa10(strings, packageName);
    return (0, $bh6RR.useMemo)(()=>new (0, $8Il4O.LocalizedStringFormatter)(locale, dictionary), [
        locale,
        dictionary
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4eae3a3a0cafbcf4$export$a2f47a3d2973640(options = {}) {
    let { locale: locale } = $4eae3a3a0cafbcf4$export$43bb16f9c6d9e3f7();
    return (0, $bh6RR.useMemo)(()=>new Intl.ListFormat(locale, options), [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4eae3a3a0cafbcf4$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, $1cCUt.useDeepMemo)(options !== null && options !== void 0 ? options : {}, $4eae3a3a0cafbcf4$var$$896ba0a80a8f4d36$var$isEqual);
    let { locale: locale } = $4eae3a3a0cafbcf4$export$43bb16f9c6d9e3f7();
    return (0, $bh6RR.useMemo)(()=>new (0, $6pvHs.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function $4eae3a3a0cafbcf4$var$$896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4eae3a3a0cafbcf4$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = $4eae3a3a0cafbcf4$export$43bb16f9c6d9e3f7();
    return (0, $bh6RR.useMemo)(()=>new (0, $dcFdO.NumberFormatter)(locale, options), [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $4eae3a3a0cafbcf4$var$$325a3faab7a68acd$var$cache = new Map();
function $4eae3a3a0cafbcf4$export$a16aca283550c30d(options) {
    let { locale: locale } = $4eae3a3a0cafbcf4$export$43bb16f9c6d9e3f7();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($4eae3a3a0cafbcf4$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $4eae3a3a0cafbcf4$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $4eae3a3a0cafbcf4$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4eae3a3a0cafbcf4$export$3274cf84b703fff(options) {
    let collator = $4eae3a3a0cafbcf4$export$a16aca283550c30d({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, $bh6RR.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, $bh6RR.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, $bh6RR.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $bh6RR.useMemo)(()=>({
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}

});
parcelRegister("6pvHs", function(module, exports) {

$parcel$export(module.exports, "DateFormatter", function () { return $4aadaad59b0aadf8$export$ad991b66133851cf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $4aadaad59b0aadf8$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = $4aadaad59b0aadf8$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}

});

parcelRegister("1cCUt", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", function () { return $0e05182213e43e87$export$722debc0e56fea39; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $0e05182213e43e87$export$722debc0e56fea39(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, $bh6RR.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}

});

parcelRegister("dcFdO", function(module, exports) {

$parcel$export(module.exports, "NumberFormatter", function () { return $99cc5f240304987f$export$cc77c4ff7e8673c5; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class $99cc5f240304987f$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $99cc5f240304987f$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = "short", locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === "unit" && !$99cc5f240304987f$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($99cc5f240304987f$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $99cc5f240304987f$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $99cc5f240304987f$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

});


parcelRegister("kayKA", function(module, exports) {

$parcel$export(module.exports, "useField", function () { return $eaefb286040097a2$export$294aa081a6c6f55d; });

var $dCyIs = parcelRequire("dCyIs");
var $43JEG = parcelRequire("43JEG");
var $bZ9ps = parcelRequire("bZ9ps");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $eaefb286040097a2$export$8467354a121f1b9f(props) {
    let { id: id, label: label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType: labelElementType = "label" } = props;
    id = (0, $43JEG.useId)(id);
    let labelId = (0, $43JEG.useId)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, $bZ9ps.useLabels)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}
function $eaefb286040097a2$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = $eaefb286040097a2$export$8467354a121f1b9f(props);
    let descriptionId = (0, $43JEG.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $43JEG.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $dCyIs.mergeProps)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

});

parcelRegister("3qDwh", function(module, exports) {

$parcel$export(module.exports, "useMenuTrigger", function () { return $27f274996e1fead5$export$dc9c12ed27dd1b49; });

var $h9QBO = parcelRequire("h9QBO");

var $c27Ny = parcelRequire("c27Ny");

var $iwZNZ = parcelRequire("iwZNZ");

var $2znJD = parcelRequire("2znJD");

var $dPEn7 = parcelRequire("dPEn7");

var $fWydv = parcelRequire("fWydv");

var $00QPa = parcelRequire("00QPa");

var $4RIqm = parcelRequire("4RIqm");

var $diImE = parcelRequire("diImE");

var $6VgTe = parcelRequire("6VgTe");

var $lDwT1 = parcelRequire("lDwT1");

var $2wVIs = parcelRequire("2wVIs");

var $2h6Dc = parcelRequire("2h6Dc");

var $aMtNA = parcelRequire("aMtNA");

var $2NmHA = parcelRequire("2NmHA");

var $c0FSQ = parcelRequire("c0FSQ");

var $eMtmj = parcelRequire("eMtmj");

var $2F4kn = parcelRequire("2F4kn");

var $ajcbS = parcelRequire("ajcbS");

var $e9Nt2 = parcelRequire("e9Nt2");

var $4KRaR = parcelRequire("4KRaR");

var $anBf6 = parcelRequire("anBf6");

var $b8uJQ = parcelRequire("b8uJQ");

var $cn5tD = parcelRequire("cn5tD");

var $1iX0Q = parcelRequire("1iX0Q");

var $d8NVS = parcelRequire("d8NVS");

var $gVEiH = parcelRequire("gVEiH");

var $ejud2 = parcelRequire("ejud2");

var $coJnk = parcelRequire("coJnk");

var $7Ib26 = parcelRequire("7Ib26");

var $fWqNR = parcelRequire("fWqNR");

var $dBOvo = parcelRequire("dBOvo");

var $8g98I = parcelRequire("8g98I");

var $eKo5C = parcelRequire("eKo5C");

var $leZvJ = parcelRequire("leZvJ");
var $dCyIs = parcelRequire("dCyIs");
var $77fRS = parcelRequire("77fRS");
var $43JEG = parcelRequire("43JEG");
var $1nsPC = parcelRequire("1nsPC");
var $2oc8v = parcelRequire("2oc8v");
var $aCMC4 = parcelRequire("aCMC4");

var $dG3Oc = parcelRequire("dG3Oc");
var $atGLR = parcelRequire("atGLR");

var $gyK3a = parcelRequire("gyK3a");
var $cCD8i = parcelRequire("cCD8i");
var $4RvdQ = parcelRequire("4RvdQ");
var $5Adeg = parcelRequire("5Adeg");
var $fZPvU = parcelRequire("fZPvU");
var $gLbl5 = parcelRequire("gLbl5");

var $iCeeA = parcelRequire("iCeeA");

var $h8hpj = parcelRequire("h8hpj");
var $6a5TU = parcelRequire("6a5TU");

var $cTyLy = parcelRequire("cTyLy");

var $bh6RR = parcelRequire("bh6RR");
function $27f274996e1fead5$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $27f274996e1fead5$var$$2cbb7ca666678a14$exports = {};
$27f274996e1fead5$var$$2cbb7ca666678a14$exports = {
    "ar-AE": (0, $h9QBO.default),
    "bg-BG": (0, $c27Ny.default),
    "cs-CZ": (0, $iwZNZ.default),
    "da-DK": (0, $2znJD.default),
    "de-DE": (0, $dPEn7.default),
    "el-GR": (0, $fWydv.default),
    "en-US": (0, $00QPa.default),
    "es-ES": (0, $4RIqm.default),
    "et-EE": (0, $diImE.default),
    "fi-FI": (0, $6VgTe.default),
    "fr-FR": (0, $lDwT1.default),
    "he-IL": (0, $2wVIs.default),
    "hr-HR": (0, $2h6Dc.default),
    "hu-HU": (0, $aMtNA.default),
    "it-IT": (0, $2NmHA.default),
    "ja-JP": (0, $c0FSQ.default),
    "ko-KR": (0, $eMtmj.default),
    "lt-LT": (0, $2F4kn.default),
    "lv-LV": (0, $ajcbS.default),
    "nb-NO": (0, $e9Nt2.default),
    "nl-NL": (0, $4KRaR.default),
    "pl-PL": (0, $anBf6.default),
    "pt-BR": (0, $b8uJQ.default),
    "pt-PT": (0, $cn5tD.default),
    "ro-RO": (0, $1iX0Q.default),
    "ru-RU": (0, $d8NVS.default),
    "sk-SK": (0, $gVEiH.default),
    "sl-SI": (0, $ejud2.default),
    "sr-SP": (0, $coJnk.default),
    "sv-SE": (0, $7Ib26.default),
    "tr-TR": (0, $fWqNR.default),
    "uk-UA": (0, $dBOvo.default),
    "zh-CN": (0, $8g98I.default),
    "zh-TW": (0, $eKo5C.default)
};
function $27f274996e1fead5$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = "menu", isDisabled: isDisabled, trigger: trigger = "press" } = props;
    let menuTriggerId = (0, $43JEG.useId)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $iCeeA.useOverlayTrigger)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === "longPress" && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case "Enter":
            case " ":
                if (trigger === "longPress") return;
            // fallthrough
            case "ArrowDown":
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("first");
                break;
            case "ArrowUp":
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("last");
                break;
            default:
                // Allow other keys.
                if ("continuePropagation" in e) e.continuePropagation();
        }
    };
    let stringFormatter = (0, $atGLR.useLocalizedStringFormatter)(/*@__PURE__*/ $27f274996e1fead5$var$$parcel$interopDefault($27f274996e1fead5$var$$2cbb7ca666678a14$exports), "@react-aria/menu");
    let { longPressProps: longPressProps } = (0, $fZPvU.useLongPress)({
        isDisabled: isDisabled || trigger !== "longPress",
        accessibilityDescription: stringFormatter.format("longPressMessage"),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open("first");
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled) // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === "virtual" ? "first" : null);
        },
        onPress (e) {
            if (e.pointerType === "touch" && !isDisabled) state.toggle();
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === "press" ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            "aria-labelledby": menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $27f274996e1fead5$var$$d5336fe17ce95402$export$6f49b4016bfc8d56 = new WeakMap();
function $27f274996e1fead5$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...otherProps } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let domProps = (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $6a5TU.useSelectableList)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: "override"
    });
    $27f274996e1fead5$var$$d5336fe17ce95402$export$6f49b4016bfc8d56.set(state, {
        onClose: props.onClose,
        onAction: props.onAction
    });
    return {
        menuProps: (0, $dCyIs.mergeProps)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, {
            role: "menu",
            ...listProps,
            onKeyDown: (e)=>{
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== "Escape") listProps.onKeyDown(e);
            }
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $27f274996e1fead5$export$9d32628fc2aea7da(props, state, ref) {
    var _item_props;
    let { key: key, closeOnSelect: closeOnSelect, isVirtualized: isVirtualized, "aria-haspopup": hasPopup, onPressStart: pressStartProp, onPressUp: pressUpProp, onPress: onPress, onPressChange: onPressChange, onPressEnd: onPressEnd, onHoverStart: hoverStartProp, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onFocusChange: onFocusChange, onBlur: onBlur } = props;
    let isTrigger = !!hasPopup;
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    let data = $27f274996e1fead5$var$$d5336fe17ce95402$export$6f49b4016bfc8d56.get(state);
    let onClose = props.onClose || data.onClose;
    let onAction = isTrigger ? ()=>{} : props.onAction || data.onAction;
    let router = (0, $aCMC4.useRouter)();
    let performAction = (e)=>{
        if (onAction) onAction(key);
        if (e.target instanceof HTMLAnchorElement) router.open(e.target, e);
    };
    let role = "menuitem";
    if (!isTrigger) {
        if (state.selectionManager.selectionMode === "single") role = "menuitemradio";
        else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
    }
    let labelId = (0, $43JEG.useSlotId)();
    let descriptionId = (0, $43JEG.useSlotId)();
    let keyboardId = (0, $43JEG.useSlotId)();
    let ariaProps = {
        "aria-disabled": isDisabled || undefined,
        role: role,
        "aria-label": props["aria-label"],
        "aria-labelledby": labelId,
        "aria-describedby": [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(" ") || undefined,
        "aria-controls": props["aria-controls"],
        "aria-haspopup": hasPopup,
        "aria-expanded": props["aria-expanded"]
    };
    if (state.selectionManager.selectionMode !== "none" && !isTrigger) ariaProps["aria-checked"] = isSelected;
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        ariaProps["aria-posinset"] = item === null || item === void 0 ? void 0 : item.index;
        ariaProps["aria-setsize"] = (0, $cTyLy.getItemCount)(state.collection);
    }
    let onPressStart = (e)=>{
        if (e.pointerType === "keyboard") performAction(e);
        pressStartProp === null || pressStartProp === void 0 || pressStartProp(e);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== "keyboard") {
            performAction(e);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (!isTrigger && onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== "multiple" || state.selectionManager.isLink(key))) onClose();
        }
        pressUpProp === null || pressUpProp === void 0 || pressUpProp(e);
    };
    let { itemProps: itemProps, isFocused: isFocused } = (0, $h8hpj.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: "none"
    });
    let { pressProps: pressProps, isPressed: isPressed } = (0, $gLbl5.usePress)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps } = (0, $4RvdQ.useHover)({
        isDisabled: isDisabled,
        onHoverStart (e) {
            if (!(0, $gyK3a.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
            hoverStartProp === null || hoverStartProp === void 0 || hoverStartProp(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $5Adeg.useKeyboard)({
        onKeyDown: (e)=>{
            // Ignore repeating events, which may have started on the menu trigger before moving
            // focus to the menu item. We want to wait for a second complete key press sequence.
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case " ":
                    if (!isDisabled && state.selectionManager.selectionMode === "none" && !isTrigger && closeOnSelect !== false && onClose) onClose();
                    break;
                case "Enter":
                    // The Enter key should always close on select, except if overridden.
                    if (!isDisabled && closeOnSelect !== false && !isTrigger && onClose) onClose();
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
                    break;
            }
        },
        onKeyUp: onKeyUp
    });
    let { focusProps: focusProps } = (0, $cCD8i.useFocus)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    });
    let domProps = (0, $leZvJ.filterDOMProps)(item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href)
    });
    delete domProps.id;
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $dCyIs.mergeProps)(domProps, isTrigger ? {
                onFocus: itemProps.onFocus
            } : itemProps, pressProps, hoverProps, keyboardProps, focusProps),
            tabIndex: itemProps.tabIndex != null ? -1 : undefined
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $27f274996e1fead5$export$73f7a44322579622(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $43JEG.useId)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $27f274996e1fead5$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS = 2;
const $27f274996e1fead5$var$$d275435c250248f8$var$THROTTLE_TIME = 50;
const $27f274996e1fead5$var$$d275435c250248f8$var$TIMEOUT_TIME = 1000;
const $27f274996e1fead5$var$$d275435c250248f8$var$ANGLE_PADDING = Math.PI / 12; // 15°
function $27f274996e1fead5$var$$d275435c250248f8$export$85ec83e04c95f50a(options) {
    let { menuRef: menuRef, submenuRef: submenuRef, isOpen: isOpen, isDisabled: isDisabled } = options;
    let prevPointerPos = (0, $bh6RR.useRef)();
    let submenuRect = (0, $bh6RR.useRef)();
    let lastProcessedTime = (0, $bh6RR.useRef)(0);
    let timeout = (0, $bh6RR.useRef)();
    let autoCloseTimeout = (0, $bh6RR.useRef)();
    let submenuSide = (0, $bh6RR.useRef)();
    let movementsTowardsSubmenuCount = (0, $bh6RR.useRef)(2);
    let [preventPointerEvents, setPreventPointerEvents] = (0, $bh6RR.useState)(false);
    let updateSubmenuRect = ()=>{
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, $2oc8v.useResizeObserver)({
        ref: submenuRef,
        onResize: updateSubmenuRect
    });
    let reset = ()=>{
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = $27f274996e1fead5$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
    };
    let modality = (0, $gyK3a.useInteractionModality)();
    (0, $bh6RR.useEffect)(()=>{
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = "none";
        else menuRef.current.style.pointerEvents = "";
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, $bh6RR.useEffect)(()=>{
        let submenu = submenuRef.current;
        let menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== "pointer") {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        let onPointerMove = (e)=>{
            if (e.pointerType === "touch" || e.pointerType === "pen") return;
            let currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < $27f274996e1fead5$var$$d275435c250248f8$var$THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            let { clientX: mouseX, clientY: mouseY } = e;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? "left" : "right";
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ let prevMouseX = prevPointerPos.current.x;
            let prevMouseY = prevPointerPos.current.y;
            let toSubmenuX = submenuSide.current === "right" ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            let angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + $27f274996e1fead5$var$$d275435c250248f8$var$ANGLE_PADDING;
            let angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - $27f274996e1fead5$var$$d275435c250248f8$var$ANGLE_PADDING;
            let anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === "left" ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            let isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, $27f274996e1fead5$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= $27f274996e1fead5$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(()=>{
                reset();
                autoCloseTimeout.current = setTimeout(()=>{
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    let target = document.elementFromPoint(mouseX, mouseY);
                    if (target && menu.contains(target)) target.dispatchEvent(new PointerEvent("pointerover", {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, $27f274996e1fead5$var$$d275435c250248f8$var$TIMEOUT_TIME);
        };
        window.addEventListener("pointermove", onPointerMove);
        return ()=>{
            window.removeEventListener("pointermove", onPointerMove);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = $27f274996e1fead5$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        submenuRef
    ]);
}
function $27f274996e1fead5$export$3819f8ee9f4ce664(props, state, ref) {
    let { parentMenuRef: parentMenuRef, submenuRef: submenuRef, type: type = "menu", isDisabled: isDisabled, node: node, delay: delay = 200 } = props;
    let submenuTriggerId = (0, $43JEG.useId)();
    let overlayId = (0, $43JEG.useId)();
    let { direction: direction } = (0, $dG3Oc.useLocale)();
    let openTimeout = (0, $bh6RR.useRef)();
    let cancelOpenTimeout = (0, $bh6RR.useCallback)(()=>{
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    let onSubmenuOpen = (0, $77fRS.useEffectEvent)((focusStrategy)=>{
        cancelOpenTimeout();
        state.open(focusStrategy);
    });
    let onSubmenuClose = (0, $77fRS.useEffectEvent)(()=>{
        cancelOpenTimeout();
        state.close();
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    let submenuKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                if (direction === "ltr" && e.currentTarget.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    ref.current.focus();
                }
                break;
            case "ArrowRight":
                if (direction === "rtl" && e.currentTarget.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    ref.current.focus();
                }
                break;
            case "Escape":
                e.stopPropagation();
                state.closeAll();
                break;
        }
    };
    let submenuProps = {
        id: overlayId,
        "aria-label": node.textValue,
        submenuLevel: state.submenuLevel,
        ...type === "menu" && {
            onClose: state.closeAll,
            autoFocus: state.focusStrategy,
            onKeyDown: submenuKeyDown
        }
    };
    let submenuTriggerKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                if (!isDisabled) {
                    if (direction === "ltr") {
                        if (!state.isOpen) onSubmenuOpen("first");
                        if (type === "menu" && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case "ArrowLeft":
                if (!isDisabled) {
                    if (direction === "rtl") {
                        if (!state.isOpen) onSubmenuOpen("first");
                        if (type === "menu" && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case "Escape":
                state.closeAll();
                break;
            default:
                e.continuePropagation();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (!isDisabled && (e.pointerType === "virtual" || e.pointerType === "keyboard")) onSubmenuOpen("first");
    };
    let onPress = (e)=>{
        if (!isDisabled && (e.pointerType === "touch" || e.pointerType === "mouse")) // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    let onHoverChange = (isHovered)=>{
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(()=>{
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    let onBlur = (e)=>{
        if (state.isOpen && parentMenuRef.current.contains(e.relatedTarget)) onSubmenuClose();
    };
    let shouldCloseOnInteractOutside = (target)=>{
        if (target !== ref.current) return true;
        return false;
    };
    $27f274996e1fead5$var$$d275435c250248f8$export$85ec83e04c95f50a({
        menuRef: parentMenuRef,
        submenuRef: submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            id: submenuTriggerId,
            "aria-controls": state.isOpen ? overlayId : undefined,
            "aria-haspopup": !isDisabled ? type : undefined,
            "aria-expanded": state.isOpen ? "true" : "false",
            onPressStart: onPressStart,
            onPress: onPress,
            onHoverChange: onHoverChange,
            onKeyDown: submenuTriggerKeyDown,
            onBlur: onBlur,
            isOpen: state.isOpen
        },
        submenuProps: submenuProps,
        popoverProps: {
            isNonModal: true,
            disableFocusManagement: true,
            shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
        }
    };
}

});
parcelRegister("h9QBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7dc15f7d7f079f0$export$2e2bcd8739ae039; });
var $c7dc15f7d7f079f0$export$2e2bcd8739ae039 = {};
$c7dc15f7d7f079f0$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};

});

parcelRegister("c27Ny", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c2bb886d85d29e2$export$2e2bcd8739ae039; });
var $8c2bb886d85d29e2$export$2e2bcd8739ae039 = {};
$8c2bb886d85d29e2$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};

});

parcelRegister("iwZNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7db286183e46d0d$export$2e2bcd8739ae039; });
var $d7db286183e46d0d$export$2e2bcd8739ae039 = {};
$d7db286183e46d0d$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};

});

parcelRegister("2znJD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1df142f55415d07a$export$2e2bcd8739ae039; });
var $1df142f55415d07a$export$2e2bcd8739ae039 = {};
$1df142f55415d07a$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};

});

parcelRegister("dPEn7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a11f5ad1bdc215e7$export$2e2bcd8739ae039; });
var $a11f5ad1bdc215e7$export$2e2bcd8739ae039 = {};
$a11f5ad1bdc215e7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};

});

parcelRegister("fWydv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b6d087d5ce6f3d$export$2e2bcd8739ae039; });
var $b9b6d087d5ce6f3d$export$2e2bcd8739ae039 = {};
$b9b6d087d5ce6f3d$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};

});

parcelRegister("00QPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0000a931ac3f2896$export$2e2bcd8739ae039; });
var $0000a931ac3f2896$export$2e2bcd8739ae039 = {};
$0000a931ac3f2896$export$2e2bcd8739ae039 = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};

});

parcelRegister("4RIqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ae9261a92c3ed0$export$2e2bcd8739ae039; });
var $38ae9261a92c3ed0$export$2e2bcd8739ae039 = {};
$38ae9261a92c3ed0$export$2e2bcd8739ae039 = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};

});

parcelRegister("diImE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aef5e9c6b504ef7$export$2e2bcd8739ae039; });
var $9aef5e9c6b504ef7$export$2e2bcd8739ae039 = {};
$9aef5e9c6b504ef7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};

});

parcelRegister("6VgTe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50a52aed6d57c5c9$export$2e2bcd8739ae039; });
var $50a52aed6d57c5c9$export$2e2bcd8739ae039 = {};
$50a52aed6d57c5c9$export$2e2bcd8739ae039 = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};

});

parcelRegister("lDwT1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0410a0004e876f9a$export$2e2bcd8739ae039; });
var $0410a0004e876f9a$export$2e2bcd8739ae039 = {};
$0410a0004e876f9a$export$2e2bcd8739ae039 = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};

});

parcelRegister("2wVIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d7b572581facb64$export$2e2bcd8739ae039; });
var $1d7b572581facb64$export$2e2bcd8739ae039 = {};
$1d7b572581facb64$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};

});

parcelRegister("2h6Dc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a82501bae748f7f$export$2e2bcd8739ae039; });
var $1a82501bae748f7f$export$2e2bcd8739ae039 = {};
$1a82501bae748f7f$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};

});

parcelRegister("aMtNA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d958083cb51937f$export$2e2bcd8739ae039; });
var $7d958083cb51937f$export$2e2bcd8739ae039 = {};
$7d958083cb51937f$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};

});

parcelRegister("2NmHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2091c482c9565e13$export$2e2bcd8739ae039; });
var $2091c482c9565e13$export$2e2bcd8739ae039 = {};
$2091c482c9565e13$export$2e2bcd8739ae039 = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu`
};

});

parcelRegister("c0FSQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8be5f9549606c991$export$2e2bcd8739ae039; });
var $8be5f9549606c991$export$2e2bcd8739ae039 = {};
$8be5f9549606c991$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};

});

parcelRegister("eMtmj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac2c526ec87b25bf$export$2e2bcd8739ae039; });
var $ac2c526ec87b25bf$export$2e2bcd8739ae039 = {};
$ac2c526ec87b25bf$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};

});

parcelRegister("2F4kn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f02c483c65669db$export$2e2bcd8739ae039; });
var $1f02c483c65669db$export$2e2bcd8739ae039 = {};
$1f02c483c65669db$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};

});

parcelRegister("ajcbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $781522822848fd30$export$2e2bcd8739ae039; });
var $781522822848fd30$export$2e2bcd8739ae039 = {};
$781522822848fd30$export$2e2bcd8739ae039 = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};

});

parcelRegister("e9Nt2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4e84721bfe5aef9$export$2e2bcd8739ae039; });
var $a4e84721bfe5aef9$export$2e2bcd8739ae039 = {};
$a4e84721bfe5aef9$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};

});

parcelRegister("4KRaR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3764b498da98cab3$export$2e2bcd8739ae039; });
var $3764b498da98cab3$export$2e2bcd8739ae039 = {};
$3764b498da98cab3$export$2e2bcd8739ae039 = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};

});

parcelRegister("anBf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78e8f0f525839a79$export$2e2bcd8739ae039; });
var $78e8f0f525839a79$export$2e2bcd8739ae039 = {};
$78e8f0f525839a79$export$2e2bcd8739ae039 = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};

});

parcelRegister("b8uJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81b849157925d11b$export$2e2bcd8739ae039; });
var $81b849157925d11b$export$2e2bcd8739ae039 = {};
$81b849157925d11b$export$2e2bcd8739ae039 = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};

});

parcelRegister("cn5tD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $901be19cefe7e0e1$export$2e2bcd8739ae039; });
var $901be19cefe7e0e1$export$2e2bcd8739ae039 = {};
$901be19cefe7e0e1$export$2e2bcd8739ae039 = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};

});

parcelRegister("1iX0Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f353f8db9e59a9e$export$2e2bcd8739ae039; });
var $0f353f8db9e59a9e$export$2e2bcd8739ae039 = {};
$0f353f8db9e59a9e$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};

});

parcelRegister("d8NVS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9912c1418518a181$export$2e2bcd8739ae039; });
var $9912c1418518a181$export$2e2bcd8739ae039 = {};
$9912c1418518a181$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("gVEiH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5313b17028bcfe1$export$2e2bcd8739ae039; });
var $c5313b17028bcfe1$export$2e2bcd8739ae039 = {};
$c5313b17028bcfe1$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};

});

parcelRegister("ejud2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6ba45f5defd9a80$export$2e2bcd8739ae039; });
var $a6ba45f5defd9a80$export$2e2bcd8739ae039 = {};
$a6ba45f5defd9a80$export$2e2bcd8739ae039 = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};

});

parcelRegister("coJnk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $906aec872152f63a$export$2e2bcd8739ae039; });
var $906aec872152f63a$export$2e2bcd8739ae039 = {};
$906aec872152f63a$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};

});

parcelRegister("7Ib26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59d53361cf5c2698$export$2e2bcd8739ae039; });
var $59d53361cf5c2698$export$2e2bcd8739ae039 = {};
$59d53361cf5c2698$export$2e2bcd8739ae039 = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};

});

parcelRegister("fWqNR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b1105ebb13e7a2$export$2e2bcd8739ae039; });
var $b9b1105ebb13e7a2$export$2e2bcd8739ae039 = {};
$b9b1105ebb13e7a2$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};

});

parcelRegister("dBOvo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e85e864a4e2a8df$export$2e2bcd8739ae039; });
var $9e85e864a4e2a8df$export$2e2bcd8739ae039 = {};
$9e85e864a4e2a8df$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("8g98I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6036e846d1764dd8$export$2e2bcd8739ae039; });
var $6036e846d1764dd8$export$2e2bcd8739ae039 = {};
$6036e846d1764dd8$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};

});

parcelRegister("eKo5C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc80c48b7d6b29d$export$2e2bcd8739ae039; });
var $abc80c48b7d6b29d$export$2e2bcd8739ae039 = {};
$abc80c48b7d6b29d$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};

});

parcelRegister("gyK3a", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $c0e38ae9e5a4fe7e$export$b9b3dfddab17db27; });
$parcel$export(module.exports, "useInteractionModality", function () { return $c0e38ae9e5a4fe7e$export$98e20ec92f614cfe; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality = null;
let $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $c0e38ae9e5a4fe7e$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $c0e38ae9e5a4fe7e$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $c0e38ae9e5a4fe7e$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$c0e38ae9e5a4fe7e$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $c0e38ae9e5a4fe7e$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $c0e38ae9e5a4fe7e$export$d90243b58daecda7.delete(windowObject);
};
function $c0e38ae9e5a4fe7e$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $c0e38ae9e5a4fe7e$export$2f1888112f558a7d();
function $c0e38ae9e5a4fe7e$export$b9b3dfddab17db27() {
    return $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $c0e38ae9e5a4fe7e$export$630ff653c5ada6a9() {
    return $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality;
}
function $c0e38ae9e5a4fe7e$export$8397ddfc504fdb9a(modality) {
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality = modality;
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $c0e38ae9e5a4fe7e$export$98e20ec92f614cfe() {
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$currentModality);
        };
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $c0e38ae9e5a4fe7e$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $c0e38ae9e5a4fe7e$export$b9b3dfddab17db27());
    $c0e38ae9e5a4fe7e$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $c0e38ae9e5a4fe7e$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($c0e38ae9e5a4fe7e$export$b9b3dfddab17db27());
        };
        $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $c0e38ae9e5a4fe7e$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("cCD8i", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $9307639632bb165b$export$f8168d8dd8fd66e6; });

var $guU5f = parcelRequire("guU5f");

var $bh6RR = parcelRequire("bh6RR");

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $9307639632bb165b$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $guU5f.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $ld26B.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("guU5f", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $c02af3b452bf68fa$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $c02af3b452bf68fa$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $c02af3b452bf68fa$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $c02af3b452bf68fa$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("4RvdQ", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $38a454c3ef9e767e$export$ae780daf29e6d456; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $38a454c3ef9e767e$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $38a454c3ef9e767e$var$$6179b936705e76d3$var$hoverCount = 0;
function $38a454c3ef9e767e$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $38a454c3ef9e767e$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $38a454c3ef9e767e$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $38a454c3ef9e767e$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $38a454c3ef9e767e$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $38a454c3ef9e767e$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $38a454c3ef9e767e$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $38a454c3ef9e767e$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $38a454c3ef9e767e$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $38a454c3ef9e767e$var$$6179b936705e76d3$var$hoverCount--;
        if ($38a454c3ef9e767e$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $38a454c3ef9e767e$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $38a454c3ef9e767e$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $38a454c3ef9e767e$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $bh6RR.useState)(false);
    let state = (0, $bh6RR.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $bh6RR.useEffect)($38a454c3ef9e767e$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $bh6RR.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($38a454c3ef9e767e$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$38a454c3ef9e767e$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $bh6RR.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});

parcelRegister("5Adeg", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $410a938d35d5dbc1$export$8f71654801c2f7cd; });

var $9vCwd = parcelRequire("9vCwd");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $410a938d35d5dbc1$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $9vCwd.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $9vCwd.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("9vCwd", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $6ec4e34fccb9ec0d$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6ec4e34fccb9ec0d$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});


parcelRegister("fZPvU", function(module, exports) {

$parcel$export(module.exports, "useLongPress", function () { return $03015cf3c9780fcf$export$c24ed0104d07eab9; });

var $gLbl5 = parcelRequire("gLbl5");

var $dCyIs = parcelRequire("dCyIs");
var $9IUYG = parcelRequire("9IUYG");
var $1mw9Z = parcelRequire("1mw9Z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $03015cf3c9780fcf$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $03015cf3c9780fcf$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $03015cf3c9780fcf$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $bh6RR.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $1mw9Z.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $gLbl5.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $9IUYG.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $dCyIs.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("gLbl5", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $c339d4d1c2f996b5$export$45712eceda6fad21; });

var $l4SSq = parcelRequire("l4SSq");

var $h1aS2 = parcelRequire("h1aS2");

var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $77fRS = parcelRequire("77fRS");
var $1mw9Z = parcelRequire("1mw9Z");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $h1aS2.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $c339d4d1c2f996b5$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $l4SSq.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $l4SSq.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $l4SSq.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $l4SSq.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $l4SSq.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $l4SSq.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $c339d4d1c2f996b5$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("l4SSq", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $f5848a12f30c71a9$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $f5848a12f30c71a9$export$b0d6fa1ab32e3295; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $8l8s9 = parcelRequire("8l8s9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $f5848a12f30c71a9$var$$14c0b72509d70225$var$state = "default";
let $f5848a12f30c71a9$var$$14c0b72509d70225$var$savedUserSelect = "";
let $f5848a12f30c71a9$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $f5848a12f30c71a9$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($f5848a12f30c71a9$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $f5848a12f30c71a9$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $f5848a12f30c71a9$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $f5848a12f30c71a9$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $f5848a12f30c71a9$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($f5848a12f30c71a9$var$$14c0b72509d70225$var$state !== "disabled") return;
        $f5848a12f30c71a9$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($f5848a12f30c71a9$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $f5848a12f30c71a9$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $f5848a12f30c71a9$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $f5848a12f30c71a9$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $f5848a12f30c71a9$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $f5848a12f30c71a9$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $f5848a12f30c71a9$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("h1aS2", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $c63af65c50dfeaea$export$5165eccb35aaadb5; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c63af65c50dfeaea$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$c63af65c50dfeaea$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});



parcelRegister("iCeeA", function(module, exports) {

$parcel$export(module.exports, "useOverlayTrigger", function () { return $d8d6d137007a1a0f$export$f9d5c8beee7d008d; });

var $A8pfx = parcelRequire("A8pfx");

var $bh6RR = parcelRequire("bh6RR");

var $43JEG = parcelRequire("43JEG");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d8d6d137007a1a0f$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $bh6RR.useEffect)(()=>{
        if (ref && ref.current) (0, $A8pfx.onCloseMap).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, $43JEG.useId)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}

});
parcelRegister("A8pfx", function(module, exports) {

$parcel$export(module.exports, "onCloseMap", function () { return $06c9e236c84d8d81$export$f6211563215e3b37; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $06c9e236c84d8d81$export$f6211563215e3b37 = new WeakMap();
function $06c9e236c84d8d81$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $bh6RR.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $06c9e236c84d8d81$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}

});


parcelRegister("h8hpj", function(module, exports) {

$parcel$export(module.exports, "useSelectableItem", function () { return $c790afb86f856ef3$export$ecf600387e221c37; });

var $7cw9l = parcelRequire("7cw9l");

var $eZzBL = parcelRequire("eZzBL");

var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");

var $4s08w = parcelRequire("4s08w");
var $3cKpv = parcelRequire("3cKpv");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c790afb86f856ef3$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $aCMC4.useRouter)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && (0, $7cw9l.isNonContiguousSelectionModifier)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ((0, $7cw9l.isCtrlKeyPressed)(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $eZzBL.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $bh6RR.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $bh6RR.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $bh6RR.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) {
            let itemProps = manager.getItemProps(key);
            router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
        }
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $c790afb86f856ef3$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$c790afb86f856ef3$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $c790afb86f856ef3$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $c790afb86f856ef3$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $3cKpv.usePress)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $4s08w.useLongPress)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $aCMC4.openLink).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $dCyIs.mergeProps)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $c790afb86f856ef3$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $c790afb86f856ef3$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}

});
parcelRegister("7cw9l", function(module, exports) {

$parcel$export(module.exports, "isNonContiguousSelectionModifier", function () { return $53e297aaff9b33c0$export$d3e3bd3e26688c04; });
$parcel$export(module.exports, "isCtrlKeyPressed", function () { return $53e297aaff9b33c0$export$16792effe837dba3; });

var $kI2if = parcelRequire("kI2if");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $53e297aaff9b33c0$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $kI2if.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function $53e297aaff9b33c0$export$16792effe837dba3(e) {
    if ((0, $kI2if.isMac)()) return e.metaKey;
    return e.ctrlKey;
}

});

parcelRegister("eZzBL", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $aea2623c65d08a33$export$80f3e147d781571c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $emMqH = parcelRequire("emMqH");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $aea2623c65d08a33$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $emMqH.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}

});
parcelRegister("emMqH", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $a758afe2a5cfe00c$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality = null;
let $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $a758afe2a5cfe00c$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $a758afe2a5cfe00c$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $a758afe2a5cfe00c$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$a758afe2a5cfe00c$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $a758afe2a5cfe00c$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $a758afe2a5cfe00c$export$d90243b58daecda7.delete(windowObject);
};
function $a758afe2a5cfe00c$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $a758afe2a5cfe00c$export$2f1888112f558a7d();
function $a758afe2a5cfe00c$export$b9b3dfddab17db27() {
    return $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $a758afe2a5cfe00c$export$630ff653c5ada6a9() {
    return $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality;
}
function $a758afe2a5cfe00c$export$8397ddfc504fdb9a(modality) {
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $a758afe2a5cfe00c$export$98e20ec92f614cfe() {
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $a758afe2a5cfe00c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $a758afe2a5cfe00c$export$b9b3dfddab17db27());
    $a758afe2a5cfe00c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $a758afe2a5cfe00c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($a758afe2a5cfe00c$export$b9b3dfddab17db27());
        };
        $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $a758afe2a5cfe00c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("4s08w", function(module, exports) {

$parcel$export(module.exports, "useLongPress", function () { return $33d9e20d2ae0bd5a$export$c24ed0104d07eab9; });

var $3cKpv = parcelRequire("3cKpv");

var $dCyIs = parcelRequire("dCyIs");
var $9IUYG = parcelRequire("9IUYG");
var $1mw9Z = parcelRequire("1mw9Z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $33d9e20d2ae0bd5a$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $33d9e20d2ae0bd5a$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $33d9e20d2ae0bd5a$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $bh6RR.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $1mw9Z.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $3cKpv.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $9IUYG.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $dCyIs.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("3cKpv", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $25567e3473f82bab$export$45712eceda6fad21; });

var $4dPVt = parcelRequire("4dPVt");

var $5EOPZ = parcelRequire("5EOPZ");

var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $77fRS = parcelRequire("77fRS");
var $1mw9Z = parcelRequire("1mw9Z");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $5EOPZ.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $25567e3473f82bab$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $25567e3473f82bab$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $25567e3473f82bab$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $25567e3473f82bab$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $25567e3473f82bab$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $25567e3473f82bab$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $25567e3473f82bab$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $25567e3473f82bab$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $25567e3473f82bab$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $25567e3473f82bab$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $25567e3473f82bab$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $25567e3473f82bab$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $25567e3473f82bab$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $4dPVt.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$25567e3473f82bab$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$25567e3473f82bab$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $4dPVt.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $4dPVt.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $25567e3473f82bab$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $4dPVt.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $25567e3473f82bab$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $25567e3473f82bab$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $4dPVt.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $4dPVt.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$25567e3473f82bab$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $25567e3473f82bab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $25567e3473f82bab$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $25567e3473f82bab$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$25567e3473f82bab$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($25567e3473f82bab$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $25567e3473f82bab$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $25567e3473f82bab$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $25567e3473f82bab$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("4dPVt", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $3130a7be81ce6512$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $3130a7be81ce6512$export$b0d6fa1ab32e3295; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $8l8s9 = parcelRequire("8l8s9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $3130a7be81ce6512$var$$14c0b72509d70225$var$state = "default";
let $3130a7be81ce6512$var$$14c0b72509d70225$var$savedUserSelect = "";
let $3130a7be81ce6512$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $3130a7be81ce6512$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($3130a7be81ce6512$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $3130a7be81ce6512$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $3130a7be81ce6512$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $3130a7be81ce6512$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $3130a7be81ce6512$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($3130a7be81ce6512$var$$14c0b72509d70225$var$state !== "disabled") return;
        $3130a7be81ce6512$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($3130a7be81ce6512$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $3130a7be81ce6512$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $3130a7be81ce6512$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $3130a7be81ce6512$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $3130a7be81ce6512$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $3130a7be81ce6512$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $3130a7be81ce6512$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("5EOPZ", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $41e81f71ae0361c0$export$5165eccb35aaadb5; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $41e81f71ae0361c0$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$41e81f71ae0361c0$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});




parcelRegister("6a5TU", function(module, exports) {

$parcel$export(module.exports, "useSelectableList", function () { return $47c840ff92a02dc8$export$b95089534ab7c1fd; });

var $4RcIn = parcelRequire("4RcIn");

var $lUkD6 = parcelRequire("lUkD6");

var $i6bwP = parcelRequire("i6bwP");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $47c840ff92a02dc8$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $i6bwP.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $bh6RR.useMemo)(()=>keyboardDelegate || new (0, $lUkD6.ListKeyboardDelegate)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator
        }), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = (0, $4RcIn.useSelectableCollection)({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

});
parcelRegister("4RcIn", function(module, exports) {

$parcel$export(module.exports, "useSelectableCollection", function () { return $3895f98bac23c690$export$d6daf82dcd84e87c; });

var $7cw9l = parcelRequire("7cw9l");

var $2h7Mj = parcelRequire("2h7Mj");

var $6afFj = parcelRequire("6afFj");

var $bh6RR = parcelRequire("bh6RR");

var $eZzBL = parcelRequire("eZzBL");
var $0KYXM = parcelRequire("0KYXM");

var $61nPD = parcelRequire("61nPD");
var $dCyIs = parcelRequire("dCyIs");
var $h4wtR = parcelRequire("h4wtR");
var $gsEnF = parcelRequire("gsEnF");
var $aCMC4 = parcelRequire("aCMC4");

var $emMqH = parcelRequire("emMqH");

var $dG3Oc = parcelRequire("dG3Oc");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3895f98bac23c690$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $dG3Oc.useLocale)();
    let router = (0, $aCMC4.useRouter)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !(0, $7cw9l.isNonContiguousSelectionModifier)(e)) {
                    (0, $6afFj.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    let itemProps = manager.getItemProps(key);
                    router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !(0, $7cw9l.isNonContiguousSelectionModifier)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $7cw9l.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(firstKey);
                    if ((0, $7cw9l.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, $7cw9l.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(lastKey);
                    if ((0, $7cw9l.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ((0, $7cw9l.isCtrlKeyPressed)(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                if (!disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $0KYXM.getFocusableTreeWalker)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $61nPD.focusWithoutScrolling)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $bh6RR.useRef)({
        top: 0,
        left: 0
    });
    (0, $gsEnF.useEvent)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $61nPD.focusWithoutScrolling)(element);
                let modality = (0, $emMqH.getInteractionModality)();
                if (modality === "keyboard") (0, $h4wtR.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $bh6RR.useRef)(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $eZzBL.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, $bh6RR.useRef)(manager.focusedKey);
    (0, $bh6RR.useEffect)(()=>{
        let modality = (0, $emMqH.getInteractionModality)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element && (modality === "keyboard" || autoFocusRef.current)) {
                if (!isVirtualized) (0, $h4wtR.scrollIntoView)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, $h4wtR.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $eZzBL.focusSafely)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $2h7Mj.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $dCyIs.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}

});
parcelRegister("2h7Mj", function(module, exports) {

$parcel$export(module.exports, "useTypeSelect", function () { return $1a8333e53e1df8d2$export$e32c88dfddc6e1d8; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $1a8333e53e1df8d2$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $1a8333e53e1df8d2$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $bh6RR.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $1a8333e53e1df8d2$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $1a8333e53e1df8d2$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $1a8333e53e1df8d2$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}

});

parcelRegister("0KYXM", function(module, exports) {

$parcel$export(module.exports, "getFocusableTreeWalker", function () { return $002471e736a2365d$export$2d6ec8fc375ceafa; });

var $eZzBL = parcelRequire("eZzBL");

var $l58Ku = parcelRequire("l58Ku");

var $ld26B = parcelRequire("ld26B");
var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $002471e736a2365d$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
let $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = null;
function $002471e736a2365d$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $bh6RR.useRef)(null);
    let endRef = (0, $bh6RR.useRef)(null);
    let scopeRef = (0, $bh6RR.useRef)([]);
    let { parentNode: parentNode } = (0, $bh6RR.useContext)($002471e736a2365d$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $bh6RR.useMemo)(()=>new $002471e736a2365d$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $002471e736a2365d$export$d06fae2ee68b101e.root;
        if ($002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope && !$002471e736a2365d$var$$9bf71ea28793e738$var$isAncestorScope($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $002471e736a2365d$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let node = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $002471e736a2365d$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $002471e736a2365d$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $002471e736a2365d$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $002471e736a2365d$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        const activeElement = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $002471e736a2365d$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope || $002471e736a2365d$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(parentScope))) $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $002471e736a2365d$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $bh6RR.useMemo)(()=>$002471e736a2365d$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $bh6RR.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($002471e736a2365d$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $002471e736a2365d$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($002471e736a2365d$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $002471e736a2365d$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $002471e736a2365d$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $002471e736a2365d$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$002471e736a2365d$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $002471e736a2365d$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $002471e736a2365d$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $002471e736a2365d$export$4c063cf1350e6fed(element) {
    return element.matches($002471e736a2365d$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $bh6RR.useRef)();
    let raf = (0, $bh6RR.useRef)();
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$002471e736a2365d$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$002471e736a2365d$var$$9bf71ea28793e738$var$activeScope || $002471e736a2365d$var$$9bf71ea28793e738$var$isAncestorScope($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($002471e736a2365d$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope && $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope.current) $002471e736a2365d$var$$9bf71ea28793e738$var$focusFirstInScope($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($002471e736a2365d$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $002471e736a2365d$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope.current) $002471e736a2365d$var$$9bf71ea28793e738$var$focusFirstInScope($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $002471e736a2365d$export$d06fae2ee68b101e.traverse($002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $002471e736a2365d$export$1258395f99bf9cbf(element) {
    return $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInChildScope(element, $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope);
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $eZzBL.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $002471e736a2365d$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $002471e736a2365d$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $002471e736a2365d$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $bh6RR.useRef)(typeof document !== "undefined" ? (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$002471e736a2365d$var$$9bf71ea28793e738$var$activeScope || $002471e736a2365d$var$$9bf71ea28793e738$var$isAncestorScope($002471e736a2365d$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $002471e736a2365d$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$002471e736a2365d$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$002471e736a2365d$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $002471e736a2365d$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $002471e736a2365d$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $002471e736a2365d$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $002471e736a2365d$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $002471e736a2365d$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $002471e736a2365d$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $002471e736a2365d$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $ld26B.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $l58Ku.isElementVisible)(node) && (!scope || $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $002471e736a2365d$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $002471e736a2365d$var$$9bf71ea28793e738$var$last(walker);
                if (next) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $002471e736a2365d$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $002471e736a2365d$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $002471e736a2365d$var$$9bf71ea28793e738$var$last(walker);
            if (next) $002471e736a2365d$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $002471e736a2365d$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $002471e736a2365d$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $002471e736a2365d$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $002471e736a2365d$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $002471e736a2365d$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $002471e736a2365d$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $002471e736a2365d$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $002471e736a2365d$export$d06fae2ee68b101e = new $002471e736a2365d$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("l58Ku", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $f590d9ee0ca60836$export$e989c0fffaa6b27a; });

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f590d9ee0ca60836$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $f590d9ee0ca60836$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $f590d9ee0ca60836$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $f590d9ee0ca60836$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $f590d9ee0ca60836$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $f590d9ee0ca60836$export$e989c0fffaa6b27a(element.parentElement, element));
}

});



parcelRegister("lUkD6", function(module, exports) {

$parcel$export(module.exports, "ListKeyboardDelegate", function () { return $ff2ed492e07177e8$export$a05409b8bb224a5a; });

var $eiwoe = parcelRequire("eiwoe");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $ff2ed492e07177e8$export$a05409b8bb224a5a {
    isDisabled(item) {
        var _item_props;
        return this.disabledBehavior === "all" && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return key !== null ? this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`) : null;
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $eiwoe.isScrollable)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $eiwoe.isScrollable)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || "all";
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
            this.disabledBehavior = "all";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}

});


parcelRegister("cTyLy", function(module, exports) {

$parcel$export(module.exports, "getItemCount", function () { return $963596eb8f393ce6$export$77d5aafae4e095b2; });

var $98tKj = parcelRequire("98tKj");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $963596eb8f393ce6$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $963596eb8f393ce6$export$77d5aafae4e095b2(collection) {
    let count = $963596eb8f393ce6$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === "section") countItems((0, $98tKj.getChildNodes)(item, collection));
        else count++;
    };
    countItems(collection);
    $963596eb8f393ce6$var$$453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}

});


parcelRegister("2FbWw", function(module, exports) {

$parcel$export(module.exports, "useTypeSelect", function () { return $1f08acb2480706dc$export$e32c88dfddc6e1d8; });
$parcel$export(module.exports, "ListKeyboardDelegate", function () { return $1f08acb2480706dc$export$a05409b8bb224a5a; });

var $6afFj = parcelRequire("6afFj");

var $bh6RR = parcelRequire("bh6RR");

var $hR9sS = parcelRequire("hR9sS");
var $aqr6D = parcelRequire("aqr6D");

var $61nPD = parcelRequire("61nPD");
var $kI2if = parcelRequire("kI2if");
var $eiwoe = parcelRequire("eiwoe");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $h4wtR = parcelRequire("h4wtR");
var $gsEnF = parcelRequire("gsEnF");

var $8kcox = parcelRequire("8kcox");
var $kJy9d = parcelRequire("kJy9d");
var $iWCBs = parcelRequire("iWCBs");

var $3Oi9j = parcelRequire("3Oi9j");
var $lbbbW = parcelRequire("lbbbW");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1f08acb2480706dc$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $kI2if.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function $1f08acb2480706dc$var$$feb5ffebff200149$export$16792effe837dba3(e) {
    if ((0, $kI2if.isMac)()) return e.metaKey;
    return e.ctrlKey;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $1f08acb2480706dc$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $1f08acb2480706dc$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $bh6RR.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $1f08acb2480706dc$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $1f08acb2480706dc$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $1f08acb2480706dc$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}
function $1f08acb2480706dc$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $lbbbW.useLocale)();
    let router = (0, $aCMC4.useRouter)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !$1f08acb2480706dc$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) {
                    (0, $6afFj.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    router.open(item, e);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !$1f08acb2480706dc$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, $1f08acb2480706dc$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(firstKey);
                    if ($1f08acb2480706dc$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, $1f08acb2480706dc$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(lastKey);
                    if ($1f08acb2480706dc$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ($1f08acb2480706dc$var$$feb5ffebff200149$export$16792effe837dba3(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $aqr6D.getFocusableTreeWalker)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $61nPD.focusWithoutScrolling)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $bh6RR.useRef)({
        top: 0,
        left: 0
    });
    (0, $gsEnF.useEvent)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $61nPD.focusWithoutScrolling)(element);
                let modality = (0, $8kcox.getInteractionModality)();
                if (modality === "keyboard") (0, $h4wtR.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $bh6RR.useRef)(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $hR9sS.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, $bh6RR.useRef)(manager.focusedKey);
    (0, $bh6RR.useEffect)(()=>{
        let modality = (0, $8kcox.getInteractionModality)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element && (modality === "keyboard" || autoFocusRef.current)) {
                if (!isVirtualized) (0, $h4wtR.scrollIntoView)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, $h4wtR.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $hR9sS.focusSafely)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = $1f08acb2480706dc$export$e32c88dfddc6e1d8({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $dCyIs.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1f08acb2480706dc$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $aCMC4.useRouter)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && $1f08acb2480706dc$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    router.open(ref.current, e);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ($1f08acb2480706dc$var$$feb5ffebff200149$export$16792effe837dba3(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $hR9sS.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $bh6RR.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $bh6RR.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $bh6RR.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) router.open(ref.current, e);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $1f08acb2480706dc$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$1f08acb2480706dc$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $1f08acb2480706dc$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $1f08acb2480706dc$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $iWCBs.usePress)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $kJy9d.useLongPress)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $aCMC4.openLink).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $dCyIs.mergeProps)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $1f08acb2480706dc$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $1f08acb2480706dc$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $1f08acb2480706dc$export$a05409b8bb224a5a {
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $eiwoe.isScrollable)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $eiwoe.isScrollable)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}
function $1f08acb2480706dc$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $3Oi9j.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $bh6RR.useMemo)(()=>keyboardDelegate || new $1f08acb2480706dc$export$a05409b8bb224a5a(collection, disabledBehavior === "selection" ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = $1f08acb2480706dc$export$d6daf82dcd84e87c({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

});
parcelRegister("hR9sS", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $cffeba6ec7c1141d$export$80f3e147d781571c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $5CNLZ = parcelRequire("5CNLZ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cffeba6ec7c1141d$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $5CNLZ.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}

});
parcelRegister("5CNLZ", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $41871c45a426281d$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality = null;
let $41871c45a426281d$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $41871c45a426281d$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $41871c45a426281d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $41871c45a426281d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $41871c45a426281d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $41871c45a426281d$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $41871c45a426281d$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $41871c45a426281d$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($41871c45a426281d$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $41871c45a426281d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $41871c45a426281d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $41871c45a426281d$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $41871c45a426281d$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$41871c45a426281d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $41871c45a426281d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $41871c45a426281d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $41871c45a426281d$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $41871c45a426281d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $41871c45a426281d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $41871c45a426281d$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $41871c45a426281d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $41871c45a426281d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $41871c45a426281d$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $41871c45a426281d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$41871c45a426281d$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $41871c45a426281d$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $41871c45a426281d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $41871c45a426281d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $41871c45a426281d$export$d90243b58daecda7.delete(windowObject);
};
function $41871c45a426281d$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $41871c45a426281d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $41871c45a426281d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$41871c45a426281d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $41871c45a426281d$export$2f1888112f558a7d();
function $41871c45a426281d$export$b9b3dfddab17db27() {
    return $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $41871c45a426281d$export$630ff653c5ada6a9() {
    return $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality;
}
function $41871c45a426281d$export$8397ddfc504fdb9a(modality) {
    $41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality = modality;
    $41871c45a426281d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $41871c45a426281d$export$98e20ec92f614cfe() {
    $41871c45a426281d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($41871c45a426281d$var$$507fabe10e71c6fb$var$currentModality);
        };
        $41871c45a426281d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $41871c45a426281d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $41871c45a426281d$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $41871c45a426281d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$41871c45a426281d$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$41871c45a426281d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $41871c45a426281d$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $41871c45a426281d$export$b9b3dfddab17db27());
    $41871c45a426281d$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $41871c45a426281d$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $41871c45a426281d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$41871c45a426281d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($41871c45a426281d$export$b9b3dfddab17db27());
        };
        $41871c45a426281d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $41871c45a426281d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("aqr6D", function(module, exports) {

$parcel$export(module.exports, "getFocusableTreeWalker", function () { return $79715bc82841e75f$export$2d6ec8fc375ceafa; });

var $hR9sS = parcelRequire("hR9sS");

var $jQuQH = parcelRequire("jQuQH");

var $ld26B = parcelRequire("ld26B");
var $1nsPC = parcelRequire("1nsPC");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $79715bc82841e75f$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
let $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = null;
function $79715bc82841e75f$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $bh6RR.useRef)(null);
    let endRef = (0, $bh6RR.useRef)(null);
    let scopeRef = (0, $bh6RR.useRef)([]);
    let { parentNode: parentNode } = (0, $bh6RR.useContext)($79715bc82841e75f$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $bh6RR.useMemo)(()=>new $79715bc82841e75f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $79715bc82841e75f$export$d06fae2ee68b101e.root;
        if ($79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope && !$79715bc82841e75f$var$$9bf71ea28793e738$var$isAncestorScope($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $79715bc82841e75f$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let node = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $79715bc82841e75f$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $79715bc82841e75f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $79715bc82841e75f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $79715bc82841e75f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        const activeElement = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $79715bc82841e75f$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope || $79715bc82841e75f$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(parentScope))) $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $79715bc82841e75f$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $bh6RR.useMemo)(()=>$79715bc82841e75f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $bh6RR.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($79715bc82841e75f$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $79715bc82841e75f$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($79715bc82841e75f$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $79715bc82841e75f$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $79715bc82841e75f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $79715bc82841e75f$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$79715bc82841e75f$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $79715bc82841e75f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $79715bc82841e75f$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $79715bc82841e75f$export$4c063cf1350e6fed(element) {
    return element.matches($79715bc82841e75f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $bh6RR.useRef)();
    let raf = (0, $bh6RR.useRef)();
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$79715bc82841e75f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope || $79715bc82841e75f$var$$9bf71ea28793e738$var$isAncestorScope($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($79715bc82841e75f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope && $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope.current) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusFirstInScope($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($79715bc82841e75f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $79715bc82841e75f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope.current) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusFirstInScope($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $79715bc82841e75f$export$d06fae2ee68b101e.traverse($79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $79715bc82841e75f$export$1258395f99bf9cbf(element) {
    return $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInChildScope(element, $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope);
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $hR9sS.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $79715bc82841e75f$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $bh6RR.useRef)(typeof document !== "undefined" ? (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $1nsPC.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope || $79715bc82841e75f$var$$9bf71ea28793e738$var$isAncestorScope($79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $79715bc82841e75f$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$79715bc82841e75f$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $1nsPC.useLayoutEffect)(()=>{
        const ownerDocument = (0, $ld26B.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $79715bc82841e75f$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $79715bc82841e75f$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $79715bc82841e75f$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $79715bc82841e75f$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $79715bc82841e75f$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $79715bc82841e75f$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $79715bc82841e75f$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $ld26B.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $jQuQH.isElementVisible)(node) && (!scope || $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $79715bc82841e75f$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $ld26B.getOwnerDocument)(root).activeElement;
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $79715bc82841e75f$var$$9bf71ea28793e738$var$last(walker);
                if (next) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $79715bc82841e75f$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $79715bc82841e75f$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $79715bc82841e75f$var$$9bf71ea28793e738$var$last(walker);
            if (next) $79715bc82841e75f$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $79715bc82841e75f$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $79715bc82841e75f$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $79715bc82841e75f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $79715bc82841e75f$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $79715bc82841e75f$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $79715bc82841e75f$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $79715bc82841e75f$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $79715bc82841e75f$export$d06fae2ee68b101e = new $79715bc82841e75f$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("jQuQH", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $e72acd9dd9cc7eae$export$e989c0fffaa6b27a; });

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e72acd9dd9cc7eae$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $e72acd9dd9cc7eae$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $e72acd9dd9cc7eae$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $e72acd9dd9cc7eae$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $e72acd9dd9cc7eae$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $e72acd9dd9cc7eae$export$e989c0fffaa6b27a(element.parentElement, element));
}

});


parcelRegister("8kcox", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $60f9ce50b54ccb47$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality = null;
let $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $60f9ce50b54ccb47$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $60f9ce50b54ccb47$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $60f9ce50b54ccb47$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$60f9ce50b54ccb47$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $60f9ce50b54ccb47$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $60f9ce50b54ccb47$export$d90243b58daecda7.delete(windowObject);
};
function $60f9ce50b54ccb47$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $60f9ce50b54ccb47$export$2f1888112f558a7d();
function $60f9ce50b54ccb47$export$b9b3dfddab17db27() {
    return $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $60f9ce50b54ccb47$export$630ff653c5ada6a9() {
    return $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality;
}
function $60f9ce50b54ccb47$export$8397ddfc504fdb9a(modality) {
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality = modality;
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $60f9ce50b54ccb47$export$98e20ec92f614cfe() {
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$currentModality);
        };
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $60f9ce50b54ccb47$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $60f9ce50b54ccb47$export$b9b3dfddab17db27());
    $60f9ce50b54ccb47$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $60f9ce50b54ccb47$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($60f9ce50b54ccb47$export$b9b3dfddab17db27());
        };
        $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $60f9ce50b54ccb47$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("kJy9d", function(module, exports) {

$parcel$export(module.exports, "useLongPress", function () { return $f1827f9d92e20ef9$export$c24ed0104d07eab9; });

var $iWCBs = parcelRequire("iWCBs");

var $dCyIs = parcelRequire("dCyIs");
var $9IUYG = parcelRequire("9IUYG");
var $1mw9Z = parcelRequire("1mw9Z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f1827f9d92e20ef9$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $f1827f9d92e20ef9$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $f1827f9d92e20ef9$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $bh6RR.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $1mw9Z.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $iWCBs.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $9IUYG.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $dCyIs.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("iWCBs", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $dcab968c2dba7854$export$45712eceda6fad21; });

var $608pz = parcelRequire("608pz");

var $dIvdn = parcelRequire("dIvdn");

var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $77fRS = parcelRequire("77fRS");
var $1mw9Z = parcelRequire("1mw9Z");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $dIvdn.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $dcab968c2dba7854$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $dcab968c2dba7854$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $dcab968c2dba7854$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $dcab968c2dba7854$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $dcab968c2dba7854$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $dcab968c2dba7854$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $dcab968c2dba7854$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $dcab968c2dba7854$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $dcab968c2dba7854$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $dcab968c2dba7854$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $dcab968c2dba7854$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $dcab968c2dba7854$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $dcab968c2dba7854$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $608pz.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$dcab968c2dba7854$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$dcab968c2dba7854$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $608pz.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $608pz.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $dcab968c2dba7854$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $608pz.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $dcab968c2dba7854$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $dcab968c2dba7854$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $608pz.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $608pz.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$dcab968c2dba7854$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $dcab968c2dba7854$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $dcab968c2dba7854$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$dcab968c2dba7854$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($dcab968c2dba7854$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $dcab968c2dba7854$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $dcab968c2dba7854$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $dcab968c2dba7854$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("608pz", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $45e9447e5be9e99f$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $45e9447e5be9e99f$export$b0d6fa1ab32e3295; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $8l8s9 = parcelRequire("8l8s9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $45e9447e5be9e99f$var$$14c0b72509d70225$var$state = "default";
let $45e9447e5be9e99f$var$$14c0b72509d70225$var$savedUserSelect = "";
let $45e9447e5be9e99f$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $45e9447e5be9e99f$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($45e9447e5be9e99f$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $45e9447e5be9e99f$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $45e9447e5be9e99f$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $45e9447e5be9e99f$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $45e9447e5be9e99f$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($45e9447e5be9e99f$var$$14c0b72509d70225$var$state !== "disabled") return;
        $45e9447e5be9e99f$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($45e9447e5be9e99f$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $45e9447e5be9e99f$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $45e9447e5be9e99f$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $45e9447e5be9e99f$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $45e9447e5be9e99f$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $45e9447e5be9e99f$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $45e9447e5be9e99f$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("dIvdn", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $9fc7990480b62bf6$export$5165eccb35aaadb5; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9fc7990480b62bf6$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$9fc7990480b62bf6$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});



parcelRegister("3Oi9j", function(module, exports) {

$parcel$export(module.exports, "useCollator", function () { return $2c641ea8a75ff687$export$a16aca283550c30d; });

var $lbbbW = parcelRequire("lbbbW");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2c641ea8a75ff687$var$$325a3faab7a68acd$var$cache = new Map();
function $2c641ea8a75ff687$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $lbbbW.useLocale)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($2c641ea8a75ff687$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $2c641ea8a75ff687$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $2c641ea8a75ff687$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}

});
parcelRegister("lbbbW", function(module, exports) {

$parcel$export(module.exports, "useLocale", function () { return $f6b34e769491261f$export$43bb16f9c6d9e3f7; });

var $h5iYA = parcelRequire("h5iYA");

var $iaGur = parcelRequire("iaGur");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f6b34e769491261f$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $f6b34e769491261f$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = (0, $iaGur.useDefaultLocale)();
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $h5iYA.isRTL)(locale) ? "rtl" : "ltr"
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($f6b34e769491261f$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $f6b34e769491261f$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $iaGur.useDefaultLocale)();
    let context = (0, $bh6RR.useContext)($f6b34e769491261f$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}

});
parcelRegister("h5iYA", function(module, exports) {

$parcel$export(module.exports, "isRTL", function () { return $c7019f8d54070445$export$702d680b21cbd764; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $c7019f8d54070445$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $c7019f8d54070445$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $c7019f8d54070445$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $c7019f8d54070445$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $c7019f8d54070445$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

});

parcelRegister("iaGur", function(module, exports) {

$parcel$export(module.exports, "useDefaultLocale", function () { return $d3aa1ecb7a594234$export$188ec29ebc2bdc3a; });

var $h5iYA = parcelRequire("h5iYA");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $d3aa1ecb7a594234$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: (0, $h5iYA.isRTL)(locale) ? "rtl" : "ltr"
    };
}
let $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$currentLocale = $d3aa1ecb7a594234$export$f09106e7c6677ec5();
let $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$currentLocale = $d3aa1ecb7a594234$export$f09106e7c6677ec5();
    for (let listener of $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$listeners)listener($d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $d3aa1ecb7a594234$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $2GhkT.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $bh6RR.useState)($d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $bh6RR.useEffect)(()=>{
        if ($d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $d3aa1ecb7a594234$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}

});





parcelRegister("aRKER", function(module, exports) {

$parcel$export(module.exports, "useMultiSelectState", function () { return $facf2dc6d264df03$export$85e876c5ce5df8f0; });

var $3hI4M = parcelRequire("3hI4M");

var $7sQTE = parcelRequire("7sQTE");

var $dQijQ = parcelRequire("dQijQ");

var $bh6RR = parcelRequire("bh6RR");
function $facf2dc6d264df03$export$85e876c5ce5df8f0(props) {
    const [isFocused, setFocused] = (0, $bh6RR.useState)(false);
    const [focusStrategy, setFocusStrategy] = (0, $bh6RR.useState)(null);
    const triggerState = (0, $7sQTE.useMenuTriggerState)(props);
    const listState = (0, $3hI4M.useMultiSelectListState)({
        ...props,
        onSelectionChange: (keys)=>{
            if (props.onSelectionChange != null) {
                if (keys === "all") props.onSelectionChange(new Set(listState.collection.getKeys()));
                else props.onSelectionChange(keys);
            }
            if (props.selectionMode === "single") triggerState.close();
        }
    });
    const validationState = (0, $dQijQ.useFormValidationState)({
        ...props,
        validationBehavior: "native",
        value: listState.selectedKeys
    });
    return {
        ...validationState,
        ...listState,
        ...triggerState,
        focusStrategy: focusStrategy,
        close () {
            triggerState.close();
        },
        open (focusStrategy2 = null) {
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy2);
                triggerState.open();
            }
        },
        toggle (focusStrategy2 = null) {
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy2);
                triggerState.toggle();
                validationState.commitValidation();
            }
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}

});
parcelRegister("3hI4M", function(module, exports) {

$parcel$export(module.exports, "useMultiSelectListState", function () { return $acbd3efe8c78febf$export$ce1d728ee50eab64; });
// src/use-multiselect-list-state.ts

var $gyqdx = parcelRequire("gyqdx");

var $bh6RR = parcelRequire("bh6RR");
function $acbd3efe8c78febf$export$ce1d728ee50eab64(props) {
    const { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager, selectionManager: { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, selectionMode: selectionMode } } = (0, $gyqdx.useListState)(props);
    const missingKeys = (0, $bh6RR.useMemo)(()=>{
        if (!props.isLoading && selectedKeys.size !== 0) return Array.from(selectedKeys).filter(Boolean).filter((key)=>!collection.getItem(key));
        return [];
    }, [
        selectedKeys,
        collection
    ]);
    const selectedItems = selectedKeys.size !== 0 ? Array.from(selectedKeys).map((key)=>{
        return collection.getItem(key);
    }).filter(Boolean) : null;
    if (missingKeys.length) console.warn(`Select: Keys "${missingKeys.join(", ")}" passed to "selectedKeys" are not present in the collection.`);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectionMode: selectionMode,
        selectedKeys: selectedKeys,
        setSelectedKeys: setSelectedKeys.bind(selectionManager),
        selectedItems: selectedItems
    };
}

});
parcelRegister("gyqdx", function(module, exports) {

$parcel$export(module.exports, "useListState", function () { return $c0d4288496cd2734$export$2f645645f7bca764; });

var $52VKi = parcelRequire("52VKi");
var $mPpgr = parcelRequire("mPpgr");

var $bh6RR = parcelRequire("bh6RR");

var $1OXFU = parcelRequire("1OXFU");

var $6YdNt = parcelRequire("6YdNt");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $c0d4288496cd2734$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}
function $c0d4288496cd2734$export$2f645645f7bca764(props) {
    let { filter: filter } = props;
    let selectionState = (0, $mPpgr.useMultipleSelectionState)(props);
    let disabledKeys = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $bh6RR.useCallback)((nodes)=>filter ? new $c0d4288496cd2734$export$d085fb9e920b5ca7(filter(nodes)) : new $c0d4288496cd2734$export$d085fb9e920b5ca7(nodes), [
        filter
    ]);
    let context = (0, $bh6RR.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $1OXFU.useCollection)(props, factory, context);
    let selectionManager = (0, $bh6RR.useMemo)(()=>new (0, $52VKi.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const diff = cachedItemNodes.length - itemNodes.length;
            let index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
            let newNode;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1) index++;
                else {
                    if (index > startItem.index) index = startItem.index;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c0d4288496cd2734$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, $6YdNt.useControlledState)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, $bh6RR.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = $c0d4288496cd2734$export$2f645645f7bca764({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}

});


parcelRegister("7sQTE", function(module, exports) {

$parcel$export(module.exports, "useMenuTriggerState", function () { return $56f42e1bf30966d3$export$79fefeb1c2091ac3; });

var $42o6y = parcelRequire("42o6y");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $56f42e1bf30966d3$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $42o6y.useOverlayTriggerState)(props);
    let [focusStrategy, setFocusStrategy] = (0, $bh6RR.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, $bh6RR.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        UNSTABLE_expandedKeysStack: expandedKeysStack,
        UNSTABLE_openSubmenu: openSubmenu,
        UNSTABLE_closeSubmenu: closeSubmenu
    };
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $56f42e1bf30966d3$export$d39fdbfa42246ac4(props, state) {
    let { triggerKey: triggerKey } = props;
    let { UNSTABLE_expandedKeysStack: UNSTABLE_expandedKeysStack, UNSTABLE_openSubmenu: UNSTABLE_openSubmenu, UNSTABLE_closeSubmenu: UNSTABLE_closeSubmenu, close: closeAll } = state;
    let [submenuLevel] = (0, $bh6RR.useState)(UNSTABLE_expandedKeysStack === null || UNSTABLE_expandedKeysStack === void 0 ? void 0 : UNSTABLE_expandedKeysStack.length);
    let isOpen = (0, $bh6RR.useMemo)(()=>UNSTABLE_expandedKeysStack[submenuLevel] === triggerKey, [
        UNSTABLE_expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    let [focusStrategy, setFocusStrategy] = (0, $bh6RR.useState)(null);
    let open = (0, $bh6RR.useCallback)((focusStrategy = null)=>{
        setFocusStrategy(focusStrategy);
        UNSTABLE_openSubmenu(triggerKey, submenuLevel);
    }, [
        UNSTABLE_openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let close = (0, $bh6RR.useCallback)(()=>{
        setFocusStrategy(null);
        UNSTABLE_closeSubmenu(triggerKey, submenuLevel);
    }, [
        UNSTABLE_closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let toggle = (0, $bh6RR.useCallback)((focusStrategy = null)=>{
        setFocusStrategy(focusStrategy);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, $bh6RR.useMemo)(()=>({
            focusStrategy: focusStrategy,
            isOpen: isOpen,
            open: open,
            close: close,
            closeAll: closeAll,
            submenuLevel: submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: ()=>{},
            toggle: toggle
        }), [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}

});
parcelRegister("42o6y", function(module, exports) {

$parcel$export(module.exports, "useOverlayTriggerState", function () { return $2f0a0c0bbe4884b4$export$61c6a8c84e605fb6; });

var $bh6RR = parcelRequire("bh6RR");

var $6YdNt = parcelRequire("6YdNt");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2f0a0c0bbe4884b4$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $6YdNt.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $bh6RR.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $bh6RR.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $bh6RR.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}

});


parcelRegister("dQijQ", function(module, exports) {

$parcel$export(module.exports, "useFormValidationState", function () { return $a13e577ff2fe11d9$export$fc1a364ae1f3ff10; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a13e577ff2fe11d9$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
    ...$a13e577ff2fe11d9$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $a13e577ff2fe11d9$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $a13e577ff2fe11d9$export$aca958c65c314e6c,
    validationErrors: []
};
const $a13e577ff2fe11d9$export$571b5131b7e65c11 = (0, $bh6RR.createContext)({});
const $a13e577ff2fe11d9$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $a13e577ff2fe11d9$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$a13e577ff2fe11d9$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$a13e577ff2fe11d9$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = "aria" } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is true, update validation result in realtime (controlled).
    let controlledError = isInvalid ? {
        isInvalid: true,
        validationErrors: [],
        validationDetails: $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $bh6RR.useMemo)(()=>$a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$getValidationResult($a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$runValidate(validate, value)), [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    let serverErrors = (0, $bh6RR.useContext)($a13e577ff2fe11d9$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $bh6RR.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$asArray(serverErrors[name])) : $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $bh6RR.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $bh6RR.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $bh6RR.useMemo)(()=>$a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $bh6RR.useRef)($a13e577ff2fe11d9$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $bh6RR.useState)($a13e577ff2fe11d9$export$dad6ae84456c676a);
    let lastError = (0, $bh6RR.useRef)($a13e577ff2fe11d9$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $a13e577ff2fe11d9$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $a13e577ff2fe11d9$export$dad6ae84456c676a;
            if (!$a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        let e = validate(value);
        if (e && typeof e !== "boolean") return $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $a13e577ff2fe11d9$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $a13e577ff2fe11d9$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$a13e577ff2fe11d9$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}

});



parcelRegister("ebpD3", function(module, exports) {

$parcel$export(module.exports, "useVisuallyHidden", function () { return $a535f92824d8bc89$export$a966af930f325cab; });
$parcel$export(module.exports, "VisuallyHidden", function () { return $a535f92824d8bc89$export$439d29a4e110a164; });

var $dCyIs = parcelRequire("dCyIs");

var $bh6RR = parcelRequire("bh6RR");

var $hqFke = parcelRequire("hqFke");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a535f92824d8bc89$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function $a535f92824d8bc89$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $bh6RR.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $hqFke.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $bh6RR.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$a535f92824d8bc89$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $a535f92824d8bc89$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $a535f92824d8bc89$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = "div", isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $a535f92824d8bc89$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Element, (0, $dCyIs.mergeProps)(otherProps, visuallyHiddenProps), children);
}

});
parcelRegister("hqFke", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $cb04ebbd801e14a3$export$420e68273165f4ec; });

var $dZTdL = parcelRequire("dZTdL");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $cb04ebbd801e14a3$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $bh6RR.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $bh6RR.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $dZTdL.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});
parcelRegister("dZTdL", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $a30bce9607d9b7fd$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $a30bce9607d9b7fd$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $a30bce9607d9b7fd$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $a30bce9607d9b7fd$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});



parcelRegister("b2mWI", function(module, exports) {

$parcel$export(module.exports, "useFormValidation", function () { return $8091ae38400187cc$export$b8473d3665f3a75a; });

var $bh6RR = parcelRequire("bh6RR");

var $7U1DD = parcelRequire("7U1DD");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8091ae38400187cc$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $1nsPC.useLayoutEffect)(()=>{
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation($8091ae38400187cc$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    let onReset = (0, $77fRS.useEffectEvent)(()=>{
        state.resetValidation();
    });
    let onInvalid = (0, $77fRS.useEffectEvent)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $8091ae38400187cc$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $7U1DD.setInteractionModality)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $77fRS.useEffectEvent)(()=>{
        state.commitValidation();
    });
    (0, $bh6RR.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 || form.addEventListener("reset", onReset);
        return ()=>{
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 || form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $8091ae38400187cc$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $8091ae38400187cc$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $8091ae38400187cc$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $8091ae38400187cc$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

});
parcelRegister("7U1DD", function(module, exports) {

$parcel$export(module.exports, "setInteractionModality", function () { return $5c0f08b2f373715d$export$8397ddfc504fdb9a; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality = null;
let $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $5c0f08b2f373715d$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($5c0f08b2f373715d$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $5c0f08b2f373715d$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $5c0f08b2f373715d$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$5c0f08b2f373715d$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $5c0f08b2f373715d$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $5c0f08b2f373715d$export$d90243b58daecda7.delete(windowObject);
};
function $5c0f08b2f373715d$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$5c0f08b2f373715d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $5c0f08b2f373715d$export$2f1888112f558a7d();
function $5c0f08b2f373715d$export$b9b3dfddab17db27() {
    return $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $5c0f08b2f373715d$export$630ff653c5ada6a9() {
    return $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality;
}
function $5c0f08b2f373715d$export$8397ddfc504fdb9a(modality) {
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality = modality;
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $5c0f08b2f373715d$export$98e20ec92f614cfe() {
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($5c0f08b2f373715d$var$$507fabe10e71c6fb$var$currentModality);
        };
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$5c0f08b2f373715d$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$5c0f08b2f373715d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $5c0f08b2f373715d$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $5c0f08b2f373715d$export$b9b3dfddab17db27());
    $5c0f08b2f373715d$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $5c0f08b2f373715d$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$5c0f08b2f373715d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($5c0f08b2f373715d$export$b9b3dfddab17db27());
        };
        $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $5c0f08b2f373715d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});



parcelRegister("dyaxi", function(module, exports) {

$parcel$export(module.exports, "listbox_default", function () { return $9a2a8334203148ad$export$3f842a5957aa0e7a; });

var $iUL7z = parcelRequire("iUL7z");

var $dgJwU = parcelRequire("dgJwU");

var $hPL9f = parcelRequire("hPL9f");

var $hN2BG = parcelRequire("hN2BG");

var $dCyIs = parcelRequire("dCyIs");

var $ih19M = parcelRequire("ih19M");
"use client";
function $9a2a8334203148ad$var$Listbox(props, ref) {
    const { Component: Component, state: state, color: color, variant: variant, itemClasses: itemClasses, getBaseProps: getBaseProps, topContent: topContent, bottomContent: bottomContent, hideEmptyContent: hideEmptyContent, hideSelectedIcon: hideSelectedIcon, shouldHighlightOnFocus: shouldHighlightOnFocus, disableAnimation: disableAnimation, getEmptyContentProps: getEmptyContentProps, getListProps: getListProps } = (0, $hPL9f.useListbox)({
        ...props,
        ref: ref
    });
    const content = /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
        ...getListProps(),
        children: [
            !state.collection.size && !hideEmptyContent && /* @__PURE__ */ (0, $ih19M.jsx)("li", {
                children: /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                    ...getEmptyContentProps()
                })
            }),
            [
                ...state.collection
            ].map((item)=>{
                var _a;
                const itemProps = {
                    color: color,
                    item: item,
                    state: state,
                    variant: variant,
                    disableAnimation: disableAnimation,
                    hideSelectedIcon: hideSelectedIcon,
                    ...item.props
                };
                if (item.type === "section") return /* @__PURE__ */ (0, $ih19M.jsx)((0, $iUL7z.listbox_section_default), {
                    ...itemProps,
                    itemClasses: itemClasses
                }, item.key);
                let listboxItem = /* @__PURE__ */ (0, $ih19M.jsx)((0, $dgJwU.listbox_item_default), {
                    ...itemProps,
                    classNames: (0, $dCyIs.mergeProps)(itemClasses, (_a = item.props) == null ? void 0 : _a.classNames),
                    shouldHighlightOnFocus: shouldHighlightOnFocus
                }, item.key);
                if (item.wrapper) listboxItem = item.wrapper(listboxItem);
                return listboxItem;
            })
        ]
    });
    return /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
        ...getBaseProps(),
        children: [
            topContent,
            content,
            bottomContent
        ]
    });
}
$9a2a8334203148ad$var$Listbox.displayName = "NextUI.Listbox";
var $9a2a8334203148ad$export$3f842a5957aa0e7a = (0, $hN2BG.forwardRef)($9a2a8334203148ad$var$Listbox);

});
parcelRegister("iUL7z", function(module, exports) {

$parcel$export(module.exports, "listbox_section_default", function () { return $7941fd5d4f11c59e$export$f8b3202ede999f4c; });

var $dgJwU = parcelRequire("dgJwU");

var $bf9cP = parcelRequire("bf9cP");

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");

var $dCyIs = parcelRequire("dCyIs");

var $3xP29 = parcelRequire("3xP29");

var $1Bn3l = parcelRequire("1Bn3l");

var $cT26W = parcelRequire("cT26W");

var $ih19M = parcelRequire("ih19M");
"use client";
var $7941fd5d4f11c59e$var$ListboxSection = (0, $hN2BG.forwardRef)(({ item: item, state: state, as: as, variant: variant, color: color, disableAnimation: disableAnimation, className: className, classNames: classNames, hideSelectedIcon: hideSelectedIcon, showDivider: showDivider = false, dividerProps: dividerProps = {}, itemClasses: itemClasses, title: title, ...otherProps }, _)=>{
    const Component = as || "li";
    const slots = (0, $bh6RR.useMemo)(()=>(0, $bf9cP.menuSection)(), []);
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    const dividerStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.divider, dividerProps == null ? void 0 : dividerProps.className);
    const { itemProps: itemProps, headingProps: headingProps, groupProps: groupProps } = (0, $cT26W.useListBoxSection)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    return /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
        "data-slot": "base",
        ...(0, $dCyIs.mergeProps)(itemProps, otherProps),
        className: slots.base({
            class: baseStyles
        }),
        children: [
            item.rendered && /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                ...headingProps,
                className: slots.heading({
                    class: classNames == null ? void 0 : classNames.heading
                }),
                "data-slot": "heading",
                children: item.rendered
            }),
            /* @__PURE__ */ (0, $ih19M.jsxs)("ul", {
                ...groupProps,
                className: slots.group({
                    class: classNames == null ? void 0 : classNames.group
                }),
                "data-has-title": !!item.rendered,
                "data-slot": "group",
                children: [
                    [
                        ...item.childNodes
                    ].map((node)=>{
                        const { key: nodeKey, props: nodeProps } = node;
                        let listboxItem = /* @__PURE__ */ (0, $ih19M.jsx)((0, $dgJwU.listbox_item_default), {
                            classNames: itemClasses,
                            color: color,
                            disableAnimation: disableAnimation,
                            hideSelectedIcon: hideSelectedIcon,
                            item: node,
                            state: state,
                            variant: variant,
                            ...nodeProps
                        }, nodeKey);
                        if (node.wrapper) listboxItem = node.wrapper(listboxItem);
                        return listboxItem;
                    }),
                    showDivider && /* @__PURE__ */ (0, $ih19M.jsx)((0, $1Bn3l.divider_default), {
                        as: "li",
                        className: slots.divider({
                            class: dividerStyles
                        }),
                        ...dividerProps
                    })
                ]
            })
        ]
    }, item.key);
});
$7941fd5d4f11c59e$var$ListboxSection.displayName = "NextUI.ListboxSection";
var $7941fd5d4f11c59e$export$f8b3202ede999f4c = $7941fd5d4f11c59e$var$ListboxSection;

});
parcelRegister("dgJwU", function(module, exports) {

$parcel$export(module.exports, "listbox_item_default", function () { return $25160a3d425e4d56$export$5f4bb52909be7a78; });

var $alfYP = parcelRequire("alfYP");

var $5IvSh = parcelRequire("5IvSh");

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");
"use client";
var $25160a3d425e4d56$var$ListboxItem = (0, $hN2BG.forwardRef)((props, _)=>{
    const { Component: Component, rendered: rendered, description: description, isSelectable: isSelectable, isSelected: isSelected, isDisabled: isDisabled, selectedIcon: selectedIcon, startContent: startContent, endContent: endContent, hideSelectedIcon: hideSelectedIcon, disableAnimation: disableAnimation, getItemProps: getItemProps, getLabelProps: getLabelProps, getWrapperProps: getWrapperProps, getDescriptionProps: getDescriptionProps, getSelectedIconProps: getSelectedIconProps } = (0, $5IvSh.useListboxItem)(props);
    const selectedContent = (0, $bh6RR.useMemo)(()=>{
        const defaultIcon = /* @__PURE__ */ (0, $ih19M.jsx)((0, $alfYP.ListboxSelectedIcon), {
            disableAnimation: disableAnimation,
            isSelected: isSelected
        });
        if (typeof selectedIcon === "function") return selectedIcon({
            icon: defaultIcon,
            isSelected: isSelected,
            isDisabled: isDisabled
        });
        if (selectedIcon) return selectedIcon;
        return defaultIcon;
    }, [
        selectedIcon,
        isSelected,
        isDisabled,
        disableAnimation
    ]);
    return /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
        ...getItemProps(),
        children: [
            startContent,
            description ? /* @__PURE__ */ (0, $ih19M.jsxs)("div", {
                ...getWrapperProps(),
                children: [
                    /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                        ...getLabelProps(),
                        children: rendered
                    }),
                    /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                        ...getDescriptionProps(),
                        children: description
                    })
                ]
            }) : /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                ...getLabelProps(),
                children: rendered
            }),
            isSelectable && !hideSelectedIcon && /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                ...getSelectedIconProps(),
                children: selectedContent
            }),
            endContent
        ]
    });
});
$25160a3d425e4d56$var$ListboxItem.displayName = "NextUI.ListboxItem";
var $25160a3d425e4d56$export$5f4bb52909be7a78 = $25160a3d425e4d56$var$ListboxItem;

});
parcelRegister("alfYP", function(module, exports) {

$parcel$export(module.exports, "ListboxSelectedIcon", function () { return $9c4995caf24e4163$export$5db3965fb0ec818; });

var $ih19M = parcelRequire("ih19M");
"use client";
function $9c4995caf24e4163$export$5db3965fb0ec818(props) {
    const { isSelected: isSelected, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $ih19M.jsx)("svg", {
        "aria-hidden": "true",
        "data-selected": isSelected,
        role: "presentation",
        viewBox: "0 0 17 18",
        ...otherProps,
        children: /* @__PURE__ */ (0, $ih19M.jsx)("polyline", {
            fill: "none",
            points: "1 9 7 14 15 4",
            stroke: "currentColor",
            strokeDasharray: 22,
            strokeDashoffset: isSelected ? 44 : 66,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            style: !disableAnimation ? {
                transition: "stroke-dashoffset 200ms ease"
            } : {}
        })
    });
}

});

parcelRegister("5IvSh", function(module, exports) {

$parcel$export(module.exports, "useListboxItem", function () { return $cfc74b23ae8ac60b$export$887eda06ad18acaf; });

var $bh6RR = parcelRequire("bh6RR");

var $bf9cP = parcelRequire("bf9cP");

var $hN2BG = parcelRequire("hN2BG");
var $gSab4 = parcelRequire("gSab4");

var $3HS2q = parcelRequire("3HS2q");

var $bIkcs = parcelRequire("bIkcs");

var $3xP29 = parcelRequire("3xP29");
var $6G4gc = parcelRequire("6G4gc");
var $6N9Z9 = parcelRequire("6N9Z9");

var $cT26W = parcelRequire("cT26W");

var $dCyIs = parcelRequire("dCyIs");

var $fvnOt = parcelRequire("fvnOt");

var $dKOon = parcelRequire("dKOon");
"use client";
function $cfc74b23ae8ac60b$export$887eda06ad18acaf(originalProps) {
    var _a, _b;
    const globalContext = (0, $gSab4.useProviderContext)();
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $bf9cP.menuItem).variantKeys);
    const { as: as, item: item, state: state, description: description, startContent: startContent, endContent: endContent, isVirtualized: isVirtualized, selectedIcon: selectedIcon, className: className, classNames: classNames, autoFocus: autoFocus, onPress: onPress, onClick: onClick, shouldHighlightOnFocus: shouldHighlightOnFocus, hideSelectedIcon: hideSelectedIcon = false, isReadOnly: isReadOnly = false, ...otherProps } = props;
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const domRef = (0, $bh6RR.useRef)(null);
    const Component = as || (originalProps.href ? "a" : "li");
    const shouldFilterDOMProps = typeof Component === "string";
    const { rendered: rendered, key: key } = item;
    const isDisabled = state.disabledKeys.has(key) || originalProps.isDisabled;
    const isSelectable = state.selectionManager.selectionMode !== "none";
    const isMobile = (0, $dKOon.useIsMobile)();
    const { pressProps: pressProps, isPressed: isPressed } = (0, $fvnOt.usePress)({
        ref: domRef,
        isDisabled: isDisabled,
        onPress: onPress
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $fvnOt.useHover)({
        isDisabled: isDisabled
    });
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $3HS2q.useFocusRing)({
        autoFocus: autoFocus
    });
    const { isFocused: isFocused, isSelected: isSelected, optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps } = (0, $cT26W.useOption)({
        key: key,
        isDisabled: isDisabled,
        "aria-label": props["aria-label"],
        isVirtualized: isVirtualized
    }, state, domRef);
    let itemProps = optionProps;
    const slots = (0, $bh6RR.useMemo)(()=>(0, $bf9cP.menuItem)({
            ...variantProps,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps),
        isDisabled,
        disableAnimation
    ]);
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    if (isReadOnly) itemProps = (0, $6N9Z9.removeEvents)(itemProps);
    const isHighlighted = (0, $bh6RR.useMemo)(()=>{
        if (shouldHighlightOnFocus && isFocused) return true;
        return isMobile ? isHovered || isPressed : isHovered;
    }, [
        isHovered,
        isPressed,
        isFocused,
        isMobile,
        shouldHighlightOnFocus
    ]);
    const getItemProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $dCyIs.mergeProps)({
                onClick: onClick
            }, itemProps, isReadOnly ? {} : (0, $dCyIs.mergeProps)(focusProps, pressProps), hoverProps, (0, $bIkcs.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2),
            "data-selectable": (0, $6G4gc.dataAttr)(isSelectable),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-hover": (0, $6G4gc.dataAttr)(isHighlighted),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            "data-selected": (0, $6G4gc.dataAttr)(isSelected),
            "data-pressed": (0, $6G4gc.dataAttr)(isPressed),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            className: slots.base({
                class: (0, $3xP29.clsx)(baseStyles, props2.className)
            })
        });
    const getLabelProps = (props2 = {})=>({
            ...(0, $dCyIs.mergeProps)(labelProps, props2),
            "data-label": (0, $6G4gc.dataAttr)(true),
            className: slots.title({
                class: classNames == null ? void 0 : classNames.title
            })
        });
    const getDescriptionProps = (props2 = {})=>({
            ...(0, $dCyIs.mergeProps)(descriptionProps, props2),
            className: slots.description({
                class: classNames == null ? void 0 : classNames.description
            })
        });
    const getWrapperProps = (props2 = {})=>({
            ...(0, $dCyIs.mergeProps)(props2),
            className: slots.wrapper({
                class: classNames == null ? void 0 : classNames.wrapper
            })
        });
    const getSelectedIconProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $6G4gc.dataAttr)(true),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            className: slots.selectedIcon({
                class: classNames == null ? void 0 : classNames.selectedIcon
            }),
            ...props2
        };
    }, [
        isDisabled,
        slots,
        classNames
    ]);
    return {
        Component: Component,
        domRef: domRef,
        slots: slots,
        classNames: classNames,
        isSelectable: isSelectable,
        isSelected: isSelected,
        isDisabled: isDisabled,
        rendered: rendered,
        description: description,
        startContent: startContent,
        endContent: endContent,
        selectedIcon: selectedIcon,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        getWrapperProps: getWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getSelectedIconProps: getSelectedIconProps
    };
}

});
parcelRegister("bf9cP", function(module, exports) {

$parcel$export(module.exports, "menu", function () { return $bde318bcb08d9311$export$b1e5508a851be14d; });
$parcel$export(module.exports, "menuItem", function () { return $bde318bcb08d9311$export$c176f998e71d0f08; });
$parcel$export(module.exports, "menuSection", function () { return $bde318bcb08d9311$export$95e0837a3419f5c1; });

var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/menu.ts
var $bde318bcb08d9311$export$b1e5508a851be14d = (0, $6ujkL.tv)({
    slots: {
        base: "w-full relative flex flex-col gap-1 p-1",
        list: "w-full flex flex-col gap-0.5 outline-none",
        emptyContent: [
            "h-10",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "text-foreground-400",
            "text-start"
        ]
    }
});
var $bde318bcb08d9311$export$c176f998e71d0f08 = (0, $6ujkL.tv)({
    slots: {
        base: [
            "flex",
            "group",
            "gap-2",
            "items-center",
            "justify-between",
            "relative",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "box-border",
            "rounded-small",
            "subpixel-antialiased",
            "outline-none",
            "cursor-pointer",
            "tap-highlight-transparent",
            ...(0, $g2NHD.dataFocusVisibleClasses),
            "data-[focus-visible=true]:dark:ring-offset-background-content1"
        ],
        wrapper: "w-full flex flex-col items-start justify-center",
        title: "flex-1 text-small font-normal truncate",
        description: [
            "w-full",
            "text-tiny",
            "text-foreground-500",
            "group-hover:text-current"
        ],
        selectedIcon: [
            "text-inherit",
            "w-3",
            "h-3",
            "flex-shrink-0"
        ],
        shortcut: [
            "px-1",
            "py-0.5",
            "rounded",
            "font-sans",
            "text-foreground-500",
            "text-tiny",
            "border-small",
            "border-default-300",
            "group-hover:border-current"
        ]
    },
    variants: {
        variant: {
            solid: {
                base: ""
            },
            bordered: {
                base: "border-medium border-transparent bg-transparent"
            },
            light: {
                base: "bg-transparent"
            },
            faded: {
                base: [
                    "border-small border-transparent hover:border-default data-[hover=true]:bg-default-100",
                    "data-[selectable=true]:focus:border-default data-[selectable=true]:focus:bg-default-100"
                ]
            },
            flat: {
                base: ""
            },
            shadow: {
                base: "data-[hover=true]:shadow-lg"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        showDivider: {
            true: {
                base: [
                    "mb-1.5",
                    "after:content-['']",
                    "after:absolute",
                    "after:-bottom-1",
                    "after:left-0",
                    "after:right-0",
                    "after:h-divider",
                    "after:bg-divider"
                ]
            },
            false: {}
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {},
            false: {
                base: "data-[hover=true]:transition-colors"
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        color: "default",
        showDivider: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:shadow-default/50 data-[hover=true]:bg-default data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:shadow-default/50 data-[selectable=true]:focus:bg-default data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:shadow-primary/30 data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:shadow-primary/30 data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:shadow-secondary/30 data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:shadow-secondary/30 data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:shadow-success/30 data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:shadow-success/30 data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:shadow-warning/30 data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:shadow-warning/30 data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:shadow-danger/30 data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:shadow-danger/30 data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "bordered",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:border-default",
                    "data-[selectable=true]:focus:border-default"
                ]
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:border-primary data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:border-primary data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:border-secondary data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:border-secondary data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:border-success data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:border-success data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:border-warning data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:border-warning data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:border-danger data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:border-danger data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "flat",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default/40",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default/40",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary/20 data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:bg-primary/20 data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary/20 data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:bg-secondary/20 data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success/20 data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:bg-success/20 data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning/20 data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:bg-warning/20 data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger/20 data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:bg-danger/20 data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "faded",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "light",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-500",
                    "data-[selectable=true]:focus:text-default-500"
                ]
            }
        },
        {
            variant: "light",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "light",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "light",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "light",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "light",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        }
    ]
});
var $bde318bcb08d9311$export$95e0837a3419f5c1 = (0, $6ujkL.tv)({
    slots: {
        base: "relative mb-2",
        heading: "pl-1 text-tiny text-foreground-500",
        group: "data-[has-title=true]:pt-1",
        divider: "mt-2"
    }
});

});

parcelRegister("cT26W", function(module, exports) {

$parcel$export(module.exports, "useListBox", function () { return $961c424b784c12e4$export$50eacbbf140a3141; });
$parcel$export(module.exports, "useOption", function () { return $961c424b784c12e4$export$497855f14858aa34; });
$parcel$export(module.exports, "useListBoxSection", function () { return $961c424b784c12e4$export$c3f9f39876e4bc7; });

var $leZvJ = parcelRequire("leZvJ");
var $kI2if = parcelRequire("kI2if");
var $dCyIs = parcelRequire("dCyIs");
var $43JEG = parcelRequire("43JEG");

var $gqfi4 = parcelRequire("gqfi4");
var $5Bgx3 = parcelRequire("5Bgx3");
var $jd6SL = parcelRequire("jd6SL");

var $cvRSw = parcelRequire("cvRSw");

var $h8hpj = parcelRequire("h8hpj");
var $6a5TU = parcelRequire("6a5TU");

var $cTyLy = parcelRequire("cTyLy");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $961c424b784c12e4$export$3585ede4d035bf14 = new WeakMap();
function $961c424b784c12e4$var$$b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function $961c424b784c12e4$export$9145995848b05025(state, itemKey) {
    let data = $961c424b784c12e4$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error("Unknown list");
    return `${data.id}-option-${$961c424b784c12e4$var$$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}
function $961c424b784c12e4$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || "toggle";
    let linkBehavior = props.linkBehavior || (selectionBehavior === "replace" ? "action" : "override");
    if (selectionBehavior === "toggle" && linkBehavior === "action") // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = "override";
    let { listProps: listProps } = (0, $6a5TU.useSelectableList)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $5Bgx3.useFocusWithin)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $43JEG.useId)(props.id);
    $961c424b784c12e4$export$3585ede4d035bf14.set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $cvRSw.useLabel)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $dCyIs.mergeProps)(domProps, focusWithinProps, state.selectionManager.selectionMode === "multiple" ? {
            "aria-multiselectable": "true"
        } : {}, {
            role: "listbox",
            ...(0, $dCyIs.mergeProps)(fieldProps, listProps)
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $961c424b784c12e4$export$497855f14858aa34(props, state, ref) {
    var _item_props;
    let { key: key } = props;
    let data = $961c424b784c12e4$export$3585ede4d035bf14.get(state);
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    var _props_shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_props_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _props_shouldSelectOnPressUp !== void 0 ? _props_shouldSelectOnPressUp : data === null || data === void 0 ? void 0 : data.shouldSelectOnPressUp;
    var _props_shouldFocusOnHover;
    let shouldFocusOnHover = (_props_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _props_shouldFocusOnHover !== void 0 ? _props_shouldFocusOnHover : data === null || data === void 0 ? void 0 : data.shouldFocusOnHover;
    var _props_shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_props_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _props_shouldUseVirtualFocus !== void 0 ? _props_shouldUseVirtualFocus : data === null || data === void 0 ? void 0 : data.shouldUseVirtualFocus;
    var _props_isVirtualized;
    let isVirtualized = (_props_isVirtualized = props.isVirtualized) !== null && _props_isVirtualized !== void 0 ? _props_isVirtualized : data === null || data === void 0 ? void 0 : data.isVirtualized;
    let labelId = (0, $43JEG.useSlotId)();
    let descriptionId = (0, $43JEG.useSlotId)();
    let optionProps = {
        role: "option",
        "aria-disabled": isDisabled || undefined,
        "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!((0, $kI2if.isMac)() && (0, $kI2if.isWebKit)())) {
        optionProps["aria-label"] = props["aria-label"];
        optionProps["aria-labelledby"] = labelId;
        optionProps["aria-describedby"] = descriptionId;
    }
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item === null || item === void 0 ? void 0 : item.index);
        optionProps["aria-posinset"] = Number.isNaN(index) ? undefined : index + 1;
        optionProps["aria-setsize"] = (0, $cTyLy.getItemCount)(state.collection);
    }
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $h8hpj.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: (data === null || data === void 0 ? void 0 : data.onAction) ? ()=>{
            var _data_onAction;
            return data === null || data === void 0 ? void 0 : (_data_onAction = data.onAction) === null || _data_onAction === void 0 ? void 0 : _data_onAction.call(data, key);
        } : undefined,
        linkBehavior: data === null || data === void 0 ? void 0 : data.linkBehavior
    });
    let { hoverProps: hoverProps } = (0, $jd6SL.useHover)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $gqfi4.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $leZvJ.filterDOMProps)(item === null || item === void 0 ? void 0 : item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href)
    });
    delete domProps.id;
    return {
        optionProps: {
            ...optionProps,
            ...(0, $dCyIs.mergeProps)(domProps, itemProps, hoverProps),
            id: $961c424b784c12e4$export$9145995848b05025(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && (0, $gqfi4.isFocusVisible)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $961c424b784c12e4$export$c3f9f39876e4bc7(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $43JEG.useId)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}

});
parcelRegister("gqfi4", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $bf4aef65660c3664$export$b9b3dfddab17db27; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality = null;
let $bf4aef65660c3664$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $bf4aef65660c3664$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $bf4aef65660c3664$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $bf4aef65660c3664$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($bf4aef65660c3664$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $bf4aef65660c3664$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $bf4aef65660c3664$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $bf4aef65660c3664$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$bf4aef65660c3664$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $bf4aef65660c3664$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $bf4aef65660c3664$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $bf4aef65660c3664$export$d90243b58daecda7.delete(windowObject);
};
function $bf4aef65660c3664$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $bf4aef65660c3664$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $bf4aef65660c3664$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$bf4aef65660c3664$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $bf4aef65660c3664$export$2f1888112f558a7d();
function $bf4aef65660c3664$export$b9b3dfddab17db27() {
    return $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $bf4aef65660c3664$export$630ff653c5ada6a9() {
    return $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality;
}
function $bf4aef65660c3664$export$8397ddfc504fdb9a(modality) {
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality = modality;
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $bf4aef65660c3664$export$98e20ec92f614cfe() {
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($bf4aef65660c3664$var$$507fabe10e71c6fb$var$currentModality);
        };
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $bf4aef65660c3664$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $bf4aef65660c3664$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $bf4aef65660c3664$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$bf4aef65660c3664$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$bf4aef65660c3664$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $bf4aef65660c3664$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $bf4aef65660c3664$export$b9b3dfddab17db27());
    $bf4aef65660c3664$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $bf4aef65660c3664$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $bf4aef65660c3664$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$bf4aef65660c3664$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($bf4aef65660c3664$export$b9b3dfddab17db27());
        };
        $bf4aef65660c3664$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $bf4aef65660c3664$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("5Bgx3", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $413d3b6972a5f102$export$420e68273165f4ec; });

var $VmMby = parcelRequire("VmMby");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $413d3b6972a5f102$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $bh6RR.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $bh6RR.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $VmMby.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});
parcelRegister("VmMby", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $0ac6fddc81067603$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $0ac6fddc81067603$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $0ac6fddc81067603$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $0ac6fddc81067603$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("jd6SL", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $dfc491e45113e407$export$ae780daf29e6d456; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $dfc491e45113e407$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $dfc491e45113e407$var$$6179b936705e76d3$var$hoverCount = 0;
function $dfc491e45113e407$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $dfc491e45113e407$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $dfc491e45113e407$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $dfc491e45113e407$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $dfc491e45113e407$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $dfc491e45113e407$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $dfc491e45113e407$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $dfc491e45113e407$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $dfc491e45113e407$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $dfc491e45113e407$var$$6179b936705e76d3$var$hoverCount--;
        if ($dfc491e45113e407$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $dfc491e45113e407$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $dfc491e45113e407$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $dfc491e45113e407$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $bh6RR.useState)(false);
    let state = (0, $bh6RR.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $bh6RR.useEffect)($dfc491e45113e407$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $bh6RR.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($dfc491e45113e407$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$dfc491e45113e407$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $bh6RR.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});


parcelRegister("dKOon", function(module, exports) {

$parcel$export(module.exports, "useIsMobile", function () { return $551b495c6e0177f7$export$2b96349243a56116; });
// src/index.ts

var $2GhkT = parcelRequire("2GhkT");
var $551b495c6e0177f7$var$MOBILE_SCREEN_WIDTH = 700;
function $551b495c6e0177f7$export$2b96349243a56116() {
    let isSSR = (0, $2GhkT.useIsSSR)();
    if (isSSR || typeof window === "undefined") return false;
    return window.screen.width <= $551b495c6e0177f7$var$MOBILE_SCREEN_WIDTH;
}

});




parcelRegister("hPL9f", function(module, exports) {

$parcel$export(module.exports, "useListbox", function () { return $4b3dfbfb562d7a7b$export$33446f1f63e37cb2; });

var $cT26W = parcelRequire("cT26W");

var $gSab4 = parcelRequire("gSab4");

var $bf9cP = parcelRequire("bf9cP");

var $4MXst = parcelRequire("4MXst");

var $bIkcs = parcelRequire("bIkcs");
var $gedB5 = parcelRequire("gedB5");

var $bh6RR = parcelRequire("bh6RR");

var $3xP29 = parcelRequire("3xP29");
"use client";
function $4b3dfbfb562d7a7b$export$33446f1f63e37cb2(props) {
    var _a;
    const globalContext = (0, $gSab4.useProviderContext)();
    const { ref: ref, as: as, state: propState, variant: variant, color: color, onAction: onAction, children: children, onSelectionChange: onSelectionChange, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, itemClasses: itemClasses, className: className, topContent: topContent, bottomContent: bottomContent, emptyContent: emptyContent = "No items.", hideSelectedIcon: hideSelectedIcon = false, hideEmptyContent: hideEmptyContent = false, shouldHighlightOnFocus: shouldHighlightOnFocus = false, classNames: classNames, ...otherProps } = props;
    const Component = as || "ul";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    const innerState = (0, $4MXst.useListState)({
        ...props,
        children: children,
        onSelectionChange: onSelectionChange
    });
    const state = propState || innerState;
    const { listBoxProps: listBoxProps } = (0, $cT26W.useListBox)({
        ...props,
        onAction: onAction
    }, state, domRef);
    const slots = (0, $bh6RR.useMemo)(()=>(0, $bf9cP.menu)({
            className: className
        }), [
        className
    ]);
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "base",
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $bIkcs.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }),
            ...props2
        };
    };
    const getListProps = (props2 = {})=>{
        return {
            "data-slot": "list",
            className: slots.list({
                class: classNames == null ? void 0 : classNames.list
            }),
            ...listBoxProps,
            ...props2
        };
    };
    const getEmptyContentProps = (props2 = {})=>{
        return {
            "data-slot": "empty-content",
            children: emptyContent,
            className: slots.emptyContent({
                class: classNames == null ? void 0 : classNames.emptyContent
            }),
            ...props2
        };
    };
    return {
        Component: Component,
        state: state,
        variant: variant,
        color: color,
        slots: slots,
        classNames: classNames,
        topContent: topContent,
        bottomContent: bottomContent,
        emptyContent: emptyContent,
        hideEmptyContent: hideEmptyContent,
        shouldHighlightOnFocus: shouldHighlightOnFocus,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        className: className,
        itemClasses: itemClasses,
        getBaseProps: getBaseProps,
        getListProps: getListProps,
        getEmptyContentProps: getEmptyContentProps
    };
}

});
parcelRegister("4MXst", function(module, exports) {

$parcel$export(module.exports, "useListState", function () { return $37c9c44fa228eddb$export$2f645645f7bca764; });

var $52VKi = parcelRequire("52VKi");
var $mPpgr = parcelRequire("mPpgr");

var $bh6RR = parcelRequire("bh6RR");

var $1OXFU = parcelRequire("1OXFU");

var $c5m63 = parcelRequire("c5m63");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $37c9c44fa228eddb$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}
function $37c9c44fa228eddb$export$2f645645f7bca764(props) {
    let { filter: filter } = props;
    let selectionState = (0, $mPpgr.useMultipleSelectionState)(props);
    let disabledKeys = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $bh6RR.useCallback)((nodes)=>filter ? new $37c9c44fa228eddb$export$d085fb9e920b5ca7(filter(nodes)) : new $37c9c44fa228eddb$export$d085fb9e920b5ca7(nodes), [
        filter
    ]);
    let context = (0, $bh6RR.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $1OXFU.useCollection)(props, factory, context);
    let selectionManager = (0, $bh6RR.useMemo)(()=>new (0, $52VKi.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const diff = cachedItemNodes.length - itemNodes.length;
            let index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
            let newNode;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1) index++;
                else {
                    if (index > startItem.index) index = startItem.index;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $37c9c44fa228eddb$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, $c5m63.useControlledState)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, $bh6RR.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = $37c9c44fa228eddb$export$2f645645f7bca764({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}

});
parcelRegister("c5m63", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $8cc7179ed55bd600$export$40bfa8c7b0832715; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8cc7179ed55bd600$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $bh6RR.useState)(value || defaultValue);
    let isControlledRef = (0, $bh6RR.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $bh6RR.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $bh6RR.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $8cc7179ed55bd600$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $8cc7179ed55bd600$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $8cc7179ed55bd600$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});




parcelRegister("hmdH9", function(module, exports) {

$parcel$export(module.exports, "free_solo_popover_default", function () { return $1f7ef100eeef8444$export$4f32f7e42026f90b; });

var $8JM8v = parcelRequire("8JM8v");

var $bh6RR = parcelRequire("bh6RR");

var $iOLGl = parcelRequire("iOLGl");

var $hN2BG = parcelRequire("hN2BG");

var $6Vrqz = parcelRequire("6Vrqz");
var $k87FL = parcelRequire("k87FL");
var $dqffP = parcelRequire("dqffP");

var $dCyIs = parcelRequire("dCyIs");

var $aGkwu = parcelRequire("aGkwu");

var $6ujp5 = parcelRequire("6ujp5");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1f7ef100eeef8444$var$FreeSoloPopoverWrapper = (0, $hN2BG.forwardRef)(({ children: children, motionProps: motionProps, placement: placement, disableAnimation: disableAnimation, style: styleProp = {}, transformOrigin: transformOrigin = {}, ...otherProps }, ref)=>{
    let style = styleProp;
    if (transformOrigin.originX !== void 0 || transformOrigin.originY !== void 0) style = {
        ...style,
        transformOrigin: transformOrigin
    };
    else style = {
        ...style,
        ...(0, $aGkwu.getTransformOrigins)(placement === "center" ? "top" : placement)
    };
    return disableAnimation ? /* @__PURE__ */ (0, $ih19M.jsx)("div", {
        ...otherProps,
        ref: ref,
        children: children
    }) : /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
        features: (0, $6Vrqz.domAnimation),
        children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).div, {
            ref: ref,
            animate: "enter",
            exit: "exit",
            initial: "initial",
            style: style,
            variants: (0, $6ujp5.TRANSITION_VARIANTS).scaleSpringOpacity,
            ...(0, $dCyIs.mergeProps)(otherProps, motionProps),
            children: children
        })
    });
});
$1f7ef100eeef8444$var$FreeSoloPopoverWrapper.displayName = "NextUI.FreeSoloPopoverWrapper";
var $1f7ef100eeef8444$var$FreeSoloPopover = (0, $hN2BG.forwardRef)(({ children: children, transformOrigin: transformOrigin, ...props }, ref)=>{
    const { Component: Component, state: state, placement: placement, backdrop: backdrop, titleProps: titleProps, portalContainer: portalContainer, disableAnimation: disableAnimation, motionProps: motionProps, isNonModal: isNonModal, getPopoverProps: getPopoverProps, getBackdropProps: getBackdropProps, getDialogProps: getDialogProps, getContentProps: getContentProps } = (0, $8JM8v.usePopover)({
        ...props,
        ref: ref
    });
    const backdropContent = $bh6RR.useMemo(()=>{
        if (backdrop === "transparent") return null;
        if (disableAnimation) return /* @__PURE__ */ (0, $ih19M.jsx)("div", {
            ...getBackdropProps()
        });
        return /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
            features: (0, $6Vrqz.domAnimation),
            children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $6ujp5.TRANSITION_VARIANTS).fade,
                ...getBackdropProps()
            })
        });
    }, [
        backdrop,
        disableAnimation,
        getBackdropProps
    ]);
    return /* @__PURE__ */ (0, $ih19M.jsxs)((0, $iOLGl.Overlay), {
        portalContainer: portalContainer,
        children: [
            !isNonModal && backdropContent,
            /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
                ...getPopoverProps(),
                children: /* @__PURE__ */ (0, $ih19M.jsxs)($1f7ef100eeef8444$var$FreeSoloPopoverWrapper, {
                    disableAnimation: disableAnimation,
                    motionProps: motionProps,
                    placement: placement,
                    tabIndex: -1,
                    transformOrigin: transformOrigin,
                    ...getDialogProps(),
                    children: [
                        !isNonModal && /* @__PURE__ */ (0, $ih19M.jsx)((0, $iOLGl.DismissButton), {
                            onDismiss: state.close
                        }),
                        /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                            ...getContentProps(),
                            children: typeof children === "function" ? children(titleProps) : children
                        }),
                        /* @__PURE__ */ (0, $ih19M.jsx)((0, $iOLGl.DismissButton), {
                            onDismiss: state.close
                        })
                    ]
                })
            })
        ]
    });
});
$1f7ef100eeef8444$var$FreeSoloPopover.displayName = "NextUI.FreeSoloPopover";
var $1f7ef100eeef8444$export$4f32f7e42026f90b = $1f7ef100eeef8444$var$FreeSoloPopover;

});

parcelRegister("lwpxJ", function(module, exports) {

$parcel$export(module.exports, "ChevronDownIcon", function () { return $208925b62414100b$export$4857d3f3f5f8319b; });
// src/chevron-down.tsx

var $ih19M = parcelRequire("ih19M");
var $208925b62414100b$export$4857d3f3f5f8319b = ({ strokeWidth: strokeWidth = 1.5, ...props })=>/* @__PURE__ */ (0, $ih19M.jsx)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth,
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $ih19M.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });

});

parcelRegister("kedtD", function(module, exports) {

$parcel$export(module.exports, "scroll_shadow_default", function () { return $a4fda3c26ad5f38e$export$bef3e985c75eafb5; });

var $jw25p = parcelRequire("jw25p");

var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a4fda3c26ad5f38e$var$ScrollShadow = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, children: children, getBaseProps: getBaseProps } = (0, $jw25p.useScrollShadow)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
        ...getBaseProps(),
        children: children
    });
});
$a4fda3c26ad5f38e$var$ScrollShadow.displayName = "NextUI.ScrollShadow";
var $a4fda3c26ad5f38e$export$bef3e985c75eafb5 = $a4fda3c26ad5f38e$var$ScrollShadow;

});
parcelRegister("jw25p", function(module, exports) {

$parcel$export(module.exports, "useScrollShadow", function () { return $026d0db6be8a5bc0$export$90e7448ca01cde65; });

var $hN2BG = parcelRequire("hN2BG");

var $5zARc = parcelRequire("5zARc");

var $gedB5 = parcelRequire("gedB5");

var $ijSzE = parcelRequire("ijSzE");

var $bh6RR = parcelRequire("bh6RR");

var $6N9Z9 = parcelRequire("6N9Z9");
"use client";
function $026d0db6be8a5bc0$export$90e7448ca01cde65(originalProps) {
    var _a;
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $5zARc.scrollShadow).variantKeys);
    const { ref: ref, as: as, children: children, className: className, style: style, size: size = 40, offset: offset = 0, visibility: visibility = "auto", isEnabled: isEnabled = true, onVisibilityChange: onVisibilityChange, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $gedB5.useDOMRef)(ref);
    (0, $ijSzE.useDataScrollOverflow)({
        domRef: domRef,
        offset: offset,
        visibility: visibility,
        isEnabled: isEnabled,
        onVisibilityChange: onVisibilityChange,
        updateDeps: [
            children
        ],
        overflowCheck: (_a = originalProps.orientation) != null ? _a : "vertical"
    });
    const styles = (0, $bh6RR.useMemo)(()=>(0, $5zARc.scrollShadow)({
            ...variantProps,
            className: className
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps),
        className
    ]);
    const getBaseProps = (props2 = {})=>{
        var _a2;
        return {
            ref: domRef,
            className: styles,
            "data-orientation": (_a2 = originalProps.orientation) != null ? _a2 : "vertical",
            style: {
                "--scroll-shadow-size": `${size}px`,
                ...style,
                ...props2.style
            },
            ...otherProps,
            ...props2
        };
    };
    return {
        Component: Component,
        styles: styles,
        domRef: domRef,
        children: children,
        getBaseProps: getBaseProps
    };
}

});
parcelRegister("5zARc", function(module, exports) {

$parcel$export(module.exports, "scrollShadow", function () { return $689e4005e213993e$export$1515b480513bd18e; });

var $6ujkL = parcelRequire("6ujkL");
// src/components/scroll-shadow.ts
var $689e4005e213993e$var$verticalShadow = [
    "data-[top-scroll=true]:[mask-image:linear-gradient(0deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[bottom-scroll=true]:[mask-image:linear-gradient(180deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[top-bottom-scroll=true]:[mask-image:linear-gradient(#000,#000,transparent_0,#000_var(--scroll-shadow-size),#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]"
];
var $689e4005e213993e$var$horizontalShadow = [
    "data-[left-scroll=true]:[mask-image:linear-gradient(270deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[right-scroll=true]:[mask-image:linear-gradient(90deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[left-right-scroll=true]:[mask-image:linear-gradient(to_right,#000,#000,transparent_0,#000_var(--scroll-shadow-size),#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]"
];
var $689e4005e213993e$export$1515b480513bd18e = (0, $6ujkL.tv)({
    base: [],
    variants: {
        orientation: {
            vertical: [
                "overflow-y-auto",
                ...$689e4005e213993e$var$verticalShadow
            ],
            horizontal: [
                "overflow-x-auto",
                ...$689e4005e213993e$var$horizontalShadow
            ]
        },
        hideScrollBar: {
            true: "scrollbar-hide",
            false: ""
        }
    },
    defaultVariants: {
        orientation: "vertical",
        hideScrollBar: false
    }
});

});

parcelRegister("ijSzE", function(module, exports) {

$parcel$export(module.exports, "useDataScrollOverflow", function () { return $e68b968e486f888a$export$372ebfbb988329b7; });
// src/index.ts

var $6N9Z9 = parcelRequire("6N9Z9");

var $bh6RR = parcelRequire("bh6RR");
function $e68b968e486f888a$export$372ebfbb988329b7(props = {}) {
    const { domRef: domRef, isEnabled: isEnabled = true, overflowCheck: overflowCheck = "vertical", visibility: visibility = "auto", offset: offset = 0, onVisibilityChange: onVisibilityChange, updateDeps: updateDeps = [] } = props;
    const visibleRef = (0, $bh6RR.useRef)(visibility);
    (0, $bh6RR.useEffect)(()=>{
        const el = domRef == null ? void 0 : domRef.current;
        if (!el || !isEnabled) return;
        const setAttributes = (direction, hasBefore, hasAfter, prefix, suffix)=>{
            if (visibility === "auto") {
                const both = `${prefix}${(0, $6N9Z9.capitalize)(suffix)}Scroll`;
                if (hasBefore && hasAfter) {
                    el.dataset[both] = "true";
                    el.removeAttribute(`data-${prefix}-scroll`);
                    el.removeAttribute(`data-${suffix}-scroll`);
                } else {
                    el.dataset[`${prefix}Scroll`] = hasBefore.toString();
                    el.dataset[`${suffix}Scroll`] = hasAfter.toString();
                    el.removeAttribute(`data-${prefix}-${suffix}-scroll`);
                }
            } else {
                const next = hasBefore && hasAfter ? "both" : hasBefore ? prefix : hasAfter ? suffix : "none";
                if (next !== visibleRef.current) {
                    onVisibilityChange == null || onVisibilityChange(next);
                    visibleRef.current = next;
                }
            }
        };
        const checkOverflow = ()=>{
            const directions = [
                {
                    type: "vertical",
                    prefix: "top",
                    suffix: "bottom"
                },
                {
                    type: "horizontal",
                    prefix: "left",
                    suffix: "right"
                }
            ];
            for (const { type: type, prefix: prefix, suffix: suffix } of directions)if (overflowCheck === type || overflowCheck === "both") {
                const hasBefore = type === "vertical" ? el.scrollTop > offset : el.scrollLeft > offset;
                const hasAfter = type === "vertical" ? el.scrollTop + el.clientHeight + offset < el.scrollHeight : el.scrollLeft + el.clientWidth + offset < el.scrollWidth;
                setAttributes(type, hasBefore, hasAfter, prefix, suffix);
            }
        };
        const clearOverflow = ()=>{
            [
                "top",
                "bottom",
                "top-bottom",
                "left",
                "right",
                "left-right"
            ].forEach((attr)=>{
                el.removeAttribute(`data-${attr}-scroll`);
            });
        };
        checkOverflow();
        el.addEventListener("scroll", checkOverflow);
        if (visibility !== "auto") {
            clearOverflow();
            if (visibility === "both") {
                el.dataset.topBottomScroll = String(overflowCheck === "vertical");
                el.dataset.leftRightScroll = String(overflowCheck === "horizontal");
            } else {
                el.dataset.topBottomScroll = "false";
                el.dataset.leftRightScroll = "false";
                [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ].forEach((attr)=>{
                    el.dataset[`${attr}Scroll`] = String(visibility === attr);
                });
            }
        }
        return ()=>{
            el.removeEventListener("scroll", checkOverflow);
            clearOverflow();
        };
    }, [
        ...updateDeps,
        isEnabled,
        visibility,
        overflowCheck,
        onVisibilityChange,
        domRef
    ]);
}

});




parcelRegister("2jaxN", function(module, exports) {

$parcel$export(module.exports, "listbox_item_base_default", function () { return $a8b08d1b442f8f05$export$c9741ea17cd30897; });

var $cTO50 = parcelRequire("cTO50");
"use client";
var $a8b08d1b442f8f05$var$ListboxItemBase = (0, $cTO50.Item);
var $a8b08d1b442f8f05$export$c9741ea17cd30897 = $a8b08d1b442f8f05$var$ListboxItemBase;

});

parcelRegister("ccrSm", function(module, exports) {

$parcel$export(module.exports, "switch_default", function () { return $2d4acb6d276df0a3$export$fc15fde3b71d3684; });

var $iqjXn = parcelRequire("iqjXn");

var $ebpD3 = parcelRequire("ebpD3");

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2d4acb6d276df0a3$var$Switch = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, children: children, startContent: startContent, endContent: endContent, thumbIcon: thumbIcon, getBaseProps: getBaseProps, getInputProps: getInputProps, getWrapperProps: getWrapperProps, getThumbProps: getThumbProps, getThumbIconProps: getThumbIconProps, getLabelProps: getLabelProps, getStartContentProps: getStartContentProps, getEndContentProps: getEndContentProps } = (0, $iqjXn.useSwitch)({
        ...props,
        ref: ref
    });
    const clonedThumbIcon = typeof thumbIcon === "function" ? thumbIcon(getThumbIconProps({
        includeStateProps: true
    })) : thumbIcon && (0, $bh6RR.cloneElement)(thumbIcon, getThumbIconProps());
    const clonedStartContent = startContent && (0, $bh6RR.cloneElement)(startContent, getStartContentProps());
    const clonedEndContent = endContent && (0, $bh6RR.cloneElement)(endContent, getEndContentProps());
    return /* @__PURE__ */ (0, $ih19M.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $ih19M.jsx)((0, $ebpD3.VisuallyHidden), {
                elementType: "span",
                children: /* @__PURE__ */ (0, $ih19M.jsx)("input", {
                    ...getInputProps()
                })
            }),
            /* @__PURE__ */ (0, $ih19M.jsxs)("span", {
                ...getWrapperProps(),
                children: [
                    startContent && clonedStartContent,
                    /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                        ...getThumbProps(),
                        children: thumbIcon && clonedThumbIcon
                    }),
                    endContent && clonedEndContent
                ]
            }),
            children && /* @__PURE__ */ (0, $ih19M.jsx)("span", {
                ...getLabelProps(),
                children: children
            })
        ]
    });
});
$2d4acb6d276df0a3$var$Switch.displayName = "NextUI.Switch";
var $2d4acb6d276df0a3$export$fc15fde3b71d3684 = $2d4acb6d276df0a3$var$Switch;

});
parcelRegister("iqjXn", function(module, exports) {

$parcel$export(module.exports, "useSwitch", function () { return $cff14da97fa38999$export$d853f7095ae95f88; });

var $bh6RR = parcelRequire("bh6RR");

var $hN2BG = parcelRequire("hN2BG");
var $gSab4 = parcelRequire("gSab4");

var $TBkqn = parcelRequire("TBkqn");

var $cOcFk = parcelRequire("cOcFk");

var $fvnOt = parcelRequire("fvnOt");

var $3ixLe = parcelRequire("3ixLe");

var $i65Wu = parcelRequire("i65Wu");
var $dCyIs = parcelRequire("dCyIs");

var $3xP29 = parcelRequire("3xP29");
var $6G4gc = parcelRequire("6G4gc");
var $6N9Z9 = parcelRequire("6N9Z9");

var $dU5JS = parcelRequire("dU5JS");

var $ekf2w = parcelRequire("ekf2w");

var $3HS2q = parcelRequire("3HS2q");
"use client";
function $cff14da97fa38999$export$d853f7095ae95f88(originalProps = {}) {
    var _a, _b;
    const globalContext = (0, $gSab4.useProviderContext)();
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $3ixLe.toggle).variantKeys);
    const { ref: ref, as: as, name: name, value: value = "", isReadOnly: isReadOnlyProp = false, autoFocus: autoFocus = false, startContent: startContent, endContent: endContent, defaultSelected: defaultSelected, isSelected: isSelectedProp, children: children, thumbIcon: thumbIcon, className: className, classNames: classNames, onChange: onChange, onValueChange: onValueChange, ...otherProps } = props;
    const Component = as || "label";
    const domRef = (0, $bh6RR.useRef)(null);
    const inputRef = (0, $bh6RR.useRef)(null);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const labelId = (0, $bh6RR.useId)();
    const ariaSwitchProps = (0, $bh6RR.useMemo)(()=>{
        const ariaLabel = otherProps["aria-label"] || typeof children === "string" ? children : void 0;
        return {
            name: name,
            value: value,
            children: children,
            autoFocus: autoFocus,
            defaultSelected: defaultSelected,
            isSelected: isSelectedProp,
            isDisabled: !!originalProps.isDisabled,
            isReadOnly: isReadOnlyProp,
            "aria-label": ariaLabel,
            "aria-labelledby": otherProps["aria-labelledby"] || labelId,
            onChange: onValueChange
        };
    }, [
        value,
        name,
        labelId,
        children,
        autoFocus,
        isReadOnlyProp,
        isSelectedProp,
        defaultSelected,
        originalProps.isDisabled,
        otherProps["aria-label"],
        otherProps["aria-labelledby"],
        onValueChange
    ]);
    const state = (0, $ekf2w.useToggleState)(ariaSwitchProps);
    (0, $cOcFk.useSafeLayoutEffect)(()=>{
        if (!inputRef.current) return;
        const isInputRefChecked = !!inputRef.current.checked;
        state.setSelected(isInputRefChecked);
    }, [
        inputRef.current
    ]);
    const { inputProps: inputProps, isPressed: isPressedKeyboard, isReadOnly: isReadOnly } = (0, $dU5JS.useSwitch)(ariaSwitchProps, state, inputRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $3HS2q.useFocusRing)({
        autoFocus: inputProps.autoFocus
    });
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $fvnOt.useHover)({
        isDisabled: inputProps.disabled
    });
    const isInteractionDisabled = ariaSwitchProps.isDisabled || isReadOnly;
    const [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    const { pressProps: pressProps } = (0, $fvnOt.usePress)({
        isDisabled: isInteractionDisabled,
        onPressStart (e) {
            if (e.pointerType !== "keyboard") setPressed(true);
        },
        onPressEnd (e) {
            if (e.pointerType !== "keyboard") setPressed(false);
        }
    });
    const pressed = isInteractionDisabled ? false : isPressed || isPressedKeyboard;
    const isSelected = inputProps.checked;
    const isDisabled = inputProps.disabled;
    const slots = (0, $bh6RR.useMemo)(()=>(0, $3ixLe.toggle)({
            ...variantProps,
            disableAnimation: disableAnimation
        }), [
        (0, $6N9Z9.objectToDeps)(variantProps),
        disableAnimation
    ]);
    const baseStyles = (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2)=>{
        return {
            ...(0, $dCyIs.mergeProps)(hoverProps, pressProps, otherProps, props2),
            ref: domRef,
            className: slots.base({
                class: (0, $3xP29.clsx)(baseStyles, props2 == null ? void 0 : props2.className)
            }),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            "data-selected": (0, $6G4gc.dataAttr)(isSelected),
            "data-readonly": (0, $6G4gc.dataAttr)(isReadOnly),
            "data-focus": (0, $6G4gc.dataAttr)(isFocused),
            "data-focus-visible": (0, $6G4gc.dataAttr)(isFocusVisible),
            "data-hover": (0, $6G4gc.dataAttr)(isHovered),
            "data-pressed": (0, $6G4gc.dataAttr)(pressed)
        };
    };
    const getWrapperProps = (0, $bh6RR.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "aria-hidden": true,
            className: (0, $3xP29.clsx)(slots.wrapper({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.wrapper, props2 == null ? void 0 : props2.className)
            }))
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.wrapper
    ]);
    const getInputProps = (props2 = {})=>{
        return {
            ...(0, $dCyIs.mergeProps)(inputProps, focusProps, props2),
            ref: (0, $TBkqn.mergeRefs)(inputRef, ref),
            id: inputProps.id,
            onChange: (0, $i65Wu.chain)(onChange, inputProps.onChange)
        };
    };
    const getThumbProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            ...props2,
            className: slots.thumb({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.thumb, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.thumb
    ]);
    const getLabelProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            ...props2,
            id: labelId,
            className: slots.label({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.label, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        isDisabled,
        isSelected
    ]);
    const getThumbIconProps = (0, $bh6RR.useCallback)((props2 = {
        includeStateProps: false
    })=>(0, $dCyIs.mergeProps)({
            width: "1em",
            height: "1em",
            className: slots.thumbIcon({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.thumbIcon)
            })
        }, props2.includeStateProps ? {
            isSelected: isSelected
        } : {}), [
        slots,
        classNames == null ? void 0 : classNames.thumbIcon,
        isSelected
    ]);
    const getStartContentProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            width: "1em",
            height: "1em",
            ...props2,
            className: slots.startContent({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.startContent, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.startContent,
        isSelected
    ]);
    const getEndContentProps = (0, $bh6RR.useCallback)((props2 = {})=>({
            width: "1em",
            height: "1em",
            ...props2,
            className: slots.endContent({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.endContent, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.endContent,
        isSelected
    ]);
    return {
        Component: Component,
        slots: slots,
        classNames: classNames,
        domRef: domRef,
        children: children,
        thumbIcon: thumbIcon,
        startContent: startContent,
        endContent: endContent,
        isHovered: isHovered,
        isSelected: isSelected,
        isPressed: pressed,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: isDisabled,
        getBaseProps: getBaseProps,
        getWrapperProps: getWrapperProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        getThumbProps: getThumbProps,
        getThumbIconProps: getThumbIconProps,
        getStartContentProps: getStartContentProps,
        getEndContentProps: getEndContentProps
    };
}

});
parcelRegister("TBkqn", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", function () { return $297e01f27479dbea$export$c9058316764c140e; });

var $6G4gc = parcelRequire("6G4gc");
"use client";
function $297e01f27479dbea$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if ((0, $6G4gc.isFunction)(ref)) {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $297e01f27479dbea$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>$297e01f27479dbea$export$d734136a7b018efe(ref, node));
    };
}

});

parcelRegister("3ixLe", function(module, exports) {

$parcel$export(module.exports, "toggle", function () { return $2327152dbd7b6bb8$export$e03c1c3201ee8bb7; });

var $6ujkL = parcelRequire("6ujkL");

var $g2NHD = parcelRequire("g2NHD");
// src/components/toggle.ts
var $2327152dbd7b6bb8$export$e03c1c3201ee8bb7 = (0, $6ujkL.tv)({
    slots: {
        base: "group relative max-w-fit inline-flex items-center justify-start cursor-pointer touch-none tap-highlight-transparent",
        wrapper: [
            "px-1",
            "relative",
            "inline-flex",
            "items-center",
            "justify-start",
            "flex-shrink-0",
            "overflow-hidden",
            "bg-default-200",
            "rounded-full",
            ...(0, $g2NHD.groupDataFocusVisibleClasses)
        ],
        thumb: [
            "z-10",
            "flex",
            "items-center",
            "justify-center",
            "bg-white",
            "shadow-small",
            "rounded-full",
            "origin-right"
        ],
        startContent: "z-0 absolute left-1.5 rtl:right-1.5 rtl:left-[unset] text-current",
        endContent: "z-0 absolute right-1.5 rtl:left-1.5 rtl:right-[unset] text-default-600",
        thumbIcon: "text-black",
        label: "relative text-foreground select-none"
    },
    variants: {
        color: {
            default: {
                wrapper: [
                    "group-data-[selected=true]:bg-default-400",
                    "group-data-[selected=true]:text-default-foreground"
                ]
            },
            primary: {
                wrapper: [
                    "group-data-[selected=true]:bg-primary",
                    "group-data-[selected=true]:text-primary-foreground"
                ]
            },
            secondary: {
                wrapper: [
                    "group-data-[selected=true]:bg-secondary",
                    "group-data-[selected=true]:text-secondary-foreground"
                ]
            },
            success: {
                wrapper: [
                    "group-data-[selected=true]:bg-success",
                    "group-data-[selected=true]:text-success-foreground"
                ]
            },
            warning: {
                wrapper: [
                    "group-data-[selected=true]:bg-warning",
                    "group-data-[selected=true]:text-warning-foreground"
                ]
            },
            danger: {
                wrapper: [
                    "group-data-[selected=true]:bg-danger",
                    "data-[selected=true]:text-danger-foreground"
                ]
            }
        },
        size: {
            sm: {
                wrapper: "w-10 h-6 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-4 h-4 text-tiny",
                    "group-data-[selected=true]:ml-4 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-4"
                ],
                endContent: "text-tiny",
                startContent: "text-tiny",
                label: "text-small"
            },
            md: {
                wrapper: "w-12 h-7 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-5 h-5 text-small",
                    "group-data-[selected=true]:ml-5 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-5"
                ],
                endContent: "text-small",
                startContent: "text-small",
                label: "text-medium"
            },
            lg: {
                wrapper: "w-14 h-8 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-6 h-6 text-medium",
                    "group-data-[selected=true]:ml-6 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-6"
                ],
                endContent: "text-medium",
                startContent: "text-medium",
                label: "text-large"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {
                wrapper: "transition-none",
                thumb: "transition-none"
            },
            false: {
                wrapper: "transition-background",
                thumb: "transition-all",
                startContent: [
                    "opacity-0",
                    "scale-50",
                    "transition-transform-opacity",
                    "group-data-[selected=true]:scale-100",
                    "group-data-[selected=true]:opacity-100"
                ],
                endContent: [
                    "opacity-100",
                    "transition-transform-opacity",
                    "group-data-[selected=true]:translate-x-3",
                    "group-data-[selected=true]:opacity-0"
                ]
            }
        }
    },
    defaultVariants: {
        color: "primary",
        size: "md",
        isDisabled: false
    },
    compoundVariants: [
        {
            disableAnimation: false,
            size: "sm",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-5",
                    "group-data-[selected]:group-data-[pressed]:ml-3"
                ]
            }
        },
        {
            disableAnimation: false,
            size: "md",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-6",
                    "group-data-[selected]:group-data-[pressed]:ml-4"
                ]
            }
        },
        {
            disableAnimation: false,
            size: "lg",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-7",
                    "group-data-[selected]:group-data-[pressed]:ml-5"
                ]
            }
        }
    ]
});

});

parcelRegister("dU5JS", function(module, exports) {

$parcel$export(module.exports, "useSwitch", function () { return $a1f4f4f451d868f2$export$d853f7095ae95f88; });

var $6fCSn = parcelRequire("6fCSn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a1f4f4f451d868f2$export$d853f7095ae95f88(props, state, ref) {
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly } = (0, $6fCSn.useToggle)(props, state, ref);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            role: "switch",
            checked: isSelected
        },
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly
    };
}

});
parcelRegister("6fCSn", function(module, exports) {

$parcel$export(module.exports, "useToggle", function () { return $48d24cc18c0b3d33$export$cbe85ee05b554577; });

var $leZvJ = parcelRequire("leZvJ");
var $dCyIs = parcelRequire("dCyIs");
var $4yIWF = parcelRequire("4yIWF");

var $8OYq1 = parcelRequire("8OYq1");

var $3fXNT = parcelRequire("3fXNT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $48d24cc18c0b3d33$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, value: value, name: name, children: children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, validationState: validationState = "valid", isInvalid: isInvalid } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $3fXNT.usePress)({
        isDisabled: isDisabled
    });
    // iOS does not toggle checkboxes if you drag off and back onto the label, so handle it ourselves.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $3fXNT.usePress)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            state.toggle();
        }
    });
    let { focusableProps: focusableProps } = (0, $8OYq1.useFocusable)(props, ref);
    let interactions = (0, $dCyIs.mergeProps)(pressProps, focusableProps);
    let domProps = (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    });
    (0, $4yIWF.useFormReset)(ref, state.isSelected, state.setSelected);
    return {
        labelProps: (0, $dCyIs.mergeProps)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $dCyIs.mergeProps)(domProps, {
            "aria-invalid": isInvalid || validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-controls": props["aria-controls"],
            "aria-readonly": isReadOnly || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value: value
            },
            name: name,
            type: "checkbox",
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || validationState === "invalid"
    };
}

});
parcelRegister("8OYq1", function(module, exports) {

$parcel$export(module.exports, "useFocusable", function () { return $66c1dc26f4789d09$export$4c014de7c8940b4c; });

var $3XrFB = parcelRequire("3XrFB");

var $dCyIs = parcelRequire("dCyIs");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");

var $qk17n = parcelRequire("qk17n");
var $i9mUb = parcelRequire("i9mUb");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $66c1dc26f4789d09$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $66c1dc26f4789d09$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $bh6RR.useContext)($66c1dc26f4789d09$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $2Cn0z.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $66c1dc26f4789d09$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $99EP5.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($66c1dc26f4789d09$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $66c1dc26f4789d09$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($66c1dc26f4789d09$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $66c1dc26f4789d09$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $qk17n.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $i9mUb.useKeyboard)(props);
    let interactions = (0, $dCyIs.mergeProps)(focusProps, keyboardProps);
    let domProps = $66c1dc26f4789d09$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $bh6RR.useRef)(props.autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $3XrFB.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $dCyIs.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

});
parcelRegister("3XrFB", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $2e1c587f1d4b9d75$export$80f3e147d781571c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $iQaIe = parcelRequire("iQaIe");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2e1c587f1d4b9d75$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $iQaIe.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}

});
parcelRegister("iQaIe", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $db7564980daaec36$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality = null;
let $db7564980daaec36$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $db7564980daaec36$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $db7564980daaec36$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $db7564980daaec36$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $db7564980daaec36$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $db7564980daaec36$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $db7564980daaec36$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $db7564980daaec36$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($db7564980daaec36$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $db7564980daaec36$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $db7564980daaec36$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $db7564980daaec36$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $db7564980daaec36$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$db7564980daaec36$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $db7564980daaec36$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $db7564980daaec36$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $db7564980daaec36$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $db7564980daaec36$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $db7564980daaec36$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $db7564980daaec36$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $db7564980daaec36$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $db7564980daaec36$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $db7564980daaec36$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $db7564980daaec36$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$db7564980daaec36$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $db7564980daaec36$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $db7564980daaec36$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $db7564980daaec36$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $db7564980daaec36$export$d90243b58daecda7.delete(windowObject);
};
function $db7564980daaec36$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $db7564980daaec36$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $db7564980daaec36$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$db7564980daaec36$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $db7564980daaec36$export$2f1888112f558a7d();
function $db7564980daaec36$export$b9b3dfddab17db27() {
    return $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $db7564980daaec36$export$630ff653c5ada6a9() {
    return $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality;
}
function $db7564980daaec36$export$8397ddfc504fdb9a(modality) {
    $db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality = modality;
    $db7564980daaec36$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $db7564980daaec36$export$98e20ec92f614cfe() {
    $db7564980daaec36$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($db7564980daaec36$var$$507fabe10e71c6fb$var$currentModality);
        };
        $db7564980daaec36$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $db7564980daaec36$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $db7564980daaec36$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $db7564980daaec36$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$db7564980daaec36$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$db7564980daaec36$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $db7564980daaec36$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $db7564980daaec36$export$b9b3dfddab17db27());
    $db7564980daaec36$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $db7564980daaec36$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $db7564980daaec36$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$db7564980daaec36$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($db7564980daaec36$export$b9b3dfddab17db27());
        };
        $db7564980daaec36$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $db7564980daaec36$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("qk17n", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $04f1f4c9c2fec4bf$export$f8168d8dd8fd66e6; });

var $egFyh = parcelRequire("egFyh");

var $bh6RR = parcelRequire("bh6RR");

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $04f1f4c9c2fec4bf$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $egFyh.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $ld26B.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("egFyh", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $a632caa7228f914e$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $a632caa7228f914e$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $a632caa7228f914e$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $a632caa7228f914e$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("i9mUb", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $d36ad5beea23db3d$export$8f71654801c2f7cd; });

var $2R5TT = parcelRequire("2R5TT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d36ad5beea23db3d$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $2R5TT.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $2R5TT.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("2R5TT", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $21451bb8a755b2b3$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $21451bb8a755b2b3$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});



parcelRegister("3fXNT", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $25f1299243113d02$export$45712eceda6fad21; });

var $hrqkN = parcelRequire("hrqkN");

var $h530V = parcelRequire("h530V");

var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $i65Wu = parcelRequire("i65Wu");
var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");
var $dCyIs = parcelRequire("dCyIs");
var $aCMC4 = parcelRequire("aCMC4");
var $77fRS = parcelRequire("77fRS");
var $1mw9Z = parcelRequire("1mw9Z");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $25f1299243113d02$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $h530V.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $dCyIs.mergeProps)(contextProps, props);
        register();
    }
    (0, $2Cn0z.useSyncRef)(context, props.ref);
    return props;
}
var $25f1299243113d02$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $25f1299243113d02$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $25f1299243113d02$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $25f1299243113d02$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $f9kyn._)(this, $25f1299243113d02$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $25f1299243113d02$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $25f1299243113d02$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $25f1299243113d02$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $25f1299243113d02$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $1mw9Z.useGlobalListeners)();
    let triggerPressStart = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $25f1299243113d02$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $77fRS.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $25f1299243113d02$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $25f1299243113d02$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $77fRS.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $25f1299243113d02$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $77fRS.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $hrqkN.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $77fRS.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($25f1299243113d02$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($25f1299243113d02$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($25f1299243113d02$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "keyup", (0, $i65Wu.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $kI2if.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $aCMC4.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $7uYIl.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $25f1299243113d02$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($25f1299243113d02$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $25f1299243113d02$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$25f1299243113d02$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$25f1299243113d02$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $aCMC4.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $7uYIl.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($25f1299243113d02$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $hrqkN.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($25f1299243113d02$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $25f1299243113d02$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $25f1299243113d02$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($25f1299243113d02$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $hrqkN.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($25f1299243113d02$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $7uYIl.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $25f1299243113d02$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $25f1299243113d02$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $61nPD.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $hrqkN.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $ld26B.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $25f1299243113d02$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $25f1299243113d02$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $25f1299243113d02$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $25f1299243113d02$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $hrqkN.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $hrqkN.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $dCyIs.mergeProps)(domProps, pressProps)
    };
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLInputElement && !$25f1299243113d02$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $ld26B.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $25f1299243113d02$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $25f1299243113d02$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $25f1299243113d02$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $25f1299243113d02$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$25f1299243113d02$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($25f1299243113d02$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $25f1299243113d02$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $25f1299243113d02$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $25f1299243113d02$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("hrqkN", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $cb2962c165440b8a$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $cb2962c165440b8a$export$b0d6fa1ab32e3295; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $8l8s9 = parcelRequire("8l8s9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $cb2962c165440b8a$var$$14c0b72509d70225$var$state = "default";
let $cb2962c165440b8a$var$$14c0b72509d70225$var$savedUserSelect = "";
let $cb2962c165440b8a$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $cb2962c165440b8a$export$16a4697467175487(target) {
    if ((0, $kI2if.isIOS)()) {
        if ($cb2962c165440b8a$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $ld26B.getOwnerDocument)(target);
            $cb2962c165440b8a$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $cb2962c165440b8a$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $cb2962c165440b8a$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $cb2962c165440b8a$export$b0d6fa1ab32e3295(target) {
    if ((0, $kI2if.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($cb2962c165440b8a$var$$14c0b72509d70225$var$state !== "disabled") return;
        $cb2962c165440b8a$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $8l8s9.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($cb2962c165440b8a$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $ld26B.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $cb2962c165440b8a$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $cb2962c165440b8a$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $cb2962c165440b8a$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $cb2962c165440b8a$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $cb2962c165440b8a$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $cb2962c165440b8a$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("h530V", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $c6f53dc6d0d682c0$export$5165eccb35aaadb5; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c6f53dc6d0d682c0$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$c6f53dc6d0d682c0$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});




parcelRegister("ekf2w", function(module, exports) {

$parcel$export(module.exports, "useToggleState", function () { return $a6de998620848590$export$8042c6c013fd5226; });

var $6YdNt = parcelRequire("6YdNt");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a6de998620848590$export$8042c6c013fd5226(props = {}) {
    let { isReadOnly: isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, $6YdNt.useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

});



parcelRegister("33otw", function(module, exports) {

$parcel$export(module.exports, "tooltip_default", function () { return $8f7ba5d4aa7c5f5c$export$a83543e92aefe46a; });

var $kgwhF = parcelRequire("kgwhF");

var $hN2BG = parcelRequire("hN2BG");

var $iOLGl = parcelRequire("iOLGl");

var $lTq24 = parcelRequire("lTq24");
var $6Vrqz = parcelRequire("6Vrqz");
var $k87FL = parcelRequire("k87FL");
var $dqffP = parcelRequire("dqffP");

var $6ujp5 = parcelRequire("6ujp5");

var $jJ443 = parcelRequire("jJ443");

var $bh6RR = parcelRequire("bh6RR");

var $aGkwu = parcelRequire("aGkwu");

var $dCyIs = parcelRequire("dCyIs");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8f7ba5d4aa7c5f5c$var$Tooltip = (0, $hN2BG.forwardRef)((props, ref)=>{
    const { Component: Component, children: children, content: content, isOpen: isOpen, portalContainer: portalContainer, placement: placement, disableAnimation: disableAnimation, motionProps: motionProps, getTriggerProps: getTriggerProps, getTooltipProps: getTooltipProps, getTooltipContentProps: getTooltipContentProps } = (0, $kgwhF.useTooltip)({
        ...props,
        ref: ref
    });
    let trigger;
    try {
        const childrenNum = (0, $bh6RR.Children).count(children);
        if (childrenNum !== 1) throw new Error();
        if (!(0, $bh6RR.isValidElement)(children)) trigger = /* @__PURE__ */ (0, $ih19M.jsx)("p", {
            ...getTriggerProps(),
            children: children
        });
        else {
            const child = children;
            trigger = (0, $bh6RR.cloneElement)(child, getTriggerProps(child.props, child.ref));
        }
    } catch (error) {
        trigger = /* @__PURE__ */ (0, $ih19M.jsx)("span", {});
        (0, $jJ443.warn)("Tooltip must have only one child node. Please, check your code.");
    }
    const { ref: tooltipRef, id: id, style: style, ...otherTooltipProps } = getTooltipProps();
    const animatedContent = /* @__PURE__ */ (0, $ih19M.jsx)("div", {
        ref: tooltipRef,
        id: id,
        style: style,
        children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $k87FL.LazyMotion), {
            features: (0, $6Vrqz.domAnimation),
            children: /* @__PURE__ */ (0, $ih19M.jsx)((0, $dqffP.m).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $6ujp5.TRANSITION_VARIANTS).scaleSpring,
                ...(0, $dCyIs.mergeProps)(motionProps, otherTooltipProps),
                style: {
                    ...(0, $aGkwu.getTransformOrigins)(placement)
                },
                children: /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
                    ...getTooltipContentProps(),
                    children: content
                })
            })
        })
    });
    return /* @__PURE__ */ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            trigger,
            disableAnimation && isOpen ? /* @__PURE__ */ (0, $ih19M.jsx)((0, $iOLGl.OverlayContainer), {
                portalContainer: portalContainer,
                children: /* @__PURE__ */ (0, $ih19M.jsx)("div", {
                    ref: tooltipRef,
                    id: id,
                    style: style,
                    ...otherTooltipProps,
                    children: /* @__PURE__ */ (0, $ih19M.jsx)(Component, {
                        ...getTooltipContentProps(),
                        children: content
                    })
                })
            }) : /* @__PURE__ */ (0, $ih19M.jsx)((0, $lTq24.AnimatePresence), {
                children: isOpen ? /* @__PURE__ */ (0, $ih19M.jsx)((0, $iOLGl.OverlayContainer), {
                    portalContainer: portalContainer,
                    children: animatedContent
                }) : null
            })
        ]
    });
});
$8f7ba5d4aa7c5f5c$var$Tooltip.displayName = "NextUI.Tooltip";
var $8f7ba5d4aa7c5f5c$export$a83543e92aefe46a = $8f7ba5d4aa7c5f5c$var$Tooltip;

});
parcelRegister("kgwhF", function(module, exports) {

$parcel$export(module.exports, "useTooltip", function () { return $bb19cf6eb902b1ca$export$1c4b08e0eca38426; });

var $bh6RR = parcelRequire("bh6RR");

var $25dC4 = parcelRequire("25dC4");

var $dCyIs = parcelRequire("dCyIs");

var $gOTHm = parcelRequire("gOTHm");

var $iOLGl = parcelRequire("iOLGl");

var $hN2BG = parcelRequire("hN2BG");
var $gSab4 = parcelRequire("gSab4");

var $9y80h = parcelRequire("9y80h");

var $3xP29 = parcelRequire("3xP29");
var $6G4gc = parcelRequire("6G4gc");
var $6N9Z9 = parcelRequire("6N9Z9");

var $gedB5 = parcelRequire("gedB5");
var $TBkqn = parcelRequire("TBkqn");

var $aGkwu = parcelRequire("aGkwu");

var $cOcFk = parcelRequire("cOcFk");
"use client";
function $bb19cf6eb902b1ca$export$1c4b08e0eca38426(originalProps) {
    var _a, _b;
    const globalContext = (0, $gSab4.useProviderContext)();
    const [props, variantProps] = (0, $hN2BG.mapPropsVariants)(originalProps, (0, $9y80h.popover).variantKeys);
    const { ref: ref, as: as, isOpen: isOpenProp, content: content, children: children, defaultOpen: defaultOpen, onOpenChange: onOpenChange, isDisabled: isDisabled, trigger: triggerAction, shouldFlip: shouldFlip = true, containerPadding: containerPadding = 12, placement: placementProp = "top", delay: delay = 0, closeDelay: closeDelay = 500, showArrow: showArrow = false, offset: offset = 7, crossOffset: crossOffset = 0, isDismissable: isDismissable, shouldCloseOnBlur: shouldCloseOnBlur = true, portalContainer: portalContainer, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, updatePositionDeps: updatePositionDeps = [], shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, className: className, onClose: onClose, motionProps: motionProps, classNames: classNames, ...otherProps } = props;
    const Component = as || "div";
    const disableAnimation = (_b = (_a = originalProps == null ? void 0 : originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const state = (0, $25dC4.useTooltipTriggerState)({
        delay: delay,
        closeDelay: closeDelay,
        isDisabled: isDisabled,
        defaultOpen: defaultOpen,
        isOpen: isOpenProp,
        onOpenChange: (isOpen2)=>{
            onOpenChange == null || onOpenChange(isOpen2);
            if (!isOpen2) onClose == null || onClose();
        }
    });
    const triggerRef = (0, $bh6RR.useRef)(null);
    const overlayRef = (0, $bh6RR.useRef)(null);
    const tooltipId = (0, $bh6RR.useId)();
    const isOpen = state.isOpen && !isDisabled;
    (0, $bh6RR.useImperativeHandle)(ref, ()=>(0, $gedB5.createDOMRef)(overlayRef));
    const { triggerProps: triggerProps, tooltipProps: triggerTooltipProps } = (0, $gOTHm.useTooltipTrigger)({
        isDisabled: isDisabled,
        trigger: triggerAction
    }, state, triggerRef);
    const { tooltipProps: tooltipProps } = (0, $gOTHm.useTooltip)({
        isOpen: isOpen,
        ...(0, $dCyIs.mergeProps)(props, triggerTooltipProps)
    }, state);
    const { overlayProps: positionProps, placement: placement, updatePosition: updatePosition } = (0, $iOLGl.useOverlayPosition)({
        isOpen: isOpen,
        targetRef: triggerRef,
        placement: (0, $aGkwu.toReactAriaPlacement)(placementProp),
        overlayRef: overlayRef,
        offset: showArrow ? offset + 3 : offset,
        crossOffset: crossOffset,
        shouldFlip: shouldFlip,
        containerPadding: containerPadding
    });
    (0, $cOcFk.useSafeLayoutEffect)(()=>{
        if (!updatePositionDeps.length) return;
        updatePosition();
    }, updatePositionDeps);
    const { overlayProps: overlayProps } = (0, $iOLGl.useOverlay)({
        isOpen: isOpen,
        onClose: state.close,
        isDismissable: isDismissable,
        shouldCloseOnBlur: shouldCloseOnBlur,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, overlayRef);
    const slots = (0, $bh6RR.useMemo)(()=>{
        var _a2, _b2, _c;
        return (0, $9y80h.popover)({
            ...variantProps,
            disableAnimation: disableAnimation,
            radius: (_a2 = originalProps == null ? void 0 : originalProps.radius) != null ? _a2 : "md",
            size: (_b2 = originalProps == null ? void 0 : originalProps.size) != null ? _b2 : "md",
            shadow: (_c = originalProps == null ? void 0 : originalProps.shadow) != null ? _c : "sm"
        });
    }, [
        (0, $6N9Z9.objectToDeps)(variantProps),
        disableAnimation,
        originalProps == null ? void 0 : originalProps.radius,
        originalProps == null ? void 0 : originalProps.size,
        originalProps == null ? void 0 : originalProps.shadow
    ]);
    const getTriggerProps = (0, $bh6RR.useCallback)((props2 = {}, _ref = null)=>({
            ...(0, $dCyIs.mergeProps)(triggerProps, props2),
            ref: (0, $TBkqn.mergeRefs)(_ref, triggerRef),
            "aria-describedby": isOpen ? tooltipId : void 0
        }), [
        triggerProps,
        isOpen,
        tooltipId,
        state
    ]);
    const getTooltipProps = (0, $bh6RR.useCallback)(()=>({
            ref: overlayRef,
            "data-slot": "base",
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-arrow": (0, $6G4gc.dataAttr)(showArrow),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            "data-placement": (0, $aGkwu.getArrowPlacement)(placement, placementProp),
            ...(0, $dCyIs.mergeProps)(tooltipProps, overlayProps, otherProps),
            style: (0, $dCyIs.mergeProps)(positionProps.style, otherProps.style, props.style),
            className: slots.base({
                class: classNames == null ? void 0 : classNames.base
            }),
            id: tooltipId
        }), [
        slots,
        isOpen,
        showArrow,
        isDisabled,
        placement,
        placementProp,
        tooltipProps,
        overlayProps,
        otherProps,
        positionProps,
        props,
        tooltipId
    ]);
    const getTooltipContentProps = (0, $bh6RR.useCallback)(()=>({
            "data-slot": "content",
            "data-open": (0, $6G4gc.dataAttr)(isOpen),
            "data-arrow": (0, $6G4gc.dataAttr)(showArrow),
            "data-disabled": (0, $6G4gc.dataAttr)(isDisabled),
            "data-placement": (0, $aGkwu.getArrowPlacement)(placement, placementProp),
            className: slots.content({
                class: (0, $3xP29.clsx)(classNames == null ? void 0 : classNames.content, className)
            })
        }), [
        slots,
        isOpen,
        showArrow,
        isDisabled,
        placement,
        placementProp,
        classNames
    ]);
    return {
        Component: Component,
        content: content,
        children: children,
        isOpen: isOpen,
        triggerRef: triggerRef,
        showArrow: showArrow,
        portalContainer: portalContainer,
        placement: placementProp,
        disableAnimation: disableAnimation,
        isDisabled: isDisabled,
        motionProps: motionProps,
        getTooltipContentProps: getTooltipContentProps,
        getTriggerProps: getTriggerProps,
        getTooltipProps: getTooltipProps
    };
}

});
parcelRegister("25dC4", function(module, exports) {

$parcel$export(module.exports, "useTooltipTriggerState", function () { return $18469ba50903eea6$export$4d40659c25ecb50b; });

var $bh6RR = parcelRequire("bh6RR");

var $42o6y = parcelRequire("42o6y");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $18469ba50903eea6$var$$8796f90736e175cb$var$TOOLTIP_DELAY = 1500; // this seems to be a 1.5 second delay, check with design
const $18469ba50903eea6$var$$8796f90736e175cb$var$TOOLTIP_COOLDOWN = 500;
let $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips = {};
let $18469ba50903eea6$var$$8796f90736e175cb$var$tooltipId = 0;
let $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmedUp = false;
let $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
let $18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout = null;
function $18469ba50903eea6$export$4d40659c25ecb50b(props = {}) {
    let { delay: delay = $18469ba50903eea6$var$$8796f90736e175cb$var$TOOLTIP_DELAY, closeDelay: closeDelay = $18469ba50903eea6$var$$8796f90736e175cb$var$TOOLTIP_COOLDOWN } = props;
    let { isOpen: isOpen, open: open, close: close } = (0, $42o6y.useOverlayTriggerState)(props);
    let id = (0, $bh6RR.useMemo)(()=>`${++$18469ba50903eea6$var$$8796f90736e175cb$var$tooltipId}`, []);
    let closeTimeout = (0, $bh6RR.useRef)();
    let ensureTooltipEntry = ()=>{
        $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips[id] = hideTooltip;
    };
    let closeOpenTooltips = ()=>{
        for(let hideTooltipId in $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips)if (hideTooltipId !== id) {
            $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips[hideTooltipId](true);
            delete $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips[hideTooltipId];
        }
    };
    let showTooltip = ()=>{
        clearTimeout(closeTimeout.current);
        closeTimeout.current = null;
        closeOpenTooltips();
        ensureTooltipEntry();
        $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmedUp = true;
        open();
        if ($18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout) {
            clearTimeout($18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout);
            $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
        }
        if ($18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout) {
            clearTimeout($18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout);
            $18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout = null;
        }
    };
    let hideTooltip = (immediate)=>{
        if (immediate || closeDelay <= 0) {
            clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
            close();
        } else if (!closeTimeout.current) closeTimeout.current = setTimeout(()=>{
            closeTimeout.current = null;
            close();
        }, closeDelay);
        if ($18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout) {
            clearTimeout($18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout);
            $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
        }
        if ($18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmedUp) {
            if ($18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout) clearTimeout($18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout);
            $18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout = setTimeout(()=>{
                delete $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips[id];
                $18469ba50903eea6$var$$8796f90736e175cb$var$globalCooldownTimeout = null;
                $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmedUp = false;
            }, Math.max($18469ba50903eea6$var$$8796f90736e175cb$var$TOOLTIP_COOLDOWN, closeDelay));
        }
    };
    let warmupTooltip = ()=>{
        closeOpenTooltips();
        ensureTooltipEntry();
        if (!isOpen && !$18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout && !$18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmedUp) $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout = setTimeout(()=>{
            $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
            $18469ba50903eea6$var$$8796f90736e175cb$var$globalWarmedUp = true;
            showTooltip();
        }, delay);
        else if (!isOpen) showTooltip();
    };
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            clearTimeout(closeTimeout.current);
            let tooltip = $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips[id];
            if (tooltip) delete $18469ba50903eea6$var$$8796f90736e175cb$var$tooltips[id];
        };
    }, [
        id
    ]);
    return {
        isOpen: isOpen,
        open: (immediate)=>{
            if (!immediate && delay > 0 && !closeTimeout.current) warmupTooltip();
            else showTooltip();
        },
        close: hideTooltip
    };
}

});

parcelRegister("gOTHm", function(module, exports) {

$parcel$export(module.exports, "useTooltip", function () { return $c3ec855dfbc21a29$export$1c4b08e0eca38426; });
$parcel$export(module.exports, "useTooltipTrigger", function () { return $c3ec855dfbc21a29$export$a6da6c504e4bba8b; });

var $leZvJ = parcelRequire("leZvJ");
var $dCyIs = parcelRequire("dCyIs");
var $43JEG = parcelRequire("43JEG");

var $hNPyg = parcelRequire("hNPyg");
var $aYzIb = parcelRequire("aYzIb");

var $bh6RR = parcelRequire("bh6RR");

var $dvZLY = parcelRequire("dvZLY");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c3ec855dfbc21a29$export$1c4b08e0eca38426(props, state) {
    let domProps = (0, $leZvJ.filterDOMProps)(props, {
        labelable: true
    });
    let { hoverProps: hoverProps } = (0, $aYzIb.useHover)({
        onHoverStart: ()=>state === null || state === void 0 ? void 0 : state.open(true),
        onHoverEnd: ()=>state === null || state === void 0 ? void 0 : state.close()
    });
    return {
        tooltipProps: (0, $dCyIs.mergeProps)(domProps, hoverProps, {
            role: "tooltip"
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c3ec855dfbc21a29$export$a6da6c504e4bba8b(props, state, ref) {
    let { isDisabled: isDisabled, trigger: trigger } = props;
    let tooltipId = (0, $43JEG.useId)();
    let isHovered = (0, $bh6RR.useRef)(false);
    let isFocused = (0, $bh6RR.useRef)(false);
    let handleShow = ()=>{
        if (isHovered.current || isFocused.current) state.open(isFocused.current);
    };
    let handleHide = (immediate)=>{
        if (!isHovered.current && !isFocused.current) state.close(immediate);
    };
    (0, $bh6RR.useEffect)(()=>{
        let onKeyDown = (e)=>{
            if (ref && ref.current) {
                if (e.key === "Escape") {
                    e.stopPropagation();
                    state.close(true);
                }
            }
        };
        if (state.isOpen) {
            document.addEventListener("keydown", onKeyDown, true);
            return ()=>{
                document.removeEventListener("keydown", onKeyDown, true);
            };
        }
    }, [
        ref,
        state
    ]);
    let onHoverStart = ()=>{
        if (trigger === "focus") return;
        // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
        // interactions for example, hover will end. When hover is restored after that element disappears,
        // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
        // is the result of moving the mouse.
        if ((0, $hNPyg.getInteractionModality)() === "pointer") isHovered.current = true;
        else isHovered.current = false;
        handleShow();
    };
    let onHoverEnd = ()=>{
        if (trigger === "focus") return;
        // no matter how the trigger is left, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide();
    };
    let onPressStart = ()=>{
        // no matter how the trigger is pressed, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let onFocus = ()=>{
        let isVisible = (0, $hNPyg.isFocusVisible)();
        if (isVisible) {
            isFocused.current = true;
            handleShow();
        }
    };
    let onBlur = ()=>{
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let { hoverProps: hoverProps } = (0, $aYzIb.useHover)({
        isDisabled: isDisabled,
        onHoverStart: onHoverStart,
        onHoverEnd: onHoverEnd
    });
    let { focusableProps: focusableProps } = (0, $dvZLY.useFocusable)({
        isDisabled: isDisabled,
        onFocus: onFocus,
        onBlur: onBlur
    }, ref);
    return {
        triggerProps: {
            "aria-describedby": state.isOpen ? tooltipId : undefined,
            ...(0, $dCyIs.mergeProps)(focusableProps, hoverProps, {
                onPointerDown: onPressStart,
                onKeyDown: onPressStart
            })
        },
        tooltipProps: {
            id: tooltipId
        }
    };
}

});
parcelRegister("hNPyg", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $cf5f00552a616272$export$b9b3dfddab17db27; });
$parcel$export(module.exports, "getInteractionModality", function () { return $cf5f00552a616272$export$630ff653c5ada6a9; });

var $ld26B = parcelRequire("ld26B");
var $kI2if = parcelRequire("kI2if");
var $7uYIl = parcelRequire("7uYIl");

var $bh6RR = parcelRequire("bh6RR");

var $2GhkT = parcelRequire("2GhkT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality = null;
let $cf5f00552a616272$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $cf5f00552a616272$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $cf5f00552a616272$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $cf5f00552a616272$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $cf5f00552a616272$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $cf5f00552a616272$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $kI2if.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($cf5f00552a616272$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $7uYIl.isVirtualClick)(e)) {
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$cf5f00552a616272$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $cf5f00552a616272$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $cf5f00552a616272$export$d90243b58daecda7.get((0, $ld26B.getOwnerWindow)(element))) return;
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $cf5f00552a616272$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $cf5f00552a616272$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $ld26B.getOwnerWindow)(element);
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$cf5f00552a616272$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $cf5f00552a616272$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $cf5f00552a616272$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $cf5f00552a616272$export$d90243b58daecda7.delete(windowObject);
};
function $cf5f00552a616272$export$2f1888112f558a7d(element) {
    const documentObject = (0, $ld26B.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $cf5f00552a616272$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $cf5f00552a616272$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$cf5f00552a616272$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $cf5f00552a616272$export$2f1888112f558a7d();
function $cf5f00552a616272$export$b9b3dfddab17db27() {
    return $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $cf5f00552a616272$export$630ff653c5ada6a9() {
    return $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality;
}
function $cf5f00552a616272$export$8397ddfc504fdb9a(modality) {
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality = modality;
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $cf5f00552a616272$export$98e20ec92f614cfe() {
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($cf5f00552a616272$var$$507fabe10e71c6fb$var$currentModality);
        };
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $cf5f00552a616272$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $2GhkT.useIsSSR)() ? null : modality;
}
const $cf5f00552a616272$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $cf5f00552a616272$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $ld26B.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$cf5f00552a616272$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$cf5f00552a616272$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $cf5f00552a616272$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $cf5f00552a616272$export$b9b3dfddab17db27());
    $cf5f00552a616272$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $cf5f00552a616272$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $cf5f00552a616272$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$cf5f00552a616272$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($cf5f00552a616272$export$b9b3dfddab17db27());
        };
        $cf5f00552a616272$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $cf5f00552a616272$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("aYzIb", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $7fdb358ba437c00b$export$ae780daf29e6d456; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $7fdb358ba437c00b$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $7fdb358ba437c00b$var$$6179b936705e76d3$var$hoverCount = 0;
function $7fdb358ba437c00b$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $7fdb358ba437c00b$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $7fdb358ba437c00b$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $7fdb358ba437c00b$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $7fdb358ba437c00b$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $7fdb358ba437c00b$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $7fdb358ba437c00b$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $7fdb358ba437c00b$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $7fdb358ba437c00b$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $7fdb358ba437c00b$var$$6179b936705e76d3$var$hoverCount--;
        if ($7fdb358ba437c00b$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $7fdb358ba437c00b$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $7fdb358ba437c00b$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $7fdb358ba437c00b$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $bh6RR.useState)(false);
    let state = (0, $bh6RR.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $bh6RR.useEffect)($7fdb358ba437c00b$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $bh6RR.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($7fdb358ba437c00b$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$7fdb358ba437c00b$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $bh6RR.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});

parcelRegister("dvZLY", function(module, exports) {

$parcel$export(module.exports, "useFocusable", function () { return $9d6e165f81c6e5df$export$4c014de7c8940b4c; });

var $dsyDZ = parcelRequire("dsyDZ");

var $dCyIs = parcelRequire("dCyIs");
var $99EP5 = parcelRequire("99EP5");
var $2Cn0z = parcelRequire("2Cn0z");

var $bh6RR = parcelRequire("bh6RR");

var $aBQqw = parcelRequire("aBQqw");
var $kSDcK = parcelRequire("kSDcK");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $9d6e165f81c6e5df$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $9d6e165f81c6e5df$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $bh6RR.useContext)($9d6e165f81c6e5df$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $2Cn0z.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $9d6e165f81c6e5df$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $99EP5.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($9d6e165f81c6e5df$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $9d6e165f81c6e5df$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($9d6e165f81c6e5df$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $9d6e165f81c6e5df$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $aBQqw.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $kSDcK.useKeyboard)(props);
    let interactions = (0, $dCyIs.mergeProps)(focusProps, keyboardProps);
    let domProps = $9d6e165f81c6e5df$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $bh6RR.useRef)(props.autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $dsyDZ.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $dCyIs.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

});
parcelRegister("dsyDZ", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $9cc8c37c3c542316$export$80f3e147d781571c; });

var $61nPD = parcelRequire("61nPD");
var $ld26B = parcelRequire("ld26B");
var $8l8s9 = parcelRequire("8l8s9");

var $hNPyg = parcelRequire("hNPyg");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9cc8c37c3c542316$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $ld26B.getOwnerDocument)(element);
    if ((0, $hNPyg.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $8l8s9.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $61nPD.focusWithoutScrolling)(element);
        });
    } else (0, $61nPD.focusWithoutScrolling)(element);
}

});

parcelRegister("aBQqw", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $7b9606f833eeaa69$export$f8168d8dd8fd66e6; });

var $6zTLn = parcelRequire("6zTLn");

var $bh6RR = parcelRequire("bh6RR");

var $ld26B = parcelRequire("ld26B");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $7b9606f833eeaa69$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $6zTLn.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $ld26B.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("6zTLn", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $4ca1445b885ea885$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $77fRS = parcelRequire("77fRS");
var $1nsPC = parcelRequire("1nsPC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $4ca1445b885ea885$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $4ca1445b885ea885$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $1nsPC.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $77fRS.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $4ca1445b885ea885$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("kSDcK", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $f33743042d2afd44$export$8f71654801c2f7cd; });

var $jJetx = parcelRequire("jJetx");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f33743042d2afd44$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $jJetx.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $jJetx.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("jJetx", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $e5cd72cf12a64725$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e5cd72cf12a64725$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});





parcelRegister("jJ443", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $4bd58457ec7784e2$export$c106dd0671a0fc2d; });
// src/console.ts

var $4TNnu = parcelRequire("4TNnu");
var $4bd58457ec7784e2$var$warningStack = {};
function $4bd58457ec7784e2$export$c106dd0671a0fc2d(message, component, ...args) {
    var _a;
    const tag = component ? ` [${component}]` : " ";
    const log = `[Next UI]${tag}: ${message}`;
    if (typeof console === "undefined") return;
    if ($4bd58457ec7784e2$var$warningStack[log]) return;
    $4bd58457ec7784e2$var$warningStack[log] = true;
    if (((_a = $4TNnu == null ? void 0 : $4TNnu.env) == null ? void 0 : _a.NODE_ENV) !== "production") return console.warn(log, args);
}

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});



parcelRegister("2gNm1", function(module, exports) {

$parcel$export(module.exports, "Clipboard", function () { return $2478752a9a0d0a4b$export$8b44c43c7d8f0830; });

var $bh6RR = parcelRequire("bh6RR");

var $6CH2P = parcelRequire("6CH2P");

var $abKlk = parcelRequire("abKlk");
var $2478752a9a0d0a4b$var$p = Object.defineProperty, $2478752a9a0d0a4b$var$f = Object.defineProperties;
var $2478752a9a0d0a4b$var$s = Object.getOwnPropertyDescriptors;
var $2478752a9a0d0a4b$var$a = Object.getOwnPropertySymbols;
var $2478752a9a0d0a4b$var$c = Object.prototype.hasOwnProperty, $2478752a9a0d0a4b$var$d = Object.prototype.propertyIsEnumerable;
var $2478752a9a0d0a4b$var$t = (r, o, e)=>o in r ? $2478752a9a0d0a4b$var$p(r, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[o] = e, $2478752a9a0d0a4b$var$m = (r, o)=>{
    for(var e in o || (o = {}))$2478752a9a0d0a4b$var$c.call(o, e) && $2478752a9a0d0a4b$var$t(r, e, o[e]);
    if ($2478752a9a0d0a4b$var$a) for (var e of $2478752a9a0d0a4b$var$a(o))$2478752a9a0d0a4b$var$d.call(o, e) && $2478752a9a0d0a4b$var$t(r, e, o[e]);
    return r;
}, $2478752a9a0d0a4b$var$i = (r, o)=>$2478752a9a0d0a4b$var$f(r, $2478752a9a0d0a4b$var$s(o));
const $2478752a9a0d0a4b$export$8b44c43c7d8f0830 = (0, $bh6RR.forwardRef)((r, o)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6CH2P.default), $2478752a9a0d0a4b$var$i($2478752a9a0d0a4b$var$m({
        ref: o
    }, r), {
        weights: (0, $abKlk.default)
    })));
$2478752a9a0d0a4b$export$8b44c43c7d8f0830.displayName = "Clipboard";

});
parcelRegister("6CH2P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32013d82d3e9d834$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $iBY4k = parcelRequire("iBY4k");
var $32013d82d3e9d834$var$y = Object.defineProperty;
var $32013d82d3e9d834$var$c = Object.getOwnPropertySymbols;
var $32013d82d3e9d834$var$f = Object.prototype.hasOwnProperty, $32013d82d3e9d834$var$g = Object.prototype.propertyIsEnumerable;
var $32013d82d3e9d834$var$d = (t, o, e)=>o in t ? $32013d82d3e9d834$var$y(t, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : t[o] = e, $32013d82d3e9d834$var$l = (t, o)=>{
    for(var e in o || (o = {}))$32013d82d3e9d834$var$f.call(o, e) && $32013d82d3e9d834$var$d(t, e, o[e]);
    if ($32013d82d3e9d834$var$c) for (var e of $32013d82d3e9d834$var$c(o))$32013d82d3e9d834$var$g.call(o, e) && $32013d82d3e9d834$var$d(t, e, o[e]);
    return t;
};
var $32013d82d3e9d834$var$a = (t, o)=>{
    var e = {};
    for(var r in t)$32013d82d3e9d834$var$f.call(t, r) && o.indexOf(r) < 0 && (e[r] = t[r]);
    if (t != null && $32013d82d3e9d834$var$c) for (var r of $32013d82d3e9d834$var$c(t))o.indexOf(r) < 0 && $32013d82d3e9d834$var$g.call(t, r) && (e[r] = t[r]);
    return e;
};
const $32013d82d3e9d834$var$h = (0, $bh6RR.forwardRef)((t, o)=>{
    const m = t, { alt: e, color: r, size: n, weight: s, mirrored: p, children: u, weights: C } = m, v = $32013d82d3e9d834$var$a(m, [
        "alt",
        "color",
        "size",
        "weight",
        "mirrored",
        "children",
        "weights"
    ]), x = (0, $bh6RR.useContext)((0, $iBY4k.IconContext)), { color: B = "currentColor", size: i, weight: I = "regular", mirrored: E = !1 } = x, R = $32013d82d3e9d834$var$a(x, [
        "color",
        "size",
        "weight",
        "mirrored"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $32013d82d3e9d834$var$l($32013d82d3e9d834$var$l({
        ref: o,
        xmlns: "http://www.w3.org/2000/svg",
        width: n != null ? n : i,
        height: n != null ? n : i,
        fill: r != null ? r : B,
        viewBox: "0 0 256 256",
        transform: p || E ? "scale(-1, 1)" : void 0
    }, R), v), !!e && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("title", null, e), u, C.get(s != null ? s : I));
});
$32013d82d3e9d834$var$h.displayName = "IconBase";
const $32013d82d3e9d834$export$2e2bcd8739ae039 = $32013d82d3e9d834$var$h;

});
parcelRegister("iBY4k", function(module, exports) {

$parcel$export(module.exports, "IconContext", function () { return $cd8458f001140569$export$a49f528ae1a4d0ed; });

var $bh6RR = parcelRequire("bh6RR");
const $cd8458f001140569$export$a49f528ae1a4d0ed = (0, $bh6RR.createContext)({
    color: "currentColor",
    size: "1em",
    weight: "regular",
    mirrored: !1
});

});


parcelRegister("abKlk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b036007a1ea6a7a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $7b036007a1ea6a7a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M200,28H165.47a51.88,51.88,0,0,0-74.94,0H56A20,20,0,0,0,36,48V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V48A20,20,0,0,0,200,28ZM155.71,60H100.29a28,28,0,0,1,55.42,0ZM196,212H60V52H77.41A52.13,52.13,0,0,0,76,64v8A12,12,0,0,0,88,84h80a12,12,0,0,0,12-12V64a52.13,52.13,0,0,0-1.41-12H196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M208,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96a39.83,39.83,0,0,0-8,24v8h80V64a39.83,39.83,0,0,0-8-24h40A8,8,0,0,1,208,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm72,184H56V48H82.75A47.93,47.93,0,0,0,80,64v8a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V64a47.93,47.93,0,0,0-2.75-16H200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M200,34H162.83a45.91,45.91,0,0,0-69.66,0H56A14,14,0,0,0,42,48V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V48A14,14,0,0,0,200,34Zm-72-4a34,34,0,0,1,34,34v2H94V64A34,34,0,0,1,128,30Zm74,186a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H85.67A45.77,45.77,0,0,0,82,64v8a6,6,0,0,0,6,6h80a6,6,0,0,0,6-6V64a45.77,45.77,0,0,0-3.67-18H200a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm72,184H56V48H82.75A47.93,47.93,0,0,0,80,64v8a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V64a47.93,47.93,0,0,0-2.75-16H200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M200,36H161.92a44,44,0,0,0-67.84,0H56A12,12,0,0,0,44,48V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V48A12,12,0,0,0,200,36Zm-72-8a36,36,0,0,1,36,36v4H92V64A36,36,0,0,1,128,28Zm76,188a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H88.83A43.71,43.71,0,0,0,84,64v8a4,4,0,0,0,4,4h80a4,4,0,0,0,4-4V64a43.71,43.71,0,0,0-4.83-20H200a4,4,0,0,1,4,4Z"
        }))
    ]
]);

});


parcelRegister("iXlRp", function(module, exports) {

$parcel$export(module.exports, "Percent", function () { return $5f29c6da0a7f2b37$export$cbc348af47898b5e; });

var $bh6RR = parcelRequire("bh6RR");

var $6CH2P = parcelRequire("6CH2P");

var $58EuN = parcelRequire("58EuN");
var $5f29c6da0a7f2b37$var$f = Object.defineProperty, $5f29c6da0a7f2b37$var$i = Object.defineProperties;
var $5f29c6da0a7f2b37$var$n = Object.getOwnPropertyDescriptors;
var $5f29c6da0a7f2b37$var$o = Object.getOwnPropertySymbols;
var $5f29c6da0a7f2b37$var$p = Object.prototype.hasOwnProperty, $5f29c6da0a7f2b37$var$s = Object.prototype.propertyIsEnumerable;
var $5f29c6da0a7f2b37$var$m = (r, e, t)=>e in r ? $5f29c6da0a7f2b37$var$f(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $5f29c6da0a7f2b37$var$a = (r, e)=>{
    for(var t in e || (e = {}))$5f29c6da0a7f2b37$var$p.call(e, t) && $5f29c6da0a7f2b37$var$m(r, t, e[t]);
    if ($5f29c6da0a7f2b37$var$o) for (var t of $5f29c6da0a7f2b37$var$o(e))$5f29c6da0a7f2b37$var$s.call(e, t) && $5f29c6da0a7f2b37$var$m(r, t, e[t]);
    return r;
}, $5f29c6da0a7f2b37$var$c = (r, e)=>$5f29c6da0a7f2b37$var$i(r, $5f29c6da0a7f2b37$var$n(e));
const $5f29c6da0a7f2b37$export$cbc348af47898b5e = (0, $bh6RR.forwardRef)((r, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6CH2P.default), $5f29c6da0a7f2b37$var$c($5f29c6da0a7f2b37$var$a({
        ref: e
    }, r), {
        weights: (0, $58EuN.default)
    })));
$5f29c6da0a7f2b37$export$cbc348af47898b5e.displayName = "Percent";

});
parcelRegister("58EuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe5c867ec3550595$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $fe5c867ec3550595$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M208.49,64.47l-144,144a12,12,0,1,1-17-17l144-144a12,12,0,0,1,17,17ZM47.72,104.27A40,40,0,1,1,76,116,39.72,39.72,0,0,1,47.72,104.27ZM60,76a16,16,0,1,0,4.69-11.31A15.87,15.87,0,0,0,60,76ZM220,180a40,40,0,1,1-11.72-28.29A39.71,39.71,0,0,1,220,180Zm-24,0a15.87,15.87,0,0,0-4.69-11.32h0A16,16,0,1,0,196,180Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M95.8,56.2a28,28,0,1,1-39.6,0A28,28,0,0,1,95.8,56.2Zm104,104a28,28,0,1,0,0,39.6A28,28,0,0,0,199.8,160.2Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M205.66,61.64l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.31ZM50.54,101.44a36,36,0,0,1,50.92-50.91h0a36,36,0,0,1-50.92,50.91ZM56,76A20,20,0,1,0,90.14,61.84h0A20,20,0,0,0,56,76ZM216,180a36,36,0,1,1-10.54-25.46h0A35.76,35.76,0,0,1,216,180Zm-16,0a20,20,0,1,0-5.86,14.14A19.87,19.87,0,0,0,200,180Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M176,172a12,12,0,1,1-12-12A12,12,0,0,1,176,172ZM92,96A12,12,0,1,0,80,84,12,12,0,0,0,92,96ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM64,84A28,28,0,1,0,92,56,28,28,0,0,0,64,84Zm128,88a28,28,0,1,0-28,28A28,28,0,0,0,192,172ZM189.66,66.34a8,8,0,0,0-11.32,0l-112,112a8,8,0,0,0,11.32,11.32l112-112A8,8,0,0,0,189.66,66.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M204.24,60.23l-144,144a6,6,0,0,1-8.48-8.48l144-144a6,6,0,1,1,8.48,8.49ZM52,100A34,34,0,1,1,76,110,33.78,33.78,0,0,1,52,100Zm2-24a22,22,0,1,0,6.44-15.56A21.86,21.86,0,0,0,54,76ZM214,180A34,34,0,1,1,204,156,33.78,33.78,0,0,1,214,180Zm-12,0a21.87,21.87,0,0,0-6.44-15.56h0A22,22,0,1,0,202,180Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M205.66,61.64l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.31ZM50.54,101.44a36,36,0,0,1,50.92-50.91h0a36,36,0,0,1-50.92,50.91ZM56,76A20,20,0,1,0,90.14,61.84h0A20,20,0,0,0,56,76ZM216,180a36,36,0,1,1-10.54-25.46h0A35.76,35.76,0,0,1,216,180Zm-16,0a20,20,0,1,0-5.86,14.14A19.87,19.87,0,0,0,200,180Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M202.83,58.81l-144,144a4,4,0,0,1-5.66-5.66l144-144a4,4,0,1,1,5.66,5.65ZM53.37,98.62A32,32,0,1,1,76,108,31.82,31.82,0,0,1,53.37,98.62ZM52,76a24,24,0,1,0,7-17A23.85,23.85,0,0,0,52,76ZM212,180a32,32,0,1,1-9.37-22.63A31.82,31.82,0,0,1,212,180Zm-8,0a24,24,0,1,0-7,17A23.89,23.89,0,0,0,204,180Z"
        }))
    ]
]);

});


parcelRegister("59s2y", function(module, exports) {

$parcel$export(module.exports, "PlusCircle", function () { return $031cacbb0bbceda5$export$d8dd5a6f368a4f30; });

var $bh6RR = parcelRequire("bh6RR");

var $6CH2P = parcelRequire("6CH2P");

var $lz0Dh = parcelRequire("lz0Dh");
var $031cacbb0bbceda5$var$s = Object.defineProperty, $031cacbb0bbceda5$var$c = Object.defineProperties;
var $031cacbb0bbceda5$var$l = Object.getOwnPropertyDescriptors;
var $031cacbb0bbceda5$var$t = Object.getOwnPropertySymbols;
var $031cacbb0bbceda5$var$f = Object.prototype.hasOwnProperty, $031cacbb0bbceda5$var$p = Object.prototype.propertyIsEnumerable;
var $031cacbb0bbceda5$var$m = (r, e, o)=>e in r ? $031cacbb0bbceda5$var$s(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : r[e] = o, $031cacbb0bbceda5$var$a = (r, e)=>{
    for(var o in e || (e = {}))$031cacbb0bbceda5$var$f.call(e, o) && $031cacbb0bbceda5$var$m(r, o, e[o]);
    if ($031cacbb0bbceda5$var$t) for (var o of $031cacbb0bbceda5$var$t(e))$031cacbb0bbceda5$var$p.call(e, o) && $031cacbb0bbceda5$var$m(r, o, e[o]);
    return r;
}, $031cacbb0bbceda5$var$i = (r, e)=>$031cacbb0bbceda5$var$c(r, $031cacbb0bbceda5$var$l(e));
const $031cacbb0bbceda5$export$d8dd5a6f368a4f30 = (0, $bh6RR.forwardRef)((r, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6CH2P.default), $031cacbb0bbceda5$var$i($031cacbb0bbceda5$var$a({
        ref: e
    }, r), {
        weights: (0, $lz0Dh.default)
    })));
$031cacbb0bbceda5$export$d8dd5a6f368a4f30.displayName = "PlusCircle";

});
parcelRegister("lz0Dh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce0d40623d1c0196$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $ce0d40623d1c0196$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm52-84a12,12,0,0,1-12,12H140v28a12,12,0,0,1-24,0V140H88a12,12,0,0,1,0-24h28V88a12,12,0,0,1,24,0v28h28A12,12,0,0,1,180,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24Zm40,112H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm46-90a6,6,0,0,1-6,6H134v34a6,6,0,0,1-12,0V134H88a6,6,0,0,1,0-12h34V88a6,6,0,0,1,12,0v34h34A6,6,0,0,1,174,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-92a4,4,0,0,1-4,4H132v36a4,4,0,0,1-8,0V132H88a4,4,0,0,1,0-8h36V88a4,4,0,0,1,8,0v36h36A4,4,0,0,1,172,128Z"
        }))
    ]
]);

});


parcelRegister("31liG", function(module, exports) {

$parcel$export(module.exports, "Question", function () { return $3d96e37e97406edb$export$38435c7d2fecd2f; });

var $bh6RR = parcelRequire("bh6RR");

var $6CH2P = parcelRequire("6CH2P");

var $lxo9O = parcelRequire("lxo9O");
var $3d96e37e97406edb$var$s = Object.defineProperty, $3d96e37e97406edb$var$f = Object.defineProperties;
var $3d96e37e97406edb$var$n = Object.getOwnPropertyDescriptors;
var $3d96e37e97406edb$var$r = Object.getOwnPropertySymbols;
var $3d96e37e97406edb$var$p = Object.prototype.hasOwnProperty, $3d96e37e97406edb$var$c = Object.prototype.propertyIsEnumerable;
var $3d96e37e97406edb$var$m = (o, e, t)=>e in o ? $3d96e37e97406edb$var$s(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $3d96e37e97406edb$var$a = (o, e)=>{
    for(var t in e || (e = {}))$3d96e37e97406edb$var$p.call(e, t) && $3d96e37e97406edb$var$m(o, t, e[t]);
    if ($3d96e37e97406edb$var$r) for (var t of $3d96e37e97406edb$var$r(e))$3d96e37e97406edb$var$c.call(e, t) && $3d96e37e97406edb$var$m(o, t, e[t]);
    return o;
}, $3d96e37e97406edb$var$i = (o, e)=>$3d96e37e97406edb$var$f(o, $3d96e37e97406edb$var$n(e));
const $3d96e37e97406edb$export$38435c7d2fecd2f = (0, $bh6RR.forwardRef)((o, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6CH2P.default), $3d96e37e97406edb$var$i($3d96e37e97406edb$var$a({
        ref: e
    }, o), {
        weights: (0, $lxo9O.default)
    })));
$3d96e37e97406edb$export$38435c7d2fecd2f.displayName = "Question";

});
parcelRegister("lxo9O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7987a706a55ecf8$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $d7987a706a55ecf8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M144,180a16,16,0,1,1-16-16A16,16,0,0,1,144,180Zm92-52A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128ZM128,64c-24.26,0-44,17.94-44,40v4a12,12,0,0,0,24,0v-4c0-8.82,9-16,20-16s20,7.18,20,16-9,16-20,16a12,12,0,0,0-12,12v8a12,12,0,0,0,23.73,2.56C158.31,137.88,172,122.37,172,104,172,81.94,152.26,64,128,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.72V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36s40,16.15,40,36C168,125.38,154.24,139.93,136,143.28Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M138,180a10,10,0,1,1-10-10A10,10,0,0,1,138,180ZM128,74c-21,0-38,15.25-38,34v4a6,6,0,0,0,12,0v-4c0-12.13,11.66-22,26-22s26,9.87,26,22-11.66,22-26,22a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0v-2.42c18.11-2.58,32-16.66,32-33.58C166,89.25,149,74,128,74Zm102,54A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M136,180a8,8,0,1,1-8-8A8,8,0,0,1,136,180ZM128,76c-19.85,0-36,14.36-36,32v4a4,4,0,0,0,8,0v-4c0-13.23,12.56-24,28-24s28,10.77,28,24-12.56,24-28,24a4,4,0,0,0-4,4v8a4,4,0,0,0,8,0v-4.2c18-1.77,32-15.36,32-31.8C164,90.36,147.85,76,128,76Zm100,52A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);

});


parcelRegister("3xiYP", function(module, exports) {

$parcel$export(module.exports, "User", function () { return $74ada8603bc427ce$export$1f44aaf2ec115b54; });

var $bh6RR = parcelRequire("bh6RR");

var $6CH2P = parcelRequire("6CH2P");

var $kDei9 = parcelRequire("kDei9");
var $74ada8603bc427ce$var$f = Object.defineProperty, $74ada8603bc427ce$var$i = Object.defineProperties;
var $74ada8603bc427ce$var$p = Object.getOwnPropertyDescriptors;
var $74ada8603bc427ce$var$t = Object.getOwnPropertySymbols;
var $74ada8603bc427ce$var$c = Object.prototype.hasOwnProperty, $74ada8603bc427ce$var$n = Object.prototype.propertyIsEnumerable;
var $74ada8603bc427ce$var$m = (r, e, o)=>e in r ? $74ada8603bc427ce$var$f(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : r[e] = o, $74ada8603bc427ce$var$a = (r, e)=>{
    for(var o in e || (e = {}))$74ada8603bc427ce$var$c.call(e, o) && $74ada8603bc427ce$var$m(r, o, e[o]);
    if ($74ada8603bc427ce$var$t) for (var o of $74ada8603bc427ce$var$t(e))$74ada8603bc427ce$var$n.call(e, o) && $74ada8603bc427ce$var$m(r, o, e[o]);
    return r;
}, $74ada8603bc427ce$var$s = (r, e)=>$74ada8603bc427ce$var$i(r, $74ada8603bc427ce$var$p(e));
const $74ada8603bc427ce$export$1f44aaf2ec115b54 = (0, $bh6RR.forwardRef)((r, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6CH2P.default), $74ada8603bc427ce$var$s($74ada8603bc427ce$var$a({
        ref: e
    }, r), {
        weights: (0, $kDei9.default)
    })));
$74ada8603bc427ce$export$1f44aaf2ec115b54.displayName = "User";

});
parcelRegister("kDei9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddca8780bb98f643$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $ddca8780bb98f643$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M234.38,210a123.36,123.36,0,0,0-60.78-53.23,76,76,0,1,0-91.2,0A123.36,123.36,0,0,0,21.62,210a12,12,0,1,0,20.77,12c18.12-31.32,50.12-50,85.61-50s67.49,18.69,85.61,50a12,12,0,0,0,20.77-12ZM76,96a52,52,0,1,1,52,52A52.06,52.06,0,0,1,76,96Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M192,96a64,64,0,1,1-64-64A64,64,0,0,1,192,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M230.93,220a8,8,0,0,1-6.93,4H32a8,8,0,0,1-6.92-12c15.23-26.33,38.7-45.21,66.09-54.16a72,72,0,1,1,73.66,0c27.39,8.95,50.86,27.83,66.09,54.16A8,8,0,0,1,230.93,220Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M229.19,213c-15.81-27.32-40.63-46.49-69.47-54.62a70,70,0,1,0-63.44,0C67.44,166.5,42.62,185.67,26.81,213a6,6,0,1,0,10.38,6C56.4,185.81,90.34,166,128,166s71.6,19.81,90.81,53a6,6,0,1,0,10.38-6ZM70,96a58,58,0,1,1,58,58A58.07,58.07,0,0,1,70,96Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M227.46,214c-16.52-28.56-43-48.06-73.68-55.09a68,68,0,1,0-51.56,0c-30.64,7-57.16,26.53-73.68,55.09a4,4,0,0,0,6.92,4C55,184.19,89.62,164,128,164s73,20.19,92.54,54a4,4,0,0,0,3.46,2,3.93,3.93,0,0,0,2-.54A4,4,0,0,0,227.46,214ZM68,96a60,60,0,1,1,60,60A60.07,60.07,0,0,1,68,96Z"
        }))
    ]
]);

});


parcelRegister("4Kpzs", function(module, exports) {

$parcel$export(module.exports, "X", function () { return $ee0ab1a75df50fca$export$78acf4525d8a74c4; });

var $bh6RR = parcelRequire("bh6RR");

var $6CH2P = parcelRequire("6CH2P");

var $iZJvY = parcelRequire("iZJvY");
var $ee0ab1a75df50fca$var$i = Object.defineProperty, $ee0ab1a75df50fca$var$p = Object.defineProperties;
var $ee0ab1a75df50fca$var$s = Object.getOwnPropertyDescriptors;
var $ee0ab1a75df50fca$var$t = Object.getOwnPropertySymbols;
var $ee0ab1a75df50fca$var$c = Object.prototype.hasOwnProperty, $ee0ab1a75df50fca$var$n = Object.prototype.propertyIsEnumerable;
var $ee0ab1a75df50fca$var$m = (o, e, r)=>e in o ? $ee0ab1a75df50fca$var$i(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : o[e] = r, $ee0ab1a75df50fca$var$a = (o, e)=>{
    for(var r in e || (e = {}))$ee0ab1a75df50fca$var$c.call(e, r) && $ee0ab1a75df50fca$var$m(o, r, e[r]);
    if ($ee0ab1a75df50fca$var$t) for (var r of $ee0ab1a75df50fca$var$t(e))$ee0ab1a75df50fca$var$n.call(e, r) && $ee0ab1a75df50fca$var$m(o, r, e[r]);
    return o;
}, $ee0ab1a75df50fca$var$f = (o, e)=>$ee0ab1a75df50fca$var$p(o, $ee0ab1a75df50fca$var$s(e));
const $ee0ab1a75df50fca$export$78acf4525d8a74c4 = (0, $bh6RR.forwardRef)((o, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6CH2P.default), $ee0ab1a75df50fca$var$f($ee0ab1a75df50fca$var$a({
        ref: e
    }, o), {
        weights: (0, $iZJvY.default)
    })));
$ee0ab1a75df50fca$export$78acf4525d8a74c4.displayName = "X";

});
parcelRegister("iZJvY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f8d1fc881fe491e$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $4f8d1fc881fe491e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
            d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"
        }))
    ]
]);

});


parcelRegister("5TnqA", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("9yX7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f652767fae8b411$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * Hook to load external script.
 * @param src - Source url to load.
 * @param onLoad - Success callback.
 * @param onError - Error callback.
 */ function $6f652767fae8b411$var$useLoadScript(src, onLoad, onError) {
    (0, $bh6RR.useEffect)(()=>{
        if (!document) return;
        // Find script tag with same src in DOM.
        const foundScript = document.querySelector('script[src="'.concat(src, '"]'));
        // Call onLoad if script marked as loaded.
        if (foundScript === null || foundScript === void 0 ? void 0 : foundScript.dataset.loaded) {
            onLoad === null || onLoad === void 0 || onLoad();
            return;
        }
        // Create or get existed tag.
        const script = foundScript || document.createElement("script");
        // Set src if no script was found.
        if (!foundScript) script.src = src;
        // Mark script as loaded on load event.
        const onLoadWithMarker = ()=>{
            script.dataset.loaded = "1";
            onLoad === null || onLoad === void 0 || onLoad();
        };
        script.addEventListener("load", onLoadWithMarker);
        if (onError) script.addEventListener("error", onError);
        // Add to DOM if not yet added.
        if (!foundScript) document.head.append(script);
        return ()=>{
            script.removeEventListener("load", onLoadWithMarker);
            if (onError) script.removeEventListener("error", onError);
        };
    }, []);
}
/**
 * Hook to load Google Charts JS API.
 * @param params - Load parameters.
 * @param [params.chartVersion] - Chart version to load.
 * @param [params.chartPackages] - Packages to load.
 * @param [params.chartLanguage] - Languages to load.
 * @param [params.mapsApiKey] - Google Maps api key.
 * @returns
 */ function $6f652767fae8b411$var$useLoadGoogleCharts(param) {
    let { chartVersion: chartVersion = "current", chartPackages: chartPackages = [
        "corechart",
        "controls"
    ], chartLanguage: chartLanguage = "en", mapsApiKey: mapsApiKey } = param;
    const [googleCharts, setGoogleCharts] = (0, $bh6RR.useState)(null);
    const [failed, setFailed] = (0, $bh6RR.useState)(false);
    $6f652767fae8b411$var$useLoadScript("https://www.gstatic.com/charts/loader.js", ()=>{
        // @ts-expect-error Getting object from global namespace.
        const google = window === null || window === void 0 ? void 0 : window.google;
        if (!google) return;
        google.charts.load(chartVersion, {
            packages: chartPackages,
            language: chartLanguage,
            mapsApiKey: mapsApiKey
        });
        google.charts.setOnLoadCallback(()=>{
            setGoogleCharts(google);
        });
    }, ()=>{
        setFailed(true);
    });
    return [
        googleCharts,
        failed
    ];
}
/**
 * Wrapper around useLoadGoogleCharts to use in legacy components.
 */ function $6f652767fae8b411$var$LoadGoogleCharts(param) {
    let { onLoad: onLoad, onError: onError, ...params } = param;
    const [googleCharts, failed] = $6f652767fae8b411$var$useLoadGoogleCharts(params);
    (0, $bh6RR.useEffect)(()=>{
        if (googleCharts && onLoad) onLoad(googleCharts);
    }, [
        googleCharts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (failed && onError) onError();
    }, [
        failed
    ]);
    return null;
}
const $6f652767fae8b411$var$chartDefaultProps = {
    // <DEPRECATED_PROPS>
    legend_toggle: false,
    // </DEPRECATED_PROPS>
    options: {},
    legendToggle: false,
    getChartWrapper: ()=>{},
    spreadSheetQueryParameters: {
        headers: 1,
        gid: 1
    },
    rootProps: {},
    chartWrapperParams: {}
};
let $6f652767fae8b411$var$uniqueID = 0;
const $6f652767fae8b411$var$generateUniqueID = ()=>{
    $6f652767fae8b411$var$uniqueID += 1;
    return "reactgooglegraph-".concat($6f652767fae8b411$var$uniqueID);
};
const $6f652767fae8b411$var$DEFAULT_CHART_COLORS = [
    "#3366CC",
    "#DC3912",
    "#FF9900",
    "#109618",
    "#990099",
    "#3B3EAC",
    "#0099C6",
    "#DD4477",
    "#66AA00",
    "#B82E2E",
    "#316395",
    "#994499",
    "#22AA99",
    "#AAAA11",
    "#6633CC",
    "#E67300",
    "#8B0707",
    "#329262",
    "#5574A6",
    "#3B3EAC"
];
const $6f652767fae8b411$var$loadDataTableFromSpreadSheet = async function(googleViz, spreadSheetUrl) {
    let urlParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return new Promise((resolve, reject)=>{
        const headers = "".concat(urlParams.headers ? "headers=".concat(urlParams.headers) : "headers=0");
        const queryString = "".concat(urlParams.query ? "&tq=".concat(encodeURIComponent(urlParams.query)) : "");
        const gid = "".concat(urlParams.gid ? "&gid=".concat(urlParams.gid) : "");
        const sheet = "".concat(urlParams.sheet ? "&sheet=".concat(urlParams.sheet) : "");
        const access_token = "".concat(urlParams.access_token ? "&access_token=".concat(urlParams.access_token) : "");
        const urlQueryString = "".concat(headers).concat(gid).concat(sheet).concat(queryString).concat(access_token);
        const urlToSpreadSheet = "".concat(spreadSheetUrl, "/gviz/tq?").concat(urlQueryString); //&tq=${queryString}`;
        const query = new googleViz.visualization.Query(urlToSpreadSheet);
        query.send((response)=>{
            if (response.isError()) reject("Error in query:  ".concat(response.getMessage(), " ").concat(response.getDetailedMessage()));
            else resolve(response.getDataTable());
        });
    });
};
const { Provider: $6f652767fae8b411$var$Provider, Consumer: $6f652767fae8b411$var$Consumer } = /*#__PURE__*/ $bh6RR.createContext($6f652767fae8b411$var$chartDefaultProps);
const $6f652767fae8b411$var$ContextProvider = (param)=>{
    let { children: children, value: value } = param;
    return /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$Provider, {
        value: value
    }, children);
};
const $6f652767fae8b411$var$ContextConsumer = (param)=>{
    let { render: render } = param;
    return /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$Consumer, null, (context)=>{
        return render(context);
    });
};
const $6f652767fae8b411$var$GRAY_COLOR = "#CCCCCC";
class $6f652767fae8b411$var$GoogleChartDataTableInner extends $bh6RR.Component {
    componentDidMount() {
        this.draw(this.props);
        window.addEventListener("resize", this.onResize);
        if (this.props.legend_toggle || this.props.legendToggle) this.listenToLegendToggle();
    }
    componentWillUnmount() {
        const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
        window.removeEventListener("resize", this.onResize);
        google.visualization.events.removeAllListeners(googleChartWrapper);
        if (googleChartWrapper.getChartType() === "Timeline") googleChartWrapper.getChart() && googleChartWrapper.getChart().clearChart();
    }
    componentDidUpdate() {
        this.draw(this.props);
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hiddenColumns: []
        };
        this.listenToLegendToggle = ()=>{
            const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
            google.visualization.events.addListener(googleChartWrapper, "select", ()=>{
                const chart = googleChartWrapper.getChart();
                const selection = chart.getSelection();
                const dataTable = googleChartWrapper.getDataTable();
                if (selection.length === 0 || // We want to listen to when a whole row is selected. This is the case only when row === null
                selection[0].row || !dataTable) return;
                const columnIndex = selection[0].column;
                const columnID = this.getColumnID(dataTable, columnIndex);
                if (this.state.hiddenColumns.includes(columnID)) this.setState((state)=>({
                        ...state,
                        hiddenColumns: [
                            ...state.hiddenColumns.filter((colID)=>colID !== columnID)
                        ]
                    }));
                else this.setState((state)=>({
                        ...state,
                        hiddenColumns: [
                            ...state.hiddenColumns,
                            columnID
                        ]
                    }));
            });
        };
        this.applyFormatters = (dataTable, formatters)=>{
            const { google: google } = this.props;
            for (let formatter of formatters)switch(formatter.type){
                case "ArrowFormat":
                    {
                        const vizFormatter = new google.visualization.ArrowFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "BarFormat":
                    {
                        const vizFormatter = new google.visualization.BarFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "ColorFormat":
                    {
                        const vizFormatter = new google.visualization.ColorFormat(formatter.options);
                        const { ranges: ranges } = formatter;
                        for (let range of ranges)vizFormatter.addRange(...range);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "DateFormat":
                    {
                        const vizFormatter = new google.visualization.DateFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "NumberFormat":
                    {
                        const vizFormatter = new google.visualization.NumberFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "PatternFormat":
                    {
                        const vizFormatter = new google.visualization.PatternFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
            }
        };
        this.getColumnID = (dataTable, columnIndex)=>{
            return dataTable.getColumnId(columnIndex) || dataTable.getColumnLabel(columnIndex);
        };
        this.draw = async (param)=>{
            let { data: data, diffdata: diffdata, rows: rows, columns: columns, options: options, legend_toggle: legend_toggle, legendToggle: legendToggle, chartType: chartType, formatters: formatters, spreadSheetUrl: spreadSheetUrl, spreadSheetQueryParameters: spreadSheetQueryParameters } = param;
            const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
            let dataTable;
            let chartDiff = null;
            if (diffdata) {
                const oldData = google.visualization.arrayToDataTable(diffdata.old);
                const newData = google.visualization.arrayToDataTable(diffdata.new);
                chartDiff = google.visualization[chartType].prototype.computeDiff(oldData, newData);
            }
            if (data !== null) {
                if (Array.isArray(data)) dataTable = google.visualization.arrayToDataTable(data);
                else dataTable = new google.visualization.DataTable(data);
            } else if (rows && columns) dataTable = google.visualization.arrayToDataTable([
                columns,
                ...rows
            ]);
            else if (spreadSheetUrl) dataTable = await $6f652767fae8b411$var$loadDataTableFromSpreadSheet(google, spreadSheetUrl, spreadSheetQueryParameters);
            else dataTable = google.visualization.arrayToDataTable([]);
            const columnCount = dataTable.getNumberOfColumns();
            for(let i = 0; i < columnCount; i += 1){
                const columnID = this.getColumnID(dataTable, i);
                if (this.state.hiddenColumns.includes(columnID)) {
                    const previousColumnLabel = dataTable.getColumnLabel(i);
                    const previousColumnID = dataTable.getColumnId(i);
                    const previousColumnType = dataTable.getColumnType(i);
                    dataTable.removeColumn(i);
                    dataTable.addColumn({
                        label: previousColumnLabel,
                        id: previousColumnID,
                        type: previousColumnType
                    });
                }
            }
            const chart = googleChartWrapper.getChart();
            if (googleChartWrapper.getChartType() === "Timeline") chart && chart.clearChart();
            googleChartWrapper.setChartType(chartType);
            googleChartWrapper.setOptions(options || {});
            googleChartWrapper.setDataTable(dataTable);
            googleChartWrapper.draw();
            if (this.props.googleChartDashboard !== null) this.props.googleChartDashboard.draw(dataTable);
            if (chartDiff) {
                googleChartWrapper.setDataTable(chartDiff);
                googleChartWrapper.draw();
            }
            if (formatters) {
                this.applyFormatters(dataTable, formatters);
                googleChartWrapper.setDataTable(dataTable);
                googleChartWrapper.draw();
            }
            if (legendToggle === true || legend_toggle === true) this.grayOutHiddenColumns({
                options: options
            });
            return;
        };
        this.grayOutHiddenColumns = (param)=>{
            let { options: options } = param;
            const { googleChartWrapper: googleChartWrapper } = this.props;
            const dataTable = googleChartWrapper.getDataTable();
            if (!dataTable) return;
            const columnCount = dataTable.getNumberOfColumns();
            const hasAHiddenColumn = this.state.hiddenColumns.length > 0;
            if (hasAHiddenColumn === false) return;
            const colors = Array.from({
                length: columnCount - 1
            }).map((dontcare, i)=>{
                const columnID = this.getColumnID(dataTable, i + 1);
                if (this.state.hiddenColumns.includes(columnID)) return $6f652767fae8b411$var$GRAY_COLOR;
                else if (options && options.colors) return options.colors[i];
                else return $6f652767fae8b411$var$DEFAULT_CHART_COLORS[i];
            });
            googleChartWrapper.setOptions({
                ...options,
                colors: colors
            });
            googleChartWrapper.draw();
        };
        this.onResize = ()=>{
            const { googleChartWrapper: googleChartWrapper } = this.props;
            googleChartWrapper.draw();
        };
    }
}
class $6f652767fae8b411$var$GoogleChartDataTable extends $bh6RR.Component {
    componentDidMount() {}
    componentWillUnmount() {}
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { google: google, googleChartWrapper: googleChartWrapper, googleChartDashboard: googleChartDashboard } = this.props;
        return /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$ContextConsumer, {
            render: (props)=>{
                return /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$GoogleChartDataTableInner, Object.assign({}, props, {
                    google: google,
                    googleChartWrapper: googleChartWrapper,
                    googleChartDashboard: googleChartDashboard
                }));
            }
        });
    }
}
class $6f652767fae8b411$var$GoogleChartEvents extends $bh6RR.Component {
    shouldComponentUpdate() {
        return false;
    }
    listenToEvents(param) {
        let { chartEvents: chartEvents, google: google, googleChartWrapper: googleChartWrapper } = param;
        if (!chartEvents) return;
        google.visualization.events.removeAllListeners(googleChartWrapper);
        for (let event of chartEvents){
            var _this = this;
            const { eventName: eventName, callback: callback } = event;
            google.visualization.events.addListener(googleChartWrapper, eventName, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                callback({
                    chartWrapper: googleChartWrapper,
                    props: _this.props,
                    google: google,
                    eventArgs: args
                });
            });
        }
    }
    componentDidMount() {
        var ref;
        const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
        this.listenToEvents({
            chartEvents: ((ref = this.propsFromContext) === null || ref === void 0 ? void 0 : ref.chartEvents) || null,
            google: google,
            googleChartWrapper: googleChartWrapper
        });
    }
    render() {
        this.props;
        return /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$ContextConsumer, {
            render: (propsFromContext)=>{
                this.propsFromContext = propsFromContext;
                return null;
            }
        });
    }
    constructor(props){
        super(props);
        this.propsFromContext = null;
    }
}
let $6f652767fae8b411$var$controlCounter = 0;
class $6f652767fae8b411$var$GoogleChart extends $bh6RR.Component {
    componentDidMount() {
        const { options: options, google: google, chartType: chartType, chartWrapperParams: chartWrapperParams, toolbarItems: toolbarItems, getChartEditor: getChartEditor, getChartWrapper: getChartWrapper } = this.props;
        const chartConfig = {
            chartType: chartType,
            options: options,
            containerId: this.getGraphID(),
            ...chartWrapperParams
        };
        const googleChartWrapper = new google.visualization.ChartWrapper(chartConfig);
        googleChartWrapper.setOptions(options || {});
        if (getChartWrapper) getChartWrapper(googleChartWrapper, google);
        const googleChartDashboard = new google.visualization.Dashboard(this.dashboard_ref);
        const googleChartControls = this.addControls(googleChartWrapper, googleChartDashboard);
        if (toolbarItems) google.visualization.drawToolbar(this.toolbar_ref.current, toolbarItems);
        let googleChartEditor = null;
        if (getChartEditor) {
            googleChartEditor = new google.visualization.ChartEditor();
            getChartEditor({
                chartEditor: googleChartEditor,
                chartWrapper: googleChartWrapper,
                google: google
            });
        }
        this.setState({
            googleChartEditor: googleChartEditor,
            googleChartControls: googleChartControls,
            googleChartDashboard: googleChartDashboard,
            googleChartWrapper: googleChartWrapper,
            isReady: true
        });
    }
    componentDidUpdate() {
        if (!this.state.googleChartWrapper) return;
        if (!this.state.googleChartDashboard) return;
        if (!this.state.googleChartControls) return;
        const { controls: controls } = this.props;
        if (controls) for(let i = 0; i < controls.length; i += 1){
            const { controlType: controlType, options: options, controlWrapperParams: controlWrapperParams } = controls[i];
            if (controlWrapperParams && "state" in controlWrapperParams) this.state.googleChartControls[i].control.setState(controlWrapperParams["state"]);
            this.state.googleChartControls[i].control.setOptions(options);
            this.state.googleChartControls[i].control.setControlType(controlType);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.isReady !== nextState.isReady || nextProps.controls !== this.props.controls;
    }
    render() {
        const { width: width, height: height, options: options, style: style } = this.props;
        const divStyle = {
            height: height || options && options.height,
            width: width || options && options.width,
            ...style
        };
        if (this.props.render) return /*#__PURE__*/ $bh6RR.createElement("div", {
            ref: this.dashboard_ref,
            style: divStyle
        }, /*#__PURE__*/ $bh6RR.createElement("div", {
            ref: this.toolbar_ref,
            id: "toolbar"
        }), this.props.render({
            renderChart: this.renderChart,
            renderControl: this.renderControl,
            renderToolbar: this.renderToolBar
        }));
        else return /*#__PURE__*/ $bh6RR.createElement("div", {
            ref: this.dashboard_ref,
            style: divStyle
        }, this.renderControl((param)=>{
            let { controlProp: controlProp } = param;
            return controlProp.controlPosition !== "bottom";
        }), this.renderChart(), this.renderControl((param)=>{
            let { controlProp: controlProp } = param;
            return controlProp.controlPosition === "bottom";
        }), this.renderToolBar());
    }
    constructor(...args1){
        var _this1;
        super(...args1), _this1 = this;
        this.state = {
            googleChartWrapper: null,
            googleChartDashboard: null,
            googleChartControls: null,
            googleChartEditor: null,
            isReady: false
        };
        this.graphID = null;
        this.dashboard_ref = /*#__PURE__*/ $bh6RR.createRef();
        this.toolbar_ref = /*#__PURE__*/ $bh6RR.createRef();
        this.getGraphID = ()=>{
            const { graphID: graphID, graph_id: graph_id } = this.props;
            let instanceGraphID;
            if (!graphID && !graph_id) {
                if (!this.graphID) instanceGraphID = $6f652767fae8b411$var$generateUniqueID();
                else instanceGraphID = this.graphID;
            } else if (graphID && !graph_id) instanceGraphID = graphID;
            else if (graph_id && !graphID) instanceGraphID = graph_id;
            else instanceGraphID = graphID;
            this.graphID = instanceGraphID;
            return this.graphID;
        };
        this.getControlID = (id, index)=>{
            $6f652767fae8b411$var$controlCounter += 1;
            let controlID;
            if (typeof id === "undefined") controlID = "googlechart-control-".concat(index, "-").concat($6f652767fae8b411$var$controlCounter);
            else controlID = id;
            return controlID;
        };
        this.addControls = (googleChartWrapper, googleChartDashboard)=>{
            const { google: google, controls: controls } = this.props;
            const googleChartControls = !controls ? null : controls.map((control, i)=>{
                const { controlID: controlIDMaybe, controlType: controlType, options: controlOptions, controlWrapperParams: controlWrapperParams } = control;
                const controlID = this.getControlID(controlIDMaybe, i);
                return {
                    controlProp: control,
                    control: new google.visualization.ControlWrapper({
                        containerId: controlID,
                        controlType: controlType,
                        options: controlOptions,
                        ...controlWrapperParams
                    })
                };
            });
            if (!googleChartControls) return null;
            googleChartDashboard.bind(googleChartControls.map((param)=>{
                let { control: control } = param;
                return control;
            }), googleChartWrapper);
            for (let chartControl of googleChartControls){
                const { control: control, controlProp: controlProp } = chartControl;
                const { controlEvents: controlEvents = [] } = controlProp;
                for (let event of controlEvents){
                    var _this = this;
                    const { callback: callback, eventName: eventName } = event;
                    google.visualization.events.removeListener(control, eventName, callback);
                    google.visualization.events.addListener(control, eventName, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        callback({
                            chartWrapper: googleChartWrapper,
                            controlWrapper: control,
                            props: _this.props,
                            google: google,
                            eventArgs: args
                        });
                    });
                }
            }
            return googleChartControls;
        };
        this.renderChart = ()=>{
            const { width: width, height: height, options: options, style: style, className: className, rootProps: rootProps, google: google } = this.props;
            const divStyle = {
                height: height || options && options.height,
                width: width || options && options.width,
                ...style
            };
            return /*#__PURE__*/ $bh6RR.createElement("div", Object.assign({
                id: this.getGraphID(),
                style: divStyle,
                className: className
            }, rootProps), this.state.isReady && this.state.googleChartWrapper !== null ? /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$GoogleChartDataTable, {
                googleChartWrapper: this.state.googleChartWrapper,
                google: google,
                googleChartDashboard: this.state.googleChartDashboard
            }), /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$GoogleChartEvents, {
                googleChartWrapper: this.state.googleChartWrapper,
                google: google
            })) : null);
        };
        this.renderControl = function() {
            let filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (param)=>{
                return true;
            };
            return _this1.state.isReady && _this1.state.googleChartControls !== null ? /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, _this1.state.googleChartControls.filter((param)=>{
                let { controlProp: controlProp, control: control } = param;
                return filter({
                    control: control,
                    controlProp: controlProp
                });
            }).map((param)=>{
                let { control: control, controlProp: controlProp } = param;
                return /*#__PURE__*/ $bh6RR.createElement("div", {
                    key: control.getContainerId(),
                    id: control.getContainerId()
                });
            })) : null;
        };
        this.renderToolBar = ()=>{
            if (!this.props.toolbarItems) return null;
            return /*#__PURE__*/ $bh6RR.createElement("div", {
                ref: this.toolbar_ref
            });
        };
    }
}
class $6f652767fae8b411$export$acaa6426d77a227e extends $bh6RR.Component {
    render() {
        const { chartLanguage: chartLanguage, chartPackages: chartPackages, chartVersion: chartVersion, mapsApiKey: mapsApiKey, loader: loader, errorElement: errorElement } = this.props;
        return /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$ContextProvider, {
            value: this.props
        }, this.state.loadingStatus === "ready" && this.state.google !== null ? /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$GoogleChart, Object.assign({}, this.props, {
            google: this.state.google
        })) : this.state.loadingStatus === "errored" && errorElement ? errorElement : loader, /*#__PURE__*/ $bh6RR.createElement($6f652767fae8b411$var$LoadGoogleCharts, {
            chartLanguage: chartLanguage,
            chartPackages: chartPackages,
            chartVersion: chartVersion,
            mapsApiKey: mapsApiKey,
            onLoad: this.onLoad,
            onError: this.onError
        }));
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    isFullyLoaded(google) {
        const { controls: controls, toolbarItems: toolbarItems, getChartEditor: getChartEditor } = this.props;
        return google && google.visualization && google.visualization.ChartWrapper && google.visualization.Dashboard && (!controls || google.visualization.ChartWrapper) && (!getChartEditor || google.visualization.ChartEditor) && (!toolbarItems || google.visualization.drawToolbar);
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.state = {
            loadingStatus: "loading",
            google: null
        };
        this.onLoad = (google1)=>{
            if (this.props.onLoad) this.props.onLoad(google1);
            if (this.isFullyLoaded(google1)) this.onSuccess(google1);
            else {
                // IE11: window.google is not fully set, we have to wait
                const id = setInterval(()=>{
                    const google = window.google;
                    if (this._isMounted) {
                        if (google && this.isFullyLoaded(google)) {
                            clearInterval(id);
                            this.onSuccess(google);
                        }
                    } else clearInterval(id);
                }, 1000);
            }
        };
        this.onSuccess = (google)=>{
            this.setState({
                loadingStatus: "ready",
                google: google
            });
        };
        this.onError = ()=>{
            this.setState({
                loadingStatus: "errored"
            });
        };
    }
}
$6f652767fae8b411$export$acaa6426d77a227e.defaultProps = $6f652767fae8b411$var$chartDefaultProps;
var $6f652767fae8b411$export$81a914879818776c;
(function(GoogleDataTableColumnRoleType) {
    GoogleDataTableColumnRoleType["annotation"] = "annotation";
    GoogleDataTableColumnRoleType["annotationText"] = "annotationText";
    GoogleDataTableColumnRoleType["certainty"] = "certainty";
    GoogleDataTableColumnRoleType["emphasis"] = "emphasis";
    GoogleDataTableColumnRoleType["interval"] = "interval";
    GoogleDataTableColumnRoleType["scope"] = "scope";
    GoogleDataTableColumnRoleType["style"] = "style";
    GoogleDataTableColumnRoleType["tooltip"] = "tooltip";
    GoogleDataTableColumnRoleType["domain"] = "domain";
})($6f652767fae8b411$export$81a914879818776c || ($6f652767fae8b411$export$81a914879818776c = {}));
var $6f652767fae8b411$export$2e2bcd8739ae039 = $6f652767fae8b411$export$acaa6426d77a227e;

});

parcelRegister("Xc4ZS", function(module, exports) {
"use client";
"use strict";
var $0b1ee18f17badd4e$var$Y = Object.create;
var $0b1ee18f17badd4e$var$E = Object.defineProperty;
var $0b1ee18f17badd4e$var$q = Object.getOwnPropertyDescriptor;
var $0b1ee18f17badd4e$var$G = Object.getOwnPropertyNames;
var $0b1ee18f17badd4e$var$K = Object.getPrototypeOf, $0b1ee18f17badd4e$var$Z = Object.prototype.hasOwnProperty;
var $0b1ee18f17badd4e$var$ee = (e, t)=>{
    for(var o in t)$0b1ee18f17badd4e$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $0b1ee18f17badd4e$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $0b1ee18f17badd4e$var$G(t))!$0b1ee18f17badd4e$var$Z.call(e, r) && r !== o && $0b1ee18f17badd4e$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $0b1ee18f17badd4e$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $0b1ee18f17badd4e$var$W = (e, t, o)=>(o = e != null ? $0b1ee18f17badd4e$var$Y($0b1ee18f17badd4e$var$K(e)) : {}, $0b1ee18f17badd4e$var$j(t || !e || !e.__esModule ? $0b1ee18f17badd4e$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $0b1ee18f17badd4e$var$te = (e)=>$0b1ee18f17badd4e$var$j($0b1ee18f17badd4e$var$E({}, "__esModule", {
        value: !0
    }), e);
var $0b1ee18f17badd4e$var$Ve = {};
$0b1ee18f17badd4e$var$ee($0b1ee18f17badd4e$var$Ve, {
    CheckmarkIcon: ()=>$0b1ee18f17badd4e$var$F,
    ErrorIcon: ()=>$0b1ee18f17badd4e$var$w,
    LoaderIcon: ()=>$0b1ee18f17badd4e$var$M,
    ToastBar: ()=>$0b1ee18f17badd4e$var$$,
    ToastIcon: ()=>$0b1ee18f17badd4e$var$U,
    Toaster: ()=>$0b1ee18f17badd4e$var$J,
    default: ()=>$0b1ee18f17badd4e$var$_e,
    resolveValue: ()=>$0b1ee18f17badd4e$var$u,
    toast: ()=>$0b1ee18f17badd4e$var$n,
    useToaster: ()=>$0b1ee18f17badd4e$var$V,
    useToasterStore: ()=>$0b1ee18f17badd4e$var$_
});
module.exports = $0b1ee18f17badd4e$var$te($0b1ee18f17badd4e$var$Ve);
var $0b1ee18f17badd4e$var$oe = (e)=>typeof e == "function", $0b1ee18f17badd4e$var$u = (e, t)=>$0b1ee18f17badd4e$var$oe(e) ? e(t) : e;
var $0b1ee18f17badd4e$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $0b1ee18f17badd4e$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $0b1ee18f17badd4e$var$re = 20;
var $0b1ee18f17badd4e$var$v = new Map, $0b1ee18f17badd4e$var$se = 1e3, $0b1ee18f17badd4e$var$X = (e)=>{
    if ($0b1ee18f17badd4e$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $0b1ee18f17badd4e$var$v.delete(e), $0b1ee18f17badd4e$var$l({
            type: 4,
            toastId: e
        });
    }, $0b1ee18f17badd4e$var$se);
    $0b1ee18f17badd4e$var$v.set(e, t);
}, $0b1ee18f17badd4e$var$ae = (e)=>{
    let t = $0b1ee18f17badd4e$var$v.get(e);
    t && clearTimeout(t);
}, $0b1ee18f17badd4e$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $0b1ee18f17badd4e$var$re)
            };
        case 1:
            return t.toast.id && $0b1ee18f17badd4e$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $0b1ee18f17badd4e$var$H(e, {
                type: 1,
                toast: o
            }) : $0b1ee18f17badd4e$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $0b1ee18f17badd4e$var$X(s) : e.toasts.forEach((a)=>{
                $0b1ee18f17badd4e$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $0b1ee18f17badd4e$var$I = [], $0b1ee18f17badd4e$var$D = {
    toasts: [],
    pausedAt: void 0
}, $0b1ee18f17badd4e$var$l = (e)=>{
    $0b1ee18f17badd4e$var$D = $0b1ee18f17badd4e$var$H($0b1ee18f17badd4e$var$D, e), $0b1ee18f17badd4e$var$I.forEach((t)=>{
        t($0b1ee18f17badd4e$var$D);
    });
}, $0b1ee18f17badd4e$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $0b1ee18f17badd4e$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("bh6RR")).useState)($0b1ee18f17badd4e$var$D);
    (0, (parcelRequire("bh6RR")).useEffect)(()=>($0b1ee18f17badd4e$var$I.push(o), ()=>{
            let r = $0b1ee18f17badd4e$var$I.indexOf(o);
            r > -1 && $0b1ee18f17badd4e$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $0b1ee18f17badd4e$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $0b1ee18f17badd4e$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $0b1ee18f17badd4e$var$Q()
    }), $0b1ee18f17badd4e$var$S = (e)=>(t, o)=>{
        let s = $0b1ee18f17badd4e$var$ce(t, e, o);
        return $0b1ee18f17badd4e$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $0b1ee18f17badd4e$var$n = (e, t)=>$0b1ee18f17badd4e$var$S("blank")(e, t);
$0b1ee18f17badd4e$var$n.error = $0b1ee18f17badd4e$var$S("error");
$0b1ee18f17badd4e$var$n.success = $0b1ee18f17badd4e$var$S("success");
$0b1ee18f17badd4e$var$n.loading = $0b1ee18f17badd4e$var$S("loading");
$0b1ee18f17badd4e$var$n.custom = $0b1ee18f17badd4e$var$S("custom");
$0b1ee18f17badd4e$var$n.dismiss = (e)=>{
    $0b1ee18f17badd4e$var$l({
        type: 3,
        toastId: e
    });
};
$0b1ee18f17badd4e$var$n.remove = (e)=>$0b1ee18f17badd4e$var$l({
        type: 4,
        toastId: e
    });
$0b1ee18f17badd4e$var$n.promise = (e, t, o)=>{
    let s = $0b1ee18f17badd4e$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($0b1ee18f17badd4e$var$n.success($0b1ee18f17badd4e$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $0b1ee18f17badd4e$var$n.error($0b1ee18f17badd4e$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $0b1ee18f17badd4e$var$pe = (e, t)=>{
    $0b1ee18f17badd4e$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $0b1ee18f17badd4e$var$de = ()=>{
    $0b1ee18f17badd4e$var$l({
        type: 5,
        time: Date.now()
    });
}, $0b1ee18f17badd4e$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $0b1ee18f17badd4e$var$_(e);
    (0, (parcelRequire("bh6RR")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $0b1ee18f17badd4e$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$0b1ee18f17badd4e$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("bh6RR")).useCallback)(()=>{
        o && $0b1ee18f17badd4e$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("bh6RR")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $0b1ee18f17badd4e$var$pe,
            startPause: $0b1ee18f17badd4e$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $0b1ee18f17badd4e$var$T = $0b1ee18f17badd4e$var$W((parcelRequire("bh6RR")));

var $6vkQq = parcelRequire("6vkQq");

var $0b1ee18f17badd4e$var$y = $0b1ee18f17badd4e$var$W((parcelRequire("bh6RR")));

var $6vkQq = parcelRequire("6vkQq");

var $6vkQq = parcelRequire("6vkQq");
var $0b1ee18f17badd4e$var$me = $6vkQq.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $0b1ee18f17badd4e$var$ue = $6vkQq.keyframes`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $0b1ee18f17badd4e$var$le = $6vkQq.keyframes`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $0b1ee18f17badd4e$var$w = (0, $6vkQq.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$0b1ee18f17badd4e$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$0b1ee18f17badd4e$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$0b1ee18f17badd4e$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $6vkQq = parcelRequire("6vkQq");
var $0b1ee18f17badd4e$var$Te = $6vkQq.keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $0b1ee18f17badd4e$var$M = (0, $6vkQq.styled)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$0b1ee18f17badd4e$var$Te} 1s linear infinite;
`;

var $6vkQq = parcelRequire("6vkQq");
var $0b1ee18f17badd4e$var$fe = $6vkQq.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $0b1ee18f17badd4e$var$ye = $6vkQq.keyframes`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $0b1ee18f17badd4e$var$F = (0, $6vkQq.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$0b1ee18f17badd4e$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$0b1ee18f17badd4e$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $0b1ee18f17badd4e$var$ge = (0, $6vkQq.styled)("div")`
  position: absolute;
`, $0b1ee18f17badd4e$var$he = (0, $6vkQq.styled)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $0b1ee18f17badd4e$var$xe = $6vkQq.keyframes`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $0b1ee18f17badd4e$var$be = (0, $6vkQq.styled)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$0b1ee18f17badd4e$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $0b1ee18f17badd4e$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $0b1ee18f17badd4e$var$y.createElement($0b1ee18f17badd4e$var$be, null, t) : t : o === "blank" ? null : $0b1ee18f17badd4e$var$y.createElement($0b1ee18f17badd4e$var$he, null, $0b1ee18f17badd4e$var$y.createElement($0b1ee18f17badd4e$var$M, {
        ...s
    }), o !== "loading" && $0b1ee18f17badd4e$var$y.createElement($0b1ee18f17badd4e$var$ge, null, o === "error" ? $0b1ee18f17badd4e$var$y.createElement($0b1ee18f17badd4e$var$w, {
        ...s
    }) : $0b1ee18f17badd4e$var$y.createElement($0b1ee18f17badd4e$var$F, {
        ...s
    })));
};
var $0b1ee18f17badd4e$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $0b1ee18f17badd4e$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $0b1ee18f17badd4e$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $0b1ee18f17badd4e$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $0b1ee18f17badd4e$var$Ee = (0, $6vkQq.styled)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $0b1ee18f17badd4e$var$Re = (0, $6vkQq.styled)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $0b1ee18f17badd4e$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $0b1ee18f17badd4e$var$R() ? [
        $0b1ee18f17badd4e$var$Pe,
        $0b1ee18f17badd4e$var$Oe
    ] : [
        $0b1ee18f17badd4e$var$Se(s),
        $0b1ee18f17badd4e$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $6vkQq.keyframes)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $6vkQq.keyframes)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $0b1ee18f17badd4e$var$$ = $0b1ee18f17badd4e$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $0b1ee18f17badd4e$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $0b1ee18f17badd4e$var$T.createElement($0b1ee18f17badd4e$var$U, {
        toast: e
    }), c = $0b1ee18f17badd4e$var$T.createElement($0b1ee18f17badd4e$var$Re, {
        ...e.ariaProps
    }, $0b1ee18f17badd4e$var$u(e.message, e));
    return $0b1ee18f17badd4e$var$T.createElement($0b1ee18f17badd4e$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $0b1ee18f17badd4e$var$T.createElement($0b1ee18f17badd4e$var$T.Fragment, null, a, c));
});

var $6vkQq = parcelRequire("6vkQq");

var $0b1ee18f17badd4e$var$f = $0b1ee18f17badd4e$var$W((parcelRequire("bh6RR")));
(0, $6vkQq.setup)($0b1ee18f17badd4e$var$f.createElement);
var $0b1ee18f17badd4e$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $0b1ee18f17badd4e$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $0b1ee18f17badd4e$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $0b1ee18f17badd4e$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $0b1ee18f17badd4e$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $0b1ee18f17badd4e$var$ke = $6vkQq.css`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $0b1ee18f17badd4e$var$L = 16, $0b1ee18f17badd4e$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $0b1ee18f17badd4e$var$V(o);
    return $0b1ee18f17badd4e$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $0b1ee18f17badd4e$var$L,
            left: $0b1ee18f17badd4e$var$L,
            right: $0b1ee18f17badd4e$var$L,
            bottom: $0b1ee18f17badd4e$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $0b1ee18f17badd4e$var$De(g, z);
        return $0b1ee18f17badd4e$var$f.createElement($0b1ee18f17badd4e$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $0b1ee18f17badd4e$var$ke : "",
            style: O
        }, p.type === "custom" ? $0b1ee18f17badd4e$var$u(p.message, p) : r ? r(p) : $0b1ee18f17badd4e$var$f.createElement($0b1ee18f17badd4e$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $0b1ee18f17badd4e$var$_e = $0b1ee18f17badd4e$var$n;

});
parcelRegister("6vkQq", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $4bc5cea4aa09b251$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $4bc5cea4aa09b251$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "setup", function () { return $4bc5cea4aa09b251$export$de27182ff8187d6c; });
$parcel$export(module.exports, "styled", function () { return $4bc5cea4aa09b251$export$3817b7a54a07cec7; });
let $4bc5cea4aa09b251$var$e = {
    data: ""
}, $4bc5cea4aa09b251$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $4bc5cea4aa09b251$var$e, $4bc5cea4aa09b251$export$54aba348a7896325 = (e)=>{
    let r = $4bc5cea4aa09b251$var$t(e), l = r.data;
    return r.data = "", l;
}, $4bc5cea4aa09b251$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $4bc5cea4aa09b251$var$a = /\/\*[^]*?\*\/|  +/g, $4bc5cea4aa09b251$var$n = /\n+/g, $4bc5cea4aa09b251$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $4bc5cea4aa09b251$var$o(c, n) : n + "{" + $4bc5cea4aa09b251$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $4bc5cea4aa09b251$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $4bc5cea4aa09b251$var$o.p ? $4bc5cea4aa09b251$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $4bc5cea4aa09b251$var$c = {}, $4bc5cea4aa09b251$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $4bc5cea4aa09b251$var$s(e[r]);
        return t;
    }
    return e;
}, $4bc5cea4aa09b251$var$i = (e, t, r, i, p)=>{
    let u = $4bc5cea4aa09b251$var$s(e), d = $4bc5cea4aa09b251$var$c[u] || ($4bc5cea4aa09b251$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$4bc5cea4aa09b251$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $4bc5cea4aa09b251$var$l.exec(e.replace($4bc5cea4aa09b251$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($4bc5cea4aa09b251$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($4bc5cea4aa09b251$var$n, " ").trim();
            return o[0];
        })(e);
        $4bc5cea4aa09b251$var$c[d] = $4bc5cea4aa09b251$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $4bc5cea4aa09b251$var$c.g ? $4bc5cea4aa09b251$var$c.g : null;
    return r && ($4bc5cea4aa09b251$var$c.g = $4bc5cea4aa09b251$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($4bc5cea4aa09b251$var$c[d], t, i, f), d;
}, $4bc5cea4aa09b251$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $4bc5cea4aa09b251$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $4bc5cea4aa09b251$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $4bc5cea4aa09b251$var$i(l.unshift ? l.raw ? $4bc5cea4aa09b251$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $4bc5cea4aa09b251$var$t(r.target), r.g, r.o, r.k);
}
let $4bc5cea4aa09b251$var$d, $4bc5cea4aa09b251$var$f, $4bc5cea4aa09b251$var$g, $4bc5cea4aa09b251$export$442f1a04865e4790 = $4bc5cea4aa09b251$export$dbf350e5966cf602.bind({
    g: 1
}), $4bc5cea4aa09b251$export$d25ddfdf17c3ad3e = $4bc5cea4aa09b251$export$dbf350e5966cf602.bind({
    k: 1
});
function $4bc5cea4aa09b251$export$de27182ff8187d6c(e, t, r, l) {
    $4bc5cea4aa09b251$var$o.p = t, $4bc5cea4aa09b251$var$d = e, $4bc5cea4aa09b251$var$f = r, $4bc5cea4aa09b251$var$g = l;
}
function $4bc5cea4aa09b251$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $4bc5cea4aa09b251$var$f && $4bc5cea4aa09b251$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $4bc5cea4aa09b251$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $4bc5cea4aa09b251$var$g && i[0] && $4bc5cea4aa09b251$var$g(c), $4bc5cea4aa09b251$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}

});


parcelRegister("bEzwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87befc68df50040c$export$2e2bcd8739ae039; });

var $7OiRl = parcelRequire("7OiRl");

var $kknQe = parcelRequire("kknQe");

var $7YxFJ = parcelRequire("7YxFJ");
function $87befc68df50040c$var$v4(options, buf, offset) {
    if ((0, $7OiRl.default).randomUUID && !buf && !options) return (0, $7OiRl.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $kknQe.default)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7YxFJ.unsafeStringify)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;

});
parcelRegister("7OiRl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5afbd4fb4df23c28$export$2e2bcd8739ae039; });
const $5afbd4fb4df23c28$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $5afbd4fb4df23c28$export$2e2bcd8739ae039 = {
    randomUUID: $5afbd4fb4df23c28$var$randomUUID
};

});

parcelRegister("kknQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc82b4b4d5334a5$export$2e2bcd8739ae039; });
let $ecc82b4b4d5334a5$var$getRandomValues;
const $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $ecc82b4b4d5334a5$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}

});

parcelRegister("7YxFJ", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $5ce84198744ccadf$export$8fb373d660548968; });

var $jPUoq = parcelRequire("jPUoq");
const $5ce84198744ccadf$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5ce84198744ccadf$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5ce84198744ccadf$export$8fb373d660548968(arr, offset = 0) {
    return ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $5ce84198744ccadf$var$stringify(arr, offset = 0) {
    const uuid = $5ce84198744ccadf$export$8fb373d660548968(arr, offset);
    if (!(0, $jPUoq.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;

});
parcelRegister("jPUoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e86397c656fa2$export$2e2bcd8739ae039; });

var $bjlDU = parcelRequire("bjlDU");
function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === "string" && (0, $bjlDU.default).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;

});
parcelRegister("bjlDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c241de251331e8$export$2e2bcd8739ae039; });
var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("166Oq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ccba2be0b51cf09$export$2e2bcd8739ae039; });
var $0ccba2be0b51cf09$var$t = "undefined" != typeof window ? window : void 0, $0ccba2be0b51cf09$var$e = "undefined" != typeof globalThis ? globalThis : $0ccba2be0b51cf09$var$t;
"undefined" == typeof self && ($0ccba2be0b51cf09$var$e.self = $0ccba2be0b51cf09$var$e), "undefined" == typeof File && ($0ccba2be0b51cf09$var$e.File = function() {});
var $0ccba2be0b51cf09$var$i = null == $0ccba2be0b51cf09$var$e ? void 0 : $0ccba2be0b51cf09$var$e.navigator, $0ccba2be0b51cf09$var$r = null == $0ccba2be0b51cf09$var$e ? void 0 : $0ccba2be0b51cf09$var$e.document, $0ccba2be0b51cf09$var$s = null == $0ccba2be0b51cf09$var$e ? void 0 : $0ccba2be0b51cf09$var$e.location, $0ccba2be0b51cf09$var$n = null == $0ccba2be0b51cf09$var$e ? void 0 : $0ccba2be0b51cf09$var$e.fetch, $0ccba2be0b51cf09$var$o = null != $0ccba2be0b51cf09$var$e && $0ccba2be0b51cf09$var$e.XMLHttpRequest && "withCredentials" in new $0ccba2be0b51cf09$var$e.XMLHttpRequest ? $0ccba2be0b51cf09$var$e.XMLHttpRequest : void 0, $0ccba2be0b51cf09$var$a = null == $0ccba2be0b51cf09$var$e ? void 0 : $0ccba2be0b51cf09$var$e.AbortController, $0ccba2be0b51cf09$var$l = null == $0ccba2be0b51cf09$var$e ? void 0 : $0ccba2be0b51cf09$var$e.CompressionStream, $0ccba2be0b51cf09$var$u = null == $0ccba2be0b51cf09$var$i ? void 0 : $0ccba2be0b51cf09$var$i.userAgent, $0ccba2be0b51cf09$var$h = null != $0ccba2be0b51cf09$var$t ? $0ccba2be0b51cf09$var$t : {}, $0ccba2be0b51cf09$var$d = "1.386.8", $0ccba2be0b51cf09$var$v = {
    DEBUG: !1,
    LIB_VERSION: $0ccba2be0b51cf09$var$d,
    LIB_NAME: "web",
    JS_SDK_VERSION: $0ccba2be0b51cf09$var$d
};
function $0ccba2be0b51cf09$var$c(t, e, i, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void i(t);
    }
    a.done ? e(l) : Promise.resolve(l).then(r, s);
}
function $0ccba2be0b51cf09$var$p(t) {
    return function() {
        var e = this, i = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(e, i);
            function o(t) {
                $0ccba2be0b51cf09$var$c(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $0ccba2be0b51cf09$var$c(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $0ccba2be0b51cf09$var$f() {
    return $0ccba2be0b51cf09$var$f = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; arguments.length > e; e++){
            var i = arguments[e];
            for(var r in i)({}).hasOwnProperty.call(i, r) && (t[r] = i[r]);
        }
        return t;
    }, $0ccba2be0b51cf09$var$f.apply(null, arguments);
}
function $0ccba2be0b51cf09$var$_(t, e) {
    if (null == t) return {};
    var i = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== e.indexOf(r)) continue;
        i[r] = t[r];
    }
    return i;
}
var $0ccba2be0b51cf09$var$g, $0ccba2be0b51cf09$var$m = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $0ccba2be0b51cf09$var$b = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $0ccba2be0b51cf09$var$y = "NativeGzipValidationError", $0ccba2be0b51cf09$var$w = (t)=>t.length >= 2 && 31 === t[0] && 139 === t[1], $0ccba2be0b51cf09$var$x = (t)=>!(!t || "object" != typeof t) && "NotReadableError" === ("name" in t ? String(t.name) : ""), $0ccba2be0b51cf09$var$E = (t)=>{
    var e = new Error("Native gzip produced invalid output: " + t);
    throw e.name = $0ccba2be0b51cf09$var$y, e;
}, $0ccba2be0b51cf09$var$S = function() {
    var t = $0ccba2be0b51cf09$var$p(function*(t, e) {
        18 > t.size && $0ccba2be0b51cf09$var$E("too-short");
        var i = new Uint8Array((yield t.slice(0, 10).arrayBuffer()));
        $0ccba2be0b51cf09$var$w(i) && 8 === i[2] || $0ccba2be0b51cf09$var$E("invalid-header");
        var r = new DataView((yield t.slice(t.size - 8).arrayBuffer()));
        r.getUint32(0, !0) !== ((t)=>{
            for(var e = (()=>{
                if ($0ccba2be0b51cf09$var$g) return $0ccba2be0b51cf09$var$g;
                $0ccba2be0b51cf09$var$g = [];
                for(var t = 0; 256 > t; t++){
                    for(var e = t, i = 0; 8 > i; i++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                    $0ccba2be0b51cf09$var$g[t] = e >>> 0;
                }
                return $0ccba2be0b51cf09$var$g;
            })(), i = 4294967295, r = 0; t.length > r; r++)i = e[255 & (i ^ t[r])] ^ i >>> 8;
            return (4294967295 ^ i) >>> 0;
        })(e) && $0ccba2be0b51cf09$var$E("invalid-crc");
        var s = e.length >>> 0;
        r.getUint32(4, !0) !== s && $0ccba2be0b51cf09$var$E("invalid-size");
    });
    return function(e, i) {
        return t.apply(this, arguments);
    };
}();
function $0ccba2be0b51cf09$var$T() {
    return $0ccba2be0b51cf09$var$T = $0ccba2be0b51cf09$var$p(function*(t, e, i) {
        void 0 === e && (e = !0);
        try {
            var r = (new TextEncoder).encode(t), s = new CompressionStream("gzip"), n = s.writable.getWriter(), o = n.write(r).then(()=>n.close()).catch(function() {
                var t = $0ccba2be0b51cf09$var$p(function*(t) {
                    try {
                        yield n.abort(t);
                    } catch (t) {}
                    throw t;
                });
                return function(e) {
                    return t.apply(this, arguments);
                };
            }()), a = new Response(s.readable).blob(), [l] = yield Promise.all([
                a,
                o
            ]);
            return yield $0ccba2be0b51cf09$var$S(l, r), l;
        } catch (t) {
            if (null != i && i.rethrow) throw t;
            return e && console.error("Failed to gzip compress data", t), null;
        }
    }), $0ccba2be0b51cf09$var$T.apply(this, arguments);
}
var $0ccba2be0b51cf09$var$k = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $0ccba2be0b51cf09$var$R = function(t, e) {
    if (void 0 === e && (e = []), !t) return !1;
    var i = t.toLowerCase();
    return $0ccba2be0b51cf09$var$k.concat(e).some((t)=>{
        var e = t.toLowerCase();
        return -1 !== i.indexOf(e);
    });
};
function $0ccba2be0b51cf09$var$P(t, e) {
    return -1 !== t.indexOf(e);
}
var $0ccba2be0b51cf09$var$O = function(t) {
    return t.trim();
}, $0ccba2be0b51cf09$var$I = function(t) {
    return t.replace(/^\$/, "");
}, $0ccba2be0b51cf09$var$C = Object.prototype, $0ccba2be0b51cf09$var$A = $0ccba2be0b51cf09$var$C.hasOwnProperty, $0ccba2be0b51cf09$var$F = $0ccba2be0b51cf09$var$C.toString, $0ccba2be0b51cf09$var$M = Array.isArray || function(t) {
    return "[object Array]" === $0ccba2be0b51cf09$var$F.call(t);
}, $0ccba2be0b51cf09$var$D = (t)=>"function" == typeof t, $0ccba2be0b51cf09$var$N = (t)=>t === Object(t) && !$0ccba2be0b51cf09$var$M(t), $0ccba2be0b51cf09$var$L = (t)=>{
    if ($0ccba2be0b51cf09$var$N(t)) {
        for(var e in t)if ($0ccba2be0b51cf09$var$A.call(t, e)) return !1;
        return !0;
    }
    return !1;
}, $0ccba2be0b51cf09$var$U = (t)=>void 0 === t, $0ccba2be0b51cf09$var$j = (t)=>"[object String]" == $0ccba2be0b51cf09$var$F.call(t), $0ccba2be0b51cf09$var$z = (t)=>$0ccba2be0b51cf09$var$j(t) && 0 === t.trim().length, $0ccba2be0b51cf09$var$B = (t)=>null === t, $0ccba2be0b51cf09$var$H = (t)=>$0ccba2be0b51cf09$var$U(t) || $0ccba2be0b51cf09$var$B(t), $0ccba2be0b51cf09$var$V = (t)=>"[object Number]" == $0ccba2be0b51cf09$var$F.call(t) && t == t, $0ccba2be0b51cf09$var$q = (t)=>$0ccba2be0b51cf09$var$V(t) && t > 0, $0ccba2be0b51cf09$var$G = (t)=>"[object Boolean]" === $0ccba2be0b51cf09$var$F.call(t), $0ccba2be0b51cf09$var$W = (t)=>t instanceof FormData, $0ccba2be0b51cf09$var$Y = (t)=>$0ccba2be0b51cf09$var$P($0ccba2be0b51cf09$var$b, t);
function $0ccba2be0b51cf09$var$J(t) {
    return null === t || "object" != typeof t;
}
function $0ccba2be0b51cf09$var$K(t, e) {
    return ({}).toString.call(t) === "[object " + e + "]";
}
function $0ccba2be0b51cf09$var$X(t) {
    return "undefined" != typeof Event && function(t, e) {
        try {
            return t instanceof e;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var $0ccba2be0b51cf09$var$Q = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $0ccba2be0b51cf09$var$Z = (t)=>$0ccba2be0b51cf09$var$P($0ccba2be0b51cf09$var$Q, t), $0ccba2be0b51cf09$var$tt = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $0ccba2be0b51cf09$var$et(t, e, i, r, s) {
    return e > i && (r.warn("min cannot be greater than max."), e = i), $0ccba2be0b51cf09$var$V(t) ? t > i ? (r.warn(" cannot be  greater than max: " + i + ". Using max value instead."), i) : e > t ? (r.warn(" cannot be less than min: " + e + ". Using min value instead."), e) : t : (r.warn(" must be a number. using max or fallback. max: " + i + ", fallback: " + s), $0ccba2be0b51cf09$var$et(s || i, e, i, r));
}
class $0ccba2be0b51cf09$var$it {
    constructor(t){
        this.$t = {}, this.zt = t.zt, this.Gt = $0ccba2be0b51cf09$var$et(t.bucketSize, 0, 100, t.Zt), this.Qt = $0ccba2be0b51cf09$var$et(t.refillRate, 0, this.Gt, t.Zt), this.Jt = $0ccba2be0b51cf09$var$et(t.refillInterval, 0, 864e5, t.Zt);
    }
    Kt(t, e) {
        var i = Math.floor((e - t.lastAccess) / this.Jt);
        i > 0 && (t.tokens = Math.min(t.tokens + i * this.Qt, this.Gt), t.lastAccess = t.lastAccess + i * this.Jt);
    }
    consumeRateLimit(t) {
        var e, i = Date.now(), r = String(t), s = this.$t[r];
        return s ? this.Kt(s, i) : this.$t[r] = s = {
            tokens: this.Gt,
            lastAccess: i
        }, 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (e = this.zt) || e.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.$t = {};
    }
}
var $0ccba2be0b51cf09$var$rt, $0ccba2be0b51cf09$var$st, $0ccba2be0b51cf09$var$nt, $0ccba2be0b51cf09$var$ot = "Mobile", $0ccba2be0b51cf09$var$at = "iOS", $0ccba2be0b51cf09$var$lt = "Android", $0ccba2be0b51cf09$var$ut = "Tablet", $0ccba2be0b51cf09$var$ht = $0ccba2be0b51cf09$var$lt + " " + $0ccba2be0b51cf09$var$ut, $0ccba2be0b51cf09$var$dt = "iPad", $0ccba2be0b51cf09$var$vt = "Apple", $0ccba2be0b51cf09$var$ct = $0ccba2be0b51cf09$var$vt + " Watch", $0ccba2be0b51cf09$var$pt = "Safari", $0ccba2be0b51cf09$var$ft = "BlackBerry", $0ccba2be0b51cf09$var$_t = "Samsung", $0ccba2be0b51cf09$var$gt = $0ccba2be0b51cf09$var$_t + "Browser", $0ccba2be0b51cf09$var$mt = $0ccba2be0b51cf09$var$_t + " Internet", $0ccba2be0b51cf09$var$bt = "Chrome", $0ccba2be0b51cf09$var$yt = $0ccba2be0b51cf09$var$bt + " OS", $0ccba2be0b51cf09$var$wt = $0ccba2be0b51cf09$var$bt + " " + $0ccba2be0b51cf09$var$at, $0ccba2be0b51cf09$var$xt = "Internet Explorer", $0ccba2be0b51cf09$var$Et = $0ccba2be0b51cf09$var$xt + " " + $0ccba2be0b51cf09$var$ot, $0ccba2be0b51cf09$var$St = "Opera", $0ccba2be0b51cf09$var$$t = $0ccba2be0b51cf09$var$St + " Mini", $0ccba2be0b51cf09$var$Tt = "Edge", $0ccba2be0b51cf09$var$kt = "Microsoft " + $0ccba2be0b51cf09$var$Tt, $0ccba2be0b51cf09$var$Rt = "Firefox", $0ccba2be0b51cf09$var$Pt = $0ccba2be0b51cf09$var$Rt + " " + $0ccba2be0b51cf09$var$at, $0ccba2be0b51cf09$var$Ot = "Nintendo", $0ccba2be0b51cf09$var$It = "PlayStation", $0ccba2be0b51cf09$var$Ct = "Xbox", $0ccba2be0b51cf09$var$At = $0ccba2be0b51cf09$var$lt + " " + $0ccba2be0b51cf09$var$ot, $0ccba2be0b51cf09$var$Ft = $0ccba2be0b51cf09$var$ot + " " + $0ccba2be0b51cf09$var$pt, $0ccba2be0b51cf09$var$Mt = "Windows", $0ccba2be0b51cf09$var$Dt = $0ccba2be0b51cf09$var$Mt + " Phone", $0ccba2be0b51cf09$var$Nt = "Nokia", $0ccba2be0b51cf09$var$Lt = "Ouya", $0ccba2be0b51cf09$var$Ut = "Generic", $0ccba2be0b51cf09$var$jt = $0ccba2be0b51cf09$var$Ut + " " + $0ccba2be0b51cf09$var$ot.toLowerCase(), $0ccba2be0b51cf09$var$zt = $0ccba2be0b51cf09$var$Ut + " " + $0ccba2be0b51cf09$var$ut.toLowerCase(), $0ccba2be0b51cf09$var$Bt = "Konqueror", $0ccba2be0b51cf09$var$Ht = "Oculus Browser", $0ccba2be0b51cf09$var$Vt = "Vivaldi", $0ccba2be0b51cf09$var$qt = "Yandex", $0ccba2be0b51cf09$var$Gt = "Whale", $0ccba2be0b51cf09$var$Wt = "DuckDuckGo", $0ccba2be0b51cf09$var$Yt = "Pale Moon", $0ccba2be0b51cf09$var$Jt = "Waterfox", $0ccba2be0b51cf09$var$Kt = "Brave", $0ccba2be0b51cf09$var$Xt = "Google Search App", $0ccba2be0b51cf09$var$Qt = "(\\d+(\\.\\d+)?)", $0ccba2be0b51cf09$var$Zt = new RegExp("Version/" + $0ccba2be0b51cf09$var$Qt), $0ccba2be0b51cf09$var$te = new RegExp($0ccba2be0b51cf09$var$Ct, "i"), $0ccba2be0b51cf09$var$ee = new RegExp($0ccba2be0b51cf09$var$It + " \\w+", "i"), $0ccba2be0b51cf09$var$ie = new RegExp($0ccba2be0b51cf09$var$Ot + " \\w+", "i"), $0ccba2be0b51cf09$var$re = new RegExp($0ccba2be0b51cf09$var$ft + "|PlayBook|BB10", "i"), $0ccba2be0b51cf09$var$se = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
}, $0ccba2be0b51cf09$var$ne = function(t, e, i, r) {
    e = e || "";
    var s = function(t) {
        return null != t && t.brave ? $0ccba2be0b51cf09$var$Kt : null;
    }(i);
    return s || (null != r && r.detectGoogleSearchApp && $0ccba2be0b51cf09$var$P(t, "GSA/") ? $0ccba2be0b51cf09$var$Xt : $0ccba2be0b51cf09$var$P(t, " OPR/") && $0ccba2be0b51cf09$var$P(t, "Mini") ? $0ccba2be0b51cf09$var$$t : $0ccba2be0b51cf09$var$P(t, " OPR/") ? $0ccba2be0b51cf09$var$St : $0ccba2be0b51cf09$var$re.test(t) ? $0ccba2be0b51cf09$var$ft : $0ccba2be0b51cf09$var$P(t, "IE" + $0ccba2be0b51cf09$var$ot) || $0ccba2be0b51cf09$var$P(t, "WPDesktop") ? $0ccba2be0b51cf09$var$Et : $0ccba2be0b51cf09$var$P(t, "OculusBrowser") ? $0ccba2be0b51cf09$var$Ht : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$gt) ? $0ccba2be0b51cf09$var$mt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$Tt) || $0ccba2be0b51cf09$var$P(t, "Edg/") ? $0ccba2be0b51cf09$var$kt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$Vt + "/") ? $0ccba2be0b51cf09$var$Vt : $0ccba2be0b51cf09$var$P(t, "YaBrowser/") ? $0ccba2be0b51cf09$var$qt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$Gt + "/") ? $0ccba2be0b51cf09$var$Gt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$Wt + "/") || $0ccba2be0b51cf09$var$P(t, "Ddg/") ? $0ccba2be0b51cf09$var$Wt : $0ccba2be0b51cf09$var$P(t, "FBIOS") ? "Facebook " + $0ccba2be0b51cf09$var$ot : $0ccba2be0b51cf09$var$P(t, "UCWEB") || $0ccba2be0b51cf09$var$P(t, "UCBrowser") ? "UC Browser" : $0ccba2be0b51cf09$var$P(t, "CriOS") ? $0ccba2be0b51cf09$var$wt : $0ccba2be0b51cf09$var$P(t, "CrMo") || $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$bt) ? $0ccba2be0b51cf09$var$bt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$lt) && $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$pt) ? $0ccba2be0b51cf09$var$At : $0ccba2be0b51cf09$var$P(t, "FxiOS") ? $0ccba2be0b51cf09$var$Pt : $0ccba2be0b51cf09$var$P(t.toLowerCase(), $0ccba2be0b51cf09$var$Bt.toLowerCase()) ? $0ccba2be0b51cf09$var$Bt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$Kt + "/") ? $0ccba2be0b51cf09$var$Kt : ((t, e)=>e && $0ccba2be0b51cf09$var$P(e, $0ccba2be0b51cf09$var$vt) || function(t) {
            return $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$pt) && !$0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$bt) && !$0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$lt);
        }(t))(t, e) ? $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$ot) ? $0ccba2be0b51cf09$var$Ft : $0ccba2be0b51cf09$var$pt : $0ccba2be0b51cf09$var$P(t, "PaleMoon/") ? $0ccba2be0b51cf09$var$Yt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$Jt + "/") ? $0ccba2be0b51cf09$var$Jt : $0ccba2be0b51cf09$var$P(t, $0ccba2be0b51cf09$var$Rt) ? $0ccba2be0b51cf09$var$Rt : $0ccba2be0b51cf09$var$P(t, "MSIE") || $0ccba2be0b51cf09$var$P(t, "Trident/") ? $0ccba2be0b51cf09$var$xt : $0ccba2be0b51cf09$var$P(t, "Gecko") ? $0ccba2be0b51cf09$var$Rt : "");
}, $0ccba2be0b51cf09$var$oe = {
    [$0ccba2be0b51cf09$var$Et]: [
        new RegExp("rv:" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$kt]: [
        new RegExp($0ccba2be0b51cf09$var$Tt + "?\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$bt]: [
        new RegExp("(" + $0ccba2be0b51cf09$var$bt + "|CrMo)\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$wt]: [
        new RegExp("CriOS\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$pt]: [
        $0ccba2be0b51cf09$var$Zt
    ],
    [$0ccba2be0b51cf09$var$Ft]: [
        $0ccba2be0b51cf09$var$Zt
    ],
    [$0ccba2be0b51cf09$var$St]: [
        new RegExp("(Opera|OPR)\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Rt]: [
        new RegExp($0ccba2be0b51cf09$var$Rt + "\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Pt]: [
        new RegExp("FxiOS\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Bt]: [
        new RegExp("Konqueror[:/]?" + $0ccba2be0b51cf09$var$Qt, "i")
    ],
    [$0ccba2be0b51cf09$var$ft]: [
        new RegExp($0ccba2be0b51cf09$var$ft + " " + $0ccba2be0b51cf09$var$Qt),
        $0ccba2be0b51cf09$var$Zt
    ],
    [$0ccba2be0b51cf09$var$At]: [
        new RegExp("android\\s" + $0ccba2be0b51cf09$var$Qt, "i")
    ],
    [$0ccba2be0b51cf09$var$mt]: [
        new RegExp($0ccba2be0b51cf09$var$gt + "\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Ht]: [
        new RegExp("OculusBrowser\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Vt]: [
        new RegExp($0ccba2be0b51cf09$var$Vt + "\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$qt]: [
        new RegExp("YaBrowser\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Gt]: [
        new RegExp($0ccba2be0b51cf09$var$Gt + "\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Kt]: [
        new RegExp($0ccba2be0b51cf09$var$Kt + "\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Wt]: [
        new RegExp("(DuckDuckGo|Ddg)\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Yt]: [
        new RegExp("PaleMoon\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Jt]: [
        new RegExp($0ccba2be0b51cf09$var$Jt + "\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$Xt]: [
        new RegExp("GSA\\/" + $0ccba2be0b51cf09$var$Qt)
    ],
    [$0ccba2be0b51cf09$var$xt]: [
        new RegExp("(rv:|MSIE )" + $0ccba2be0b51cf09$var$Qt)
    ],
    Mozilla: [
        new RegExp("rv:" + $0ccba2be0b51cf09$var$Qt)
    ]
}, $0ccba2be0b51cf09$var$ae = function(t, e, i, r) {
    var s = $0ccba2be0b51cf09$var$ne(t, e, i, r), n = $0ccba2be0b51cf09$var$oe[s];
    if ($0ccba2be0b51cf09$var$U(n)) return null;
    for(var o = 0; n.length > o; o++){
        var a = t.match(n[o]);
        if (a) return parseFloat(a[a.length - 2]);
    }
    return null;
}, $0ccba2be0b51cf09$var$le = [
    [
        new RegExp($0ccba2be0b51cf09$var$Ct + "; " + $0ccba2be0b51cf09$var$Ct + " (.*?)[);]", "i"),
        (t)=>[
                $0ccba2be0b51cf09$var$Ct,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($0ccba2be0b51cf09$var$Ot, "i"),
        [
            $0ccba2be0b51cf09$var$Ot,
            ""
        ]
    ],
    [
        new RegExp($0ccba2be0b51cf09$var$It, "i"),
        [
            $0ccba2be0b51cf09$var$It,
            ""
        ]
    ],
    [
        $0ccba2be0b51cf09$var$re,
        [
            $0ccba2be0b51cf09$var$ft,
            ""
        ]
    ],
    [
        new RegExp($0ccba2be0b51cf09$var$Mt, "i"),
        (t, e)=>{
            if (/Phone/.test(e) || /WPDesktop/.test(e)) return [
                $0ccba2be0b51cf09$var$Dt,
                ""
            ];
            if (new RegExp($0ccba2be0b51cf09$var$ot).test(e) && !/IEMobile\b/.test(e)) return [
                $0ccba2be0b51cf09$var$Mt + " " + $0ccba2be0b51cf09$var$ot,
                ""
            ];
            var i = /Windows NT ([0-9.]+)/i.exec(e);
            if (i && i[1]) {
                var r = $0ccba2be0b51cf09$var$se[i[1]] || "";
                return /arm/i.test(e) && (r = "RT"), [
                    $0ccba2be0b51cf09$var$Mt,
                    r
                ];
            }
            return [
                $0ccba2be0b51cf09$var$Mt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>t && t[3] ? [
                $0ccba2be0b51cf09$var$at,
                [
                    t[3],
                    t[4],
                    t[5] || "0"
                ].join(".")
            ] : [
                $0ccba2be0b51cf09$var$at,
                ""
            ]
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var e = "";
            return t && t.length >= 3 && (e = $0ccba2be0b51cf09$var$U(t[2]) ? t[3] : t[2]), [
                "watchOS",
                e
            ];
        }
    ],
    [
        new RegExp("(" + $0ccba2be0b51cf09$var$lt + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $0ccba2be0b51cf09$var$lt + ")", "i"),
        (t)=>t && t[2] ? [
                $0ccba2be0b51cf09$var$lt,
                [
                    t[2],
                    t[3],
                    t[4] || "0"
                ].join(".")
            ] : [
                $0ccba2be0b51cf09$var$lt,
                ""
            ]
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var e = [
                "Mac OS X",
                ""
            ];
            return t && t[1] && (e[1] = [
                t[1],
                t[2],
                t[3] || "0"
            ].join(".")), e;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $0ccba2be0b51cf09$var$yt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $0ccba2be0b51cf09$var$ue = function(t) {
    return $0ccba2be0b51cf09$var$ie.test(t) ? $0ccba2be0b51cf09$var$Ot : $0ccba2be0b51cf09$var$ee.test(t) ? $0ccba2be0b51cf09$var$It : $0ccba2be0b51cf09$var$te.test(t) ? $0ccba2be0b51cf09$var$Ct : new RegExp($0ccba2be0b51cf09$var$Lt, "i").test(t) ? $0ccba2be0b51cf09$var$Lt : new RegExp("(" + $0ccba2be0b51cf09$var$Dt + "|WPDesktop)", "i").test(t) ? $0ccba2be0b51cf09$var$Dt : /iPad/.test(t) ? $0ccba2be0b51cf09$var$dt : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $0ccba2be0b51cf09$var$ct : $0ccba2be0b51cf09$var$re.test(t) ? $0ccba2be0b51cf09$var$ft : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($0ccba2be0b51cf09$var$Nt, "i").test(t) ? $0ccba2be0b51cf09$var$Nt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($0ccba2be0b51cf09$var$ot).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $0ccba2be0b51cf09$var$lt : $0ccba2be0b51cf09$var$ht : new RegExp("(pda|" + $0ccba2be0b51cf09$var$ot + ")", "i").test(t) ? $0ccba2be0b51cf09$var$jt : new RegExp($0ccba2be0b51cf09$var$ut, "i").test(t) && !new RegExp($0ccba2be0b51cf09$var$ut + " pc", "i").test(t) ? $0ccba2be0b51cf09$var$zt : "";
}, $0ccba2be0b51cf09$var$he = (t)=>t instanceof Error, $0ccba2be0b51cf09$var$de = {
    trace: {
        text: "TRACE",
        number: 1
    },
    debug: {
        text: "DEBUG",
        number: 5
    },
    info: {
        text: "INFO",
        number: 9
    },
    warn: {
        text: "WARN",
        number: 13
    },
    error: {
        text: "ERROR",
        number: 17
    },
    fatal: {
        text: "FATAL",
        number: 21
    }
}, $0ccba2be0b51cf09$var$ve = $0ccba2be0b51cf09$var$de.info;
function $0ccba2be0b51cf09$var$ce(t) {
    if ($0ccba2be0b51cf09$var$G(t)) return {
        boolValue: t
    };
    if ("number" == typeof t) return Number.isFinite(t) ? Number.isInteger(t) ? {
        intValue: t
    } : {
        doubleValue: t
    } : {
        stringValue: String(t)
    };
    if ("string" == typeof t) return {
        stringValue: t
    };
    if ($0ccba2be0b51cf09$var$M(t)) return {
        arrayValue: {
            values: t.map((t)=>$0ccba2be0b51cf09$var$ce(t))
        }
    };
    try {
        return {
            stringValue: JSON.stringify(t)
        };
    } catch (e) {
        return {
            stringValue: String(t)
        };
    }
}
function $0ccba2be0b51cf09$var$pe(t) {
    var e = [];
    for(var i in t){
        var r = t[i];
        $0ccba2be0b51cf09$var$B(r) || $0ccba2be0b51cf09$var$U(r) || e.push({
            key: i,
            value: $0ccba2be0b51cf09$var$ce(r)
        });
    }
    return e;
}
function $0ccba2be0b51cf09$var$fe(t) {
    var e = globalThis._posthogChunkIds;
    if (e) {
        var i = Object.keys(e);
        return $0ccba2be0b51cf09$var$nt && i.length === $0ccba2be0b51cf09$var$st || ($0ccba2be0b51cf09$var$st = i.length, $0ccba2be0b51cf09$var$nt = i.reduce((i, r)=>{
            $0ccba2be0b51cf09$var$rt || ($0ccba2be0b51cf09$var$rt = {});
            var s = $0ccba2be0b51cf09$var$rt[r];
            if (s) i[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = e[r];
                if (l && u) {
                    i[l] = u, $0ccba2be0b51cf09$var$rt[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return i;
        }, {})), $0ccba2be0b51cf09$var$nt;
    }
}
class $0ccba2be0b51cf09$var$_e {
    constructor(t, e, i){
        void 0 === i && (i = []), this.coercers = t, this.stackParser = e, this.modifiers = i;
    }
    buildFromUnknown(t, e) {
        void 0 === e && (e = {});
        var i = e && e.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(i, e, 0).apply(t), s = this.buildParsingContext(e), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, i),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var e = this;
        return $0ccba2be0b51cf09$var$p(function*() {
            for (var i of t)i.stacktrace && i.stacktrace.frames && $0ccba2be0b51cf09$var$M(i.stacktrace.frames) && (i.stacktrace.frames = yield e.applyModifiers(i.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var e;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (e = t.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, e) {
        var i, r;
        return null != t.cause && (i = this.parseStacktrace(t.cause, e)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? e.skipFirstLines : 0), e.chunkIdMap)), $0ccba2be0b51cf09$var$f({}, t, {
            cause: i,
            stack: r
        });
    }
    applyChunkIds(t, e) {
        return t.map((t)=>(t.filename && e && (t.chunk_id = e[t.filename]), t));
    }
    applyCoercers(t, e) {
        for (var i of this.coercers)if (i.match(t)) return i.coerce(t, e);
        return this.coerceFallback(e);
    }
    applyModifiers(t) {
        var e = this;
        return $0ccba2be0b51cf09$var$p(function*() {
            var i = t;
            for (var r of e.modifiers)i = yield r(i);
            return i;
        })();
    }
    convertToExceptionList(t, e) {
        var i, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (i = e.type) && void 0 !== i ? i : "generic",
                handled: null === (r = e.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $0ccba2be0b51cf09$var$f({}, e, {
            handled: !0
        }))), o;
    }
    buildParsingContext(t) {
        var e;
        return {
            chunkIdMap: $0ccba2be0b51cf09$var$fe(this.stackParser),
            skipFirstLines: null !== (e = t.skipFirstLines) && void 0 !== e ? e : 1
        };
    }
    buildCoercingContext(t, e, i) {
        void 0 === i && (i = 0);
        var r = (i, r)=>{
            if (4 >= r) {
                var s = this.buildCoercingContext(t, e, r);
                return this.applyCoercers(i, s);
            }
        };
        return $0ccba2be0b51cf09$var$f({}, e, {
            syntheticException: 0 == i ? e.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, i),
            next: (t)=>r(t, i + 1)
        });
    }
}
var $0ccba2be0b51cf09$var$ge = "?";
function $0ccba2be0b51cf09$var$me(t, e, i, r, s) {
    var n = {
        platform: t,
        filename: e,
        function: "<anonymous>" === i ? $0ccba2be0b51cf09$var$ge : i,
        in_app: !0
    };
    return $0ccba2be0b51cf09$var$U(r) || (n.lineno = r), $0ccba2be0b51cf09$var$U(s) || (n.colno = s), n;
}
var $0ccba2be0b51cf09$var$be = (t, e)=>{
    var i = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return i || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $0ccba2be0b51cf09$var$ge,
        i ? "safari-extension:" + e : "safari-web-extension:" + e
    ] : [
        t,
        e
    ];
}, $0ccba2be0b51cf09$var$ye = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $0ccba2be0b51cf09$var$we = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $0ccba2be0b51cf09$var$xe = /\((\S*)(?::(\d+))(?::(\d+))\)/, $0ccba2be0b51cf09$var$Ee = (t, e)=>{
    var i = $0ccba2be0b51cf09$var$ye.exec(t);
    if (i) {
        var [, r, s, n] = i;
        return $0ccba2be0b51cf09$var$me(e, r, $0ccba2be0b51cf09$var$ge, +s, +n);
    }
    var o = $0ccba2be0b51cf09$var$we.exec(t);
    if (o) {
        if (o[2] && 0 === o[2].indexOf("eval")) {
            var a = $0ccba2be0b51cf09$var$xe.exec(o[2]);
            a && (o[2] = a[1], o[3] = a[2], o[4] = a[3]);
        }
        var [l, u] = $0ccba2be0b51cf09$var$be(o[1] || $0ccba2be0b51cf09$var$ge, o[2]);
        return $0ccba2be0b51cf09$var$me(e, u, l, o[3] ? +o[3] : void 0, o[4] ? +o[4] : void 0);
    }
}, $0ccba2be0b51cf09$var$Se = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $0ccba2be0b51cf09$var$$e = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $0ccba2be0b51cf09$var$Te = (t, e)=>{
    var i = $0ccba2be0b51cf09$var$Se.exec(t);
    if (i) {
        if (i[3] && i[3].indexOf(" > eval") > -1) {
            var r = $0ccba2be0b51cf09$var$$e.exec(i[3]);
            r && (i[1] = i[1] || "eval", i[3] = r[1], i[4] = r[2], i[5] = "");
        }
        var s = i[3], n = i[1] || $0ccba2be0b51cf09$var$ge;
        return [n, s] = $0ccba2be0b51cf09$var$be(n, s), $0ccba2be0b51cf09$var$me(e, s, n, i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
    }
}, $0ccba2be0b51cf09$var$ke = /\(error: (.*)\)/;
class $0ccba2be0b51cf09$var$Re {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, e) {
        var i = $0ccba2be0b51cf09$var$j(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: i ? t.stack : void 0,
            cause: t.cause ? e.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var e = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? e + ": " + t.message : e;
    }
    isDOMException(t) {
        return $0ccba2be0b51cf09$var$K(t, "DOMException");
    }
    isDOMError(t) {
        return $0ccba2be0b51cf09$var$K(t, "DOMError");
    }
}
class $0ccba2be0b51cf09$var$Pe {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, e) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, e),
            stack: this.getStack(t),
            cause: t.cause ? e.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, e) {
        var i = t.message;
        return String(i.error && "string" == typeof i.error.message ? i.error.message : i);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $0ccba2be0b51cf09$var$Oe {
    constructor(){}
    match(t) {
        return $0ccba2be0b51cf09$var$K(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, e) {
        var i;
        return e.apply(t.error) || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
var $0ccba2be0b51cf09$var$Ie = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $0ccba2be0b51cf09$var$Ce {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, e) {
        var i, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var e = "Error", i = t, r = t.match($0ccba2be0b51cf09$var$Ie);
        return r && (e = r[1], i = r[2]), [
            e,
            i
        ];
    }
}
var $0ccba2be0b51cf09$var$Ae = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $0ccba2be0b51cf09$var$Fe(t, e) {
    void 0 === e && (e = 40);
    var i = Object.keys(t);
    if (i.sort(), !i.length) return "[object has no keys]";
    for(var r = i.length; r > 0; r--){
        var s = i.slice(0, r).join(", ");
        if (e >= s.length) return r === i.length ? s : s.length > e ? s.slice(0, e) + "..." : s;
    }
    return "";
}
class $0ccba2be0b51cf09$var$Me {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, e) {
        var i, r = this.getErrorPropertyFromObject(t);
        return r ? e.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $0ccba2be0b51cf09$var$X(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var e = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (e += " with message: '" + t.message + "'"), e;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var i = this.getObjectClassName(t);
        return (i && "Object" !== i ? "'" + i + "'" : "Object") + " captured as exception with keys: " + $0ccba2be0b51cf09$var$Fe(t);
    }
    isSeverityLevel(t) {
        return $0ccba2be0b51cf09$var$j(t) && !$0ccba2be0b51cf09$var$z(t) && $0ccba2be0b51cf09$var$Ae.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var e in t)if (({}).hasOwnProperty.call(t, e)) {
            var i = t[e];
            if ($0ccba2be0b51cf09$var$he(i)) return i;
        }
    }
    getObjectClassName(t) {
        try {
            var e = Object.getPrototypeOf(t);
            return e ? e.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $0ccba2be0b51cf09$var$De {
    match(t) {
        return $0ccba2be0b51cf09$var$X(t);
    }
    coerce(t, e) {
        var i, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $0ccba2be0b51cf09$var$Fe(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
class $0ccba2be0b51cf09$var$Ne {
    match(t) {
        return $0ccba2be0b51cf09$var$J(t);
    }
    coerce(t, e) {
        var i;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
class $0ccba2be0b51cf09$var$Le {
    match(t) {
        return $0ccba2be0b51cf09$var$K(t, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(t);
    }
    isCustomEventWrappingRejection(t) {
        if (!$0ccba2be0b51cf09$var$X(t)) return !1;
        try {
            var e = t.detail;
            return null != e && "object" == typeof e && "reason" in e;
        } catch (t) {
            return !1;
        }
    }
    coerce(t, e) {
        var i, r = this.getUnhandledRejectionReason(t);
        return $0ccba2be0b51cf09$var$J(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        } : e.apply(r);
    }
    getUnhandledRejectionReason(t) {
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && null != t.detail && "object" == typeof t.detail && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $0ccba2be0b51cf09$var$Ue = "$message", $0ccba2be0b51cf09$var$je = "$timestamp", $0ccba2be0b51cf09$var$ze = new Set([
    $0ccba2be0b51cf09$var$Ue,
    $0ccba2be0b51cf09$var$je
]), $0ccba2be0b51cf09$var$Be = {
    enabled: !0,
    max_bytes: 32768
};
function $0ccba2be0b51cf09$var$He(t) {
    var e;
    return t ? {
        enabled: null !== (e = t.enabled) && void 0 !== e ? e : $0ccba2be0b51cf09$var$Be.enabled,
        max_bytes: $0ccba2be0b51cf09$var$qe(t.max_bytes, $0ccba2be0b51cf09$var$Be.max_bytes)
    } : $0ccba2be0b51cf09$var$f({}, $0ccba2be0b51cf09$var$Be);
}
class $0ccba2be0b51cf09$var$Ve {
    constructor(t){
        this.Yt = [], this.Xt = 0, this.qt = $0ccba2be0b51cf09$var$He(t);
    }
    setConfig(t) {
        this.qt = $0ccba2be0b51cf09$var$He(t), this.er();
    }
    add(t) {
        var e = function(t) {
            var e = function(t) {
                var e = new WeakSet;
                try {
                    return JSON.stringify(t, (t, i)=>{
                        if ("bigint" == typeof i) return i.toString();
                        if ("function" != typeof i && "symbol" != typeof i) {
                            if (i instanceof Date) return i.toISOString();
                            if (i instanceof Error) return {
                                name: i.name,
                                message: i.message,
                                stack: i.stack
                            };
                            if (i && "object" == typeof i) {
                                if (e.has(i)) return "[Circular]";
                                e.add(i);
                            }
                            return i;
                        }
                    });
                } catch (t) {
                    return;
                }
            }(t);
            if (e) try {
                var i = JSON.parse(e);
                if (!$0ccba2be0b51cf09$var$N(i)) return;
                var r = i, s = r[$0ccba2be0b51cf09$var$Ue], n = r[$0ccba2be0b51cf09$var$je];
                if (!$0ccba2be0b51cf09$var$j(s) || 0 === s.trim().length) return;
                if (!$0ccba2be0b51cf09$var$j(n) && !$0ccba2be0b51cf09$var$V(n)) return;
                return {
                    step: r,
                    json: e
                };
            } catch (t) {
                return;
            }
        }(t);
        if (e) {
            var i = function(t) {
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t).length;
                for(var e = encodeURIComponent(t), i = 0, r = 0; e.length > r; r++)"%" === e[r] ? (i += 1, r += 2) : i += 1;
                return i;
            }(e.json);
            i > this.qt.max_bytes || (this.Yt.push({
                step: e.step,
                bytes: i
            }), this.Xt += i, this.er());
        }
    }
    getAttachable() {
        return this.Yt.map((t)=>t.step);
    }
    clear() {
        this.Yt = [], this.Xt = 0;
    }
    size() {
        return this.Yt.length;
    }
    er() {
        for(; this.Xt > this.qt.max_bytes && this.Yt.length > 0;){
            var t = this.Yt.shift();
            t && (this.Xt -= t.bytes);
        }
    }
}
function $0ccba2be0b51cf09$var$qe(t, e) {
    if (!$0ccba2be0b51cf09$var$V(t) || t === 1 / 0 || t === -1 / 0) return e;
    var i = Math.floor(t);
    return 0 > i ? e : i;
}
var $0ccba2be0b51cf09$var$Ge = function(e, i) {
    var { debugEnabled: r } = void 0 === i ? {} : i, s = {
        k (i) {
            if ($0ccba2be0b51cf09$var$t && ($0ccba2be0b51cf09$var$v.DEBUG || $0ccba2be0b51cf09$var$h.POSTHOG_DEBUG || r) && !$0ccba2be0b51cf09$var$U($0ccba2be0b51cf09$var$t.console) && $0ccba2be0b51cf09$var$t.console) {
                for(var s = ("__rrweb_original__" in $0ccba2be0b51cf09$var$t.console[i]) ? $0ccba2be0b51cf09$var$t.console[i].__rrweb_original__ : $0ccba2be0b51cf09$var$t.console[i], n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; n > a; a++)o[a - 1] = arguments[a];
                s(e, ...o);
            }
        },
        debug () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("debug", ...e);
        },
        info () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("log", ...e);
        },
        warn () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("warn", ...e);
        },
        error () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("error", ...e);
        },
        critical () {
            for(var t = arguments.length, i = new Array(t), r = 0; t > r; r++)i[r] = arguments[r];
            console.error(e, ...i);
        },
        uninitializedWarning (t) {
            s.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t, i)=>$0ccba2be0b51cf09$var$Ge(e + " " + t, i)
    };
    return s;
}, $0ccba2be0b51cf09$var$We = $0ccba2be0b51cf09$var$Ge("[PostHog.js]"), $0ccba2be0b51cf09$var$Ye = $0ccba2be0b51cf09$var$We.createLogger, $0ccba2be0b51cf09$var$Je = $0ccba2be0b51cf09$var$Ye("[ExternalScriptsLoader]"), $0ccba2be0b51cf09$var$Ke = (t, e, i)=>{
    if (t.config.disable_external_dependency_loading) return $0ccba2be0b51cf09$var$Je.warn(e + " was requested but loading of external scripts is disabled."), i("Loading of external scripts is disabled");
    var s = null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.querySelectorAll("script");
    if (s) {
        for(var n, o = function() {
            if (s[a].src === e) {
                var t = s[a];
                return t.__posthog_loading_callback_fired ? {
                    v: i()
                } : (t.addEventListener("load", (e)=>{
                    t.__posthog_loading_callback_fired = !0, i(void 0, e);
                }), t.onerror = (t)=>i(t), {
                    v: void 0
                });
            }
        }, a = 0; s.length > a; a++)if (n = o()) return n.v;
    }
    var l = ()=>{
        if (!$0ccba2be0b51cf09$var$r) return i("document not found");
        var s = $0ccba2be0b51cf09$var$r.createElement("script");
        if (s.type = "text/javascript", s.crossOrigin = "anonymous", s.src = e, s.onload = (t)=>{
            s.__posthog_loading_callback_fired = !0, i(void 0, t);
        }, s.onerror = (t)=>i(t), t.config.prepare_external_dependency_script && (s = t.config.prepare_external_dependency_script(s)), !s) return i("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $0ccba2be0b51cf09$var$r.head.appendChild(s);
        else {
            var n, o = $0ccba2be0b51cf09$var$r.querySelectorAll("body > script");
            o.length > 0 ? null == (n = o[0].parentNode) || n.insertBefore(s, o[0]) : $0ccba2be0b51cf09$var$r.body.appendChild(s);
        }
    };
    null != $0ccba2be0b51cf09$var$r && $0ccba2be0b51cf09$var$r.body ? l() : null == $0ccba2be0b51cf09$var$r || $0ccba2be0b51cf09$var$r.addEventListener("DOMContentLoaded", l);
};
$0ccba2be0b51cf09$var$h.__PosthogExtensions__ = $0ccba2be0b51cf09$var$h.__PosthogExtensions__ || {}, $0ccba2be0b51cf09$var$h.__PosthogExtensions__.loadExternalDependency = (t, e, i)=>{
    if ("remote-config" !== e) {
        var r;
        if (t.config.strict_script_versioning) r = t.requestRouter.endpointFor("assets", "/static/" + t.version + "/" + e + ".js");
        else {
            var s = "/static/" + e + ".js?v=" + t.version;
            if ("toolbar" === e) {
                var n = 3e5;
                s = s + "&t=" + Math.floor(Date.now() / n) * n;
            }
            r = t.requestRouter.endpointFor("assets", s);
        }
        $0ccba2be0b51cf09$var$Ke(t, r, i);
    } else {
        var o = t.requestRouter.endpointFor("assets", "/array/" + t.config.token + "/config.js");
        $0ccba2be0b51cf09$var$Ke(t, o, i);
    }
}, $0ccba2be0b51cf09$var$h.__PosthogExtensions__.loadSiteApp = (t, e, i)=>{
    var r = t.requestRouter.endpointFor("api", e);
    $0ccba2be0b51cf09$var$Ke(t, r, i);
};
var $0ccba2be0b51cf09$var$Xe = "$people_distinct_id", $0ccba2be0b51cf09$var$Qe = "$device_id", $0ccba2be0b51cf09$var$Ze = "__alias", $0ccba2be0b51cf09$var$ti = "__timers", $0ccba2be0b51cf09$var$ei = "$autocapture_disabled_server_side", $0ccba2be0b51cf09$var$ii = "$heatmaps_enabled_server_side", $0ccba2be0b51cf09$var$ri = "$exception_capture_enabled_server_side", $0ccba2be0b51cf09$var$si = "$error_tracking_suppression_rules", $0ccba2be0b51cf09$var$ni = "$error_tracking_capture_extension_exceptions", $0ccba2be0b51cf09$var$oi = "$web_vitals_enabled_server_side", $0ccba2be0b51cf09$var$ai = "$dead_clicks_enabled_server_side", $0ccba2be0b51cf09$var$li = "$product_tours_enabled_server_side", $0ccba2be0b51cf09$var$ui = "$web_vitals_allowed_metrics", $0ccba2be0b51cf09$var$hi = "$session_recording_remote_config", $0ccba2be0b51cf09$var$di = "$replay_sample_rate", $0ccba2be0b51cf09$var$vi = "$replay_override_sampling", $0ccba2be0b51cf09$var$ci = "$replay_override_linked_flag", $0ccba2be0b51cf09$var$pi = "$replay_override_url_trigger", $0ccba2be0b51cf09$var$fi = "$replay_override_event_trigger", $0ccba2be0b51cf09$var$_i = "$sesid", $0ccba2be0b51cf09$var$gi = "$session_is_sampled", $0ccba2be0b51cf09$var$mi = "$enabled_feature_flags", $0ccba2be0b51cf09$var$bi = "$active_feature_flags", $0ccba2be0b51cf09$var$yi = "$early_access_features", $0ccba2be0b51cf09$var$wi = "$feature_flag_details", $0ccba2be0b51cf09$var$xi = "$feature_flag_payloads", $0ccba2be0b51cf09$var$Ei = "$feature_flag_request_id", $0ccba2be0b51cf09$var$Si = "$override_feature_flags", $0ccba2be0b51cf09$var$$i = "$override_feature_flag_payloads", $0ccba2be0b51cf09$var$Ti = "$stored_person_properties", $0ccba2be0b51cf09$var$ki = "$stored_group_properties", $0ccba2be0b51cf09$var$Ri = "$surveys", $0ccba2be0b51cf09$var$Pi = "$surveys_loaded_at", $0ccba2be0b51cf09$var$Oi = "$surveys_activated", $0ccba2be0b51cf09$var$Ii = "ph_product_tours", $0ccba2be0b51cf09$var$Ci = "$flag_call_reported", $0ccba2be0b51cf09$var$Ai = "$flag_call_reported_session_id", $0ccba2be0b51cf09$var$Fi = "$feature_flag_errors", $0ccba2be0b51cf09$var$Mi = "$feature_flag_evaluated_at", $0ccba2be0b51cf09$var$Di = "$user_state", $0ccba2be0b51cf09$var$Ni = "$client_session_props", $0ccba2be0b51cf09$var$Li = "$capture_rate_limit", $0ccba2be0b51cf09$var$Ui = "$initial_campaign_params", $0ccba2be0b51cf09$var$ji = "$initial_referrer_info", $0ccba2be0b51cf09$var$zi = "$initial_person_info", $0ccba2be0b51cf09$var$Bi = "$epp", $0ccba2be0b51cf09$var$Hi = "__POSTHOG_TOOLBAR__", $0ccba2be0b51cf09$var$Vi = "$posthog_cookieless", $0ccba2be0b51cf09$var$qi = "$sdk_debug_extensions_init_method", $0ccba2be0b51cf09$var$Gi = "$sdk_debug_extensions_init_time_ms", $0ccba2be0b51cf09$var$Wi = "$sdk_debug_recording_script_not_loaded", $0ccba2be0b51cf09$var$Yi = "PostHog loadExternalDependency extension not found.", $0ccba2be0b51cf09$var$Ji = "on_reject", $0ccba2be0b51cf09$var$Ki = "always", $0ccba2be0b51cf09$var$Xi = "anonymous", $0ccba2be0b51cf09$var$Qi = "identified", $0ccba2be0b51cf09$var$Zi = "identified_only", $0ccba2be0b51cf09$var$tr = "visibilitychange", $0ccba2be0b51cf09$var$er = "beforeunload", $0ccba2be0b51cf09$var$ir = "$pageview", $0ccba2be0b51cf09$var$rr = "$pageleave", $0ccba2be0b51cf09$var$sr = "$identify", $0ccba2be0b51cf09$var$nr = "$groupidentify";
function $0ccba2be0b51cf09$var$or(t, e) {
    $0ccba2be0b51cf09$var$M(t) && t.forEach(e);
}
function $0ccba2be0b51cf09$var$ar(t, e) {
    if (!$0ccba2be0b51cf09$var$H(t)) {
        if ($0ccba2be0b51cf09$var$M(t)) t.forEach(e);
        else if ($0ccba2be0b51cf09$var$W(t)) t.forEach((t, i)=>e(t, i));
        else for(var i in t)$0ccba2be0b51cf09$var$A.call(t, i) && e(t[i], i);
    }
}
var $0ccba2be0b51cf09$var$lr = function(t) {
    for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
    for (var s of i)for(var n in s)void 0 !== s[n] && (t[n] = s[n]);
    return t;
};
function $0ccba2be0b51cf09$var$ur(t) {
    for(var e = Object.keys(t), i = e.length, r = new Array(i); i--;)r[i] = [
        e[i],
        t[e[i]]
    ];
    return r;
}
var $0ccba2be0b51cf09$var$hr = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $0ccba2be0b51cf09$var$dr = function(t) {
    return function() {
        try {
            for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
            return t.apply(this, i);
        } catch (t) {
            $0ccba2be0b51cf09$var$We.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $0ccba2be0b51cf09$var$We.critical(t);
        }
    };
}, $0ccba2be0b51cf09$var$vr = function(t) {
    var e = {};
    return $0ccba2be0b51cf09$var$ar(t, function(t, i) {
        ($0ccba2be0b51cf09$var$j(t) && t.length > 0 || $0ccba2be0b51cf09$var$V(t)) && (e[i] = t);
    }), e;
};
var $0ccba2be0b51cf09$var$cr = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $0ccba2be0b51cf09$var$pr(t) {
    var e = null == t ? void 0 : t.hostname;
    if (!$0ccba2be0b51cf09$var$j(e)) return !1;
    var i = e.split(".").slice(-2).join(".");
    for (var r of $0ccba2be0b51cf09$var$cr)if (i === r) return !1;
    return !0;
}
function $0ccba2be0b51cf09$var$fr(t, e, i, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(e, i, {
        capture: s,
        passive: n
    });
}
function $0ccba2be0b51cf09$var$_r(t) {
    return "ph_toolbar_internal" === t.name;
}
Math.trunc || (Math.trunc = function(t) {
    return 0 > t ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $0ccba2be0b51cf09$var$V(t) && isFinite(t) && Math.floor(t) === t;
});
class $0ccba2be0b51cf09$var$gr {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, e, i, r) {
        if (!Number.isInteger(t) || !Number.isInteger(e) || !Number.isInteger(i) || !Number.isInteger(r) || 0 > t || 0 > e || 0 > i || 0 > r || t > 0xffffffffffff || e > 4095 || i > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | e >>> 8, s[7] = e, s[8] = 128 | i >>> 24, s[9] = i >>> 16, s[10] = i >>> 8, s[11] = i, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $0ccba2be0b51cf09$var$gr(s);
    }
    toString() {
        for(var t = "", e = 0; this.bytes.length > e; e++)t = t + (this.bytes[e] >>> 4).toString(16) + (15 & this.bytes[e]).toString(16), 3 !== e && 5 !== e && 7 !== e && 9 !== e || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $0ccba2be0b51cf09$var$gr(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var e = 0; 16 > e; e++){
            var i = this.bytes[e] - t.bytes[e];
            if (0 !== i) return Math.sign(i);
        }
        return 0;
    }
}
class $0ccba2be0b51cf09$var$mr {
    constructor(){
        this.S = 0, this.C = 0, this.I = new $0ccba2be0b51cf09$var$wr;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($0ccba2be0b51cf09$var$U(t)) {
            this.S = 0;
            var e = this.generateOrAbort();
            if ($0ccba2be0b51cf09$var$U(e)) throw new Error("Could not generate UUID after timestamp reset");
            return e;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.S) this.S = t, this.T();
        else {
            if (this.S >= t + 1e4) return;
            this.C++, this.C > 4398046511103 && (this.S++, this.T());
        }
        return $0ccba2be0b51cf09$var$gr.fromFieldsV7(this.S, Math.trunc(this.C / Math.pow(2, 30)), this.C & Math.pow(2, 30) - 1, this.I.nextUint32());
    }
    T() {
        this.C = 1024 * this.I.nextUint32() + (1023 & this.I.nextUint32());
    }
}
var $0ccba2be0b51cf09$var$br, $0ccba2be0b51cf09$var$yr = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var e = 0; t.length > e; e++)t[e] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$0ccba2be0b51cf09$var$t && !$0ccba2be0b51cf09$var$U($0ccba2be0b51cf09$var$t.crypto) && crypto.getRandomValues && ($0ccba2be0b51cf09$var$yr = (t)=>crypto.getRandomValues(t));
class $0ccba2be0b51cf09$var$wr {
    constructor(){
        this.M = new Uint32Array(8), this.R = 1 / 0;
    }
    nextUint32() {
        return this.M.length > this.R || ($0ccba2be0b51cf09$var$yr(this.M), this.R = 0), this.M[this.R++];
    }
}
var $0ccba2be0b51cf09$var$xr = ()=>$0ccba2be0b51cf09$var$Er().toString(), $0ccba2be0b51cf09$var$Er = ()=>($0ccba2be0b51cf09$var$br || ($0ccba2be0b51cf09$var$br = new $0ccba2be0b51cf09$var$mr)).generate(), $0ccba2be0b51cf09$var$Sr = "", $0ccba2be0b51cf09$var$$r = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
var $0ccba2be0b51cf09$var$Tr = {
    O: ()=>!!$0ccba2be0b51cf09$var$r,
    D (t) {
        $0ccba2be0b51cf09$var$We.error("cookieStore error: " + t);
    },
    A (t) {
        if ($0ccba2be0b51cf09$var$r) {
            try {
                for(var e = t + "=", i = $0ccba2be0b51cf09$var$r.cookie.split(";").filter((t)=>t.length), s = 0; i.length > s; s++){
                    for(var n = i[s]; " " == n.charAt(0);)n = n.substring(1, n.length);
                    if (0 === n.indexOf(e)) return decodeURIComponent(n.substring(e.length, n.length));
                }
            } catch (t) {}
            return null;
        }
    },
    F (t) {
        var e;
        try {
            e = JSON.parse($0ccba2be0b51cf09$var$Tr.A(t)) || {};
        } catch (t) {}
        return e;
    },
    N (t, e, i, s, n) {
        if (!$0ccba2be0b51cf09$var$r) return !1;
        try {
            var o = "", a = "", l = function(t, e) {
                if (e) {
                    var i = function(t, e) {
                        if (void 0 === e && (e = $0ccba2be0b51cf09$var$r), $0ccba2be0b51cf09$var$Sr) return $0ccba2be0b51cf09$var$Sr;
                        if (!e) return "";
                        if ([
                            "localhost",
                            "127.0.0.1"
                        ].includes(t)) return "";
                        for(var i = t.split("."), s = Math.min(i.length, 8), n = "dmn_chk_" + $0ccba2be0b51cf09$var$xr(); !$0ccba2be0b51cf09$var$Sr && s--;){
                            var o = i.slice(s).join("."), a = n + "=1;domain=." + o + ";path=/";
                            e.cookie = a + ";max-age=3", e.cookie.includes(n) && (e.cookie = a + ";max-age=0", $0ccba2be0b51cf09$var$Sr = o);
                        }
                        return $0ccba2be0b51cf09$var$Sr;
                    }(t);
                    if (!i) {
                        var s = ((t)=>{
                            var e = t.match($0ccba2be0b51cf09$var$$r);
                            return e ? e[0] : "";
                        })(t);
                        s !== i && $0ccba2be0b51cf09$var$We.info("Warning: cookie subdomain discovery mismatch", s, i), i = s;
                    }
                    return i ? "; domain=." + i : "";
                }
                return "";
            }($0ccba2be0b51cf09$var$r.location.hostname, s);
            if (i) {
                var u = new Date;
                u.setTime(u.getTime() + 864e5 * i), o = "; expires=" + u.toUTCString();
            }
            n && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(e)) + o + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $0ccba2be0b51cf09$var$We.warn("cookieStore warning: large cookie, len=" + h.length), $0ccba2be0b51cf09$var$r.cookie = h, !0;
        } catch (t) {
            return !1;
        }
    },
    q (t, e) {
        if (null != $0ccba2be0b51cf09$var$r && $0ccba2be0b51cf09$var$r.cookie) try {
            $0ccba2be0b51cf09$var$Tr.N(t, "", -1, e);
        } catch (t) {
            return;
        }
    }
}, $0ccba2be0b51cf09$var$kr = null, $0ccba2be0b51cf09$var$Rr = {
    O () {
        if (!$0ccba2be0b51cf09$var$B($0ccba2be0b51cf09$var$kr)) return $0ccba2be0b51cf09$var$kr;
        var e = !0;
        if ($0ccba2be0b51cf09$var$U($0ccba2be0b51cf09$var$t)) e = !1;
        else try {
            var i = "__mplssupport__";
            $0ccba2be0b51cf09$var$Rr.N(i, "xyz"), '"xyz"' !== $0ccba2be0b51cf09$var$Rr.A(i) && (e = !1), $0ccba2be0b51cf09$var$Rr.q(i);
        } catch (t) {
            e = !1;
        }
        return e || $0ccba2be0b51cf09$var$We.error("localStorage unsupported; falling back to cookie store"), $0ccba2be0b51cf09$var$kr = e, e;
    },
    D (t) {
        $0ccba2be0b51cf09$var$We.error("localStorage error: " + t);
    },
    A (e) {
        try {
            return null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.localStorage.getItem(e);
        } catch (t) {
            $0ccba2be0b51cf09$var$Rr.D(t);
        }
        return null;
    },
    F (t) {
        try {
            return JSON.parse($0ccba2be0b51cf09$var$Rr.A(t)) || {};
        } catch (t) {}
        return null;
    },
    N (e, i) {
        try {
            return null == $0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$t.localStorage.setItem(e, JSON.stringify(i)), !0;
        } catch (t) {
            $0ccba2be0b51cf09$var$Rr.D(t);
        }
        return !1;
    },
    q (e) {
        try {
            null == $0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$t.localStorage.removeItem(e);
        } catch (t) {
            $0ccba2be0b51cf09$var$Rr.D(t);
        }
    }
}, $0ccba2be0b51cf09$var$Pr = [
    $0ccba2be0b51cf09$var$Qe,
    "distinct_id",
    $0ccba2be0b51cf09$var$_i,
    $0ccba2be0b51cf09$var$gi,
    $0ccba2be0b51cf09$var$Bi,
    $0ccba2be0b51cf09$var$zi,
    $0ccba2be0b51cf09$var$Di
], $0ccba2be0b51cf09$var$Or = {}, $0ccba2be0b51cf09$var$Ir = {
    O: ()=>!0,
    D (t) {
        $0ccba2be0b51cf09$var$We.error("memoryStorage error: " + t);
    },
    A: (t)=>$0ccba2be0b51cf09$var$Or[t] || null,
    F: (t)=>$0ccba2be0b51cf09$var$Or[t] || null,
    N: (t, e)=>($0ccba2be0b51cf09$var$Or[t] = e, !0),
    q (t) {
        delete $0ccba2be0b51cf09$var$Or[t];
    }
}, $0ccba2be0b51cf09$var$Cr = null, $0ccba2be0b51cf09$var$Ar = {
    O () {
        if (!$0ccba2be0b51cf09$var$B($0ccba2be0b51cf09$var$Cr)) return $0ccba2be0b51cf09$var$Cr;
        if ($0ccba2be0b51cf09$var$Cr = !0, $0ccba2be0b51cf09$var$U($0ccba2be0b51cf09$var$t)) $0ccba2be0b51cf09$var$Cr = !1;
        else try {
            var e = "__support__";
            $0ccba2be0b51cf09$var$Ar.N(e, "xyz"), '"xyz"' !== $0ccba2be0b51cf09$var$Ar.A(e) && ($0ccba2be0b51cf09$var$Cr = !1), $0ccba2be0b51cf09$var$Ar.q(e);
        } catch (t) {
            $0ccba2be0b51cf09$var$Cr = !1;
        }
        return $0ccba2be0b51cf09$var$Cr;
    },
    D (t) {
        $0ccba2be0b51cf09$var$We.error("sessionStorage error: ", t);
    },
    A (e) {
        try {
            return null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.sessionStorage.getItem(e);
        } catch (t) {
            $0ccba2be0b51cf09$var$Ar.D(t);
        }
        return null;
    },
    F (t) {
        try {
            return JSON.parse($0ccba2be0b51cf09$var$Ar.A(t)) || null;
        } catch (t) {}
        return null;
    },
    N (e, i) {
        try {
            return null == $0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$t.sessionStorage.setItem(e, JSON.stringify(i)), !0;
        } catch (t) {
            $0ccba2be0b51cf09$var$Ar.D(t);
        }
        return !1;
    },
    q (e) {
        try {
            null == $0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$t.sessionStorage.removeItem(e);
        } catch (t) {
            $0ccba2be0b51cf09$var$Ar.D(t);
        }
    }
};
class $0ccba2be0b51cf09$var$Fr {
    constructor(t){
        this._instance = t;
    }
    get qt() {
        return this._instance.config;
    }
    get consent() {
        return this.rr() ? 0 : this.ir;
    }
    isOptedOut() {
        return this.qt.cookieless_mode === $0ccba2be0b51cf09$var$Ki || this.isRejected() || -1 === this.consent && this.qt.cookieless_mode === $0ccba2be0b51cf09$var$Ji;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return 0 === this.consent;
    }
    isRejected() {
        return 0 === this.consent || -1 === this.consent && this.qt.opt_out_capturing_by_default;
    }
    optInOut(t) {
        this.nr.N(this.sr, t ? 1 : 0, this.qt.cookie_expiration, this.qt.cross_subdomain_cookie, this.qt.secure_cookie);
    }
    reset() {
        this.nr.q(this.sr, this.qt.cross_subdomain_cookie);
    }
    get sr() {
        var { token: t, opt_out_capturing_cookie_prefix: e, consent_persistence_name: i } = this._instance.config;
        return i || (e ? e + t : "__ph_opt_in_out_" + t);
    }
    get ir() {
        var t = this.nr.A(this.sr);
        return $0ccba2be0b51cf09$var$Z(t) ? 1 : $0ccba2be0b51cf09$var$P($0ccba2be0b51cf09$var$tt, t) ? 0 : -1;
    }
    get nr() {
        var t = this.qt.opt_out_capturing_persistence_type, e = "localStorage" === t ? $0ccba2be0b51cf09$var$Rr : $0ccba2be0b51cf09$var$Tr;
        if (!this.ar || this.ar !== e) {
            this.ar = e;
            var i = "localStorage" === t ? $0ccba2be0b51cf09$var$Tr : $0ccba2be0b51cf09$var$Rr;
            i.A(this.sr) && (this.ar.A(this.sr) || this.optInOut($0ccba2be0b51cf09$var$Z(i.A(this.sr))), i.q(this.sr, this.qt.cross_subdomain_cookie));
        }
        return this.ar;
    }
    rr() {
        return !!this.qt.respect_dnt && [
            null == $0ccba2be0b51cf09$var$i ? void 0 : $0ccba2be0b51cf09$var$i.doNotTrack,
            null == $0ccba2be0b51cf09$var$i ? void 0 : $0ccba2be0b51cf09$var$i.msDoNotTrack,
            $0ccba2be0b51cf09$var$h.doNotTrack
        ].some((t)=>$0ccba2be0b51cf09$var$Z(t));
    }
}
var $0ccba2be0b51cf09$var$Mr = 1, $0ccba2be0b51cf09$var$Dr = 3, $0ccba2be0b51cf09$var$Nr = 11;
function $0ccba2be0b51cf09$var$Lr(t) {
    return t instanceof Element && (t.id === $0ccba2be0b51cf09$var$Hi || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $0ccba2be0b51cf09$var$Ur(t) {
    return !!t && t.nodeType === $0ccba2be0b51cf09$var$Mr;
}
function $0ccba2be0b51cf09$var$jr(t, e) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === e.toLowerCase();
}
function $0ccba2be0b51cf09$var$zr(t) {
    return !!t && t.nodeType === $0ccba2be0b51cf09$var$Dr;
}
function $0ccba2be0b51cf09$var$Br(t) {
    return !!t && t.nodeType === $0ccba2be0b51cf09$var$Nr && $0ccba2be0b51cf09$var$Ur(t.host);
}
function $0ccba2be0b51cf09$var$Hr(t) {
    return t ? $0ccba2be0b51cf09$var$O(t).split(/\s+/) : [];
}
function $0ccba2be0b51cf09$var$Vr(e) {
    var i = null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.location.href;
    return !!(i && e && e.some((t)=>i.match(t)));
}
function $0ccba2be0b51cf09$var$qr(t) {
    var e = "";
    switch(typeof t.className){
        case "string":
            e = t.className;
            break;
        case "object":
            e = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            e = "";
    }
    return $0ccba2be0b51cf09$var$Hr(e);
}
function $0ccba2be0b51cf09$var$Gr(t) {
    return $0ccba2be0b51cf09$var$H(t) ? null : $0ccba2be0b51cf09$var$O(t).split(/(\s+)/).filter((t)=>$0ccba2be0b51cf09$var$ps(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $0ccba2be0b51cf09$var$Wr(t) {
    var e = "";
    return $0ccba2be0b51cf09$var$os(t) && !$0ccba2be0b51cf09$var$as(t) && t.childNodes && t.childNodes.length && $0ccba2be0b51cf09$var$ar(t.childNodes, function(t) {
        var i;
        $0ccba2be0b51cf09$var$zr(t) && t.textContent && (e += null !== (i = $0ccba2be0b51cf09$var$Gr(t.textContent)) && void 0 !== i ? i : "");
    }), $0ccba2be0b51cf09$var$O(e);
}
function $0ccba2be0b51cf09$var$Yr(t) {
    var e;
    return $0ccba2be0b51cf09$var$U(t.target) ? t.srcElement || null : null != (e = t.target) && e.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $0ccba2be0b51cf09$var$Jr = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $0ccba2be0b51cf09$var$Kr(t, e) {
    if ($0ccba2be0b51cf09$var$U(e)) return !0;
    var i, r = function(t) {
        if (e.some((e)=>t.matches(e))) return {
            v: !0
        };
    };
    for (var s of t)if (i = r(s)) return i.v;
    return !1;
}
function $0ccba2be0b51cf09$var$Xr(t) {
    var e = t.parentNode;
    return !(!e || !$0ccba2be0b51cf09$var$Ur(e)) && e;
}
var $0ccba2be0b51cf09$var$Qr = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $0ccba2be0b51cf09$var$Zr = [
    ...$0ccba2be0b51cf09$var$Qr,
    "+",
    "-",
    "\u2212",
    "\u2013"
], $0ccba2be0b51cf09$var$ts = (t, e)=>/[a-z0-9]/i.test(e) ? t.includes(e) : t === e, $0ccba2be0b51cf09$var$es = [
    ".ph-no-rageclick",
    ".ph-no-capture"
], $0ccba2be0b51cf09$var$is = [
    "",
    "text",
    "search",
    "email",
    "password",
    "url",
    "tel",
    "number"
];
function $0ccba2be0b51cf09$var$rs(e, i) {
    if (!$0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$ss(e)) return !1;
    var r, s, n, o, a;
    if ($0ccba2be0b51cf09$var$G(i) ? (r = !!i && $0ccba2be0b51cf09$var$es, s = void 0, n = !1) : (r = null !== (o = null == i ? void 0 : i.css_selector_ignorelist) && void 0 !== o ? o : $0ccba2be0b51cf09$var$es, s = null == i ? void 0 : i.content_ignorelist, n = null !== (a = null == i ? void 0 : i.ignore_text_selection) && void 0 !== a && a), !1 === r) return !1;
    if (n && function(t) {
        return !(!t || !$0ccba2be0b51cf09$var$Ur(t)) && (!!$0ccba2be0b51cf09$var$jr(t, "textarea") || ($0ccba2be0b51cf09$var$jr(t, "input") ? $0ccba2be0b51cf09$var$P($0ccba2be0b51cf09$var$is, (t.getAttribute("type") || "").toLowerCase()) : function(t) {
            if (t.isContentEditable) return !0;
            var e = null == t.getAttribute ? void 0 : t.getAttribute("contenteditable");
            return "true" === e || "" === e;
        }(t)));
    }(e)) return !1;
    var { targetElementList: l } = $0ccba2be0b51cf09$var$ns(e, !1);
    return !function(t, e) {
        if (!1 === t || $0ccba2be0b51cf09$var$U(t)) return !1;
        var i;
        if (!0 === t) i = $0ccba2be0b51cf09$var$Qr;
        else {
            if (!$0ccba2be0b51cf09$var$M(t)) return !1;
            if (t.length > 10) return $0ccba2be0b51cf09$var$We.error("[PostHog] content_ignorelist array cannot exceed 10 items. Use css_selector_ignorelist for more complex matching."), !1;
            i = t.map((t)=>t.toLowerCase());
        }
        return e.some((t)=>{
            var { safeText: e, ariaLabel: r } = t;
            return i.some((t)=>$0ccba2be0b51cf09$var$ts(e, t) || $0ccba2be0b51cf09$var$ts(r, t));
        });
    }(s, l.map((t)=>{
        var e;
        return {
            safeText: $0ccba2be0b51cf09$var$Wr(t).toLowerCase(),
            ariaLabel: (null == (e = t.getAttribute("aria-label")) ? void 0 : e.toLowerCase().trim()) || ""
        };
    })) && !$0ccba2be0b51cf09$var$Kr(l, r);
}
var $0ccba2be0b51cf09$var$ss = (t)=>!t || $0ccba2be0b51cf09$var$jr(t, "html") || !$0ccba2be0b51cf09$var$Ur(t), $0ccba2be0b51cf09$var$ns = (e, i)=>{
    if (!$0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$ss(e)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        e
    ], n = e; n.parentNode && !$0ccba2be0b51cf09$var$jr(n, "body");)if ($0ccba2be0b51cf09$var$Br(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $0ccba2be0b51cf09$var$Xr(n);
        if (!o) break;
        if (i || $0ccba2be0b51cf09$var$Jr.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = $0ccba2be0b51cf09$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $0ccba2be0b51cf09$var$os(t) {
    for(var e = t; e.parentNode && !$0ccba2be0b51cf09$var$jr(e, "body"); e = e.parentNode){
        var i = $0ccba2be0b51cf09$var$qr(e);
        if ($0ccba2be0b51cf09$var$P(i, "ph-sensitive") || $0ccba2be0b51cf09$var$P(i, "ph-no-capture")) return !1;
    }
    if ($0ccba2be0b51cf09$var$P($0ccba2be0b51cf09$var$qr(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($0ccba2be0b51cf09$var$j(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    return !$0ccba2be0b51cf09$var$j(s) || !/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""));
}
function $0ccba2be0b51cf09$var$as(t) {
    return !!($0ccba2be0b51cf09$var$jr(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $0ccba2be0b51cf09$var$jr(t, "select") || $0ccba2be0b51cf09$var$jr(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $0ccba2be0b51cf09$var$ls = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $0ccba2be0b51cf09$var$us = new RegExp("^(?:" + $0ccba2be0b51cf09$var$ls + ")$"), $0ccba2be0b51cf09$var$hs = new RegExp($0ccba2be0b51cf09$var$ls), $0ccba2be0b51cf09$var$ds = "\\d{3}-?\\d{2}-?\\d{4}", $0ccba2be0b51cf09$var$vs = new RegExp("^(" + $0ccba2be0b51cf09$var$ds + ")$"), $0ccba2be0b51cf09$var$cs = new RegExp("(" + $0ccba2be0b51cf09$var$ds + ")");
function $0ccba2be0b51cf09$var$ps(t, e) {
    if (void 0 === e && (e = !0), $0ccba2be0b51cf09$var$H(t)) return !1;
    if ($0ccba2be0b51cf09$var$j(t)) {
        if (t = $0ccba2be0b51cf09$var$O(t), (e ? $0ccba2be0b51cf09$var$us : $0ccba2be0b51cf09$var$hs).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((e ? $0ccba2be0b51cf09$var$vs : $0ccba2be0b51cf09$var$cs).test(t)) return !1;
    }
    return !0;
}
function $0ccba2be0b51cf09$var$fs(t) {
    var e = $0ccba2be0b51cf09$var$Wr(t);
    return $0ccba2be0b51cf09$var$ps(e = (e + " " + $0ccba2be0b51cf09$var$_s(t)).trim()) ? e : "";
}
function $0ccba2be0b51cf09$var$_s(t) {
    var e = "";
    return t && t.childNodes && t.childNodes.length && $0ccba2be0b51cf09$var$ar(t.childNodes, function(t) {
        var i;
        if (t && "span" === (null == (i = t.tagName) ? void 0 : i.toLowerCase())) try {
            var r = $0ccba2be0b51cf09$var$Wr(t);
            e = (e + " " + r).trim(), t.childNodes && t.childNodes.length && (e = (e + " " + $0ccba2be0b51cf09$var$_s(t)).trim());
        } catch (t) {
            $0ccba2be0b51cf09$var$We.error("[AutoCapture]", t);
        }
    }), e;
}
function $0ccba2be0b51cf09$var$gs(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $0ccba2be0b51cf09$var$ms(t) {
    var e = t.attr__class;
    return e ? $0ccba2be0b51cf09$var$M(e) ? e : $0ccba2be0b51cf09$var$Hr(e) : void 0;
}
var $0ccba2be0b51cf09$var$bs = $0ccba2be0b51cf09$var$Ye("[Dead Clicks]"), $0ccba2be0b51cf09$var$ys = ()=>!0, $0ccba2be0b51cf09$var$ws = (t)=>{
    var e, i = !(null == (e = t.instance.persistence) || !e.get_property($0ccba2be0b51cf09$var$ai)), r = t.instance.config.capture_dead_clicks;
    return $0ccba2be0b51cf09$var$G(r) ? r : !!$0ccba2be0b51cf09$var$N(r) || i;
};
class $0ccba2be0b51cf09$var$xs {
    get lazyLoadedDeadClicksAutocapture() {
        return this.lr;
    }
    constructor(t, e, i){
        this.instance = t, this.isEnabled = e, this.onCapture = i, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        "captureDeadClicks" in t && (this.instance.persistence && this.instance.persistence.register({
            [$0ccba2be0b51cf09$var$ai]: t.captureDeadClicks
        }), this.startIfEnabledOrStop());
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.ur(()=>{
            this.hr();
        }) : this.stop();
    }
    ur(t) {
        var e, i;
        null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && e.initDeadClicksAutocapture && t(), null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this.instance, "dead-clicks-autocapture", (e)=>{
            e ? $0ccba2be0b51cf09$var$bs.error("failed to load script", e) : t();
        });
    }
    hr() {
        var t;
        if ($0ccba2be0b51cf09$var$r) {
            if (!this.lr && null != (t = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var e = $0ccba2be0b51cf09$var$N(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                e.__onCapture = this.onCapture, this.lr = $0ccba2be0b51cf09$var$h.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, e), this.lr.start($0ccba2be0b51cf09$var$r), $0ccba2be0b51cf09$var$bs.info("starting...");
            }
        } else $0ccba2be0b51cf09$var$bs.error("`document` not found. Cannot start.");
    }
    stop() {
        this.lr && (this.lr.stop(), this.lr = void 0, $0ccba2be0b51cf09$var$bs.info("stopping..."));
    }
}
var $0ccba2be0b51cf09$var$Es = $0ccba2be0b51cf09$var$Ye("[SegmentIntegration]");
var $0ccba2be0b51cf09$var$Ss = "posthog-js";
function $0ccba2be0b51cf09$var$$s(t, e) {
    var { organization: i, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === e ? {} : e;
    return (e)=>{
        var a, l, u, h, d;
        if ("*" !== n && !n.includes(e.level) || !t.__loaded) return e;
        e.tags || (e.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        e.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (e.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c, p = (null == (a = e.exception) ? void 0 : a.values) || [], _ = p.map((t)=>$0ccba2be0b51cf09$var$f({}, t, {
                stacktrace: t.stacktrace ? $0ccba2be0b51cf09$var$f({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$0ccba2be0b51cf09$var$f({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), g = {
            $exception_message: (null == (l = p[0]) ? void 0 : l.value) || e.message,
            $exception_type: null == (u = p[0]) ? void 0 : u.type,
            $exception_level: e.level,
            $exception_list: _,
            $sentry_event_id: e.event_id,
            $sentry_exception: e.exception,
            $sentry_exception_message: (null == (h = p[0]) ? void 0 : h.value) || e.message,
            $sentry_exception_type: null == (d = p[0]) ? void 0 : d.type,
            $sentry_tags: e.tags
        };
        return i && r && (g.$sentry_url = (s || "https://sentry.io/organizations/") + i + "/issues/?project=" + r + "&query=" + e.event_id), o && (null == (c = t.exceptions) || c.sendExceptionEvent(g)), e;
    };
}
class $0ccba2be0b51cf09$var$Ts {
    constructor(t, e, i, r, s, n){
        this.name = $0ccba2be0b51cf09$var$Ss, this.setupOnce = function(o) {
            o($0ccba2be0b51cf09$var$$s(t, {
                organization: e,
                projectId: i,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
class $0ccba2be0b51cf09$var$ks {
    constructor(t){
        this.cr = (t, e, i)=>{
            i && (i.noSessionId || i.activityTimeout || i.sessionPastMaximumLength || i.crossTabAdoption) && ($0ccba2be0b51cf09$var$We.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: i
            }), this.dr = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.vr();
    }
    vr() {
        var t;
        this.pr = null == (t = this._instance.sessionManager) ? void 0 : t.onSessionId(this.cr);
    }
    destroy() {
        var t;
        null == (t = this.pr) || t.call(this), this.pr = void 0;
    }
    doPageView(e, i) {
        var r, s = this.gr(e, i);
        return this.dr = {
            pathname: null !== (r = null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: i,
            timestamp: e
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var e;
        return this.gr(t, null == (e = this.dr) ? void 0 : e.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.dr) ? void 0 : t.pageViewId
        };
    }
    gr(t, e) {
        var i = this.dr;
        if (!i) return {
            $pageview_id: e
        };
        var r = {
            $pageview_id: e,
            $prev_pageview_id: i.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($0ccba2be0b51cf09$var$U(n) || $0ccba2be0b51cf09$var$U(o) || $0ccba2be0b51cf09$var$U(a) || $0ccba2be0b51cf09$var$U(l) || $0ccba2be0b51cf09$var$U(u) || $0ccba2be0b51cf09$var$U(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n > 1 ? $0ccba2be0b51cf09$var$et(o / n, 0, 1, $0ccba2be0b51cf09$var$We) : 1, v = n > 1 ? $0ccba2be0b51cf09$var$et(a / n, 0, 1, $0ccba2be0b51cf09$var$We) : 1, c = l > 1 ? $0ccba2be0b51cf09$var$et(u / l, 0, 1, $0ccba2be0b51cf09$var$We) : 1, p = l > 1 ? $0ccba2be0b51cf09$var$et(h / l, 0, 1, $0ccba2be0b51cf09$var$We) : 1;
                r = $0ccba2be0b51cf09$var$lr(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: p
                });
            }
        }
        return i.pathname && (r.$prev_pageview_pathname = i.pathname), i.timestamp && (r.$prev_pageview_duration = (t.getTime() - i.timestamp.getTime()) / 1e3), r;
    }
}
var $0ccba2be0b51cf09$var$Rs = [
    "flags",
    "surveys"
], $0ccba2be0b51cf09$var$Ps = {
    [$0ccba2be0b51cf09$var$Xe]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Ze]: {
        exposure: "hidden"
    },
    __cmpns: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$ti]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$ei]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$ii]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$ri]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$si]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$ni]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$oi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$ai]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$li]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$ui]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$hi]: {
        exposure: "hidden"
    },
    $session_recording_enabled_server_side: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$_i]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$gi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$di]: {
        exposure: "event",
        shouldSkipFromEventProperties: (t)=>$0ccba2be0b51cf09$var$B(t)
    },
    $session_past_minimum_duration: {
        exposure: "event"
    },
    $session_recording_url_trigger_activated_session: {
        exposure: "event"
    },
    $session_recording_event_trigger_activated_session: {
        exposure: "event"
    },
    $debug_first_full_snapshot_timestamp: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$mi]: {
        exposure: "derived",
        storageGroup: "flags",
        shouldSkipFromEventProperties: (t, e)=>e(),
        transformToEventProperties (t) {
            if (!$0ccba2be0b51cf09$var$N(t)) return {};
            for(var e = {}, i = Object.keys(t), r = 0; i.length > r; r++)e["$feature/" + i[r]] = t[i[r]];
            return e;
        }
    },
    [$0ccba2be0b51cf09$var$bi]: {
        exposure: "event",
        storageGroup: "flags"
    },
    [$0ccba2be0b51cf09$var$yi]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$wi]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$0ccba2be0b51cf09$var$xi]: {
        exposure: "event",
        storageGroup: "flags"
    },
    [$0ccba2be0b51cf09$var$Ei]: {
        exposure: "event",
        storageGroup: "flags",
        volatile: !0
    },
    [$0ccba2be0b51cf09$var$Si]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$$i]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Ti]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$ki]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Ri]: {
        exposure: "hidden",
        storageGroup: "surveys"
    },
    [$0ccba2be0b51cf09$var$Pi]: {
        exposure: "hidden",
        storageGroup: "surveys",
        volatile: !0
    },
    [$0ccba2be0b51cf09$var$Oi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$Ii]: {
        exposure: "hidden"
    },
    $product_tours_activated: {
        exposure: "hidden"
    },
    $conversations_widget_session_id: {
        exposure: "event"
    },
    $conversations_ticket_id: {
        exposure: "event"
    },
    $conversations_widget_state: {
        exposure: "event"
    },
    $conversations_user_traits: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$Ci]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Ai]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Fi]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Mi]: {
        exposure: "hidden",
        storageGroup: "flags",
        volatile: !0
    },
    [$0ccba2be0b51cf09$var$Di]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Ni]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Li]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Ui]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$ji]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$zi]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$Bi]: {
        exposure: "hidden"
    },
    [$0ccba2be0b51cf09$var$vi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$ci]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$pi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$fi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$qi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$Gi]: {
        exposure: "event"
    },
    [$0ccba2be0b51cf09$var$Wi]: {
        exposure: "event"
    },
    $sdk_debug_replay_event_trigger_status: {
        exposure: "event"
    },
    $sdk_debug_replay_linked_flag_trigger_status: {
        exposure: "event"
    },
    $sdk_debug_replay_matched_recording_trigger_groups: {
        exposure: "event"
    },
    $sdk_debug_replay_remote_trigger_matching_config: {
        exposure: "event"
    },
    $sdk_debug_replay_trigger_groups_count: {
        exposure: "event"
    },
    $sdk_debug_replay_url_trigger_status: {
        exposure: "event"
    },
    $session_recording_start_reason: {
        exposure: "event"
    }
}, $0ccba2be0b51cf09$var$Os = [
    [
        "$posthog_sr_group_event_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_url_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_sampling_",
        {
            exposure: "hidden"
        }
    ]
], $0ccba2be0b51cf09$var$Is = (t)=>{
    var e = $0ccba2be0b51cf09$var$Ps[t];
    if (e) return e;
    for (var [i, r] of $0ccba2be0b51cf09$var$Os)if (0 === t.indexOf(i)) return r;
}, $0ccba2be0b51cf09$var$Cs = (t)=>{
    var e = null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.createElement("a");
    return $0ccba2be0b51cf09$var$U(e) ? null : (e.href = t, e);
}, $0ccba2be0b51cf09$var$As = function(t, e) {
    for(var i, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; r.length > s; s++){
        var n = r[s].split("=");
        if (n[0] === e) {
            i = n;
            break;
        }
    }
    if (!$0ccba2be0b51cf09$var$M(i) || 2 > i.length) return "";
    var o = i[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $0ccba2be0b51cf09$var$We.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $0ccba2be0b51cf09$var$Fs = function(t, e, i) {
    if (!t || !e || !e.length) return t;
    for(var r = t.split("#"), s = r[1], n = (r[0] || "").split("?"), o = n[1], a = n[0], l = (o || "").split("&"), u = [], h = 0; l.length > h; h++){
        var d = l[h].split("=");
        $0ccba2be0b51cf09$var$M(d) && (e.includes(d[0]) ? u.push(d[0] + "=" + i) : u.push(l[h]));
    }
    var v = a;
    return null != o && (v += "?" + u.join("&")), null != s && (v += "#" + s), v;
}, $0ccba2be0b51cf09$var$Ms = function(t, e) {
    var i = t.match(new RegExp(e + "=([^&]*)"));
    return i ? i[1] : null;
}, $0ccba2be0b51cf09$var$Ds = "https?://(.*)", $0ccba2be0b51cf09$var$Ns = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $0ccba2be0b51cf09$var$Ls = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    ...$0ccba2be0b51cf09$var$Ns
], $0ccba2be0b51cf09$var$Us = "<masked>", $0ccba2be0b51cf09$var$js = [
    "li_fat_id"
];
function $0ccba2be0b51cf09$var$zs(t, e, i) {
    if (!$0ccba2be0b51cf09$var$r) return {};
    var s, n = e ? [
        ...$0ccba2be0b51cf09$var$Ns,
        ...i || []
    ] : [], o = $0ccba2be0b51cf09$var$Bs($0ccba2be0b51cf09$var$Fs($0ccba2be0b51cf09$var$r.URL, n, $0ccba2be0b51cf09$var$Us), t), a = (s = {}, $0ccba2be0b51cf09$var$ar($0ccba2be0b51cf09$var$js, function(t) {
        var e = $0ccba2be0b51cf09$var$Tr.A(t);
        s[t] = e || null;
    }), s);
    return $0ccba2be0b51cf09$var$lr(a, o);
}
function $0ccba2be0b51cf09$var$Bs(t, e) {
    var i = $0ccba2be0b51cf09$var$Ls.concat(e || []), r = {};
    return $0ccba2be0b51cf09$var$ar(i, function(e) {
        var i = $0ccba2be0b51cf09$var$As(t, e);
        r[e] = i || null;
    }), r;
}
function $0ccba2be0b51cf09$var$Hs(t) {
    var e = function(t) {
        return t ? 0 === t.search($0ccba2be0b51cf09$var$Ds + "google.([^/?]*)") ? "google" : 0 === t.search($0ccba2be0b51cf09$var$Ds + "bing.com") ? "bing" : 0 === t.search($0ccba2be0b51cf09$var$Ds + "yahoo.com") ? "yahoo" : 0 === t.search($0ccba2be0b51cf09$var$Ds + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), i = "yahoo" != e ? "q" : "p", s = {};
    if (!$0ccba2be0b51cf09$var$B(e)) {
        s.$search_engine = e;
        var n = $0ccba2be0b51cf09$var$r ? $0ccba2be0b51cf09$var$As($0ccba2be0b51cf09$var$r.referrer, i) : "";
        n.length && (s.ph_keyword = n);
    }
    return s;
}
function $0ccba2be0b51cf09$var$Vs() {
    return navigator.language || navigator.userLanguage;
}
var $0ccba2be0b51cf09$var$qs = "$direct";
function $0ccba2be0b51cf09$var$Gs() {
    return (null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.referrer) || $0ccba2be0b51cf09$var$qs;
}
function $0ccba2be0b51cf09$var$Ws(t, e) {
    var i = t ? [
        ...$0ccba2be0b51cf09$var$Ns,
        ...e || []
    ] : [], r = null == $0ccba2be0b51cf09$var$s ? void 0 : $0ccba2be0b51cf09$var$s.href.substring(0, 1e3);
    return {
        r: $0ccba2be0b51cf09$var$Gs().substring(0, 1e3),
        u: r ? $0ccba2be0b51cf09$var$Fs(r, i, $0ccba2be0b51cf09$var$Us) : void 0
    };
}
function $0ccba2be0b51cf09$var$Ys(t) {
    var e, { r: i, u: r } = t, s = {
        $referrer: i,
        $referring_domain: null == i ? void 0 : i == $0ccba2be0b51cf09$var$qs ? $0ccba2be0b51cf09$var$qs : null == (e = $0ccba2be0b51cf09$var$Cs(i)) ? void 0 : e.host
    };
    if (r) {
        s.$current_url = r;
        var n = $0ccba2be0b51cf09$var$Cs(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $0ccba2be0b51cf09$var$Bs(r);
        $0ccba2be0b51cf09$var$lr(s, o);
    }
    if (i) {
        var a = $0ccba2be0b51cf09$var$Hs(i);
        $0ccba2be0b51cf09$var$lr(s, a);
    }
    return s;
}
function $0ccba2be0b51cf09$var$Js() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $0ccba2be0b51cf09$var$Ks() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
var $0ccba2be0b51cf09$var$Xs = {
    flags: $0ccba2be0b51cf09$var$Mi,
    surveys: $0ccba2be0b51cf09$var$Pi
}, $0ccba2be0b51cf09$var$Qs = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $0ccba2be0b51cf09$var$Zs = "main";
class $0ccba2be0b51cf09$var$tn {
    constructor(e, i, r){
        if (void 0 === r && (r = !0), this.mr = {}, this.yr = !1, this.br = !1, this.qt = e, this._r = r, this.props = {}, this.wr = !1, this.kr = ((t)=>{
            var e = "";
            return t.token && (e = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + e + "_posthog";
        })(e), this.nr = this.Sr(e), this.br = this.Cr(e), this.load(), e.debug && $0ccba2be0b51cf09$var$We.info("Persistence loaded", e.persistence, $0ccba2be0b51cf09$var$f({}, this.props)), this.update_config(e, e, i), this.save(), $0ccba2be0b51cf09$var$t) {
            var s = ()=>this.flush();
            $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "beforeunload", s, {
                capture: !1
            }), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "pagehide", s, {
                capture: !1
            });
        }
    }
    Ir() {
        var t, e = null == (t = this.qt) ? void 0 : t.persistence_save_debounce_ms;
        return $0ccba2be0b51cf09$var$V(e) && e > 0 ? e : 0;
    }
    isDisabled() {
        return !!this.Tr;
    }
    Sr(e) {
        -1 === $0ccba2be0b51cf09$var$Qs.indexOf(e.persistence.toLowerCase()) && ($0ccba2be0b51cf09$var$We.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
        var i, r = function(e, i) {
            void 0 === e && (e = []), void 0 === i && (i = !1);
            var r = [
                ...$0ccba2be0b51cf09$var$Pr,
                ...e
            ];
            return $0ccba2be0b51cf09$var$f({}, $0ccba2be0b51cf09$var$Rr, {
                F (t) {
                    try {
                        var e = {};
                        try {
                            e = $0ccba2be0b51cf09$var$Tr.F(t) || {};
                        } catch (t) {}
                        var r, s = JSON.parse($0ccba2be0b51cf09$var$Rr.A(t) || "{}");
                        if (i) {
                            var n = {};
                            for(var o in e){
                                var a = e[o];
                                $0ccba2be0b51cf09$var$B(a) || "" === a || (n[o] = a);
                            }
                            r = $0ccba2be0b51cf09$var$lr(s, n);
                        } else r = $0ccba2be0b51cf09$var$lr(e, s);
                        return $0ccba2be0b51cf09$var$Rr.N(t, r), r;
                    } catch (t) {}
                    return null;
                },
                N (t, e, i, s, n, o) {
                    var a = $0ccba2be0b51cf09$var$Rr.N(t, e, void 0, void 0, o);
                    try {
                        var l = {};
                        r.forEach((t)=>{
                            e[t] && (l[t] = e[t]);
                        }), Object.keys(l).length && $0ccba2be0b51cf09$var$Tr.N(t, l, i, s, n, o);
                    } catch (t) {
                        $0ccba2be0b51cf09$var$Rr.D(t);
                    }
                    return a;
                },
                q (e, i) {
                    try {
                        null == $0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$t.localStorage.removeItem(e), $0ccba2be0b51cf09$var$Tr.q(e, i);
                    } catch (t) {
                        $0ccba2be0b51cf09$var$Rr.D(t);
                    }
                }
            });
        }(e.cookie_persisted_properties || [], e.__preview_cookie_wins_on_conflict || !1), s = !1, n = e.persistence.toLowerCase();
        return "localstorage" === n && $0ccba2be0b51cf09$var$Rr.O() ? (i = $0ccba2be0b51cf09$var$Rr, s = !0) : "localstorage+cookie" === n && r.O() ? (i = r, s = !0) : "sessionstorage" === n && $0ccba2be0b51cf09$var$Ar.O() ? i = $0ccba2be0b51cf09$var$Ar : "memory" === n ? i = $0ccba2be0b51cf09$var$Ir : "cookie" === n ? i = $0ccba2be0b51cf09$var$Tr : r.O() ? (i = r, s = !0) : i = $0ccba2be0b51cf09$var$Tr, this.yr = s, i;
    }
    Er(t) {
        return this.kr + "__" + t;
    }
    Cr(t) {
        return this.yr && !!t.split_storage;
    }
    Mr(t) {
        var e = null != t ? t : this.qt.feature_flag_cache_ttl_ms;
        if (!e || 0 >= e) return !1;
        var i = this.props[$0ccba2be0b51cf09$var$Mi];
        return !i || "number" != typeof i || Date.now() - i > e;
    }
    properties() {
        var t = {};
        return $0ccba2be0b51cf09$var$ar(this.props, (e, i)=>{
            var r = $0ccba2be0b51cf09$var$Is(i);
            if ("derived" === (null == r ? void 0 : r.exposure)) {
                if (null != r.shouldSkipFromEventProperties && r.shouldSkipFromEventProperties(e, i === $0ccba2be0b51cf09$var$mi ? ()=>this.Mr() : ()=>!1)) return;
                r.transformToEventProperties && $0ccba2be0b51cf09$var$lr(t, r.transformToEventProperties(e));
            } else if (!r || "event" === r.exposure) {
                if (null != r && null != r.shouldSkipFromEventProperties && r.shouldSkipFromEventProperties(e, ()=>!1)) return;
                t[i] = e;
            }
        }), t;
    }
    load() {
        if (!this.Tr) {
            var t = this.nr.F(this.kr);
            t && (this.props = $0ccba2be0b51cf09$var$lr({}, t)), this.br && this.Rr();
        }
    }
    Rr() {
        for (var t of $0ccba2be0b51cf09$var$Rs){
            var e = $0ccba2be0b51cf09$var$Rr.F(this.Er(t));
            if (e && !$0ccba2be0b51cf09$var$L(e)) {
                var i = this.Pr(t);
                i.persisted = !0, this.Or(t) || (i.fingerprint = this.Lr(e, t)), this.Ar(t, e) || $0ccba2be0b51cf09$var$lr(this.props, e);
            }
        }
    }
    Or(t) {
        return Object.keys(this.props).some((e)=>{
            var i;
            return (null == (i = $0ccba2be0b51cf09$var$Is(e)) ? void 0 : i.storageGroup) === t;
        });
    }
    Ar(t, e) {
        var i = $0ccba2be0b51cf09$var$Xs[t];
        if (!i) return !1;
        var r = e[i], s = this.props[i];
        return $0ccba2be0b51cf09$var$V(r) && $0ccba2be0b51cf09$var$V(s) && s > r;
    }
    refreshKey(t) {
        var e;
        if (!this.Tr) {
            var i = this.br ? null == (e = $0ccba2be0b51cf09$var$Is(t)) ? void 0 : e.storageGroup : void 0, r = i ? $0ccba2be0b51cf09$var$Rr.F(this.Er(i)) : this.nr.F(this.kr);
            if (r && t in r) this.Fr(t, r[t]);
            else {
                if (i) {
                    var s = this.nr.F(this.kr);
                    if (s && t in s) return void this.Fr(t, s[t]);
                }
                this.Nr(t);
            }
        }
    }
    save() {
        if (!this.Tr) {
            var t = this.Ir();
            t > 0 ? $0ccba2be0b51cf09$var$U(this.Dr) && (this.Dr = setTimeout(()=>{
                this.Dr = void 0, this.$r();
            }, t)) : this.$r();
        }
    }
    flush() {
        $0ccba2be0b51cf09$var$U(this.Dr) || (clearTimeout(this.Dr), this.Dr = void 0, this.$r());
    }
    $r() {
        this.Tr || (this.br ? this.qr() : this.jr(this.nr, this.kr, this.props, $0ccba2be0b51cf09$var$Zs));
    }
    qr() {
        var { main: t, groups: e } = this.Br();
        for (var i of (this.jr(this.nr, this.kr, t, $0ccba2be0b51cf09$var$Zs), $0ccba2be0b51cf09$var$Rs)){
            var r, s = e[i];
            (!$0ccba2be0b51cf09$var$L(s) || null != (r = this.mr[i]) && r.persisted) && this.jr($0ccba2be0b51cf09$var$Rr, this.Er(i), s, i);
        }
    }
    Br() {
        var t = {}, e = {};
        for (var i of $0ccba2be0b51cf09$var$Rs)e[i] = {};
        return $0ccba2be0b51cf09$var$ar(this.props, (i, r)=>{
            var s, n = null == (s = $0ccba2be0b51cf09$var$Is(r)) ? void 0 : s.storageGroup;
            n ? e[n][r] = i : t[r] = i;
        }), {
            main: t,
            groups: e
        };
    }
    Lr(t, e) {
        if (e === $0ccba2be0b51cf09$var$Zs) return JSON.stringify(t) + "|" + this.Hr + "|" + this.Ur + "|" + this.zr;
        var i = {};
        return $0ccba2be0b51cf09$var$ar(t, (t, e)=>{
            var r;
            i[e] = null != (r = $0ccba2be0b51cf09$var$Is(e)) && r.volatile ? "__volatile__" : t;
        }), JSON.stringify(i);
    }
    jr(t, e, i, r) {
        var s = this.Pr(r);
        if (r === $0ccba2be0b51cf09$var$Zs || s.dirty || $0ccba2be0b51cf09$var$U(s.fingerprint)) {
            var n;
            try {
                if ((n = this.Lr(i, r)) === s.fingerprint) return void (s.dirty = !1);
            } catch (t) {
                n = void 0;
            }
            t.N(e, i, this.Hr, this.Ur, this.zr, this.qt.debug) ? (s.dirty = !1, r !== $0ccba2be0b51cf09$var$Zs && (s.persisted = !0), $0ccba2be0b51cf09$var$U(n) || (s.fingerprint = n)) : this.qt.debug && $0ccba2be0b51cf09$var$We.warn('failed to persist storage entry "' + e + '"; will retry on next save');
        }
    }
    remove(t) {
        var { keepGroupEntries: e = !1 } = void 0 === t ? {} : t;
        if ($0ccba2be0b51cf09$var$U(this.Dr) || (clearTimeout(this.Dr), this.Dr = void 0), this.nr.q(this.kr, !1), this.nr.q(this.kr, !0), !e && this._r) for (var i of $0ccba2be0b51cf09$var$Rs)$0ccba2be0b51cf09$var$Rr.q(this.Er(i));
        e ? delete this.mr[$0ccba2be0b51cf09$var$Zs] : this.mr = {};
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, e, i) {
        if ($0ccba2be0b51cf09$var$N(t)) {
            $0ccba2be0b51cf09$var$U(e) && (e = "None"), this.Hr = $0ccba2be0b51cf09$var$U(i) ? this.Vr : i;
            var r = !1;
            if ($0ccba2be0b51cf09$var$ar(t, (t, i)=>{
                this.props.hasOwnProperty(i) && this.props[i] !== e || (this.Fr(i, t), r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, e) {
        if ($0ccba2be0b51cf09$var$N(t)) {
            this.Hr = $0ccba2be0b51cf09$var$U(e) ? this.Vr : e;
            var i = !1;
            if ($0ccba2be0b51cf09$var$ar(t, (e, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== e && (this.Fr(r, e), i = !0);
            }), i) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (this.Nr(t), this.save());
    }
    update_campaign_params() {
        if (!this.wr) {
            var t = $0ccba2be0b51cf09$var$zs(this.qt.custom_campaign_params, this.qt.mask_personal_data_properties, this.qt.custom_personal_data_properties);
            $0ccba2be0b51cf09$var$L($0ccba2be0b51cf09$var$vr(t)) || this.register(t), this.wr = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.referrer) ? $0ccba2be0b51cf09$var$Hs(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $0ccba2be0b51cf09$var$Gs(),
            $referring_domain: null != $0ccba2be0b51cf09$var$r && $0ccba2be0b51cf09$var$r.referrer && (null == (t = $0ccba2be0b51cf09$var$Cs($0ccba2be0b51cf09$var$r.referrer)) ? void 0 : t.host) || $0ccba2be0b51cf09$var$qs
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$0ccba2be0b51cf09$var$Ui] || this.props[$0ccba2be0b51cf09$var$ji] || this.register_once({
            [$0ccba2be0b51cf09$var$zi]: $0ccba2be0b51cf09$var$Ws(this.qt.mask_personal_data_properties, this.qt.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $0ccba2be0b51cf09$var$ar([
            $0ccba2be0b51cf09$var$ji,
            $0ccba2be0b51cf09$var$Ui
        ], (e)=>{
            var i = this.props[e];
            i && $0ccba2be0b51cf09$var$ar(i, function(e, i) {
                t["$initial_" + $0ccba2be0b51cf09$var$I(i)] = e;
            });
        });
        var e, i, r = this.props[$0ccba2be0b51cf09$var$zi];
        if (r) {
            var s = (e = $0ccba2be0b51cf09$var$Ys(r), i = {}, $0ccba2be0b51cf09$var$ar(e, function(t, e) {
                i["$initial_" + $0ccba2be0b51cf09$var$I(e)] = t;
            }), i);
            $0ccba2be0b51cf09$var$lr(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $0ccba2be0b51cf09$var$ar(this.props, function(e, i) {
            i in t || (t[i] = e);
        }), t;
    }
    update_config(t, e, i) {
        this.Vr = this.Hr = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!i), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie);
        var r = t.persistence !== e.persistence || !((t, e)=>{
            if (t.length !== e.length) return !1;
            var i = [
                ...t
            ].sort(), r = [
                ...e
            ].sort();
            return i.every((t, e)=>t === r[e]);
        })(t.cookie_persisted_properties || [], e.cookie_persisted_properties || []), s = r ? this.Sr(t) : this.nr, n = this.Cr(t);
        if (r || n !== this.br) {
            var o = this.props;
            this.clear(), this.nr = s, this.br = n, this.props = o, this.save();
        }
    }
    set_disabled(t) {
        this.Tr = t, this.Tr ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ur && (this.Ur = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_secure(t) {
        t !== this.zr && (this.zr = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_event_timer(t, e) {
        var i = this.props[$0ccba2be0b51cf09$var$ti] || {};
        i[t] = e, this.Fr($0ccba2be0b51cf09$var$ti, i), this.save();
    }
    remove_event_timer(t) {
        var e = this.props[$0ccba2be0b51cf09$var$ti] || {}, i = e[t];
        return $0ccba2be0b51cf09$var$U(i) || (delete e[t], this.Fr($0ccba2be0b51cf09$var$ti, e), this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, e) {
        this.Fr(t, e), this.save();
    }
    Fr(t, e) {
        var i;
        this.props[t] = e, null != (i = $0ccba2be0b51cf09$var$Is(t)) && i.volatile || this.Wr(t);
    }
    Nr(t) {
        delete this.props[t], this.Wr(t);
    }
    Wr(t) {
        var e, i = null == (e = $0ccba2be0b51cf09$var$Is(t)) ? void 0 : e.storageGroup;
        i && (this.Pr(i).dirty = !0);
    }
    Pr(t) {
        return this.mr[t] || (this.mr[t] = {});
    }
}
var $0ccba2be0b51cf09$export$352273f853caad57 = {
    Activation: "events",
    Cancellation: "cancelEvents"
}, $0ccba2be0b51cf09$export$87f1e68f1b904cbb = {
    Button: "button",
    Tab: "tab",
    Selector: "selector"
}, $0ccba2be0b51cf09$export$8c0ce98316e43193 = {
    TopLeft: "top_left",
    TopRight: "top_right",
    TopCenter: "top_center",
    MiddleLeft: "middle_left",
    MiddleRight: "middle_right",
    MiddleCenter: "middle_center",
    Left: "left",
    Center: "center",
    Right: "right",
    NextToTrigger: "next_to_trigger"
}, $0ccba2be0b51cf09$export$3693bed37a847924 = {
    Top: "top",
    Left: "left",
    Right: "right",
    Bottom: "bottom"
}, $0ccba2be0b51cf09$export$22779822dd24228f = {
    Popover: "popover",
    API: "api",
    Widget: "widget",
    ExternalSurvey: "external_survey"
}, $0ccba2be0b51cf09$export$9c2ac61661d417f8 = {
    Open: "open",
    MultipleChoice: "multiple_choice",
    SingleChoice: "single_choice",
    Rating: "rating",
    Link: "link"
}, $0ccba2be0b51cf09$export$bbed2da3bd3bb001 = {
    NextQuestion: "next_question",
    End: "end",
    ResponseBased: "response_based",
    SpecificQuestion: "specific_question"
}, $0ccba2be0b51cf09$export$407ee791fe918359 = {
    Once: "once",
    Recurring: "recurring",
    Always: "always"
}, $0ccba2be0b51cf09$export$9d7ec1793ca1658e = {
    SHOWN: "survey shown",
    DISMISSED: "survey dismissed",
    SENT: "survey sent",
    ABANDONED: "survey abandoned"
}, $0ccba2be0b51cf09$export$fe4c9af525341543 = {
    SURVEY_ID: "$survey_id",
    SURVEY_NAME: "$survey_name",
    SURVEY_RESPONSE: "$survey_response",
    SURVEY_ITERATION: "$survey_iteration",
    SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date",
    SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed",
    SURVEY_SUBMISSION_ID: "$survey_submission_id",
    SURVEY_QUESTIONS: "$survey_questions",
    SURVEY_COMPLETED: "$survey_completed",
    PRODUCT_TOUR_ID: "$product_tour_id",
    SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date",
    SURVEY_LANGUAGE: "$survey_language"
}, $0ccba2be0b51cf09$export$a8a66d9d1b857494 = {
    Popover: "popover",
    Inline: "inline"
}, $0ccba2be0b51cf09$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $0ccba2be0b51cf09$export$e5d0052c1e47bfda = {
    SHOWN: "product tour shown",
    DISMISSED: "product tour dismissed",
    COMPLETED: "product tour completed",
    STEP_SHOWN: "product tour step shown",
    STEP_COMPLETED: "product tour step completed",
    BUTTON_CLICKED: "product tour button clicked",
    STEP_SELECTOR_FAILED: "product tour step selector failed",
    BANNER_CONTAINER_SELECTOR_FAILED: "product tour banner container selector failed",
    BANNER_ACTION_CLICKED: "product tour banner action clicked"
}, $0ccba2be0b51cf09$export$eedf6d13bc23d767 = {
    TOUR_ID: "$product_tour_id",
    TOUR_NAME: "$product_tour_name",
    TOUR_ITERATION: "$product_tour_iteration",
    TOUR_RENDER_REASON: "$product_tour_render_reason",
    TOUR_STEP_ID: "$product_tour_step_id",
    TOUR_STEP_ORDER: "$product_tour_step_order",
    TOUR_STEP_TYPE: "$product_tour_step_type",
    TOUR_DISMISS_REASON: "$product_tour_dismiss_reason",
    TOUR_BUTTON_TEXT: "$product_tour_button_text",
    TOUR_BUTTON_ACTION: "$product_tour_button_action",
    TOUR_BUTTON_LINK: "$product_tour_button_link",
    TOUR_BUTTON_TOUR_ID: "$product_tour_button_tour_id",
    TOUR_STEPS_COUNT: "$product_tour_steps_count",
    TOUR_STEP_SELECTOR: "$product_tour_step_selector",
    TOUR_STEP_SELECTOR_FOUND: "$product_tour_step_selector_found",
    TOUR_STEP_ELEMENT_TAG: "$product_tour_step_element_tag",
    TOUR_STEP_ELEMENT_ID: "$product_tour_step_element_id",
    TOUR_STEP_ELEMENT_CLASSES: "$product_tour_step_element_classes",
    TOUR_STEP_ELEMENT_TEXT: "$product_tour_step_element_text",
    TOUR_ERROR: "$product_tour_error",
    TOUR_MATCHES_COUNT: "$product_tour_matches_count",
    TOUR_FAILURE_PHASE: "$product_tour_failure_phase",
    TOUR_WAITED_FOR_ELEMENT: "$product_tour_waited_for_element",
    TOUR_WAIT_DURATION_MS: "$product_tour_wait_duration_ms",
    TOUR_BANNER_SELECTOR: "$product_tour_banner_selector",
    TOUR_LINKED_SURVEY_ID: "$product_tour_linked_survey_id",
    USE_MANUAL_SELECTOR: "$use_manual_selector",
    INFERENCE_DATA_PRESENT: "$inference_data_present",
    TOUR_LAST_SEEN_DATE: "$product_tour_last_seen_date",
    TOUR_TYPE: "$product_tour_type"
}, $0ccba2be0b51cf09$var$_n = $0ccba2be0b51cf09$var$Ye("[RateLimiter]");
class $0ccba2be0b51cf09$var$gn {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var e = t.text;
            if (e && e.length) try {
                (JSON.parse(e).quota_limited || []).forEach((t)=>{
                    $0ccba2be0b51cf09$var$_n.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $0ccba2be0b51cf09$var$_n.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: e
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t) {
        var e, i, r;
        void 0 === t && (t = !1);
        var { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, o = (new Date).getTime(), a = null !== (e = null == (i = this.instance.persistence) ? void 0 : i.get_property($0ccba2be0b51cf09$var$Li)) && void 0 !== e ? e : {
            tokens: s,
            last: o
        };
        a.tokens += (o - a.last) / 1e3 * n, a.last = o, a.tokens > s && (a.tokens = s);
        var l = 1 > a.tokens;
        return l || t || (a.tokens = Math.max(0, a.tokens - 1)), !l || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + n + " events per second and " + s + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = l, null == (r = this.instance.persistence) || r.set_property($0ccba2be0b51cf09$var$Li, a), {
            isRateLimited: l,
            remainingTokens: a.tokens
        };
    }
    isServerRateLimited(t) {
        var e = this.serverLimits[t || "events"] || !1;
        return !1 !== e && (new Date).getTime() < e;
    }
}
var $0ccba2be0b51cf09$var$mn = $0ccba2be0b51cf09$var$Ye("[RemoteConfig]");
class $0ccba2be0b51cf09$var$bn {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $0ccba2be0b51cf09$var$h._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    Gr(t) {
        var e, i;
        null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && e.loadExternalDependency ? null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : t();
    }
    Zr(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback (e) {
                t(e.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $0ccba2be0b51cf09$var$mn.info("Using preloaded remote config", this.remoteConfig), this.Qr(this.remoteConfig), void this.Jr();
            if (this._instance.Kr()) return void $0ccba2be0b51cf09$var$mn.warn("Remote config is disabled. Falling back to local config.");
            this.Gr((t)=>{
                if (!t) return $0ccba2be0b51cf09$var$mn.info("No config found after loading remote JS config. Falling back to JSON."), void this.Zr((t)=>{
                    this.Qr(t), this.Jr();
                });
                this.Qr(t), this.Jr();
            });
        } catch (t) {
            $0ccba2be0b51cf09$var$mn.error("Error loading remote config", t);
        }
    }
    stop() {
        this.Yr && (clearInterval(this.Yr), this.Yr = void 0);
    }
    refresh() {
        !this._instance.Kr() && $0ccba2be0b51cf09$var$r && "hidden" !== $0ccba2be0b51cf09$var$r.visibilityState && this._instance.reloadFeatureFlags();
    }
    Jr() {
        var t;
        if (!this.Yr) {
            var e = null !== (t = this._instance.config.remote_config_refresh_interval_ms) && void 0 !== t ? t : 3e5;
            0 !== e && (this.Yr = setInterval(()=>{
                this.refresh();
            }, e));
        }
    }
    Qr(t) {
        var e;
        t || $0ccba2be0b51cf09$var$mn.error("Failed to fetch remote config from PostHog."), this._instance.Qr(null != t ? t : {}), !1 !== (null == t ? void 0 : t.hasFeatureFlags) && (this._instance.config.advanced_disable_feature_flags_on_first_load || null == (e = this._instance.featureFlags) || e.ensureFlagsLoaded());
    }
}
var $0ccba2be0b51cf09$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $0ccba2be0b51cf09$export$6a00d17b5aff0af = {
    GZipJS: "gzip-js",
    Base64: "base64"
}, $0ccba2be0b51cf09$var$xn = Uint8Array, $0ccba2be0b51cf09$var$En = Uint16Array, $0ccba2be0b51cf09$var$Sn = Uint32Array, $0ccba2be0b51cf09$var$$n = new $0ccba2be0b51cf09$var$xn([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $0ccba2be0b51cf09$var$Tn = new $0ccba2be0b51cf09$var$xn([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $0ccba2be0b51cf09$var$kn = new $0ccba2be0b51cf09$var$xn([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $0ccba2be0b51cf09$var$Rn = function(t, e) {
    for(var i = new $0ccba2be0b51cf09$var$En(31), r = 0; 31 > r; ++r)i[r] = e += 1 << t[r - 1];
    var s = new $0ccba2be0b51cf09$var$Sn(i[30]);
    for(r = 1; 30 > r; ++r)for(var n = i[r]; i[r + 1] > n; ++n)s[n] = n - i[r] << 5 | r;
    return [
        i,
        s
    ];
}, $0ccba2be0b51cf09$var$Pn = $0ccba2be0b51cf09$var$Rn($0ccba2be0b51cf09$var$$n, 2), $0ccba2be0b51cf09$var$On = $0ccba2be0b51cf09$var$Pn[1];
$0ccba2be0b51cf09$var$Pn[0][28] = 258, $0ccba2be0b51cf09$var$On[258] = 28;
for(var $0ccba2be0b51cf09$var$In = $0ccba2be0b51cf09$var$Rn($0ccba2be0b51cf09$var$Tn, 0)[1], $0ccba2be0b51cf09$var$Cn = new $0ccba2be0b51cf09$var$En(32768), $0ccba2be0b51cf09$var$An = 0; 32768 > $0ccba2be0b51cf09$var$An; ++$0ccba2be0b51cf09$var$An){
    var $0ccba2be0b51cf09$var$Fn = (43690 & $0ccba2be0b51cf09$var$An) >>> 1 | (21845 & $0ccba2be0b51cf09$var$An) << 1;
    $0ccba2be0b51cf09$var$Cn[$0ccba2be0b51cf09$var$An] = ((65280 & ($0ccba2be0b51cf09$var$Fn = (61680 & ($0ccba2be0b51cf09$var$Fn = (52428 & $0ccba2be0b51cf09$var$Fn) >>> 2 | (13107 & $0ccba2be0b51cf09$var$Fn) << 2)) >>> 4 | (3855 & $0ccba2be0b51cf09$var$Fn) << 4)) >>> 8 | (255 & $0ccba2be0b51cf09$var$Fn) << 8) >>> 1;
}
var $0ccba2be0b51cf09$var$Mn = function(t, e, i) {
    for(var r = t.length, s = 0, n = new $0ccba2be0b51cf09$var$En(e); r > s; ++s)++n[t[s] - 1];
    var o, a = new $0ccba2be0b51cf09$var$En(e);
    for(s = 0; e > s; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (i) {
        o = new $0ccba2be0b51cf09$var$En(1 << e);
        var l = 15 - e;
        for(s = 0; r > s; ++s)if (t[s]) for(var u = s << 4 | t[s], h = e - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; v >= d; ++d)o[$0ccba2be0b51cf09$var$Cn[d] >>> l] = u;
    } else for(o = new $0ccba2be0b51cf09$var$En(r), s = 0; r > s; ++s)o[s] = $0ccba2be0b51cf09$var$Cn[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $0ccba2be0b51cf09$var$Dn = new $0ccba2be0b51cf09$var$xn(288);
for($0ccba2be0b51cf09$var$An = 0; 144 > $0ccba2be0b51cf09$var$An; ++$0ccba2be0b51cf09$var$An)$0ccba2be0b51cf09$var$Dn[$0ccba2be0b51cf09$var$An] = 8;
for($0ccba2be0b51cf09$var$An = 144; 256 > $0ccba2be0b51cf09$var$An; ++$0ccba2be0b51cf09$var$An)$0ccba2be0b51cf09$var$Dn[$0ccba2be0b51cf09$var$An] = 9;
for($0ccba2be0b51cf09$var$An = 256; 280 > $0ccba2be0b51cf09$var$An; ++$0ccba2be0b51cf09$var$An)$0ccba2be0b51cf09$var$Dn[$0ccba2be0b51cf09$var$An] = 7;
for($0ccba2be0b51cf09$var$An = 280; 288 > $0ccba2be0b51cf09$var$An; ++$0ccba2be0b51cf09$var$An)$0ccba2be0b51cf09$var$Dn[$0ccba2be0b51cf09$var$An] = 8;
var $0ccba2be0b51cf09$var$Nn = new $0ccba2be0b51cf09$var$xn(32);
for($0ccba2be0b51cf09$var$An = 0; 32 > $0ccba2be0b51cf09$var$An; ++$0ccba2be0b51cf09$var$An)$0ccba2be0b51cf09$var$Nn[$0ccba2be0b51cf09$var$An] = 5;
var $0ccba2be0b51cf09$var$Ln = $0ccba2be0b51cf09$var$Mn($0ccba2be0b51cf09$var$Dn, 9, 0), $0ccba2be0b51cf09$var$Un = $0ccba2be0b51cf09$var$Mn($0ccba2be0b51cf09$var$Nn, 5, 0), $0ccba2be0b51cf09$var$jn = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $0ccba2be0b51cf09$var$zn = function(t, e, i) {
    (null == i || i > t.length) && (i = t.length);
    var r = new (t instanceof $0ccba2be0b51cf09$var$En ? $0ccba2be0b51cf09$var$En : t instanceof $0ccba2be0b51cf09$var$Sn ? $0ccba2be0b51cf09$var$Sn : $0ccba2be0b51cf09$var$xn)(i - e);
    return r.set(t.subarray(e, i)), r;
}, $0ccba2be0b51cf09$var$Bn = function(t, e, i) {
    var r = e / 8 >> 0;
    t[r] |= i <<= 7 & e, t[r + 1] |= i >>> 8;
}, $0ccba2be0b51cf09$var$Hn = function(t, e, i) {
    var r = e / 8 >> 0;
    t[r] |= i <<= 7 & e, t[r + 1] |= i >>> 8, t[r + 2] |= i >>> 16;
}, $0ccba2be0b51cf09$var$Vn = function(t, e) {
    for(var i = [], r = 0; t.length > r; ++r)t[r] && i.push({
        s: r,
        f: t[r]
    });
    var s = i.length, n = i.slice();
    if (!s) return [
        new $0ccba2be0b51cf09$var$xn(0),
        0
    ];
    if (1 == s) {
        var o = new $0ccba2be0b51cf09$var$xn(i[0].s + 1);
        return o[i[0].s] = 1, [
            o,
            1
        ];
    }
    i.sort(function(t, e) {
        return t.f - e.f;
    }), i.push({
        s: -1,
        f: 25001
    });
    var a = i[0], l = i[1], u = 0, h = 1, d = 2;
    for(i[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = i[i[d].f > i[u].f ? u++ : d++], l = i[u != h && i[d].f > i[u].f ? u++ : d++], i[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; s > r; ++r)n[r].s > v && (v = n[r].s);
    var c = new $0ccba2be0b51cf09$var$En(v + 1), p = $0ccba2be0b51cf09$var$qn(i[h - 1], c, 0);
    if (p > e) {
        r = 0;
        var f = 0, _ = p - e, g = 1 << _;
        for(n.sort(function(t, e) {
            return c[e.s] - c[t.s] || t.f - e.f;
        }); s > r; ++r){
            var m = n[r].s;
            if (e >= c[m]) break;
            f += g - (1 << p - c[m]), c[m] = e;
        }
        for(f >>>= _; f > 0;){
            var b = n[r].s;
            e > c[b] ? f -= 1 << e - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && f; --r){
            var y = n[r].s;
            c[y] == e && (--c[y], ++f);
        }
        p = e;
    }
    return [
        new $0ccba2be0b51cf09$var$xn(c),
        p
    ];
}, $0ccba2be0b51cf09$var$qn = function(t, e, i) {
    return -1 == t.s ? Math.max($0ccba2be0b51cf09$var$qn(t.l, e, i + 1), $0ccba2be0b51cf09$var$qn(t.r, e, i + 1)) : e[t.s] = i;
}, $0ccba2be0b51cf09$var$Gn = function(t) {
    for(var e = t.length; e && !t[--e];);
    for(var i = new $0ccba2be0b51cf09$var$En(++e), r = 0, s = t[0], n = 1, o = function(t) {
        i[r++] = t;
    }, a = 1; e >= a; ++a)if (t[a] == s && a != e) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        i.subarray(0, r),
        e
    ];
}, $0ccba2be0b51cf09$var$Wn = function(t, e) {
    for(var i = 0, r = 0; e.length > r; ++r)i += t[r] * e[r];
    return i;
}, $0ccba2be0b51cf09$var$Yn = function(t, e, i) {
    var r = i.length, s = $0ccba2be0b51cf09$var$jn(e + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; r > n; ++n)t[s + n + 4] = i[n];
    return 8 * (s + 4 + r);
}, $0ccba2be0b51cf09$var$Jn = function(t, e, i, r, s, n, o, a, l, u, h) {
    $0ccba2be0b51cf09$var$Bn(e, h++, i), ++s[256];
    for(var d = $0ccba2be0b51cf09$var$Vn(s, 15), v = d[0], c = d[1], p = $0ccba2be0b51cf09$var$Vn(n, 15), f = p[0], _ = p[1], g = $0ccba2be0b51cf09$var$Gn(v), m = g[0], b = g[1], y = $0ccba2be0b51cf09$var$Gn(f), w = y[0], x = y[1], E = new $0ccba2be0b51cf09$var$En(19), S = 0; m.length > S; ++S)E[31 & m[S]]++;
    for(S = 0; w.length > S; ++S)E[31 & w[S]]++;
    for(var T = $0ccba2be0b51cf09$var$Vn(E, 7), k = T[0], R = T[1], P = 19; P > 4 && !k[$0ccba2be0b51cf09$var$kn[P - 1]]; --P);
    var O, I, C, A, F = u + 5 << 3, M = $0ccba2be0b51cf09$var$Wn(s, $0ccba2be0b51cf09$var$Dn) + $0ccba2be0b51cf09$var$Wn(n, $0ccba2be0b51cf09$var$Nn) + o, D = $0ccba2be0b51cf09$var$Wn(s, v) + $0ccba2be0b51cf09$var$Wn(n, f) + o + 14 + 3 * P + $0ccba2be0b51cf09$var$Wn(E, k) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (M >= F && D >= F) return $0ccba2be0b51cf09$var$Yn(e, h, t.subarray(l, l + u));
    if ($0ccba2be0b51cf09$var$Bn(e, h, 1 + (M > D)), h += 2, M > D) {
        O = $0ccba2be0b51cf09$var$Mn(v, c, 0), I = v, C = $0ccba2be0b51cf09$var$Mn(f, _, 0), A = f;
        var N = $0ccba2be0b51cf09$var$Mn(k, R, 0);
        for($0ccba2be0b51cf09$var$Bn(e, h, b - 257), $0ccba2be0b51cf09$var$Bn(e, h + 5, x - 1), $0ccba2be0b51cf09$var$Bn(e, h + 10, P - 4), h += 14, S = 0; P > S; ++S)$0ccba2be0b51cf09$var$Bn(e, h + 3 * S, k[$0ccba2be0b51cf09$var$kn[S]]);
        h += 3 * P;
        for(var L = [
            m,
            w
        ], U = 0; 2 > U; ++U){
            var j = L[U];
            for(S = 0; j.length > S; ++S)$0ccba2be0b51cf09$var$Bn(e, h, N[z = 31 & j[S]]), h += k[z], z > 15 && ($0ccba2be0b51cf09$var$Bn(e, h, j[S] >>> 5 & 127), h += j[S] >>> 12);
        }
    } else O = $0ccba2be0b51cf09$var$Ln, I = $0ccba2be0b51cf09$var$Dn, C = $0ccba2be0b51cf09$var$Un, A = $0ccba2be0b51cf09$var$Nn;
    for(S = 0; a > S; ++S)if (r[S] > 255) {
        var z;
        $0ccba2be0b51cf09$var$Hn(e, h, O[257 + (z = r[S] >>> 18 & 31)]), h += I[z + 257], z > 7 && ($0ccba2be0b51cf09$var$Bn(e, h, r[S] >>> 23 & 31), h += $0ccba2be0b51cf09$var$$n[z]);
        var B = 31 & r[S];
        $0ccba2be0b51cf09$var$Hn(e, h, C[B]), h += A[B], B > 3 && ($0ccba2be0b51cf09$var$Hn(e, h, r[S] >>> 5 & 8191), h += $0ccba2be0b51cf09$var$Tn[B]);
    } else $0ccba2be0b51cf09$var$Hn(e, h, O[r[S]]), h += I[r[S]];
    return $0ccba2be0b51cf09$var$Hn(e, h, O[256]), h + I[256];
}, $0ccba2be0b51cf09$var$Kn = new $0ccba2be0b51cf09$var$Sn([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $0ccba2be0b51cf09$var$Xn = function() {
    for(var t = new $0ccba2be0b51cf09$var$Sn(256), e = 0; 256 > e; ++e){
        for(var i = e, r = 9; --r;)i = (1 & i && 3988292384) ^ i >>> 1;
        t[e] = i;
    }
    return t;
}(), $0ccba2be0b51cf09$var$Qn = function(t, e, i) {
    for(; i; ++e)t[e] = i, i >>>= 8;
};
function $0ccba2be0b51cf09$var$Zn(t, e) {
    void 0 === e && (e = {});
    var i = function() {
        var t = 4294967295;
        return {
            p (e) {
                for(var i = t, r = 0; e.length > r; ++r)i = $0ccba2be0b51cf09$var$Xn[255 & i ^ e[r]] ^ i >>> 8;
                t = i;
            },
            d () {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    i.p(t);
    var s, n, o, a, l, u = (a = 10 + ((s = e).filename && s.filename.length + 1 || 0), l = 8, function(t, e, i, r, s, n) {
        var o = t.length, a = new $0ccba2be0b51cf09$var$xn(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!e || 8 > o) for(var h = 0; o >= h; h += 65535){
            var d = h + 65535;
            o > d ? u = $0ccba2be0b51cf09$var$Yn(l, u, t.subarray(h, d)) : (l[h] = !0, u = $0ccba2be0b51cf09$var$Yn(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $0ccba2be0b51cf09$var$Kn[e - 1], c = v >>> 13, p = 8191 & v, f = (1 << i) - 1, _ = new $0ccba2be0b51cf09$var$En(32768), g = new $0ccba2be0b51cf09$var$En(f + 1), m = Math.ceil(i / 3), b = 2 * m, y = function(e) {
                return (t[e] ^ t[e + 1] << m ^ t[e + 2] << b) & f;
            }, w = new $0ccba2be0b51cf09$var$Sn(25e3), x = new $0ccba2be0b51cf09$var$En(288), E = new $0ccba2be0b51cf09$var$En(32), S = 0, T = 0, k = (h = 0, 0), R = 0, P = 0; o > h; ++h){
                var O = y(h), I = 32767 & h, C = g[O];
                if (_[I] = C, g[O] = I, h >= R) {
                    var A = o - h;
                    if ((S > 7e3 || k > 24576) && A > 423) {
                        u = $0ccba2be0b51cf09$var$Jn(t, l, 0, w, x, E, T, k, P, h - P, u), k = S = T = 0, P = h;
                        for(var F = 0; 286 > F; ++F)x[F] = 0;
                        for(F = 0; 30 > F; ++F)E[F] = 0;
                    }
                    var M = 2, D = 0, N = p, L = I - C & 32767;
                    if (A > 2 && O == y(h - L)) for(var U = Math.min(c, A) - 1, j = Math.min(32767, h), z = Math.min(258, A); j >= L && --N && I != C;){
                        if (t[h + M] == t[h + M - L]) {
                            for(var B = 0; z > B && t[h + B] == t[h + B - L]; ++B);
                            if (B > M) {
                                if (M = B, D = L, B > U) break;
                                var H = Math.min(L, B - 2), V = 0;
                                for(F = 0; H > F; ++F){
                                    var q = h - L + F + 32768 & 32767, G = q - _[q] + 32768 & 32767;
                                    G > V && (V = G, C = q);
                                }
                            }
                        }
                        L += (I = C) - (C = _[I]) + 32768 & 32767;
                    }
                    if (D) {
                        w[k++] = 268435456 | $0ccba2be0b51cf09$var$On[M] << 18 | $0ccba2be0b51cf09$var$In[D];
                        var W = 31 & $0ccba2be0b51cf09$var$On[M], Y = 31 & $0ccba2be0b51cf09$var$In[D];
                        T += $0ccba2be0b51cf09$var$$n[W] + $0ccba2be0b51cf09$var$Tn[Y], ++x[257 + W], ++E[Y], R = h + M, ++S;
                    } else w[k++] = t[h], ++x[t[h]];
                }
            }
            u = $0ccba2be0b51cf09$var$Jn(t, l, !0, w, x, E, T, k, P, h - P, u);
        }
        return $0ccba2be0b51cf09$var$zn(a, 0, r + $0ccba2be0b51cf09$var$jn(u) + s);
    }(n = t, null == (o = e).level ? 6 : o.level, null == o.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(n.length)))) : 12 + o.mem, a, l)), h = u.length;
    return function(t, e) {
        var i = e.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = 2 > e.level ? 4 : 9 == e.level ? 2 : 0, t[9] = 3, 0 != e.mtime && $0ccba2be0b51cf09$var$Qn(t, 4, Math.floor(new Date(e.mtime || Date.now()) / 1e3)), i) {
            t[3] = 8;
            for(var r = 0; i.length >= r; ++r)t[r + 10] = i.charCodeAt(r);
        }
    }(u, e), $0ccba2be0b51cf09$var$Qn(u, h - 8, i.d()), $0ccba2be0b51cf09$var$Qn(u, h - 4, r), u;
}
var $0ccba2be0b51cf09$var$to = !!$0ccba2be0b51cf09$var$o || !!$0ccba2be0b51cf09$var$n, $0ccba2be0b51cf09$var$eo = "text/plain", $0ccba2be0b51cf09$var$io = !1, $0ccba2be0b51cf09$var$ro = (t, e)=>{
    var [i, r] = t.split("#"), [s, n] = i.split("?");
    if (!n) return t;
    var o = n.split("&").filter((t)=>t.split("=")[0] !== e).join("&");
    return s + (o ? "?" + o : "") + (r ? "#" + r : "");
}, $0ccba2be0b51cf09$var$so = function(t, e, i) {
    var r;
    void 0 === i && (i = !0);
    var [s, n] = t.split("?"), o = $0ccba2be0b51cf09$var$f({}, e), a = null !== (r = null == n ? void 0 : n.split("&").map((t)=>{
        var e, [r, s] = t.split("="), n = i && null !== (e = o[r]) && void 0 !== e ? e : s;
        return delete o[r], r + "=" + n;
    })) && void 0 !== r ? r : [], l = function(t, e) {
        var i, r;
        void 0 === e && (e = "&");
        var s = [];
        return $0ccba2be0b51cf09$var$ar(t, function(t, e) {
            $0ccba2be0b51cf09$var$U(t) || $0ccba2be0b51cf09$var$U(e) || "undefined" === e || (i = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(e), s[s.length] = r + "=" + i);
        }), s.join(e);
    }(o);
    return l && a.push(l), s + "?" + a.join("&");
}, $0ccba2be0b51cf09$var$no = (t, e)=>JSON.stringify(t, (t, e)=>"bigint" == typeof e ? e.toString() : e, e), $0ccba2be0b51cf09$var$oo = (t)=>{
    if (t.tr) return t.tr;
    var { data: e, compression: i } = t;
    if (e) {
        if (i === $0ccba2be0b51cf09$export$6a00d17b5aff0af.GZipJS) {
            var r = $0ccba2be0b51cf09$var$Zn(function(t, e) {
                var i = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new $0ccba2be0b51cf09$var$xn(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; i > o; ++o){
                    if (s + 5 > r.length) {
                        var a = new $0ccba2be0b51cf09$var$xn(s + 8 + (i - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    128 > l ? n(l) : 2048 > l ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && 57344 > l ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return $0ccba2be0b51cf09$var$zn(r, 0, s);
            }($0ccba2be0b51cf09$var$no(e)), {
                mtime: 0
            });
            return {
                contentType: $0ccba2be0b51cf09$var$eo,
                body: r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength),
                estimatedSize: r.byteLength
            };
        }
        if (i === $0ccba2be0b51cf09$export$6a00d17b5aff0af.Base64) {
            var s = function(t) {
                return t ? btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, (t, e)=>String.fromCharCode(parseInt(e, 16)))) : t;
            }($0ccba2be0b51cf09$var$no(e)), n = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $0ccba2be0b51cf09$var$no(t)))(s);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: n,
                estimatedSize: new Blob([
                    n
                ]).size
            };
        }
        var o = $0ccba2be0b51cf09$var$no(e);
        return {
            contentType: "application/json",
            body: o,
            estimatedSize: new Blob([
                o
            ]).size
        };
    }
}, $0ccba2be0b51cf09$var$ao = (t)=>{
    var e, i, r, s = $0ccba2be0b51cf09$var$oo(t);
    return !s || (i = t.compression, r = $0ccba2be0b51cf09$var$As(t.url, "compression"), i !== $0ccba2be0b51cf09$var$m.GZipJS && r !== $0ccba2be0b51cf09$var$m.GZipJS && "gzip" !== r) || ((e = s.body) instanceof ArrayBuffer ? $0ccba2be0b51cf09$var$w(new Uint8Array(e)) : ArrayBuffer.isView(e) && $0ccba2be0b51cf09$var$w(new Uint8Array(e.buffer, e.byteOffset, e.byteLength))) ? {
        url: t.url,
        encodedBody: s
    } : ($0ccba2be0b51cf09$var$io = !0, {
        url: $0ccba2be0b51cf09$var$ro(t.url, "compression"),
        encodedBody: $0ccba2be0b51cf09$var$oo($0ccba2be0b51cf09$var$f({}, t, {
            compression: void 0,
            tr: void 0
        }))
    });
}, $0ccba2be0b51cf09$var$lo = function() {
    var t = $0ccba2be0b51cf09$var$p(function*(t) {
        var e = $0ccba2be0b51cf09$var$no(t.data), i = yield function(t, e, i) {
            return $0ccba2be0b51cf09$var$T.apply(this, arguments);
        }(e, $0ccba2be0b51cf09$var$v.DEBUG, {
            rethrow: !0
        });
        if (!i) return t;
        var r = yield i.arrayBuffer();
        return $0ccba2be0b51cf09$var$f({}, t, {
            tr: {
                contentType: $0ccba2be0b51cf09$var$eo,
                body: r,
                estimatedSize: r.byteLength
            }
        });
    });
    return function(e) {
        return t.apply(this, arguments);
    };
}(), $0ccba2be0b51cf09$var$uo = (t, e)=>$0ccba2be0b51cf09$var$so(t, {
        _: (new Date).getTime().toString(),
        ver: $0ccba2be0b51cf09$var$v.JS_SDK_VERSION,
        compression: e
    }), $0ccba2be0b51cf09$var$ho = [];
$0ccba2be0b51cf09$var$n && $0ccba2be0b51cf09$var$ho.push({
    transport: "fetch",
    method (t) {
        var e, { url: i, encodedBody: r } = $0ccba2be0b51cf09$var$ao(t), { contentType: s, body: o, estimatedSize: l } = null != r ? r : {}, u = new Headers;
        $0ccba2be0b51cf09$var$ar(t.headers, function(t, e) {
            u.append(e, t);
        }), s && u.append("Content-Type", s);
        var h = null;
        if ($0ccba2be0b51cf09$var$a) {
            var d = new $0ccba2be0b51cf09$var$a;
            h = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $0ccba2be0b51cf09$var$n(i, $0ccba2be0b51cf09$var$f({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: u,
            keepalive: "POST" === t.method && 52428.8 > (l || 0),
            body: o,
            signal: null == (e = h) ? void 0 : e.signal
        }, t.fetchOptions)).then((e)=>e.text().then((i)=>{
                var r = {
                    statusCode: e.status,
                    text: i
                };
                if (200 === e.status) try {
                    r.json = JSON.parse(i);
                } catch (t) {
                    $0ccba2be0b51cf09$var$We.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((e)=>{
            $0ccba2be0b51cf09$var$We.error(e), null == t.callback || t.callback({
                statusCode: 0,
                error: e
            });
        }).finally(()=>h ? clearTimeout(h.timeout) : null);
    }
}), $0ccba2be0b51cf09$var$o && $0ccba2be0b51cf09$var$ho.push({
    transport: "XHR",
    method (t) {
        var e = new $0ccba2be0b51cf09$var$o, { url: i, encodedBody: r } = $0ccba2be0b51cf09$var$ao(t);
        e.open(t.method || "GET", i, !0);
        var { contentType: s, body: n } = null != r ? r : {};
        $0ccba2be0b51cf09$var$ar(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), s && e.setRequestHeader("Content-Type", s), t.timeout && (e.timeout = t.timeout), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(n);
    }
}), null != $0ccba2be0b51cf09$var$i && $0ccba2be0b51cf09$var$i.sendBeacon && $0ccba2be0b51cf09$var$ho.push({
    transport: "sendBeacon",
    method (t) {
        try {
            var { url: e, encodedBody: r } = $0ccba2be0b51cf09$var$ao(t), s = $0ccba2be0b51cf09$var$so(e, {
                beacon: "1"
            }), { contentType: n, body: o } = null != r ? r : {};
            if (!o) return;
            var a = o instanceof Blob ? o : new Blob([
                o
            ], {
                type: n
            });
            $0ccba2be0b51cf09$var$i.sendBeacon(s, a);
        } catch (t) {}
    }
});
var $0ccba2be0b51cf09$var$vo = 3e3;
class $0ccba2be0b51cf09$var$co {
    constructor(t, e){
        this.Xr = !0, this.ei = [], this.ti = $0ccba2be0b51cf09$var$et((null == e ? void 0 : e.flush_interval_ms) || $0ccba2be0b51cf09$var$vo, 250, 5e3, $0ccba2be0b51cf09$var$We.createLogger("flush interval"), $0ccba2be0b51cf09$var$vo), this.ri = t;
    }
    enqueue(t) {
        this.ei.push(t), this.ii || this.ni();
    }
    unload() {
        this.si();
        var t = this.ei.length > 0 ? this.oi() : {}, e = Object.values(t);
        [
            ...e.filter((t)=>0 === t.url.indexOf("/e")),
            ...e.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.ri($0ccba2be0b51cf09$var$f({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.Xr = !1, this.ni();
    }
    ni() {
        var t = this;
        this.Xr || (this.ii = setTimeout(()=>{
            if (this.si(), this.ei.length > 0) {
                var e = this.oi(), i = function() {
                    var i = e[r], s = (new Date).getTime();
                    i.data && $0ccba2be0b51cf09$var$M(i.data) && $0ccba2be0b51cf09$var$ar(i.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.ri(i);
                };
                for(var r in e)i();
            }
        }, this.ti));
    }
    si() {
        clearTimeout(this.ii), this.ii = void 0;
    }
    oi() {
        var t = {};
        return $0ccba2be0b51cf09$var$ar(this.ei, (e)=>{
            var i, r = e, s = (r ? r.batchKey : null) || r.url;
            $0ccba2be0b51cf09$var$U(t[s]) && (t[s] = $0ccba2be0b51cf09$var$f({}, r, {
                data: []
            })), null == (i = t[s].data) || i.push(r.data);
        }), this.ei = [], t;
    }
}
var $0ccba2be0b51cf09$var$po = [
    "retriesPerformedSoFar"
];
class $0ccba2be0b51cf09$var$fo {
    constructor(e){
        this.ai = !1, this.li = 3e3, this.ei = [], this._instance = e, this.ei = [], this.ui = !0, !$0ccba2be0b51cf09$var$U($0ccba2be0b51cf09$var$t) && "onLine" in $0ccba2be0b51cf09$var$t.navigator && (this.ui = $0ccba2be0b51cf09$var$t.navigator.onLine, this.hi = ()=>{
            this.ui = !0, this.ci();
        }, this.di = ()=>{
            this.ui = !1;
        }, $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "online", this.hi), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "offline", this.di));
    }
    get length() {
        return this.ei.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: e } = t, i = $0ccba2be0b51cf09$var$_(t, $0ccba2be0b51cf09$var$po);
        $0ccba2be0b51cf09$var$q(e) && (i.url = $0ccba2be0b51cf09$var$so(i.url, {
            retry_count: e
        })), this._instance._send_request($0ccba2be0b51cf09$var$f({}, i, {
            callback: (t)=>{
                200 === t.statusCode || t.statusCode >= 400 && 500 > t.statusCode || (null != e ? e : 0) >= 10 ? null == i.callback || i.callback(t) : this.vi($0ccba2be0b51cf09$var$f({
                    retriesPerformedSoFar: e
                }, i));
            }
        }));
    }
    vi(t) {
        var e = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = e + 1;
        var i = function(t) {
            var e = 3e3 * Math.pow(2, t), i = e / 2, r = Math.min(18e5, e), s = Math.random() - .5;
            return Math.ceil(r + s * (r - i));
        }(e), r = Date.now() + i;
        this.ei.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + i;
        navigator.onLine || (s += " (Browser is offline)"), $0ccba2be0b51cf09$var$We.warn(s), this.ai || (this.ai = !0, this.fi());
    }
    fi() {
        if (this.pi && clearTimeout(this.pi), 0 === this.ei.length) return this.ai = !1, void (this.pi = void 0);
        this.pi = setTimeout(()=>{
            this.ui && this.ei.length > 0 && this.ci(), this.fi();
        }, this.li);
    }
    ci() {
        var t = Date.now(), e = [], i = this.ei.filter((i)=>t > i.retryAt || (e.push(i), !1));
        if (this.ei = e, i.length > 0) for (var { requestOptions: r } of i)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: e } of (this.pi && (clearTimeout(this.pi), this.pi = void 0), this.ai = !1, $0ccba2be0b51cf09$var$U($0ccba2be0b51cf09$var$t) || (this.hi && ($0ccba2be0b51cf09$var$t.removeEventListener("online", this.hi), this.hi = void 0), this.di && ($0ccba2be0b51cf09$var$t.removeEventListener("offline", this.di), this.di = void 0)), this.ei))try {
            this._instance._send_request($0ccba2be0b51cf09$var$f({}, e, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $0ccba2be0b51cf09$var$We.error(t);
        }
        this.ei = [];
    }
}
class $0ccba2be0b51cf09$var$_o {
    constructor(t){
        this.gi = ()=>{
            var t, e, i, r;
            this.mi || (this.mi = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.mi.lastScrollY = Math.ceil(n), this.mi.maxScrollY = Math.max(n, null !== (t = this.mi.maxScrollY) && void 0 !== t ? t : 0), this.mi.maxScrollHeight = Math.max(o, null !== (e = this.mi.maxScrollHeight) && void 0 !== e ? e : 0), this.mi.lastContentY = a, this.mi.maxContentY = Math.max(a, null !== (i = this.mi.maxContentY) && void 0 !== i ? i : 0), this.mi.maxContentHeight = Math.max(l, null !== (r = this.mi.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    get yi() {
        return this._instance.config.scroll_root_selector;
    }
    getContext() {
        return this.mi;
    }
    resetContext() {
        var t = this.mi;
        return setTimeout(this.gi, 0), t;
    }
    startMeasuringScrollPosition() {
        $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "scroll", this.gi, {
            capture: !0
        }), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "scrollend", this.gi, {
            capture: !0
        }), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "resize", this.gi);
    }
    scrollElement() {
        if (!this.yi) return null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.document.documentElement;
        var e = $0ccba2be0b51cf09$var$M(this.yi) ? this.yi : [
            this.yi
        ];
        for (var i of e){
            var r = null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.document.querySelector(i);
            if (r) return r;
        }
    }
    bi(e) {
        var i = "y" === e ? "scrollTop" : "scrollLeft";
        if (this.yi) {
            var r = this.scrollElement();
            return r && r[i] || 0;
        }
        return $0ccba2be0b51cf09$var$t ? "y" === e ? $0ccba2be0b51cf09$var$t.scrollY || $0ccba2be0b51cf09$var$t.pageYOffset || $0ccba2be0b51cf09$var$t.document.documentElement.scrollTop || 0 : $0ccba2be0b51cf09$var$t.scrollX || $0ccba2be0b51cf09$var$t.pageXOffset || $0ccba2be0b51cf09$var$t.document.documentElement.scrollLeft || 0 : 0;
    }
    scrollY() {
        return this.bi("y");
    }
    scrollX() {
        return this.bi("x");
    }
}
var $0ccba2be0b51cf09$var$go = (t)=>$0ccba2be0b51cf09$var$Ws(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $0ccba2be0b51cf09$var$mo {
    constructor(t, e, i, r){
        this.wi = (t)=>{
            var e = this.xi();
            if (!e || e.sessionId !== t) {
                var i = {
                    sessionId: t,
                    props: this.ki(this._instance)
                };
                this.Si.register({
                    [$0ccba2be0b51cf09$var$Ni]: i
                });
            }
        }, this._instance = t, this.Ci = e, this.Si = i, this.ki = r || $0ccba2be0b51cf09$var$go, this.Ci.onSessionId(this.wi);
    }
    xi() {
        return this.Si.props[$0ccba2be0b51cf09$var$Ni];
    }
    getSetOnceProps() {
        var t, e = null == (t = this.xi()) ? void 0 : t.props;
        return e ? "r" in e ? $0ccba2be0b51cf09$var$Ys(e) : {
            $referring_domain: e.referringDomain,
            $pathname: e.initialPathName,
            utm_source: e.utm_source,
            utm_campaign: e.utm_campaign,
            utm_medium: e.utm_medium,
            utm_content: e.utm_content,
            utm_term: e.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $0ccba2be0b51cf09$var$ar($0ccba2be0b51cf09$var$vr(this.getSetOnceProps()), (e, i)=>{
            "$current_url" === i && (i = "url"), t["$session_entry_" + $0ccba2be0b51cf09$var$I(i)] = e;
        }), t;
    }
}
class $0ccba2be0b51cf09$var$bo {
    constructor(){
        this.Ii = {};
    }
    on(t, e) {
        return this.Ii[t] || (this.Ii[t] = []), this.Ii[t].push(e), ()=>{
            this.Ii[t] = this.Ii[t].filter((t)=>t !== e);
        };
    }
    emit(t, e) {
        for (var i of this.Ii[t] || [])i(e);
        for (var r of this.Ii["*"] || [])r(t, e);
    }
}
var $0ccba2be0b51cf09$var$yo = $0ccba2be0b51cf09$var$Ye("[SessionId]");
class $0ccba2be0b51cf09$var$wo {
    on(t, e) {
        return this.Ti.on(t, e);
    }
    constructor(t, e, i){
        var r;
        if (this.Ei = null, this.Mi = [], this.Ri = void 0, this.Pi = !1, this.Ti = new $0ccba2be0b51cf09$var$bo, this.Oi = (t, e)=>!(!$0ccba2be0b51cf09$var$q(t) || !$0ccba2be0b51cf09$var$q(e)) && Math.abs(t - e) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if (t.config.cookieless_mode === $0ccba2be0b51cf09$var$Ki) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.qt = t.config, this.Si = t.persistence, this.Li = void 0, this.Ai = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Fi = e || $0ccba2be0b51cf09$var$xr, this.Ni = i || $0ccba2be0b51cf09$var$xr;
        var s = this.qt.persistence_name || this.qt.token;
        if (this._sessionTimeoutMs = 1e3 * $0ccba2be0b51cf09$var$et(this.qt.session_idle_timeout_seconds || 1800, 60, 36e3, $0ccba2be0b51cf09$var$yo.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Di(), this.$i = "ph_" + s + "_window_id", this.qi = "ph_" + s + "_primary_window_exists", this.ji()) {
            var n = $0ccba2be0b51cf09$var$Ar.F(this.$i), o = $0ccba2be0b51cf09$var$Ar.F(this.qi);
            n && !o ? this.Li = n : $0ccba2be0b51cf09$var$Ar.q(this.$i), $0ccba2be0b51cf09$var$Ar.N(this.qi, !0);
        }
        if (null != (r = this.qt.bootstrap) && r.sessionID) try {
            var a = ((t)=>{
                var e = this.qt.bootstrap.sessionID.replace(/-/g, "");
                if (32 !== e.length) throw new Error("Not a valid UUID");
                if ("7" !== e[12]) throw new Error("Not a UUIDv7");
                return parseInt(e.substring(0, 12), 16);
            })();
            this.Bi(this.qt.bootstrap.sessionID, (new Date).getTime(), a);
        } catch (t) {
            $0ccba2be0b51cf09$var$yo.error("Invalid sessionID in bootstrap", t);
        }
        this.Hi();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $0ccba2be0b51cf09$var$U(this.Mi) && (this.Mi = []), this.Mi.push(t), this.Ai && t(this.Ai, this.Li), ()=>{
            this.Mi = this.Mi.filter((e)=>e !== t);
        };
    }
    ji() {
        return "memory" !== this.qt.persistence && !this.Si.Tr && $0ccba2be0b51cf09$var$Ar.O();
    }
    Ui(t) {
        t !== this.Li && (this.Li = t, this.ji() && $0ccba2be0b51cf09$var$Ar.N(this.$i, t));
    }
    zi() {
        return this.Li ? this.Li : this.ji() ? $0ccba2be0b51cf09$var$Ar.F(this.$i) : null;
    }
    Vi(t) {
        var e = this.Ei;
        return !$0ccba2be0b51cf09$var$B(e) && !$0ccba2be0b51cf09$var$B(t) && 5e3 > Math.abs(t - e);
    }
    Bi(t, e, i) {
        var r = e !== this._sessionActivityTimestamp, s = !(t !== this.Ai || i !== this._sessionStartTimestamp);
        this._sessionStartTimestamp = i, this._sessionActivityTimestamp = e, this.Ai = t, s && !r || s && this.Vi(e) || (this.Ei = e, this.Si.register({
            [$0ccba2be0b51cf09$var$_i]: [
                e,
                t,
                i
            ]
        }));
    }
    Wi() {
        var t, e = null == (t = this.qt) ? void 0 : t.persistence_save_debounce_ms;
        return $0ccba2be0b51cf09$var$q(e) && e > 0;
    }
    Gi() {
        this.Wi() ? this.Si.refreshKey($0ccba2be0b51cf09$var$_i) : (this.Si.flush(), this.Si.load());
    }
    Zi() {
        var t;
        if (!$0ccba2be0b51cf09$var$B(this._sessionActivityTimestamp) && this._sessionActivityTimestamp !== this.Ei) {
            this.Gi();
            var [, e, i] = this.Qi();
            e === this.Ai && i === this._sessionStartTimestamp && (this.Ei = this._sessionActivityTimestamp, this.Si.register({
                [$0ccba2be0b51cf09$var$_i]: [
                    this._sessionActivityTimestamp,
                    null !== (t = this.Ai) && void 0 !== t ? t : null,
                    this._sessionStartTimestamp
                ]
            }), this.Si.flush());
        }
    }
    Ji() {
        var [t] = this.Qi(), e = $0ccba2be0b51cf09$var$q(t) ? t : 0, i = $0ccba2be0b51cf09$var$q(this._sessionActivityTimestamp) ? this._sessionActivityTimestamp : 0;
        return Math.max(e, i);
    }
    Ki(t) {
        return this.Gi(), this.Oi(t, this.Ji());
    }
    Qi() {
        var t = this.Si.props[$0ccba2be0b51cf09$var$_i];
        return $0ccba2be0b51cf09$var$M(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Ei = null, clearTimeout(this.Yi), this.Yi = void 0, this.Bi(null, null, null);
    }
    destroy() {
        this.Pi = !0, this.Zi(), clearTimeout(this.Yi), this.Yi = void 0, this.Ri && $0ccba2be0b51cf09$var$t && ($0ccba2be0b51cf09$var$t.removeEventListener($0ccba2be0b51cf09$var$er, this.Ri, {
            capture: !1
        }), this.Ri = void 0), this.Mi = [];
    }
    Hi() {
        this.Ri = ()=>{
            this.Zi(), this.ji() && $0ccba2be0b51cf09$var$Ar.q(this.qi);
        }, $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, $0ccba2be0b51cf09$var$er, this.Ri, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, e) {
        if (void 0 === t && (t = !1), void 0 === e && (e = null), this.qt.cookieless_mode === $0ccba2be0b51cf09$var$Ki) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var i = e || (new Date).getTime(), [, r, s] = this.Qi(), n = this.Ji(), o = this.zi(), a = $0ccba2be0b51cf09$var$q(s) && Math.abs(i - s) > 864e5, l = !1, u = !1, h = !r, d = r, v = !h && !t && this.Oi(i, n);
        v && ((v = this.Ki(i)) || $0ccba2be0b51cf09$var$yo.info("cross-tab refresh kept the session alive", {
            sessionId: r
        }), [, r, s] = this.Qi()), h || v || a ? (r = this.Fi(), o = this.Ni(), $0ccba2be0b51cf09$var$yo.info("new session ID generated", {
            sessionId: r,
            windowId: o,
            changeReason: {
                noSessionId: h,
                activityTimeout: v,
                sessionPastMaximumLength: a
            }
        }), s = i, l = !0) : (o || (o = this.Ni(), l = !0), (u = r !== d) && ($0ccba2be0b51cf09$var$yo.info("adopted cross-tab session id", {
            sessionId: r,
            windowId: o
        }), l = !0));
        var c = $0ccba2be0b51cf09$var$q(n) && t && !a ? n : i, p = $0ccba2be0b51cf09$var$q(s) ? s : (new Date).getTime();
        this.Ui(o), this.Bi(r, c, p), t || this.Di();
        var f = {
            noSessionId: h,
            activityTimeout: v,
            sessionPastMaximumLength: a,
            crossTabAdoption: u
        };
        return l && this.Mi.forEach((t)=>t(r, o, f)), {
            sessionId: r,
            windowId: o,
            sessionStartTimestamp: p,
            changeReason: l ? f : void 0,
            lastActivityTimestamp: n
        };
    }
    Di() {
        this.Pi || (clearTimeout(this.Yi), this.Yi = setTimeout(()=>{
            if (!this.Pi) {
                if (this.Ki((new Date).getTime())) {
                    var t = this.Ai;
                    this.resetSessionId(), this.Ti.emit("forcedIdleReset", {
                        idleSessionId: t
                    });
                } else this.Di();
            }
        }, 1.1 * this.sessionTimeoutMs));
    }
}
var $0ccba2be0b51cf09$var$xo = function(t, e) {
    if (!t) return !1;
    var i = t.userAgent;
    if (i && $0ccba2be0b51cf09$var$R(i, e)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$0ccba2be0b51cf09$var$R(null == t ? void 0 : t.brand, e))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $0ccba2be0b51cf09$var$Eo = function(t, e) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(e)) return !1;
    try {
        return new RegExp(e).test(t);
    } catch (t) {
        return !1;
    }
};
function $0ccba2be0b51cf09$var$So(t, e, i) {
    return $0ccba2be0b51cf09$var$no({
        distinct_id: t,
        userPropertiesToSet: e,
        userPropertiesToSetOnce: i
    });
}
var $0ccba2be0b51cf09$var$$o = {
    exact: (t, e)=>e.some((e)=>t.some((t)=>e === t)),
    is_not: (t, e)=>e.every((e)=>t.every((t)=>e !== t)),
    regex: (t, e)=>e.some((e)=>t.some((t)=>$0ccba2be0b51cf09$var$Eo(e, t))),
    not_regex: (t, e)=>e.every((e)=>t.every((t)=>!$0ccba2be0b51cf09$var$Eo(e, t))),
    icontains: (t, e)=>e.map($0ccba2be0b51cf09$var$To).some((e)=>t.map($0ccba2be0b51cf09$var$To).some((t)=>e.includes(t))),
    not_icontains: (t, e)=>e.map($0ccba2be0b51cf09$var$To).every((e)=>t.map($0ccba2be0b51cf09$var$To).every((t)=>!e.includes(t))),
    gt: (t, e)=>e.some((e)=>{
            var i = parseFloat(e);
            return !isNaN(i) && t.some((t)=>i > parseFloat(t));
        }),
    lt: (t, e)=>e.some((e)=>{
            var i = parseFloat(e);
            return !isNaN(i) && t.some((t)=>i < parseFloat(t));
        })
}, $0ccba2be0b51cf09$var$To = (t)=>t.toLowerCase();
function $0ccba2be0b51cf09$var$ko(t, e) {
    return !t || Object.entries(t).every((t)=>{
        var [i, r] = t, s = null == e ? void 0 : e[i];
        if ($0ccba2be0b51cf09$var$U(s) || $0ccba2be0b51cf09$var$B(s)) return !1;
        var n = [
            String(s)
        ], o = $0ccba2be0b51cf09$var$$o[r.operator];
        return !!o && o(r.values, n);
    });
}
var $0ccba2be0b51cf09$var$Ro = "custom", $0ccba2be0b51cf09$var$Po = "i.posthog.com", $0ccba2be0b51cf09$var$Oo = /^\/static\//;
class $0ccba2be0b51cf09$var$Io {
    constructor(t){
        this.Xi = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        var t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t, e = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return e || (e = this.apiHost.replace("." + $0ccba2be0b51cf09$var$Po, ".posthog.com")), "https://app.posthog.com" === e ? "https://us.posthog.com" : e;
    }
    get region() {
        return this.Xi[this.apiHost] || (this.Xi[this.apiHost] = /https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "us" : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "eu" : $0ccba2be0b51cf09$var$Ro), this.Xi[this.apiHost];
    }
    en(t) {
        if ($0ccba2be0b51cf09$var$Oo.test(t)) {
            var e = this.instance.config.asset_host;
            if ("string" == typeof e) return e.trim().replace(/\/$/, "") || void 0;
        }
    }
    endpointFor(t, e) {
        if (void 0 === e && (e = ""), e && (e = "/" === e[0] ? e : "/" + e), "ui" === t) return this.uiHost + e;
        if ("flags" === t) return this.flagsApiHost + e;
        if ("assets" === t) {
            var i = this.en(e);
            if (i) return "" + i + e;
        }
        if (this.region === $0ccba2be0b51cf09$var$Ro) return this.apiHost + e;
        var r = $0ccba2be0b51cf09$var$Po + e;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + r;
            case "api":
                return "https://" + this.region + "." + r;
        }
    }
}
var $0ccba2be0b51cf09$var$Co = $0ccba2be0b51cf09$var$Ye("[Surveys]"), $0ccba2be0b51cf09$var$Ao = "seenSurvey_", $0ccba2be0b51cf09$var$Fo = [
    $0ccba2be0b51cf09$export$22779822dd24228f.Popover,
    $0ccba2be0b51cf09$export$22779822dd24228f.Widget,
    $0ccba2be0b51cf09$export$22779822dd24228f.API
], $0ccba2be0b51cf09$var$Mo = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $0ccba2be0b51cf09$export$a8a66d9d1b857494.Popover
}, $0ccba2be0b51cf09$var$Do = $0ccba2be0b51cf09$var$Ye("[PostHog ExternalIntegrations]"), $0ccba2be0b51cf09$var$No = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $0ccba2be0b51cf09$var$Lo {
    constructor(t){
        this._instance = t;
    }
    ur(t, e) {
        var i;
        null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $0ccba2be0b51cf09$var$Do.error("failed to load script", t);
            e();
        });
    }
    startIfEnabledOrStop() {
        var t = this, e = function(e) {
            var i, s, n;
            !r || null != (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && null != (i = i.integrations) && i[e] || t.ur($0ccba2be0b51cf09$var$No[e], ()=>{
                var i;
                null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == (i = i.integrations) || null == (i = i[e]) || i.start(t._instance);
            }), !r && null != (s = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && null != (s = s.integrations) && s[e] && (null == (n = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[e]) || n.stop());
        };
        for (var [i, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            e(i);
        }
    }
}
var $0ccba2be0b51cf09$var$Uo, $0ccba2be0b51cf09$var$jo = {}, $0ccba2be0b51cf09$var$zo = 0, $0ccba2be0b51cf09$var$Bo = ()=>{}, $0ccba2be0b51cf09$var$Ho = 'Consent opt in/out is not valid with cookieless_mode="always" and will be ignored', $0ccba2be0b51cf09$var$Vo = "Surveys module not available", $0ccba2be0b51cf09$var$qo = "sanitize_properties is deprecated. Use before_send instead", $0ccba2be0b51cf09$var$Go = "Invalid value for property_denylist config: ", $0ccba2be0b51cf09$var$Wo = "posthog", $0ccba2be0b51cf09$var$Yo = !$0ccba2be0b51cf09$var$to && -1 === (null == $0ccba2be0b51cf09$var$u ? void 0 : $0ccba2be0b51cf09$var$u.indexOf("MSIE")) && -1 === (null == $0ccba2be0b51cf09$var$u ? void 0 : $0ccba2be0b51cf09$var$u.indexOf("Mozilla")), $0ccba2be0b51cf09$var$Jo = (e)=>{
    var i;
    return $0ccba2be0b51cf09$var$f({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        asset_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $0ccba2be0b51cf09$var$pr(null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $0ccba2be0b51cf09$var$Bo,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != e ? e : "unset",
        __preview_deferred_init_extensions: !1,
        __preview_external_dependency_versioned_paths: !1,
        __preview_cookie_wins_on_conflict: !1,
        debug: $0ccba2be0b51cf09$var$s && $0ccba2be0b51cf09$var$j(null == $0ccba2be0b51cf09$var$s ? void 0 : $0ccba2be0b51cf09$var$s.search) && -1 !== $0ccba2be0b51cf09$var$s.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disable_external_dependency_loading: !1,
        strict_script_versioning: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $0ccba2be0b51cf09$var$t || null == (i = $0ccba2be0b51cf09$var$t.location) ? void 0 : i.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_feature_flags_dedup_per_session: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error (t) {
            $0ccba2be0b51cf09$var$We.error("Bad HTTP status: " + t.statusCode + " " + t.text);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: $0ccba2be0b51cf09$var$Zi,
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $0ccba2be0b51cf09$var$vo
        },
        error_tracking: {},
        _onCapture: $0ccba2be0b51cf09$var$Bo
    }, ((t)=>({
            rageclick: t && t >= "2026-05-30" ? {
                content_ignorelist: $0ccba2be0b51cf09$var$Zr,
                ignore_text_selection: !0
            } : !t || "2025-11-30" > t || {
                content_ignorelist: !0
            },
            capture_pageview: !t || "2025-05-24" > t || "history_change",
            session_recording: t && t >= "2025-11-30" ? {
                strictMinimumDuration: !0
            } : {},
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0,
            persistence_save_debounce_ms: t && t >= "2026-05-30" ? 250 : 0,
            split_storage: !(!t || "2026-05-30" > t),
            detect_google_search_app: !(!t || "2026-05-30" > t)
        }))(e));
}, $0ccba2be0b51cf09$var$Ko = [
    [
        "process_person",
        "person_profiles"
    ],
    [
        "xhr_headers",
        "request_headers"
    ],
    [
        "cookie_name",
        "persistence_name"
    ],
    [
        "disable_cookie",
        "disable_persistence"
    ],
    [
        "__preview_disable_beacon",
        "disable_beacon"
    ],
    [
        "store_google",
        "save_campaign_params"
    ],
    [
        "verbose",
        "debug"
    ]
], $0ccba2be0b51cf09$var$Xo = (t)=>{
    var e = {};
    for (var [i, r] of $0ccba2be0b51cf09$var$Ko)$0ccba2be0b51cf09$var$U(t[i]) || (e[r] = t[i]);
    var s = $0ccba2be0b51cf09$var$lr({}, e, t), n = t.__preview_external_dependency_versioned_paths;
    return $0ccba2be0b51cf09$var$U(n) || ($0ccba2be0b51cf09$var$U(t.strict_script_versioning) && (s.strict_script_versioning = !!n), $0ccba2be0b51cf09$var$j(n) && $0ccba2be0b51cf09$var$U(t.asset_host) && (s.asset_host = n)), $0ccba2be0b51cf09$var$M(t.property_blacklist) && ($0ccba2be0b51cf09$var$U(t.property_denylist) ? s.property_denylist = t.property_blacklist : $0ccba2be0b51cf09$var$M(t.property_denylist) ? s.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $0ccba2be0b51cf09$var$We.error($0ccba2be0b51cf09$var$Go + t.property_denylist)), s;
};
class $0ccba2be0b51cf09$var$Qo {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get tn() {
        return this.__forceAllowLocalhost;
    }
    set tn(t) {
        $0ccba2be0b51cf09$var$We.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $0ccba2be0b51cf09$export$a9d6b9cbf49b8241 {
    rn(t, e) {
        if (t) {
            var i = this.nn.indexOf(t);
            -1 !== i && this.nn.splice(i, 1);
        }
        return this.nn.push(e), null == e.initialize || e.initialize(), e;
    }
    sn() {
        return this.config.cookieless_mode === $0ccba2be0b51cf09$var$Ki || this.config.cookieless_mode === $0ccba2be0b51cf09$var$Ji && this.consent.isRejected();
    }
    get decideEndpointWasHit() {
        var t, e;
        return null !== (t = null == (e = this.featureFlags) ? void 0 : e.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, e;
        return null !== (t = null == (e = this.featureFlags) ? void 0 : e.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        var t;
        this.webPerformance = new $0ccba2be0b51cf09$var$Qo, this.an = !1, this.version = $0ccba2be0b51cf09$var$v.LIB_VERSION, this.ln = new $0ccba2be0b51cf09$var$bo, this.nn = [], this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $0ccba2be0b51cf09$var$Jo(), this.SentryIntegration = $0ccba2be0b51cf09$var$Ts, this.sentryIntegration = (t)=>(function(t, e) {
                var i = $0ccba2be0b51cf09$var$$s(t, e);
                return {
                    name: $0ccba2be0b51cf09$var$Ss,
                    processEvent: (t)=>i(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.un = !1, this.hn = null, this.cn = null, this.dn = null, this.scrollManager = new $0ccba2be0b51cf09$var$_o(this), this.pageViewManager = new $0ccba2be0b51cf09$var$ks(this), this.rateLimiter = new $0ccba2be0b51cf09$var$gn(this), this.requestRouter = new $0ccba2be0b51cf09$var$Io(this), this.consent = new $0ccba2be0b51cf09$var$Fr(this), this.externalIntegrations = new $0ccba2be0b51cf09$var$Lo(this);
        var e = null !== (t = $0ccba2be0b51cf09$export$a9d6b9cbf49b8241.__defaultExtensionClasses) && void 0 !== t ? t : {};
        this.featureFlags = e.featureFlags && new e.featureFlags(this), this.toolbar = e.toolbar && new e.toolbar(this), this.surveys = e.surveys && new e.surveys(this), this.conversations = e.conversations && new e.conversations(this), this.logs = e.logs && new e.logs(this), this.experiments = e.experiments && new e.experiments(this), this.exceptions = e.exceptions && new e.exceptions(this), this.people = {
            set: (t, e, i)=>{
                var r = $0ccba2be0b51cf09$var$j(t) ? {
                    [t]: e
                } : t;
                this.setPersonProperties(r), null == i || i({});
            },
            set_once: (t, e, i)=>{
                var r = $0ccba2be0b51cf09$var$j(t) ? {
                    [t]: e
                } : t;
                this.setPersonProperties(void 0, r), null == i || i({});
            }
        }, this.on("eventCaptured", (t)=>$0ccba2be0b51cf09$var$We.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, e, i) {
        if (i && i !== $0ccba2be0b51cf09$var$Wo) {
            var r, s = null !== (r = $0ccba2be0b51cf09$var$jo[i]) && void 0 !== r ? r : new $0ccba2be0b51cf09$export$a9d6b9cbf49b8241;
            return s._init(t, e, i), $0ccba2be0b51cf09$var$jo[i] = s, $0ccba2be0b51cf09$var$jo[$0ccba2be0b51cf09$var$Wo][i] = s, s;
        }
        return this._init(t, e, i);
    }
    _init(e, i, r) {
        var s, n;
        void 0 === i && (i = {});
        var o = $0ccba2be0b51cf09$var$j(e) ? e.trim() : "";
        if (!o) return $0ccba2be0b51cf09$var$We.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, i.debug = this.vn(i.debug), this.fn = i, this.pn = [], i.person_profiles ? this.cn = i.person_profiles : i.process_person && (this.cn = i.process_person);
        var a = $0ccba2be0b51cf09$var$Jo(i.defaults), l = $0ccba2be0b51cf09$var$Xo(i), u = $0ccba2be0b51cf09$var$lr({}, a, l, {
            name: r,
            token: o
        });
        $0ccba2be0b51cf09$var$N(a.rageclick) && $0ccba2be0b51cf09$var$N(l.rageclick) && (u.rageclick = $0ccba2be0b51cf09$var$lr({}, a.rageclick, l.rageclick)), this.set_config(u), this.config.on_xhr_error && $0ccba2be0b51cf09$var$We.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = i.disable_compression ? void 0 : $0ccba2be0b51cf09$export$6a00d17b5aff0af.GZipJS;
        var h = this.gn();
        this.persistence = new $0ccba2be0b51cf09$var$tn(this.config, h), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $0ccba2be0b51cf09$var$tn($0ccba2be0b51cf09$var$f({}, this.config, {
            persistence: "sessionStorage"
        }), h, !1);
        var d = $0ccba2be0b51cf09$var$f({}, this.persistence.props), c = $0ccba2be0b51cf09$var$f({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.mn = new $0ccba2be0b51cf09$var$co((t)=>this.yn(t), this.config.request_queue_config), this.bn = new $0ccba2be0b51cf09$var$fo(this), this.__request_queue = [];
        var p = this.sn();
        if (p || (this.sessionManager = new $0ccba2be0b51cf09$var$wo(this), this.sessionPropsManager = new $0ccba2be0b51cf09$var$mo(this, this.sessionManager, this.persistence)), this.config.__preview_deferred_init_extensions ? ($0ccba2be0b51cf09$var$We.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this._n(p);
        }, 0)) : ($0ccba2be0b51cf09$var$We.info("Initializing extensions synchronously"), this._n(p)), $0ccba2be0b51cf09$var$v.DEBUG = $0ccba2be0b51cf09$var$v.DEBUG || this.config.debug, $0ccba2be0b51cf09$var$v.DEBUG && $0ccba2be0b51cf09$var$We.info("Starting in debug mode", {
            this: this,
            config: i,
            thisC: $0ccba2be0b51cf09$var$f({}, this.config),
            p: d,
            s: c
        }), !this.config.identity_distinct_id || null != (s = i.bootstrap) && s.distinctID || (i.bootstrap = $0ccba2be0b51cf09$var$f({}, i.bootstrap, {
            distinctID: this.config.identity_distinct_id,
            isIdentifiedID: !0
        })), void 0 !== (null == (n = i.bootstrap) ? void 0 : n.distinctID)) {
            var _ = i.bootstrap.distinctID, g = this.get_distinct_id(), m = this.persistence.get_property($0ccba2be0b51cf09$var$Di);
            if (i.bootstrap.isIdentifiedID && null != g && g !== _ && m === $0ccba2be0b51cf09$var$Xi) this.identify(_);
            else if (i.bootstrap.isIdentifiedID && null != g && g !== _ && m === $0ccba2be0b51cf09$var$Qi) $0ccba2be0b51cf09$var$We.warn("Bootstrap distinctID differs from an already-identified user. The existing identity is preserved. Call reset() before reinitializing if you intend to switch users.");
            else {
                var b = this.config.get_device_id($0ccba2be0b51cf09$var$xr()), y = i.bootstrap.isIdentifiedID ? b : _;
                this.persistence.set_property($0ccba2be0b51cf09$var$Di, i.bootstrap.isIdentifiedID ? $0ccba2be0b51cf09$var$Qi : $0ccba2be0b51cf09$var$Xi), this.register({
                    distinct_id: _,
                    $device_id: y
                });
            }
        }
        if (p) this.register_once({
            distinct_id: $0ccba2be0b51cf09$var$Vi,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var w = this.config.get_device_id($0ccba2be0b51cf09$var$xr());
            this.register_once({
                distinct_id: w,
                $device_id: w
            }, ""), this.persistence.set_property($0ccba2be0b51cf09$var$Di, $0ccba2be0b51cf09$var$Xi);
        }
        return $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), i.segment ? function(t, e) {
            var i = t.config.segment;
            if (!i) return e();
            !function(t, e) {
                var i = t.config.segment;
                if (!i) return e();
                var r = (i)=>{
                    var r = ()=>i.anonymousId() || $0ccba2be0b51cf09$var$xr();
                    t.config.get_device_id = r, i.id() && (t.register({
                        distinct_id: i.id(),
                        $device_id: r()
                    }), t.persistence.set_property($0ccba2be0b51cf09$var$Di, $0ccba2be0b51cf09$var$Qi)), e();
                }, s = i.user();
                "then" in s && $0ccba2be0b51cf09$var$D(s.then) ? s.then(r) : r(s);
            }(t, ()=>{
                i.register(((t)=>{
                    Promise && Promise.resolve || $0ccba2be0b51cf09$var$Es.warn("This browser does not have Promise support, and can not use the segment integration");
                    var e = (e, i)=>{
                        if (!i) return e;
                        e.event.userId || e.event.anonymousId === t.get_distinct_id() || ($0ccba2be0b51cf09$var$Es.info("No userId set, resetting PostHog"), t.reset()), e.event.userId && e.event.userId !== t.get_distinct_id() && ($0ccba2be0b51cf09$var$Es.info("UserId set, identifying with PostHog"), t.identify(e.event.userId));
                        var r = t.calculateEventProperties(i, e.event.properties);
                        return e.event.properties = Object.assign({}, r, e.event.properties), e;
                    };
                    return {
                        name: "PostHog JS",
                        type: "enrichment",
                        version: "1.0.0",
                        isLoaded: ()=>!0,
                        load: ()=>Promise.resolve(),
                        track: (t)=>e(t, t.event.event),
                        page: (t)=>e(t, $0ccba2be0b51cf09$var$ir),
                        identify: (t)=>e(t, $0ccba2be0b51cf09$var$sr),
                        screen: (t)=>e(t, "$screen")
                    };
                })(t)).then(()=>{
                    e();
                });
            });
        }(this, ()=>this.wn()) : this.wn(), $0ccba2be0b51cf09$var$D(this.config._onCapture) && this.config._onCapture !== $0ccba2be0b51cf09$var$Bo && ($0ccba2be0b51cf09$var$We.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $0ccba2be0b51cf09$var$We.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    _n(t) {
        var e, i, r, s, n, o, a, l = performance.now(), u = $0ccba2be0b51cf09$var$f({}, $0ccba2be0b51cf09$export$a9d6b9cbf49b8241.__defaultExtensionClasses, this.config.__extensionClasses), h = [];
        u.featureFlags && this.nn.push(this.featureFlags = null !== (e = this.featureFlags) && void 0 !== e ? e : new u.featureFlags(this)), u.exceptions && this.nn.push(this.exceptions = null !== (i = this.exceptions) && void 0 !== i ? i : new u.exceptions(this)), u.historyAutocapture && this.nn.push(this.historyAutocapture = new u.historyAutocapture(this)), u.tracingHeaders && this.nn.push(this.tracingHeaders = new u.tracingHeaders(this)), u.siteApps && this.nn.push(this.siteApps = new u.siteApps(this)), u.sessionRecording && !t && this.nn.push(this.sessionRecording = new u.sessionRecording(this)), this.config.disable_scroll_properties || h.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), u.autocapture && this.nn.push(this.autocapture = new u.autocapture(this)), u.surveys && this.nn.push(this.surveys = null !== (r = this.surveys) && void 0 !== r ? r : new u.surveys(this)), u.logs && this.nn.push(this.logs = null !== (s = this.logs) && void 0 !== s ? s : new u.logs(this)), u.conversations && this.nn.push(this.conversations = null !== (n = this.conversations) && void 0 !== n ? n : new u.conversations(this)), u.productTours && this.nn.push(this.productTours = new u.productTours(this)), u.heatmaps && this.nn.push(this.heatmaps = new u.heatmaps(this)), u.webVitalsAutocapture && this.nn.push(this.webVitalsAutocapture = new u.webVitalsAutocapture(this)), u.exceptionObserver && this.nn.push(this.exceptionObserver = new u.exceptionObserver(this)), u.deadClicksAutocapture && this.nn.push(this.deadClicksAutocapture = new u.deadClicksAutocapture(this, $0ccba2be0b51cf09$var$ws)), u.toolbar && this.nn.push(this.toolbar = null !== (o = this.toolbar) && void 0 !== o ? o : new u.toolbar(this)), u.experiments && this.nn.push(this.experiments = null !== (a = this.experiments) && void 0 !== a ? a : new u.experiments(this)), this.nn.forEach((t)=>{
            t.initialize && h.push(()=>{
                null == t.initialize || t.initialize();
            });
        }), h.push(()=>{
            if (this.xn) {
                var t = this.xn;
                this.xn = void 0, this.Qr(t);
            }
        }), this.kn(h, l);
    }
    kn(t, e) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions && performance.now() - e >= 30 && t.length > 0) return void setTimeout(()=>{
                this.kn(t, e);
            }, 0);
            var i = t.shift();
            if (i) try {
                i();
            } catch (t) {
                $0ccba2be0b51cf09$var$We.error("Error initializing extension:", t);
            }
        }
        var r = Math.round(performance.now() - e);
        this.register_for_session({
            [$0ccba2be0b51cf09$var$qi]: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            [$0ccba2be0b51cf09$var$Gi]: r
        }), this.config.__preview_deferred_init_extensions && $0ccba2be0b51cf09$var$We.info("PostHog extensions initialized (" + r + "ms)");
    }
    Qr(t) {
        var e;
        if (!$0ccba2be0b51cf09$var$r || !$0ccba2be0b51cf09$var$r.body) return $0ccba2be0b51cf09$var$We.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.Qr(t);
        }, 500);
        this.config.__preview_deferred_init_extensions && (this.xn = t), this.Sn = t, this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $0ccba2be0b51cf09$var$P(t.supportedCompression, $0ccba2be0b51cf09$export$6a00d17b5aff0af.GZipJS) ? $0ccba2be0b51cf09$export$6a00d17b5aff0af.GZipJS : $0ccba2be0b51cf09$var$P(t.supportedCompression, $0ccba2be0b51cf09$export$6a00d17b5aff0af.Base64) ? $0ccba2be0b51cf09$export$6a00d17b5aff0af.Base64 : void 0), null != (e = t.analytics) && e.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.cn ? this.cn : $0ccba2be0b51cf09$var$Zi
        }), this.nn.forEach((e)=>null == e.onRemoteConfig ? void 0 : e.onRemoteConfig(t));
    }
    wn() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $0ccba2be0b51cf09$var$We.critical("`loaded` function failed", t);
        }
        if (this.Cn(), this.config.internal_or_test_user_hostname && null != $0ccba2be0b51cf09$var$s && $0ccba2be0b51cf09$var$s.hostname) {
            var t = $0ccba2be0b51cf09$var$s.hostname, e = this.config.internal_or_test_user_hostname;
            ("string" == typeof e ? t === e : e.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || this.sn()) && this.In();
        }, 1), this.Tn = new $0ccba2be0b51cf09$var$bn(this), this.Tn.load();
    }
    Cn() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.mn) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $0ccba2be0b51cf09$var$or(this.__request_queue, (t)=>this.yn(t)), this.__request_queue = [], this.Cn();
    }
    _handle_unload() {
        var t, e, i, r;
        null == (t = this.surveys) || t.handlePageUnload(), this.config.request_batching ? (this.En() && this.capture($0ccba2be0b51cf09$var$rr), null == (e = this.logs) || e.flushLogs("sendBeacon"), null == (i = this.mn) || i.unload(), null == (r = this.bn) || r.unload()) : this.En() && this.capture($0ccba2be0b51cf09$var$rr, null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        this.__loaded && ($0ccba2be0b51cf09$var$Yo ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $0ccba2be0b51cf09$var$so(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $0ccba2be0b51cf09$var$f({}, this.config.request_headers, t.headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, ($0ccba2be0b51cf09$var$U(this.config.disable_beacon) ? this.config.__preview_disable_beacon : this.config.disable_beacon) && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var e, i, r, s = $0ccba2be0b51cf09$var$f({}, t);
            s.timeout = s.timeout || 6e4, s.url = $0ccba2be0b51cf09$var$uo(s.url, s.compression);
            var n = null !== (e = s.transport) && void 0 !== e ? e : "fetch", o = $0ccba2be0b51cf09$var$ho.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (i = null == (r = function(t, e) {
                for(var i = 0; t.length > i; i++)if (t[i].transport === n) return t[i];
            }(o)) ? void 0 : r.method) && void 0 !== i ? i : o[0].method;
            if (!a) throw new Error("No available transport method");
            "sendBeacon" !== n && s.data && s.compression === $0ccba2be0b51cf09$export$6a00d17b5aff0af.GZipJS && $0ccba2be0b51cf09$var$l && !$0ccba2be0b51cf09$var$io ? $0ccba2be0b51cf09$var$lo(s).then((t)=>{
                a(t);
            }).catch((e)=>{
                if ($0ccba2be0b51cf09$var$x(e)) return $0ccba2be0b51cf09$var$io = !0, void a($0ccba2be0b51cf09$var$f({}, s, {
                    compression: void 0,
                    url: $0ccba2be0b51cf09$var$uo(t.url, void 0)
                }));
                ((t)=>{
                    if (!t || "object" != typeof t) return !1;
                    var e = "name" in t ? String(t.name) : "";
                    return $0ccba2be0b51cf09$var$x(t) || e === $0ccba2be0b51cf09$var$y;
                })(e) && ($0ccba2be0b51cf09$var$io = !0), a(s);
            }) : a(s);
        })($0ccba2be0b51cf09$var$f({}, t, {
            callback: (e)=>{
                var i, r;
                this.rateLimiter.checkForLimiting(e), 400 > e.statusCode || null == (i = (r = this.config).on_request_error) || i.call(r, e), null == t.callback || t.callback(e);
            }
        }))));
    }
    yn(t) {
        this.bn ? this.bn.retriableRequest(t) : this._send_request(t);
    }
    _execute_array(t) {
        $0ccba2be0b51cf09$var$zo++;
        try {
            var e, i = [], r = [], s = [];
            $0ccba2be0b51cf09$var$or(t, (t)=>{
                if (t) {
                    if ($0ccba2be0b51cf09$var$M(e = t[0])) s.push(t);
                    else if ($0ccba2be0b51cf09$var$D(t)) try {
                        t.call(this);
                    } catch (e) {
                        $0ccba2be0b51cf09$var$We.error("Error executing queued PostHog call", t, e);
                    }
                    else $0ccba2be0b51cf09$var$M(t) && "alias" === e ? i.push(t) : $0ccba2be0b51cf09$var$M(t) && -1 !== e.indexOf("capture") && $0ccba2be0b51cf09$var$D(this[e]) ? s.push(t) : r.push(t);
                }
            });
            var n = function(t, e) {
                $0ccba2be0b51cf09$var$or(t, function(t) {
                    try {
                        if ($0ccba2be0b51cf09$var$M(t[0])) {
                            var i = e;
                            $0ccba2be0b51cf09$var$ar(t, function(t) {
                                i = i[t[0]].apply(i, t.slice(1));
                            });
                        } else e[t[0]].apply(e, t.slice(1));
                    } catch (e) {
                        $0ccba2be0b51cf09$var$We.error("Error executing queued PostHog call", t, e);
                    }
                });
            };
            n(i, this), n(r, this), n(s, this);
        } finally{
            $0ccba2be0b51cf09$var$zo--;
        }
    }
    push(t) {
        if ($0ccba2be0b51cf09$var$zo > 0 && $0ccba2be0b51cf09$var$M(t) && $0ccba2be0b51cf09$var$j(t[0])) {
            var e = $0ccba2be0b51cf09$export$a9d6b9cbf49b8241.prototype[t[0]];
            $0ccba2be0b51cf09$var$D(e) && e.apply(this, t.slice(1));
        } else this._execute_array([
            t
        ]);
    }
    capture(t, e, i) {
        var r, s, n, o, a;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.mn) {
            if (this.is_capturing()) {
                if (!$0ccba2be0b51cf09$var$U(t) && $0ccba2be0b51cf09$var$j(t)) {
                    var l = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!l || this.config.__preview_capture_bot_pageviews) {
                        var u = null != i && i.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == u || !u.isRateLimited) {
                            null != e && e.$current_url && !$0ccba2be0b51cf09$var$j(null == e ? void 0 : e.$current_url) && ($0ccba2be0b51cf09$var$We.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == e || delete e.$current_url), "$exception" !== t || null != i && i.Mn || $0ccba2be0b51cf09$var$We.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var h = new Date, d = (null == i ? void 0 : i.timestamp) || h, v = (null == i ? void 0 : i.uuid) || $0ccba2be0b51cf09$var$xr(), c = {
                                uuid: v,
                                event: t,
                                properties: this.calculateEventProperties(t, e || {}, d, v)
                            };
                            t === $0ccba2be0b51cf09$var$ir && this.config.__preview_capture_bot_pageviews && l && (c.event = "$bot_pageview", c.properties.$browser_type = "bot"), u && (c.properties.$lib_rate_limit_remaining_tokens = u.remainingTokens), (null == i ? void 0 : i.$set) && (c.$set = null == i ? void 0 : i.$set);
                            var p, _, g, m = this.Rn(null == i ? void 0 : i.$set_once, t !== $0ccba2be0b51cf09$var$nr, t === $0ccba2be0b51cf09$var$sr);
                            if (m && (c.$set_once = m), null != i && i._noTruncate || (s = this.config.properties_string_max_length, n = c, o = (t)=>$0ccba2be0b51cf09$var$j(t) ? t.slice(0, s) : t, a = new Set, c = function t(e, i) {
                                var r;
                                return e !== Object(e) ? o ? o(e) : e : a.has(e) ? void 0 : (a.add(e), $0ccba2be0b51cf09$var$M(e) ? (r = [], $0ccba2be0b51cf09$var$or(e, (e)=>{
                                    r.push(t(e));
                                })) : (r = {}, $0ccba2be0b51cf09$var$ar(e, (e, i)=>{
                                    a.has(e) || (r[i] = t(e, i));
                                })), r);
                            }(n)), c.timestamp = d, $0ccba2be0b51cf09$var$U(null == i ? void 0 : i.timestamp) || (c.properties.$event_time_override_provided = !0, c.properties.$event_time_override_system_time = h), t === $0ccba2be0b51cf09$export$9d7ec1793ca1658e.DISMISSED || t === $0ccba2be0b51cf09$export$9d7ec1793ca1658e.SENT) {
                                var b = null == e ? void 0 : e[$0ccba2be0b51cf09$export$fe4c9af525341543.SURVEY_ID], y = null == e ? void 0 : e[$0ccba2be0b51cf09$export$fe4c9af525341543.SURVEY_ITERATION];
                                ((t)=>{
                                    try {
                                        var e = ((t)=>((t, e)=>{
                                                var i = "" + $0ccba2be0b51cf09$var$Ao + e.id;
                                                return e.current_iteration && e.current_iteration > 0 && (i = "" + $0ccba2be0b51cf09$var$Ao + e.id + "_" + e.current_iteration), i;
                                            })(0, t))(t);
                                        if (localStorage.getItem(e)) return;
                                        localStorage.setItem(e, "true");
                                    } catch (t) {
                                        $0ccba2be0b51cf09$var$Co.error("Failed to persist survey seen state", t);
                                    }
                                })({
                                    id: b,
                                    current_iteration: y
                                }), c.$set = $0ccba2be0b51cf09$var$f({}, c.$set, {
                                    [(p = {
                                        id: b,
                                        current_iteration: y
                                    }, _ = t === $0ccba2be0b51cf09$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed", g = "$survey_" + _ + "/" + p.id, p.current_iteration && p.current_iteration > 0 && (g = "$survey_" + _ + "/" + p.id + "/" + p.current_iteration), g)]: !0
                                });
                            } else t === $0ccba2be0b51cf09$export$9d7ec1793ca1658e.SHOWN && (c.$set = $0ccba2be0b51cf09$var$f({}, c.$set, {
                                [$0ccba2be0b51cf09$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
                            }));
                            if (t === $0ccba2be0b51cf09$export$e5d0052c1e47bfda.SHOWN) {
                                var w = null == e ? void 0 : e[$0ccba2be0b51cf09$export$eedf6d13bc23d767.TOUR_TYPE];
                                w && (c.$set = $0ccba2be0b51cf09$var$f({}, c.$set, {
                                    [$0ccba2be0b51cf09$export$eedf6d13bc23d767.TOUR_LAST_SEEN_DATE + "/" + w]: (new Date).toISOString()
                                }));
                            }
                            var x = $0ccba2be0b51cf09$var$f({}, c.properties.$set, c.$set);
                            if ($0ccba2be0b51cf09$var$L(x) || this.setPersonPropertiesForFlags(x), !$0ccba2be0b51cf09$var$H(this.config.before_send)) {
                                var E = this.Pn(c);
                                if (!E) return;
                                c = E;
                            }
                            this.ln.emit("eventCaptured", c);
                            var S = {
                                method: "POST",
                                url: null !== (r = null == i ? void 0 : i._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: c,
                                compression: "best-available",
                                batchKey: null == i ? void 0 : i._batchKey,
                                transport: null == i ? void 0 : i.transport
                            };
                            return !this.config.request_batching || i && (null == i || !i._batchKey) || null != i && i.send_instantly ? this.yn(S) : this.mn.enqueue(S), c;
                        }
                        $0ccba2be0b51cf09$var$We.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $0ccba2be0b51cf09$var$We.error("No event name provided to posthog.capture");
            }
        } else $0ccba2be0b51cf09$var$We.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (e)=>t(e.event, e));
    }
    calculateEventProperties(e, i, n, o, a) {
        if (n = n || new Date, !this.persistence || !this.sessionPersistence) return i;
        var l = a ? void 0 : this.persistence.remove_event_timer(e), h = $0ccba2be0b51cf09$var$f({}, i);
        if (h.token = this.config.token, h.$config_defaults = this.config.defaults, this.sn() && (h.$cookieless_mode = !0), "$snapshot" === e) {
            var d = $0ccba2be0b51cf09$var$f({}, this.persistence.properties(), this.sessionPersistence.properties());
            return h.distinct_id = d.distinct_id, (!$0ccba2be0b51cf09$var$j(h.distinct_id) && !$0ccba2be0b51cf09$var$V(h.distinct_id) || $0ccba2be0b51cf09$var$z(h.distinct_id)) && $0ccba2be0b51cf09$var$We.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), h;
        }
        var c, p = function(e, i, r) {
            var n, o, a, l;
            if (!$0ccba2be0b51cf09$var$u) return {};
            var h, d, c, p, f, _, g, m, b, y = e ? [
                ...$0ccba2be0b51cf09$var$Ns,
                ...i || []
            ] : [], [w, x] = function(t) {
                for(var e = 0; $0ccba2be0b51cf09$var$le.length > e; e++){
                    var [i, r] = $0ccba2be0b51cf09$var$le[e], s = i.exec(t), n = s && ($0ccba2be0b51cf09$var$D(r) ? r(s, t) : r);
                    if (n) return n;
                }
                return [
                    "",
                    ""
                ];
            }($0ccba2be0b51cf09$var$u), E = null != (h = "undefined" != typeof navigator ? navigator : void 0) && h.brave ? {
                brave: !0
            } : {}, S = {
                detectGoogleSearchApp: r
            }, T = $0ccba2be0b51cf09$var$lr($0ccba2be0b51cf09$var$vr({
                $os: w,
                $os_version: x,
                $browser: $0ccba2be0b51cf09$var$ne($0ccba2be0b51cf09$var$u, navigator.vendor, E, S),
                $device: $0ccba2be0b51cf09$var$ue($0ccba2be0b51cf09$var$u),
                $device_type: (c = $0ccba2be0b51cf09$var$u, p = {
                    userAgentDataPlatform: null == (n = navigator) || null == (n = n.userAgentData) ? void 0 : n.platform,
                    maxTouchPoints: null == (o = navigator) ? void 0 : o.maxTouchPoints,
                    screenWidth: null == $0ccba2be0b51cf09$var$t || null == (a = $0ccba2be0b51cf09$var$t.screen) ? void 0 : a.width,
                    screenHeight: null == $0ccba2be0b51cf09$var$t || null == (l = $0ccba2be0b51cf09$var$t.screen) ? void 0 : l.height,
                    devicePixelRatio: null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.devicePixelRatio
                }, b = $0ccba2be0b51cf09$var$ue(c), b === $0ccba2be0b51cf09$var$dt || b === $0ccba2be0b51cf09$var$ht || "Kobo" === b || "Kindle Fire" === b || b === $0ccba2be0b51cf09$var$zt ? $0ccba2be0b51cf09$var$ut : b === $0ccba2be0b51cf09$var$Ot || b === $0ccba2be0b51cf09$var$Ct || b === $0ccba2be0b51cf09$var$It || b === $0ccba2be0b51cf09$var$Lt ? "Console" : b === $0ccba2be0b51cf09$var$ct ? "Wearable" : b ? $0ccba2be0b51cf09$var$ot : "Android" === (null == p ? void 0 : p.userAgentDataPlatform) && (null !== (f = null == p ? void 0 : p.maxTouchPoints) && void 0 !== f ? f : 0) > 0 ? 600 > Math.min(null !== (_ = null == p ? void 0 : p.screenWidth) && void 0 !== _ ? _ : 0, null !== (g = null == p ? void 0 : p.screenHeight) && void 0 !== g ? g : 0) / (null !== (m = null == p ? void 0 : p.devicePixelRatio) && void 0 !== m ? m : 1) ? $0ccba2be0b51cf09$var$ot : $0ccba2be0b51cf09$var$ut : "Desktop"),
                $timezone: $0ccba2be0b51cf09$var$Js(),
                $timezone_offset: $0ccba2be0b51cf09$var$Ks()
            }), {
                $current_url: $0ccba2be0b51cf09$var$Fs(null == $0ccba2be0b51cf09$var$s ? void 0 : $0ccba2be0b51cf09$var$s.href, y, $0ccba2be0b51cf09$var$Us),
                $host: null == $0ccba2be0b51cf09$var$s ? void 0 : $0ccba2be0b51cf09$var$s.host,
                $pathname: null == $0ccba2be0b51cf09$var$s ? void 0 : $0ccba2be0b51cf09$var$s.pathname,
                $raw_user_agent: $0ccba2be0b51cf09$var$u.length > 1e3 ? $0ccba2be0b51cf09$var$u.substring(0, 997) + "..." : $0ccba2be0b51cf09$var$u,
                $browser_version: $0ccba2be0b51cf09$var$ae($0ccba2be0b51cf09$var$u, navigator.vendor, E, S),
                $browser_language: $0ccba2be0b51cf09$var$Vs(),
                $browser_language_prefix: (d = $0ccba2be0b51cf09$var$Vs(), "string" == typeof d ? d.split("-")[0] : void 0),
                $screen_height: null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.screen.height,
                $screen_width: null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.screen.width,
                $viewport_height: null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.innerHeight,
                $viewport_width: null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.innerWidth,
                $lib: $0ccba2be0b51cf09$var$v.LIB_NAME,
                $lib_version: $0ccba2be0b51cf09$var$v.LIB_VERSION,
                $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
                $time: Date.now() / 1e3
            });
            return $0ccba2be0b51cf09$var$v.SDK_DIST_CHANNEL && (T.$sdk_dist_channel = $0ccba2be0b51cf09$var$v.SDK_DIST_CHANNEL), T;
        }(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties, this.config.detect_google_search_app);
        if (this.sessionManager) {
            var { sessionId: _, windowId: g } = this.sessionManager.checkAndGetSessionAndWindowId(a, n.getTime());
            h.$session_id = _, h.$window_id = g;
        }
        this.sessionPropsManager && $0ccba2be0b51cf09$var$lr(h, this.sessionPropsManager.getSessionProps());
        try {
            var m;
            this.sessionRecording && $0ccba2be0b51cf09$var$lr(h, this.sessionRecording.sdkDebugProperties), h.$sdk_debug_retry_queue_size = null == (m = this.bn) ? void 0 : m.length;
        } catch (t) {
            h.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $0ccba2be0b51cf09$var$Ro && (h.$lib_custom_api_host = this.config.api_host), c = e !== $0ccba2be0b51cf09$var$ir || a ? e !== $0ccba2be0b51cf09$var$rr || a ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(n) : this.pageViewManager.doPageView(n, o), h = $0ccba2be0b51cf09$var$lr(h, c), e === $0ccba2be0b51cf09$var$ir && $0ccba2be0b51cf09$var$r && (h.title = $0ccba2be0b51cf09$var$r.title), !$0ccba2be0b51cf09$var$U(l)) {
            var b = n.getTime() - l;
            h.$duration = parseFloat((b / 1e3).toFixed(3));
        }
        $0ccba2be0b51cf09$var$u && this.config.opt_out_useragent_filter && (h.$browser_type = this._is_bot() ? "bot" : "browser"), (h = $0ccba2be0b51cf09$var$lr({}, p, this.persistence.properties(), this.sessionPersistence.properties(), h)).$is_identified = this._isIdentified(), $0ccba2be0b51cf09$var$M(this.config.property_denylist) ? $0ccba2be0b51cf09$var$ar(this.config.property_denylist, function(t) {
            delete h[t];
        }) : $0ccba2be0b51cf09$var$We.error($0ccba2be0b51cf09$var$Go + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var y = this.config.sanitize_properties;
        y && ($0ccba2be0b51cf09$var$We.error($0ccba2be0b51cf09$var$qo), h = y(h, e));
        var w = this.On();
        return h.$process_person_profile = w, w && !a && this.Ln("_calculate_event_properties"), h;
    }
    Rn(t, e, i) {
        var r;
        if (void 0 === e && (e = !0), void 0 === i && (i = !1), !this.persistence || !this.On()) return t;
        if (this.an && !i) return t;
        var s = this.persistence.get_initial_props(), n = null == (r = this.sessionPropsManager) ? void 0 : r.getSetOnceProps(), o = $0ccba2be0b51cf09$var$lr({}, s, n || {}, t || {}), a = this.config.sanitize_properties;
        return a && ($0ccba2be0b51cf09$var$We.error($0ccba2be0b51cf09$var$qo), o = a(o, "$set_once")), e && (this.an = !0), $0ccba2be0b51cf09$var$L(o) ? void 0 : o;
    }
    register(t, e) {
        var i;
        null == (i = this.persistence) || i.register(t, e);
    }
    register_once(t, e, i) {
        var r;
        null == (r = this.persistence) || r.register_once(t, e, i);
    }
    register_for_session(t) {
        var e;
        null == (e = this.sessionPersistence) || e.register(t);
    }
    unregister(t) {
        var e;
        null == (e = this.persistence) || e.unregister(t);
    }
    unregister_for_session(t) {
        var e;
        null == (e = this.sessionPersistence) || e.unregister(t);
    }
    An(t, e) {
        this.register({
            [t]: e
        });
    }
    getFeatureFlag(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.getFeatureFlag(t, e);
    }
    getFeatureFlagPayload(t) {
        var e;
        return null == (e = this.featureFlags) ? void 0 : e.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.getFeatureFlagResult(t, e);
    }
    isFeatureEnabled(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.isFeatureEnabled(t, e);
    }
    reloadFeatureFlags() {
        var t;
        null == (t = this.featureFlags) || t.reloadFeatureFlags();
    }
    updateFlags(t, e, i) {
        var r;
        null == (r = this.featureFlags) || r.updateFlags(t, e, i);
    }
    updateEarlyAccessFeatureEnrollment(t, e, i) {
        var r;
        null == (r = this.featureFlags) || r.updateEarlyAccessFeatureEnrollment(t, e, i);
    }
    getEarlyAccessFeatures(t, e, i) {
        var r;
        return void 0 === e && (e = !1), null == (r = this.featureFlags) ? void 0 : r.getEarlyAccessFeatures(t, e, i);
    }
    on(t, e) {
        return this.ln.on(t, e);
    }
    onFeatureFlags(t) {
        return this.featureFlags ? this.featureFlags.onFeatureFlags(t) : (t([], {}, {
            errorsLoading: !0
        }), ()=>{});
    }
    onSurveysLoaded(t) {
        return this.surveys ? this.surveys.onSurveysLoaded(t) : (t([], {
            isLoaded: !1,
            error: $0ccba2be0b51cf09$var$Vo
        }), ()=>{});
    }
    onSessionId(t) {
        var e, i;
        return null !== (e = null == (i = this.sessionManager) ? void 0 : i.onSessionId(t)) && void 0 !== e ? e : ()=>{};
    }
    getSurveys(t, e) {
        void 0 === e && (e = !1), this.surveys ? this.surveys.getSurveys(t, e) : t([], {
            isLoaded: !1,
            error: $0ccba2be0b51cf09$var$Vo
        });
    }
    getActiveMatchingSurveys(t, e) {
        void 0 === e && (e = !1), this.surveys ? this.surveys.getActiveMatchingSurveys(t, e) : t([], {
            isLoaded: !1,
            error: $0ccba2be0b51cf09$var$Vo
        });
    }
    renderSurvey(t, e) {
        var i;
        null == (i = this.surveys) || i.renderSurvey(t, e);
    }
    displaySurvey(t, e) {
        var i;
        void 0 === e && (e = $0ccba2be0b51cf09$var$Mo), null == (i = this.surveys) || i.displaySurvey(t, e);
    }
    cancelPendingSurvey(t) {
        var e;
        null == (e = this.surveys) || e.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        var e, i;
        return null !== (e = null == (i = this.surveys) ? void 0 : i.canRenderSurvey(t)) && void 0 !== e ? e : {
            visible: !1,
            disabledReason: $0ccba2be0b51cf09$var$Vo
        };
    }
    canRenderSurveyAsync(t, e) {
        var i, r;
        return void 0 === e && (e = !1), null !== (i = null == (r = this.surveys) ? void 0 : r.canRenderSurveyAsync(t, e)) && void 0 !== i ? i : Promise.resolve({
            visible: !1,
            disabledReason: $0ccba2be0b51cf09$var$Vo
        });
    }
    Fn(t) {
        return !t || $0ccba2be0b51cf09$var$z(t) ? ($0ccba2be0b51cf09$var$We.critical("Unique user id has not been set in posthog.identify"), !1) : t === $0ccba2be0b51cf09$var$Vi ? ($0ccba2be0b51cf09$var$We.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.'), !1) : ![
            "distinct_id",
            "distinctid"
        ].includes(t.toLowerCase()) && ![
            "undefined",
            "null"
        ].includes(t.toLowerCase()) || ($0ccba2be0b51cf09$var$We.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'), !1);
    }
    identify(t, e, i) {
        if (!this.__loaded || !this.persistence) return $0ccba2be0b51cf09$var$We.uninitializedWarning("posthog.identify");
        if ($0ccba2be0b51cf09$var$V(t) && (t = t.toString(), $0ccba2be0b51cf09$var$We.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), this.Fn(t) && this.Ln("posthog.identify")) {
            var r = this.get_distinct_id();
            this.register({
                $user_id: t
            }), this.get_property($0ccba2be0b51cf09$var$Qe) || this.register_once({
                $had_persisted_distinct_id: !0,
                $device_id: r
            }, ""), t !== r && t !== this.get_property($0ccba2be0b51cf09$var$Ze) && (this.unregister($0ccba2be0b51cf09$var$Ze), this.register({
                distinct_id: t
            }));
            var s, n = (this.persistence.get_property($0ccba2be0b51cf09$var$Di) || $0ccba2be0b51cf09$var$Xi) === $0ccba2be0b51cf09$var$Xi;
            t !== r && n ? (this.persistence.set_property($0ccba2be0b51cf09$var$Di, $0ccba2be0b51cf09$var$Qi), this.setPersonPropertiesForFlags({
                $set: e || {},
                $set_once: i || {}
            }, !1), this.capture($0ccba2be0b51cf09$var$sr, {
                distinct_id: t,
                $anon_distinct_id: r
            }, {
                $set: e || {},
                $set_once: i || {}
            }), this.dn = $0ccba2be0b51cf09$var$So(t, e, i), null == (s = this.featureFlags) || s.setAnonymousDistinctId(r)) : (e || i) && this.setPersonProperties(e, i), t !== r && (this.reloadFeatureFlags(), this.unregister($0ccba2be0b51cf09$var$Ci));
        }
    }
    setPersonProperties(t, e) {
        if ((t || e) && this.Ln("posthog.setPersonProperties")) {
            var i = $0ccba2be0b51cf09$var$So(this.get_distinct_id(), t, e);
            this.dn !== i ? (this.setPersonPropertiesForFlags({
                $set: t || {},
                $set_once: e || {}
            }, !0), this.capture("$set", {
                $set: t || {},
                $set_once: e || {}
            }), this.dn = i) : $0ccba2be0b51cf09$var$We.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, e, i) {
        if (t && e) {
            var r = this.getGroups(), s = r[t] !== e;
            if (s && this.resetGroupPropertiesForFlags(t), this.register({
                $groups: $0ccba2be0b51cf09$var$f({}, r, {
                    [t]: e
                })
            }), s || i) {
                var n = {
                    $group_type: t,
                    $group_key: e
                };
                i && (n.$group_set = i), this.capture($0ccba2be0b51cf09$var$nr, n);
            }
            i && this.setGroupPropertiesForFlags({
                [t]: i
            }), s && !i && this.reloadFeatureFlags();
        } else $0ccba2be0b51cf09$var$We.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, e) {
        var i;
        void 0 === e && (e = !0), null == (i = this.featureFlags) || i.setPersonPropertiesForFlags(t, e);
    }
    resetPersonPropertiesForFlags(t) {
        var e;
        void 0 === t && (t = !0), null == (e = this.featureFlags) || e.resetPersonPropertiesForFlags(t);
    }
    setGroupPropertiesForFlags(t, e) {
        var i;
        void 0 === e && (e = !0), this.Ln("posthog.setGroupPropertiesForFlags") && (null == (i = this.featureFlags) || i.setGroupPropertiesForFlags(t, e));
    }
    resetGroupPropertiesForFlags(t) {
        var e;
        null == (e = this.featureFlags) || e.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var e, i, r, s, n, o, a, l;
        if ($0ccba2be0b51cf09$var$We.info("reset"), !this.__loaded) return $0ccba2be0b51cf09$var$We.uninitializedWarning("posthog.reset");
        var u, h = this.get_property($0ccba2be0b51cf09$var$Qe), d = this.get_property($0ccba2be0b51cf09$var$hi);
        if (this.consent.reset(), null == (e = this.persistence) || e.clear(), null == (i = this.sessionPersistence) || i.clear(), $0ccba2be0b51cf09$var$U(d) || null == (u = this.persistence) || u.register({
            [$0ccba2be0b51cf09$var$hi]: d
        }), null == (r = this.surveys) || r.reset(), null == (s = this.Tn) || s.stop(), null == (n = this.featureFlags) || n.reset(), null == (o = this.conversations) || o.reset(), null == (a = this.persistence) || a.set_property($0ccba2be0b51cf09$var$Di, $0ccba2be0b51cf09$var$Xi), null == (l = this.sessionManager) || l.resetSessionId(), this.dn = null, this.config.cookieless_mode === $0ccba2be0b51cf09$var$Ki) this.register_once({
            distinct_id: $0ccba2be0b51cf09$var$Vi,
            $device_id: null
        }, "");
        else {
            var v = this.config.get_device_id($0ccba2be0b51cf09$var$xr());
            this.register_once({
                distinct_id: v,
                $device_id: t ? v : h
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1), delete this.config.identity_distinct_id, delete this.config.identity_hash, this.reloadFeatureFlags();
    }
    setIdentity(t, e) {
        var i;
        this.config.identity_distinct_id = t, this.config.identity_hash = e, this.alias(t), null == (i = this.conversations) || i.Nn();
    }
    clearIdentity() {
        var t;
        delete this.config.identity_distinct_id, delete this.config.identity_hash, null == (t = this.conversations) || t.Dn();
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, e;
        return null !== (t = null == (e = this.sessionManager) ? void 0 : e.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: e, sessionStartTimestamp: i } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + e);
        if (null != t && t.withTimestamp && i) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!i) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, e) {
        return t === this.get_property($0ccba2be0b51cf09$var$Xe) ? ($0ccba2be0b51cf09$var$We.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Ln("posthog.alias") ? ($0ccba2be0b51cf09$var$U(e) && (e = this.get_distinct_id()), t !== e ? (this.An($0ccba2be0b51cf09$var$Ze, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: e
        })) : ($0ccba2be0b51cf09$var$We.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var e = $0ccba2be0b51cf09$var$f({}, this.config);
        if ($0ccba2be0b51cf09$var$N(t)) {
            var i, r, s, n, o, a, l, u, h, d, c;
            $0ccba2be0b51cf09$var$lr(this.config, $0ccba2be0b51cf09$var$Xo(t));
            var p = this.gn();
            null == (i = this.persistence) || i.update_config(this.config, e, p), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $0ccba2be0b51cf09$var$tn($0ccba2be0b51cf09$var$f({}, this.config, {
                persistence: "sessionStorage"
            }), p, !1);
            var _ = this.vn(this.config.debug);
            $0ccba2be0b51cf09$var$G(_) && (this.config.debug = _), $0ccba2be0b51cf09$var$G(this.config.debug) && (this.config.debug ? ($0ccba2be0b51cf09$var$v.DEBUG = !0, $0ccba2be0b51cf09$var$Rr.O() && $0ccba2be0b51cf09$var$Rr.N("ph_debug", !0), $0ccba2be0b51cf09$var$We.info("set_config", {
                config: t,
                oldConfig: e,
                newConfig: $0ccba2be0b51cf09$var$f({}, this.config)
            })) : ($0ccba2be0b51cf09$var$v.DEBUG = !1, $0ccba2be0b51cf09$var$Rr.O() && $0ccba2be0b51cf09$var$Rr.q("ph_debug"))), null == (r = this.exceptionObserver) || r.onConfigChange(), null == (s = this.exceptions) || s.onConfigChange(), null == (n = this.sessionRecording) || n.startIfEnabledOrStop(), null == (o = this.tracingHeaders) || o.startIfEnabledOrStop(), null == (a = this.autocapture) || a.startIfEnabled(), null == (l = this.heatmaps) || l.startIfEnabled(), null == (u = this.exceptionObserver) || u.startIfEnabledOrStop(), null == (h = this.deadClicksAutocapture) || h.startIfEnabledOrStop(), null == (d = this.surveys) || d.loadIfEnabled(), this.$n(), null == (c = this.externalIntegrations) || c.startIfEnabledOrStop();
        }
    }
    _overrideSDKInfo(t, e) {
        $0ccba2be0b51cf09$var$v.LIB_NAME = t, $0ccba2be0b51cf09$var$v.LIB_VERSION = e;
    }
    startSessionRecording(t) {
        var e, i, r, s, n, o = !0 === t, a = {
            sampling: o || !(null == t || !t.sampling),
            linked_flag: o || !(null == t || !t.linked_flag),
            url_trigger: o || !(null == t || !t.url_trigger),
            event_trigger: o || !(null == t || !t.event_trigger)
        };
        Object.values(a).some(Boolean) && (null == (e = this.sessionManager) || e.checkAndGetSessionAndWindowId(), a.sampling && (null == (i = this.sessionRecording) || i.overrideSampling()), a.linked_flag && (null == (r = this.sessionRecording) || r.overrideLinkedFlag()), a.url_trigger && (null == (s = this.sessionRecording) || s.overrideTrigger("url")), a.event_trigger && (null == (n = this.sessionRecording) || n.overrideTrigger("event")));
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, e) {
        if (this.exceptions) {
            var i = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
                handled: !0,
                syntheticException: i
            });
            return this.exceptions.sendExceptionEvent($0ccba2be0b51cf09$var$f({}, r, e));
        }
    }
    addExceptionStep(t, e) {
        var i;
        null == (i = this.exceptions) || i.addExceptionStep(t, e);
    }
    captureLog(t) {
        var e;
        null == (e = this.logs) || e.captureLog(t);
    }
    get logger() {
        var t, e;
        return null !== (t = null == (e = this.logs) ? void 0 : e.logger) && void 0 !== t ? t : $0ccba2be0b51cf09$export$a9d6b9cbf49b8241.qn;
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        var e, i;
        return null !== (e = null == (i = this.toolbar) ? void 0 : i.loadToolbar(t)) && void 0 !== e && e;
    }
    get_property(t) {
        var e;
        return null == (e = this.persistence) ? void 0 : e.props[t];
    }
    getSessionProperty(t) {
        var e;
        return null == (e = this.sessionPersistence) ? void 0 : e.props[t];
    }
    toString() {
        var t, e = null !== (t = this.config.name) && void 0 !== t ? t : $0ccba2be0b51cf09$var$Wo;
        return e !== $0ccba2be0b51cf09$var$Wo && (e = $0ccba2be0b51cf09$var$Wo + "." + e), e;
    }
    _isIdentified() {
        var t, e;
        return (null == (t = this.persistence) ? void 0 : t.get_property($0ccba2be0b51cf09$var$Di)) === $0ccba2be0b51cf09$var$Qi || (null == (e = this.sessionPersistence) ? void 0 : e.get_property($0ccba2be0b51cf09$var$Di)) === $0ccba2be0b51cf09$var$Qi;
    }
    On() {
        var t, e;
        return !("never" === this.config.person_profiles || this.config.person_profiles === $0ccba2be0b51cf09$var$Zi && !this._isIdentified() && $0ccba2be0b51cf09$var$L(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$0ccba2be0b51cf09$var$Ze]) && (null == (e = this.persistence) || null == (e = e.props) || !e[$0ccba2be0b51cf09$var$Bi]));
    }
    En() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.On() || this.Ln("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.Ln("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    Ln(t) {
        return "never" === this.config.person_profiles ? ($0ccba2be0b51cf09$var$We.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.An($0ccba2be0b51cf09$var$Bi, !0), !0);
    }
    gn() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut();
        return this.config.disable_persistence || t && !(!this.config.opt_out_persistence_by_default && this.config.cookieless_mode !== $0ccba2be0b51cf09$var$Ji);
    }
    $n() {
        var t, e, i, r, s = this.gn();
        return (null == (t = this.persistence) ? void 0 : t.Tr) !== s && (null == (i = this.persistence) || i.set_disabled(s)), (null == (e = this.sessionPersistence) ? void 0 : e.Tr) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s)), s;
    }
    opt_in_capturing(t) {
        var e;
        if (this.config.cookieless_mode !== $0ccba2be0b51cf09$var$Ki) {
            if (this.sn()) {
                var i, r, s, n, o;
                this.reset(!0), null == (i = this.sessionManager) || i.destroy(), null == (r = this.pageViewManager) || r.destroy(), this.sessionManager = new $0ccba2be0b51cf09$var$wo(this), this.pageViewManager = new $0ccba2be0b51cf09$var$ks(this), this.persistence && (this.sessionPropsManager = new $0ccba2be0b51cf09$var$mo(this, this.sessionManager, this.persistence));
                var a, l = null !== (s = null == (n = this.config.__extensionClasses) ? void 0 : n.sessionRecording) && void 0 !== s ? s : null == (o = $0ccba2be0b51cf09$export$a9d6b9cbf49b8241.__defaultExtensionClasses) ? void 0 : o.sessionRecording;
                l && (this.sessionRecording = this.rn(this.sessionRecording, new l(this)), this.Sn && (null == (a = this.sessionRecording) || null == a.onRemoteConfig || a.onRemoteConfig(this.Sn)));
            }
            var u, h;
            this.consent.optInOut(!0), this.$n(), this.Cn(), null == (e = this.sessionRecording) || e.startIfEnabledOrStop(), this.config.cookieless_mode == $0ccba2be0b51cf09$var$Ji && (null == (u = this.surveys) || u.loadIfEnabled()), ($0ccba2be0b51cf09$var$U(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) && this.capture(null !== (h = null == t ? void 0 : t.captureEventName) && void 0 !== h ? h : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            }), this.config.capture_pageview && this.In();
        } else $0ccba2be0b51cf09$var$We.warn($0ccba2be0b51cf09$var$Ho);
    }
    opt_out_capturing() {
        var t, e, i;
        this.config.cookieless_mode !== $0ccba2be0b51cf09$var$Ki ? (this.config.cookieless_mode === $0ccba2be0b51cf09$var$Ji && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.$n(), this.config.cookieless_mode === $0ccba2be0b51cf09$var$Ji && (this.register({
            distinct_id: $0ccba2be0b51cf09$var$Vi,
            $device_id: null
        }), null == (t = this.sessionRecording) || t.stopRecording(), this.sessionRecording = void 0, null == (e = this.sessionManager) || e.destroy(), null == (i = this.pageViewManager) || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, this.config.capture_pageview && this.In(), this.Cn())) : $0ccba2be0b51cf09$var$We.warn($0ccba2be0b51cf09$var$Ho);
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return 1 === t ? "granted" : 0 === t ? "denied" : "pending";
    }
    is_capturing() {
        return this.config.cookieless_mode === $0ccba2be0b51cf09$var$Ki || (this.config.cookieless_mode === $0ccba2be0b51cf09$var$Ji ? this.consent.isRejected() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.$n();
    }
    _is_bot() {
        return $0ccba2be0b51cf09$var$i ? $0ccba2be0b51cf09$var$xo($0ccba2be0b51cf09$var$i, this.config.custom_blocked_useragents) : void 0;
    }
    In() {
        $0ccba2be0b51cf09$var$r && ("visible" === $0ccba2be0b51cf09$var$r.visibilityState ? this.un || (this.un = !0, this.capture($0ccba2be0b51cf09$var$ir, {
            title: $0ccba2be0b51cf09$var$r.title
        }, {
            send_instantly: !0
        }), this.hn && ($0ccba2be0b51cf09$var$r.removeEventListener($0ccba2be0b51cf09$var$tr, this.hn), this.hn = null)) : this.hn || (this.hn = this.In.bind(this), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, $0ccba2be0b51cf09$var$tr, this.hn)));
    }
    debug(e) {
        !1 === e ? (null == $0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    Kr() {
        var t, e, i, r, s, n, o = this.fn || {};
        return "advanced_disable_flags" in o ? !!o.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($0ccba2be0b51cf09$var$We.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (i = "advanced_disable_decide", r = $0ccba2be0b51cf09$var$We, s = (e = "advanced_disable_flags") in (t = o) && !$0ccba2be0b51cf09$var$H(t[e]), n = i in t && !$0ccba2be0b51cf09$var$H(t[i]), s ? t[e] : !!n && (r && r.warn("Config field '" + i + "' is deprecated. Please use '" + e + "' instead. The old field will be removed in a future major version."), t[i]));
    }
    Pn(t) {
        if ($0ccba2be0b51cf09$var$H(this.config.before_send)) return t;
        var e = $0ccba2be0b51cf09$var$M(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], i = t;
        for (var r of e){
            if (i = r(i), $0ccba2be0b51cf09$var$H(i)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $0ccba2be0b51cf09$var$Y(t.event) ? $0ccba2be0b51cf09$var$We.warn(s + ". This can cause unexpected behavior.") : $0ccba2be0b51cf09$var$We.info(s), null;
            }
            i.properties && !$0ccba2be0b51cf09$var$L(i.properties) || $0ccba2be0b51cf09$var$We.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return i;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.dr) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, e) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: e
        });
    }
    captureTraceMetric(t, e, i) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: e,
            $ai_metric_value: String(i)
        });
    }
    vn(t) {
        var e = $0ccba2be0b51cf09$var$G(t) && !t, i = $0ccba2be0b51cf09$var$Rr.O() && "true" === $0ccba2be0b51cf09$var$Rr.A("ph_debug");
        return !e && (!!i || t);
    }
}
$0ccba2be0b51cf09$export$a9d6b9cbf49b8241.__defaultExtensionClasses = {}, $0ccba2be0b51cf09$export$a9d6b9cbf49b8241.qn = {
    trace: $0ccba2be0b51cf09$var$Uo = ()=>{},
    debug: $0ccba2be0b51cf09$var$Uo,
    info: $0ccba2be0b51cf09$var$Uo,
    warn: $0ccba2be0b51cf09$var$Uo,
    error: $0ccba2be0b51cf09$var$Uo,
    fatal: $0ccba2be0b51cf09$var$Uo
}, function(t, e) {
    for(var i = 0; e.length > i; i++)t.prototype[e[i]] = $0ccba2be0b51cf09$var$dr(t.prototype[e[i]]);
}($0ccba2be0b51cf09$export$a9d6b9cbf49b8241, [
    "identify"
]);
class $0ccba2be0b51cf09$var$ta {
    constructor(t){
        this.disabled = !1 === t;
        var e = $0ccba2be0b51cf09$var$N(t) ? t : {};
        this.thresholdPx = e.threshold_px || 30, this.timeoutMs = e.timeout_ms || 1e3, this.clickCount = e.click_count || 3, this.clicks = [];
    }
    isRageClick(t, e, i) {
        if (this.disabled) return !1;
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(e - r.y) < this.thresholdPx && this.timeoutMs > i - r.timestamp) {
            if (this.clicks.push({
                x: t,
                y: e,
                timestamp: i
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: e,
                timestamp: i
            }
        ];
        return !1;
    }
}
var $0ccba2be0b51cf09$var$ea = "$copy_autocapture", $0ccba2be0b51cf09$var$ia = $0ccba2be0b51cf09$var$Ye("[AutoCapture]");
function $0ccba2be0b51cf09$var$ra(t, e) {
    return e.length > t ? e.slice(0, t) + "..." : e;
}
function $0ccba2be0b51cf09$var$sa(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var e = t;
    do e = e.previousSibling;
    while (e && !$0ccba2be0b51cf09$var$Ur(e));
    return e;
}
function $0ccba2be0b51cf09$var$na(e, i) {
    var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = i;
    if (!$0ccba2be0b51cf09$var$Ur(e)) return {
        props: {}
    };
    for(var h = [
        e
    ], d = e; d.parentNode && !$0ccba2be0b51cf09$var$jr(d, "body");)if ($0ccba2be0b51cf09$var$Br(d.parentNode)) h.push(d.parentNode.host), d = d.parentNode.host;
    else {
        if (!$0ccba2be0b51cf09$var$Ur(d.parentNode)) break;
        h.push(d.parentNode), d = d.parentNode;
    }
    var v, c, p = [], _ = {}, g = !1, m = !1;
    if ($0ccba2be0b51cf09$var$ar(h, (t)=>{
        var e = $0ccba2be0b51cf09$var$os(t);
        if ($0ccba2be0b51cf09$var$jr(t, "a")) {
            var i = t.getAttribute("href");
            g = e && !!i && $0ccba2be0b51cf09$var$ps(i) && i;
        }
        $0ccba2be0b51cf09$var$P($0ccba2be0b51cf09$var$qr(t), "ph-no-capture") && (m = !0), p.push(function(t, e, i, r) {
            var s = t.tagName.toLowerCase(), n = {
                tag_name: s
            };
            $0ccba2be0b51cf09$var$Jr.indexOf(s) > -1 && !i && (n.$el_text = "a" === s.toLowerCase() || "button" === s.toLowerCase() ? $0ccba2be0b51cf09$var$ra(1024, $0ccba2be0b51cf09$var$fs(t)) : $0ccba2be0b51cf09$var$ra(1024, $0ccba2be0b51cf09$var$Wr(t)));
            var o = $0ccba2be0b51cf09$var$qr(t);
            o.length > 0 && (n.classes = o.filter(function(t) {
                return "" !== t;
            })), $0ccba2be0b51cf09$var$ar(t.attributes, function(i) {
                var s;
                if ((!$0ccba2be0b51cf09$var$as(t) || -1 !== [
                    "name",
                    "id",
                    "class",
                    "aria-label"
                ].indexOf(i.name)) && (null == r || !r.includes(i.name)) && !e && $0ccba2be0b51cf09$var$ps(i.value) && (!$0ccba2be0b51cf09$var$j(s = i.name) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
                    var o = i.value;
                    "class" === i.name && (o = $0ccba2be0b51cf09$var$Hr(o).join(" ")), n["attr__" + i.name] = $0ccba2be0b51cf09$var$ra(1024, o);
                }
            });
            for(var a = 1, l = 1, u = t; u = $0ccba2be0b51cf09$var$sa(u);)a++, u.tagName === t.tagName && l++;
            return n.nth_child = a, n.nth_of_type = l, n;
        }(t, o, a, l));
        var r = function(t) {
            if (!$0ccba2be0b51cf09$var$os(t)) return {};
            var e = {};
            return $0ccba2be0b51cf09$var$ar(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var i = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    i && r && $0ccba2be0b51cf09$var$ps(r) && (e[i] = r);
                }
            }), e;
        }(t);
        $0ccba2be0b51cf09$var$lr(_, r);
    }), m) return {
        props: {},
        explicitNoCapture: m
    };
    if (a || (p[0].$el_text = $0ccba2be0b51cf09$var$jr(e, "a") || $0ccba2be0b51cf09$var$jr(e, "button") ? $0ccba2be0b51cf09$var$fs(e) : $0ccba2be0b51cf09$var$Wr(e)), g) {
        var b, y;
        p[0].attr__href = g;
        var w = null == (b = $0ccba2be0b51cf09$var$Cs(g)) ? void 0 : b.host, x = null == $0ccba2be0b51cf09$var$t || null == (y = $0ccba2be0b51cf09$var$t.location) ? void 0 : y.host;
        w && x && w !== x && (v = g);
    }
    return {
        props: $0ccba2be0b51cf09$var$lr({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: p
        }, {
            $elements_chain: (c = p, function(t) {
                return t.map((t)=>{
                    var e, i, r = "";
                    if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
                    var n = $0ccba2be0b51cf09$var$f({}, t.text ? {
                        text: t.text
                    } : {}, {
                        "nth-child": null !== (e = t.nth_child) && void 0 !== e ? e : 0,
                        "nth-of-type": null !== (i = t.nth_of_type) && void 0 !== i ? i : 0
                    }, t.href ? {
                        href: t.href
                    } : {}, t.attr_id ? {
                        attr_id: t.attr_id
                    } : {}, t.attributes), o = {};
                    return $0ccba2be0b51cf09$var$ur(n).sort((t, e)=>{
                        var [i] = t, [r] = e;
                        return i.localeCompare(r);
                    }).forEach((t)=>{
                        var [e, i] = t;
                        return o[$0ccba2be0b51cf09$var$gs(e.toString())] = $0ccba2be0b51cf09$var$gs(i.toString());
                    }), (r += ":") + $0ccba2be0b51cf09$var$ur(o).map((t)=>{
                        var [e, i] = t;
                        return e + '="' + i + '"';
                    }).join("");
                }).join(";");
            }(function(t) {
                return t.map((t)=>{
                    var e, i, r = {
                        text: null == (e = t.$el_text) ? void 0 : e.slice(0, 400),
                        tag_name: t.tag_name,
                        href: null == (i = t.attr__href) ? void 0 : i.slice(0, 2048),
                        attr_class: $0ccba2be0b51cf09$var$ms(t),
                        attr_id: t.attr__id,
                        nth_child: t.nth_child,
                        nth_of_type: t.nth_of_type,
                        attributes: {}
                    };
                    return $0ccba2be0b51cf09$var$ur(t).filter((t)=>{
                        var [e] = t;
                        return 0 === e.indexOf("attr__");
                    }).forEach((t)=>{
                        var [e, i] = t;
                        return r.attributes[e] = i;
                    }), r;
                });
            }(c)))
        }, null != (r = p[0]) && r.$el_text ? {
            $el_text: null == (s = p[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, _)
    };
}
var $0ccba2be0b51cf09$var$oa = $0ccba2be0b51cf09$var$Ye("[ExceptionAutocapture]"), $0ccba2be0b51cf09$var$aa = $0ccba2be0b51cf09$var$Ye("[TracingHeaders]"), $0ccba2be0b51cf09$var$la = $0ccba2be0b51cf09$var$Ye("[Web Vitals]"), $0ccba2be0b51cf09$var$ua = 9e5, $0ccba2be0b51cf09$var$ha = "disabled", $0ccba2be0b51cf09$var$da = "lazy_loading", $0ccba2be0b51cf09$var$va = "awaiting_config", $0ccba2be0b51cf09$var$ca = "missing_config";
$0ccba2be0b51cf09$var$Ye("[SessionRecording]"), $0ccba2be0b51cf09$var$Ye("[SessionRecording]");
var $0ccba2be0b51cf09$var$pa = "[SessionRecording]", $0ccba2be0b51cf09$var$fa = $0ccba2be0b51cf09$var$Ye($0ccba2be0b51cf09$var$pa), $0ccba2be0b51cf09$var$_a = $0ccba2be0b51cf09$var$Ye("[Heatmaps]");
function $0ccba2be0b51cf09$var$ga(t) {
    return $0ccba2be0b51cf09$var$N(t) && "clientX" in t && "clientY" in t && $0ccba2be0b51cf09$var$V(t.clientX) && $0ccba2be0b51cf09$var$V(t.clientY);
}
var $0ccba2be0b51cf09$var$ma = $0ccba2be0b51cf09$var$Ye("[Product Tours]"), $0ccba2be0b51cf09$var$ba = (t)=>{
    var e;
    return !t.config.disable_product_tours && !(null == (e = t.persistence) || !e.get_property($0ccba2be0b51cf09$var$li));
}, $0ccba2be0b51cf09$var$ya = [
    "$set_once",
    "$set"
], $0ccba2be0b51cf09$var$wa = $0ccba2be0b51cf09$var$Ye("[SiteApps]"), $0ccba2be0b51cf09$var$xa = "Error while initializing PostHog app with config id ";
function $0ccba2be0b51cf09$var$Ea(t, e, i) {
    if ($0ccba2be0b51cf09$var$H(t)) return !1;
    switch(i){
        case "exact":
            return t === e;
        case "contains":
            var r = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
            return new RegExp(r, "i").test(t);
        case "regex":
            try {
                return new RegExp(e).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
class $0ccba2be0b51cf09$var$Sa {
    constructor(t){
        this.jn = new $0ccba2be0b51cf09$var$bo, this.Bn = (t, e)=>this.Hn(t, e) && this.Un(t, e) && this.zn(t, e) && this.Vn(t, e), this.Hn = (t, e)=>null == e || !e.event || (null == t ? void 0 : t.event) === (null == e ? void 0 : e.event), this._instance = t, this.Wn = new Set, this.Gn = new Set;
    }
    init() {
        var t, e;
        $0ccba2be0b51cf09$var$U(null == (t = this._instance) ? void 0 : t._addCaptureHook) || null == (e = this._instance) || e._addCaptureHook((t, e)=>{
            this.on(t, e);
        });
    }
    register(t) {
        var e, i;
        if (!$0ccba2be0b51cf09$var$U(null == (e = this._instance) ? void 0 : e._addCaptureHook) && (t.forEach((t)=>{
            var e, i;
            null == (e = this.Gn) || e.add(t), null == (i = t.steps) || i.forEach((t)=>{
                var e;
                null == (e = this.Wn) || e.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (i = this._instance) && i.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var e;
                null == (e = t.steps) || e.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, e) {
        var i;
        null != e && 0 != t.length && (this.Wn.has(t) || this.Wn.has(null == e ? void 0 : e.event)) && this.Gn && (null == (i = this.Gn) ? void 0 : i.size) > 0 && this.Gn.forEach((t)=>{
            this.Zn(e, t) && this.jn.emit("actionCaptured", t.name);
        });
    }
    Qn(t) {
        this.onAction("actionCaptured", (e)=>t(e));
    }
    Zn(t, e) {
        if (null == (null == e ? void 0 : e.steps)) return !1;
        for (var i of e.steps)if (this.Bn(t, i)) return !0;
        return !1;
    }
    onAction(t, e) {
        return this.jn.on(t, e);
    }
    Un(t, e) {
        if (null != e && e.url) {
            var i, r = null == t || null == (i = t.properties) ? void 0 : i.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$0ccba2be0b51cf09$var$Ea(r, e.url, e.url_matching || "contains")) return !1;
        }
        return !0;
    }
    zn(t, e) {
        return !!this.Jn(t, e) && !!this.Kn(t, e) && !!this.Yn(t, e);
    }
    Jn(t, e) {
        var i;
        if (null == e || !e.href) return !0;
        var r = this.Xn(t);
        if (r.length > 0) return r.some((t)=>$0ccba2be0b51cf09$var$Ea(t.href, e.href, e.href_matching || "exact"));
        var s, n = (null == t || null == (i = t.properties) ? void 0 : i.$elements_chain) || "";
        return !!n && $0ccba2be0b51cf09$var$Ea((s = n.match(/(?::|")href="(.*?)"/)) ? s[1] : "", e.href, e.href_matching || "exact");
    }
    Kn(t, e) {
        var i;
        if (null == e || !e.text) return !0;
        var r = this.Xn(t);
        if (r.length > 0) return r.some((t)=>$0ccba2be0b51cf09$var$Ea(t.text, e.text, e.text_matching || "exact") || $0ccba2be0b51cf09$var$Ea(t.$el_text, e.text, e.text_matching || "exact"));
        var s, n, o, a = (null == t || null == (i = t.properties) ? void 0 : i.$elements_chain) || "";
        return !!a && (s = function(t) {
            for(var e, i = [], r = /(?::|")text="(.*?)"/g; !$0ccba2be0b51cf09$var$H(e = r.exec(t));)i.includes(e[1]) || i.push(e[1]);
            return i;
        }(a), n = e.text, o = e.text_matching || "exact", s.some((t)=>$0ccba2be0b51cf09$var$Ea(t, n, o)));
    }
    Yn(t, e) {
        var i, r;
        if (null == e || !e.selector) return !0;
        var s = null == t || null == (i = t.properties) ? void 0 : i.$element_selectors;
        if (null != s && s.includes(e.selector)) return !0;
        var n = (null == t || null == (r = t.properties) ? void 0 : r.$elements_chain) || "";
        if (e.selector_regex && n) try {
            return new RegExp(e.selector_regex).test(n);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    Xn(t) {
        var e;
        return null == (null == t || null == (e = t.properties) ? void 0 : e.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    Vn(t, e) {
        return null == e || !e.properties || 0 === e.properties.length || $0ccba2be0b51cf09$var$ko(e.properties.reduce((t, e)=>{
            var i = $0ccba2be0b51cf09$var$M(e.value) ? e.value.map(String) : null != e.value ? [
                String(e.value)
            ] : [];
            return t[e.key] = {
                values: i,
                operator: e.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}
class $0ccba2be0b51cf09$var$$a {
    constructor(t){
        this._instance = t, this.es = new Map, this.ts = new Map, this.rs = new Map;
    }
    ns(t, e) {
        return !!t && $0ccba2be0b51cf09$var$ko(t.propertyFilters, null == e ? void 0 : e.properties);
    }
    ss(t, e) {
        var i = new Map;
        return t.forEach((t)=>{
            var r;
            null == (r = t.conditions) || null == (r = r[e]) || null == (r = r.values) || r.forEach((e)=>{
                if (null != e && e.name) {
                    var r = i.get(e.name) || [];
                    r.push(t.id), i.set(e.name, r);
                }
            });
        }), i;
    }
    os(t, e, i) {
        var r = (i === $0ccba2be0b51cf09$export$352273f853caad57.Activation ? this.es : this.ts).get(t), s = [];
        return this.ls((t)=>{
            s = t.filter((t)=>null == r ? void 0 : r.includes(t.id));
        }), s.filter((r)=>{
            var s, n = null == (s = r.conditions) || null == (s = s[i]) || null == (s = s.values) ? void 0 : s.find((e)=>e.name === t);
            return this.ns(n, e);
        });
    }
    register(t) {
        var e;
        $0ccba2be0b51cf09$var$U(null == (e = this._instance) ? void 0 : e._addCaptureHook) || (this.us(t), this.hs(t));
    }
    hs(t) {
        var e = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.actions) && (null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) ? void 0 : i.length) > 0;
        });
        0 !== e.length && (null == this.cs && (this.cs = new $0ccba2be0b51cf09$var$Sa(this._instance), this.cs.init(), this.cs.Qn((t)=>{
            this.onAction(t);
        })), e.forEach((t)=>{
            var e, i, r, s, n;
            t.conditions && null != (e = t.conditions) && e.actions && null != (i = t.conditions) && null != (i = i.actions) && i.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.cs) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((e)=>{
                if (e && e.name) {
                    var i = this.rs.get(e.name);
                    i && i.push(t.id), this.rs.set(e.name, i || [
                        t.id
                    ]);
                }
            }));
        }));
    }
    us(t) {
        var e, i = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.events) && (null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) ? void 0 : i.length) > 0;
        }), r = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.cancelEvents) && (null == (i = t.conditions) || null == (i = i.cancelEvents) || null == (i = i.values) ? void 0 : i.length) > 0;
        });
        0 === i.length && 0 === r.length || (null == (e = this._instance) || e._addCaptureHook((t, e)=>{
            this.onEvent(t, e);
        }), this.es = this.ss(t, $0ccba2be0b51cf09$export$352273f853caad57.Activation), this.ts = this.ss(t, $0ccba2be0b51cf09$export$352273f853caad57.Cancellation));
    }
    onEvent(t, e) {
        var i, r = this.le(), s = this.ds(), n = this.vs(), o = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[s]) || [];
        if (n === t && e && o.length > 0) {
            var a, l;
            r.info("event matched, removing item from activated items", {
                event: t,
                eventPayload: e,
                existingActivatedItems: o
            });
            var u = (null == e || null == (a = e.properties) ? void 0 : a.$survey_id) || (null == e || null == (l = e.properties) ? void 0 : l.$product_tour_id);
            if (u) {
                var h = o.indexOf(u);
                0 > h || (o.splice(h, 1), this.fs(o));
            }
        } else {
            if (this.ts.has(t)) {
                var d = this.os(t, e, $0ccba2be0b51cf09$export$352273f853caad57.Cancellation);
                d.length > 0 && (r.info("cancel event matched, cancelling items", {
                    event: t,
                    itemsToCancel: d.map((t)=>t.id)
                }), d.forEach((t)=>{
                    var e = o.indexOf(t.id);
                    0 > e || o.splice(e, 1), this.ps(t.id);
                }), this.fs(o));
            }
            if (this.es.has(t)) {
                r.info("event name matched", {
                    event: t,
                    eventPayload: e,
                    items: this.es.get(t)
                });
                var v = this.os(t, e, $0ccba2be0b51cf09$export$352273f853caad57.Activation);
                this.fs(o.concat(v.map((t)=>t.id) || []));
            }
        }
    }
    onAction(t) {
        var e, i = this.ds(), r = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[i]) || [];
        this.rs.has(t) && this.fs(r.concat(this.rs.get(t) || []));
    }
    fs(t) {
        var e = this.le(), i = [
            ...new Set(t)
        ].filter((t)=>!this.gs(t));
        e.info("updating activated items", {
            activatedItems: i
        }), this.ys(i);
    }
    getActivatedIds() {
        var t, e = this.ds();
        return (null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[e]) || [];
    }
    getEventToItemsMap() {
        return this.es;
    }
    bs() {
        return this.cs;
    }
}
class $0ccba2be0b51cf09$var$Ta extends $0ccba2be0b51cf09$var$$a {
    constructor(t){
        super(t);
    }
    ds() {
        return $0ccba2be0b51cf09$var$Oi;
    }
    vs() {
        return $0ccba2be0b51cf09$export$9d7ec1793ca1658e.SHOWN;
    }
    ls(t) {
        var e;
        null == (e = this._instance) || e.getSurveys(t);
    }
    ps(t) {
        var e;
        null == (e = this._instance) || e.cancelPendingSurvey(t);
    }
    le() {
        return $0ccba2be0b51cf09$var$Co;
    }
    ys(t) {
        var e;
        null == (e = this._instance) || null == (e = e.persistence) || e.register({
            [$0ccba2be0b51cf09$var$Oi]: t
        });
    }
    gs() {
        return !1;
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
var $0ccba2be0b51cf09$var$ka = "SDK is not enabled or survey functionality is not yet loaded", $0ccba2be0b51cf09$var$Ra = "Disabled. Not loading surveys.", $0ccba2be0b51cf09$var$Pa = null != $0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$t.location ? $0ccba2be0b51cf09$var$Ms($0ccba2be0b51cf09$var$t.location.hash, "__posthog") || $0ccba2be0b51cf09$var$Ms(location.hash, "state") : null, $0ccba2be0b51cf09$var$Oa = "_postHogToolbarParams", $0ccba2be0b51cf09$var$Ia = $0ccba2be0b51cf09$var$Ye("[Toolbar]"), $0ccba2be0b51cf09$var$Ca = $0ccba2be0b51cf09$var$Ye("[FeatureFlags]"), $0ccba2be0b51cf09$var$Aa = $0ccba2be0b51cf09$var$Ye("[FeatureFlags]", {
    debugEnabled: !0
}), $0ccba2be0b51cf09$var$Fa = "\" failed. Feature flags didn't load in time.", $0ccba2be0b51cf09$var$Ma = (t)=>{
    for(var e = {}, i = 0; t.length > i; i++)e[t[i]] = !0;
    return e;
}, $0ccba2be0b51cf09$var$Da = (t)=>{
    var e = {};
    for (var [i, r] of $0ccba2be0b51cf09$var$ur(t || {}))r && (e[i] = r);
    return e;
}, $0ccba2be0b51cf09$var$Na = $0ccba2be0b51cf09$var$Ye("[Error tracking]"), $0ccba2be0b51cf09$var$La = "Refusing to render web experiment since the viewer is a likely bot", $0ccba2be0b51cf09$var$Ua = {
    icontains: (e, i)=>!!$0ccba2be0b51cf09$var$t && i.href.toLowerCase().indexOf(e.toLowerCase()) > -1,
    not_icontains: (e, i)=>!!$0ccba2be0b51cf09$var$t && -1 === i.href.toLowerCase().indexOf(e.toLowerCase()),
    regex: (e, i)=>!!$0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$Eo(i.href, e),
    not_regex: (e, i)=>!!$0ccba2be0b51cf09$var$t && !$0ccba2be0b51cf09$var$Eo(i.href, e),
    exact: (t, e)=>e.href === t,
    is_not: (t, e)=>e.href !== t
};
class $0ccba2be0b51cf09$var$ja {
    get qt() {
        return this._instance.config;
    }
    constructor(t){
        var e = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), e.getWebExperiments((t)=>{
                $0ccba2be0b51cf09$var$ja._s("retrieved web experiments from the server"), e.ws = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var i;
                        e.ws && ($0ccba2be0b51cf09$var$ja._s("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (i = e.ws) || i.set(t.feature_flag_key, t));
                        var r = e._instance.getFeatureFlag(t.feature_flag_key);
                        $0ccba2be0b51cf09$var$j(r) && t.variants[r] && e.xs(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $0ccba2be0b51cf09$var$ja.ks(n) && e.xs(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    initialize() {}
    onFeatureFlags(t) {
        if (this._is_bot()) $0ccba2be0b51cf09$var$ja._s($0ccba2be0b51cf09$var$La);
        else if (!this.qt.disable_web_experiments) {
            if ($0ccba2be0b51cf09$var$H(this.ws)) return this.ws = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $0ccba2be0b51cf09$var$ja._s("applying feature flags", t), t.forEach((t)=>{
                var e;
                if (this.ws && null != (e = this.ws) && e.has(t)) {
                    var i, r = this._instance.getFeatureFlag(t), s = null == (i = this.ws) ? void 0 : i.get(t);
                    r && null != s && s.variants[r] && this.xs(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $0ccba2be0b51cf09$var$ja.getWindowLocation();
        if (null != t && t.search) {
            var e = $0ccba2be0b51cf09$var$As(null == t ? void 0 : t.search, "__experiment_id"), i = $0ccba2be0b51cf09$var$As(null == t ? void 0 : t.search, "__experiment_variant");
            e && i && ($0ccba2be0b51cf09$var$ja._s("previewing web experiments " + e + " && " + i), this.getWebExperiments((t)=>{
                this.Ss(parseInt(e), i, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this.qt.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, e, i) {
        if (this.qt.disable_web_experiments && !i) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !e) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this.qt.token),
            method: "GET",
            callback: (e)=>t(200 === e.statusCode && e.json && e.json.experiments || [])
        });
    }
    Ss(t, e, i) {
        var r = i.filter((e)=>e.id === t);
        r && r.length > 0 && ($0ccba2be0b51cf09$var$ja._s("Previewing web experiment [" + r[0].name + "] with variant [" + e + "]"), this.xs(r[0].name, e, r[0].variants[e].transforms));
    }
    static ks(t) {
        return !$0ccba2be0b51cf09$var$H(t.conditions) && $0ccba2be0b51cf09$var$ja.Cs(t) && $0ccba2be0b51cf09$var$ja.Is(t);
    }
    static Cs(t) {
        var e;
        if ($0ccba2be0b51cf09$var$H(t.conditions) || $0ccba2be0b51cf09$var$H(null == (e = t.conditions) ? void 0 : e.url)) return !0;
        var i, r, s, n = $0ccba2be0b51cf09$var$ja.getWindowLocation();
        return !!n && (null == (i = t.conditions) || !i.url || $0ccba2be0b51cf09$var$Ua[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.location;
    }
    static Is(t) {
        var e;
        if ($0ccba2be0b51cf09$var$H(t.conditions) || $0ccba2be0b51cf09$var$H(null == (e = t.conditions) ? void 0 : e.utm)) return !0;
        var i = $0ccba2be0b51cf09$var$zs();
        if (i.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == i.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == i.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == i.utm_medium, p = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == i.utm_term;
            return d && c && p && v;
        }
        return !1;
    }
    static _s(t) {
        for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
        $0ccba2be0b51cf09$var$We.info("[WebExperiments] " + t, i);
    }
    xs(t, e, i) {
        this._is_bot() ? $0ccba2be0b51cf09$var$ja._s($0ccba2be0b51cf09$var$La) : "control" !== e ? i.forEach((i)=>{
            if (i.selector) {
                var r;
                $0ccba2be0b51cf09$var$ja._s("applying transform of variant " + e + " for experiment " + t + " ", i);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(i.selector);
                null == s || s.forEach((t)=>{
                    var e = t;
                    i.html && (e.innerHTML = i.html), i.css && e.setAttribute("style", i.css);
                });
            }
        }) : $0ccba2be0b51cf09$var$ja._s("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $0ccba2be0b51cf09$var$i && this._instance ? $0ccba2be0b51cf09$var$xo($0ccba2be0b51cf09$var$i, this.qt.custom_blocked_useragents) : void 0;
    }
}
var $0ccba2be0b51cf09$var$za = $0ccba2be0b51cf09$var$Ye("[Conversations]"), $0ccba2be0b51cf09$var$Ba = "Conversations not available yet.", $0ccba2be0b51cf09$var$Ha = {
    featureFlags: class {
        constructor(t){
            this.Ts = !1, this.Es = !1, this.Ms = !1, this.Rs = !1, this.Ps = !1, this.Os = !1, this.Ls = !1, this.As = !1, this._instance = t, this.featureFlagEventHandlers = [];
        }
        get qt() {
            return this._instance.config;
        }
        get Si() {
            return this._instance.persistence;
        }
        Fs(t) {
            return this._instance.get_property(t);
        }
        Ns() {
            var t, e;
            return null !== (t = null == (e = this.Si) ? void 0 : e.Mr(this.qt.feature_flag_cache_ttl_ms)) && void 0 !== t && t;
        }
        Ds() {
            return !!this.Ns() && (this.As || this.Ms || (this.As = !0, $0ccba2be0b51cf09$var$Ca.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
        }
        $s() {
            var t, e = null !== (t = this.qt.evaluation_contexts) && void 0 !== t ? t : this.qt.evaluation_environments;
            return !this.qt.evaluation_environments || this.qt.evaluation_contexts || this.Ls || ($0ccba2be0b51cf09$var$Ca.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.Ls = !0), null != e && e.length ? e.filter((t)=>{
                var e = t && "string" == typeof t && t.trim().length > 0;
                return e || $0ccba2be0b51cf09$var$Ca.error("Invalid evaluation context found:", t, "Expected non-empty string"), e;
            }) : [];
        }
        qs() {
            return this.$s().length > 0;
        }
        js() {
            var t = this.qt.flag_keys;
            if (!$0ccba2be0b51cf09$var$U(t)) {
                if ($0ccba2be0b51cf09$var$M(t)) return t.filter((t)=>{
                    var e = t && "string" == typeof t && t.trim().length > 0;
                    return e || $0ccba2be0b51cf09$var$Ca.error("Invalid flag key found:", t, "Expected non-empty string"), e;
                });
                $0ccba2be0b51cf09$var$Ca.error("Invalid flag_keys found:", t, "Expected array of non-empty strings");
            }
        }
        initialize() {
            var t, e, { config: i } = this._instance, r = null !== (t = null == (e = i.bootstrap) ? void 0 : e.featureFlags) && void 0 !== t ? t : {};
            if (Object.keys(r).length) {
                var s, n, o = null !== (s = null == (n = i.bootstrap) ? void 0 : n.featureFlagPayloads) && void 0 !== s ? s : {}, a = Object.keys(r).filter((t)=>!!r[t]).reduce((t, e)=>(t[e] = r[e] || !1, t), {}), l = Object.keys(o).filter((t)=>a[t]).reduce((t, e)=>(o[e] && (t[e] = o[e]), t), {});
                this.receivedFeatureFlags({
                    featureFlags: a,
                    featureFlagPayloads: l
                });
            }
        }
        updateFlags(t, e, i) {
            var r = null != i && i.merge ? this.getFlagVariants() : {}, s = null != i && i.merge ? this.getFlagPayloads() : {}, n = $0ccba2be0b51cf09$var$f({}, r, t), o = $0ccba2be0b51cf09$var$f({}, s, e), a = {};
            for (var [l, u] of Object.entries(n)){
                var h = "string" == typeof u;
                a[l] = {
                    key: l,
                    enabled: !!h || Boolean(u),
                    variant: h ? u : void 0,
                    reason: void 0,
                    metadata: $0ccba2be0b51cf09$var$U(null == o ? void 0 : o[l]) ? void 0 : {
                        id: 0,
                        version: void 0,
                        description: void 0,
                        payload: o[l]
                    }
                };
            }
            this.receivedFeatureFlags({
                flags: a
            });
        }
        get hasLoadedFlags() {
            return this.Es;
        }
        getFlags() {
            return Object.keys(this.getFlagVariants());
        }
        getFlagsWithDetails() {
            var t = this.Fs($0ccba2be0b51cf09$var$wi), e = this.Fs($0ccba2be0b51cf09$var$Si), i = this.Fs($0ccba2be0b51cf09$var$$i);
            if (!i && !e) return t || {};
            var r = $0ccba2be0b51cf09$var$lr({}, t || {}), s = [
                ...new Set([
                    ...Object.keys(i || {}),
                    ...Object.keys(e || {})
                ])
            ];
            for (var n of s){
                var o, a, l = r[n], u = null == e ? void 0 : e[n], h = $0ccba2be0b51cf09$var$U(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $0ccba2be0b51cf09$var$U(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == i ? void 0 : i[n], c = $0ccba2be0b51cf09$var$f({}, l, {
                    enabled: h,
                    variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
                });
                h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v && (c.metadata = $0ccba2be0b51cf09$var$f({}, null == l ? void 0 : l.metadata, {
                    payload: v,
                    original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
                })), r[n] = c;
            }
            return this.Ts || ($0ccba2be0b51cf09$var$Ca.warn(" Overriding feature flag details!", {
                flagDetails: t,
                overriddenPayloads: i,
                finalDetails: r
            }), this.Ts = !0), r;
        }
        getFlagVariants() {
            var t = this.Fs($0ccba2be0b51cf09$var$mi), e = this.Fs($0ccba2be0b51cf09$var$Si);
            if (!e) return t || {};
            for(var i = $0ccba2be0b51cf09$var$lr({}, t), r = Object.keys(e), s = 0; r.length > s; s++)i[r[s]] = e[r[s]];
            return this.Ts || ($0ccba2be0b51cf09$var$Ca.warn(" Overriding feature flags!", {
                enabledFlags: t,
                overriddenFlags: e,
                finalFlags: i
            }), this.Ts = !0), i;
        }
        getFlagPayloads() {
            var t = this.Fs($0ccba2be0b51cf09$var$xi), e = this.Fs($0ccba2be0b51cf09$var$$i);
            if (!e) return t || {};
            for(var i = $0ccba2be0b51cf09$var$lr({}, t || {}), r = Object.keys(e), s = 0; r.length > s; s++)i[r[s]] = e[r[s]];
            return this.Ts || ($0ccba2be0b51cf09$var$Ca.warn(" Overriding feature flag payloads!", {
                flagPayloads: t,
                overriddenPayloads: e,
                finalPayloads: i
            }), this.Ts = !0), i;
        }
        reloadFeatureFlags() {
            this.Rs || this.qt.advanced_disable_feature_flags || this.Bs || (this._instance.ln.emit("featureFlagsReloading", !0), this.Bs = setTimeout(()=>{
                this.Hs();
            }, 5));
        }
        Us() {
            clearTimeout(this.Bs), this.Bs = void 0;
        }
        ensureFlagsLoaded() {
            this.Es || this.Ms || this.Bs || this.reloadFeatureFlags();
        }
        setAnonymousDistinctId(t) {
            this.$anon_distinct_id = t;
        }
        setReloadingPaused(t) {
            this.Rs = t;
        }
        Hs(t) {
            var e;
            if (this.Us(), !this._instance.Kr()) {
                if (this.Ms) this.Ps = !0;
                else {
                    var i = this.qt.token, r = this.Fs($0ccba2be0b51cf09$var$Qe), s = {
                        token: i,
                        distinct_id: this._instance.get_distinct_id(),
                        groups: this._instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: $0ccba2be0b51cf09$var$f({}, (null == (e = this.Si) ? void 0 : e.get_initial_props()) || {}, this.Fs($0ccba2be0b51cf09$var$Ti) || {}),
                        group_properties: this.Fs($0ccba2be0b51cf09$var$ki),
                        timezone: $0ccba2be0b51cf09$var$Js()
                    };
                    $0ccba2be0b51cf09$var$B(r) || $0ccba2be0b51cf09$var$U(r) || (s.$device_id = r), (null != t && t.disableFlags || this.qt.advanced_disable_feature_flags) && (s.disable_flags = !0), this.qs() && (s.evaluation_contexts = this.$s());
                    var n = this.js();
                    $0ccba2be0b51cf09$var$U(n) || (s.flag_keys = n);
                    var o = !!this.qt.advanced_only_evaluate_survey_feature_flags, a = this._instance.requestRouter.endpointFor("flags", "/flags/?v=2" + (this.qt.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : ""));
                    this.Ms = !0, this._instance._send_request({
                        method: "POST",
                        url: a,
                        data: s,
                        compression: this.qt.disable_compression ? void 0 : $0ccba2be0b51cf09$export$6a00d17b5aff0af.Base64,
                        timeout: this.qt.feature_flag_request_timeout_ms,
                        callback: (t)=>{
                            var e, i, r, n = !0;
                            if (200 === t.statusCode && (this.Ps || (this.$anon_distinct_id = void 0), n = !1), this.Ms = !1, !s.disable_flags || this.Ps) {
                                this.Os = !n;
                                var a = [];
                                t.error ? t.error instanceof Error ? a.push("AbortError" === t.error.name ? "timeout" : "connection_error") : a.push("unknown_error") : 200 !== t.statusCode && a.push("api_error_" + t.statusCode), null != (e = t.json) && e.errorsWhileComputingFlags && a.push("errors_while_computing_flags");
                                var l, u = !(null == (i = t.json) || null == (i = i.quotaLimited) || !i.includes("feature_flags"));
                                if (u && a.push("quota_limited"), null == (r = this.Si) || r.register({
                                    [$0ccba2be0b51cf09$var$Fi]: a
                                }), u) $0ccba2be0b51cf09$var$Ca.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                                else s.disable_flags || this.receivedFeatureFlags(null !== (l = t.json) && void 0 !== l ? l : {}, n, {
                                    partialResponse: o
                                }), this.Ps && (this.Ps = !1, this.Hs());
                            }
                        }
                    });
                }
            }
        }
        getFeatureFlag(t, e) {
            var i;
            if (void 0 === e && (e = {}), !e.fresh || this.Os) {
                if (this.Es || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.Ds()) {
                        var r = this.getFeatureFlagResult(t, e);
                        return null !== (i = null == r ? void 0 : r.variant) && void 0 !== i ? i : null == r ? void 0 : r.enabled;
                    }
                } else $0ccba2be0b51cf09$var$Ca.warn('getFeatureFlag for key "' + t + $0ccba2be0b51cf09$var$Fa);
            }
        }
        getFeatureFlagDetails(t) {
            return this.getFlagsWithDetails()[t];
        }
        getFeatureFlagPayload(t) {
            var e = this.getFeatureFlagResult(t, {
                send_event: !1
            });
            return null == e ? void 0 : e.payload;
        }
        getFeatureFlagResult(t, e) {
            if (void 0 === e && (e = {}), !e.fresh || this.Os) {
                if (this.Es || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.Ds()) {
                        var i = this.getFlagVariants(), r = t in i, s = i[t], n = this.getFlagPayloads()[t], o = String(s), a = this.Fs($0ccba2be0b51cf09$var$Ei) || void 0, l = this.Fs($0ccba2be0b51cf09$var$Mi) || void 0, u = this.Fs($0ccba2be0b51cf09$var$Ci) || {};
                        if (this.qt.advanced_feature_flags_dedup_per_session) {
                            var h, d = this._instance.get_session_id(), v = this.Fs($0ccba2be0b51cf09$var$Ai);
                            d && d !== v && (u = {}, null == (h = this.Si) || h.register({
                                [$0ccba2be0b51cf09$var$Ci]: u,
                                [$0ccba2be0b51cf09$var$Ai]: d
                            }));
                        }
                        if ((e.send_event || !("send_event" in e)) && (!(t in u) || !u[t].includes(o))) {
                            var c, p, f, _, g, m, b, y, w, x;
                            $0ccba2be0b51cf09$var$M(u[t]) ? u[t].push(o) : u[t] = [
                                o
                            ], null == (c = this.Si) || c.register({
                                [$0ccba2be0b51cf09$var$Ci]: u
                            });
                            var E = this.getFeatureFlagDetails(t), S = [
                                ...null !== (p = this.Fs($0ccba2be0b51cf09$var$Fi)) && void 0 !== p ? p : []
                            ];
                            $0ccba2be0b51cf09$var$U(s) && S.push("flag_missing");
                            var T = {
                                $feature_flag: t,
                                $feature_flag_response: s,
                                $feature_flag_payload: n || null,
                                $feature_flag_request_id: a,
                                $feature_flag_evaluated_at: l,
                                $feature_flag_bootstrapped_response: (null == (f = this.qt.bootstrap) || null == (f = f.featureFlags) ? void 0 : f[t]) || null,
                                $feature_flag_bootstrapped_payload: (null == (_ = this.qt.bootstrap) || null == (_ = _.featureFlagPayloads) ? void 0 : _[t]) || null,
                                $used_bootstrap_value: !this.Os
                            };
                            $0ccba2be0b51cf09$var$U(null == E || null == (g = E.metadata) ? void 0 : g.version) || (T.$feature_flag_version = E.metadata.version);
                            var k, R = null !== (m = null == E || null == (b = E.reason) ? void 0 : b.description) && void 0 !== m ? m : null == E || null == (y = E.reason) ? void 0 : y.code;
                            R && (T.$feature_flag_reason = R), null != E && null != (w = E.metadata) && w.id && (T.$feature_flag_id = E.metadata.id), $0ccba2be0b51cf09$var$U(null == E ? void 0 : E.original_variant) && $0ccba2be0b51cf09$var$U(null == E ? void 0 : E.original_enabled) || (T.$feature_flag_original_response = $0ccba2be0b51cf09$var$U(E.original_variant) ? E.original_enabled : E.original_variant), null != E && null != (x = E.metadata) && x.original_payload && (T.$feature_flag_original_payload = null == E || null == (k = E.metadata) ? void 0 : k.original_payload), S.length && (T.$feature_flag_error = S.join(",")), this._instance.capture("$feature_flag_called", T);
                        }
                        if (r) {
                            var P = n;
                            if (!$0ccba2be0b51cf09$var$U(n)) try {
                                P = JSON.parse(n);
                            } catch (t) {}
                            return {
                                key: t,
                                enabled: !!s,
                                variant: "string" == typeof s ? s : void 0,
                                payload: P
                            };
                        }
                    }
                } else $0ccba2be0b51cf09$var$Ca.warn('getFeatureFlagResult for key "' + t + $0ccba2be0b51cf09$var$Fa);
            }
        }
        getRemoteConfigPayload(t, e) {
            var i = this.qt.token, r = {
                distinct_id: this._instance.get_distinct_id(),
                token: i
            };
            this.qs() && (r.evaluation_contexts = this.$s());
            var s = this.js();
            $0ccba2be0b51cf09$var$U(s) || (r.flag_keys = s), this._instance._send_request({
                method: "POST",
                url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2"),
                data: r,
                compression: this.qt.disable_compression ? void 0 : $0ccba2be0b51cf09$export$6a00d17b5aff0af.Base64,
                timeout: this.qt.feature_flag_request_timeout_ms,
                callback (i) {
                    var r, s = null == (r = i.json) ? void 0 : r.featureFlagPayloads;
                    e((null == s ? void 0 : s[t]) || void 0);
                }
            });
        }
        isFeatureEnabled(t, e) {
            if (void 0 === e && (e = {}), !e.fresh || this.Os) {
                if (this.Es || this.getFlags() && this.getFlags().length > 0) {
                    var i = this.getFeatureFlag(t, e);
                    return $0ccba2be0b51cf09$var$U(i) ? void 0 : !!i;
                }
                $0ccba2be0b51cf09$var$Ca.warn('isFeatureEnabled for key "' + t + $0ccba2be0b51cf09$var$Fa);
            }
        }
        addFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers.push(t);
        }
        removeFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((e)=>e !== t);
        }
        receivedFeatureFlags(t, e, i) {
            if (this.Si) {
                this.Es = !0;
                var r = this.getFlagVariants(), s = this.getFlagPayloads(), n = this.getFlagsWithDetails();
                !function(t, e, i, r, s, n) {
                    void 0 === i && (i = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                    var o = ((t)=>{
                        var e = t.flags;
                        return e ? (t.featureFlags = Object.fromEntries(Object.keys(e).map((t)=>{
                            var i;
                            return [
                                t,
                                null !== (i = e[t].variant) && void 0 !== i ? i : e[t].enabled
                            ];
                        })), t.featureFlagPayloads = Object.fromEntries(Object.keys(e).filter((t)=>e[t].enabled).filter((t)=>{
                            var i;
                            return null == (i = e[t].metadata) ? void 0 : i.payload;
                        }).map((t)=>{
                            var i;
                            return [
                                t,
                                null == (i = e[t].metadata) ? void 0 : i.payload
                            ];
                        }))) : $0ccba2be0b51cf09$var$Ca.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
                    })(t), a = o.flags, l = o.featureFlags, u = o.featureFlagPayloads;
                    if (l) {
                        var h = t.requestId, d = t.evaluatedAt;
                        if ($0ccba2be0b51cf09$var$M(l)) {
                            $0ccba2be0b51cf09$var$Ca.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                            var v = {};
                            if (l) for(var c = 0; l.length > c; c++)v[l[c]] = !0;
                            e && e.register({
                                [$0ccba2be0b51cf09$var$bi]: l,
                                [$0ccba2be0b51cf09$var$mi]: v
                            });
                        } else {
                            var p = l, _ = u, g = a;
                            if (null != n && n.partialResponse) p = $0ccba2be0b51cf09$var$f({}, i, p), _ = $0ccba2be0b51cf09$var$f({}, r, _), g = $0ccba2be0b51cf09$var$f({}, s, g);
                            else if (t.errorsWhileComputingFlags) {
                                if (a) {
                                    var m = new Set(Object.keys(a).filter((t)=>{
                                        var e;
                                        return !(null != (e = a[t]) && e.failed);
                                    }));
                                    p = $0ccba2be0b51cf09$var$f({}, i, Object.fromEntries(Object.entries(p).filter((t)=>{
                                        var [e] = t;
                                        return m.has(e);
                                    }))), _ = $0ccba2be0b51cf09$var$f({}, r, Object.fromEntries(Object.entries(_ || {}).filter((t)=>{
                                        var [e] = t;
                                        return m.has(e);
                                    }))), g = $0ccba2be0b51cf09$var$f({}, s, Object.fromEntries(Object.entries(g || {}).filter((t)=>{
                                        var [e] = t;
                                        return m.has(e);
                                    })));
                                } else p = $0ccba2be0b51cf09$var$f({}, i, p), _ = $0ccba2be0b51cf09$var$f({}, r, _), g = $0ccba2be0b51cf09$var$f({}, s, g);
                            }
                            e && e.register($0ccba2be0b51cf09$var$f({
                                [$0ccba2be0b51cf09$var$bi]: Object.keys($0ccba2be0b51cf09$var$Da(p)),
                                [$0ccba2be0b51cf09$var$mi]: p || {},
                                [$0ccba2be0b51cf09$var$xi]: _ || {},
                                [$0ccba2be0b51cf09$var$wi]: g || {}
                            }, h ? {
                                [$0ccba2be0b51cf09$var$Ei]: h
                            } : {}, d ? {
                                [$0ccba2be0b51cf09$var$Mi]: d
                            } : {}));
                        }
                    }
                }(t, this.Si, r, s, n, i), e || (this.As = !1), this.zs(e);
            }
        }
        override(t, e) {
            void 0 === e && (e = !1), $0ccba2be0b51cf09$var$Ca.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
                flags: t,
                suppressWarning: e
            });
        }
        overrideFeatureFlags(t) {
            if (!this._instance.__loaded || !this.Si) return $0ccba2be0b51cf09$var$Ca.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
            if (!1 === t) return this.Si.unregister($0ccba2be0b51cf09$var$Si), this.Si.unregister($0ccba2be0b51cf09$var$$i), this.zs(), $0ccba2be0b51cf09$var$Aa.info("All overrides cleared");
            if ($0ccba2be0b51cf09$var$M(t)) {
                var e = $0ccba2be0b51cf09$var$Ma(t);
                return this.Si.register({
                    [$0ccba2be0b51cf09$var$Si]: e
                }), this.zs(), $0ccba2be0b51cf09$var$Aa.info("Flag overrides set", {
                    flags: t
                });
            }
            if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
                var i, r = t;
                if (this.Ts = Boolean(null !== (i = r.suppressWarning) && void 0 !== i && i), "flags" in r) {
                    if (!1 === r.flags) this.Si.unregister($0ccba2be0b51cf09$var$Si), $0ccba2be0b51cf09$var$Aa.info("Flag overrides cleared");
                    else if (r.flags) {
                        if ($0ccba2be0b51cf09$var$M(r.flags)) {
                            var s = $0ccba2be0b51cf09$var$Ma(r.flags);
                            this.Si.register({
                                [$0ccba2be0b51cf09$var$Si]: s
                            });
                        } else this.Si.register({
                            [$0ccba2be0b51cf09$var$Si]: r.flags
                        });
                        $0ccba2be0b51cf09$var$Aa.info("Flag overrides set", {
                            flags: r.flags
                        });
                    }
                }
                return "payloads" in r && (!1 === r.payloads ? (this.Si.unregister($0ccba2be0b51cf09$var$$i), $0ccba2be0b51cf09$var$Aa.info("Payload overrides cleared")) : r.payloads && (this.Si.register({
                    [$0ccba2be0b51cf09$var$$i]: r.payloads
                }), $0ccba2be0b51cf09$var$Aa.info("Payload overrides set", {
                    payloads: r.payloads
                }))), void this.zs();
            }
            if (t && "object" == typeof t) return this.Si.register({
                [$0ccba2be0b51cf09$var$Si]: t
            }), this.zs(), $0ccba2be0b51cf09$var$Aa.info("Flag overrides set", {
                flags: t
            });
            $0ccba2be0b51cf09$var$Ca.warn("Invalid overrideOptions provided to overrideFeatureFlags", {
                overrideOptions: t
            });
        }
        onFeatureFlags(t) {
            if (this.addFeatureFlagsHandler(t), this.Es) {
                var { flags: e, flagVariants: i } = this.Vs();
                t(e, i);
            }
            return ()=>this.removeFeatureFlagsHandler(t);
        }
        updateEarlyAccessFeatureEnrollment(t, e, i) {
            var r, s = (this.Fs($0ccba2be0b51cf09$var$yi) || []).find((e)=>e.flagKey === t), n = {
                ["$feature_enrollment/" + t]: e
            }, o = {
                $feature_flag: t,
                $feature_enrollment: e,
                $set: n
            };
            s && (o.$early_access_feature_name = s.name), i && (o.$feature_enrollment_stage = i), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
            var a = $0ccba2be0b51cf09$var$f({}, this.getFlagVariants(), {
                [t]: e
            });
            null == (r = this.Si) || r.register({
                [$0ccba2be0b51cf09$var$bi]: Object.keys($0ccba2be0b51cf09$var$Da(a)),
                [$0ccba2be0b51cf09$var$mi]: a
            }), this.zs();
        }
        getEarlyAccessFeatures(t, e, i) {
            void 0 === e && (e = !1);
            var r = this.Fs($0ccba2be0b51cf09$var$yi), s = i ? "&" + i.map((t)=>"stage=" + t).join("&") : "";
            if (r && !e) return t(r);
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this.qt.token + s),
                method: "GET",
                callback: (e)=>{
                    var i, r;
                    if (e.json) {
                        var s = e.json.earlyAccessFeatures;
                        return null == (i = this.Si) || i.unregister($0ccba2be0b51cf09$var$yi), null == (r = this.Si) || r.register({
                            [$0ccba2be0b51cf09$var$yi]: s
                        }), t(s);
                    }
                }
            });
        }
        Vs() {
            var t = this.getFlags(), e = this.getFlagVariants();
            return {
                flags: t.filter((t)=>e[t]),
                flagVariants: Object.keys(e).filter((t)=>e[t]).reduce((t, i)=>(t[i] = e[i], t), {})
            };
        }
        zs(t) {
            var { flags: e, flagVariants: i } = this.Vs();
            this.featureFlagEventHandlers.forEach((r)=>r(e, i, {
                    errorsLoading: t
                }));
        }
        setPersonPropertiesForFlags(t, e) {
            void 0 === e && (e = !0);
            var i = this.Fs($0ccba2be0b51cf09$var$Ti) || {}, r = (null == t ? void 0 : t.$set) || (null != t && t.$set_once ? {} : t), s = null == t ? void 0 : t.$set_once, n = {};
            if (s) for(var o in s)({}).hasOwnProperty.call(s, o) && (o in i || (n[o] = s[o]));
            this._instance.register({
                [$0ccba2be0b51cf09$var$Ti]: $0ccba2be0b51cf09$var$f({}, i, n, r)
            }), e && this._instance.reloadFeatureFlags();
        }
        resetPersonPropertiesForFlags(t) {
            void 0 === t && (t = !0), this._instance.unregister($0ccba2be0b51cf09$var$Ti), t && this._instance.reloadFeatureFlags();
        }
        setGroupPropertiesForFlags(t, e) {
            void 0 === e && (e = !0);
            var i = this.Fs($0ccba2be0b51cf09$var$ki) || {};
            0 !== Object.keys(i).length && Object.keys(i).forEach((e)=>{
                i[e] = $0ccba2be0b51cf09$var$f({}, i[e], t[e]), delete t[e];
            }), this._instance.register({
                [$0ccba2be0b51cf09$var$ki]: $0ccba2be0b51cf09$var$f({}, i, t)
            }), e && this._instance.reloadFeatureFlags();
        }
        resetGroupPropertiesForFlags(t) {
            if (t) {
                var e = this.Fs($0ccba2be0b51cf09$var$ki) || {};
                this._instance.register({
                    [$0ccba2be0b51cf09$var$ki]: $0ccba2be0b51cf09$var$f({}, e, {
                        [t]: {}
                    })
                });
            } else this._instance.unregister($0ccba2be0b51cf09$var$ki);
        }
        reset() {
            this.Es = !1, this.Ms = !1, this.Rs = !1, this.Ps = !1, this.Os = !1, this.$anon_distinct_id = void 0, this.Us(), this.Ts = !1;
        }
    }
}, $0ccba2be0b51cf09$var$Va = {
    sessionRecording: class {
        get qt() {
            return this._instance.config;
        }
        get Si() {
            return this._instance.persistence;
        }
        get started() {
            var t;
            return !(null == (t = this.Ws) || !t.isStarted);
        }
        get status() {
            var t, e;
            return this.Gs === $0ccba2be0b51cf09$var$va || this.Gs === $0ccba2be0b51cf09$var$ca ? this.Gs : null !== (t = null == (e = this.Ws) ? void 0 : e.status) && void 0 !== t ? t : this.Gs;
        }
        constructor(t){
            if (this._forceAllowLocalhostNetworkCapture = !1, this.Gs = $0ccba2be0b51cf09$var$ha, this.Zs = void 0, this._instance = t, !this._instance.sessionManager) throw $0ccba2be0b51cf09$var$fa.error("started without valid sessionManager"), new Error($0ccba2be0b51cf09$var$pa + " started without valid sessionManager. This is a bug.");
            if (this.qt.cookieless_mode === $0ccba2be0b51cf09$var$Ki) throw new Error($0ccba2be0b51cf09$var$pa + ' cannot be used with cookieless_mode="always"');
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        get Qs() {
            var e, i = !(null == (e = this._instance.get_property($0ccba2be0b51cf09$var$hi)) || !e.enabled), r = !this.qt.disable_session_recording, s = this.qt.disable_session_recording || this._instance.consent.isOptedOut();
            return $0ccba2be0b51cf09$var$t && i && r && !s;
        }
        startIfEnabledOrStop(t) {
            var e;
            if (!this.Qs || null == (e = this.Ws) || !e.isStarted) {
                var i = !$0ccba2be0b51cf09$var$U(Object.assign) && !$0ccba2be0b51cf09$var$U(Array.from);
                this.Qs && i ? (this.Js(t), $0ccba2be0b51cf09$var$fa.info("starting")) : (this.Gs = $0ccba2be0b51cf09$var$ha, this.stopRecording());
            }
        }
        Js(t) {
            var e, i, r;
            this.Qs && (this.Gs !== $0ccba2be0b51cf09$var$va && this.Gs !== $0ccba2be0b51cf09$var$ca && (this.Gs = $0ccba2be0b51cf09$var$da), null != $0ccba2be0b51cf09$var$h && null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && null != (e = e.rrweb) && e.record && null != (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && i.initSessionRecording ? this.Ks(t) : null == (r = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.Ys, (e)=>{
                if (e) return $0ccba2be0b51cf09$var$fa.error("could not load recorder", e);
                this.Ks(t);
            }));
        }
        stopRecording() {
            var t, e;
            null == (t = this.Zs) || t.call(this), this.Zs = void 0, null == (e = this.Ws) || e.stop();
        }
        Xs() {
            var t, e;
            null == (t = this.Zs) || t.call(this), this.Zs = void 0, null == (e = this.Ws) || e.discard();
        }
        eo() {
            var t, e;
            null == (t = this.Si) || t.unregister($0ccba2be0b51cf09$var$gi), null == (e = this.Si) || e.unregister($0ccba2be0b51cf09$var$di);
        }
        ro(t, e) {
            if ($0ccba2be0b51cf09$var$H(t)) return null;
            var i, r = $0ccba2be0b51cf09$var$V(t) ? t : parseFloat(t);
            return "number" != typeof (i = r) || !Number.isFinite(i) || 0 > i || i > 1 ? ($0ccba2be0b51cf09$var$fa.warn(e + " must be between 0 and 1. Ignoring invalid value:", t), null) : r;
        }
        io(t) {
            if (this.Si) {
                var e, i, r = this.Si, s = ()=>{
                    var e, i = !1 === t.sessionRecording ? void 0 : t.sessionRecording, s = this.ro(null == (e = this.qt.session_recording) ? void 0 : e.sampleRate, "session_recording.sampleRate"), n = this.ro(null == i ? void 0 : i.sampleRate, "remote config sampleRate"), o = null != s ? s : n;
                    $0ccba2be0b51cf09$var$H(o) && this.eo();
                    var a = null == i ? void 0 : i.minimumDurationMilliseconds;
                    r.register({
                        [$0ccba2be0b51cf09$var$hi]: $0ccba2be0b51cf09$var$f({
                            cache_timestamp: Date.now(),
                            enabled: !!i
                        }, i, {
                            networkPayloadCapture: $0ccba2be0b51cf09$var$f({
                                capturePerformance: t.capturePerformance
                            }, null == i ? void 0 : i.networkPayloadCapture),
                            canvasRecording: {
                                enabled: null == i ? void 0 : i.recordCanvas,
                                fps: null == i ? void 0 : i.canvasFps,
                                quality: null == i ? void 0 : i.canvasQuality
                            },
                            sampleRate: o,
                            minimumDurationMilliseconds: $0ccba2be0b51cf09$var$U(a) ? null : a,
                            endpoint: null == i ? void 0 : i.endpoint,
                            triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                            masking: null == i ? void 0 : i.masking,
                            urlTriggers: null == i ? void 0 : i.urlTriggers,
                            version: null == i ? void 0 : i.version,
                            triggerGroups: null == i ? void 0 : i.triggerGroups
                        })
                    });
                };
                s(), null == (e = this.Zs) || e.call(this), this.Zs = null == (i = this._instance.sessionManager) ? void 0 : i.onSessionId(s);
            }
        }
        onRemoteConfig(t) {
            return "sessionRecording" in t ? !1 === t.sessionRecording ? (this.io(t), void this.Xs()) : (this.io(t), void this.startIfEnabledOrStop()) : (this.Gs === $0ccba2be0b51cf09$var$va && (this.Gs = $0ccba2be0b51cf09$var$ca, $0ccba2be0b51cf09$var$fa.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
        }
        log(t, e) {
            var i;
            void 0 === e && (e = "log"), null != (i = this.Ws) && i.log ? this.Ws.log(t, e) : $0ccba2be0b51cf09$var$fa.warn("log called before recorder was ready");
        }
        get Ys() {
            var t, e, i = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($0ccba2be0b51cf09$var$hi);
            return (null == i || null == (e = i.scriptConfig) ? void 0 : e.script) || "lazy-recorder";
        }
        no() {
            var t, e, i = this._instance.get_property($0ccba2be0b51cf09$var$hi);
            if (!i) return !1;
            try {
                e = "object" == typeof i ? i : JSON.parse(i);
            } catch (t) {
                return $0ccba2be0b51cf09$var$fa.warn("persisted remote config for session recording is invalid and will be ignored", t), !1;
            }
            var r = null !== (t = e.cache_timestamp) && void 0 !== t ? t : Date.now();
            return 36e5 >= Date.now() - r;
        }
        Ks(t) {
            var e, i;
            if (null == (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || !e.initSessionRecording) return $0ccba2be0b51cf09$var$fa.warn("Called on script loaded before session recording is available. This can be caused by adblockers."), void this._instance.register_for_session({
                [$0ccba2be0b51cf09$var$Wi]: !0
            });
            if (this.Ws || (this.Ws = null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) ? void 0 : i.initSessionRecording(this._instance), this.Ws._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.no()) {
                if (this.Gs === $0ccba2be0b51cf09$var$ca || this.Gs === $0ccba2be0b51cf09$var$va) return;
                return this.Gs = $0ccba2be0b51cf09$var$va, $0ccba2be0b51cf09$var$fa.info("persisted remote config is stale, requesting fresh config before starting"), void new $0ccba2be0b51cf09$var$bn(this._instance).load();
            }
            this.Gs = $0ccba2be0b51cf09$var$da, this.Ws.start(t);
        }
        onRRwebEmit(t) {
            var e;
            null == (e = this.Ws) || null == e.onRRwebEmit || e.onRRwebEmit(t);
        }
        overrideLinkedFlag() {
            var t, e;
            this.Ws || null == (e = this.Si) || e.register({
                [$0ccba2be0b51cf09$var$ci]: !0
            }), null == (t = this.Ws) || t.overrideLinkedFlag();
        }
        overrideSampling() {
            var t, e;
            this.Ws || null == (e = this.Si) || e.register({
                [$0ccba2be0b51cf09$var$vi]: !0
            }), null == (t = this.Ws) || t.overrideSampling();
        }
        overrideTrigger(t) {
            var e, i;
            this.Ws || null == (i = this.Si) || i.register({
                ["url" === t ? $0ccba2be0b51cf09$var$pi : $0ccba2be0b51cf09$var$fi]: !0
            }), null == (e = this.Ws) || e.overrideTrigger(t);
        }
        get sdkDebugProperties() {
            var t;
            return (null == (t = this.Ws) ? void 0 : t.sdkDebugProperties) || {
                $recording_status: this.status
            };
        }
        tryAddCustomEvent(t, e) {
            var i;
            return !(null == (i = this.Ws) || !i.tryAddCustomEvent(t, e));
        }
    }
}, $0ccba2be0b51cf09$var$qa = {
    autocapture: class {
        constructor(t){
            this.so = !1, this.oo = null, this.ao = !1, this.instance = t, this.rageclicks = new $0ccba2be0b51cf09$var$ta(t.config.rageclick), this.lo = null;
        }
        initialize() {
            this.startIfEnabled();
        }
        get qt() {
            var t, e, i = $0ccba2be0b51cf09$var$N(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
            return i.url_allowlist = null == (t = i.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), i.url_ignorelist = null == (e = i.url_ignorelist) ? void 0 : e.map((t)=>new RegExp(t)), i;
        }
        uo() {
            if (this.isBrowserSupported()) {
                if ($0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$r) {
                    var e = (e)=>{
                        e = e || (null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.event);
                        try {
                            this.ho(e);
                        } catch (t) {
                            $0ccba2be0b51cf09$var$ia.error("Failed to capture event", t);
                        }
                    };
                    if ($0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "submit", e, {
                        capture: !0
                    }), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "change", e, {
                        capture: !0
                    }), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "click", e, {
                        capture: !0
                    }), this.qt.capture_copied_text) {
                        var i = (e)=>{
                            e = e || (null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.event);
                            try {
                                this.ho(e, $0ccba2be0b51cf09$var$ea);
                            } catch (t) {
                                $0ccba2be0b51cf09$var$ia.error("Failed to capture copy/cut event", t);
                            }
                        };
                        $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "copy", i, {
                            capture: !0
                        }), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "cut", i, {
                            capture: !0
                        });
                    }
                }
            } else $0ccba2be0b51cf09$var$ia.info("Disabling Automatic Event Collection because this browser is not supported");
        }
        startIfEnabled() {
            this.isEnabled && !this.so && (this.uo(), this.so = !0);
        }
        onRemoteConfig(t) {
            t.elementsChainAsString && (this.ao = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
                [$0ccba2be0b51cf09$var$ei]: !!t.autocapture_opt_out
            }), this.oo = !!t.autocapture_opt_out, this.startIfEnabled();
        }
        setElementSelectors(t) {
            this.lo = t;
        }
        getElementSelectors(t) {
            var e, i = [];
            return null == (e = this.lo) || e.forEach((e)=>{
                var s = null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.querySelectorAll(e);
                null == s || s.forEach((r)=>{
                    t === r && i.push(e);
                });
            }), i;
        }
        get isEnabled() {
            var t, e, i = null == (t = this.instance.persistence) ? void 0 : t.props[$0ccba2be0b51cf09$var$ei];
            if ($0ccba2be0b51cf09$var$B(this.oo) && !$0ccba2be0b51cf09$var$G(i) && !this.instance.Kr()) return !1;
            var r = null !== (e = this.oo) && void 0 !== e ? e : !!i;
            return !!this.instance.config.autocapture && !r;
        }
        ho(e, i) {
            if (void 0 === i && (i = "$autocapture"), this.isEnabled) {
                var r, s = $0ccba2be0b51cf09$var$Yr(e);
                $0ccba2be0b51cf09$var$zr(s) && (s = s.parentNode || null), "$autocapture" === i && "click" === e.type && e instanceof MouseEvent && this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(e.clientX, e.clientY, e.timeStamp || (new Date).getTime()) && $0ccba2be0b51cf09$var$rs(s, this.instance.config.rageclick) && this.ho(e, "$rageclick");
                var n = i === $0ccba2be0b51cf09$var$ea;
                if (s && function(e, i, r, s, n) {
                    var o, a, l, u;
                    if (void 0 === r && (r = void 0), !$0ccba2be0b51cf09$var$t || $0ccba2be0b51cf09$var$ss(e)) return !1;
                    if (null != (o = r) && o.url_allowlist && !$0ccba2be0b51cf09$var$Vr(r.url_allowlist)) return !1;
                    if (null != (a = r) && a.url_ignorelist && $0ccba2be0b51cf09$var$Vr(r.url_ignorelist)) return !1;
                    if (null != (l = r) && l.dom_event_allowlist) {
                        var h = r.dom_event_allowlist;
                        if (h && !h.some((t)=>i.type === t)) return !1;
                    }
                    var { parentIsUsefulElement: d, targetElementList: v } = $0ccba2be0b51cf09$var$ns(e, s);
                    if (!function(t, e) {
                        var i = null == e ? void 0 : e.element_allowlist;
                        if ($0ccba2be0b51cf09$var$U(i)) return !0;
                        var r, s = function(t) {
                            if (i.some((e)=>t.tagName.toLowerCase() === e)) return {
                                v: !0
                            };
                        };
                        for (var n of t)if (r = s(n)) return r.v;
                        return !1;
                    }(v, r)) return !1;
                    if (!$0ccba2be0b51cf09$var$Kr(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
                    var c = $0ccba2be0b51cf09$var$t.getComputedStyle(e);
                    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === i.type) return !0;
                    var p = e.tagName.toLowerCase();
                    switch(p){
                        case "html":
                            return !1;
                        case "form":
                            return (n || [
                                "submit"
                            ]).indexOf(i.type) >= 0;
                        case "input":
                        case "select":
                        case "textarea":
                            return (n || [
                                "change",
                                "click"
                            ]).indexOf(i.type) >= 0;
                        default:
                            return d ? (n || [
                                "click"
                            ]).indexOf(i.type) >= 0 : (n || [
                                "click"
                            ]).indexOf(i.type) >= 0 && ($0ccba2be0b51cf09$var$Jr.indexOf(p) > -1 || "true" === e.getAttribute("contenteditable"));
                    }
                }(s, e, this.qt, n, n ? [
                    "copy",
                    "cut"
                ] : void 0)) {
                    var { props: o, explicitNoCapture: a } = $0ccba2be0b51cf09$var$na(s, {
                        e: e,
                        maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                        maskAllText: this.instance.config.mask_all_text,
                        elementAttributeIgnoreList: this.qt.element_attribute_ignorelist,
                        elementsChainAsString: this.ao
                    });
                    if (a) return !1;
                    var l = this.getElementSelectors(s);
                    if (l && l.length > 0 && (o.$element_selectors = l), i === $0ccba2be0b51cf09$var$ea) {
                        var u, h = $0ccba2be0b51cf09$var$Gr(null == $0ccba2be0b51cf09$var$t || null == (u = $0ccba2be0b51cf09$var$t.getSelection()) ? void 0 : u.toString()), d = e.type || "clipboard";
                        if (!h) return !1;
                        o.$selected_content = h, o.$copy_type = d;
                    }
                    return this.instance.capture(i, o), !0;
                }
            }
        }
        isBrowserSupported() {
            return $0ccba2be0b51cf09$var$D(null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.querySelectorAll);
        }
    },
    historyAutocapture: class {
        constructor(e){
            var i;
            this._instance = e, this.co = (null == $0ccba2be0b51cf09$var$t || null == (i = $0ccba2be0b51cf09$var$t.location) ? void 0 : i.pathname) || "";
        }
        initialize() {
            this.startIfEnabled();
        }
        get isEnabled() {
            return "history_change" === this._instance.config.capture_pageview;
        }
        startIfEnabled() {
            this.isEnabled && ($0ccba2be0b51cf09$var$We.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
        }
        stop() {
            this.do && this.do(), this.do = void 0, $0ccba2be0b51cf09$var$We.info("History API monitoring stopped");
        }
        monitorHistoryChanges() {
            $0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$t.history && (this.vo("pushState"), this.vo("replaceState"), this.fo());
        }
        vo(e) {
            var i;
            if ($0ccba2be0b51cf09$var$t && (null == (i = $0ccba2be0b51cf09$var$t.history[e]) || !i.__posthog_wrapped__)) {
                var r = this;
                !function(t, e, i) {
                    try {
                        if (!(e in t)) return ()=>{};
                        var r = t[e], s = i(r);
                        return $0ccba2be0b51cf09$var$D(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
                            __posthog_wrapped__: {
                                enumerable: !1,
                                value: !0
                            }
                        })), t[e] = s, ()=>{
                            t[e] === s && (t[e] = r);
                        };
                    } catch (t) {
                        return ()=>{};
                    }
                }($0ccba2be0b51cf09$var$t.history, e, (t)=>function(i, s, n) {
                        t.call(this, i, s, n), r.po(e);
                    });
            }
        }
        po(e) {
            try {
                var i, r = null == $0ccba2be0b51cf09$var$t || null == (i = $0ccba2be0b51cf09$var$t.location) ? void 0 : i.pathname;
                if (!r) return;
                r !== this.co && this.isEnabled && this._instance.capture($0ccba2be0b51cf09$var$ir, {
                    navigation_type: e
                }), this.co = r;
            } catch (t) {
                $0ccba2be0b51cf09$var$We.error("Error capturing " + e + " pageview", t);
            }
        }
        fo() {
            if (!this.do) {
                var e = ()=>{
                    this.po("popstate");
                };
                $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "popstate", e), this.do = ()=>{
                    $0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$t.removeEventListener("popstate", e);
                };
            }
        }
    },
    heatmaps: class {
        get qt() {
            return this.instance.config;
        }
        constructor(t){
            var e;
            this.mo = !1, this.so = !1, this.yo = null, this.instance = t, this.mo = !(null == (e = this.instance.persistence) || !e.props[$0ccba2be0b51cf09$var$ii]), this.rageclicks = new $0ccba2be0b51cf09$var$ta(t.config.rageclick);
        }
        initialize() {
            this.startIfEnabled();
        }
        get flushIntervalMilliseconds() {
            var t = 5e3;
            return $0ccba2be0b51cf09$var$N(this.qt.capture_heatmaps) && this.qt.capture_heatmaps.flush_interval_milliseconds && (t = this.qt.capture_heatmaps.flush_interval_milliseconds), t;
        }
        get isEnabled() {
            return $0ccba2be0b51cf09$var$H(this.qt.capture_heatmaps) ? $0ccba2be0b51cf09$var$H(this.qt.enable_heatmaps) ? this.mo : this.qt.enable_heatmaps : !1 !== this.qt.capture_heatmaps;
        }
        startIfEnabled() {
            if (this.isEnabled) {
                if (this.so) return;
                $0ccba2be0b51cf09$var$_a.info("starting..."), this.bo(), this.At();
            } else {
                var t;
                clearInterval(null !== (t = this.yo) && void 0 !== t ? t : void 0), this._o(), this.getAndClearBuffer();
            }
        }
        onRemoteConfig(t) {
            if ("heatmaps" in t) {
                var e = !!t.heatmaps;
                this.instance.persistence && this.instance.persistence.register({
                    [$0ccba2be0b51cf09$var$ii]: e
                }), this.mo = e, this.startIfEnabled();
            }
        }
        getAndClearBuffer() {
            var t = this.M;
            return this.M = void 0, t;
        }
        wo(t) {
            this.Mt(t.originalEvent, "deadclick");
        }
        At() {
            this.yo && clearInterval(this.yo), this.yo = "visible" === (null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.visibilityState) ? setInterval(this.ci.bind(this), this.flushIntervalMilliseconds) : null;
        }
        bo() {
            $0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$r && (this.xo = this.ci.bind(this), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, $0ccba2be0b51cf09$var$er, this.xo), this.ko = (e)=>this.Mt(e || (null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.event)), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "click", this.ko, {
                capture: !0
            }), this.So = (e)=>this.Co(e || (null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.event)), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "mousemove", this.So, {
                capture: !0
            }), this.Io = new $0ccba2be0b51cf09$var$xs(this.instance, $0ccba2be0b51cf09$var$ys, this.wo.bind(this)), this.Io.startIfEnabledOrStop(), this.To = this.At.bind(this), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, $0ccba2be0b51cf09$var$tr, this.To), this.so = !0);
        }
        _o() {
            var e;
            $0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$r && (this.xo && $0ccba2be0b51cf09$var$t.removeEventListener($0ccba2be0b51cf09$var$er, this.xo), this.ko && $0ccba2be0b51cf09$var$r.removeEventListener("click", this.ko, {
                capture: !0
            }), this.So && $0ccba2be0b51cf09$var$r.removeEventListener("mousemove", this.So, {
                capture: !0
            }), this.To && $0ccba2be0b51cf09$var$r.removeEventListener($0ccba2be0b51cf09$var$tr, this.To), clearTimeout(this.Eo), null == (e = this.Io) || e.stop(), this.so = !1);
        }
        Mo(e, i) {
            var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(e, i, r) {
                for(var s = e; s && $0ccba2be0b51cf09$var$Ur(s) && !$0ccba2be0b51cf09$var$jr(s, "body");){
                    if (s === r) return !1;
                    if ($0ccba2be0b51cf09$var$P(i, null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.getComputedStyle(s).position)) return !0;
                    s = $0ccba2be0b51cf09$var$Xr(s);
                }
                return !1;
            }($0ccba2be0b51cf09$var$Yr(e), [
                "fixed",
                "sticky"
            ], n);
            return {
                x: e.clientX + (o ? 0 : s),
                y: e.clientY + (o ? 0 : r),
                target_fixed: o,
                type: i
            };
        }
        Mt(t, e) {
            var i;
            if (void 0 === e && (e = "click"), !$0ccba2be0b51cf09$var$Lr(t.target) && $0ccba2be0b51cf09$var$ga(t)) {
                var r = this.Mo(t, e);
                null != (i = this.rageclicks) && i.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && $0ccba2be0b51cf09$var$rs($0ccba2be0b51cf09$var$Yr(t), this.instance.config.rageclick) && this.Ro($0ccba2be0b51cf09$var$f({}, r, {
                    type: "rageclick"
                })), this.Ro(r);
            }
        }
        Co(t) {
            !$0ccba2be0b51cf09$var$Lr(t.target) && $0ccba2be0b51cf09$var$ga(t) && (clearTimeout(this.Eo), this.Eo = setTimeout(()=>{
                this.Ro(this.Mo(t, "mousemove"));
            }, 500));
        }
        Ro(e) {
            if ($0ccba2be0b51cf09$var$t) {
                var i = $0ccba2be0b51cf09$var$t.location.href, r = this.qt.custom_personal_data_properties, s = this.qt.mask_personal_data_properties ? [
                    ...$0ccba2be0b51cf09$var$Ns,
                    ...r || []
                ] : [], n = $0ccba2be0b51cf09$var$Fs(i, s, $0ccba2be0b51cf09$var$Us);
                this.M = this.M || {}, this.M[n] || (this.M[n] = []), this.M[n].push(e);
            }
        }
        ci() {
            this.M && !$0ccba2be0b51cf09$var$L(this.M) && this.instance.capture("$$heatmap", {
                $heatmap_data: this.getAndClearBuffer()
            });
        }
    },
    deadClicksAutocapture: $0ccba2be0b51cf09$var$xs,
    webVitalsAutocapture: class {
        constructor(t){
            var e;
            this.mo = !1, this.so = !1, this.M = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            }, this.Po = ()=>{
                clearTimeout(this.Oo), 0 !== this.M.metrics.length && (this._instance.capture("$web_vitals", this.M.metrics.reduce((t, e)=>$0ccba2be0b51cf09$var$f({}, t, {
                        ["$web_vitals_" + e.name + "_event"]: $0ccba2be0b51cf09$var$f({}, e),
                        ["$web_vitals_" + e.name + "_value"]: e.value
                    }), {})), this.M = {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                });
            }, this.ht = (t)=>{
                var e;
                this.M = this.M || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var i = this.Lo();
                if (!$0ccba2be0b51cf09$var$U(i)) {
                    if ($0ccba2be0b51cf09$var$H(null == t ? void 0 : t.name) || $0ccba2be0b51cf09$var$H(null == t ? void 0 : t.value)) $0ccba2be0b51cf09$var$la.error("Invalid metric received", t);
                    else if (!this.Ao || this.Ao > t.value) {
                        this.M.url !== i && (this.Po(), this.Oo = setTimeout(this.Po, this.flushToCaptureTimeoutMs)), $0ccba2be0b51cf09$var$U(this.M.url) && (this.M.url = i), this.M.firstMetricTimestamp = $0ccba2be0b51cf09$var$U(this.M.firstMetricTimestamp) ? Date.now() : this.M.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0);
                        var r = null == (e = this._instance.sessionManager) ? void 0 : e.checkAndGetSessionAndWindowId(!0), s = $0ccba2be0b51cf09$var$f({}, t, {
                            $current_url: i,
                            timestamp: Date.now()
                        });
                        $0ccba2be0b51cf09$var$U(r) || (s.$session_id = r.sessionId, s.$window_id = r.windowId), this.M.metrics.push(s), this.M.metrics.length === this.allowedMetrics.length && this.Po();
                    } else $0ccba2be0b51cf09$var$la.error("Ignoring metric with value >= " + this.Ao, t);
                }
            }, this.Fo = ()=>{
                if (!this.so) {
                    var t, e, i, r, s = $0ccba2be0b51cf09$var$h.__PosthogExtensions__;
                    $0ccba2be0b51cf09$var$U(s) || $0ccba2be0b51cf09$var$U(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: e, onFCP: i, onINP: r } = s.postHogWebVitalsCallbacks), t && e && i && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.ht.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && e(this.ht.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && i(this.ht.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.ht.bind(this)), this.so = !0) : $0ccba2be0b51cf09$var$la.error("web vitals callbacks not loaded - not starting");
                }
            }, this._instance = t, this.mo = !(null == (e = this._instance.persistence) || !e.props[$0ccba2be0b51cf09$var$oi]), this.startIfEnabled();
        }
        get No() {
            return this._instance.config.capture_performance;
        }
        get allowedMetrics() {
            var t, e, i = $0ccba2be0b51cf09$var$N(this.No) ? null == (t = this.No) ? void 0 : t.web_vitals_allowed_metrics : void 0;
            return $0ccba2be0b51cf09$var$H(i) ? (null == (e = this._instance.persistence) ? void 0 : e.props[$0ccba2be0b51cf09$var$ui]) || [
                "CLS",
                "FCP",
                "INP",
                "LCP"
            ] : i;
        }
        get flushToCaptureTimeoutMs() {
            return ($0ccba2be0b51cf09$var$N(this.No) ? this.No.web_vitals_delayed_flush_ms : void 0) || 5e3;
        }
        get useAttribution() {
            var t = $0ccba2be0b51cf09$var$N(this.No) ? this.No.web_vitals_attribution : void 0;
            return null != t && t;
        }
        get Ao() {
            var t = $0ccba2be0b51cf09$var$N(this.No) && $0ccba2be0b51cf09$var$V(this.No.__web_vitals_max_value) ? this.No.__web_vitals_max_value : $0ccba2be0b51cf09$var$ua;
            return t > 0 && 6e4 >= t ? $0ccba2be0b51cf09$var$ua : t;
        }
        get isEnabled() {
            var t = null == $0ccba2be0b51cf09$var$s ? void 0 : $0ccba2be0b51cf09$var$s.protocol;
            if ("http:" !== t && "https:" !== t) return $0ccba2be0b51cf09$var$la.info("Web Vitals are disabled on non-http/https protocols"), !1;
            var e = $0ccba2be0b51cf09$var$N(this.No) ? this.No.web_vitals : $0ccba2be0b51cf09$var$G(this.No) ? this.No : void 0;
            return $0ccba2be0b51cf09$var$G(e) ? e : this.mo;
        }
        startIfEnabled() {
            this.isEnabled && !this.so && ($0ccba2be0b51cf09$var$la.info("enabled, starting..."), this.ur(this.Fo));
        }
        onRemoteConfig(t) {
            if ("capturePerformance" in t) {
                var e = $0ccba2be0b51cf09$var$N(t.capturePerformance) && !!t.capturePerformance.web_vitals, i = $0ccba2be0b51cf09$var$N(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
                this._instance.persistence && (this._instance.persistence.register({
                    [$0ccba2be0b51cf09$var$oi]: e
                }), this._instance.persistence.register({
                    [$0ccba2be0b51cf09$var$ui]: i
                })), this.mo = e, this.startIfEnabled();
            }
        }
        ur(t) {
            var e, i;
            null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && e.postHogWebVitalsCallbacks ? t() : null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, this.useAttribution ? "web-vitals-with-attribution" : "web-vitals", (e)=>{
                e ? $0ccba2be0b51cf09$var$la.error("failed to load script", e) : t();
            });
        }
        Lo() {
            var e = $0ccba2be0b51cf09$var$t ? $0ccba2be0b51cf09$var$t.location.href : void 0;
            if (e) {
                var i = this._instance.config.custom_personal_data_properties, r = this._instance.config.mask_personal_data_properties ? [
                    ...$0ccba2be0b51cf09$var$Ns,
                    ...i || []
                ] : [];
                return $0ccba2be0b51cf09$var$Fs(e, r, $0ccba2be0b51cf09$var$Us);
            }
            $0ccba2be0b51cf09$var$la.error("Could not determine current URL");
        }
    }
}, $0ccba2be0b51cf09$var$Ga = {
    exceptionObserver: class {
        constructor(e){
            var i, r, s;
            this.Fo = ()=>{
                var e;
                if ($0ccba2be0b51cf09$var$t && this.isEnabled && null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && e.errorWrappingFunctions) {
                    var i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $0ccba2be0b51cf09$var$h.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $0ccba2be0b51cf09$var$h.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                    try {
                        !this.Do && this.qt.capture_unhandled_errors && (this.Do = i(this.captureException.bind(this))), !this.$o && this.qt.capture_unhandled_rejections && (this.$o = r(this.captureException.bind(this))), !this.qo && this.qt.capture_console_errors && (this.qo = s(this.captureException.bind(this)));
                    } catch (t) {
                        $0ccba2be0b51cf09$var$oa.error("failed to start", t), this.jo();
                    }
                }
            }, this._instance = e, this.Bo = !(null == (i = this._instance.persistence) || !i.props[$0ccba2be0b51cf09$var$ri]), this.Ho = new $0ccba2be0b51cf09$var$it({
                refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
                bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
                refillInterval: 1e4,
                Zt: $0ccba2be0b51cf09$var$oa
            }), this.qt = this.Uo(), this.startIfEnabledOrStop();
        }
        Uo() {
            var t = this._instance.config.capture_exceptions, e = {
                capture_unhandled_errors: !1,
                capture_unhandled_rejections: !1,
                capture_console_errors: !1
            };
            return $0ccba2be0b51cf09$var$N(t) ? e = $0ccba2be0b51cf09$var$f({}, e, t) : ($0ccba2be0b51cf09$var$U(t) ? this.Bo : t) && (e = $0ccba2be0b51cf09$var$f({}, e, {
                capture_unhandled_errors: !0,
                capture_unhandled_rejections: !0
            })), e;
        }
        get isEnabled() {
            return this.qt.capture_console_errors || this.qt.capture_unhandled_errors || this.qt.capture_unhandled_rejections;
        }
        startIfEnabledOrStop() {
            this.isEnabled ? ($0ccba2be0b51cf09$var$oa.info("enabled"), this.jo(), this.ur(this.Fo)) : this.jo();
        }
        ur(t) {
            var e, i;
            null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && e.errorWrappingFunctions && t(), null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "exception-autocapture", (e)=>{
                if (e) return $0ccba2be0b51cf09$var$oa.error("failed to load script", e);
                t();
            });
        }
        jo() {
            var t, e, i;
            null == (t = this.Do) || t.call(this), this.Do = void 0, null == (e = this.$o) || e.call(this), this.$o = void 0, null == (i = this.qo) || i.call(this), this.qo = void 0;
        }
        onRemoteConfig(t) {
            "autocaptureExceptions" in t && (this.Bo = !!t.autocaptureExceptions || !1, this._instance.persistence && this._instance.persistence.register({
                [$0ccba2be0b51cf09$var$ri]: this.Bo
            }), this.qt = this.Uo(), this.startIfEnabledOrStop());
        }
        onConfigChange() {
            this.qt = this.Uo();
        }
        captureException(t) {
            var e, i, r, s = null !== (e = null == t || null == (i = t.$exception_list) || null == (i = i[0]) ? void 0 : i.type) && void 0 !== e ? e : "Exception";
            this.Ho.consumeRateLimit(s) ? $0ccba2be0b51cf09$var$oa.info("Skipping exception capture because of client rate limiting.", {
                exception: s
            }) : null == (r = this._instance.exceptions) || r.sendExceptionEvent(t);
        }
    },
    exceptions: class {
        constructor(t){
            var e, i;
            this.zo = [], this.Vo = new $0ccba2be0b51cf09$var$_e([
                new $0ccba2be0b51cf09$var$Re,
                new $0ccba2be0b51cf09$var$Le,
                new $0ccba2be0b51cf09$var$Oe,
                new $0ccba2be0b51cf09$var$Pe,
                new $0ccba2be0b51cf09$var$De,
                new $0ccba2be0b51cf09$var$Me,
                new $0ccba2be0b51cf09$var$Ce,
                new $0ccba2be0b51cf09$var$Ne
            ], function(t) {
                for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
                return function(e, r) {
                    void 0 === r && (r = 0);
                    for(var s = [], n = e.split("\n"), o = r; n.length > o; o++){
                        var a = n[o];
                        if (1024 >= a.length) {
                            var l = $0ccba2be0b51cf09$var$ke.test(a) ? a.replace($0ccba2be0b51cf09$var$ke, "$1") : a;
                            if (!l.match(/\S*Error: /)) {
                                for (var u of i){
                                    var h = u(l, t);
                                    if (h) {
                                        s.push(h);
                                        break;
                                    }
                                }
                                if (s.length >= 50) break;
                            }
                        }
                    }
                    return function(t) {
                        if (!t.length) return [];
                        var e = Array.from(t);
                        return e.reverse(), e.slice(0, 50).map((t)=>{
                            var i;
                            return $0ccba2be0b51cf09$var$f({}, t, {
                                filename: t.filename || (i = e, i[i.length - 1] || {}).filename,
                                function: t.function || $0ccba2be0b51cf09$var$ge
                            });
                        });
                    }(s);
                };
            }("web:javascript", $0ccba2be0b51cf09$var$Ee, $0ccba2be0b51cf09$var$Te)), this._instance = t, this.zo = null !== (e = null == (i = this._instance.persistence) ? void 0 : i.get_property($0ccba2be0b51cf09$var$si)) && void 0 !== e ? e : [], this.Wo = $0ccba2be0b51cf09$var$He(this.Go()), this.Zo = new $0ccba2be0b51cf09$var$Ve(this.Wo);
        }
        onConfigChange() {
            this.Wo = $0ccba2be0b51cf09$var$He(this.Go()), this.Zo.setConfig(this.Wo);
        }
        onRemoteConfig(t) {
            var e, i, r;
            if ("errorTracking" in t) {
                var s = null !== (e = null == (i = t.errorTracking) ? void 0 : i.suppressionRules) && void 0 !== e ? e : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
                this.zo = s, this._instance.persistence && this._instance.persistence.register({
                    [$0ccba2be0b51cf09$var$si]: this.zo,
                    [$0ccba2be0b51cf09$var$ni]: n
                });
            }
        }
        get Qo() {
            var t, e = !!this._instance.get_property($0ccba2be0b51cf09$var$ni), i = this._instance.config.error_tracking.captureExtensionExceptions;
            return null !== (t = null != i ? i : e) && void 0 !== t && t;
        }
        buildProperties(t, e) {
            return this.Vo.buildFromUnknown(t, {
                syntheticException: null == e ? void 0 : e.syntheticException,
                mechanism: {
                    handled: null == e ? void 0 : e.handled
                }
            });
        }
        addExceptionStep(t, e) {
            if (this.Wo.enabled) try {
                if (!$0ccba2be0b51cf09$var$j(t) || 0 === t.trim().length) return void $0ccba2be0b51cf09$var$Na.warn("Ignoring exception step because message must be a non-empty string");
                var i = this.Jo(e), { sanitizedProperties: r, droppedKeys: s } = function(t) {
                    if (!t) return {
                        sanitizedProperties: {},
                        droppedKeys: []
                    };
                    var e = [];
                    return {
                        sanitizedProperties: Object.keys(t).reduce((i, r)=>$0ccba2be0b51cf09$var$ze.has(r) ? (e.push(r), i) : (i[r] = t[r], i), {}),
                        droppedKeys: e
                    };
                }(i);
                s.length > 0 && $0ccba2be0b51cf09$var$Na.warn("Ignoring reserved exception step fields", {
                    droppedKeys: s
                }), this.Zo.add($0ccba2be0b51cf09$var$f({
                    [$0ccba2be0b51cf09$var$Ue]: t,
                    [$0ccba2be0b51cf09$var$je]: (new Date).toISOString()
                }, r));
            } catch (t) {
                $0ccba2be0b51cf09$var$Na.error("Failed to add exception step. Ignoring breadcrumb.", t);
            }
        }
        sendExceptionEvent(t) {
            try {
                var e = t.$exception_list;
                if (this.Ko(e)) {
                    if (this.Yo(e)) return this.Xo("Exception dropped: matched a suppression rule"), void $0ccba2be0b51cf09$var$Na.info("Skipping exception capture because a suppression rule matched");
                    if (!this.Qo && this.ea(e)) return this.Xo("Exception dropped: thrown by a browser extension"), void $0ccba2be0b51cf09$var$Na.info("Skipping exception capture because it was thrown by an extension");
                    if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.ta(e)) return this.Xo("Exception dropped: thrown by the PostHog SDK"), void $0ccba2be0b51cf09$var$Na.info("Skipping exception capture because it was thrown by the PostHog SDK");
                }
                var i = this.Wo.enabled && $0ccba2be0b51cf09$var$H(t.$exception_steps) ? this.ra(t) : t;
                try {
                    var r = this._instance.capture("$exception", i, {
                        _noTruncate: !0,
                        _batchKey: "exceptionEvent",
                        Mn: !0
                    });
                    return r && this.Zo.clear(), r;
                } catch (t) {
                    return $0ccba2be0b51cf09$var$Na.error("Failed to capture exception event. Dropping this exception.", t), void this.Zo.clear();
                }
            } catch (t) {
                return void $0ccba2be0b51cf09$var$Na.error("Failed to process exception event. Ignoring this exception.", t);
            }
        }
        ra(t) {
            try {
                var e = this.Zo.getAttachable();
                return 0 === e.length ? t : $0ccba2be0b51cf09$var$f({}, t, {
                    $exception_steps: e
                });
            } catch (e) {
                return $0ccba2be0b51cf09$var$Na.error("Failed to read buffered exception steps. Capturing exception without steps.", e), t;
            }
        }
        Xo(t) {
            this.Wo.enabled && this.Zo.add({
                [$0ccba2be0b51cf09$var$Ue]: t,
                [$0ccba2be0b51cf09$var$je]: (new Date).toISOString()
            });
        }
        Jo(t) {
            return $0ccba2be0b51cf09$var$N(t) ? $0ccba2be0b51cf09$var$f({}, t) : {};
        }
        Go() {
            var t, e;
            return null !== (t = null == (e = this._instance.config.error_tracking) ? void 0 : e.exception_steps) && void 0 !== t ? t : {};
        }
        Yo(t) {
            if (0 === t.length) return !1;
            var e = t.reduce((t, e)=>{
                var { type: i, value: r } = e;
                return $0ccba2be0b51cf09$var$j(i) && i.length > 0 && t.$exception_types.push(i), $0ccba2be0b51cf09$var$j(r) && r.length > 0 && t.$exception_values.push(r), t;
            }, {
                $exception_types: [],
                $exception_values: []
            });
            return this.zo.some((t)=>{
                var i = t.values.map((t)=>{
                    var i, r = $0ccba2be0b51cf09$var$$o[t.operator], s = $0ccba2be0b51cf09$var$M(t.value) ? t.value : [
                        t.value
                    ], n = null !== (i = e[t.key]) && void 0 !== i ? i : [];
                    return s.length > 0 && r(s, n);
                });
                return "OR" === t.type ? i.some(Boolean) : i.every(Boolean);
            });
        }
        ea(t) {
            return t.flatMap((t)=>{
                var e, i;
                return null !== (e = null == (i = t.stacktrace) ? void 0 : i.frames) && void 0 !== e ? e : [];
            }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
        }
        ta(t) {
            if (t.length > 0) {
                var e, i, r, s, n = null !== (e = null == (i = t[0].stacktrace) ? void 0 : i.frames) && void 0 !== e ? e : [], o = n[n.length - 1];
                return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
            }
            return !1;
        }
        Ko(t) {
            return !$0ccba2be0b51cf09$var$H(t) && $0ccba2be0b51cf09$var$M(t);
        }
    }
}, $0ccba2be0b51cf09$var$Wa = $0ccba2be0b51cf09$var$f({
    productTours: class {
        get Si() {
            return this._instance.persistence;
        }
        constructor(t){
            this.ia = null, this.na = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if ("productTours" in t) {
                var e, i;
                if (this.Si && this.Si.register({
                    [$0ccba2be0b51cf09$var$li]: !!t.productTours
                }), !$0ccba2be0b51cf09$var$ba(this._instance)) return !this.ia && $0ccba2be0b51cf09$var$H(null == (e = this.Si) ? void 0 : e.props[$0ccba2be0b51cf09$var$Ii]) || $0ccba2be0b51cf09$var$ma.info("product tours disabled; stopping and clearing cached tours"), null == (i = this.ia) || i.stop(), this.ia = null, void this.clearCache();
                this.loadIfEnabled();
            }
        }
        loadIfEnabled() {
            !this.ia && $0ccba2be0b51cf09$var$ba(this._instance) && this.ur(()=>this.sa());
        }
        ur(t) {
            var e, i;
            null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && e.generateProductTours ? t() : null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "product-tours", (e)=>{
                e ? $0ccba2be0b51cf09$var$ma.error("Could not load product tours script", e) : t();
            });
        }
        sa() {
            var t;
            !this.ia && null != (t = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && t.generateProductTours && (this.ia = $0ccba2be0b51cf09$var$h.__PosthogExtensions__.generateProductTours(this._instance, !0));
        }
        getProductTours(t, e) {
            if (void 0 === e && (e = !1), !$0ccba2be0b51cf09$var$M(this.na) || e) {
                var i = this.Si;
                if (i) {
                    var r = i.props[$0ccba2be0b51cf09$var$Ii];
                    if ($0ccba2be0b51cf09$var$M(r) && !e) return this.na = r, void t(r, {
                        isLoaded: !0
                    });
                }
                this._instance._send_request({
                    url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token),
                    method: "GET",
                    callback: (e)=>{
                        if ($0ccba2be0b51cf09$var$ba(this._instance)) {
                            var r = e.statusCode;
                            if (200 !== r || !e.json) {
                                var s = "Product Tours API could not be loaded, status: " + r;
                                return $0ccba2be0b51cf09$var$ma.error(s), void t([], {
                                    isLoaded: !1,
                                    error: s
                                });
                            }
                            var n = $0ccba2be0b51cf09$var$M(e.json.product_tours) ? e.json.product_tours : [];
                            this.na = n, i && i.register({
                                [$0ccba2be0b51cf09$var$Ii]: n
                            }), t(n, {
                                isLoaded: !0
                            });
                        } else t([], {
                            isLoaded: !0
                        });
                    }
                });
            } else t(this.na, {
                isLoaded: !0
            });
        }
        getActiveProductTours(t) {
            $0ccba2be0b51cf09$var$H(this.ia) ? t([], {
                isLoaded: !1,
                error: "Product tours not loaded"
            }) : this.ia.getActiveProductTours(t);
        }
        showProductTour(t) {
            var e;
            null == (e = this.ia) || e.showTourById(t);
        }
        previewTour(t) {
            this.ia ? this.ia.previewTour(t) : this.ur(()=>{
                var e;
                this.sa(), null == (e = this.ia) || e.previewTour(t);
            });
        }
        dismissProductTour() {
            var t;
            null == (t = this.ia) || t.dismissTour("user_clicked_skip");
        }
        nextStep() {
            var t;
            null == (t = this.ia) || t.nextStep();
        }
        previousStep() {
            var t;
            null == (t = this.ia) || t.previousStep();
        }
        clearCache() {
            var t;
            this.na = null, null == (t = this.Si) || t.unregister($0ccba2be0b51cf09$var$Ii);
        }
        resetTour(t) {
            var e;
            null == (e = this.ia) || e.resetTour(t);
        }
        resetAllTours() {
            var t;
            null == (t = this.ia) || t.resetAllTours();
        }
        cancelPendingTour(t) {
            var e;
            null == (e = this.ia) || e.cancelPendingTour(t);
        }
    }
}, $0ccba2be0b51cf09$var$Ha), $0ccba2be0b51cf09$var$Ya = {
    siteApps: class {
        constructor(t){
            this._instance = t, this.oa = [], this.apps = {};
        }
        get isEnabled() {
            return !!this._instance.config.opt_in_site_apps;
        }
        aa(t, e) {
            if (e) {
                var i = this.globalsForEvent(e);
                this.oa.push(i), this.oa.length > 1e3 && (this.oa = this.oa.slice(10));
            }
        }
        get siteAppLoaders() {
            var t;
            return null == (t = $0ccba2be0b51cf09$var$h._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
        }
        initialize() {
            if (this.isEnabled) {
                var t = this._instance._addCaptureHook(this.aa.bind(this));
                this.la = ()=>{
                    t(), this.oa = [], this.la = void 0;
                };
            }
        }
        globalsForEvent(t) {
            var e, i, r, s, n, o, a;
            if (!t) throw new Error("Event payload is required");
            var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
            for (var [d, v] of Object.entries(h))l[d] = {
                id: u[d],
                type: d,
                properties: v
            };
            var { $set_once: c, $set: p } = t;
            return {
                event: $0ccba2be0b51cf09$var$f({}, $0ccba2be0b51cf09$var$_(t, $0ccba2be0b51cf09$var$ya), {
                    properties: $0ccba2be0b51cf09$var$f({}, t.properties, p ? {
                        $set: $0ccba2be0b51cf09$var$f({}, null !== (e = null == (i = t.properties) ? void 0 : i.$set) && void 0 !== e ? e : {}, p)
                    } : {}, c ? {
                        $set_once: $0ccba2be0b51cf09$var$f({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                    } : {}),
                    elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                    distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
                }),
                person: {
                    properties: this._instance.get_property("$stored_person_properties")
                },
                groups: l
            };
        }
        setupSiteApp(t) {
            var e = this.apps[t.id], i = ()=>{
                var i;
                !e.errored && this.oa.length && ($0ccba2be0b51cf09$var$wa.info("Processing " + this.oa.length + " events for site app with id " + t.id), this.oa.forEach((t)=>null == e.processEvent ? void 0 : e.processEvent(t)), e.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored) && (null == (i = this.la) || i.call(this));
            }, r = !1, s = (s)=>{
                e.errored = !s, e.loaded = !0, $0ccba2be0b51cf09$var$wa.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && i();
            };
            try {
                var { processEvent: n } = t.init({
                    posthog: this._instance,
                    callback (t) {
                        s(t);
                    }
                });
                n && (e.processEvent = n), r = !0;
            } catch (e) {
                $0ccba2be0b51cf09$var$wa.error($0ccba2be0b51cf09$var$xa + t.id, e), s(!1);
            }
            if (r && e.loaded) try {
                i();
            } catch (i) {
                $0ccba2be0b51cf09$var$wa.error("Error while processing buffered events PostHog app with config id " + t.id, i), e.errored = !0;
            }
        }
        ua() {
            var t = this.siteAppLoaders || [];
            for (var e of t)this.apps[e.id] = {
                id: e.id,
                loaded: !1,
                errored: !1,
                processedBuffer: !1
            };
            for (var i of t)this.setupSiteApp(i);
        }
        ha(t) {
            if (0 !== Object.keys(this.apps).length) {
                var e = this.globalsForEvent(t);
                for (var i of Object.values(this.apps))try {
                    null == i.processEvent || i.processEvent(e);
                } catch (e) {
                    $0ccba2be0b51cf09$var$wa.error("Error while processing event " + t.event + " for site app " + i.id, e);
                }
            }
        }
        onRemoteConfig(t) {
            var e, i, r, s = this;
            if (null != (e = this.siteAppLoaders) && e.length) return this.isEnabled ? (this.ua(), void this._instance.on("eventCaptured", (t)=>this.ha(t))) : void $0ccba2be0b51cf09$var$wa.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            if (null == (i = this.la) || i.call(this), null != (r = t.siteApps) && r.length) {
                if (this.isEnabled) {
                    var n = function(t) {
                        var e;
                        $0ccba2be0b51cf09$var$h["__$$ph_site_app_" + t] = s._instance, null == (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == e.loadSiteApp || e.loadSiteApp(s._instance, a, (e)=>{
                            if (e) return $0ccba2be0b51cf09$var$wa.error($0ccba2be0b51cf09$var$xa + t, e);
                        });
                    };
                    for (var { id: o, url: a } of t.siteApps)n(o);
                } else $0ccba2be0b51cf09$var$wa.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            }
        }
    }
}, $0ccba2be0b51cf09$var$Ja = {
    tracingHeaders: class {
        constructor(t){
            this.ca = void 0, this.da = void 0, this.va = void 0, this.Fo = ()=>{
                var t, e, i = this.fa();
                i ? ($0ccba2be0b51cf09$var$U(this.ca) && (this.ca = null == (t = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) ? void 0 : t._patchXHR(i, ()=>this._instance.get_distinct_id(), this._instance.sessionManager)), $0ccba2be0b51cf09$var$U(this.da) && (this.da = null == (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == (e = e.tracingHeadersPatchFns) ? void 0 : e._patchFetch(i, ()=>this._instance.get_distinct_id(), this._instance.sessionManager))) : this.jo();
            }, this._instance = t;
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        ur(t) {
            var e, i;
            null != (e = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) && e.tracingHeadersPatchFns ? t() : null == (i = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "tracing-headers", (e)=>{
                if (e) return $0ccba2be0b51cf09$var$aa.error("failed to load script", e);
                t();
            });
        }
        pa() {
            var t, e;
            return null !== (t = null !== (e = this._instance.config.tracing_headers) && void 0 !== e ? e : this._instance.config.addTracingHeaders) && void 0 !== t ? t : this._instance.config.__add_tracing_headers;
        }
        fa() {
            var t = this.pa();
            return $0ccba2be0b51cf09$var$M(t) ? ($0ccba2be0b51cf09$var$M(this.va) ? this.va.splice(0, this.va.length, ...t) : this.va = [
                ...t
            ], t.length > 0 ? this.va : void 0) : ($0ccba2be0b51cf09$var$M(this.va) && this.va.splice(0), this.va = t || void 0, this.va);
        }
        jo() {
            var t, e;
            null == (t = this.ca) || t.call(this), null == (e = this.da) || e.call(this), this.ca = void 0, this.da = void 0;
        }
        startIfEnabledOrStop() {
            this.fa() ? this.ur(this.Fo) : this.jo();
        }
    }
}, $0ccba2be0b51cf09$var$Ka = $0ccba2be0b51cf09$var$f({
    surveys: class {
        get qt() {
            return this._instance.config;
        }
        constructor(t){
            this.ga = void 0, this._surveyManager = null, this.ma = !1, this.ya = [], this.ba = null, this._instance = t, this._surveyEventReceiver = null;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this.qt.disable_surveys) {
                var e = t.surveys;
                if ($0ccba2be0b51cf09$var$H(e)) return $0ccba2be0b51cf09$var$Co.warn("Flags not loaded yet. Not loading surveys.");
                var i = $0ccba2be0b51cf09$var$M(e);
                this.ga = i ? e.length > 0 : e, $0ccba2be0b51cf09$var$Co.info("flags response received, isSurveysEnabled: " + this.ga), this.loadIfEnabled();
            }
        }
        reset() {
            try {
                localStorage.removeItem("lastSeenSurveyDate");
                for(var t = [], e = 0; e < localStorage.length; e++){
                    var i = localStorage.key(e);
                    (null != i && i.startsWith($0ccba2be0b51cf09$var$Ao) || null != i && i.startsWith("inProgressSurvey_")) && t.push(i);
                }
                t.forEach((t)=>localStorage.removeItem(t));
            } catch (t) {}
        }
        loadIfEnabled() {
            if (!this._surveyManager) {
                if (this.ma) $0ccba2be0b51cf09$var$Co.info("Already initializing surveys, skipping...");
                else if (this.qt.disable_surveys) $0ccba2be0b51cf09$var$Co.info($0ccba2be0b51cf09$var$Ra);
                else if (this.qt.cookieless_mode && this._instance.consent.isOptedOut()) $0ccba2be0b51cf09$var$Co.info("Not loading surveys in cookieless mode without consent.");
                else {
                    var t = null == $0ccba2be0b51cf09$var$h ? void 0 : $0ccba2be0b51cf09$var$h.__PosthogExtensions__;
                    if (t) {
                        if (!$0ccba2be0b51cf09$var$U(this.ga) || this.qt.advanced_enable_surveys) {
                            var e = this.ga || this.qt.advanced_enable_surveys;
                            this.ma = !0;
                            try {
                                var i = t.generateSurveys;
                                if (i) return void this._a(i, e);
                                var r = t.loadExternalDependency;
                                if (!r) return void this.wa($0ccba2be0b51cf09$var$Yi);
                                r(this._instance, "surveys", (i)=>{
                                    i || !t.generateSurveys ? this.wa("Could not load surveys script", i) : this._a(t.generateSurveys, e);
                                });
                            } catch (t) {
                                throw this.wa("Error initializing surveys", t), t;
                            } finally{
                                this.ma = !1;
                            }
                        }
                    } else $0ccba2be0b51cf09$var$Co.error("PostHog Extensions not found.");
                }
            }
        }
        _a(t, e) {
            this._surveyManager = t(this._instance, e), this._surveyEventReceiver = new $0ccba2be0b51cf09$var$Ta(this._instance), $0ccba2be0b51cf09$var$Co.info("Surveys loaded successfully"), this.xa({
                isLoaded: !0
            });
        }
        wa(t, e) {
            $0ccba2be0b51cf09$var$Co.error(t, e), this.xa({
                isLoaded: !1,
                error: t
            });
        }
        onSurveysLoaded(t) {
            return this.ya.push(t), this._surveyManager && this.xa({
                isLoaded: !0
            }), ()=>{
                this.ya = this.ya.filter((e)=>e !== t);
            };
        }
        getSurveys(t, e) {
            if (void 0 === e && (e = !1), this.qt.disable_surveys) return $0ccba2be0b51cf09$var$Co.info($0ccba2be0b51cf09$var$Ra), t([]);
            var i, r = this._instance.get_property($0ccba2be0b51cf09$var$Ri);
            if (r && !e) return t(r, {
                isLoaded: !0
            });
            "undefined" != typeof Promise && this.ba ? this.ba.then((e)=>{
                var { surveys: i, context: r } = e;
                return t(i, r);
            }) : ("undefined" != typeof Promise && (this.ba = new Promise((t)=>{
                i = t;
            })), this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this.qt.token),
                method: "GET",
                timeout: this.qt.surveys_request_timeout_ms,
                callback: (e)=>{
                    var r;
                    this.ba = null;
                    var s = e.statusCode;
                    if (200 !== s || !e.json) {
                        var n = "Surveys API could not be loaded, status: " + s;
                        $0ccba2be0b51cf09$var$Co.error(n);
                        var o = {
                            isLoaded: !1,
                            error: n
                        };
                        return t([], o), void (null == i || i({
                            surveys: [],
                            context: o
                        }));
                    }
                    var a, l = e.json.surveys || [], u = l.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var e;
                            return !(null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) || !e.length);
                        }(t) || function(t) {
                            var e;
                            return !(null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) || !e.length);
                        }(t)));
                    u.length > 0 && (null == (a = this._surveyEventReceiver) || a.register(u)), null == (r = this._instance.persistence) || r.register({
                        [$0ccba2be0b51cf09$var$Ri]: l,
                        [$0ccba2be0b51cf09$var$Pi]: Date.now()
                    });
                    var h = {
                        isLoaded: !0
                    };
                    t(l, h), null == i || i({
                        surveys: l,
                        context: h
                    });
                }
            }));
        }
        xa(t) {
            for (var e of this.ya)try {
                if (!t.isLoaded) return e([], t);
                this.getSurveys(e);
            } catch (t) {
                $0ccba2be0b51cf09$var$Co.error("Error in survey callback", t);
            }
        }
        getActiveMatchingSurveys(t, e) {
            if (void 0 === e && (e = !1), !$0ccba2be0b51cf09$var$H(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, e);
            $0ccba2be0b51cf09$var$Co.warn("init was not called");
        }
        ka(t) {
            var e = null;
            return this.getSurveys((i)=>{
                var r;
                e = null !== (r = i.find((e)=>e.id === t)) && void 0 !== r ? r : null;
            }), e;
        }
        Sa(t) {
            if ($0ccba2be0b51cf09$var$H(this._surveyManager)) return {
                eligible: !1,
                reason: $0ccba2be0b51cf09$var$ka
            };
            var e = "string" == typeof t ? this.ka(t) : t;
            return e ? this._surveyManager.checkSurveyEligibility(e) : {
                eligible: !1,
                reason: "Survey not found"
            };
        }
        canRenderSurvey(t) {
            if ($0ccba2be0b51cf09$var$H(this._surveyManager)) return $0ccba2be0b51cf09$var$Co.warn("init was not called"), {
                visible: !1,
                disabledReason: $0ccba2be0b51cf09$var$ka
            };
            var e = this.Sa(t);
            return {
                visible: e.eligible,
                disabledReason: e.reason
            };
        }
        canRenderSurveyAsync(t, e) {
            return $0ccba2be0b51cf09$var$H(this._surveyManager) ? ($0ccba2be0b51cf09$var$Co.warn("init was not called"), Promise.resolve({
                visible: !1,
                disabledReason: $0ccba2be0b51cf09$var$ka
            })) : new Promise((i)=>{
                this.getSurveys((e)=>{
                    var r, s = null !== (r = e.find((e)=>e.id === t)) && void 0 !== r ? r : null;
                    if (s) {
                        var n = this.Sa(s);
                        i({
                            visible: n.eligible,
                            disabledReason: n.reason
                        });
                    } else i({
                        visible: !1,
                        disabledReason: "Survey not found"
                    });
                }, e);
            });
        }
        renderSurvey(t, e, i) {
            var s;
            if ($0ccba2be0b51cf09$var$H(this._surveyManager)) $0ccba2be0b51cf09$var$Co.warn("init was not called");
            else {
                var n = "string" == typeof t ? this.ka(t) : t;
                if (null != n && n.id) {
                    if ($0ccba2be0b51cf09$var$Fo.includes(n.type)) {
                        var o = null == $0ccba2be0b51cf09$var$r ? void 0 : $0ccba2be0b51cf09$var$r.querySelector(e);
                        if (o) return null != (s = n.appearance) && s.surveyPopupDelaySeconds ? ($0ccba2be0b51cf09$var$Co.info("Rendering survey " + n.id + " with delay of " + n.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                            var t, e;
                            $0ccba2be0b51cf09$var$Co.info("Rendering survey " + n.id + " with delay of " + (null == (t = n.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (e = this._surveyManager) || e.renderSurvey(n, o, i), $0ccba2be0b51cf09$var$Co.info("Survey " + n.id + " rendered");
                        }, 1e3 * n.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(n, o, i);
                        $0ccba2be0b51cf09$var$Co.warn("Survey element not found");
                    } else $0ccba2be0b51cf09$var$Co.warn("Surveys of type " + n.type + " cannot be rendered in the app");
                } else $0ccba2be0b51cf09$var$Co.warn("Survey not found");
            }
        }
        displaySurvey(t, e) {
            var i;
            if ($0ccba2be0b51cf09$var$H(this._surveyManager)) $0ccba2be0b51cf09$var$Co.warn("init was not called");
            else {
                var r = this.ka(t);
                if (r) {
                    var s = r;
                    if (null != (i = r.appearance) && i.surveyPopupDelaySeconds && e.ignoreDelay && (s = $0ccba2be0b51cf09$var$f({}, r, {
                        appearance: $0ccba2be0b51cf09$var$f({}, r.appearance, {
                            surveyPopupDelaySeconds: 0
                        })
                    })), e.displayType !== $0ccba2be0b51cf09$export$a8a66d9d1b857494.Popover && e.initialResponses && $0ccba2be0b51cf09$var$Co.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === e.ignoreConditions) {
                        var n = this.canRenderSurvey(r);
                        if (!n.visible) return void $0ccba2be0b51cf09$var$Co.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                    }
                    e.displayType !== $0ccba2be0b51cf09$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s, e) : this.renderSurvey(s, e.selector, e.properties);
                } else $0ccba2be0b51cf09$var$Co.warn("Survey not found");
            }
        }
        cancelPendingSurvey(t) {
            $0ccba2be0b51cf09$var$H(this._surveyManager) ? $0ccba2be0b51cf09$var$Co.warn("init was not called") : this._surveyManager.cancelSurvey(t);
        }
        handlePageUnload() {
            var t;
            null == (t = this._surveyManager) || t.handlePageUnload();
        }
    }
}, $0ccba2be0b51cf09$var$Ha), $0ccba2be0b51cf09$var$Xa = {
    toolbar: class {
        constructor(t){
            this.instance = t;
        }
        Ca(t) {
            $0ccba2be0b51cf09$var$h.ph_toolbar_state = t;
        }
        Ia() {
            var t;
            return null !== (t = $0ccba2be0b51cf09$var$h.ph_toolbar_state) && void 0 !== t ? t : 0;
        }
        initialize() {
            return this.maybeLoadToolbar();
        }
        maybeLoadToolbar(e, i, s) {
            if (void 0 === e && (e = void 0), void 0 === i && (i = void 0), void 0 === s && (s = void 0), $0ccba2be0b51cf09$var$_r(this.instance.config)) return !1;
            if (!$0ccba2be0b51cf09$var$t || !$0ccba2be0b51cf09$var$r) return !1;
            e = null != e ? e : $0ccba2be0b51cf09$var$t.location, s = null != s ? s : $0ccba2be0b51cf09$var$t.history;
            try {
                if (!i) {
                    try {
                        $0ccba2be0b51cf09$var$t.localStorage.setItem("test", "test"), $0ccba2be0b51cf09$var$t.localStorage.removeItem("test");
                    } catch (t) {
                        return !1;
                    }
                    i = null == $0ccba2be0b51cf09$var$t ? void 0 : $0ccba2be0b51cf09$var$t.localStorage;
                }
                var n, o = $0ccba2be0b51cf09$var$Pa || $0ccba2be0b51cf09$var$Ms(e.hash, "__posthog") || $0ccba2be0b51cf09$var$Ms(e.hash, "state"), a = o ? $0ccba2be0b51cf09$var$hr(()=>JSON.parse(atob(decodeURIComponent(o)))) || $0ccba2be0b51cf09$var$hr(()=>JSON.parse(decodeURIComponent(o))) : null;
                return a && "ph_authorize" === a.action ? ((n = a).source = "url", n && Object.keys(n).length > 0 && (a.desiredHash ? e.hash = a.desiredHash : s ? s.replaceState(s.state, "", e.pathname + e.search) : e.hash = "")) : ((n = JSON.parse(i.getItem($0ccba2be0b51cf09$var$Oa) || "{}")).source = "localstorage", delete n.userIntent), !(!n.token || this.instance.config.token !== n.token || (this.loadToolbar(n), 0));
            } catch (t) {
                return !1;
            }
        }
        Ta(t) {
            var e = $0ccba2be0b51cf09$var$h.ph_load_toolbar || $0ccba2be0b51cf09$var$h.ph_load_editor;
            !$0ccba2be0b51cf09$var$H(e) && $0ccba2be0b51cf09$var$D(e) ? e(t, this.instance) : $0ccba2be0b51cf09$var$Ia.warn("No toolbar load function found");
        }
        loadToolbar(e) {
            var i = !(null == $0ccba2be0b51cf09$var$r || !$0ccba2be0b51cf09$var$r.getElementById($0ccba2be0b51cf09$var$Hi));
            if (!$0ccba2be0b51cf09$var$t || i) return !1;
            var s = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, n = $0ccba2be0b51cf09$var$f({
                token: this.instance.config.token
            }, e, {
                apiURL: this.instance.requestRouter.endpointFor("ui")
            }, s ? {
                instrument: !1
            } : {});
            if ($0ccba2be0b51cf09$var$t.localStorage.setItem($0ccba2be0b51cf09$var$Oa, JSON.stringify($0ccba2be0b51cf09$var$f({}, n, {
                source: void 0
            }))), 2 === this.Ia()) this.Ta(n);
            else if (0 === this.Ia()) {
                var o;
                this.Ca(1), null == (o = $0ccba2be0b51cf09$var$h.__PosthogExtensions__) || null == o.loadExternalDependency || o.loadExternalDependency(this.instance, "toolbar", (t)=>{
                    if (t) return $0ccba2be0b51cf09$var$Ia.error("[Toolbar] Failed to load", t), void this.Ca(0);
                    this.Ca(2), this.Ta(n);
                }), $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$t, "turbolinks:load", ()=>{
                    this.Ca(0), this.loadToolbar(n);
                });
            }
            return !0;
        }
        Ea(t) {
            return this.loadToolbar(t);
        }
        maybeLoadEditor(t, e, i) {
            return void 0 === t && (t = void 0), void 0 === e && (e = void 0), void 0 === i && (i = void 0), this.maybeLoadToolbar(t, e, i);
        }
    }
}, $0ccba2be0b51cf09$var$Qa = $0ccba2be0b51cf09$var$f({
    experiments: $0ccba2be0b51cf09$var$ja
}, $0ccba2be0b51cf09$var$Ha), $0ccba2be0b51cf09$var$Za = {
    conversations: class {
        constructor(t){
            this.Ma = void 0, this._conversationsManager = null, this.Ra = !1, this.Pa = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this._instance.config.disable_conversations) {
                var e = t.conversations;
                $0ccba2be0b51cf09$var$H(e) || ($0ccba2be0b51cf09$var$G(e) ? this.Ma = e : (this.Ma = e.enabled, this.Pa = e), this.loadIfEnabled());
            }
        }
        reset() {
            var t;
            null == (t = this._conversationsManager) || t.reset(), this._conversationsManager = null, this.Ma = void 0, this.Pa = null;
        }
        loadIfEnabled() {
            if (!(this._conversationsManager || this.Ra || this._instance.config.disable_conversations || $0ccba2be0b51cf09$var$_r(this._instance.config) || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
                var t = null == $0ccba2be0b51cf09$var$h ? void 0 : $0ccba2be0b51cf09$var$h.__PosthogExtensions__;
                if (t && !$0ccba2be0b51cf09$var$U(this.Ma) && this.Ma) {
                    if (this.Pa && this.Pa.token) {
                        this.Ra = !0;
                        try {
                            var e = t.initConversations;
                            if (e) return this.Oa(e), void (this.Ra = !1);
                            var i = t.loadExternalDependency;
                            if (!i) return void this.La($0ccba2be0b51cf09$var$Yi);
                            i(this._instance, "conversations", (e)=>{
                                e || !t.initConversations ? this.La("Could not load conversations script", e) : this.Oa(t.initConversations), this.Ra = !1;
                            });
                        } catch (t) {
                            this.La("Error initializing conversations", t), this.Ra = !1;
                        }
                    } else $0ccba2be0b51cf09$var$za.error("Conversations enabled but missing token in remote config.");
                }
            }
        }
        Oa(t) {
            if (this.Pa) try {
                this._conversationsManager = t(this.Pa, this._instance), $0ccba2be0b51cf09$var$za.info("Conversations loaded successfully");
            } catch (t) {
                this.La("Error completing conversations initialization", t);
            }
            else $0ccba2be0b51cf09$var$za.error("Cannot complete initialization: remote config is null");
        }
        La(t, e) {
            $0ccba2be0b51cf09$var$za.error(t, e), this._conversationsManager = null, this.Ra = !1;
        }
        show() {
            this._conversationsManager ? this._conversationsManager.show() : $0ccba2be0b51cf09$var$za.warn("Conversations not loaded yet.");
        }
        hide() {
            this._conversationsManager && this._conversationsManager.hide();
        }
        isAvailable() {
            return !0 === this.Ma && !$0ccba2be0b51cf09$var$B(this._conversationsManager);
        }
        isVisible() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.isVisible()) && void 0 !== t && t;
        }
        sendMessage(t, e, i) {
            var r = this;
            return $0ccba2be0b51cf09$var$p(function*() {
                return r._conversationsManager ? r._conversationsManager.sendMessage(t, e, i) : ($0ccba2be0b51cf09$var$za.warn($0ccba2be0b51cf09$var$Ba), null);
            })();
        }
        getMessages(t, e) {
            var i = this;
            return $0ccba2be0b51cf09$var$p(function*() {
                return i._conversationsManager ? i._conversationsManager.getMessages(t, e) : ($0ccba2be0b51cf09$var$za.warn($0ccba2be0b51cf09$var$Ba), null);
            })();
        }
        markAsRead(t) {
            var e = this;
            return $0ccba2be0b51cf09$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.markAsRead(t) : ($0ccba2be0b51cf09$var$za.warn($0ccba2be0b51cf09$var$Ba), null);
            })();
        }
        getTickets(t) {
            var e = this;
            return $0ccba2be0b51cf09$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.getTickets(t) : ($0ccba2be0b51cf09$var$za.warn($0ccba2be0b51cf09$var$Ba), null);
            })();
        }
        requestRestoreLink(t) {
            var e = this;
            return $0ccba2be0b51cf09$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.requestRestoreLink(t) : ($0ccba2be0b51cf09$var$za.warn($0ccba2be0b51cf09$var$Ba), null);
            })();
        }
        restoreFromToken(t) {
            var e = this;
            return $0ccba2be0b51cf09$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.restoreFromToken(t) : ($0ccba2be0b51cf09$var$za.warn($0ccba2be0b51cf09$var$Ba), null);
            })();
        }
        restoreFromUrlToken() {
            var t = this;
            return $0ccba2be0b51cf09$var$p(function*() {
                return t._conversationsManager ? t._conversationsManager.restoreFromUrlToken() : ($0ccba2be0b51cf09$var$za.warn($0ccba2be0b51cf09$var$Ba), null);
            })();
        }
        getCurrentTicketId() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.getCurrentTicketId()) && void 0 !== t ? t : null;
        }
        getWidgetSessionId() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.getWidgetSessionId()) && void 0 !== t ? t : null;
        }
        Nn() {
            var t;
            null == (t = this._conversationsManager) || t.setIdentity();
        }
        Dn() {
            var t;
            null == (t = this._conversationsManager) || t.clearIdentity();
        }
    }
}, $0ccba2be0b51cf09$var$tl = {
    logs: class {
        constructor(t){
            var e;
            this.Aa = !1, this.Fa = !1, this.Zt = $0ccba2be0b51cf09$var$Ye("[logs]"), this.Na = [], this.Da = 0, this.$a = 0, this.qa = !1, this._instance = t, this._instance && null != (e = this._instance.config.logs) && e.captureConsoleLogs && (this.Aa = !0);
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            var e, i = null == (e = t.logs) ? void 0 : e.captureConsoleLogs;
            !$0ccba2be0b51cf09$var$H(i) && i && (this.Aa = !0, this.loadIfEnabled());
        }
        reset() {
            this.Na = [], this.ii && (clearTimeout(this.ii), this.ii = void 0), this.Da = 0, this.$a = 0, this.qa = !1;
        }
        loadIfEnabled() {
            if (this.Aa && !this.Fa) {
                var t = null == $0ccba2be0b51cf09$var$h ? void 0 : $0ccba2be0b51cf09$var$h.__PosthogExtensions__;
                if (t) {
                    var e = t.loadExternalDependency;
                    e ? e(this._instance, "logs", (e)=>{
                        var i;
                        e || null == (i = t.logs) || !i.initializeLogs ? this.Zt.error("Could not load logs script", e) : (t.logs.initializeLogs(this._instance), this.Fa = !0);
                    }) : this.Zt.error($0ccba2be0b51cf09$var$Yi);
                } else this.Zt.error("PostHog Extensions not found.");
            }
        }
        captureLog(t) {
            var e, i, r, s, n, o;
            if (this._instance.is_capturing()) {
                if (t && t.body) {
                    var a = null !== (e = null == (i = this._instance.config.logs) ? void 0 : i.flushIntervalMs) && void 0 !== e ? e : 3e3, l = null !== (r = null == (s = this._instance.config.logs) ? void 0 : s.maxLogsPerInterval) && void 0 !== r ? r : 1e3, u = Date.now();
                    if (a > u - this.$a || (this.$a = u, this.Da = 0, this.qa = !1), l > this.Da) {
                        this.Da++;
                        var h = function(t, e) {
                            var i = t.level || "info", { text: r, number: s } = $0ccba2be0b51cf09$var$de[i] || $0ccba2be0b51cf09$var$ve, n = String(Date.now()) + "000000", o = {};
                            e.distinctId && (o.posthogDistinctId = e.distinctId), e.sessionId && (o.sessionId = e.sessionId), e.currentUrl && (o["url.full"] = e.currentUrl), e.screenName && (o["screen.name"] = e.screenName), e.appState && (o["app.state"] = e.appState), e.activeFeatureFlags && e.activeFeatureFlags.length > 0 && (o.feature_flags = e.activeFeatureFlags);
                            var a = $0ccba2be0b51cf09$var$f({}, o, t.attributes || {}), l = {
                                timeUnixNano: n,
                                observedTimeUnixNano: n,
                                severityNumber: s,
                                severityText: r,
                                body: {
                                    stringValue: t.body
                                },
                                attributes: $0ccba2be0b51cf09$var$pe(a)
                            };
                            return t.trace_id && (l.traceId = t.trace_id), t.span_id && (l.spanId = t.span_id), $0ccba2be0b51cf09$var$U(t.trace_flags) || (l.flags = t.trace_flags), l;
                        }(t, this.ja());
                        this.Na.push({
                            record: h
                        }), (null !== (n = null == (o = this._instance.config.logs) ? void 0 : o.maxBufferSize) && void 0 !== n ? n : 100) > this.Na.length ? this.Ba() : this.flushLogs();
                    } else this.qa || (this.Zt.warn("captureLog dropping logs: exceeded " + l + " logs per " + a + "ms"), this.qa = !0);
                } else this.Zt.warn("captureLog requires a body");
            }
        }
        get logger() {
            return this.Ha || (this.Ha = {
                trace: (t, e)=>this.captureLog({
                        body: t,
                        level: "trace",
                        attributes: e
                    }),
                debug: (t, e)=>this.captureLog({
                        body: t,
                        level: "debug",
                        attributes: e
                    }),
                info: (t, e)=>this.captureLog({
                        body: t,
                        level: "info",
                        attributes: e
                    }),
                warn: (t, e)=>this.captureLog({
                        body: t,
                        level: "warn",
                        attributes: e
                    }),
                error: (t, e)=>this.captureLog({
                        body: t,
                        level: "error",
                        attributes: e
                    }),
                fatal: (t, e)=>this.captureLog({
                        body: t,
                        level: "fatal",
                        attributes: e
                    })
            }), this.Ha;
        }
        flushLogs(t) {
            if (this.ii && (clearTimeout(this.ii), this.ii = void 0), 0 !== this.Na.length) {
                var e = this.Na;
                this.Na = [];
                var i = this._instance.config.logs, r = $0ccba2be0b51cf09$var$f({
                    "service.name": (null == i ? void 0 : i.serviceName) || "unknown_service"
                }, (null == i ? void 0 : i.environment) && {
                    "deployment.environment": i.environment
                }, (null == i ? void 0 : i.serviceVersion) && {
                    "service.version": i.serviceVersion
                }, null == i ? void 0 : i.resourceAttributes), s = function(t, e, i, r) {
                    return {
                        resourceLogs: [
                            {
                                resource: {
                                    attributes: $0ccba2be0b51cf09$var$pe(e)
                                },
                                scopeLogs: [
                                    {
                                        scope: {
                                            name: i,
                                            version: r
                                        },
                                        logRecords: t
                                    }
                                ]
                            }
                        ]
                    };
                }(e.map((t)=>t.record), r, $0ccba2be0b51cf09$var$v.LIB_NAME, $0ccba2be0b51cf09$var$v.LIB_VERSION), n = this._instance.requestRouter.endpointFor("api", "/i/v1/logs") + "?token=" + encodeURIComponent(this._instance.config.token);
                this._instance.yn({
                    method: "POST",
                    url: n,
                    data: s,
                    compression: "best-available",
                    batchKey: "logs",
                    transport: t
                });
            }
        }
        Ba() {
            var t, e;
            this.ii || (this.ii = setTimeout(()=>{
                this.ii = void 0, this.flushLogs();
            }, null !== (t = null == (e = this._instance.config.logs) ? void 0 : e.flushIntervalMs) && void 0 !== t ? t : 3e3));
        }
        ja() {
            var t, e = {};
            if (e.distinctId = this._instance.get_distinct_id(), this._instance.sessionManager) {
                var { sessionId: i } = this._instance.sessionManager.checkAndGetSessionAndWindowId(!0);
                e.sessionId = i;
            }
            if (null != $0ccba2be0b51cf09$var$h && null != (t = $0ccba2be0b51cf09$var$h.location) && t.href && (e.currentUrl = $0ccba2be0b51cf09$var$h.location.href), this._instance.featureFlags) {
                var r = this._instance.featureFlags.getFlags();
                r && r.length > 0 && (e.activeFeatureFlags = r);
            }
            return e;
        }
    }
}, $0ccba2be0b51cf09$var$el = $0ccba2be0b51cf09$var$f({}, $0ccba2be0b51cf09$var$Ha, $0ccba2be0b51cf09$var$Va, $0ccba2be0b51cf09$var$qa, $0ccba2be0b51cf09$var$Ga, $0ccba2be0b51cf09$var$Wa, $0ccba2be0b51cf09$var$Ya, $0ccba2be0b51cf09$var$Ka, $0ccba2be0b51cf09$var$Ja, $0ccba2be0b51cf09$var$Xa, $0ccba2be0b51cf09$var$Qa, $0ccba2be0b51cf09$var$Za, $0ccba2be0b51cf09$var$tl);
$0ccba2be0b51cf09$export$a9d6b9cbf49b8241.__defaultExtensionClasses = $0ccba2be0b51cf09$var$f({}, $0ccba2be0b51cf09$var$el);
var $0ccba2be0b51cf09$export$2e2bcd8739ae039 = function() {
    $0ccba2be0b51cf09$var$v.SDK_DIST_CHANNEL = "npm";
    var e = $0ccba2be0b51cf09$var$jo[$0ccba2be0b51cf09$var$Wo] = new $0ccba2be0b51cf09$export$a9d6b9cbf49b8241;
    return function() {
        function e() {
            e.done || (e.done = !0, $0ccba2be0b51cf09$var$Yo = !1, $0ccba2be0b51cf09$var$ar($0ccba2be0b51cf09$var$jo, function(t) {
                t._dom_loaded();
            }));
        }
        null != $0ccba2be0b51cf09$var$r && $0ccba2be0b51cf09$var$r.addEventListener ? "complete" === $0ccba2be0b51cf09$var$r.readyState ? e() : $0ccba2be0b51cf09$var$fr($0ccba2be0b51cf09$var$r, "DOMContentLoaded", e, {
            capture: !1
        }) : $0ccba2be0b51cf09$var$t && $0ccba2be0b51cf09$var$We.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
    }(), e;
}();

});



//# sourceMappingURL=index.b0fae1b1.js.map
